webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(686)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(152)(module)))

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var markedRenderer = new _marked2.default.Renderer({
    breaks: false,
    sanitize: true
});

// https://github.com/chjj/marked/blob/master/lib/marked.js#L869
markedRenderer.link = function (href, title, text) {
    var externalLink = /^https?:\/\//i.test(href);
    if (this.options.sanitize) {
        try {
            var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
                return '';
            }
        } catch (e) {
            return '';
        }
    }
    var out = '<a href="' + href + '"';
    if (title) {
        out += ' title="' + title + '"';
    }
    if (externalLink) {
        out += ' target="_blank"';
    }
    out += '>' + text + '</a>';
    return out;
};

exports.default = markedRenderer;

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateTimeHelper = function () {
    function DateTimeHelper(format) {
        _classCallCheck(this, DateTimeHelper);

        if (!format) {
            throw 'format is required';
        }
        this._format = format;
        this._momentFormat = DateTimeHelper.getMomentFormat(format);
        this._allowedFormats = DateTimeHelper.getAllowedFormats(this.momentFormat);
        this._formatRegex = DateTimeHelper.getFormatRegex(this.momentFormat);
    }

    DateTimeHelper.prototype.parseValue = function parseValue(value) {
        if (value instanceof Date) {
            return DateTimeHelper.momentValue(value).format();
        }

        if (value.match(new RegExp(this.formatRegex))) {
            var momentValue = DateTimeHelper.momentValue(value, this.allowedFormats);
            if (momentValue.isValid()) {
                return momentValue.format();
            }
        }
        return value;
    };

    DateTimeHelper.prototype.formatValue = function formatValue(value) {
        var momentValue = DateTimeHelper.momentValue(value);
        if (momentValue.isValid()) {
            return momentValue.format(this.momentFormat);
        }
        return value;
    };

    DateTimeHelper.formatValue = function formatValue(value, format) {
        return new DateTimeHelper(format).formatValue(value);
    };

    DateTimeHelper.getFormatsForPart = function getFormatsForPart(format, allowedFormats, part) {
        var doublePart = '' + part + part;
        var formats = [].concat(allowedFormats);
        if (format.match(RegExp(doublePart))) {
            for (var i = 0; i < allowedFormats.length; i++) {
                formats.push(allowedFormats[i].replace(RegExp(doublePart), part));
            }
        } else if (format.match(RegExp(part))) {
            for (var _i = 0; _i < allowedFormats.length; _i++) {
                formats.push(allowedFormats[_i].replace(RegExp(part), doublePart));
            }
        }
        return formats;
    };

    DateTimeHelper.getAllowedFormats = function getAllowedFormats(format) {
        var allowedFormats = [format];

        ['s', 'm', 'H', 'D', 'M'].forEach(function (part) {
            allowedFormats = DateTimeHelper.getFormatsForPart(format, allowedFormats, part);
        });

        return allowedFormats;
    };

    DateTimeHelper.getFormatRegex = function getFormatRegex(format) {
        return new RegExp('^(' + format.replace('ss', DateTimeHelper.secondsRegex).replace('s', DateTimeHelper.secondsRegex).replace('mm', DateTimeHelper.minutesRegex).replace('m', DateTimeHelper.minutesRegex).replace('HH', DateTimeHelper.hoursRegex).replace('H', DateTimeHelper.hoursRegex).replace('H', DateTimeHelper.hoursRegex).replace('DD', DateTimeHelper.daysRegex).replace('D', DateTimeHelper.daysRegex).replace('MM', DateTimeHelper.monthsRegex).replace('M', DateTimeHelper.monthsRegex).replace('YYYY', DateTimeHelper.yearRegex) + ')$');
    };

    DateTimeHelper.getMomentFormat = function getMomentFormat(format) {
        return format.replace(new RegExp('d', 'g'), 'D').replace(new RegExp('y', 'g'), 'Y');
    };

    DateTimeHelper.prototype.momentValue = function momentValue(value) {
        var inputFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment2.default.ISO_8601;

        if (value instanceof Date) {
            return (0, _moment2.default)(value);
        }
        return (0, _moment2.default)(value, inputFormats, true);
    };

    DateTimeHelper.momentValue = function momentValue(value) {
        var inputFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _moment2.default.ISO_8601;

        if (value instanceof Date) {
            return (0, _moment2.default)(value);
        }
        return (0, _moment2.default)(value, inputFormats, true);
    };

    DateTimeHelper.parseValue = function parseValue(value, format) {
        return new DateTimeHelper(format).parseValue(value);
    };

    _createClass(DateTimeHelper, [{
        key: 'allowedFormats',
        get: function get() {
            return this._allowedFormats;
        }
    }, {
        key: 'format',
        get: function get() {
            return this._format;
        }
    }, {
        key: 'formatRegex',
        get: function get() {
            return this._formatRegex;
        }
    }, {
        key: 'momentFormat',
        get: function get() {
            return this._momentFormat;
        }
    }, {
        key: 'formatHasSeconds',
        get: function get() {
            return this.format.indexOf(':s') !== -1;
        }
    }, {
        key: 'formatHasMinutes',
        get: function get() {
            return this.format.indexOf(':m') !== -1;
        }
    }, {
        key: 'formatHasHours',
        get: function get() {
            return this.format.indexOf(':H') !== -1;
        }
    }], [{
        key: 'daysRegex',
        get: function get() {
            return '([0-9]|0[0-9]|[1-2][0-9]|3[0-1])';
        }
    }, {
        key: 'hoursRegex',
        get: function get() {
            return '([0-9]|0[0-9]|1[0-9]|2[0-3])';
        }
    }, {
        key: 'minutesRegex',
        get: function get() {
            return '([0-5]?[0-9])';
        }
    }, {
        key: 'monthsRegex',
        get: function get() {
            return '([0-9]|0[0-9]|1[0-2])';
        }
    }, {
        key: 'secondsRegex',
        get: function get() {
            return '([0-5]?[0-9])';
        }
    }, {
        key: 'yearRegex',
        get: function get() {
            return '([1-9][0-9]{3})';
        }
    }, {
        key: 'defaultDateFormat',
        get: function get() {
            return 'dd/MM/yyyy';
        }
    }, {
        key: 'defaultDateTimeFormat',
        get: function get() {
            return 'dd/MM/yyyy HH:mm';
        }
    }, {
        key: 'defaultTimeFormat',
        get: function get() {
            return 'HH:mm';
        }
    }]);

    return DateTimeHelper;
}();

exports.default = DateTimeHelper;

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = __webpack_require__(95);

var _angularjs2 = _interopRequireDefault(_angularjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('blocks.security', ['ng', _angularjs2.default]);

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * Bootstrap Datetime Picker v4.17.49
  * Copyright 2015-2020 Jonathan Peterson
  * Licensed under MIT (https://github.com/Eonasdan/bootstrap-datetimepicker/blob/master/LICENSE)
  */
/*global define:false */
/*global exports:false */
/*global require:false */
/*global jQuery:false */
/*global moment:false */
(function (factory) {
    'use strict';
    if (true) {
        // AMD is used - Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'), require('moment'));
    } else {
        // Neither AMD nor CommonJS used. Use global variables.
        if (typeof jQuery === 'undefined') {
            throw 'bootstrap-datetimepicker requires jQuery to be loaded first';
        }
        if (typeof moment === 'undefined') {
            throw 'bootstrap-datetimepicker requires Moment.js to be loaded first';
        }
        factory(jQuery, moment);
    }
}(function ($, moment) {
    'use strict';
    if (!moment) {
        throw new Error('bootstrap-datetimepicker requires Moment.js to be loaded first');
    }

    var dateTimePicker = function (element, options) {
        var picker = {},
            date,
            viewDate,
            unset = true,
            input,
            component = false,
            widget = false,
            use24Hours,
            minViewModeNumber = 0,
            actualFormat,
            parseFormats,
            currentViewMode,
            datePickerModes = [
                {
                    clsName: 'days',
                    navFnc: 'M',
                    navStep: 1
                },
                {
                    clsName: 'months',
                    navFnc: 'y',
                    navStep: 1
                },
                {
                    clsName: 'years',
                    navFnc: 'y',
                    navStep: 10
                },
                {
                    clsName: 'decades',
                    navFnc: 'y',
                    navStep: 100
                }
            ],
            viewModes = ['days', 'months', 'years', 'decades'],
            verticalModes = ['top', 'bottom', 'auto'],
            horizontalModes = ['left', 'right', 'auto'],
            toolbarPlacements = ['default', 'top', 'bottom'],
            keyMap = {
                'up': 38,
                38: 'up',
                'down': 40,
                40: 'down',
                'left': 37,
                37: 'left',
                'right': 39,
                39: 'right',
                'tab': 9,
                9: 'tab',
                'escape': 27,
                27: 'escape',
                'enter': 13,
                13: 'enter',
                'pageUp': 33,
                33: 'pageUp',
                'pageDown': 34,
                34: 'pageDown',
                'shift': 16,
                16: 'shift',
                'control': 17,
                17: 'control',
                'space': 32,
                32: 'space',
                't': 84,
                84: 't',
                'delete': 46,
                46: 'delete'
            },
            keyState = {},

            /********************************************************************************
             *
             * Private functions
             *
             ********************************************************************************/

            hasTimeZone = function () {
                return moment.tz !== undefined && options.timeZone !== undefined && options.timeZone !== null && options.timeZone !== '';
            },

            getMoment = function (d) {
                var returnMoment;

                if (d === undefined || d === null) {
                    returnMoment = moment(); //TODO should this use format? and locale?
                } else if (moment.isDate(d) || moment.isMoment(d)) {
                    // If the date that is passed in is already a Date() or moment() object,
                    // pass it directly to moment.
                    returnMoment = moment(d);
                } else if (hasTimeZone()) { // There is a string to parse and a default time zone
                    // parse with the tz function which takes a default time zone if it is not in the format string
                    returnMoment = moment.tz(d, parseFormats, options.useStrict, options.timeZone);
                } else {
                    returnMoment = moment(d, parseFormats, options.useStrict);
                }

                if (hasTimeZone()) {
                    returnMoment.tz(options.timeZone);
                }

                return returnMoment;
            },

            isEnabled = function (granularity) {
                if (typeof granularity !== 'string' || granularity.length > 1) {
                    throw new TypeError('isEnabled expects a single character string parameter');
                }
                switch (granularity) {
                    case 'y':
                        return actualFormat.indexOf('Y') !== -1;
                    case 'M':
                        return actualFormat.indexOf('M') !== -1;
                    case 'd':
                        return actualFormat.toLowerCase().indexOf('d') !== -1;
                    case 'h':
                    case 'H':
                        return actualFormat.toLowerCase().indexOf('h') !== -1;
                    case 'm':
                        return actualFormat.indexOf('m') !== -1;
                    case 's':
                        return actualFormat.indexOf('s') !== -1;
                    default:
                        return false;
                }
            },

            hasTime = function () {
                return (isEnabled('h') || isEnabled('m') || isEnabled('s'));
            },

            hasDate = function () {
                return (isEnabled('y') || isEnabled('M') || isEnabled('d'));
            },

            getDatePickerTemplate = function () {
                var headTemplate = $('<thead>')
                        .append($('<tr>')
                            .append($('<th>').addClass('prev').attr('data-action', 'previous')
                                .append($('<span>').addClass(options.icons.previous))
                                )
                            .append($('<th>').addClass('picker-switch').attr('data-action', 'pickerSwitch').attr('colspan', (options.calendarWeeks ? '6' : '5')))
                            .append($('<th>').addClass('next').attr('data-action', 'next')
                                .append($('<span>').addClass(options.icons.next))
                                )
                            ),
                    contTemplate = $('<tbody>')
                        .append($('<tr>')
                            .append($('<td>').attr('colspan', (options.calendarWeeks ? '8' : '7')))
                            );

                return [
                    $('<div>').addClass('datepicker-days')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate)
                            .append($('<tbody>'))
                            ),
                    $('<div>').addClass('datepicker-months')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-years')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            ),
                    $('<div>').addClass('datepicker-decades')
                        .append($('<table>').addClass('table-condensed')
                            .append(headTemplate.clone())
                            .append(contTemplate.clone())
                            )
                ];
            },

            getTimePickerMainTemplate = function () {
                var topRow = $('<tr>'),
                    middleRow = $('<tr>'),
                    bottomRow = $('<tr>');

                if (isEnabled('h')) {
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementHour }).addClass('btn').attr('data-action', 'incrementHours').append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-hour').attr({ 'data-time-component': 'hours', 'title': options.tooltips.pickHour }).attr('data-action', 'showHours')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementHour }).addClass('btn').attr('data-action', 'decrementHours').append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('m')) {
                    if (isEnabled('h')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementMinute }).addClass('btn').attr('data-action', 'incrementMinutes')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-minute').attr({ 'data-time-component': 'minutes', 'title': options.tooltips.pickMinute }).attr('data-action', 'showMinutes')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementMinute }).addClass('btn').attr('data-action', 'decrementMinutes')
                            .append($('<span>').addClass(options.icons.down))));
                }
                if (isEnabled('s')) {
                    if (isEnabled('m')) {
                        topRow.append($('<td>').addClass('separator'));
                        middleRow.append($('<td>').addClass('separator').html(':'));
                        bottomRow.append($('<td>').addClass('separator'));
                    }
                    topRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.incrementSecond }).addClass('btn').attr('data-action', 'incrementSeconds')
                            .append($('<span>').addClass(options.icons.up))));
                    middleRow.append($('<td>')
                        .append($('<span>').addClass('timepicker-second').attr({ 'data-time-component': 'seconds', 'title': options.tooltips.pickSecond }).attr('data-action', 'showSeconds')));
                    bottomRow.append($('<td>')
                        .append($('<a>').attr({ href: '#', tabindex: '-1', 'title': options.tooltips.decrementSecond }).addClass('btn').attr('data-action', 'decrementSeconds')
                            .append($('<span>').addClass(options.icons.down))));
                }

                if (!use24Hours) {
                    topRow.append($('<td>').addClass('separator'));
                    middleRow.append($('<td>')
                        .append($('<button>').addClass('btn btn-primary').attr({ 'data-action': 'togglePeriod', tabindex: '-1', 'title': options.tooltips.togglePeriod })));
                    bottomRow.append($('<td>').addClass('separator'));
                }

                return $('<div>').addClass('timepicker-picker')
                    .append($('<table>').addClass('table-condensed')
                        .append([topRow, middleRow, bottomRow]));
            },

            getTimePickerTemplate = function () {
                var hoursView = $('<div>').addClass('timepicker-hours')
                        .append($('<table>').addClass('table-condensed')),
                    minutesView = $('<div>').addClass('timepicker-minutes')
                        .append($('<table>').addClass('table-condensed')),
                    secondsView = $('<div>').addClass('timepicker-seconds')
                        .append($('<table>').addClass('table-condensed')),
                    ret = [getTimePickerMainTemplate()];

                if (isEnabled('h')) {
                    ret.push(hoursView);
                }
                if (isEnabled('m')) {
                    ret.push(minutesView);
                }
                if (isEnabled('s')) {
                    ret.push(secondsView);
                }

                return ret;
            },

            getToolbar = function () {
                var row = [];
                if (options.showTodayButton) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'today', 'title': options.tooltips.today }).append($('<span>').addClass(options.icons.today))));
                }
                if (!options.sideBySide && hasDate() && hasTime()) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'togglePicker', 'title': options.tooltips.selectTime }).append($('<span>').addClass(options.icons.time))));
                }
                if (options.showClear) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'clear', 'title': options.tooltips.clear }).append($('<span>').addClass(options.icons.clear))));
                }
                if (options.showClose) {
                    row.push($('<td>').append($('<a>').attr({ 'data-action': 'close', 'title': options.tooltips.close }).append($('<span>').addClass(options.icons.close))));
                }
                return $('<table>').addClass('table-condensed').append($('<tbody>').append($('<tr>').append(row)));
            },

            getTemplate = function () {
                var template = $('<div>').addClass('bootstrap-datetimepicker-widget dropdown-menu'),
                    dateView = $('<div>').addClass('datepicker').append(getDatePickerTemplate()),
                    timeView = $('<div>').addClass('timepicker').append(getTimePickerTemplate()),
                    content = $('<ul>').addClass('list-unstyled'),
                    toolbar = $('<li>').addClass('picker-switch' + (options.collapse ? ' accordion-toggle' : '')).append(getToolbar());

                if (options.inline) {
                    template.removeClass('dropdown-menu');
                }

                if (use24Hours) {
                    template.addClass('usetwentyfour');
                }

                if (isEnabled('s') && !use24Hours) {
                    template.addClass('wider');
                }

                if (options.sideBySide && hasDate() && hasTime()) {
                    template.addClass('timepicker-sbs');
                    if (options.toolbarPlacement === 'top') {
                        template.append(toolbar);
                    }
                    template.append(
                        $('<div>').addClass('row')
                            .append(dateView.addClass('col-md-6'))
                            .append(timeView.addClass('col-md-6'))
                    );
                    if (options.toolbarPlacement === 'bottom') {
                        template.append(toolbar);
                    }
                    return template;
                }

                if (options.toolbarPlacement === 'top') {
                    content.append(toolbar);
                }
                if (hasDate()) {
                    content.append($('<li>').addClass((options.collapse && hasTime() ? 'collapse in' : '')).append(dateView));
                }
                if (options.toolbarPlacement === 'default') {
                    content.append(toolbar);
                }
                if (hasTime()) {
                    content.append($('<li>').addClass((options.collapse && hasDate() ? 'collapse' : '')).append(timeView));
                }
                if (options.toolbarPlacement === 'bottom') {
                    content.append(toolbar);
                }
                return template.append(content);
            },

            dataToOptions = function () {
                var eData,
                    dataOptions = {};

                if (element.is('input') || options.inline) {
                    eData = element.data();
                } else {
                    eData = element.find('input').data();
                }

                if (eData.dateOptions && eData.dateOptions instanceof Object) {
                    dataOptions = $.extend(true, dataOptions, eData.dateOptions);
                }

                $.each(options, function (key) {
                    var attributeName = 'date' + key.charAt(0).toUpperCase() + key.slice(1);
                    if (eData[attributeName] !== undefined) {
                        dataOptions[key] = eData[attributeName];
                    }
                });
                return dataOptions;
            },

            place = function () {
                var position = (component || element).position(),
                    offset = (component || element).offset(),
                    vertical = options.widgetPositioning.vertical,
                    horizontal = options.widgetPositioning.horizontal,
                    parent;

                if (options.widgetParent) {
                    parent = options.widgetParent.append(widget);
                } else if (element.is('input')) {
                    parent = element.after(widget).parent();
                } else if (options.inline) {
                    parent = element.append(widget);
                    return;
                } else {
                    parent = element;
                    element.children().first().after(widget);
                }

                // Top and bottom logic
                if (vertical === 'auto') {
                    if (offset.top + widget.height() * 1.5 >= $(window).height() + $(window).scrollTop() &&
                        widget.height() + element.outerHeight() < offset.top) {
                        vertical = 'top';
                    } else {
                        vertical = 'bottom';
                    }
                }

                // Left and right logic
                if (horizontal === 'auto') {
                    if (parent.width() < offset.left + widget.outerWidth() / 2 &&
                        offset.left + widget.outerWidth() > $(window).width()) {
                        horizontal = 'right';
                    } else {
                        horizontal = 'left';
                    }
                }

                if (vertical === 'top') {
                    widget.addClass('top').removeClass('bottom');
                } else {
                    widget.addClass('bottom').removeClass('top');
                }

                if (horizontal === 'right') {
                    widget.addClass('pull-right');
                } else {
                    widget.removeClass('pull-right');
                }

                // find the first parent element that has a non-static css positioning
                if (parent.css('position') === 'static') {
                    parent = parent.parents().filter(function () {
                        return $(this).css('position') !== 'static';
                    }).first();
                }

                if (parent.length === 0) {
                    throw new Error('datetimepicker component should be placed within a non-static positioned container');
                }

                widget.css({
                    top: vertical === 'top' ? 'auto' : position.top + element.outerHeight(),
                    bottom: vertical === 'top' ? parent.outerHeight() - (parent === element ? 0 : position.top) : 'auto',
                    left: horizontal === 'left' ? (parent === element ? 0 : position.left) : 'auto',
                    right: horizontal === 'left' ? 'auto' : parent.outerWidth() - element.outerWidth() - (parent === element ? 0 : position.left)
                });
            },

            notifyEvent = function (e) {
                if (e.type === 'dp.change' && ((e.date && e.date.isSame(e.oldDate)) || (!e.date && !e.oldDate))) {
                    return;
                }
                element.trigger(e);
            },

            viewUpdate = function (e) {
                if (e === 'y') {
                    e = 'YYYY';
                }
                notifyEvent({
                    type: 'dp.update',
                    change: e,
                    viewDate: viewDate.clone()
                });
            },

            showMode = function (dir) {
                if (!widget) {
                    return;
                }
                if (dir) {
                    currentViewMode = Math.max(minViewModeNumber, Math.min(3, currentViewMode + dir));
                }
                widget.find('.datepicker > div').hide().filter('.datepicker-' + datePickerModes[currentViewMode].clsName).show();
            },

            fillDow = function () {
                var row = $('<tr>'),
                    currentDate = viewDate.clone().startOf('w').startOf('d');

                if (options.calendarWeeks === true) {
                    row.append($('<th>').addClass('cw').text('#'));
                }

                while (currentDate.isBefore(viewDate.clone().endOf('w'))) {
                    row.append($('<th>').addClass('dow').text(currentDate.format('dd')));
                    currentDate.add(1, 'd');
                }
                widget.find('.datepicker-days thead').append(row);
            },

            isInDisabledDates = function (testDate) {
                return options.disabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInEnabledDates = function (testDate) {
                return options.enabledDates[testDate.format('YYYY-MM-DD')] === true;
            },

            isInDisabledHours = function (testDate) {
                return options.disabledHours[testDate.format('H')] === true;
            },

            isInEnabledHours = function (testDate) {
                return options.enabledHours[testDate.format('H')] === true;
            },

            isValid = function (targetMoment, granularity) {
                if (!targetMoment.isValid()) {
                    return false;
                }
                if (options.disabledDates && granularity === 'd' && isInDisabledDates(targetMoment)) {
                    return false;
                }
                if (options.enabledDates && granularity === 'd' && !isInEnabledDates(targetMoment)) {
                    return false;
                }
                if (options.minDate && targetMoment.isBefore(options.minDate, granularity)) {
                    return false;
                }
                if (options.maxDate && targetMoment.isAfter(options.maxDate, granularity)) {
                    return false;
                }
                if (options.daysOfWeekDisabled && granularity === 'd' && options.daysOfWeekDisabled.indexOf(targetMoment.day()) !== -1) {
                    return false;
                }
                if (options.disabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && isInDisabledHours(targetMoment)) {
                    return false;
                }
                if (options.enabledHours && (granularity === 'h' || granularity === 'm' || granularity === 's') && !isInEnabledHours(targetMoment)) {
                    return false;
                }
                if (options.disabledTimeIntervals && (granularity === 'h' || granularity === 'm' || granularity === 's')) {
                    var found = false;
                    $.each(options.disabledTimeIntervals, function () {
                        if (targetMoment.isBetween(this[0], this[1])) {
                            found = true;
                            return false;
                        }
                    });
                    if (found) {
                        return false;
                    }
                }
                return true;
            },

            fillMonths = function () {
                var spans = [],
                    monthsShort = viewDate.clone().startOf('y').startOf('d');
                while (monthsShort.isSame(viewDate, 'y')) {
                    spans.push($('<span>').attr('data-action', 'selectMonth').addClass('month').text(monthsShort.format('MMM')));
                    monthsShort.add(1, 'M');
                }
                widget.find('.datepicker-months td').empty().append(spans);
            },

            updateMonths = function () {
                var monthsView = widget.find('.datepicker-months'),
                    monthsViewHeader = monthsView.find('th'),
                    months = monthsView.find('tbody').find('span');

                monthsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevYear);
                monthsViewHeader.eq(1).attr('title', options.tooltips.selectYear);
                monthsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextYear);

                monthsView.find('.disabled').removeClass('disabled');

                if (!isValid(viewDate.clone().subtract(1, 'y'), 'y')) {
                    monthsViewHeader.eq(0).addClass('disabled');
                }

                monthsViewHeader.eq(1).text(viewDate.year());

                if (!isValid(viewDate.clone().add(1, 'y'), 'y')) {
                    monthsViewHeader.eq(2).addClass('disabled');
                }

                months.removeClass('active');
                if (date.isSame(viewDate, 'y') && !unset) {
                    months.eq(date.month()).addClass('active');
                }

                months.each(function (index) {
                    if (!isValid(viewDate.clone().month(index), 'M')) {
                        $(this).addClass('disabled');
                    }
                });
            },

            updateYears = function () {
                var yearsView = widget.find('.datepicker-years'),
                    yearsViewHeader = yearsView.find('th'),
                    startYear = viewDate.clone().subtract(5, 'y'),
                    endYear = viewDate.clone().add(6, 'y'),
                    html = '';

                yearsViewHeader.eq(0).find('span').attr('title', options.tooltips.prevDecade);
                yearsViewHeader.eq(1).attr('title', options.tooltips.selectDecade);
                yearsViewHeader.eq(2).find('span').attr('title', options.tooltips.nextDecade);

                yearsView.find('.disabled').removeClass('disabled');

                if (options.minDate && options.minDate.isAfter(startYear, 'y')) {
                    yearsViewHeader.eq(0).addClass('disabled');
                }

                yearsViewHeader.eq(1).text(startYear.year() + '-' + endYear.year());

                if (options.maxDate && options.maxDate.isBefore(endYear, 'y')) {
                    yearsViewHeader.eq(2).addClass('disabled');
                }

                while (!startYear.isAfter(endYear, 'y')) {
                    html += '<span data-action="selectYear" class="year' + (startYear.isSame(date, 'y') && !unset ? ' active' : '') + (!isValid(startYear, 'y') ? ' disabled' : '') + '">' + startYear.year() + '</span>';
                    startYear.add(1, 'y');
                }

                yearsView.find('td').html(html);
            },

            updateDecades = function () {
                var decadesView = widget.find('.datepicker-decades'),
                    decadesViewHeader = decadesView.find('th'),
                    startDecade = moment({ y: viewDate.year() - (viewDate.year() % 100) - 1 }),
                    endDecade = startDecade.clone().add(100, 'y'),
                    startedAt = startDecade.clone(),
                    minDateDecade = false,
                    maxDateDecade = false,
                    endDecadeYear,
                    html = '';

                decadesViewHeader.eq(0).find('span').attr('title', options.tooltips.prevCentury);
                decadesViewHeader.eq(2).find('span').attr('title', options.tooltips.nextCentury);

                decadesView.find('.disabled').removeClass('disabled');

                if (startDecade.isSame(moment({ y: 1900 })) || (options.minDate && options.minDate.isAfter(startDecade, 'y'))) {
                    decadesViewHeader.eq(0).addClass('disabled');
                }

                decadesViewHeader.eq(1).text(startDecade.year() + '-' + endDecade.year());

                if (startDecade.isSame(moment({ y: 2000 })) || (options.maxDate && options.maxDate.isBefore(endDecade, 'y'))) {
                    decadesViewHeader.eq(2).addClass('disabled');
                }

                while (!startDecade.isAfter(endDecade, 'y')) {
                    endDecadeYear = startDecade.year() + 12;
                    minDateDecade = options.minDate && options.minDate.isAfter(startDecade, 'y') && options.minDate.year() <= endDecadeYear;
                    maxDateDecade = options.maxDate && options.maxDate.isAfter(startDecade, 'y') && options.maxDate.year() <= endDecadeYear;
                    html += '<span data-action="selectDecade" class="decade' + (date.isAfter(startDecade) && date.year() <= endDecadeYear ? ' active' : '') +
                        (!isValid(startDecade, 'y') && !minDateDecade && !maxDateDecade ? ' disabled' : '') + '" data-selection="' + (startDecade.year() + 6) + '">' + (startDecade.year() + 1) + ' - ' + (startDecade.year() + 12) + '</span>';
                    startDecade.add(12, 'y');
                }
                html += '<span></span><span></span><span></span>'; //push the dangling block over, at least this way it's even

                decadesView.find('td').html(html);
                decadesViewHeader.eq(1).text((startedAt.year() + 1) + '-' + (startDecade.year()));
            },

            fillDate = function () {
                var daysView = widget.find('.datepicker-days'),
                    daysViewHeader = daysView.find('th'),
                    currentDate,
                    html = [],
                    row,
                    clsNames = [],
                    i;

                if (!hasDate()) {
                    return;
                }

                daysViewHeader.eq(0).find('span').attr('title', options.tooltips.prevMonth);
                daysViewHeader.eq(1).attr('title', options.tooltips.selectMonth);
                daysViewHeader.eq(2).find('span').attr('title', options.tooltips.nextMonth);

                daysView.find('.disabled').removeClass('disabled');
                daysViewHeader.eq(1).text(viewDate.format(options.dayViewHeaderFormat));

                if (!isValid(viewDate.clone().subtract(1, 'M'), 'M')) {
                    daysViewHeader.eq(0).addClass('disabled');
                }
                if (!isValid(viewDate.clone().add(1, 'M'), 'M')) {
                    daysViewHeader.eq(2).addClass('disabled');
                }

                currentDate = viewDate.clone().startOf('M').startOf('w').startOf('d');

                for (i = 0; i < 42; i++) { //always display 42 days (should show 6 weeks)
                    if (currentDate.weekday() === 0) {
                        row = $('<tr>');
                        if (options.calendarWeeks) {
                            row.append('<td class="cw">' + currentDate.week() + '</td>');
                        }
                        html.push(row);
                    }
                    clsNames = ['day'];
                    if (currentDate.isBefore(viewDate, 'M')) {
                        clsNames.push('old');
                    }
                    if (currentDate.isAfter(viewDate, 'M')) {
                        clsNames.push('new');
                    }
                    if (currentDate.isSame(date, 'd') && !unset) {
                        clsNames.push('active');
                    }
                    if (!isValid(currentDate, 'd')) {
                        clsNames.push('disabled');
                    }
                    if (currentDate.isSame(getMoment(), 'd')) {
                        clsNames.push('today');
                    }
                    if (currentDate.day() === 0 || currentDate.day() === 6) {
                        clsNames.push('weekend');
                    }
                    notifyEvent({
                        type: 'dp.classify',
                        date: currentDate,
                        classNames: clsNames
                    });
                    row.append('<td data-action="selectDay" data-day="' + currentDate.format('L') + '" class="' + clsNames.join(' ') + '">' + currentDate.date() + '</td>');
                    currentDate.add(1, 'd');
                }

                daysView.find('tbody').empty().append(html);

                updateMonths();

                updateYears();

                updateDecades();
            },

            fillHours = function () {
                var table = widget.find('.timepicker-hours table'),
                    currentHour = viewDate.clone().startOf('d'),
                    html = [],
                    row = $('<tr>');

                if (viewDate.hour() > 11 && !use24Hours) {
                    currentHour.hour(12);
                }
                while (currentHour.isSame(viewDate, 'd') && (use24Hours || (viewDate.hour() < 12 && currentHour.hour() < 12) || viewDate.hour() > 11)) {
                    if (currentHour.hour() % 4 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectHour" class="hour' + (!isValid(currentHour, 'h') ? ' disabled' : '') + '">' + currentHour.format(use24Hours ? 'HH' : 'hh') + '</td>');
                    currentHour.add(1, 'h');
                }
                table.empty().append(html);
            },

            fillMinutes = function () {
                var table = widget.find('.timepicker-minutes table'),
                    currentMinute = viewDate.clone().startOf('h'),
                    html = [],
                    row = $('<tr>'),
                    step = options.stepping === 1 ? 5 : options.stepping;

                while (viewDate.isSame(currentMinute, 'h')) {
                    if (currentMinute.minute() % (step * 4) === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectMinute" class="minute' + (!isValid(currentMinute, 'm') ? ' disabled' : '') + '">' + currentMinute.format('mm') + '</td>');
                    currentMinute.add(step, 'm');
                }
                table.empty().append(html);
            },

            fillSeconds = function () {
                var table = widget.find('.timepicker-seconds table'),
                    currentSecond = viewDate.clone().startOf('m'),
                    html = [],
                    row = $('<tr>');

                while (viewDate.isSame(currentSecond, 'm')) {
                    if (currentSecond.second() % 20 === 0) {
                        row = $('<tr>');
                        html.push(row);
                    }
                    row.append('<td data-action="selectSecond" class="second' + (!isValid(currentSecond, 's') ? ' disabled' : '') + '">' + currentSecond.format('ss') + '</td>');
                    currentSecond.add(5, 's');
                }

                table.empty().append(html);
            },

            fillTime = function () {
                var toggle, newDate, timeComponents = widget.find('.timepicker span[data-time-component]');

                if (!use24Hours) {
                    toggle = widget.find('.timepicker [data-action=togglePeriod]');
                    newDate = date.clone().add((date.hours() >= 12) ? -12 : 12, 'h');

                    toggle.text(date.format('A'));

                    if (isValid(newDate, 'h')) {
                        toggle.removeClass('disabled');
                    } else {
                        toggle.addClass('disabled');
                    }
                }
                timeComponents.filter('[data-time-component=hours]').text(date.format(use24Hours ? 'HH' : 'hh'));
                timeComponents.filter('[data-time-component=minutes]').text(date.format('mm'));
                timeComponents.filter('[data-time-component=seconds]').text(date.format('ss'));

                fillHours();
                fillMinutes();
                fillSeconds();
            },

            update = function () {
                if (!widget) {
                    return;
                }
                fillDate();
                fillTime();
            },

            setValue = function (targetMoment) {
                var oldDate = unset ? null : date;

                // case of calling setValue(null or false)
                if (!targetMoment) {
                    unset = true;
                    input.val('');
                    element.data('date', '');
                    notifyEvent({
                        type: 'dp.change',
                        date: false,
                        oldDate: oldDate
                    });
                    update();
                    return;
                }

                targetMoment = targetMoment.clone().locale(options.locale);

                if (hasTimeZone()) {
                    targetMoment.tz(options.timeZone);
                }

                if (options.stepping !== 1) {
                    targetMoment.minutes((Math.round(targetMoment.minutes() / options.stepping) * options.stepping)).seconds(0);

                    while (options.minDate && targetMoment.isBefore(options.minDate)) {
                        targetMoment.add(options.stepping, 'minutes');
                    }
                }

                if (isValid(targetMoment)) {
                    date = targetMoment;
                    viewDate = date.clone();
                    input.val(date.format(actualFormat));
                    element.data('date', date.format(actualFormat));
                    unset = false;
                    update();
                    notifyEvent({
                        type: 'dp.change',
                        date: date.clone(),
                        oldDate: oldDate
                    });
                } else {
                    if (!options.keepInvalid) {
                        input.val(unset ? '' : date.format(actualFormat));
                    } else {
                        notifyEvent({
                            type: 'dp.change',
                            date: targetMoment,
                            oldDate: oldDate
                        });
                    }
                    notifyEvent({
                        type: 'dp.error',
                        date: targetMoment,
                        oldDate: oldDate
                    });
                }
            },

            /**
             * Hides the widget. Possibly will emit dp.hide
             */
            hide = function () {
                var transitioning = false;
                if (!widget) {
                    return picker;
                }
                // Ignore event if in the middle of a picker transition
                widget.find('.collapse').each(function () {
                    var collapseData = $(this).data('collapse');
                    if (collapseData && collapseData.transitioning) {
                        transitioning = true;
                        return false;
                    }
                    return true;
                });
                if (transitioning) {
                    return picker;
                }
                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                widget.hide();

                $(window).off('resize', place);
                widget.off('click', '[data-action]');
                widget.off('mousedown', false);

                widget.remove();
                widget = false;

                notifyEvent({
                    type: 'dp.hide',
                    date: date.clone()
                });

                input.blur();

                viewDate = date.clone();

                return picker;
            },

            clear = function () {
                setValue(null);
            },

            parseInputDate = function (inputDate) {
                if (options.parseInputDate === undefined) {
                    if (!moment.isMoment(inputDate) || inputDate instanceof Date) {
                        inputDate = getMoment(inputDate);
                    }
                } else {
                    inputDate = options.parseInputDate(inputDate);
                }
                //inputDate.locale(options.locale);
                return inputDate;
            },

            /********************************************************************************
             *
             * Widget UI interaction functions
             *
             ********************************************************************************/
            actions = {
                next: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.add(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                previous: function () {
                    var navFnc = datePickerModes[currentViewMode].navFnc;
                    viewDate.subtract(datePickerModes[currentViewMode].navStep, navFnc);
                    fillDate();
                    viewUpdate(navFnc);
                },

                pickerSwitch: function () {
                    showMode(1);
                },

                selectMonth: function (e) {
                    var month = $(e.target).closest('tbody').find('span').index($(e.target));
                    viewDate.month(month);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()).month(viewDate.month()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('M');
                },

                selectYear: function (e) {
                    var year = parseInt($(e.target).text(), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDecade: function (e) {
                    var year = parseInt($(e.target).data('selection'), 10) || 0;
                    viewDate.year(year);
                    if (currentViewMode === minViewModeNumber) {
                        setValue(date.clone().year(viewDate.year()));
                        if (!options.inline) {
                            hide();
                        }
                    } else {
                        showMode(-1);
                        fillDate();
                    }
                    viewUpdate('YYYY');
                },

                selectDay: function (e) {
                    var day = viewDate.clone();
                    if ($(e.target).is('.old')) {
                        day.subtract(1, 'M');
                    }
                    if ($(e.target).is('.new')) {
                        day.add(1, 'M');
                    }
                    setValue(day.date(parseInt($(e.target).text(), 10)));
                    if (!hasTime() && !options.keepOpen && !options.inline) {
                        hide();
                    }
                },

                incrementHours: function () {
                    var newDate = date.clone().add(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                incrementMinutes: function () {
                    var newDate = date.clone().add(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                incrementSeconds: function () {
                    var newDate = date.clone().add(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                decrementHours: function () {
                    var newDate = date.clone().subtract(1, 'h');
                    if (isValid(newDate, 'h')) {
                        setValue(newDate);
                    }
                },

                decrementMinutes: function () {
                    var newDate = date.clone().subtract(options.stepping, 'm');
                    if (isValid(newDate, 'm')) {
                        setValue(newDate);
                    }
                },

                decrementSeconds: function () {
                    var newDate = date.clone().subtract(1, 's');
                    if (isValid(newDate, 's')) {
                        setValue(newDate);
                    }
                },

                togglePeriod: function () {
                    setValue(date.clone().add((date.hours() >= 12) ? -12 : 12, 'h'));
                },

                togglePicker: function (e) {
                    var $this = $(e.target),
                        $parent = $this.closest('ul'),
                        expanded = $parent.find('.in'),
                        closed = $parent.find('.collapse:not(.in)'),
                        collapseData;

                    if (expanded && expanded.length) {
                        collapseData = expanded.data('collapse');
                        if (collapseData && collapseData.transitioning) {
                            return;
                        }
                        if (expanded.collapse) { // if collapse plugin is available through bootstrap.js then use it
                            expanded.collapse('hide');
                            closed.collapse('show');
                        } else { // otherwise just toggle in class on the two views
                            expanded.removeClass('in');
                            closed.addClass('in');
                        }
                        if ($this.is('span')) {
                            $this.toggleClass(options.icons.time + ' ' + options.icons.date);
                        } else {
                            $this.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        }

                        // NOTE: uncomment if toggled state will be restored in show()
                        //if (component) {
                        //    component.find('span').toggleClass(options.icons.time + ' ' + options.icons.date);
                        //}
                    }
                },

                showPicker: function () {
                    widget.find('.timepicker > div:not(.timepicker-picker)').hide();
                    widget.find('.timepicker .timepicker-picker').show();
                },

                showHours: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-hours').show();
                },

                showMinutes: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-minutes').show();
                },

                showSeconds: function () {
                    widget.find('.timepicker .timepicker-picker').hide();
                    widget.find('.timepicker .timepicker-seconds').show();
                },

                selectHour: function (e) {
                    var hour = parseInt($(e.target).text(), 10);

                    if (!use24Hours) {
                        if (date.hours() >= 12) {
                            if (hour !== 12) {
                                hour += 12;
                            }
                        } else {
                            if (hour === 12) {
                                hour = 0;
                            }
                        }
                    }
                    setValue(date.clone().hours(hour));
                    actions.showPicker.call(picker);
                },

                selectMinute: function (e) {
                    setValue(date.clone().minutes(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                selectSecond: function (e) {
                    setValue(date.clone().seconds(parseInt($(e.target).text(), 10)));
                    actions.showPicker.call(picker);
                },

                clear: clear,

                today: function () {
                    var todaysDate = getMoment();
                    if (isValid(todaysDate, 'd')) {
                        setValue(todaysDate);
                    }
                },

                close: hide
            },

            doAction = function (e) {
                if ($(e.currentTarget).is('.disabled')) {
                    return false;
                }
                actions[$(e.currentTarget).data('action')].apply(picker, arguments);
                return false;
            },

            /**
             * Shows the widget. Possibly will emit dp.show and dp.change
             */
            show = function () {
                var currentMoment,
                    useCurrentGranularity = {
                        'year': function (m) {
                            return m.month(0).date(1).hours(0).seconds(0).minutes(0);
                        },
                        'month': function (m) {
                            return m.date(1).hours(0).seconds(0).minutes(0);
                        },
                        'day': function (m) {
                            return m.hours(0).seconds(0).minutes(0);
                        },
                        'hour': function (m) {
                            return m.seconds(0).minutes(0);
                        },
                        'minute': function (m) {
                            return m.seconds(0);
                        }
                    };

                if (input.prop('disabled') || (!options.ignoreReadonly && input.prop('readonly')) || widget) {
                    return picker;
                }
                if (input.val() !== undefined && input.val().trim().length !== 0) {
                    setValue(parseInputDate(input.val().trim()));
                } else if (unset && options.useCurrent && (options.inline || (input.is('input') && input.val().trim().length === 0))) {
                    currentMoment = getMoment();
                    if (typeof options.useCurrent === 'string') {
                        currentMoment = useCurrentGranularity[options.useCurrent](currentMoment);
                    }
                    setValue(currentMoment);
                }
                widget = getTemplate();

                fillDow();
                fillMonths();

                widget.find('.timepicker-hours').hide();
                widget.find('.timepicker-minutes').hide();
                widget.find('.timepicker-seconds').hide();

                update();
                showMode();

                $(window).on('resize', place);
                widget.on('click', '[data-action]', doAction); // this handles clicks on the widget
                widget.on('mousedown', false);

                if (component && component.hasClass('btn')) {
                    component.toggleClass('active');
                }
                place();
                widget.show();
                if (options.focusOnShow && !input.is(':focus')) {
                    input.focus();
                }

                notifyEvent({
                    type: 'dp.show'
                });
                return picker;
            },

            /**
             * Shows or hides the widget
             */
            toggle = function () {
                return (widget ? hide() : show());
            },

            keydown = function (e) {
                var handler = null,
                    index,
                    index2,
                    pressedKeys = [],
                    pressedModifiers = {},
                    currentKey = e.which,
                    keyBindKeys,
                    allModifiersPressed,
                    pressed = 'p';

                keyState[currentKey] = pressed;

                for (index in keyState) {
                    if (keyState.hasOwnProperty(index) && keyState[index] === pressed) {
                        pressedKeys.push(index);
                        if (parseInt(index, 10) !== currentKey) {
                            pressedModifiers[index] = true;
                        }
                    }
                }

                for (index in options.keyBinds) {
                    if (options.keyBinds.hasOwnProperty(index) && typeof (options.keyBinds[index]) === 'function') {
                        keyBindKeys = index.split(' ');
                        if (keyBindKeys.length === pressedKeys.length && keyMap[currentKey] === keyBindKeys[keyBindKeys.length - 1]) {
                            allModifiersPressed = true;
                            for (index2 = keyBindKeys.length - 2; index2 >= 0; index2--) {
                                if (!(keyMap[keyBindKeys[index2]] in pressedModifiers)) {
                                    allModifiersPressed = false;
                                    break;
                                }
                            }
                            if (allModifiersPressed) {
                                handler = options.keyBinds[index];
                                break;
                            }
                        }
                    }
                }

                if (handler) {
                    handler.call(picker, widget);
                    e.stopPropagation();
                    e.preventDefault();
                }
            },

            keyup = function (e) {
                keyState[e.which] = 'r';
                e.stopPropagation();
                e.preventDefault();
            },

            change = function (e) {
                var val = $(e.target).val().trim(),
                    parsedDate = val ? parseInputDate(val) : null;
                setValue(parsedDate);
                e.stopImmediatePropagation();
                return false;
            },

            attachDatePickerElementEvents = function () {
                input.on({
                    'change': change,
                    'blur': options.debug ? '' : hide,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? show : ''
                });

                if (element.is('input')) {
                    input.on({
                        'focus': show
                    });
                } else if (component) {
                    component.on('click', toggle);
                    component.on('mousedown', false);
                }
            },

            detachDatePickerElementEvents = function () {
                input.off({
                    'change': change,
                    'blur': blur,
                    'keydown': keydown,
                    'keyup': keyup,
                    'focus': options.allowInputToggle ? hide : ''
                });

                if (element.is('input')) {
                    input.off({
                        'focus': show
                    });
                } else if (component) {
                    component.off('click', toggle);
                    component.off('mousedown', false);
                }
            },

            indexGivenDates = function (givenDatesArray) {
                // Store given enabledDates and disabledDates as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledDates['2014-02-27'] === true)
                var givenDatesIndexed = {};
                $.each(givenDatesArray, function () {
                    var dDate = parseInputDate(this);
                    if (dDate.isValid()) {
                        givenDatesIndexed[dDate.format('YYYY-MM-DD')] = true;
                    }
                });
                return (Object.keys(givenDatesIndexed).length) ? givenDatesIndexed : false;
            },

            indexGivenHours = function (givenHoursArray) {
                // Store given enabledHours and disabledHours as keys.
                // This way we can check their existence in O(1) time instead of looping through whole array.
                // (for example: options.enabledHours['2014-02-27'] === true)
                var givenHoursIndexed = {};
                $.each(givenHoursArray, function () {
                    givenHoursIndexed[this] = true;
                });
                return (Object.keys(givenHoursIndexed).length) ? givenHoursIndexed : false;
            },

            initFormatting = function () {
                var format = options.format || 'L LT';

                actualFormat = format.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput) {
                    var newinput = date.localeData().longDateFormat(formatInput) || formatInput;
                    return newinput.replace(/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, function (formatInput2) { //temp fix for #740
                        return date.localeData().longDateFormat(formatInput2) || formatInput2;
                    });
                });


                parseFormats = options.extraFormats ? options.extraFormats.slice() : [];
                if (parseFormats.indexOf(format) < 0 && parseFormats.indexOf(actualFormat) < 0) {
                    parseFormats.push(actualFormat);
                }

                use24Hours = (actualFormat.toLowerCase().indexOf('a') < 1 && actualFormat.replace(/\[.*?\]/g, '').indexOf('h') < 1);

                if (isEnabled('y')) {
                    minViewModeNumber = 2;
                }
                if (isEnabled('M')) {
                    minViewModeNumber = 1;
                }
                if (isEnabled('d')) {
                    minViewModeNumber = 0;
                }

                currentViewMode = Math.max(minViewModeNumber, currentViewMode);

                if (!unset) {
                    setValue(date);
                }
            };

        /********************************************************************************
         *
         * Public API functions
         * =====================
         *
         * Important: Do not expose direct references to private objects or the options
         * object to the outer world. Always return a clone when returning values or make
         * a clone when setting a private variable.
         *
         ********************************************************************************/
        picker.destroy = function () {
            ///<summary>Destroys the widget and removes all attached event listeners</summary>
            hide();
            detachDatePickerElementEvents();
            element.removeData('DateTimePicker');
            element.removeData('date');
        };

        picker.toggle = toggle;

        picker.show = show;

        picker.hide = hide;

        picker.disable = function () {
            ///<summary>Disables the input element, the component is attached to, by adding a disabled="true" attribute to it.
            ///If the widget was visible before that call it is hidden. Possibly emits dp.hide</summary>
            hide();
            if (component && component.hasClass('btn')) {
                component.addClass('disabled');
            }
            input.prop('disabled', true);
            return picker;
        };

        picker.enable = function () {
            ///<summary>Enables the input element, the component is attached to, by removing disabled attribute from it.</summary>
            if (component && component.hasClass('btn')) {
                component.removeClass('disabled');
            }
            input.prop('disabled', false);
            return picker;
        };

        picker.ignoreReadonly = function (ignoreReadonly) {
            if (arguments.length === 0) {
                return options.ignoreReadonly;
            }
            if (typeof ignoreReadonly !== 'boolean') {
                throw new TypeError('ignoreReadonly () expects a boolean parameter');
            }
            options.ignoreReadonly = ignoreReadonly;
            return picker;
        };

        picker.options = function (newOptions) {
            if (arguments.length === 0) {
                return $.extend(true, {}, options);
            }

            if (!(newOptions instanceof Object)) {
                throw new TypeError('options() options parameter should be an object');
            }
            $.extend(true, options, newOptions);
            $.each(options, function (key, value) {
                if (picker[key] !== undefined) {
                    picker[key](value);
                } else {
                    throw new TypeError('option ' + key + ' is not recognized!');
                }
            });
            return picker;
        };

        picker.date = function (newDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.date">
            ///<summary>Returns the component's model current date, a moment object or null if not set.</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Sets the components model current moment to it. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.</summary>
            ///<param name="newDate" locid="$.fn.datetimepicker.date_p:newDate">Takes string, Date, moment, null parameter.</param>
            ///</signature>
            if (arguments.length === 0) {
                if (unset) {
                    return null;
                }
                return date.clone();
            }

            if (newDate !== null && typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('date() parameter must be one of [null, string, moment or Date]');
            }

            setValue(newDate === null ? null : parseInputDate(newDate));
            return picker;
        };

        picker.format = function (newFormat) {
            ///<summary>test su</summary>
            ///<param name="newFormat">info about para</param>
            ///<returns type="string|boolean">returns foo</returns>
            if (arguments.length === 0) {
                return options.format;
            }

            if ((typeof newFormat !== 'string') && ((typeof newFormat !== 'boolean') || (newFormat !== false))) {
                throw new TypeError('format() expects a string or boolean:false parameter ' + newFormat);
            }

            options.format = newFormat;
            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.timeZone = function (newZone) {
            if (arguments.length === 0) {
                return options.timeZone;
            }

            if (typeof newZone !== 'string') {
                throw new TypeError('newZone() expects a string parameter');
            }

            options.timeZone = newZone;

            return picker;
        };

        picker.dayViewHeaderFormat = function (newFormat) {
            if (arguments.length === 0) {
                return options.dayViewHeaderFormat;
            }

            if (typeof newFormat !== 'string') {
                throw new TypeError('dayViewHeaderFormat() expects a string parameter');
            }

            options.dayViewHeaderFormat = newFormat;
            return picker;
        };

        picker.extraFormats = function (formats) {
            if (arguments.length === 0) {
                return options.extraFormats;
            }

            if (formats !== false && !(formats instanceof Array)) {
                throw new TypeError('extraFormats() expects an array or false parameter');
            }

            options.extraFormats = formats;
            if (parseFormats) {
                initFormatting(); // reinit formatting
            }
            return picker;
        };

        picker.disabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledDates">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledDates ? $.extend({}, options.disabledDates) : options.disabledDates);
            }

            if (!dates) {
                options.disabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('disabledDates() expects an array parameter');
            }
            options.disabledDates = indexGivenDates(dates);
            options.enabledDates = false;
            update();
            return picker;
        };

        picker.enabledDates = function (dates) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledDates">
            ///<summary>Returns an array with the currently set enabled dates on the component.</summary>
            ///<returns type="array">options.enabledDates</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.enabledDates_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledDates ? $.extend({}, options.enabledDates) : options.enabledDates);
            }

            if (!dates) {
                options.enabledDates = false;
                update();
                return picker;
            }
            if (!(dates instanceof Array)) {
                throw new TypeError('enabledDates() expects an array parameter');
            }
            options.enabledDates = indexGivenDates(dates);
            options.disabledDates = false;
            update();
            return picker;
        };

        picker.daysOfWeekDisabled = function (daysOfWeekDisabled) {
            if (arguments.length === 0) {
                return options.daysOfWeekDisabled.splice(0);
            }

            if ((typeof daysOfWeekDisabled === 'boolean') && !daysOfWeekDisabled) {
                options.daysOfWeekDisabled = false;
                update();
                return picker;
            }

            if (!(daysOfWeekDisabled instanceof Array)) {
                throw new TypeError('daysOfWeekDisabled() expects an array parameter');
            }
            options.daysOfWeekDisabled = daysOfWeekDisabled.reduce(function (previousValue, currentValue) {
                currentValue = parseInt(currentValue, 10);
                if (currentValue > 6 || currentValue < 0 || isNaN(currentValue)) {
                    return previousValue;
                }
                if (previousValue.indexOf(currentValue) === -1) {
                    previousValue.push(currentValue);
                }
                return previousValue;
            }, []).sort();
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'd')) {
                    date.add(1, 'd');
                    if (tries === 31) {
                        throw 'Tried 31 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.maxDate = function (maxDate) {
            if (arguments.length === 0) {
                return options.maxDate ? options.maxDate.clone() : options.maxDate;
            }

            if ((typeof maxDate === 'boolean') && maxDate === false) {
                options.maxDate = false;
                update();
                return picker;
            }

            if (typeof maxDate === 'string') {
                if (maxDate === 'now' || maxDate === 'moment') {
                    maxDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(maxDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('maxDate() Could not parse date parameter: ' + maxDate);
            }
            if (options.minDate && parsedDate.isBefore(options.minDate)) {
                throw new TypeError('maxDate() date parameter is before options.minDate: ' + parsedDate.format(actualFormat));
            }
            options.maxDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isAfter(maxDate)) {
                setValue(options.maxDate);
            }
            if (viewDate.isAfter(parsedDate)) {
                viewDate = parsedDate.clone().subtract(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.minDate = function (minDate) {
            if (arguments.length === 0) {
                return options.minDate ? options.minDate.clone() : options.minDate;
            }

            if ((typeof minDate === 'boolean') && minDate === false) {
                options.minDate = false;
                update();
                return picker;
            }

            if (typeof minDate === 'string') {
                if (minDate === 'now' || minDate === 'moment') {
                    minDate = getMoment();
                }
            }

            var parsedDate = parseInputDate(minDate);

            if (!parsedDate.isValid()) {
                throw new TypeError('minDate() Could not parse date parameter: ' + minDate);
            }
            if (options.maxDate && parsedDate.isAfter(options.maxDate)) {
                throw new TypeError('minDate() date parameter is after options.maxDate: ' + parsedDate.format(actualFormat));
            }
            options.minDate = parsedDate;
            if (options.useCurrent && !options.keepInvalid && date.isBefore(minDate)) {
                setValue(options.minDate);
            }
            if (viewDate.isBefore(parsedDate)) {
                viewDate = parsedDate.clone().add(options.stepping, 'm');
            }
            update();
            return picker;
        };

        picker.defaultDate = function (defaultDate) {
            ///<signature helpKeyword="$.fn.datetimepicker.defaultDate">
            ///<summary>Returns a moment with the options.defaultDate option configuration or false if not set</summary>
            ///<returns type="Moment">date.clone()</returns>
            ///</signature>
            ///<signature>
            ///<summary>Will set the picker's inital date. If a boolean:false value is passed the options.defaultDate parameter is cleared.</summary>
            ///<param name="defaultDate" locid="$.fn.datetimepicker.defaultDate_p:defaultDate">Takes a string, Date, moment, boolean:false</param>
            ///</signature>
            if (arguments.length === 0) {
                return options.defaultDate ? options.defaultDate.clone() : options.defaultDate;
            }
            if (!defaultDate) {
                options.defaultDate = false;
                return picker;
            }

            if (typeof defaultDate === 'string') {
                if (defaultDate === 'now' || defaultDate === 'moment') {
                    defaultDate = getMoment();
                } else {
                    defaultDate = getMoment(defaultDate);
                }
            }

            var parsedDate = parseInputDate(defaultDate);
            if (!parsedDate.isValid()) {
                throw new TypeError('defaultDate() Could not parse date parameter: ' + defaultDate);
            }
            if (!isValid(parsedDate)) {
                throw new TypeError('defaultDate() date passed is invalid according to component setup validations');
            }

            options.defaultDate = parsedDate;

            if ((options.defaultDate && options.inline) || input.val().trim() === '') {
                setValue(options.defaultDate);
            }
            return picker;
        };

        picker.locale = function (locale) {
            if (arguments.length === 0) {
                return options.locale;
            }

            if (!moment.localeData(locale)) {
                throw new TypeError('locale() locale ' + locale + ' is not loaded from moment locales!');
            }

            options.locale = locale;
            date.locale(options.locale);
            viewDate.locale(options.locale);

            if (actualFormat) {
                initFormatting(); // reinit formatting
            }
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.stepping = function (stepping) {
            if (arguments.length === 0) {
                return options.stepping;
            }

            stepping = parseInt(stepping, 10);
            if (isNaN(stepping) || stepping < 1) {
                stepping = 1;
            }
            options.stepping = stepping;
            return picker;
        };

        picker.useCurrent = function (useCurrent) {
            var useCurrentOptions = ['year', 'month', 'day', 'hour', 'minute'];
            if (arguments.length === 0) {
                return options.useCurrent;
            }

            if ((typeof useCurrent !== 'boolean') && (typeof useCurrent !== 'string')) {
                throw new TypeError('useCurrent() expects a boolean or string parameter');
            }
            if (typeof useCurrent === 'string' && useCurrentOptions.indexOf(useCurrent.toLowerCase()) === -1) {
                throw new TypeError('useCurrent() expects a string parameter of ' + useCurrentOptions.join(', '));
            }
            options.useCurrent = useCurrent;
            return picker;
        };

        picker.collapse = function (collapse) {
            if (arguments.length === 0) {
                return options.collapse;
            }

            if (typeof collapse !== 'boolean') {
                throw new TypeError('collapse() expects a boolean parameter');
            }
            if (options.collapse === collapse) {
                return picker;
            }
            options.collapse = collapse;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.icons = function (icons) {
            if (arguments.length === 0) {
                return $.extend({}, options.icons);
            }

            if (!(icons instanceof Object)) {
                throw new TypeError('icons() expects parameter to be an Object');
            }
            $.extend(options.icons, icons);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.tooltips = function (tooltips) {
            if (arguments.length === 0) {
                return $.extend({}, options.tooltips);
            }

            if (!(tooltips instanceof Object)) {
                throw new TypeError('tooltips() expects parameter to be an Object');
            }
            $.extend(options.tooltips, tooltips);
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.useStrict = function (useStrict) {
            if (arguments.length === 0) {
                return options.useStrict;
            }

            if (typeof useStrict !== 'boolean') {
                throw new TypeError('useStrict() expects a boolean parameter');
            }
            options.useStrict = useStrict;
            return picker;
        };

        picker.sideBySide = function (sideBySide) {
            if (arguments.length === 0) {
                return options.sideBySide;
            }

            if (typeof sideBySide !== 'boolean') {
                throw new TypeError('sideBySide() expects a boolean parameter');
            }
            options.sideBySide = sideBySide;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.viewMode = function (viewMode) {
            if (arguments.length === 0) {
                return options.viewMode;
            }

            if (typeof viewMode !== 'string') {
                throw new TypeError('viewMode() expects a string parameter');
            }

            if (viewModes.indexOf(viewMode) === -1) {
                throw new TypeError('viewMode() parameter must be one of (' + viewModes.join(', ') + ') value');
            }

            options.viewMode = viewMode;
            currentViewMode = Math.max(viewModes.indexOf(viewMode), minViewModeNumber);

            showMode();
            return picker;
        };

        picker.toolbarPlacement = function (toolbarPlacement) {
            if (arguments.length === 0) {
                return options.toolbarPlacement;
            }

            if (typeof toolbarPlacement !== 'string') {
                throw new TypeError('toolbarPlacement() expects a string parameter');
            }
            if (toolbarPlacements.indexOf(toolbarPlacement) === -1) {
                throw new TypeError('toolbarPlacement() parameter must be one of (' + toolbarPlacements.join(', ') + ') value');
            }
            options.toolbarPlacement = toolbarPlacement;

            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetPositioning = function (widgetPositioning) {
            if (arguments.length === 0) {
                return $.extend({}, options.widgetPositioning);
            }

            if (({}).toString.call(widgetPositioning) !== '[object Object]') {
                throw new TypeError('widgetPositioning() expects an object variable');
            }
            if (widgetPositioning.horizontal) {
                if (typeof widgetPositioning.horizontal !== 'string') {
                    throw new TypeError('widgetPositioning() horizontal variable must be a string');
                }
                widgetPositioning.horizontal = widgetPositioning.horizontal.toLowerCase();
                if (horizontalModes.indexOf(widgetPositioning.horizontal) === -1) {
                    throw new TypeError('widgetPositioning() expects horizontal parameter to be one of (' + horizontalModes.join(', ') + ')');
                }
                options.widgetPositioning.horizontal = widgetPositioning.horizontal;
            }
            if (widgetPositioning.vertical) {
                if (typeof widgetPositioning.vertical !== 'string') {
                    throw new TypeError('widgetPositioning() vertical variable must be a string');
                }
                widgetPositioning.vertical = widgetPositioning.vertical.toLowerCase();
                if (verticalModes.indexOf(widgetPositioning.vertical) === -1) {
                    throw new TypeError('widgetPositioning() expects vertical parameter to be one of (' + verticalModes.join(', ') + ')');
                }
                options.widgetPositioning.vertical = widgetPositioning.vertical;
            }
            update();
            return picker;
        };

        picker.calendarWeeks = function (calendarWeeks) {
            if (arguments.length === 0) {
                return options.calendarWeeks;
            }

            if (typeof calendarWeeks !== 'boolean') {
                throw new TypeError('calendarWeeks() expects parameter to be a boolean value');
            }

            options.calendarWeeks = calendarWeeks;
            update();
            return picker;
        };

        picker.showTodayButton = function (showTodayButton) {
            if (arguments.length === 0) {
                return options.showTodayButton;
            }

            if (typeof showTodayButton !== 'boolean') {
                throw new TypeError('showTodayButton() expects a boolean parameter');
            }

            options.showTodayButton = showTodayButton;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.showClear = function (showClear) {
            if (arguments.length === 0) {
                return options.showClear;
            }

            if (typeof showClear !== 'boolean') {
                throw new TypeError('showClear() expects a boolean parameter');
            }

            options.showClear = showClear;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.widgetParent = function (widgetParent) {
            if (arguments.length === 0) {
                return options.widgetParent;
            }

            if (typeof widgetParent === 'string') {
                widgetParent = $(widgetParent);
            }

            if (widgetParent !== null && (typeof widgetParent !== 'string' && !(widgetParent instanceof $))) {
                throw new TypeError('widgetParent() expects a string or a jQuery object parameter');
            }

            options.widgetParent = widgetParent;
            if (widget) {
                hide();
                show();
            }
            return picker;
        };

        picker.keepOpen = function (keepOpen) {
            if (arguments.length === 0) {
                return options.keepOpen;
            }

            if (typeof keepOpen !== 'boolean') {
                throw new TypeError('keepOpen() expects a boolean parameter');
            }

            options.keepOpen = keepOpen;
            return picker;
        };

        picker.focusOnShow = function (focusOnShow) {
            if (arguments.length === 0) {
                return options.focusOnShow;
            }

            if (typeof focusOnShow !== 'boolean') {
                throw new TypeError('focusOnShow() expects a boolean parameter');
            }

            options.focusOnShow = focusOnShow;
            return picker;
        };

        picker.inline = function (inline) {
            if (arguments.length === 0) {
                return options.inline;
            }

            if (typeof inline !== 'boolean') {
                throw new TypeError('inline() expects a boolean parameter');
            }

            options.inline = inline;
            return picker;
        };

        picker.clear = function () {
            clear();
            return picker;
        };

        picker.keyBinds = function (keyBinds) {
            if (arguments.length === 0) {
                return options.keyBinds;
            }

            options.keyBinds = keyBinds;
            return picker;
        };

        picker.getMoment = function (d) {
            return getMoment(d);
        };

        picker.debug = function (debug) {
            if (typeof debug !== 'boolean') {
                throw new TypeError('debug() expects a boolean parameter');
            }

            options.debug = debug;
            return picker;
        };

        picker.allowInputToggle = function (allowInputToggle) {
            if (arguments.length === 0) {
                return options.allowInputToggle;
            }

            if (typeof allowInputToggle !== 'boolean') {
                throw new TypeError('allowInputToggle() expects a boolean parameter');
            }

            options.allowInputToggle = allowInputToggle;
            return picker;
        };

        picker.showClose = function (showClose) {
            if (arguments.length === 0) {
                return options.showClose;
            }

            if (typeof showClose !== 'boolean') {
                throw new TypeError('showClose() expects a boolean parameter');
            }

            options.showClose = showClose;
            return picker;
        };

        picker.keepInvalid = function (keepInvalid) {
            if (arguments.length === 0) {
                return options.keepInvalid;
            }

            if (typeof keepInvalid !== 'boolean') {
                throw new TypeError('keepInvalid() expects a boolean parameter');
            }
            options.keepInvalid = keepInvalid;
            return picker;
        };

        picker.datepickerInput = function (datepickerInput) {
            if (arguments.length === 0) {
                return options.datepickerInput;
            }

            if (typeof datepickerInput !== 'string') {
                throw new TypeError('datepickerInput() expects a string parameter');
            }

            options.datepickerInput = datepickerInput;
            return picker;
        };

        picker.parseInputDate = function (parseInputDate) {
            if (arguments.length === 0) {
                return options.parseInputDate;
            }

            if (typeof parseInputDate !== 'function') {
                throw new TypeError('parseInputDate() sholud be as function');
            }

            options.parseInputDate = parseInputDate;

            return picker;
        };

        picker.disabledTimeIntervals = function (disabledTimeIntervals) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledTimeIntervals">
            ///<summary>Returns an array with the currently set disabled dates on the component.</summary>
            ///<returns type="array">options.disabledTimeIntervals</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledDates if such exist.</summary>
            ///<param name="dates" locid="$.fn.datetimepicker.disabledTimeIntervals_p:dates">Takes an [ string or Date or moment ] of values and allows the user to select only from those days.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledTimeIntervals ? $.extend({}, options.disabledTimeIntervals) : options.disabledTimeIntervals);
            }

            if (!disabledTimeIntervals) {
                options.disabledTimeIntervals = false;
                update();
                return picker;
            }
            if (!(disabledTimeIntervals instanceof Array)) {
                throw new TypeError('disabledTimeIntervals() expects an array parameter');
            }
            options.disabledTimeIntervals = disabledTimeIntervals;
            update();
            return picker;
        };

        picker.disabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.disabledHours">
            ///<summary>Returns an array with the currently set disabled hours on the component.</summary>
            ///<returns type="array">options.disabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of
            ///options.enabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.disabledHours_p:hours">Takes an [ int ] of values and disallows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.disabledHours ? $.extend({}, options.disabledHours) : options.disabledHours);
            }

            if (!hours) {
                options.disabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('disabledHours() expects an array parameter');
            }
            options.disabledHours = indexGivenHours(hours);
            options.enabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };

        picker.enabledHours = function (hours) {
            ///<signature helpKeyword="$.fn.datetimepicker.enabledHours">
            ///<summary>Returns an array with the currently set enabled hours on the component.</summary>
            ///<returns type="array">options.enabledHours</returns>
            ///</signature>
            ///<signature>
            ///<summary>Setting this takes precedence over options.minDate, options.maxDate configuration. Also calling this function removes the configuration of options.disabledHours if such exist.</summary>
            ///<param name="hours" locid="$.fn.datetimepicker.enabledHours_p:hours">Takes an [ int ] of values and allows the user to select only from those hours.</param>
            ///</signature>
            if (arguments.length === 0) {
                return (options.enabledHours ? $.extend({}, options.enabledHours) : options.enabledHours);
            }

            if (!hours) {
                options.enabledHours = false;
                update();
                return picker;
            }
            if (!(hours instanceof Array)) {
                throw new TypeError('enabledHours() expects an array parameter');
            }
            options.enabledHours = indexGivenHours(hours);
            options.disabledHours = false;
            if (options.useCurrent && !options.keepInvalid) {
                var tries = 0;
                while (!isValid(date, 'h')) {
                    date.add(1, 'h');
                    if (tries === 24) {
                        throw 'Tried 24 times to find a valid date';
                    }
                    tries++;
                }
                setValue(date);
            }
            update();
            return picker;
        };
        /**
         * Returns the component's model current viewDate, a moment object or null if not set. Passing a null value unsets the components model current moment. Parsing of the newDate parameter is made using moment library with the options.format and options.useStrict components configuration.
         * @param {Takes string, viewDate, moment, null parameter.} newDate
         * @returns {viewDate.clone()}
         */
        picker.viewDate = function (newDate) {
            if (arguments.length === 0) {
                return viewDate.clone();
            }

            if (!newDate) {
                viewDate = date.clone();
                return picker;
            }

            if (typeof newDate !== 'string' && !moment.isMoment(newDate) && !(newDate instanceof Date)) {
                throw new TypeError('viewDate() parameter must be one of [string, moment or Date]');
            }

            viewDate = parseInputDate(newDate);
            viewUpdate();
            return picker;
        };

        // initializing element and component attributes
        if (element.is('input')) {
            input = element;
        } else {
            input = element.find(options.datepickerInput);
            if (input.length === 0) {
                input = element.find('input');
            } else if (!input.is('input')) {
                throw new Error('CSS class "' + options.datepickerInput + '" cannot be applied to non input element');
            }
        }

        if (element.hasClass('input-group')) {
            // in case there is more then one 'input-group-addon' Issue #48
            if (element.find('.datepickerbutton').length === 0) {
                component = element.find('.input-group-addon');
            } else {
                component = element.find('.datepickerbutton');
            }
        }

        if (!options.inline && !input.is('input')) {
            throw new Error('Could not initialize DateTimePicker without an input element');
        }

        // Set defaults for date here now instead of in var declaration
        date = getMoment();
        viewDate = date.clone();

        $.extend(true, options, dataToOptions());

        picker.options(options);

        initFormatting();

        attachDatePickerElementEvents();

        if (input.prop('disabled')) {
            picker.disable();
        }
        if (input.is('input') && input.val().trim().length !== 0) {
            setValue(parseInputDate(input.val().trim()));
        }
        else if (options.defaultDate && input.attr('placeholder') === undefined) {
            setValue(options.defaultDate);
        }
        if (options.inline) {
            show();
        }
        return picker;
    };

    /********************************************************************************
     *
     * jQuery plugin constructor and defaults object
     *
     ********************************************************************************/

    /**
    * See (http://jquery.com/).
    * @name jQuery
    * @class
    * See the jQuery Library  (http://jquery.com/) for full details.  This just
    * documents the function and classes that are added to jQuery by this plug-in.
    */
    /**
     * See (http://jquery.com/)
     * @name fn
     * @class
     * See the jQuery Library  (http://jquery.com/) for full details.  This just
     * documents the function and classes that are added to jQuery by this plug-in.
     * @memberOf jQuery
     */
    /**
     * Show comments
     * @class datetimepicker
     * @memberOf jQuery.fn
     */
    $.fn.datetimepicker = function (options) {
        options = options || {};

        var args = Array.prototype.slice.call(arguments, 1),
            isInstance = true,
            thisMethods = ['destroy', 'hide', 'show', 'toggle'],
            returnValue;

        if (typeof options === 'object') {
            return this.each(function () {
                var $this = $(this),
                    _options;
                if (!$this.data('DateTimePicker')) {
                    // create a private copy of the defaults object
                    _options = $.extend(true, {}, $.fn.datetimepicker.defaults, options);
                    $this.data('DateTimePicker', dateTimePicker($this, _options));
                }
            });
        } else if (typeof options === 'string') {
            this.each(function () {
                var $this = $(this),
                    instance = $this.data('DateTimePicker');
                if (!instance) {
                    throw new Error('bootstrap-datetimepicker("' + options + '") method was called on an element that is not using DateTimePicker');
                }

                returnValue = instance[options].apply(instance, args);
                isInstance = returnValue === instance;
            });

            if (isInstance || $.inArray(options, thisMethods) > -1) {
                return this;
            }

            return returnValue;
        }

        throw new TypeError('Invalid arguments for DateTimePicker: ' + options);
    };

    $.fn.datetimepicker.defaults = {
        timeZone: '',
        format: false,
        dayViewHeaderFormat: 'MMMM YYYY',
        extraFormats: false,
        stepping: 1,
        minDate: false,
        maxDate: false,
        useCurrent: true,
        collapse: true,
        locale: moment.locale(),
        defaultDate: false,
        disabledDates: false,
        enabledDates: false,
        icons: {
            time: 'glyphicon glyphicon-time',
            date: 'glyphicon glyphicon-calendar',
            up: 'glyphicon glyphicon-chevron-up',
            down: 'glyphicon glyphicon-chevron-down',
            previous: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            today: 'glyphicon glyphicon-screenshot',
            clear: 'glyphicon glyphicon-trash',
            close: 'glyphicon glyphicon-remove'
        },
        tooltips: {
            today: 'Go to today',
            clear: 'Clear selection',
            close: 'Close the picker',
            selectMonth: 'Select Month',
            prevMonth: 'Previous Month',
            nextMonth: 'Next Month',
            selectYear: 'Select Year',
            prevYear: 'Previous Year',
            nextYear: 'Next Year',
            selectDecade: 'Select Decade',
            prevDecade: 'Previous Decade',
            nextDecade: 'Next Decade',
            prevCentury: 'Previous Century',
            nextCentury: 'Next Century',
            pickHour: 'Pick Hour',
            incrementHour: 'Increment Hour',
            decrementHour: 'Decrement Hour',
            pickMinute: 'Pick Minute',
            incrementMinute: 'Increment Minute',
            decrementMinute: 'Decrement Minute',
            pickSecond: 'Pick Second',
            incrementSecond: 'Increment Second',
            decrementSecond: 'Decrement Second',
            togglePeriod: 'Toggle Period',
            selectTime: 'Select Time'
        },
        useStrict: false,
        sideBySide: false,
        daysOfWeekDisabled: false,
        calendarWeeks: false,
        viewMode: 'days',
        toolbarPlacement: 'default',
        showTodayButton: false,
        showClear: false,
        showClose: false,
        widgetPositioning: {
            horizontal: 'auto',
            vertical: 'auto'
        },
        widgetParent: null,
        ignoreReadonly: false,
        keepOpen: false,
        focusOnShow: true,
        inline: false,
        keepInvalid: false,
        datepickerInput: '.datepickerinput',
        keyBinds: {
            up: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(7, 'd'));
                } else {
                    this.date(d.clone().add(this.stepping(), 'm'));
                }
            },
            down: function (widget) {
                if (!widget) {
                    this.show();
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(7, 'd'));
                } else {
                    this.date(d.clone().subtract(this.stepping(), 'm'));
                }
            },
            'control up': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'y'));
                } else {
                    this.date(d.clone().add(1, 'h'));
                }
            },
            'control down': function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'y'));
                } else {
                    this.date(d.clone().subtract(1, 'h'));
                }
            },
            left: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'd'));
                }
            },
            right: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'd'));
                }
            },
            pageUp: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().subtract(1, 'M'));
                }
            },
            pageDown: function (widget) {
                if (!widget) {
                    return;
                }
                var d = this.date() || this.getMoment();
                if (widget.find('.datepicker').is(':visible')) {
                    this.date(d.clone().add(1, 'M'));
                }
            },
            enter: function () {
                this.hide();
            },
            escape: function () {
                this.hide();
            },
            //tab: function (widget) { //this break the flow of the form. disabling for now
            //    var toggle = widget.find('.picker-switch a[data-action="togglePicker"]');
            //    if(toggle.length > 0) toggle.click();
            //},
            'control space': function (widget) {
                if (!widget) {
                    return;
                }
                if (widget.find('.timepicker').is(':visible')) {
                    widget.find('.btn[data-action="togglePeriod"]').click();
                }
            },
            t: function () {
                this.date(this.getMoment());
            },
            'delete': function () {
                this.clear();
            }
        },
        debug: false,
        allowInputToggle: false,
        disabledTimeIntervals: false,
        disabledHours: false,
        enabledHours: false,
        viewDate: false
    };

    return $.fn.datetimepicker;
}));


/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _security = __webpack_require__(151);

var _security2 = _interopRequireDefault(_security);

__webpack_require__(697);

__webpack_require__(698);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import './unauthenticated';
//import './unauthorized';
//import './unauthorizedInterceptor';

//import './_security.init';
//import './_security.routes';
//import './authorizeInterceptor';
exports.default = _security2.default.name;

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
            '_'
        ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(4)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
            '_'
        ),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
            '_'
        ),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
            '_'
        ),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),
/* 246 */
/***/ (function(module, exports) {

﻿// Copyright 2014-2015 Twitter, Inc.
// Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
/*
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
    var msViewportStyle = document.createElement('style');
    msViewportStyle.appendChild(
      document.createTextNode(
        '@-ms-viewport{width:auto!important}'
      )
    );
    document.querySelector('head').appendChild(msViewportStyle);
}*/

/***/ }),
/* 247 */
/***/ (function(module, exports) {

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.5.9
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
!function(a){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(a,b){return'<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">'+(b+1)+"</button>"},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!1,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.hidden="hidden",e.paused=!1,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,f,d),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0),e.checkResponsive(!0)}var b=0;return c}(),b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.asNavFor=function(b){var c=this,d=c.options.asNavFor;d&&null!==d&&(d=a(d).not(c.$slider)),null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer),a.slideCount>a.options.slidesToShow&&a.paused!==!0&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this;a.options.infinite===!1?1===a.direction?(a.currentSlide+1===a.slideCount-1&&(a.direction=0),a.slideHandler(a.currentSlide+a.options.slidesToScroll)):(a.currentSlide-1===0&&(a.direction=1),a.slideHandler(a.currentSlide-a.options.slidesToScroll)):a.slideHandler(a.currentSlide+a.options.slidesToScroll)},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(d='<ul class="'+b.options.dotsClass+'">',c=0;c<=b.getDotCount();c+=1)d+="<li>"+b.options.customPaging.call(this,b,c)+"</li>";d+="</ul>",b.$dots=a(d).appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.html(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.target);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&(a("li",b.$dots).off("click.slick",b.changeSlide),b.options.pauseOnDotsHover===!0&&b.options.autoplay===!0&&a("li",b.$dots).off("mouseenter.slick",a.proxy(b.setPaused,b,!0)).off("mouseleave.slick",a.proxy(b.setPaused,b,!1))),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.$list.off("mouseenter.slick",a.proxy(b.setPaused,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.setPaused,b,!1)),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.html(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&b.options.autoplay===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.setPaused,b,!0)).on("mouseleave.slick",a.proxy(b.setPaused,b,!1))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.$list.on("mouseenter.slick",a.proxy(b.setPaused,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.setPaused,b,!1)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show(),a.options.autoplay===!0&&a.autoPlay()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:"next"}}))},b.prototype.lazyLoad=function(){function g(b){a("img[data-lazy]",b).each(function(){var b=a(this),c=a(this).attr("data-lazy"),d=document.createElement("img");d.onload=function(){b.animate({opacity:0},100,function(){b.attr("src",c).animate({opacity:1},200,function(){b.removeAttr("data-lazy").removeClass("slick-loading")})})},d.src=c})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=e+b.options.slidesToShow,b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.paused=!1,a.autoPlay()},b.prototype.postSlide=function(a){var b=this;b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay===!0&&b.paused===!1&&b.autoPlay(),b.options.accessibility===!0&&b.initADA()},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(){var c,d,b=this;c=a("img[data-lazy]",b.$slider).length,c>0&&(d=a("img[data-lazy]",b.$slider).first(),d.attr("src",null),d.attr("src",d.attr("data-lazy")).removeClass("slick-loading").load(function(){d.removeAttr("data-lazy"),b.progressiveLazyLoad(),b.options.adaptiveHeight===!0&&b.setPosition()}).error(function(){d.removeAttr("data-lazy"),b.progressiveLazyLoad()}))},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,c.options.infinite||(c.slideCount<=c.options.slidesToShow?c.currentSlide=0:c.currentSlide>e&&(c.currentSlide=e)),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses(0),b.setPosition(),b.$slider.trigger("reInit",[b]),b.options.autoplay===!0&&b.focusHandler()},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(b,c,d){var f,g,e=this;if("responsive"===b&&"array"===a.type(c))for(g in c)if("array"!==a.type(e.options.responsive))e.options.responsive=[c[g]];else{for(f=e.options.responsive.length-1;f>=0;)e.options.responsive[f].breakpoint===c[g].breakpoint&&e.options.responsive.splice(f,1),f--;e.options.responsive.push(c[g])}else e.options[b]=c;d===!0&&(e.unload(),e.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.setPaused=function(a){var b=this;b.options.autoplay===!0&&b.options.pauseOnHover===!0&&(b.paused=a,a?b.autoPlayClear():b.autoPlay())},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d);
}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay===!0&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"left":"right":"vertical"},b.prototype.swipeEnd=function(a){var c,b=this;if(b.dragging=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe)switch(b.swipeDirection()){case"left":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.slideHandler(c),b.currentDirection=0,b.touchObject={},b.$slider.trigger("swipe",[b,"left"]);break;case"right":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.slideHandler(c),b.currentDirection=1,b.touchObject={},b.$slider.trigger("swipe",[b,"right"])}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return 1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;document[a.hidden]?(a.paused=!0,a.autoPlayClear()):a.options.autoplay===!0&&(a.paused=!1,a.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.focusHandler=function(){var b=this;b.$slider.on("focus.slick blur.slick","*",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.isPlay&&(d.is(":focus")?(b.autoPlayClear(),b.paused=!0):(b.paused=!1,b.autoPlay()))},0)})},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(angular) {/**
 * State-based routing for AngularJS 1.x
 * @version v1.0.29
 * @link https://ui-router.github.io
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (global, factory) {
     true ? factory(exports, __webpack_require__(2)) :
    typeof define === 'function' && define.amd ? define(['exports', 'angular'], factory) :
    (global = global || self, factory(global['@uirouter/angularjs-state-events'] = {}, global.angular));
}(this, (function (exports, ng_from_import) { 'use strict';

    /** @publicapi @module ng1 */ /** */
    /** @hidden */ var ng_from_global = angular;
    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;

    /**
     * # Legacy state events
     *
     * Polyfill implementation of the UI-Router 0.2.x state events.
     *
     * The 0.2.x state events are deprecated.  We recommend moving to Transition Hooks instead, as they
     * provide much more flexibility, support async, and provide the context (the Transition, etc) necessary
     * to implement meaningful application behaviors.
     *
     * To enable these state events, include the `stateEvents.js` file in your project, e.g.,
     * ```
     * <script src="stateEvents.js"></script>
     * ```
     * and also make sure you depend on the `ui.router.state.events` angular module, e.g.,
     * ```
     * angular.module("myApplication", ['ui.router', 'ui.router.state.events']
     * ```
     *
     * @publicapi @module ng1_state_events
     */ /** */
    /**
     * An event broadcast on `$rootScope` when the state transition **begins**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] instead
     *
     * You can use `event.preventDefault()`
     * to prevent the transition from happening and then the transition promise will be
     * rejected with a `'transition prevented'` value.
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]]
     *
     * #### Example:
     * ```js
     * $rootScope.$on('$stateChangeStart', function(event, transition) {
     *   event.preventDefault();
     *   // transitionTo() promise will be rejected with
     *   // a 'transition prevented' error
     * })
     * ```
     *
     * @event $stateChangeStart
     * @deprecated
     */
    var $stateChangeStart;
    /**
     * An event broadcast on `$rootScope` if a transition is **cancelled**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] instead
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that was cancelled
     *
     * @event $stateChangeCancel
     * @deprecated
     */
    var $stateChangeCancel;
    /**
     * An event broadcast on `$rootScope` once the state transition is **complete**.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] and [[Transition.promise]], or [[Transition.onSuccess]]
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that just succeeded
     *
     * @event $stateChangeSuccess
     * @deprecated
     */
    var $stateChangeSuccess;
    /**
     * An event broadcast on `$rootScope` when an **error occurs** during transition.
     *
     * ### Deprecation warning: use [[TransitionService.onStart]] and [[Transition.promise]], or [[Transition.onError]]
     *
     * It's important to note that if you
     * have any errors in your resolve functions (javascript errors, non-existent services, etc)
     * they will not throw traditionally. You must listen for this $stateChangeError event to
     * catch **ALL** errors.
     *
     * Additional arguments to the event handler are provided:
     * - `toState`: the Transition Target state
     * - `toParams`: the Transition Target Params
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `error`: The reason the transition errored.
     * - `options`: any Transition Options
     * - `$transition$`: the [[Transition]] that errored
     *
     * @event $stateChangeError
     * @deprecated
     */
    var $stateChangeError;
    /**
     * An event broadcast on `$rootScope` when a requested state **cannot be found** using the provided state name.
     *
     * ### Deprecation warning: use [[StateService.onInvalid]] instead
     *
     * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
     * lazy-loading the unfound state). A `TargetState` object is passed to the listener handler,
     * you can see its properties in the example. You can use `event.preventDefault()` to abort the
     * transition and the promise returned from `transitionTo()` will be rejected with a
     * `'transition aborted'` error.
     *
     * Additional arguments to the event handler are provided:
     * - `unfoundState` Unfound State information. Contains: `to, toParams, options` properties.
     * - `fromState`: the state the transition is coming from
     * - `fromParams`: the parameters from the state the transition is coming from
     * - `options`: any Transition Options
     *
     * #### Example:
     * ```js
     * // somewhere, assume lazy.state has not been defined
     * $state.go("lazy.state", { a: 1, b: 2 }, { inherit: false });
     *
     * // somewhere else
     * $scope.$on('$stateNotFound', function(event, transition) {
     * function(event, unfoundState, fromState, fromParams){
     *     console.log(unfoundState.to); // "lazy.state"
     *     console.log(unfoundState.toParams); // {a:1, b:2}
     *     console.log(unfoundState.options); // {inherit:false} + default options
     * });
     * ```
     *
     * @event $stateNotFound
     * @deprecated
     */
    var $stateNotFound;
    (function () {
        var isFunction = ng.isFunction, isString = ng.isString;
        function applyPairs(memo, keyValTuple) {
            var key, value;
            if (Array.isArray(keyValTuple))
                key = keyValTuple[0], value = keyValTuple[1];
            if (!isString(key))
                throw new Error('invalid parameters to applyPairs');
            memo[key] = value;
            return memo;
        }
        function stateChangeStartHandler($transition$) {
            if (!$transition$.options().notify || !$transition$.valid() || $transition$.ignored())
                return;
            var $injector = $transition$.injector();
            var $stateEvents = $injector.get('$stateEvents');
            var $rootScope = $injector.get('$rootScope');
            var $state = $injector.get('$state');
            var $urlRouter = $injector.get('$urlRouter');
            var enabledEvents = $stateEvents.provider.enabled();
            var toParams = $transition$.params('to');
            var fromParams = $transition$.params('from');
            if (enabledEvents.$stateChangeSuccess) {
                var startEvent = $rootScope.$broadcast('$stateChangeStart', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                if (startEvent.defaultPrevented) {
                    if (enabledEvents.$stateChangeCancel) {
                        $rootScope.$broadcast('$stateChangeCancel', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                    }
                    // Don't update and resync url if there's been a new transition started. see issue #2238, #600
                    if ($state.transition == null)
                        $urlRouter.update();
                    return false;
                }
                // right after global state is updated
                var successOpts = { priority: 9999 };
                $transition$.onSuccess({}, function () {
                    $rootScope.$broadcast('$stateChangeSuccess', $transition$.to(), toParams, $transition$.from(), fromParams, $transition$.options(), $transition$);
                }, successOpts);
            }
            if (enabledEvents.$stateChangeError) {
                $transition$.promise['catch'](function (error) {
                    if (error && (error.type === 2 /* RejectType.SUPERSEDED */ || error.type === 3) /* RejectType.ABORTED */)
                        return;
                    var evt = $rootScope.$broadcast('$stateChangeError', $transition$.to(), toParams, $transition$.from(), fromParams, error, $transition$.options(), $transition$);
                    if (!evt.defaultPrevented) {
                        $urlRouter.update();
                    }
                });
            }
        }
        stateNotFoundHandler.$inject = ['$to$', '$from$', '$state', '$rootScope', '$urlRouter'];
        function stateNotFoundHandler($to$, $from$, injector) {
            var $state = injector.get('$state');
            var $rootScope = injector.get('$rootScope');
            var $urlRouter = injector.get('$urlRouter');
            var redirect = { to: $to$.identifier(), toParams: $to$.params(), options: $to$.options() };
            var e = $rootScope.$broadcast('$stateNotFound', redirect, $from$.state(), $from$.params());
            if (e.defaultPrevented || e.retry)
                $urlRouter.update();
            function redirectFn() {
                return $state.target(redirect.to, redirect.toParams, redirect.options);
            }
            if (e.defaultPrevented) {
                return false;
            }
            else if (e.retry || !!$state.get(redirect.to)) {
                return e.retry && isFunction(e.retry.then) ? e.retry.then(redirectFn) : redirectFn();
            }
        }
        $StateEventsProvider.$inject = ['$stateProvider'];
        function $StateEventsProvider($stateProvider) {
            $StateEventsProvider.prototype.instance = this;
            var runtime = false;
            var allEvents = ['$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError'];
            var enabledStateEvents = allEvents.map(function (e) { return [e, true]; }).reduce(applyPairs, {});
            function assertNotRuntime() {
                if (runtime)
                    throw new Error('Cannot enable events at runtime (use $stateEventsProvider');
            }
            /**
             * Enables the deprecated UI-Router 0.2.x State Events
             * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
             */
            this.enable = function () {
                var events = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    events[_i] = arguments[_i];
                }
                assertNotRuntime();
                if (!events || !events.length)
                    events = allEvents;
                events.forEach(function (event) { return (enabledStateEvents[event] = true); });
            };
            /**
             * Disables the deprecated UI-Router 0.2.x State Events
             * [ '$stateChangeStart', '$stateNotFound', '$stateChangeSuccess', '$stateChangeError' ]
             */
            this.disable = function () {
                var events = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    events[_i] = arguments[_i];
                }
                assertNotRuntime();
                if (!events || !events.length)
                    events = allEvents;
                events.forEach(function (event) { return delete enabledStateEvents[event]; });
            };
            this.enabled = function () { return enabledStateEvents; };
            this.$get = $get;
            $get.$inject = ['$transitions'];
            function $get($transitions) {
                runtime = true;
                if (enabledStateEvents['$stateNotFound'])
                    $stateProvider.onInvalid(stateNotFoundHandler);
                if (enabledStateEvents.$stateChangeStart)
                    $transitions.onBefore({}, stateChangeStartHandler, { priority: 1000 });
                return {
                    provider: $StateEventsProvider.prototype.instance,
                };
            }
        }
        ng
            .module('ui.router.state.events', ['ui.router.state'])
            .provider('$stateEvents', $StateEventsProvider)
            .run([
            '$stateEvents',
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            function ($stateEvents) {
                /* Invokes $get() */
            },
        ]);
    })();

    exports.$stateChangeCancel = $stateChangeCancel;
    exports.$stateChangeError = $stateChangeError;
    exports.$stateChangeStart = $stateChangeStart;
    exports.$stateChangeSuccess = $stateChangeSuccess;
    exports.$stateNotFound = $stateNotFound;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=stateEvents.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "dimanche",
      "lundi",
      "mardi",
      "mercredi",
      "jeudi",
      "vendredi",
      "samedi"
    ],
    "ERANAMES": [
      "avant J\u00e9sus-Christ",
      "apr\u00e8s J\u00e9sus-Christ"
    ],
    "ERAS": [
      "av. J.-C.",
      "ap. J.-C."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "janvier",
      "f\u00e9vrier",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "ao\u00fbt",
      "septembre",
      "octobre",
      "novembre",
      "d\u00e9cembre"
    ],
    "SHORTDAY": [
      "dim.",
      "lun.",
      "mar.",
      "mer.",
      "jeu.",
      "ven.",
      "sam."
    ],
    "SHORTMONTH": [
      "janv.",
      "f\u00e9vr.",
      "mars",
      "avr.",
      "mai",
      "juin",
      "juil.",
      "ao\u00fbt",
      "sept.",
      "oct.",
      "nov.",
      "d\u00e9c."
    ],
    "STANDALONEMONTH": [
      "Janvier",
      "F\u00e9vrier",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Ao\u00fbt",
      "Septembre",
      "Octobre",
      "Novembre",
      "D\u00e9cembre"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "d MMM y HH:mm:ss",
    "mediumDate": "d MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/y HH:mm",
    "shortDate": "dd/MM/y",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": "\u00a0",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "\u00a0\u00a4",
        "posPre": "",
        "posSuf": "\u00a0\u00a4"
      }
    ]
  },
  "id": "fr",
  "localeID": "fr",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  if (i == 0 || i == 1) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "a.m.",
      "p.m."
    ],
    "DAY": [
      "zondag",
      "maandag",
      "dinsdag",
      "woensdag",
      "donderdag",
      "vrijdag",
      "zaterdag"
    ],
    "ERANAMES": [
      "voor Christus",
      "na Christus"
    ],
    "ERAS": [
      "v.Chr.",
      "n.Chr."
    ],
    "FIRSTDAYOFWEEK": 0,
    "MONTH": [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december"
    ],
    "SHORTDAY": [
      "zo",
      "ma",
      "di",
      "wo",
      "do",
      "vr",
      "za"
    ],
    "SHORTMONTH": [
      "jan.",
      "feb.",
      "mrt.",
      "apr.",
      "mei",
      "jun.",
      "jul.",
      "aug.",
      "sep.",
      "okt.",
      "nov.",
      "dec."
    ],
    "STANDALONEMONTH": [
      "Januari",
      "Februari",
      "Maart",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Augustus",
      "September",
      "Oktober",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE d MMMM y",
    "longDate": "d MMMM y",
    "medium": "d MMM y HH:mm:ss",
    "mediumDate": "d MMM y",
    "mediumTime": "HH:mm:ss",
    "short": "dd-MM-yy HH:mm",
    "shortDate": "dd-MM-yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u20ac",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "\u00a4\u00a0-",
        "negSuf": "",
        "posPre": "\u00a4\u00a0",
        "posSuf": ""
      }
    ]
  },
  "id": "nl",
  "localeID": "nl",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 252 */,
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.appComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = exports.appComponent = {
    template: __webpack_require__(505),
    controllerAs: 'vm',
    controller: ["config", "authService", "categoryService", "sellerService", "$q", "localizer", "gettextCatalog", "reservationCampaignService", function controller(config, authService, categoryService, sellerService, $q, localizer, gettextCatalog, reservationCampaignService /*, $rootScope, $timeout, common*/) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.languageChanged = languageChanged;
        vm.getPolicyUrl = getPolicyUrl;
        vm.closeVaccinesAlert = closeVaccinesAlert;
        vm.cookieMessage = gettextCatalog.getString('Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.');
        vm.cookieAcceptText = gettextCatalog.getString('Close and don\'t show again');
        vm.cookiePolicyText = gettextCatalog.getString('Learn more');
        vm.vaccinesAlertOpen = false;
        vm.isFebelcoCustomer = false;
        vm.navigationData = {};
        vm.isBeforeBlackFriday = isBeforeBlackFriday;
        vm.isBlackFridayDate = isBlackFridayDate;
        vm.checkVaccinDate = checkVaccinDate;

        vm.closeReservationCampaignAlert = closeReservationCampaignAlert;
        vm.activeCampaigns = [];

        function init() {
            var _this = this;

            var tenants = authService.customUserInfo.tenants;
            vm.activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.isFebelcoCustomer = authService.isFebelcoCustomer;
            localizer.addLanguageChangeEvent(function () {
                return _this.languageChanged();
            });
            vm.vaccinesAlertOpen = getVaccinesAlertOpenFromLocalStorage();
            if (vm.isFebelcoCustomer) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    response.forEach(function (campaign) {
                        campaign.alertDismissed = getReservationCampaignAlertDismissedFromLocalStorage(campaign.code);
                    });
                    vm.activeCampaigns = response;
                });
            }
        }

        function getVaccinesAlertOpenFromLocalStorage() {
            if (window.localStorage.getItem('vaccinesAlertOpen2020') === 'false') {
                return false;
            } else {
                return true;
            }
        }

        function getReservationCampaignAlertDismissedFromLocalStorage(code) {
            if (window.localStorage.getItem('ReservationCampaignAlertOpen' + code) === 'false') {
                return true;
            } else {
                return false;
            }
        }

        function closeReservationCampaignAlert(campaign) {
            campaign.alertDismissed = true;
            window.localStorage.setItem('ReservationCampaignAlertOpen' + campaign.code, false);
        }

        function languageChanged() {
            categoryService.getMenuCategories().then(function (result) {
                vm.navigationData.categories = result;
            });
        }

        function getPolicyUrl() {
            switch (window.localStorage.getItem('language')) {
                case 'nl':
                    return 'http://www.profficina.be/nl/algemene-voorwaarden.html';
                case 'fr':
                    return 'http://www.profficina.be/fr/conditions-generales.html';
                default:
                    return 'http://www.profficina.be/nl/algemene-voorwaarden.html';
            }
        }

        function closeVaccinesAlert() {
            vm.vaccinesAlertOpen = false;
            window.localStorage.setItem('vaccinesAlertOpen2020', false);
        }

        function isBlackFridayDate() {
            if ((0, _moment2.default)('2019-11-29').format('YYYY-MM-DD') === (0, _moment2.default)().format('YYYY-MM-DD')) {
                return true;
            }
            return false; //change to false to make this work
        }

        function isBeforeBlackFriday() {
            if ((0, _moment2.default)('2019-11-29').format('YYYY-MM-DD') > (0, _moment2.default)().format('YYYY-MM-DD')) {
                return true;
            }
            return false;
        }

        function checkVaccinDate() {
            var fluVaccinesEndDate = config.fluVaccines.endDate;
            var fluVaccinesStartDate = config.fluVaccines.startDate;
            return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD');
            // var today= moment().format('YYYY-MM-DD');
            // var startDate= moment('2020-03-16').format('YYYY-MM-DD');
            // var endDate = moment('2020-04-15').format('YYYY-MM-DD');
            // var condition = startDate <= today && endDate >= today;
            // if (condition) {
            //     return true;
            // }
            // return false; //change to false to make this work
        }
    }]
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(96);

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(156);

__webpack_require__(95);

__webpack_require__(158);

__webpack_require__(75);

__webpack_require__(163);

__webpack_require__(164);

__webpack_require__(155);

__webpack_require__(153);

__webpack_require__(154);

__webpack_require__(159);

__webpack_require__(161);

__webpack_require__(157);

__webpack_require__(160);

__webpack_require__(167);

var _core = __webpack_require__(706);

var _core2 = _interopRequireDefault(_core);

var _directives = __webpack_require__(723);

var _directives2 = _interopRequireDefault(_directives);

var _filters = __webpack_require__(725);

var _filters2 = _interopRequireDefault(_filters);

var _models = __webpack_require__(753);

var _models2 = _interopRequireDefault(_models);

var _services = __webpack_require__(814);

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.common', [
// 3rd party dependencies
'gettext', 'ui.router', 'ngResource', 'ngLodash', 'ngDialog', 'ngStorage', 'ngLocale', 'tmh.dynamicLocale', 'angular-click-outside', 'toastr', 'ngAria', 'slickCarousel', 'youtube-embed', 'angular-google-analytics', 'ngPicturefill',

// own dependencies
_core2.default, _directives2.default, _filters2.default, _models2.default, _services2.default]);

exports.default = _module.name;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _account = __webpack_require__(847);

var _account2 = _interopRequireDefault(_account);

var _authorization = __webpack_require__(893);

var _authorization2 = _interopRequireDefault(_authorization);

var _brand = __webpack_require__(896);

var _brand2 = _interopRequireDefault(_brand);

var _category = __webpack_require__(899);

var _category2 = _interopRequireDefault(_category);

var _checkout = __webpack_require__(909);

var _checkout2 = _interopRequireDefault(_checkout);

var _common = __webpack_require__(919);

var _common2 = _interopRequireDefault(_common);

var _discount = __webpack_require__(928);

var _discount2 = _interopRequireDefault(_discount);

var _fastOrder = __webpack_require__(933);

var _fastOrder2 = _interopRequireDefault(_fastOrder);

var _home = __webpack_require__(937);

var _home2 = _interopRequireDefault(_home);

var _layout = __webpack_require__(939);

var _layout2 = _interopRequireDefault(_layout);

var _news = __webpack_require__(952);

var _news2 = _interopRequireDefault(_news);

var _help = __webpack_require__(935);

var _help2 = _interopRequireDefault(_help);

var _product = __webpack_require__(985);

var _product2 = _interopRequireDefault(_product);

var _search = __webpack_require__(1006);

var _search2 = _interopRequireDefault(_search);

var _seller = __webpack_require__(1021);

var _seller2 = _interopRequireDefault(_seller);

var _error = __webpack_require__(930);

var _error2 = _interopRequireDefault(_error);

var _vaccines = __webpack_require__(1031);

var _vaccines2 = _interopRequireDefault(_vaccines);

var _reservationCampaign = __webpack_require__(1004);

var _reservationCampaign2 = _interopRequireDefault(_reservationCampaign);

var _outlet = __webpack_require__(957);

var _outlet2 = _interopRequireDefault(_outlet);

var _rental = __webpack_require__(999);

var _rental2 = _interopRequireDefault(_rental);

var _certificates = __webpack_require__(902);

var _certificates2 = _interopRequireDefault(_certificates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import staticModule from './static';

var _module = _angular2.default.module('app.features', [_account2.default, _authorization2.default, _brand2.default, _category2.default, _checkout2.default, _common2.default, _discount2.default, _fastOrder2.default, _home2.default, _layout2.default, _news2.default, _product2.default, _search2.default, _seller2.default,
//staticModule,
_vaccines2.default, _reservationCampaign2.default, _error2.default, _help2.default, _outlet2.default, _rental2.default, _certificates2.default]);

exports.default = _module.name;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


logDecorator.$inject = ["$logProvider", "$provide", "config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logDecorator = logDecorator;
/*@ngInject*/
function logDecorator($logProvider, $provide, config) {
    // In acceptance and production, we only log warnings and errors
    $logProvider.debugEnabled(config.env === 'local' || config.env === 'dev');

    $provide.decorator('$log', ["$delegate", function ($delegate) {
        //Original methods
        var origInfo = $delegate.info;
        var origLog = $delegate.log;

        //Override the default behavior    
        $delegate.log = function () {
            if ($logProvider.debugEnabled()) {
                origLog.apply(null, arguments);
            }
        };

        //Override the default behavior
        $delegate.info = function () {
            if ($logProvider.debugEnabled()) {
                origInfo.apply(null, arguments);
            }
        };

        return $delegate;
    }]);
}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = trackJs;

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, exports) {

module.exports = "<cookie-law-banner policy-button=true message=\"{{vm.cookieMessage}}\" accept-text=\"{{vm.cookieAcceptText}}\" policy-text=\"{{vm.cookiePolicyText}}\" policy-blank=true policy-url=\"{{vm.getPolicyUrl()}}\"></cookie-law-banner> <div ng-if=\"vm.vaccinesAlertOpen && vm.activeTenant && vm.isFebelcoCustomer && vm.checkVaccinDate()\" class=\"alert-header alert-header-info\"> <a ng-click=vm.closeVaccinesAlert() class=alert-close></a> <div class=container> <div class=alert-content> <a ui-sref=general.vaccines translate>Reserveer nu uw griep vaccins</a> </div> </div> </div> <div ng-if=\"vm.activeTenant && vm.isFebelcoCustomer && vm.activeCampaigns.length\"> <div ng-repeat=\"campaign in vm.activeCampaigns\"> <div class=\"alert-header alert-header-info\" ng-if=!campaign.alertDismissed> <a ng-click=vm.closeReservationCampaignAlert(campaign) class=alert-close></a> <div class=container> <div class=alert-content> <a ui-sref=\"general.reservations({ code: campaign.code })\">{{ campaign.name }}</a> </div> </div> </div> </div> </div> <div ng-if=::vm.isBlackFridayDate() class=\"align-center center-block\"> <div class=blackfriday-header> <a ui-sref=\"general.products({filter:'102_17292__103_1'})\"> <img src={{::$root.getBlackFridayImageUrl()}} alt=\"\"/> </a> </div> </div> <div ng-if=::vm.isBeforeBlackFriday() class=\"align-center center-block\"> <div class=blackfriday-header> <img src={{::$root.getBeforeBlackFridayImageUrl()}} alt=\"\"/> </div> </div> <div class=site id=top> <header class=site-header> <div class=site-header-top> <div class=container> <a ui-sref=home class=\"site-header-logo hidden-sm-down\"> <img src=/assets/img/profficina-logo.svg alt=Profficina /> </a> <a ui-sref=home class=\"site-header-logo hidden-md-up\"> <img src=/assets/img/profficina-logo-sm.svg alt=Profficina /> </a> <div ui-view=header></div> </div> </div> <div ui-view=menu></div> <div ui-view=submenu></div> </header> <div class=\"container site-container\"> <div ui-view=main></div> <div ui-view=aside fb-ignore-for-breadcrumb></div> </div> <footer ui-view=footer fb-ignore-for-breadcrumb> </footer> </div> <div ng-if=$root.overlayVisible class=\"loading-overlay loading-overlay-page\"> <div class=\"loading loading-large\"></div> </div>";

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dialog dialog-add-to-cart\"> <div class=\"box box-2\"> <div class=\"box-hd is-info\"> <h3>{{ ::title }}</h3> </div> <div class=box-bd> {{ ::msg }} </div> <div class=box-ft> <ul class=\"btn-holder btn-holder-2-btn\"> <li><a ng-click=closeThisDialog(0) role=button class=\"btn btn-primary-outline btn-block\" translate>No</a></li> <li><a ng-click=closeThisDialog(1) role=button class=\"btn btn-primary btn-block\" translate>Yes</a></li> </ul> </div> </div> </div>";

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = "<div class=dialog> <div class=\"box box-2\" claim-authorize=IsBuyer> <div class=\"box-hd is-info\"> <h3 translate>Select other pharmacy</h3> </div> <div class=box-bd> <ul class=\"list list-arrow list-spaced list-divided m-b-2\"> <li ng-repeat=\"t in ::tenants\"> <a ng-if=\"t.apbNumber === activeTenant.apbNumber\" class=\"link active\">{{::t.name}} - {{::t.apbNumber}}</a> <a ng-if=\"t.apbNumber !== activeTenant.apbNumber\" role=button class=link ng-click=select(t)>{{::t.name}} - {{::t.apbNumber}}</a> </li> </ul> <p class=\"type-small text-muted\" translate>Orders are pharmacy based. When you log on as another pharmacy, your shopping basket will change. Your current shopping basket is however not removed.</p> </div> <div class=box-ft> <ul class=\"btn-holder btn-holder-2-btn\"> <li></li> <li><a ng-click=closeThisDialog(0) role=button class=\"btn btn-outline btn-block\" translate>Cancel</a></li> </ul> </div> </div> <div class=\"box box-2\" claim-authorize=IsSeller> <div class=\"box-hd is-info\"> <h3 translate>Select other seller</h3> </div> <div class=box-bd> <ul class=\"list list-arrow list-spaced list-divided m-b-2\"> <li ng-repeat=\"t in ::tenants\"> <a ng-if=\"t.secondaryAppUserKey === activeTenant.secondaryAppUserKey\" class=\"link active\">{{::t.sellerName}}</a> <a ng-if=\"t.secondaryAppUserKey !== activeTenant.secondaryAppUserKey\" role=button class=link ng-click=select(t)>{{::t.sellerName}}</a> </li> </ul> </div> <div class=box-ft> <ul class=\"btn-holder btn-holder-2-btn\"> <li></li> <li><a ng-click=closeThisDialog(0) role=button class=\"btn btn-outline btn-block\" translate>Cancel</a></li> </ul> </div> </div> </div>";

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-lg-2-3 w-xl-1-2\"> <h1>{{vm.contract.name}}</h1> </div> </div> <div class=r> <div class=\"c w-lg-2-3 w-xl-1-2\"> <div class=box> <div class=\"r clearfix\"> <div class=\"c w-md-1-2 m-b-1\"> <p> <span class=\"discount-sticker-{{vm.contract.portalContractTypeCode.toLowerCase()}}\" style=width:32px;height:32px></span> <img ng-src=\"{{::$root.getImage(vm.contract.logoImagePath, 'Logo');}}\" style=width:128px /> </p> </div> <div class=\"c w-md-1-2 m-b-1\"> <p class=\"align-right p-t-1\"><a href={{vm.getDownloadUrlContractDetail()}} target=_blank class=\"btn btn-outline\" style=width:196px><i class=\"ico ico-file-pdf\"></i><b class=lbl translate>Download PDF</b></a></p> </div> </div> <p> <span translate>Valid from</span> <strong>{{vm.contract.startDate | date: 'dd/MM/yyyy'}}</strong> <span ng-if=!vm.checkYearsApart() translate>until</span> <strong ng-if=!vm.checkYearsApart()>{{vm.contract.endDate | date: 'dd/MM/yyyy'}}</strong> <span ng-if=vm.checkYearsApart() translate>indefinite</span> </p> <p ng-if=\"vm.contract.portalContractTypeCode === 'FEB' || vm.contract.portalContractTypeCode === 'FPA'\" translate>For more information about this contract, please contact your relationship manager.</p> <p ng-if=\"vm.contract.portalContractTypeCode === 'AGIOS'\" translate>For more information about this contract, please contact your supplier.</p> </div> <div class=\"box box-bg\"> <div class=box-hd> <h3 translate>Your purchases</h3> </div> <div class=box-bd> <div class=form-inline> <div class=\"form-group form-group-stretch\"> <label class=form-lbl translate>From</label> <fb-date-picker value=vm.from min-date=vm.minFrom></fb-date-picker> </div> <div class=\"form-group form-group-stretch\"> <label class=form-lbl translate>Until</label> <fb-date-picker value=vm.to></fb-date-picker> </div> <div class=\"form-group align-bottom\"> <a href={{vm.getDownloadUrl()}} ng-disabled=!vm.startDateIsValid() class=\"btn btn-primary btn-block\" target=_blank><i class=\"ico ico-file-pdf\"></i><b class=lbl>Rapport</b></a> </div> </div> <div ng-if=!vm.startDateIsValid()> <span class=invalid-feedback translate>From date must be greater than contract start date.</span> </div> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-2-3 w-xl-1-2\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>Contract details</h3> </div> <div class=box-bd> <div class=folder-faq> <folder-collapse is-open=true folder-title=::vm.contract.name> <div class=richtext ng-bind-html=::vm.contract.description> </div> </folder-collapse> </div> </div> </div> </div> </div> <contract-products contract=vm.contract></contract-products>";

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-lg-2-3 w-xl-1-2\"> <div ng-if=vm.contract.products.length class=\"box box-2\"> <div class=box-hd> <h3 translate>Products</h3> </div> <div class=box-bd> <pager paging=vm.contract.paging go-to-page=vm.goToPage(page)></pager> <div class=box> <div ng-if=!vm.contract.allProducts class=\"toolbar toolbar-sellers-overview toolbar-top\"> <div class=search> <input ng-model=vm.searchValue ng-change=vm.onProductSearch() type=search placeholder=\"{{ 'Search by name or number' | translate}}\" class=input /> </div> </div> <div class=\"alert alert-info\" ng-if=vm.contract.allProducts> <span translate>All products of this supplier or in your contract.</span> </div> </div> <table ng-if=vm.pagedContractProducts.length class=\"table table-block\"> <thead> <tr> <th ng-click=\"vm.onOrderProducts('sellerArticleNumber')\" translate>Product number</th> <th ng-click=\"vm.onOrderProducts('name')\" translate>Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.pagedContractProducts\"> <td>{{product.sellerArticleNumber}}</td> <td>{{product.name}}</td> </tr> </tbody> </table> <div ng-if=!vm.pagedContractProducts.length> <span translate>No products found.</span> </div> </div> </div> <div ng-if=!vm.contract.products.length> <span translate>No products found.</span> </div> </div> </div>";

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "<h1 translate ng-if=\"vm.context !== 'partnership'\">My contracts</h1> <div ng-if=\"vm.contracts.length !== 0 && vm.context !== 'partnership'\" class=box> <div class=\"toolbar toolbar-sellers-overview toolbar-top\"> <div class=search> <input ng-model=vm.searchValue type=search placeholder=\"{{ 'Search by contract name' | translate}}\" class=input /> </div> </div> </div> <div ng-repeat=\"contractsObject in vm.contracts\" class=\"box box-2\"> <div class=box-hd> <h2>{{contractsObject.type.name}}</h2> </div> <div class=box-bd> <table class=\"table table-block table-spaced table-agios-contracts\"> <thead> <tr> <th></th> <th></th> <th translate ng-click=\"vm.sortBy('name')\">Contract name</th> <th translate>Valid from - until</th> </tr> </thead> <tbody> <tr ng-repeat=\"contract in contractsObject.contracts | filter: vm.searchValue | orderBy : vm.propertyName : vm.reverse\"> <td> <span class=\"discount-sticker-{{contract.portalContractTypeCode.toLowerCase()}}\"></span> </td> <td><img ng-src=\"{{::$root.getImage(contract.logoImagePath, 'Logo');}}\" alt=\"\"></td> <td><a ui-sref=\"contract-detail({ id: contract.id })\" class=link>{{contract.name}}</a></td> <td>{{contract.startDate | date: 'dd/MM/yyyy' }} - <span ng-if=!vm.checkYearsApart(contract)>{{contract.endDate | date: 'dd/MM/yyyy' }}</span> <span ng-if=vm.checkYearsApart(contract) translate>indefinitely</span></td> </tr> </tbody> </table> </div> </div> <div ng-if=\"vm.contracts.length === 0\" class=\"box box-2\"> <p translate>Currently you do not have any Febelco Partner or Agios contract.</p> </div>";

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2 box-2-primary\" ng-if=::vm.order.shippingNotes> <div class=box-hd> <h3 translate>Deliveries</h3> </div> <div class=box-bd> <div class=\"table table-fake table-deliveries\"> <div class=table-hd> <div class=table-r> <div class=\"table-c table-c-delivery\" translate>Delivery nr.</div> <div class=\"table-c table-c-status\" translate>Status</div> <div class=\"table-c table-c-amount\" translate>Total</div> </div> </div> <div class=table-bd> <div class=table-r ng-repeat=\"shippingNote in ::vm.order.shippingNotes\"> <div class=table-r-folder fb-folder target=\"#od-{{ ::shippingNote.shippingNoteNumber }}\"> <div class=\"table-c table-c-delivery\"> <div class=table-lbl translate>Delivery nr.</div> <div class=table-val>{{ ::shippingNote.warehouseCode }}/{{ ::shippingNote.shippingNoteNumber }}</div> </div> <div class=\"table-c table-c-status\" ng-class=\"{ 'text-success': (shippingNote.stateCode === 'DELIVREADY' || shippingNote.stateCode === 'DELIVINV') }\"> <i class=ico ng-class=\"{ 'ico-alert-success': (shippingNote.stateCode === 'DELIVREADY' || shippingNote.stateCode === 'DELIVINV') }\"></i> {{vm.getDeliveryStatusText(shippingNote.stateCode)}} </div> <div class=\"table-c table-c-amount\"> <div class=table-lbl>Total</div> <div class=table-val>{{ ::shippingNote.totalPrice | currency:\"€\":2 }}</div> </div> </div> <div class=\"table-c table-c-detail\" id=\"od-{{ ::shippingNote.shippingNoteNumber }}\"> <div class=\"box box-border\"> <div class=delivery-statuses> <div class=delivery-status ng-class=\"{'is-active': shippingNote.stateCode === 'DELIVREG'}\"> <i class=\"ico ico-registered\"></i> <span class=lbl>{{vm.getDeliveryStatusText('DELIVREG')}}</span> </div> <div class=delivery-status ng-class=\"{'is-active': shippingNote.stateCode === 'DELIVBUSY'}\"> <i class=\"ico ico-picking\"></i> <span class=lbl>{{vm.getDeliveryStatusText('DELIVBUSY')}}</span> </div> <div class=delivery-status ng-class=\"{'is-active': (shippingNote.stateCode === 'DELIVREADY' || shippingNote.stateCode === 'DELIVINV')}\"> <i class=\"ico ico-success\"></i> <span class=lbl>{{vm.getDeliveryStatusText(shippingNote.stateCode)}}</span> </div> </div> <order-detail-delivery-products ng-if=::shippingNote.detail.products products=shippingNote.detail.products></order-detail-delivery-products> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box delivery-history\"> <table class=\"table table-block table-compact table-adapt\"> <thead class=\"table-hd hidden-sm-down\"> <tr> <th translate>Date</th> <th translate>Time</th> <th translate>Status</th> </tr> </thead> <tbody> <tr ng-repeat=\"i in ::vm.history\"> <td>{{ ::i.date }}</td> <td>{{ ::i.time }}</td> <td>{{ ::i.text }}</td> </tr> </tbody> </table> </div>";

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <div class=box-hd fb-folder> <h5 translate>Products</h5> </div> <div class=box-bd> <table class=\"table table-block table-compact table-adapt table-delivery-products\"> <thead class=\"table-hd hidden-sm-down\"> <tr> <th class=table-c-prod-cnk translate>Product number</th> <th class=table-c-prod-name translate>Name</th> <th class=table-c-prod-quantity translate>Quantity</th> <th class=table-c-prod-discount translate>Discount</th> <th class=table-c-prod-amount translate>Amount</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in ::vm.products\"> <td class=table-c-prod-cnk> {{ ::product.productNumber }} </td> <td class=table-c-prod-name> {{ ::product.name }} </td> <td class=table-c-prod-quantity> {{ ::product.amount }} </td> <td class=table-c-prod-discount> <span class=text-info>{{ ::product.totalProductDiscount | currency:\"€\":2}}</span> </td> <td class=table-c-prod-amount> {{ ::product.totalProductPrice | currency:\"€\":2 }} </td> </tr> </tbody> </table> </div> </div>";

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2 box-2-primary\"> <div class=box-hd fb-folder> <h3 translate>Your info</h3> </div> <div class=box-bd> <div class=r> <div class=\"c w-md-1-2\"> <ul class=\"list list-values\"> <li> <div class=lbl translate>Customer number</div> <div class=val>{{ ::vm.order.customerNumber }}</div> </li> <li> <div class=lbl translate>APB-number</div> <div class=val>{{ ::vm.order.APBNr }}</div> </li> <li ng-if=::vm.order.deliveryAddress> <div class=lbl translate>Delivery address</div> <div class=val><address address=::vm.order.deliveryAddress></address></div> </li> <li ng-if=::vm.order.invoiceAddress> <div class=lbl translate>Billing address</div> <div class=val><address address=::vm.order.invoiceAddress></address></div> </li> </ul> </div> </div> </div> </div>";

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <form name=vm.forms.requestOrderDate> <div class=r> <div class=\"c w-md-1-2 w-xl-1-3\"> <div class=r> <div class=\"c w-1-2\"><translate>Profficina ref.</translate>:</div> <div class=\"c w-1-2\">{{ ::vm.order.referenceNumber }}</div> </div> <div class=r> <div class=\"c w-1-2\"><translate>TO-nr.</translate>:</div> <div class=\"c w-1-2\"><span ng-if=::vm.order.orderNumber>{{ ::vm.order.orderNumber }}</span><span ng-if=::!vm.order.orderNumber>-</span></div> </div> <div class=r> <div class=\"c w-1-2\"><translate>Date</translate>:</div> <div class=\"c w-1-2\">{{ ::vm.order.date | date: 'dd/MM/yyyy HH:mm' }}</div> </div> </div> <div class=\"c w-md-1-2 w-xl-1-3\"> <div class=r> <div class=\"c w-1-2\"><translate>Vendor</translate>:</div> <div class=\"c w-1-2\">{{ ::vm.order.sellerName }}</div> </div> <div class=r> <div class=\"c w-1-2\"><translate>Status</translate>:</div> <div class=\"c w-1-2\" ng-class=\"{ 'text-success': vm.order.hasSuccess, 'text-error': vm.order.hasError }\"> <i class=ico ng-class=\"{ 'ico-alert-success': vm.order.hasSuccess, 'ico-alert-error': vm.order.hasError }\"></i> {{ ::vm.order.orderStatusText }} </div> </div> <div class=r ng-if=vm.order.deliveryDate> <div class=\"c w-1-2\"><translate>Delivery Date</translate>:</div> <div class=\"c w-1-2\">{{ vm.order.deliveryDate | date: 'dd/MM/yyyy' }}</div> </div> <div class=r ng-if=::vm.order.wholesalerName> <div class=\"c w-1-2\"><translate>Wholesaler</translate></div> <div class=\"c w-1-2\">{{::vm.order.wholesalerName}}</div> </div> </div> <div class=\"c w-md-1-2 w-xl-1-3\"> <div class=r ng-if=vm.order.actualDeliveryDate> <div class=\"c w-1-2\"><translate>Estimated Delivery Date</translate>:</div> <div class=\"c w-1-2\">{{ ::vm.order.actualDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}</div> </div> <div class=r ng-if=vm.order.deliveryRouteNumber> <div class=\"c w-1-2\"><translate>Route number</translate>:</div> <div class=\"c w-1-2\">{{ ::vm.order.deliveryRouteNumber | date: 'dd/MM/yyyy HH:mm' }}</div> </div> </div> <div class=\"c w-md-1-2 w-xl-1-3\"> <br class=hidden-xl-up /> <div class=\"box box-bg\" style=\"margin:-.5rem 0 1rem;padding-top:.75rem\" ng-if=vm.showRequestOrderDate()> <h6 class=form-lbl translate>Deliver earlier</h6> <div class=form-inline ng-if=!vm.updatingOrderDate> <div class=\"form-group form-group-inline-stretch\"> <div class=form-control><fb-date-picker value=vm.newOrderDate max-date=vm.maxDate min-date=vm.minDate></fb-date-picker></div> </div> <div class=\"form-group align-bottom\"> <button ng-disabled=vm.buttonDisabled() type=button ng-click=vm.onSetOrderDelivery(vm.newOrderDate) class=\"btn btn-primary\" translate>Modify</button> </div> </div> <p class=loading-message ng-if=vm.updatingOrderDate> <span class=loading></span> <span class=lbl translate>Processing...</span> </p> <div class=\"text-error type-small\" ng-if=!vm.updatingOrderDate> <div ng-if=vm.forms.requestOrderDate.$error.minDate translate>New order date must be later than today</div> <div ng-if=vm.forms.requestOrderDate.$error.maxDate translate>New order date must be before current order date</div> <div ng-repeat=\"error in vm.updateOrderDeliverDateErrors\" ng-if=vm.updateOrderDeliverDateErrors.length>{{error.message}}</div> </div> </div> </div> </div> </form> <p ng-if=\"vm.order.orderStatusCode !== 'ERROR'\" style=padding-top:20px> <a href={{vm.getDownloadUrl(vm.order)}} target=_blank class=\"btn btn-outline\"><b class=lbl translate>Download PDF</b></a> &nbsp; <a ng-if=!vm.isAddingToCart ng-click=vm.orderProductsAgain() target=_blank class=\"btn btn-outline\"><b class=lbl translate>Reorder</b></a> </p> <div ng-if=vm.isAddingToCart> <div class=loading></div> <span class=lbl translate>Just a moment please, your order is being added to your shopping cart...</span> </div> <div ng-if=::vm.order.note> <div><translate>Note</translate>:</div> <div>{{ ::vm.order.note }}</div> </div> </div>";

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2 box-2-primary\"> <div class=box-hd fb-folder init-open=md-up> <h3 translate>Ordered products</h3> </div> <div class=box-bd> <div class=table-responsive> <table class=\"table table-block\"> <thead> <tr> <th translate>Product number</th> <th translate>Name</th> <th class=align-right translate>Price</th> <th class=align-right translate>Quantity</th> <th translate>Discount</th> <th translate>Status</th> <th class=align-right translate>Subtotal</th> </tr> </thead> <tbody ng-class=\"{'table-disabled': product.isDisabled}\" ng-repeat=\"productGroup in ::vm.order.groupedProducts\"> <tr ng-repeat=\"product in productGroup\" ng-class=\"{'table-parent': $index === 0, 'table-child': $index != 0}\"> <td> <span ng-if=\"::product.productNumber === null && $index === 0\" translate>Promopack</span> <span ng-if=\"::product.productNumber && $index === 0\">{{::product.productNumber}}</span> </td> <td> <span ng-if=\"$index === 0\">{{::product.name}}</span> </td> <td class=align-right> <span ng-if=\"$index === 0\">{{ vm.getDiscountPrice(product.unitPrice, product.discountPercentage) | currency:'€':4 }}</span> </td> <td class=align-right ng-class=\"{ 'text-cancelled': product.reasonCode === 'CANCELLED'}\"> {{product.quantity}} </td> <td> <span class=text-info ng-if=\"::product.discountPercentage > 0\">{{ ::product.discountPercentage }}%</span> <span class=text-info ng-if=::product.promoCode> &ndash; {{ ::product.promoCode }}</span> </td> <td> <i ng-if=product.hasError class=\"ico ico-alert-error text-error\"></i> <i ng-if=product.hasSuccess class=\"ico ico-alert-success text-success\"></i> <i ng-if=\"!product.hasSuccess && !product.hasError\" class=\"ico ico-alert-warning text-info\"></i> <span ng-if=!product.status> - </span> <span class=type-small ng-if=!product.reason>{{product.status}}</span> <span class=type-small ng-if=product.reason>{{product.reason}}</span> </td> <td class=align-right> {{product.totalPriceWithDiscount | currency:\"€\":2 }} </td> </tr> </tbody> </table> </div> </div> <totals totals=::vm.order.totals></totals> </div>";

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = "<div class=toolbar-search> <div class=form-inline> <div class=form-group> <div class=\"form-lbl type-h5\" translate>Search</div> </div> <div class=form-group> <input class=input type=search ng-model-options=\"{  debounce: 1000 }\" ng-model=vm.searchValue placeholder=\"{{ 'Profficina ref. or TO-nr.' | translate }}\"/> </div> <div class=form-group> <select class=select ng-options=\"seller.name for seller in vm.sellers\" ng-model=vm.selectedSeller ng-change=vm.changeSeller(vm.selectedSeller)> </select> </div> <div class=form-group> <a href=# class=\"btn btn-outline hidden-md-up\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i><b translate>Search</b></a> <a href=# class=\"btn btn-outline btn-tile hidden-sm-down\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i></a> </div> </div> </div>";

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <contract-detail-info contract=vm.contract></contract-detail-info>";

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-xl-3-4\"> <contracts-overview-info contracts=vm.contracts></contracts-overview-info> </div> </div>";

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>_myDocuments.myDocuments</h1> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>_myDocuments._reportPurchaseProposals.title</h3> </div> <div class=box-bd> <p translate> _myDocuments._reportPurchaseProposals.description </p> <p> <a href={{vm.getUrlReportPurchaseProposals()}} class=\"btn btn-outline p-x-3\" target=_blank><i class=\"ico ico-file-pdf\"></i><b class=lbl translate>_myDocuments.downloadDocument</b></a> </p> </div> </div> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>_myDocuments._reportNarcotics.title</h3> </div> <div class=box-bd> <p translate>_myDocuments._reportNarcotics.description</p> <p> <a href={{vm.getUrlReportNarcotics()}} class=\"btn btn-outline p-x-3\" target=_blank><i class=\"ico ico-file-pdf\"></i><b class=lbl translate>_myDocuments.downloadDocument</b></a> </p> </div> </div> </div> </div>";

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.submitStep1Form()> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3>Naar welke apotheek wilt u een pakket verzenden?</h3> </div> <div class=box-bd> <div class=\"alert alert-error m-b-2\" ng-if=vm.errorNotFound> <div>Geen apotheek gevonden met deze gegevens.</div> </div> <div class=m-b-2> <p class=type-small>Geef vergunningsnummer en Febelco klantnummer in van bestemming, op basis daarvan wordt het adres opgezocht.</p> <div class=r> <div class=\"c w-md-1-2\"> <div class=form-group> <label for=licenseNumber class=type-bold>Vergunningsnummer</label> <input ng-model=vm.licenseNumber id=licenseNumber type=text class=input placeholder=\"\"/> </div> <div class=form-group> <label for=customerNumber class=type-bold>Febelco klantnummer</label> <input ng-model=vm.customerNumber id=customerNumber type=text class=input placeholder=\"\"/> </div> </div> </div> <div ng-if=vm.error> <div><span class=invalid-feedback>{{ vm.error }}</span></div> </div> </div> <ul class=btn-holder> <li class=btn-holder-left> <button type=submit class=\"btn btn-primary\"> <b>Volgende</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.onCancel() class=\"btn btn-outline\"> <b translate>Cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <div class=\"box-hd clearfix\"> <div class=left> <h3>Verzenden naar</h3> </div> <div class=right> <a href=# ng-click=vm.onEditStep1() class=\"btn btn-outline btn-tile pod-btn-edit\"><i class=\"ico ico-edit\"></i></a> </div> </div> <div class=box-bd> <div class=pod-icon-item> <div class=pod-icon> <i class=\"ico ico-location-2 text-success ico-large\"></i> </div> <div class=pod-item> <order-receiver-detail receiver=::vm.receiver></order-receiver-detail> </div> </div> </div> </div>";

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.submitStep2Form()> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3>Wat wil u verzenden?</h3> </div> <div class=box-bd> <div class=\"alert alert-error m-b-2\" ng-if=vm.showError> <div>Foutmelding... </div> </div> <div class=m-b-4> <div ng-repeat=\"orderline in vm.orderlines\"> <div class=\"pod-orderline-form-row border-bottom border-2x p-y-1 m-b-1\"> <div class=pod-orderline-icon> <i class=\"ico ico-box ico-large text-success\"></i> </div> <div class=pod-orderline-controls> <div class=form-group> <div ng-repeat=\"packageType in vm.packageTypes\"> <div class=radio> <input id=\"packageType{{$parent.$index}}_{{$index}}\" name=\"packageType{{$parent.$index}}\" type=radio ng-model=orderline.packageType value=\"{{packageType.code}}\"/> <label for=\"packageType{{$parent.$index}}_{{$index}}\"> <div>{{packageType.name}}</div> <div class=\"text-muted type-xsmall\">{{packageType.description}}</div> </label> </div> </div> </div> <div class=form-group> <div class=checkbox> <input id=\"signatureRequired{{$index}}\" type=checkbox ng-model=orderline.signatureRequired /> <label for=\"signatureRequired{{$index}}\"> <div>Aftekenen bij ontvangst</div> <div class=\"text-muted type-xsmall\">Lorem ipsum dolor sit amet...</div> </label> </div> </div> </div> <div class=pod-orderline-delete> <button type=button ng-click=vm.deleteOrderline($index) ng-if=\"vm.orderlines.length > 1\" ng-disabled=\"vm.orderlines.length < 2\" class=\"btn btn-outline btn-tile\"><i class=\"ico ico-delete text-danger\"></i></button> </div> </div> </div> <p class=align-right> <button type=button ng-click=vm.addOrderline() class=\"btn btn-outline\"><i class=\"ico ico-plus-circle m-r-1\"></i>Nog een pakket toevoegen</button> </p> </div> <div class=m-b-4> <div class=form-group> <label for=remark> <div class=type-h4>Opmerking / Bericht voor koerier</div> <div class=\"text-muted type-xsmall\">Lorem ipsum dolor sit amet.</div> </label> </div> <textarea id=remark class=input rows=3 maxlength=1000 ng-model=vm.remark>\r\n                </textarea> </div> <ul class=btn-holder> <li class=btn-holder-left> <button type=submit ng-click=vm.createOrder() class=\"btn btn-primary\"> <b>Volgende</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.cancel() class=\"btn btn-outline\"> <b translate>Cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <div class=\"box-hd clearfix\"> <div class=left> <h3>Pakketjes</h3> </div> <div class=right> <a href=# ng-click=vm.onEditStep2() class=\"btn btn-outline btn-tile pod-btn-edit\"><i class=\"ico ico-edit\"></i></a> </div> </div> <div class=box-bd> <div class=m-b-4> <div ng-repeat=\"orderline in vm.delivery.orderlines\"> <div class=\"pod-icon-item border-bottom border-2x p-b-1 m-b-1\"> <div class=pod-icon> <i class=\"ico ico-box ico-large text-success\"></i> </div> <div class=pod-item> <div class=r> <div class=\"c w-md-1-2\"> <div>{{orderline.packageType.name}}</div> <div class=\"text-muted type-xsmall\">{{orderline.packageType.description}}</div> </div> <div class=\"c w-md-1-2\" ng-if=orderline.signatureRequired> <div>Aftekenen bij ontvangst</div> <div class=\"text-muted type-xsmall\">Lorem ipsum dolor sit amet...</div> </div> </div> </div> </div> </div> </div> <div class=m-b-4> <div class=type-h4>Opmerking / Bericht voor koerier</div> <div class=\"text-muted type-xsmall\">Lorem ipsum dolor sit amet.</div> <div class=m-t-1>{{ ::vm.delivery.remark ? vm.delivery.remark : '/' }}</div> </div> </div> </div>";

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.submitStep3Form()> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3>Verzending bevestigen</h3> </div> <div class=box-bd> <div> <p>Controleer de gegevens en duid aan dat u akkoord gaat met <a href=# class=link>de voorwaarden</a>.</p> <p class=type-small>Febelco is niet verantwoordelijk voor de inhoud van de pakjes. Voorwaarden in het kort...</p> <div class=\"custom-control custom-checkbox pod-custom-checkbox m-t-3\"> <input id=agreeWithTerms type=checkbox class=custom-control-input ng-change=vm.onOrderedChanged() ng-model=vm.agreeWithTerms> <label class=custom-control-label for=agreeWithTerms> <div class=type-btn>Ik ga akkoord met de voorwaarden.</div> <div ng-if=vm.showError class=invalid-feedback>Gelieve akkoord te gaan met de voorwaarden.</div> </label> </div> </div> <ul class=\"btn-holder m-t-4\"> <li class=btn-holder-left> <button type=submit ng-click=vm.onSubmitStep3Form() class=\"btn btn-primary\"> <b>Verzending aanmaken</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.onCancel() class=\"btn btn-outline\"> <b translate>Cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3>Hoe werkt het? ..TBD</h3> </div> <div class=box-bd> <ul class=\"list list-dash\"> <li>Maak hier een verzendlabel aan</li> <li>Geef uw pakket met label aan de Febelco koerier</li> <li>Volg via Track & Trace</li> <li>Binnen 48u geleverd op bestemming</li> </ul> </div> </div>";

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div class=\"box box-2\"> <div class=box-hd fb-folder> <h3>Details verzending</h3> </div> <div class=box-bd> <div class=m-b-1> <span class=type-h4>Verzending ID</span> <span class=type-small-uppercase>{{ ::vm.order.number }}</span> </div> <div class=r> <div class=\"c w-md-1-2\"> <div> <div class=type-h4>Verstuurd naar</div> <order-receiver-detail receiver=::vm.order.receiver></order-receiver-detail> </div> </div> <div class=\"c w-md-1-2\"> <div ng-if=vm.order.remark> <div class=type-h4>Opmerking / Bericht voor koerier</div> <p>{{ ::vm.order.remark }}</p> </div> </div> </div> </div> </div> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=sm-up> <h3>{{::vm.order.quantity }} <span ng-if=\"vm.order.quantity === 1\">pakje</span><span ng-if=\"vm.order.quantity !== 1\">pakjes</span></h3> </div> <div class=box-bd> <div ng-repeat=\"line in ::vm.order.lines\"> <order-line-detail line=line show-line-state=!vm.confirmation></order-line-detail> </div> </div> </div> </div> </div>";

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = "<div class=\"border-bottom border-2x p-b-1 m-b-2\"> <div class=r> <div class=\"c w-2-3\"> <div class=m-b-1> <div>{{ ::vm.line.packageType.name }}</div> <div class=\"type-xsmall text-muted\">{{ ::vm.line.packageType.description }}</div> <div class=\"\" ng-if=::vm.line.signatureRequired>Aftekenen bij ontvangst</div> </div> <div ng-if=vm.showLineState> <div class=m-b-1> <order-line-state state=::vm.line.state></order-line-state> <div class=type-xsmall> {{ ::vm.line.date | date:'d MMMM yyyy' }} <span class=text-muted>{{ ::vm.line.date | date:'hh:mm' }}</span> </div> </div> <div class=m-b-1> <div class=type-btn fb-folder>Track & Trace activiteit in detail</div> <div> <order-line-state-history line-id=::vm.line.id></order-line-state-history> </div> </div> </div> </div> <div class=\"c w-1-3 align-right\"> <div class=\"m-b-1 type-xsmall-uppercase\">Barcode {{ ::vm.line.barcode }}</div> <div class=m-y-1><a class=btn ng-class=\"{'btn-outline': vm.showLineState, 'btn-primary': !vm.showLineState}\" href=# target=_blank type=button>Print verzendlabel</a></div> </div> </div> </div>";

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = "<ul class=list-state-history> <li class=list-item ng-repeat=\"history in vm.stateHistory\"> <div>{{ history.state.name }}</div> <div class=type-xsmall> {{ history.changedOn | date:'d MMMM yyyy' }} <span class=text-muted>{{ history.changedOn | date:'hh:mm' }}</span> </div> </li> </ul>";

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=::vm.stateContext> <i class=\"ico ico-w-1\" ng-class=::vm.stateIcon></i> <span class=type-small>{{ ::vm.state.name }}</span> </div>";

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = "<div>{{ ::vm.receiver.name }}</div> <div>{{ ::vm.receiver.streetName }} {{ ::vm.receiver.houseNumber }} {{ ::vm.receiver.boxNumber }}</div> <div>{{ ::vm.receiver.postalCode }} {{ ::vm.receiver.cityName }}</div> <div class=type-xsmall>Vergunningsnr. {{ ::vm.receiver.licenseNumber }}, klantnr. {{ ::vm.receiver.customerNumber }}</div>";

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = "<div class=p-y-2> <div class=r> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase><span>Verzending ID</span> {{ ::vm.order.number }}</div> {{ ::vm.order.createdOn | date:'d MMMM yyyy' }} </div> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase>Verstuurd naar</div> <order-receiver-detail receiver=::vm.order.receiver></order-receiver-detail> </div> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase> <span>{{ ::vm.order.lines.length }}</span> <span ng-if=\"vm.order.lines.length !== 1\">pakjes</span> <span ng-if=\"vm.order.lines.length === 1\">pakje</span> </div> <div ng-repeat=\"line in vm.order.lines\" class=p-y-quart> <order-line-state state=line.state></order-line-state> <div class=type-xsmall>{{ line.barcode }}</div> </div> <div><a ui-sref=\"package-detail({ id: {{::vm.order.id}} })\" class=\"link type-btn\">Detail verzending</a></div> </div> </div> </div>";

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=::vm.stateContext> <i class=ico ng-class=::vm.stateIcon></i> {{ ::vm.state.name }} </div>";

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div>Uw verzending is geregistreerd</div> </h1> <div class=\"box box-border box-border-primary\"> <div class=box-body> <h5 class=m-b-0>Print de verzendlabels en geef de pakjes mee met uw Febelco chauffeur.</h5> <p> Een woordje uitleg wat men nu moet doen ... Text TBD </p> </div> </div> </div> </div> <order-detail-content order=vm.order confirmation=true></order-detail-content>";

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>Verzending aanmaken</h1> <p class=type-lead>Pakket versturen naar een apotheek via Febelco? Maak hier een verzendlabel aan.</p> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div ng-if=\"vm.currentStep === 1\"> <add-step1-select-receiver-form receiver=::vm.receiver select-receiver=vm.selectReceiver($event) cancel=vm.cancel()></add-step1-select-receiver-form> </div> <div ng-if=\"vm.currentStep > 1\"> <add-step1-select-receiver-read receiver=::vm.receiver edit-receiver=vm.editReceiver($event)></add-step1-select-receiver-read> </div> <div ng-if=\"vm.currentStep === 2\"> <add-step2-details-form receiver=::vm.receiver delivery=::vm.delivery submit-step2=vm.submitStep2($event) cancel=vm.cancel()></add-step2-details-form> </div> <div ng-if=\"vm.currentStep > 2\"> <add-step2-details-read edit-step2=vm.editStep2($event) delivery=::vm.delivery></add-step2-details-read> </div> <div ng-if=\"vm.currentStep === 3\"> <add-step3-confirm-form submit-step3=vm.submitStep3($event) cancel=vm.cancel()></add-step3-confirm-form> </div> </div> <div class=\"c w-lg-1-3 w-xl-1-4 w-xx-4-12 offset-xx-1-12\"> <how-does-it-work-box></how-does-it-work-box> </div> </div>";

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>Al mijn verzendingen</h1> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div ng-if=\"vm.model !== null\"> <div class=\"box search-box\"> <div class=box-hd fb-folder> <h4>Zoeken</h4> </div> <div class=box-bd> <div class=r> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl>Verzending ID</div> <div class=search-control> <input ng-model=vm.model.search.orderNumber class=input type=text placeholder=\"Naam, apb-nr, klantnr.\"> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl>Verstuurd naar</div> <div class=search-control> <input ng-model=vm.model.search.receiver class=input type=text placeholder=\"Naam, apb-nr, klantnr.\"> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl>Aangemaakt op</div> <div class=search-control> <div class=search-filter-period> <div class=search-filter-period-control> <input ng-model=vm.model.search.createdOnFrom class=input type=text placeholder=\"{{'DD-MM-YYYY' | translate}}\"> </div> <div class=search-filter-period-lbl>tot</div> <div class=search-filter-period-control> <input ng-model=vm.model.search.createdOnUntil class=input type=text placeholder=\"{{'DD-MM-YYYY' | translate}}\"> </div> </div> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl>Barcode pakket</div> <div class=search-control> <input ng-model=vm.model.search.barcode class=input type=text placeholder=Barcode> </div> </div> </div> </div> <div class=search-btns> <button class=\"btn btn-primary m-r-1\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b translate>Search</b> </button> <button class=\"btn btn-outline\" ng-click=vm.clear()> <i class=\"ico ico-remove\"></i><b translate>Reset</b> </button> </div> </div> </div> <div class=\"toolbar toolbar-top\"> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.paging.totalItems}}</strong> <translate translate-n=vm.model.paging.totalItems translate-plural=verzendingen>verzending</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pagecountList\" ng-model=vm.model.paging.itemsPerPage ng-change=\"vm.changeItemsPerPage({itemsPerPage: vm.model.paging.itemsPerPage})\"></select> <label translate>per page</label> </div> <pager paging=vm.model.paging go-to-page=vm.goToPage(page)></pager> </div> </div> </div> <div ng-if=\"vm.model === null\" class=loading></div> <div ng-if=\"vm.model.paging.totalItems === 0\"><p class=m-t-1>Geen verzendingen gevonden voor ingegeven zoekcriteria.</p></div> <div class=\"border-bottom border-2x\" ng-repeat=\"order in vm.orders\"> <order-search-result-item order=order></order-search-result-item> </div> <div ng-if=\"vm.model !== null && vm.model.paging.totalItems !== 0\" class=\"toolbar toolbar-bottom\" style=margin-top:-2px> <div> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.paging.totalItems}}</strong> <translate translate-n=vm.model.paging.totalItems translate-plural=verzendingen>verzending</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pagecountList\" ng-model=vm.model.paging.itemsPerPage ng-change=\"vm.changeItemsPerPage({itemsPerPage: vm.model.paging.itemsPerPage})\"></select> <label translate>per page</label> </div> <pager paging=vm.model.paging go-to-page=vm.goToPage(page)></pager> </div> </div> </div> </div>";

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div><span>Verzending</span> {{ ::vm.order.number }}</div> <div class=\"type-base m-y-1\"> <div>Aangemaakt op <strong>{{ ::vm.order.createdOn | date:'d MMMM yyyy'}}</strong></div> <div>Naar <strong>{{ ::vm.order.receiver.name }}</strong></div> </div> </h1> </div> </div> <order-detail-content order=vm.order confirmation=false></order-detail-content>";

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>Mijn verzendingen</h1> <p class=m-b-2><a class=\"btn btn-primary-outline\" ui-sref=add-package><span>Verzending aanmaken</span></a></p> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div class=\"box box-2\" ng-if=vm.recentOrders.length> <div class=box-hd> <h2 class=left>Laatste verzendingen van afgelopen 6 maand</h2> <a class=\"right btn btn-outline\" ui-sref=package-archive><span>Al mijn verzendingen</span></a> </div> <div class=box-bd> <div class=\"border-bottom border-2x m-b-1\" ng-repeat=\"order in vm.recentOrders\"> <order-search-result-item order=order></order-search-result-item> </div> <div class=align-right> <a class=\"btn btn-outline\" ui-sref=package-archive><span>Al mijn verzendingen</span></a> </div> </div> </div> <div class=\"box box-2\" ng-if=vm.recentOrders.length> <div class=box-hd> <h2 class=left>U heeft recent geen verzendingen geregistreerd</h2> <a class=\"right btn btn-outline\" ui-sref=package-archive><span>Al mijn verzendingen</span></a> </div> <div class=box-bd> <p>Zoek in al uw verzendingen of maak een nieuwe verzending aan.</p> <p>Een woordje uitleg over wat men kan verzenden en hoe het werkt.</p> <ul class=\"btn-holder m-t-2\"> <li class=btn-holder-left> <a class=\"btn btn-primary-outline\" ui-sref=add-package>Verzending aanmaken</a> </li> <li class=btn-holder-right> <a class=\"btn btn-outline\" ui-sref=add-package>Al mijn verzendingen</a> </li> </ul> </div> </div> </div> <div class=\"c w-lg-1-3 w-xl-1-4 w-xx-4-12 offset-xx-1-12\"> <div class=\"box box-border box-border-primary\"> <p>Pakje versturen naar een apotheek of naar HC Pharma? Maak hier uw verzendlabel aan.</p> <p class=align-center> <a class=\"btn btn-primary-outline\" ui-sref=add-package><span>Verzending aanmaken</span></a> </p> </div> <how-does-it-work-box></how-does-it-work-box> </div> </div>";

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=\"box box-1\"> <p translate> Dear Pharmacist, </p> <p translate> From 23/01/2023 <strong>you</strong> and anyone who gives you rights, <strong>can manage the reservations yourself</strong> via <a class=link target=_blank href={{vm.myFebelcoLink}}>MyFebelco</a>, our new customer portal: changing, removing or adding can then be done in a few mouse clicks. </p> <p translate> Via <a class=link target=_blank href={{vm.myFebelcoLink}}>MyFebelco</a> you also get direct access to all kinds of information, personal data and useful tools. Calling customer service is no longer necessary, so they have more time to help our customers on the line faster. </p> <p translate> Due to this progress, the <strong>reservation overview</strong> will no longer be available on Profficina and your secure area (my Febelco) <strong>from 16/01</strong>. </p> <p translate> <strong>Questions?</strong><br/>Before you can go to MyFebelco, you must activate your account on the basis of a registration email. </p> <p translate> Didn't receive a registration email? Then contact <a href=mailto:support@myfebelco.be class=link>support@myfebelco.be</a>. </p> </div>";

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1><translate>Order - noun</translate> {{ ::vm.order.referenceNumber }}</h1> <order-detail-header set-order-delivery-date=vm.setOrderDeliveryDate($event) update-order-deliver-date-errors=vm.updateOrderDeliverDateErrors updating-order-date=vm.updatingOrderDate order=vm.order></order-detail-header> <order-detail-products order=::vm.order></order-detail-products> <order-detail-deliveries order=::vm.order></order-detail-deliveries> <order-detail-extra-info order=::vm.order></order-detail-extra-info> <p><a ui-sref=order-overview class=\"btn btn-outline\"><i class=\"ico ico-angle-left\"></i><b class=lbl translate>Back to overview</b></a></p>";

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>My orders</h1> <div class=box> <div ng-if=\"!vm.isLoading && !vm.isAddingToCart\" class=\"toolbar toolbar-top toolbar-search-pager toolbar-search-order\"> <div class=r> <div class=c> <order-overview-search search-value=vm.searchValue search=vm.search($event) sellers=vm.sellers></order-overview-search> </div> <div class=c> <div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> </div> </div> <div ng-if=vm.isLoading class=\"p-t-2 p-b-2\"> <div class=loading></div> </div> <div ng-if=vm.isAddingToCart class=\"p-t-2 p-b-2\"> <div class=loading></div> <span class=lbl translate>Just a moment please, your order is being added to your shopping cart...</span> </div> <div ng-if=\"!vm.isLoading && vm.orders.length && !vm.isAddingToCart\" class=\"table table-fake table-order-overview m-b-0\"> <div class=table-hd> <div class=table-r> <div class=\"table-c table-c-date\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'OrderDate', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('OrderDate')\"> <b translate>Date</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-seller\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'SellerName', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('SellerName')\"> <b translate>Seller</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-reference\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'ReferenceNumber', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('ReferenceNumber')\"> <b translate>Profficina ref.</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-to-reference\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'OrderNumber', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('OrderNumber')\"> <b translate>TO-nr.</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-status\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'StateName', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('StateName')\"> <b translate>Status</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-amount\"> <a href=# class=sort ng-class=\"{'active': vm.sortProperty == 'TotalPriceWithDiscount', 'sort-asc': vm.sortAsc, 'sort-desc': !vm.sortAsc}\" ng-click=\"vm.changeSorting('TotalPriceWithDiscount')\"> <b translate>Amount</b><i class=ico></i> </a> </div> <div class=\"table-c table-c-pdf hidden-md\"> </div> <div class=\"table-c table-c-reorder hidden-md\"> </div> </div> </div> <div class=table-bd> <div class=table-r ng-repeat=\"order in vm.orders\"> <div class=\"table-c table-c-date\"> {{ ::order.date | date:'dd/MM/yyyy' }} </div> <div class=\"table-c table-c-seller\"> {{ ::order.seller }} </div> <div class=\"table-c table-c-reference\"> <div class=table-lbl translate>Profficina ref.</div> <div class=table-val><a ui-sref=\"order({ id: order.id })\" class=\"link link-primary\"><b>{{ ::order.referenceNumber }}</b></a></div> </div> <div class=\"table-c table-c-to-reference\"> <div class=table-lbl translate>TO-nr.</div> <div class=table-val><span ng-if=::order.orderNumber>{{ ::order.orderNumber }}</span><span ng-if=::!order.orderNumber>-</span></div> </div> <div class=\"table-c table-c-status\" ng-class=\"{ 'text-success': order.hasSuccess, 'text-error': order.hasError }\"> <i class=ico ng-class=\"{ 'ico-alert-success': order.hasSuccess, 'ico-alert-error': order.hasError }\"></i> {{ ::order.orderStatusText }} </div> <div class=\"table-c table-c-amount hidden-sm-down\"> {{ ::order.amount | currency:\"€\":2 }} </div> <div class=\"table-c table-c-pdf hidden-sm-down align-right\"> <a href={{vm.getDownloadUrl(order)}} ng-if=\"::order.orderStatusCode !== 'ERROR'\" target=_blank class=\"btn btn-outline\"><b class=lbl translate>PDF</b></a> </div> <div class=\"table-c table-c-reorder hidden-sm-down align-right\"> <a ng-click=vm.reOrderProducts(order) target=_blank class=\"btn btn-outline\" title=\"{{ 'Reorder' | translate }}\"><b class=lbl translate>Reorder</b></a> </div> </div> </div> </div> <div ng-if=!vm.isLoading class=\"toolbar toolbar-bottom toolbar-search-pager\"> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> <div ng-if=\"!vm.isLoading && !vm.orders.length\"> <span translate>No orders found</span> </div> </div>";

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.submitStep1Form()> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3 translate>parcel.whichPharmacyToSend</h3> </div> <div class=box-bd> <div class=\"alert alert-error m-b-2\" ng-if=vm.errorNotFound> <div translate>parcel.noPharmacyFound</div> </div> <div class=m-b-2> <p class=type-small translate> parcel.enterLicenseNumberLong </p> <div class=r> <div class=\"c w-md-1-2\"> <div class=form-group> <label for=licenseNumber class=type-bold translate>parcel.licenseNumber</label> <input ng-model=vm.licenseNumber id=licenseNumber type=text class=input placeholder=\"\"/> </div> </div> </div> <div ng-if=vm.error> <div> <span class=invalid-feedback>{{ vm.error }}</span> </div> </div> </div> <ul class=btn-holder> <li class=btn-holder-left> <button type=submit class=\"btn btn-primary\"> <b translate>parcel.next</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.onCancel() class=\"btn btn-outline\"> <b translate>parcel.cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <div class=\"box-hd clearfix\"> <div class=left> <h3 translate>parcel.sendTo</h3> </div> <div class=right ng-if=vm.editable> <a href=# ng-click=vm.onEditStep1() class=\"btn btn-outline btn-tile pod-btn-edit\"><i class=\"ico ico-edit\"></i></a> </div> </div> <div class=box-bd> <div class=pod-icon-item> <div class=pod-icon> <i class=\"ico ico-location-2 text-success ico-large\"></i> </div> <div class=pod-item> <parcel-receiver-detail receiver=::vm.receiver></parcel-receiver-detail> </div> </div> </div> </div>";

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.submitStep2Form() novalidate name=vm.formReference> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3 translate>parcel.whatToSend</h3> </div> <div class=box-bd> <div ng-repeat=\"orderline in vm.orderlines\"> <div class=\"pod-orderline-form-row border-bottom border-2x p-y-1 m-b-1\"> <div class=pod-orderline-icon> <i class=\"ico ico-box ico-large text-success\"></i> </div> <div class=pod-orderline-controls> <div class=form-group> <div ng-repeat=\"packageType in vm.packageTypes\"> <div class=radio> <input id=\"packageType{{$parent.$index}}_{{$index}}\" name=\"packageType{{$parent.$index}}\" type=radio ng-model=orderline.packageTypeCode value=\"{{packageType.code}}\" ng-change=\"vm.onPackageTypeSelection({{$parent.$index}})\"/> <label for=\"packageType{{$parent.$index}}_{{$index}}\"> <div>{{packageType.name}}</div> <div class=\"text-muted type-xsmall\">{{packageType.description}}</div> <div class=\"text-muted type-xsmall\"><span translate>parcel.packagePrice</span>{{packageType.packagePrice | currency:'€':2}}</div> <div class=\"text-muted type-xsmall\"><span translate>parcel.packageDiscount</span>{{packageType.packageDiscount | currency:'€':2}}</div> </label> </div> </div> <div class=invalid-feedback ng-if=orderline.packageTypeError> {{ orderline.packageTypeError }} </div> </div> <div class=form-group ng-if=orderline.insurancePriceDescription> <div class=checkbox> <input id=\"packageHasInsurance{{$index}}\" name=\"packageHasInsurance{{$index}}\" type=checkbox ng-model=orderline.hasInsurance value=\"{{packageType.hasInsurance}}\"/> <label for=\"packageHasInsurance{{$index}}\"> <div translate>parcel.insurance</div> <div class=\"text-muted type-xsmall\">{{orderline.insurancePriceDescription}}</div> </label> </div> <div class=m-l-2 ng-if=orderline.hasInsurance> <label class=form-lbl translate>parcel.packageValue</label> <div class=input-group> <div class=\"input-prepend p-x-1\"> € </div> <input type=number min=0 max=999999999999.9999 type=number step=0.0001 ng-model=orderline.packageValue ng-required=true id=\"packageValue{{$index}}\" name=\"packageValue{{$index}}\" ng-class=\"vm.formReference.packageValue{{$index}}.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\"/> <div ng-messages=\"vm.formReference['packageValue' + $index].$error\" ng-if=\"vm.formReference['packageValue' + $index].$invalid && vm.formReference.$submitted\"> <div ng-message=required> <span class=invalid-feedback translate>parcel.required</span> </div> </div> </div> </div> </div> <div class=pod-orderline-delete> <button type=button ng-click=vm.deleteOrderline($index) ng-if=\"vm.orderlines.length > 1\" ng-disabled=\"vm.orderlines.length < 2\" class=\"btn btn-outline btn-tile\"><i class=\"ico ico-delete text-danger\"></i></button> </div> </div> </div> </div> <p class=align-right> <button type=button ng-click=vm.addOrderline() class=\"btn btn-outline\"> <i class=\"ico ico-plus-circle m-r-1\"></i> <span translate>parcel.addAnotherLine</span> </button> </p> <div class=m-b-4> <div class=form-group> <label for=remark> <div class=type-h4 translate>parcel.remarkForCourier</div> <div class=\"text-muted type-xsmall\" translate>parcel.remarkForCourierDescription</div> </label> </div> <textarea id=remark class=input rows=3 maxlength=255 ng-model=vm.remark>\r\n                </textarea> </div> <ul class=btn-holder> <li class=btn-holder-left> <button type=submit ng-click=vm.createOrder() class=\"btn btn-primary\"> <b translate>parcel.next</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.cancel() class=\"btn btn-outline\"> <b translate>parcel.cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\"> <div class=\"box-hd clearfix\"> <div class=left> <h3 translate>parcel.packages</h3> </div> <div class=right ng-if=vm.editable> <a href=# ng-click=vm.onEditStep2() class=\"btn btn-outline btn-tile pod-btn-edit\"><i class=\"ico ico-edit\"></i></a> </div> </div> <div class=box-bd> <div class=m-b-4> <div ng-repeat=\"orderline in vm.delivery.orderlines\"> <div class=\"pod-icon-item border-bottom border-2x p-b-1 m-b-1\"> <div class=pod-icon> <i class=\"ico ico-box ico-large text-success\"></i> </div> <div class=pod-item> <div class=r> <div class=\"c w-md-1-2\"> <div>{{orderline.packageType.name}}</div> <div class=\"text-muted type-xsmall\">{{orderline.packageType.description}}</div> <div class=\"text-muted type-xsmall\"><span translate>parcel.packagePrice</span>{{orderline.packageType.packagePrice | currency:'€':2}}</div> <div class=\"text-muted type-xsmall\"><span translate>parcel.packageDiscount</span>{{orderline.packageType.packageDiscount | currency:'€':2}}</div> </div> <div class=\"c w-md-1-2\"> <div class=type-xsmall><span translate>parcel.insurance</span>: {{orderline.hasInsurance ? ('Yes' | translate) : ('No' | translate)}}</div> <div class=type-xsmall ng-if=orderline.hasInsurance>{{orderline.insurancePriceDescription}}</div> <div class=type-xsmall ng-if=orderline.hasInsurance><span translate>parcel.packageValue</span>: {{orderline.packageValue | currency:'€':2}}</div> </div> </div> </div> </div> </div> </div> <div class=m-b-4> <div class=type-h4 translate>parcel.remarkForCourier</div> <div class=\"text-muted type-xsmall\" translate>parcel.remarkForCourierDescription</div> <div class=m-t-1>{{ ::vm.delivery.remark ? vm.delivery.remark : '/' }}</div> </div> </div> </div>";

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = "<form ng-submit=vm.onSubmitStep3Form()> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h3 translate>parcel.confirmOrder</h3> </div> <div class=box-bd> <div> <p><span translate>parcel.checkData</span> <a href=# class=link><span translate>parcel.theConditions</span></a>.</p> <p class=type-small translate>parcel.febelcoNotResponsibleForContent</p> <div class=\"custom-control custom-checkbox pod-custom-checkbox m-t-3\"> <input id=agreeWithTerms type=checkbox class=custom-control-input ng-model=vm.agreeWithTerms> <label class=custom-control-label for=agreeWithTerms> <div class=type-btn translate>parcel.iAgreeToTheTerms</div> <div ng-if=vm.showError class=invalid-feedback translate>parcel.pleaseAgreeToTerms</div> </label> </div> </div> <ul class=\"btn-holder m-t-4\"> <li class=btn-holder-left> <button type=submit class=\"btn btn-primary\"> <b translate>parcel.createParcel</b> <i class=\"ico ico-angle-right\"></i> </button> </li> <li class=btn-holder-right> <button type=button ng-click=vm.onCancel() class=\"btn btn-outline\"> <b translate>parcel.cancel</b> </button> </li> </ul> </div> </div> </form>";

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div class=\"box box-2\"> <div class=box-hd fb-folder> <h3 translate>parcel.shippingDetails</h3> </div> <div class=box-bd> <div class=m-b-1> <span class=type-h4 translate>parcel.orderNumber</span> <span class=type-small-uppercase>{{ ::vm.parcel.number }}</span> </div> <div class=r> <div class=\"c w-md-1-2\"> <div> <div class=type-h4 translate>parcel.sentTo</div> <parcel-receiver-detail receiver=::vm.parcel.receiver></parcel-receiver-detail> </div> </div> <div class=\"c w-md-1-2\"> <div ng-if=vm.parcel.remark> <div class=type-h4 translate>parcel.remarkForCourier</div> <p>{{ ::vm.parcel.remark }}</p> </div> </div> </div> </div> </div> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=sm-up> <h3> <span>{{::vm.parcel.quantity }}</span> <translate translate-n=vm.parcel.quantity translate-plural=parcel.packsLower>parcel.packLower</translate> </h3> </div> <div class=box-bd> <div ng-repeat=\"line in vm.parcel.lines\"> <parcel-line-detail line=line show-line-state=!vm.confirmation can-cancel=vm.canCancel cancel=\"vm.onCancel({lineId: line.id})\"></parcel-line-detail> </div> </div> </div> <p class=\"align-right m-b-1\"> <a class=\"btn btn-outline\" ui-sref=parcels><span translate>parcel.backToOverview</span></a> </p> </div> </div>";

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = "";

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = "<div class=\"border-bottom border-2x p-b-1 m-b-2\"> <div class=r> <div class=\"c w-1-3\"> <div class=m-b-1> <div>{{ ::vm.line.packageType.name }}</div> <div class=\"type-xsmall text-muted\"> {{ ::vm.line.packageType.description }} </div> <div class=\"type-xsmall text-muted\"> <span translate>parcel.packagePrice</span> {{ ::vm.line.packageType.packagePrice | currency:'€':2 }} </div> <div class=\"type-xsmall text-muted\"> <span translate>parcel.packageDiscount</span> {{ ::vm.line.packageType.packageDiscount | currency:'€':2 }} </div> <div ng-switch on=::vm.line.isFree> <div class=\"type-xsmall text-muted\" ng-switch-when=false> <span translate>parcel.packageInvoiceAmount</span> {{::vm.line.packageInvoiceAmount | currency:'€':2}} </div> <div class=\"type-xsmall text-muted\" ng-switch-when=true> <span translate>parcel.freePackage</span> </div> </div> <div class=\"type-xsmall text-muted\" ng-if=vm.line.signatureRequired> <span translate>parcel.insuranceInvoiceAmount</span> {{::vm.line.insuranceInvoiceAmount | currency:'€':2}} </div> </div> <div ng-if=vm.showLineState> <div class=m-b-1> <parcel-line-state state=vm.line.state></parcel-line-state> <div class=type-xsmall> {{ ::vm.line.date | date:'d MMMM yyyy' }} <span class=text-muted>{{ ::vm.line.date | date:'HH:mm' }}</span> </div> </div> <div class=m-b-1> <div class=type-btn fb-folder ng-click=vm.loadHistory() translate> parcel.trackAndTraceInDetail </div> <div> <parcel-line-state-history ng-if=!!vm.stateHistory state-history=vm.stateHistory></parcel-line-state-history> </div> </div> </div> </div> <div class=\"c w-1-3\"> <div class=type-xsmall><span translate>parcel.insurance</span>: {{::vm.line.signatureRequired ? ('Yes' | translate) : ('No' | translate)}}</div> <div class=type-xsmall ng-if=vm.line.signatureRequired>{{vm.insuranceDescription}}</div> <div class=type-xsmall ng-if=vm.line.signatureRequired><span translate>parcel.packageValue</span>: {{::vm.line.packageValue | currency:'€':4}}</div> </div> <div class=\"c w-1-3 align-right\"> <div class=\"m-b-1 type-xsmall-uppercase\"> <span translate>parcel.barcode</span> <span>{{ ::vm.line.barcode }}</span> </div> <div class=m-y-1> <a class=btn ng-class=\"{'btn-outline': vm.showLineState, 'btn-primary': !vm.showLineState}\" target=_blank href={{vm.getLabelUrl()}}> <span translate>parcel.printLabel</span> </a> </div> <div class=m-t-1 ng-if=vm.canCancelLine()> <a class=\"link-btn link-btn-error\" ng-click=vm.onCancel()> <span class=\"btn btn-small btn-tile btn-outline\" ng-disabled=vm.canCancel><i class=\"ico ico-delete\"></i></span> <b class=font-weight-normal translate>parcel.cancelParcel</b> </a> </div> </div> </div> </div>";

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = "<ul class=list-state-history> <li class=list-item ng-repeat=\"history in vm.stateHistory\"> <div ng-class=vm.getContext(history.state.code)> {{ history.state.name }} </div> <div class=type-xsmall> {{ history.changedOn | date:'d MMMM yyyy' }} <span class=text-muted>{{ history.changedOn | date:'HH:mm' }}</span> </div> <div class=type-xsmall ng-if=\"history.isSigned !== null\"> <span translate>parcel.isSigned</span> <span class=text-muted>{{ history.isSigned ? ('Yes' | translate) : ('No' | translate) }}</span> </div> </li> </ul>";

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=vm.stateContext> <i class=\"ico ico-w-1\" ng-class=vm.stateIcon></i> <span class=type-small>{{ vm.state.name }}</span> </div>";

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = "<div>{{ ::vm.receiver.name }}</div> <div>{{ ::vm.receiver.addressLine }}</div> <div>{{ ::vm.receiver.postalCode }} {{ ::vm.receiver.cityName }}</div> <div class=type-xsmall> <span translate>parcel.licenseNumberShort</span> {{ ::vm.receiver.licenseNumber }} </div>";

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = "<div class=p-y-2> <div class=r> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase><span translate>parcel.orderNumber</span> {{ ::vm.parcel.number }}</div> {{ ::vm.parcel.createdOn | date:'d MMMM yyyy' }} </div> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase translate>parcel.sentTo</div> <parcel-receiver-detail receiver=::vm.parcel.receiver></parcel-receiver-detail> </div> <div class=\"c w-1-3\"> <div class=type-xsmall-uppercase> <span>{{ ::vm.parcel.lines.length }}</span> <translate translate-n=vm.parcel.lines.length translate-plural=parcel.lines>parcel.line</translate> </div> <div ng-repeat=\"line in vm.parcel.lines\" class=p-y-quart> <parcel-line-state state=line.state></parcel-line-state> <div class=type-xsmall>{{ line.barcode }}</div> </div> <div class=align-right><a ui-sref=\"parcel-detail({ id: vm.parcel.id })\" class=\"btn btn-outline btn-small\" translate>parcel.shippingDetail</a></div> </div> </div> </div>";

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=vm.stateContext> <i class=ico ng-class=vm.stateIcon></i> {{ vm.state.name }} </div>";

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div translate>parcel.yourParcelWasRegistered</div> </h1> <div class=\"box box-border box-border-primary\"> <div class=box-body> <h5 translate>parcel.printAndHandToDriver</h5> </div> </div> </div> </div> <parcel-detail-content parcel=vm.parcel confirmation=true></parcel-detail-content>";

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>parcel.createParcel</h1> <p class=type-lead translate>parcel.createShippingLabelHere</p> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div ng-if=\"vm.currentStep === 1\"> <parcel-add-step1-select-receiver-form receiver=::vm.receiver select-receiver=vm.selectReceiver($event) validate-receiver=vm.validateReceiver($event) cancel=vm.cancel()></parcel-add-step1-select-receiver-form> </div> <div ng-if=\"vm.currentStep > 1\"> <parcel-add-step1-select-receiver-read editable=\"vm.currentStep !== 4\" receiver=::vm.receiver edit-receiver=vm.editReceiver($event)></parcel-add-step1-select-receiver-read> </div> <div ng-if=\"vm.currentStep === 2\"> <parcel-add-step2-details-form receiver=::vm.receiver delivery=::vm.delivery submit-step2=vm.submitStep2($event) cancel=vm.cancel()></parcel-add-step2-details-form> </div> <div ng-if=\"vm.currentStep > 2\"> <parcel-add-step2-details-read editable=\"vm.currentStep !== 4\" edit-step2=vm.editStep2($event) delivery=::vm.delivery></parcel-add-step2-details-read> </div> <div ng-if=\"vm.currentStep === 3\"> <parcel-add-step3-confirm-form submit-step3=vm.submitStep3($event) cancel=vm.cancel()></parcel-add-step3-confirm-form> </div> <div ng-if=\"vm.currentStep === 4\"> <div class=loading></div> </div> </div> <div class=\"c w-lg-1-3 w-xl-1-4 w-xx-4-12 offset-xx-1-12\"> <parcel-how-does-it-work-box></parcel-how-does-it-work-box> </div> </div>";

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>parcel.allMyParcels</h1> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div ng-if=\"vm.model !== null\"> <div class=\"box search-box\"> <div class=box-hd fb-folder init-open=\"{{vm.isSearchUsed() === true ? 'md-up' : 'md-down'}}\"> <h4 translate>parcel.search</h4> </div> <div class=box-bd> <div class=r> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl translate>parcel.orderNumber</div> <div class=search-control> <input ng-model=vm.model.search.orderNumber class=input type=text placeholder=\"{{ 'parcel.orderNumber' | translate }}\"> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl translate>parcel.sentTo</div> <div class=search-control> <input ng-model=vm.model.search.identification class=input type=text placeholder=\"{{ 'parcel.nameApbOrCustomerNr' | translate }}\"> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl translate>parcel.madeOn</div> <div class=search-control> <div class=search-filter-period> <div class=search-filter-period-control> <fb-date-picker value=vm.model.search.dateFrom></fb-date-picker> </div> <div class=search-filter-period-lbl translate>parcel.until</div> <div class=search-filter-period-control> <fb-date-picker value=vm.model.search.dateTo></fb-date-picker> </div> </div> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=search-filter> <div class=search-lbl translate>parcel.parcelBarcode</div> <div class=search-control> <input ng-model=vm.model.search.barCode class=input type=text placeholder=\"{{'parcel.barcode' | translate}}\"> </div> </div> </div> </div> <div class=search-btns> <button class=\"btn btn-primary m-r-1\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b translate>parcel.search</b> </button> <button class=\"btn btn-outline\" ng-click=vm.clear()> <i class=\"ico ico-remove\"></i><b translate>parcel.reset</b> </button> </div> </div> </div> <div class=\"toolbar toolbar-top\"> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.count}}</strong> <translate translate-n=vm.model.count translate-plural=parcel.parcelsLower>parcel.parcelLower</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pageCountList\" ng-model=vm.paging.itemsPerPage ng-change=vm.changeItemsPerPage(vm.paging.itemsPerPage)></select> <label translate>parcel.perPage</label> </div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> </div> <div ng-if=vm.ordersLoading class=\"loading loading-block\"></div> <div ng-if=\"!vm.ordersLoading && vm.model.count === 0 && !vm.isSearchUsed()\"><p class=m-t-1 translate>parcel.noParcelsFound</p></div> <div ng-if=\"!vm.ordersLoading && vm.model.count === 0 && vm.isSearchUsed()\"><p class=m-t-1 translate>parcel.noParcelsFoundForCriteria</p></div> <div class=\"border-bottom border-2x\" ng-if=!vm.ordersLoading ng-repeat=\"parcel in vm.model.results\"> <parcel-search-result-item parcel=parcel></parcel-search-result-item> </div> <div ng-if=\"vm.model !== null && vm.model.count !== 0\" class=\"toolbar toolbar-bottom\" style=margin-top:-2px> <div> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.count}}</strong> <translate translate-n=vm.model.count translate-plural=parcel.parcelsLower>parcel.parcelLower</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pageCountList\" ng-model=vm.paging.itemsPerPage ng-change=vm.changeItemsPerPage(vm.paging.itemsPerPage)></select> <label translate>parcel.perPage</label> </div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> </div> </div>";

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r ng-if=vm.parcel> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div class=\"c w-2-3 p-l-0\"> <h1> <div><span translate>parcel.parcel</span> {{ vm.parcel.number }}</div> <div class=\"type-base m-y-1\"> <div> <span translate>parcel.madeOn</span> <strong>{{ vm.parcel.createdOn | date:'d MMMM yyyy'}}</strong> </div> <div> <span translate>parcel.to</span> <strong>{{ vm.parcel.receiver.name }}</strong> </div> </div> </h1> </div> <div class=\"c w-1-3 p-r-0 align-right\"> <div class=m-b-1> <a class=\"m-t-3 btn btn-outline btn-error-outline\" ng-click=vm.cancelOrder() ng-if=vm.orderCanBeCancelled()> <i class=\"ico ico-delete text-error m-r-1\"></i><span translate>parcel.cancel</span> </a> </div> </div> </div> </div> <parcel-detail-content parcel=vm.parcel confirmation=false cancel=vm.cancelLine(lineId) can-cancel=vm.canCancel></parcel-detail-content>";

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>parcel.myParcels</h1> <p class=m-b-2><a class=\"btn btn-primary-outline\" ui-sref=add-parcel><span translate>parcel.createParcel</span></a></p> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <div class=\"box box-2\" ng-if=vm.recentOrders.length> <div class=box-hd> <h2 class=left translate>parcel.latestShipments</h2> <a class=\"right btn btn-outline\" ui-sref=parcel-archive><span translate>parcel.allMyParcels</span></a> </div> <div class=box-bd> <div class=\"border-bottom border-2x m-b-1\" ng-repeat=\"order in vm.recentOrders\"> <parcel-search-result-item parcel=order></parcel-search-result-item> </div> <div class=align-right> <a class=\"btn btn-outline\" ui-sref=parcel-archive><span translate>parcel.allMyParcels</span></a> </div> </div> </div> <div class=\"box box-2\" ng-if=!vm.recentOrders.length> <div class=box-hd> <h2 class=left translate>parcel.youHaveNoRecentParcels</h2> <a class=\"right btn btn-outline\" ui-sref=parcel-archive><span translate>parcel.allMyParcels</span></a> </div> <div class=box-bd> <p translate>parcel.searchAllParcels</p> <p translate>parcel.whatCanBeSentAndHowItWorks</p> <ul class=\"btn-holder m-t-2\"> <li class=btn-holder-left> <a class=\"btn btn-primary-outline\" ui-sref=add-parcel><span translate>parcel.createParcel</span></a> </li> <li class=btn-holder-right> <a class=\"btn btn-outline\" ui-sref=parcel-archive><span translate>parcel.allMyParcels</span></a> </li> </ul> </div> </div> </div> <div class=\"c w-lg-1-3 w-xl-1-4 w-xx-4-12 offset-xx-1-12\"> <div class=\"box box-border box-border-primary\"> <p translate>parcel.createShippingLabelHere</p> <p class=align-center> <a class=\"btn btn-primary-outline\" ui-sref=add-parcel><span translate>parcel.createParcel</span></a> </p> </div> </div> </div>";

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>My rent overview</h1> <div class=r> <div class=\"c w-xx-3-4 p-t-1\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>Rental products in your possession</h3> </div> <div class=box-bd> <div class=r ng-if=\"!vm.productsLoading && !vm.products.length\"> <div class=\"c w-xl-2-3 w-xx-1-2\"> <p> <span translate>You currently do not rent products from Febelco.</span><br/> <span translate>Discover the <a class=link-primary ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.</span> </p> </div> </div> <div ng-if=vm.productsLoading class=\"loading loading-block\"></div> <div ng-if=\"!vm.productsLoading && vm.products.length !== 0\" class=table-responsive> <table class=\"table table-block table-adapt\"> <thead> <tr> <th width=1%></th> <th width=40%></th> <th width=24% translate>Rented from</th> <th width=15% class=align-right translate>Deposit</th> <th width=15% class=align-right translate>Total rent</th> <th width=15%></th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.products\"> <td> <img class=\"img-thumbnail img-size-smallthumb\" ng-src=\"{{product.productImagePath ? $root.getImage(product.productImagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{product.productName}}\"/> </td><td> <a ui-sref=\"rented-product-detail({ id: product.id })\" class=link>{{product.productName}} </a> <div class=type-small>{{product.remark}}</div> </td> <td><span class=\"left hidden-md-up\">{{'Rented from' | translate}}:</span> {{product.startDate | date: 'dd-MM-yyyy'}} </td> <td class=align-right><span class=\"left hidden-md-up\">{{'Deposit' | translate}}:</span>{{product.deposit | currency:'€':2}}</td> <td class=align-right><span class=\"left hidden-md-up\">{{'Total rent' | translate}}:</span>{{product.totalRent | currency:'€':2}}</td> <td class=align-right><a ui-sref=\"rented-product-detail({ id: product.id })\" class=\"btn btn-outline\" translate>Detail</a></td> </tr> </tbody> </table> <div class=\"align-center p-t-1\" ng-if=\"vm.rentingProductsTotalCount > vm.products.length\"> <div class=d-block translate>You have more than 15 rental products in your possession.</div> <a class=link-primary ui-sref=\"rented-product-archive({statusId: vm.getInRentStatus().id})\" translate>Click here to see the complete list.</a> </div> </div> </div> </div> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>Recently passed rental products</h3> </div> <div class=box-bd> <div class=r ng-if=\"!vm.recentRentEndedProductsLoading && !vm.rentEndedProducts.length\"> <div class=\"c w-xl-2-3 w-xx-1-2\"> <p> <span translate>No passed rental products the last 3 months.</span><br/> <span translate>Discover the <a class=link-primary ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.</span> </p> </div> </div> <div ng-if=vm.recentRentEndedProductsLoading class=\"loading loading-block\"></div> <div ng-if=\"!vm.recentRentEndedProductsLoading && vm.rentEndedProducts.length !== 0\" class=table-responsive> <table class=\"table table-block table-adapt\"> <thead> <tr> <th width=1%></th> <th width=40%></th> <th width=24% class=align-bottom translate>Rented since &ndash; until</th> <th width=15% class=\"align-right align-bottom\" translate>Deposit</th> <th width=15% class=\"align-right align-bottom\"><span style=max-width:80px;display:inline-block translate>Refunded deposit</span></th> <th width=15%></th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.rentEndedProducts\"> <td> <img class=\"img-thumbnail img-size-smallthumb\" ng-src=\"{{product.productImagePath ? $root.getImage(product.productImagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{product.productName}}\"/> </td> <td style=min-width:200px> <a ui-sref=\"rented-product-detail({ id: product.id })\" class=link>{{product.productName}} </a> <div class=type-small>{{product.remark}}</div> </td> <td><span class=\"left hidden-md-up\">{{'Rented until' | translate}}:</span>{{ product.startDate | date: 'dd-MM-yyyy' }} &ndash; {{ product.endDate | date: 'dd-MM-yyyy' }}</td> <td class=align-right><span class=\"left hidden-md-up\">{{'Deposit' | translate}}:</span> {{product.deposit | currency:'€':2}}</td> <td class=align-right> <span class=\"left hidden-md-up\">{{'Refunded deposit' | translate}}:</span> <div ng-if=\"product.depositRefunded !== null\"> <div ng-if=product.depositRefunded><span translate>Yes</span> <div ng-if=!!product.depositRefundedDate>{{ product.depositRefundedDate | date: 'dd-MM-yyyy' }}</div> </div> <div ng-if=!product.depositRefunded translate>No</div> </div> </td> <td class=align-right><a ui-sref=\"rented-product-detail({ id: product.id })\" class=\"btn btn-outline\" translate>Detail</a></td> </tr> </tbody> </table> <div class=\"align-center p-t-1\"> <div class=d-block ng-if=\"vm.recentRentEndedProductsCount > vm.rentEndedProducts.length\" translate>The last 3 months, you ended rent for more than 15 products.</div> <a class=link-primary ng-if=\"vm.recentRentEndedProductsCount > vm.rentEndedProducts.length || vm.recentRentEndedProductsCount < vm.rentEndedProductsTotalCount\" ui-sref=\"rented-product-archive({ statusId: vm.getRentEndedStatus().id })\" translate>Click here to see the complete list.</a> </div> </div> </div> </div> </div> <div class=\"c w-xx-1-4\"> <div class=\"box box-border box-border-primary\"> <p translate>An overview of all rental products since 2019.</p> <p class=align-center> <a class=\"btn btn-outline\" ui-sref=rented-product-archive><span translate>All my rented products</span></a> </p> </div> <div class=\"box box-border\"> <div class=box-hd> <h3 translate>Your recent rental requests</h3> </div> <div class=box-bd> <div ng-if=\"!vm.ordersLoading && vm.orders.length === 0\" class=r> <div class=c> <p> <span translate>The last 3 months you did not submit any rental applications via Profficina.</span> </p> </div> </div> <div ng-if=vm.ordersLoading class=\"loading loading-block\"></div> <div ng-if=\"!vm.ordersLoading && vm.orders.length !== 0\"> <div class=r> <div class=\"c w-md-1-2 w-lg-1-3 w-xx-1-1 m-b-2\" ng-repeat=\"order in vm.orders\"> <div> <span ng-repeat=\"product in order.rentalProducts\"> <img class=\"img-thumbnail img-size-smallthumb\" ng-src=\"{{product.productImagePath ? $root.getImage(product.productImagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{product.productName}}\"/> </span> </div> <a class=link ng-if=\"::order.orderStatusCode !== 'ERROR'\" target=_blank href={{vm.getDownloadUrl(order)}}> {{ 'Your rent request on' | translate }} {{order.deliveryDate | date:'d MMMM yyyy'}} (Pdf)</a> </div> </div> <div> <div class=\"d-block align-center\" ng-if=\"vm.ordersTotalCount > vm.orders.length\" translate> You have more than 15 rental requests in the last 3 months. </div> </div> </div> </div> <div class=box-ft> <div class=btn-holder> <a class=\"btn btn-outline\" ui-sref=rental-request-archive><span translate>All my rental requests</span></a> </div> </div> </div> </div> </div>";

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>All my rental requests</h1> <div class=\"toolbar toolbar-top\"> <div class=toolbar-search> <div class=\"form-inline d-flex\"> <div class=form-group> <input ng-model=vm.model.search.product class=input type=search placeholder=\"{{'Product name or number' | translate}}\"> </div> <div class=form-group style=width:156px> <select class=select ng-options=\"year for year in vm.years\" ng-model=vm.model.search.year> <option value=\"\" selected=selected>--{{ 'Year' | translate }}--</option> </select> </div> <div class=form-group> <button class=\"btn btn-outline btn-tile\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b class=sr-only translate>Search</b> </button> </div> <div class=form-group> <button class=\"btn btn-outline btn-tile\" ng-click=vm.clear()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Reset</b> </button> </div> </div> </div> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{ vm.model.count }}</strong> <translate translate-n=vm.model.count translate-plural=\"rental requests\">rental request</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pageCountList\" ng-model=vm.paging.itemsPerPage ng-change=vm.changeItemsPerPage(vm.paging.itemsPerPage)></select> <label translate>per page</label> </div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> <div ng-if=vm.ordersLoading class=\"loading loading-block\"></div> <div ng-if=\"vm.model.count === 0 && vm.isSearchUsed()\"><p class=m-t-1 translate>Unfortunately there were no rental requests found.</p></div> <div ng-if=\"vm.model.count === 0 && !vm.isSearchUsed()\"><p class=m-t-1 translate>Unfortunately there were no items found from Profficina.</p></div> <div class=table-responsive ng-if=\"!vm.ordersLoading && vm.model.count !== 0\"> <table class=\"table table-block table-adapt m-b-0\"> <thead> <tr> <th translate>Date</th> <th> <span translate>Product</span> <div class=right translate>Quantity</div> </th> <th class=align-right translate>Detail</th> </tr> </thead> <tbody> <tr ng-repeat=\"order in vm.model.results\"> <td>{{order.deliveryDate | date:'yyyy-MM-dd'}}</td> <td> <div ng-repeat=\"product in order.rentalProducts\"> <a ng-if=\"product.productType === 'RENTAL'\" ui-sref=\"seller.rentProductDetail({ productId: product.id, sellerId: product.sellerId })\" class=link target=_blank> {{ product.productName }} &ndash; {{ product.sellerArticleNumber }} </a> <a ng-if=\"product.productType === 'PORTALPRODUCT'\" ui-sref=\"general.products.product({ productId:  product.id })\" class=link target=_blank> {{ product.productName }} &ndash; {{ product.sellerArticleNumber }} </a> <strong class=\"right m-l-2\">{{ product.quantity }}</strong> </div> </td> <td class=align-right> <a class=\"btn btn-outline\" ng-if=\"::order.orderStatusCode !== 'ERROR'\" target=_blank href={{vm.getDownloadUrl(order)}} translate>Rental request (Pdf)</a> </td> </tr> </tbody> </table> </div> <div class=\"toolbar toolbar-bottom\" ng-if=\"vm.model.count !== 0\"> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div>";

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-xl-1-2 w-xl-2-3\"> <h1 translate>All my rented products</h1> </div> </div> <div class=\"toolbar toolbar-top\"> <div class=\"toolbar-search toolbar-rented-product-archive\"> <div class=\"form-inline d-flex\"> <div class=form-group> <input ng-model=vm.model.search.product class=input type=search placeholder=\"{{'Product name or number' | translate}}\"> </div> <div class=form-group> <input ng-model=vm.model.search.remark class=input type=search placeholder=\"{{'Info' | translate}}\"> </div> <div class=form-group style=width:156px> <select class=select ng-options=\"year for year in vm.years\" ng-model=vm.model.search.year> <option value=\"\" selected=selected>--{{ 'Year' | translate }}--</option> </select> </div> <div class=form-group> <select class=select ng-options=\"status as status.name for status in vm.statuses track by status.id\" ng-model=vm.model.search.status> <option value=\"\" selected=selected>--{{ 'Status' | translate }}--</option> </select> </div> <div class=form-group> <select class=select ng-model=vm.model.search.depositRefunded> <option value=\"\" selected=selected>--{{ 'Deposit' | translate }}--</option> <option value=true translate>Deposit refunded</option> <option value=false translate>Deposit not refunded</option> </select> </div> <div class=form-group> <button class=\"btn btn-outline btn-tile\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b class=sr-only translate>Search</b> </button> </div> <div class=form-group> <button class=\"btn btn-outline btn-tile\" ng-click=vm.clear()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Reset</b> </button> </div> </div> </div> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{ vm.model.count }}</strong> <translate translate-n=vm.model.count translate-plural=\"rental products\">rental product</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pageCountList\" ng-model=vm.paging.itemsPerPage ng-change=vm.changeItemsPerPage(vm.paging.itemsPerPage)></select> <label translate>per page</label> </div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> <div ng-if=vm.historyLoading class=\"loading loading-block\"></div> <div ng-if=\"vm.model.count === 0 && vm.isSearchUsed()\"><p class=m-t-1 translate>Unfortunately there were no rental products found.</p></div> <div ng-if=\"vm.model.count === 0 && !vm.isSearchUsed()\"><p class=m-t-1 translate>You have not rented products from Febelco.</p></div> <div class=table-responsive ng-if=\"!vm.historyLoading && vm.model.count !== 0\"> <table class=\"table table-block table-adapt m-b-0\"> <thead> <tr> <th width=1%></th> <th width=37%></th> <th width=20% class=\"align-bottom nowrap\" translate>Rented until &ndash; from</th> <th width=8% class=\"align-bottom align-right\" translate>Deposit</th> <th width=8% class=\"align-bottom align-right\" translate>Total rent</th> <th width=8% class=\"align-bottom align-right\" translate>Refunded deposit</th> <th width=10% class=\"align-bottom align-right\" translate>Status</th> <th width=8%></th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.model.results\"> <td width=1%> <img class=\"img-thumbnail img-size-smallthumb\" ng-src=\"{{product.productImagePath ? $root.getImage(product.productImagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{product.productName}}\"/> </td><td> <a ui-sref=\"rented-product-detail({ id: product.id })\" class=link>{{product.productName}} &ndash; {{product.sellerArticleNumber}}</a> <div class=type-small>{{ product.remark }}</div> </td> <td width=1% class=nowrap> {{ product.startDate | date: 'dd-MM-yyyy' }} <span ng-if=product.endDate>&ndash;</span> {{ product.endDate | date: 'dd-MM-yyyy' }} </td> <td class=align-right> {{ product.deposit | currency:'€':2 }} </td> <td class=align-right> {{ product.totalRent | currency:'€':2 }}</td> <td class=align-right> <div ng-if=\"product.depositRefunded !== null\"> <div ng-if=product.depositRefunded><span translate>Yes</span> <div ng-if=!!product.depositRefundedDate>{{ product.depositRefundedDate | date: 'dd-MM-yyyy' }}</div> </div> <div ng-if=!product.depositRefunded translate>No</div> </div> </td> <td class=align-right> <span ng-class=\"{ 'text-error': product.isCancelled }\"> <i class=ico ng-class=\"{  'ico-alert-error': product.isCancelled }\"></i> {{ product.statusName }} </span> </td> <td class=align-right> <a ui-sref=\"rented-product-detail({ id: product.id })\" class=\"btn btn-outline bbtn-small\" translate>Detail</a> </td> </tr> </tbody> </table> </div> <div class=\"toolbar toolbar-bottom\" ng-if=\"vm.model.count !== 0\"> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div>";

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <span style=display:none translate>Rented product detail</span> <h1 class=m-b-2>{{vm.rentalHistory.productName}} &ndash; {{vm.rentalHistory.sellerArticleNumber}}</h1> <div class=r> <div class=\"c w-lg-1-3 w-xl-1-2 push-lg-2-3 push-xl-1-2\"> <div class=p-t-1 style=max-width:100%> <a ui-sref=\"seller.rentProductDetail({ productId: product.id, sellerId: product.sellerId })\" class=link target=_blank> <img class=img-thumbnail ng-src=\"{{vm.rentalHistory.productImagePath ? $root.getImage(vm.rentalHistory.productImagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{vm.rentalHistory.productName}}\"/> </a> </div> </div> <div class=\"c w-lg-2-3 w-xl-1-2 pull-lg-1-3 pull-xl-1-2\"> <div class=box> <ul class=\"list list-values\"> <li> <div class=lbl translate>Status</div> <div class=val ng-class=\"{ 'text-error': vm.rentalHistory.isCancelled }\"> <i class=ico ng-class=\"{  'ico-alert-error': vm.rentalHistory.isCancelled }\"></i> {{vm.rentalHistory.status.name }} </div> </li> <li> <div class=lbl translate>Rented from</div> <div class=val>{{vm.rentalHistory.startDate | date: 'dd MMMM yyyy'}}</div> </li> <li> <div class=lbl translate>Rented until</div> <div class=val>{{vm.rentalHistory.endDate | date: 'dd MMMM yyyy'}}</div> </li> <li> <div class=lbl translate>Serialnumber</div> <div class=val>{{vm.rentalHistory.serialNumber}}</div> </li> <li> <div class=lbl translate>Shipping note</div> <div class=val>{{vm.rentalHistory.shippingNoteNumber}}</div> </li> <li> <div class=lbl translate>Info</div> <div class=val> {{vm.rentalHistory.remark}} <a href=# class=\"link link-primary\" ng-click=\"vm.isEditingRemark = !vm.isEditingRemark\" class=mr-base><span translate>Modify</span></a> </div> </li> </ul> <div ng-if=vm.isEditingRemark class=\"box box-bg\"> <div class=box-bd> <div class=form-group> <div class=input-group> <input type=text class=input maxlength=75 ng-model=vm.remark> <div class=\"input-append p-x-1\"> <button class=\"btn btn-outline btn-tile\" ng-click=vm.clearRemark()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Clear</b> </button> </div> <div class=input-append> <button class=\"btn btn-primary\" ng-click=vm.saveRemark()><span translate>Save</span></button> </div> </div> </div> </div> </div> <br/> <ul class=\"list list-values\"> <li> <div class=lbl translate>Rent per day</div> <div class=val>{{vm.rentalHistory.dailyRentalPrice | currency:'€':2}}</div> </li> <li> <div class=lbl translate>Total rent</div> <div class=val>{{vm.rentalHistory.totalRent | currency:'€':2}}</div> </li> <li> <div class=lbl translate>Deposit</div> <div class=val>{{vm.rentalHistory.deposit | currency:'€':2}}</div> </li> <li ng-if=\"vm.rentalHistory.depositRefunded !== null\"> <div class=lbl translate>Deposit refunded</div> <div class=val> {{ vm.rentalHistory.depositRefunded ?   ('Yes' | translate) : ('No' | translate) }} <span ng-if=!!vm.rentalHistory.depositRefundedDate><span translate>refundOnDate</span> {{ vm.rentalHistory.depositRefundedDate | date: 'dd MMMM yyyy' }}</span> </div> </li> </ul> </div> <div class=box> <ul class=btn-holder> <li><a class=\"btn btn-outline\" target=_blank ui-sref=\"general.products.product({ productId:  vm.rentalHistory.productId })\" translate>Product info</a></li> </ul> </div> <div class=\"box box-2\" ng-if=\"vm.rentalHistory.status.code !== '50'\"> <div class=box-hd fb-folder> <h4 translate>Rental amount per month</h4> </div> <div class=box-bd> <table class=\"table table-block\"> <thead> <tr> <th translate>Month</th> <th class=align-right translate>Amount</th> </tr> </thead> <tbody> <tr ng-repeat=\"rent in vm.rentalHistory.rentPerMonth\"> <td>{{ rent.month }}</td> <td class=align-right>{{rent.rent | currency:'€':2}}</td> </tr> </tbody> <tfoot> <tr> <td class=\"font-weight-bold table-border-2x\" translate>Total</td> <td class=\"font-weight-bold align-right table-border-2x\">{{vm.rentalHistory.totalRent | currency:'€':2}}</td> </tr> </tfoot> </table> </div> </div> </div> </div>";

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>My account</h1> <div class=r> <div class=\"c w-lg-1-2\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>My log in data</h3> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl translate>Displayname</div> <div class=val>{{::vm.name}} &nbsp; <a ng-href=\"{{vm.modifyName()}}\" target=_blank class=\"link link-primary\" translate>Change</a></div> </li> <li> <div class=lbl translate>Email address</div> <div class=val>{{::vm.email}} &nbsp; <a ng-href=\"{{vm.modifyEmail()}}\" target=_blank class=\"link link-primary\" translate>Change</a></div> </li> <li ng-if=\"vm.amr[0] !== 'external'\"> <div class=lbl translate>Password</div> <div class=val><a ng-href=\"{{vm.modifyPassword()}}\" target=_blank class=\"link link-primary\" translate>Modify password</a></div> </li> <li> <div class=lbl translate>Pharmacy</div> <div class=val> <p>{{::vm.pharmacyName}} - {{::vm.apbNumber}}</p> <div ng-if=\"!vm.isShopAdmin && vm.tenants.length > 1\"> <div class=type-h6>{{ 'Log in with other pharmacy:' | translate }}</div> <ul class=\"list list-spaced p-t-1\"> <li ng-repeat=\"t in vm.tenants\" ng-if=\"vm.apbNumber != t.apbNumber\"> <a class=\"link link-primary\" role=button ng-click=vm.selectTenant(t.secondaryAppUserKey)><b>{{t.name + ' - ' + t.apbNumber}}</b></a> </li> </ul> </div> <div ng-if=vm.isShopAdmin> <a class=\"link link-primary\" role=button ng-click=vm.changeBuyerBase()><b translate>Select other pharmacy</b></a> </div> </div> </li> </ul> <p><a role=button ng-click=vm.signOut() class=\"btn btn-outline\"><i class=\"ico ico-sign-out\"></i><b translate>Sign out</b></a></p> </div> </div> </div> <div class=\"c w-lg-1-2\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>My pharmacy</h3> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl translate>Delivery address</div> <div class=val> {{vm.user.deliveryAddress.streetName}} {{vm.user.deliveryAddress.houseNumber}}<br/> {{vm.user.deliveryAddress.postalCode}} {{vm.user.deliveryAddress.cityName}} </div> </li> <li> <div class=lbl translate>Billing address</div> <div class=val> {{vm.user.invoiceAddress.streetName}} {{vm.user.invoiceAddress.houseNumber}}<br/> {{vm.user.invoiceAddress.postalCode}} {{vm.user.invoiceAddress.cityName}} </div> </li> </ul> <ul class=\"list list-values\"> <li> <div class=lbl translate>Telephone number</div> <div class=val> <p>{{vm.user.phoneNumber}} &nbsp; </p></div> </li> <li> <div class=lbl translate>Company number</div> <div class=val> <p>{{vm.user.companyNumber}} &nbsp; </p></div> </li> </ul> <p translate>E-mail address and language for order confirmations:</p> <ul class=\"list list-values\"> <li> <div class=lbl translate>Email address</div> <div class=val> <p>{{vm.user.mail}} &nbsp; <a ng-click=vm.showModifyBuyerEmail() target=_blank class=\"link link-primary\" translate>Change</a></p> </div> </li> </ul> <div ng-if=vm.showModifyEmail> <div class=\"box box-bg\"> <div class=box-bd> <div class=form-group> <div class=input-group> <input class=input placeholder=\"{{ 'Enter e-mailadress' | translate }}\" ng-model=vm.newMail /> <div class=input-append> <button class=\"btn btn-primary\" ng-click=vm.modifyBuyerEmail() translate>Modify</button> </div> </div> </div> </div> </div> </div> <ul class=\"list list-values\"> <li> <div class=lbl translate>Language</div> <div class=val> <p>{{vm.communicationLanguage.displayName | translate}}&nbsp; <a ng-click=vm.showModifyCommunicationLanguage() target=_blank class=\"link link-primary\" translate>Change</a></p> </div> </li> </ul> <div ng-if=vm.modifyCommunicationLanguage class=\"box box-bg\"> <div class=box-bd> <div class=form-group> <div class=input-group> <select class=select ng-options=\"lang as lang.displayName | translate for lang in vm.getEmailLanguages() track by lang.id\" ng-model=vm.selectedLanguage></select> <div class=input-append> <button class=\"btn btn-primary\" ng-click=vm.selectedLanguageChanged() translate>Modify</button> </div> </div> </div> </div> </div> <div class=richtext> <br/> <p class=type-small translate>checkout.contactSupportWhenInvoiceAddressIsIncorrect</p> </div> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-1-2\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>My orders</h3> </div> <div class=box-bd> <p><i translate>Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.</i></p> <p><a ui-sref=order-overview class=\"btn btn-outline\" translate>View my orders</a></p> </div> </div> </div> <div class=\"c w-lg-1-2\" ng-if=vm.isFebelcoCustomer()> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>My rent overview</h3> </div> <div class=box-bd> <p><i translate>Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.</i></p> <p><a ui-sref=rental-overview class=\"btn btn-outline\" translate>View my rent overview</a></p> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-1-2\" ng-if=vm.isFebelcoCustomer()> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>My reservations</h3> </div> <div class=box-bd> <p><i translate>Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.</i></p> <p><a ui-sref=my-reservations class=\"btn btn-outline\" translate>View my reservations</a></p> </div> </div> </div> <div class=\"c w-lg-1-2\" ng-if=vm.isFebelcoCustomer()> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>_myDocuments._settings.myDocuments</h3> </div> <div class=box-bd> <p><i translate>_myDocuments._settings.introText</i></p> <p><a ui-sref=my-documents class=\"btn btn-outline\" translate>_myDocuments._settings.viewMyDocuments</a></p> </div> </div> </div> <div class=\"c w-lg-1-2\" ng-if=\"vm.isFebelcoCustomer() && vm.canViewPackages\"> <div class=\"box box-2\"> <div class=box-hd> <h3 translate>parcel.myParcels</h3> </div> <div class=box-bd> <p><i translate>parcel.hereYouCanRegister</i></p> <p><a ui-sref=parcels class=\"btn btn-outline\" translate>parcel.viewMyParcels</a></p> </div> </div> </div> </div>";

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = "<h1 translate>Access is denied</h1> <p class=type-h5 translate>You do not have permission to view this page.</p> <p class=type-h5 translate>Contact <a href=mailto:support@profficina.be class=link>support@profficina.be</a> for further assistance.</p> <p>Error 401 - Unauthorized</p> <br/>";

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{vm.brand.name}}</h1> <product-overview context=brand-detail model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=brands translate>Brands</a> <a class=breadcrumb-item ui-sref=\"brand({id: vm.brand.id})\">{{::vm.brand.name}}</a> <b class=breadcrumb-item>News</b> </div> </nav> <h1>{{'News' | translate }} {{::vm.brand.name}}</h1> <news-overview model=vm.newsOverviewModel view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>Brands</h1> <div class=index> <div class=\"toolbar toolbar-brand-overview\"> <div class=search> <input ng-model=vm.searchValue type=search placeholder=\"{{ 'Your search value' | translate }}\" class=input /> </div> <nav class=toolbar-brand-overview-nav> <ul class=\"list list-horizontal\"> <li ng-repeat=\"item in ::vm.brandIndexes\"> <a scroll-to=\"{{::item.char}}\" class=\"btn btn-outline btn-tile\">{{::item.char}}</a> </li> </ul> </nav> </div> <div class=\"r index-r\"> <div class=\"c index-c\" ng-repeat=\"item in ::vm.brandIndexes\"> <div id=\"index-{{::item.char}}\" class=\"box index-box\" ng-show=filteredBrands.length> <div id=\"{{::item.char}}\" class=box-hd> <h2>{{::item.char}}</h2> </div> <div class=box-bd> <ul class=list> <li ng-repeat=\"brand in item.brands | filter: {name: vm.searchValue} as filteredBrands\"> <a ng-href=\"{{::vm.currentLanguage}}/brands/{{::brand.id}}\">{{::brand.name.toLowerCase()}}</a> </li> </ul> </div> </div> </div> </div> </div>";

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <ul class=breadcrumb-wrap> <li class=breadcrumb-item ng-show=!$last aria-hidden=false><a href=/nl class=ng-binding translate>Home</a></li> <li class=breadcrumb-item ng-show=!$last aria-hidden=false><a href=/nl/products class=ng-binding translate>Products</a> </li> <li class=breadcrumb-item ng-repeat=\"category in vm.productOverviewModel.category.parents\"><a ui-sref=general.products.category({categoryId:category.id}) class=ng-binding>{{category.name}}</a> </li><li class=breadcrumb-item>{{vm.productOverviewModel.category.name}}</li> </ul> </nav> <h1>{{ ::vm.category.name }}</h1> <product-overview on-filter-change=vm.onFilterChange() context=category-overview model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-xl-1-2 w-xl-2-3\"> <h1 translate>Certificates title</h1> <div class=box translate>Certificates introtext</div> </div> </div> <div class=\"toolbar toolbar-top toolbar-partnerships-overview toolbar-news-overview\"> <div class=toolbar-search> <div class=toolbar-search-by-term> <form ng-submit=vm.search()> <div class=input-group> <input ng-model=vm.model.search.identification class=input type=search placeholder=\"{{'Product name, number or lot number' | translate}}\"> <div class=input-append> <button type=button class=\"btn btn-outline btn-tile\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b class=sr-only translate>Search</b> </button> </div> <div class=input-append> <button type=button class=\"btn btn-outline btn-tile\" ng-click=vm.clear()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Clear</b> </button> </div> </div> </form> </div> </div> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{ vm.model.count }}</strong> <translate translate-n=vm.model.count translate-plural=certificates>certificate</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pageCountList\" ng-model=vm.paging.itemsPerPage ng-change=vm.changeItemsPerPage(vm.paging.itemsPerPage)></select> <label translate>per page</label> </div> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div> </div> <div ng-if=vm.certificatesLoading class=\"loading loading-block\"></div> <div ng-if=\"!vm.certificatesLoading && vm.model.count === 0 && !vm.isSearchUsed()\"><p class=m-t-1 translate>Unfortunately there were no certificates found.</p></div> <div ng-if=\"!vm.certificatesLoading && vm.model.count === 0 && vm.isSearchUsed()\"><p class=m-t-1 translate>No certificates found for the given search criteria.</p></div> <div class=table-responsive ng-if=\"!vm.certificatesLoading && vm.model.count !== 0\"> <table class=\"table table-block table-adapt m-b-0 table-certificates\"> <thead class=hidden-sm-down> <tr> <th class=table-c-cnk translate>CNK</th> <th class=table-c-name translate>Name</th> <th class=table-c-batch translate>Batch number</th> <th class=table-c-exp translate>Expiry date</th> <th class=table-c-file translate>Document (pdf)</th> </tr> </thead> <tbody> <tr ng-repeat=\"certificate in vm.model.results\"> <td class=table-c-cnk> <div class=table-lbl translate>Product</div> <div class=table-val>{{ certificate.productNumber }}</div> </td> <td class=table-c-name> {{ certificate.productName }} </td> <td class=table-c-batch> <div class=table-lbl translate>Batch number</div> <div class=table-val>{{ certificate.batchNumber }}</div> </td> <td class=table-c-exp> <div class=table-lbl translate>Expiry date</div> <div class=table-val>{{ certificate.expiryDate | date: 'dd-MM-yyyy' }}</div> </td> <td class=table-c-file> <div class=table-lbl translate>Document (pdf)</div> <a ng-if=!!certificate.filename target=_blank class=\"link link-primary\" href={{vm.getCoaUrl(certificate.id)}}> {{ certificate.filename }} </a> </td> </tr> </tbody> </table> </div> <div class=\"toolbar toolbar-bottom\" ng-if=\"vm.model.count !== 0\"> <pager paging=vm.paging go-to-page=vm.goToPage(page)></pager> </div>";

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = "<h1 translate>Something went wrong</h1> <p class=type-h5 translate>Something went wrong when loading this page.</p> <p class=type-h5 translate>Contact <a href=mailto:support@profficina.be class=link>support@profficina.be</a> for further assistance.</p> <p>Error 500 - Internal Server Error</p> <br/>";

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 class=\"inline-block m-r-1\" translate>Your shopping cart</h1> <h6 class=inline-block><span translate>APB-number</span> {{ vm.apbNumber }}</h6> <div ng-if=\"!vm.cart || vm.cart.isEmpty\"> <br/> <p><a ui-sref=home class=\"btn btn-primary-outline\" translate>Continue shopping</a></p> </div> <div class=cart ng-if=\"vm.cart && !vm.cart.isEmpty\"> <div class=\"alert alert-{{::e.type}}\" ng-repeat=\"error in vm.cart.errors\"> <div ng-if=\"error.code === 'DWE'\" translate> Please place your order within {{error.daysLeftUntilDiscountExpires}} days, discount for {{error.productName}} ends on {{error.expireDate | date:'yyyy-MM-dd'}} </div> <div ng-if=\"error.code === 'PIA'\"> <div><span translate>The shaded products can no longer be ordered.</span> </div> </div> <div ng-if=\"error.code === 'MAR'\"> <div>{{error.message}}</div> </div> </div> <cart-total-price-discounts ng-if=vm.cart.totalPriceDiscounts.length class=product-discount-container-in-list total-price-discounts=vm.cart.totalPriceDiscounts></cart-total-price-discounts> <div class=\"box box-1 box-1-primary cart-seller-box\" ng-class=\"{'is-on-hold': true}\" ng-repeat=\"seller in vm.cart.sellers  | orderBy: ['sellerCodeName']\"> <div class=box-hd> <div class=left> <h3>{{seller.sellerCodeName}} <span ng-if=seller.protocolName class=type-h6>({{seller.protocolName}}</span> - <span ng-if=seller.deliveryPartnerName class=type-h6>{{seller.deliveryPartnerName}})</span></h3> <span ng-repeat=\"errorMessage in seller.errorMessages\" class=\"message message-error type-small\">{{errorMessage.message}}</span> </div> <div class=\"right btn-holder\"> <button class=\"btn btn-outline btn-small\" ng-click=vm.removeSellerFromCart(seller.sellerCodeId)><i class=\"ico ico-delete\"></i><b translate>Delete</b></button> <a class=folder-trigger role=button fb-folder target=\"#folder-seller-{{ ::seller.sellerCodeId }}\" init-open=xs-up></a> </div> </div> <div class=box-bd id=\"folder-seller-{{ ::seller.sellerCodeId }}\"> <div class=cart-product-list> <div class=table-fake> <div class=table-hd> <div class=table-r> <div class=\"table-c table-c-cnk\" translate>Product number</div> <div class=\"table-c table-c-name\" translate>Name</div> <div class=\"table-c table-c-price\" translate>Price</div> <div class=\"table-c table-c-gpm\"><abbr title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr></div> <div class=\"table-c table-c-max-discount\" translate>Max. discount</div> <div class=\"table-c table-c-discount\" translate>Current discount</div> <div class=\"table-c table-c-quantity\" translate>Quantity</div> <div class=\"table-c table-c-subtotal\" translate>Subtotal</div> </div> </div> <div class=table-bd> <div class=table-r ng-class=\"{'table-disabled': product.isDisabled}\" ng-repeat=\"product in seller.products | orderBy: '-name' :true\"> <cart-product parent-state=vm.parentState product=product is-vip-seller=seller.isVipSeller remove-products=vm.removeProducts($event) quantity-changed=vm.quantityChanged()></cart-product> </div> </div> </div> </div> <totals totals=seller.totals ng-if=vm.cart.sellers.length></totals> </div> </div> <div class=\"box box-1\"> <div class=box-ft> <ul class=btn-holder> <li class=btn-holder-right><a ng-disabled=\"vm.cartUpdated || !vm.cart.canCheckout\" ng-click=vm.checkout() role=link class=\"btn btn-primary\"> <b translate>Place order</b><i class=\"ico ico-angle-right\"></i></a></li> <li><a ng-click=vm.clear() role=link class=\"btn btn-outline\" translate>Clear shopping cart</a></li> </ul> </div> </div> <div class=\"cart-update-toolbar fixed\" ng-class=\"{'is-open':vm.cartUpdated}\"> <a ng-click=vm.undoChanged() role=link class=\"btn btn-primary-outline\" translate>Undo changes</a> <a ng-click=vm.updateQuantity() role=link class=\"btn btn-primary\" translate>Update shopping cart [ENTER]</a> </div> </div> <div ng-if=vm.isLoading class=loading-overlay> <div class=loading></div> </div>";

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\" ng-repeat=\"seller in vm.cart.sellers  | orderBy: ['name','sellerCodeName']\"> <div class=\"box-hd clearfix\" fb-folder init-open=xs-up> <h2 class=\"inline-block p-r-2\">{{seller.displayName}}</h2> <p class=\"inline-block message\" ng-if=\"errorMessage.code === 'MOP'\" ng-repeat=\"errorMessage in seller.errorMessages\" ng-class=\"'message-error'\"><span>{{errorMessage.message}}</span></p> </div> <div class=box-bd> <div class=\"r cart-items\"> <cart-product ng-repeat=\"product in seller.products | orderBy: '-createdOn'\" seller-id=seller.id product=product is-vip-seller=seller.isVipSeller update-quantity=\"vm.updateQuantity({ product: product })\" remove-product=\"vm.removeProduct({ sellerId: seller.id, product: product })\"> </cart-product> </div> <div class=order-total ng-if=\"vm.cart.sellers.length > 1\"> <totals totals=seller.totals></totals> </div> </div> </div>";

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = "<div class=\"table-c table-c-cnk\"> <span ng-if=\"vm.product.type==='single'\">{{vm.product.productNumber}}</span> <span ng-if=\"vm.product.type!=='single'\">{{vm.product.type}}</span> </div> <div class=\"table-c table-c-name\"> <a class=link ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState.name}\" ng-click=vm.productClicked() ng-class=\"{'is-disabled': vm.product.isDisabled}\">{{ vm.product.displayName }}</a> <span class=discount-sticker-agios ng-if=\"vm.product.portalContractTypeCode === 'AGIOS'\" ng-click=vm.toggleProductDiscounts(vm.product)></span> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> <div class=\"table-c table-c-price\"> <div ng-if=\"vm.product.discountPct === 0\"> {{vm.product.unitPrice | currency:\"€\":2 }} </div> <div ng-if=\"vm.product.discountPct > 0\"> {{vm.product.unitPriceWithDiscount | currency:\"€\":4 }} <strike class=\"text-muted type-xsmall block\" ng-if=\"vm.product.unitPriceWithDiscount !== vm.product.unitPrice\">{{vm.product.unitPrice | currency:\"€\":2 }}</strike> </div> </div> <div class=\"table-c table-c-gpm\"> <span>{{vm.product.grossProfitPercentage + '%'}}</span> <span class=hidden-md-up translate>GPM</span> <strike class=\"text-muted type-xsmall block\" ng-if=\"vm.product.grossProfitPercentage !== vm.product.grossProfitPercentageWithoutDiscount\">{{vm.product.grossProfitPercentageWithoutDiscount + '%'}}</strike> <div>{{vm.product.grossProfitAmount | currency:\"€\":2}}</div> </div> <div class=\"table-c table-c-max-discount\"> <span class=\"text-muted hidden-sm-down\" ng-if=!vm.product.maxDiscount>&ndash;</span> <span class=discount-sticker-container ng-if=vm.product.maxDiscount ng-click=vm.toggleProductDiscounts(vm.product) ng-class=\"{'is-disabled': vm.product.isDisabled}\"> <span class=discount-sticker><span class=lbl>{{ vm.product.maxDiscount }}%</span></span> </span> </div> <div class=\"table-c table-c-discount\"> <span class=\"text-muted hidden-sm-down\" ng-if=!vm.product.discountPct>&ndash;</span> <div class=discount-sticker-current-container ng-click=vm.toggleProductDiscounts(vm.product) ng-class=\"{'is-disabled': vm.product.isDisabled}\"> <span class=discount-sticker-current ng-if=vm.product.discountPct><span class=lbl>{{vm.product.discountPct + '%'}}</span></span> <span class=text-info ng-if=vm.product.discountAmount>{{vm.product.discountAmount  | currency:'€':2}}</span> <div class=\"message message-warning message-expires type-xsmall-uppercase\" ng-if=\"vm.product.daysLeftUntilDiscountExpires < 30 && vm.product.daysLeftUntilDiscountExpires > 1\" translate>Expires within {{vm.product.daysLeftUntilDiscountExpires}} days</div> <div class=\"message message-warning message-expires type-xsmall-uppercase\" ng-if=\"productDiscounts.daysLeftUntilDiscountExpires === 0\" translate>Discount expires today</div> </div> </div> <div class=\"table-c table-c-quantity\"> <div class=input-group> <input ng-change=vm.quantityChanged() class=input type=number min=0 max=\"{{vm.isVipSeller ? 999 : 10000}}\" step=1 ng-model=vm.product.quantity /> <div class=input-append> <a href=# ng-click=vm.removeProductsFromList([vm.product]) class=\"btn btn-outline btn-tile cart-item-remove\"><i class=\"ico ico-delete\"></i></a> </div> </div> </div> <div class=\"table-c table-c-subtotal\"> {{vm.product.totalPriceWithDiscount | currency:\"€\":2 }} </div> <product-discounts ng-if=vm.productDiscountsOpen class=product-discount-container-in-list close=vm.closeProductDiscounts() active-discounts=[vm.product.discountId] total-price-discount-ids=[vm.product.totalPriceDiscountId] context=vm.context portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading parent-state=vm.parentState product-discounts=vm.productDiscounts></product-discounts>";

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"list list-divided list-divided-light\" ng-if=vm.totalPriceDiscounts.length> <li ng-repeat=\"d in vm.totalPriceDiscounts\"> <div class=\"box-bg box-bg-primary m-b-0 p-t-1 p-b-0\"> <div class=\"box-bd text-light\"> <p> <span class=inline-block><span translate>Discount on total order at</span> {{d.displayName}}:</span> <span class=inline-block> <span ng-repeat=\"range in d.discountRanges\"> <strong>{{ range.discount }}{{range.discountValueTypeSymbol}}</strong> <span translate>upward of</span> <strong>{{range.from ? range.from : range.amount | currency:'€':0 }}</strong><span ng-if=!$last>,</span> </span> </span> <span class=\"inline-block type-xsmall\" translate>(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})</span> </p> </div> </div> </li> </ul>";

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = "<h1 translate>Thank you for ordering</h1> <div class=box> <p ng-if=vm.mail translate> You will receive an email confirmation shortly at {{ vm.mail }}. </p> <p translate>checkout.linkToOrderOverview</p> <div class=richtext> <p class=type-small translate>checkout.contactSupportWhenInvoiceAddressIsIncorrect</p> </div> <br/> <div ng-if=vm.ordersWithDeliveryDate.length class=\"table table-fake table-order-confirmation\"> <div class=\"table-hd hidden-sm-down\"> <div class=table-r> <div class=\"table-c table-c-seller\" translate>Seller</div> <div class=\"table-c table-c-reference\" translate> Profficina Ref. </div> <div class=\"table-c table-c-discount\" translate>Discount</div> <div class=\"table-c table-c-total\" translate>Total</div> <div class=\"table-c table-c-receipt\" translate>Receipt</div> </div> </div> <div class=table-bd> <div class=table-r ng-repeat=\"o in ::vm.ordersWithDeliveryDate\"> <div class=\"table-c table-c-seller\"> {{ ::o.sellerName }} </div> <div class=\"table-c table-c-reference\"> <span class=table-lbl translate>Profficina Ref.</span> <span class=table-val>{{ ::o.orderNumber }}</span> </div> <div class=\"table-c table-c-discount\"> <span class=table-lbl translate>Discount</span> <span class=table-val>{{ ::o.totalDiscount | currency:'€':2 }}</span> </div> <div class=\"table-c table-c-total\"> <span class=table-lbl translate>Total</span> <span class=table-val>{{ ::o.totalPrice | currency:'€':2 }}</span> </div> <div class=\"table-c table-c-receipt\"> <a href={{vm.getDownloadUrl(o.id)}} target=_blank class=\"btn btn-outline\"> <i class=\"ico ico-download\"></i><b translate>PDF</b> </a> </div> </div> </div> </div> <br/> <h2 ng-if=vm.ordersWithoutDeliveryDate.length translate> Delayed deliveries </h2> <div ng-if=vm.ordersWithoutDeliveryDate.length class=\"table table-fake table-order-confirmation table-order-confirmation-delayed\"> <div class=\"table-hd hidden-sm-down\"> <div class=table-r> <div class=\"table-c table-c-seller\" translate>Seller</div> <div class=\"table-c table-c-reference\" translate> Profficina Ref. </div> <div class=\"table-c table-c-discount\" translate>Discount</div> <div class=\"table-c table-c-total\" translate>Total</div> <div class=\"table-c table-c-deliveryDate\" translate> Delivery Date </div> <div class=\"table-c table-c-receipt\" translate>Receipt</div> </div> </div> <div class=table-bd> <div class=table-r ng-repeat=\"o in ::vm.ordersWithoutDeliveryDate\"> <div class=\"table-c table-c-seller\"> {{ ::o.sellerName }} </div> <div class=\"table-c table-c-reference\"> <span class=table-lbl translate>Profficina Ref.</span> <span class=table-val>{{ ::o.orderNumber }}</span> </div> <div class=\"table-c table-c-discount\"> <span class=table-lbl translate>Discount</span> <span class=table-val>{{ ::o.totalDiscount | currency:'€':2 }}</span> </div> <div class=\"table-c table-c-total\"> <span class=table-lbl translate>Total</span> <span class=table-val>{{ ::o.totalPrice | currency:'€':2 }}</span> </div> <div class=\"table-c table-c-deliveryDate\"> <span class=table-lbl translate>Delivery Date</span> <span ng-if=::o.deliveryDate class=table-val>{{ ::o.deliveryDate | date: 'dd/MM/yyyy' }}</span> <span ng-if=::!o.deliveryDate class=table-val> - </span> </div> <div class=\"table-c table-c-receipt\"> <a href={{vm.getDownloadUrl(o.id)}} target=_blank class=\"btn btn-outline\"> <i class=\"ico ico-download\"></i><b translate>PDF</b> </a> </div> </div> </div> </div> <div class=box ng-if=vm.disabledSellers.length> <h1 translate>There are still products in your shopping cart</h1> </div> <div ng-if=vm.disabledSellers.length class=\"table table-fake table-order-confirmation\"> <div class=\"table-hd hidden-sm-down\"> <div class=table-r> <div class=\"table-c table-c-seller\" translate>Seller</div> <div class=\"table-c table-c-total\" translate>Total</div> <div class=\"table-c table-c-total\" translate> Deficit </div> </div> </div> <div class=table-bd> <div class=table-r ng-repeat=\"disabledSellers in vm.disabledSellers\"> <div class=\"table-c table-c-seller\"> {{ disabledSellers.name }} </div> <div class=\"table-c table-c-total\"> <span class=table-val>{{ disabledSellers.totalPriceWithDiscount | currency: '€':2 }}</span> </div> <div class=\"table-c table-c-total\"> <span class=table-val style=color:red>{{ disabledSellers.minOrderPriceExclVat - disabledSellers.totalPriceWithDiscount | currency: '€':2 }}</span> </div> </div> </div> </div> <br/> <ul class=btn-holder> <li class=btn-holder-left ng-if=vm.disabledSellers.length> <a ui-sref=cart class=\"btn btn-primary-outline\" translate>View your shopping basket</a> </li> <li class=btn-holder-left> <a ui-sref=general.discounts class=\"btn btn-primary-outline\" translate>See the latest discounts</a> </li> </ul> </div>";

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate translate-context=verb>Order</h1> <h6 class=inline-block> <span translate>APB-number</span> {{ vm.apbNumber }} </h6> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h2>1. <translate>Check your order</translate></h2> </div> <div class=box-bd> <div class=\"box box-2 box-2-primary\" ng-repeat=\"seller in vm.cart.disabledSellers\"> <div class=box-hd> <h3>{{ seller.name }}</h3> <span ng-repeat=\"errorMessage in seller.errorMessages\" class=\"message message-error type-small\">{{ errorMessage.message }}</span> </div> </div> <div class=\"box box-2 box-2-primary\" ng-repeat=\"seller in vm.cart.sellers\"> <div class=box-hd fb-folder init-open=xs-up> <h3>{{ seller.name }}</h3> </div> <div class=box-bd> <div class=\"table table-fake table-order\"> <div class=table-hd> <div class=table-r> <div class=\"table-c table-c-cnk\" translate>Product number</div> <div class=\"table-c table-c-name\" translate> Name </div> <div class=\"table-c table-c-price\" translate> Price </div> <div class=\"table-c table-c-quantity\" translate> Quantity </div> <div class=\"table-c table-c-discount\" translate> Discount </div> <div class=\"table-c table-c-subtotal\" translate> Subtotal </div> </div> </div> <div class=table-bd> <div class=table-r ng-class=\"{'table-disabled': product.isDisabled}\" ng-repeat=\"product in seller.products | orderBy: '-createdOn'\"> <div class=\"table-c table-c-cnk\"> <span ng-if=\"product.type==='single'\">{{ product.productNumber }}</span> <span ng-if=\"product.type!=='single'\">{{ product.type }}</span> </div> <div class=\"table-c table-c-name\"> {{ product.displayName }} </div> <div class=\"table-c table-c-price\"> {{ product.unitPriceWithDiscount | currency: '€':4 }} </div> <div class=\"table-c table-c-quantity\"> {{ product.quantity }} </div> <div class=\"table-c table-c-discount\"> <span class=\"text-muted hidden-sm-down\" ng-if=!product.discountPct>&ndash;</span> <span ng-if=product.discountPct class=discount-sticker-current><span class=lbl>{{ product.discountPct }}%</span></span> <span ng-if=product.promocode class=\"type-xsmall text-info\">{{ product.promocode }}</span> </div> <div class=\"table-c table-c-subtotal\"> {{ product.totalPriceWithDiscount | currency: '€':2 }} </div> </div> </div> </div> <totals totals=::seller.totals></totals> </div> </div> <div ng-if=\"vm.cart.sellers.length > 1\"> <h3 translate>Order total</h3> <totals totals=::vm.cart.totals class=bg-light></totals> </div> </div> </div> <div ng-if=\"vm.hasSpecialOrderProducts && vm.isFebelcoCustomer()\" class=\"box box-1 box-1-primary\"> <div class=box-hd> <h2>2. <span translate>Special orders</span></h2> </div> <div class=box-bd> <p> <span translate>Following products can be ordered via 'special order', should the product not be in stock at the moment.</span> <a ui-sref=\"help({questionCode:'specialorderabout'})\" class=link translate>More info about 'special orders'.</a> </p> <ul class=\"list list-dash\"> <li ng-repeat=\"product in vm.specialOrderProducts\"> {{ product.displayName }} </li> </ul> <br/> <p class=form-lbl translate>What would you like use to do <strong>when these products are not in stock</strong>?</p> <form> <div class=radio> <input id=orderSpecialOrder type=radio ng-model=vm.isSpecialOrder value=true /> <label for=orderSpecialOrder translate><strong>Order</strong> the products <strong>anyway</strong> via the customer service ('special order').</label> <br/> </div> <div class=radio> <input id=doNotOrderSpecialOrder type=radio ng-model=vm.isSpecialOrder value=false /> <label for=doNotOrderSpecialOrder translate><strong>Do not order</strong> the products.</label> </div> </form> </div> </div> <div ng-if=::!vm.isFebelcoCustomer() class=\"box box-1 box-1-primary\"> <div class=box-hd> <h2>2. <span translate>Select wholesaler</span></h2> </div> <div class=box-bd> <form> <select class=select ng-options=\"wholeSaler.name disable when wholeSaler.isDisabled for wholeSaler in vm.wholeSalers | filter:{isFebelcoCustomerWholesaler:true}  | orderBy : 'name'\" ng-model=vm.selectedWholeSaler> <option value=\"\" disabled=disabled selected=selected translate>Select wholesaler</option> </select> </form> </div> </div> <div ng-if=\"::vm.isFebelcoCustomer() && vm.showCustomerAccounts\" class=\"box box-1 box-1-primary\"> <div class=box-hd> <h2> <span ng-if=!vm.hasSpecialOrderProducts>2.</span> <span ng-if=vm.hasSpecialOrderProducts>3.</span> <span translate>_order.selectAccountTitle</span> </h2> </div> <div class=box-bd> <form> <select class=select ng-options=\"acc.name + ' - ' + acc.number for acc in vm.customerAccounts | orderBy : 'name'\" ng-model=vm.selectedCustomerAccount> </select> </form> </div> </div> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <h2> <span ng-if=\"vm.isFebelcoCustomer() && !vm.hasSpecialOrderProducts && !vm.showCustomerAccounts\"> 2. </span> <span ng-if=\"!vm.isFebelcoCustomer() || (vm.hasSpecialOrderProducts && !vm.showCustomerAccounts || !vm.hasSpecialOrderProducts && vm.showCustomerAccounts)\"> 3. </span> <span ng-if=\"vm.isFebelcoCustomer() && vm.hasSpecialOrderProducts && vm.showCustomerAccounts\"> 4. </span> <span translate>Confirm</span> </h2> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl translate>Delivery address</div> <div class=val> {{::vm.user.deliveryAddress.streetName}} {{::vm.user.deliveryAddress.houseNumber}} {{::vm.user.deliveryAddress.boxNumber}}<br/> {{::vm.user.deliveryAddress.postalCode}} {{::vm.user.deliveryAddress.cityName}} </div> </li> <li> <div class=lbl translate>Billing address</div> <div class=val> {{::vm.user.invoiceAddress.streetName}} {{::vm.user.invoiceAddress.houseNumber}} {{::vm.user.invoiceAddress.boxNumber}}<br/> {{::vm.user.invoiceAddress.postalCode}} {{::vm.user.invoiceAddress.cityName}} </div> </li> <li ng-if=::vm.user.mail> <div class=lbl translate>Email address</div> <div class=val>{{::vm.user.mail}}</div> </li> <li ng-if=::vm.user.phoneNumber> <div class=lbl translate>Telephone number</div> <div class=val>{{ vm.user.phoneNumber }}</div> </li> <li ng-if=::vm.user.companyNumber> <div class=lbl translate>Company number</div> <div class=val>{{ vm.user.companyNumber }}</div> </li> </ul> <br/> <p translate>checkout.agreeWithTerms</p> <div class=richtext> <p class=type-small translate>checkout.contactSupportWhenInvoiceAddressIsIncorrect</p> </div> <ul class=btn-holder> <li class=btn-holder-right> <a ng-disabled=vm.isCreateOrderDisabled() ng-click=vm.createOrders() role=button class=\"btn btn-primary\"><b translate>Confirm order</b><i class=\"ico ico-angle-right\"></i></a> </li> </ul> </div> </div> <div ng-if=vm.isLoading class=loading-overlay> <div class=loading></div> </div>";

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = "<div> <span ng-if=::vm.address.addressLine1>{{ vm.address.addressLine1 }}</span> <span ng-if=::vm.address.addressLine2><br/>{{ ::vm.address.addressLine2 }}</span> <span ng-if=::vm.address.postalCode><br/>{{ ::vm.address.postalCode }} {{ ::vm.address.cityName }}</span> <span ng-if=::vm.address.countryName><br/>{{ ::vm.address.countryName }}</span> </div>";

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = "<div class=\"media person-card-small\"> <img class=\"media-img img-circle img-size-smallthumb\" ng-src=\"{{::$root.getImage( (vm.contact.imagePath) ? vm.contact.imagePath : '/assets/img/photo.jpg' , 'PersonThumb'); }}\" alt=\"{{vm.contact.firstName}} {{vm.contact.lastName}}\"/> <div class=media-body> <div><strong>{{vm.contact.firstName}} {{vm.contact.lastName}}</strong></div> <div>{{vm.contact.function}}</div> <div class=word-break><a href=\"mailto:{{vm.contact.email}}\">{{vm.contact.email}}</a></div> <div><a href=\"tel:{{vm.contact.phoneNumber}}\">{{vm.contact.phoneNumber}}</a></div> </div> </div>";

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = "<div id=datetimepicker> <input fb-date-time-picker type=text fb-date-formatter ng-model=vm.value fb-max-date=\"{{vm.maxDate}}\" fb-min-date=\"{{vm.minDate}}\" id=dpicker name=dpicker placeholder=DD/MM/YYYY ng-change=vm.valueChanged(vm.value) class=\"input input-date\"/> </div>";

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-content> <div class=modal-header> <h4 class=modal-title ng-bind=vm.messageTitle></h4> </div> <div class=modal-body ng-bind-html=vm.message></div> <div class=modal-footer> <button class=\"btn btn-primary\" test-context=option-yes ng-click=vm.confirm() translate>Yes</button> <button class=\"btn btn-primary-outline\" test-context=option-no ng-click=vm.reject() type=button translate>No</button> <button class=\"btn btn-primary-outline\" test-context=option-cancel ng-click=vm.cancel() type=button translate>Cancel</button> </div> </div>";

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-content> <div class=modal-header> <h5 class=modal-title translate>Attention!</h5> </div> <div class=modal-body> <p translate>You did not update your cart with the quantities you last modified.</p> </div> <div class=modal-footer> <button class=\"btn btn-primary\" test-context=option-discard ng-click=vm.cancel($event) translate>Update cart</button> <button class=\"btn btn-primary-outline\" test-context=option-cancel ng-click=vm.discard($event) type=button translate>Continue without updating cart</button> </div> </div>";

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = "<div class=folder ng-class=vm.setFolderClass() ng-click=vm.toggleFolder()> {{vm.folderTitle}} <div ng-if=vm.showCount class=\"type-btn link inline-block type-regular\">{{vm.itemCount}} {{vm.itemLabel}}</div> </div> <div class=folder-content ng-class=\"{'is-open': vm.folderOpen}\" ng-if=vm.folderOpen ng-transclude></div>";

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = "<div class=box ng-if=\"::vm.gallery.length > 0\"> <slick class=gallery settings=::vm.gallerySliderSettings> <div ng-repeat=\"gallery in ::vm.gallery | orderBy:'priority'\" ng-class=\"gallery.type === 'VIDEO' ? 'gallery-item gallery-item-video' : 'gallery-item'\"> <a ng-if=\"gallery.type === 'IMAGE'\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-href=\"{{::$root.getImage(gallery.path, 'GalleryS');}}\" ng-attr-data-srcset=\"{{::$root.getImage(gallery.path, 'GalleryL');}} 1400w, {{::$root.getImage(gallery.path, 'GalleryM');}} 1000w, {{::$root.getImage(gallery.path, 'GalleryS');}} 600w\" fb-fancybox data-fancybox=gallery data-caption=\"{{gallery.description}}\"><img ng-src=\"{{::$root.getImage(gallery.thumbnailPath, 'GalleryThumb');}}\" alt=\"{{gallery.description}}\"/></a> <a ng-if=\"gallery.type === 'VIDEO'\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-href=\"{{'https://www.youtube.com/watch?v=' + gallery.path}}\" fb-fancybox data-fancybox=gallery data-caption=\"{{gallery.description}}\"><img ng-src=\"{{gallery.thumbnailPath}}\" alt=\"{{gallery.description}}\"/></a> </div> </slick> </div>";

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"::vm.links.length > 0\" class=box> <h3 translate>More info</h3> <ul class=\"list list-arrow\"> <li ng-repeat=\"link in ::vm.links | orderBy:'priority'\"> <div ng-switch on=link.type> <div ng-switch-when=EXTERNAL><a href={{link.value}} class=link target=_blank>{{link.text}}</a></div> <div ng-switch-when=PRODUCT><a ui-sref=\"seller.products.product({ productId: link.value, sellerId: vm.sellerId})\" class=link>{{link.text}}</a></div> <div ng-switch-when=NEWS><a ui-sref=\"seller.news.newsitem({ newsItemId: link.value, sellerId: vm.sellerId})\" class=link>{{link.text}}</a></div> <div ng-switch-when=BENEFIT><a ui-sref=\"seller.partnerships.partnership({ id: link.value, sellerId: vm.sellerId})\" class=link>{{link.text}}</a></div> <div ng-switch-when=SELLER><a ui-sref=\"seller.home({ sellerId: link.value})\" class=link>{{link.text}}</a></div> <div ng-switch-when=FILE><a href={{::$root.getDocument(link.value)}} class=link target=_blank>{{link.text}}</a></div> </div> </li> </ul> </div>";

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = "<div class=\"pager toolbar-pager\"> <ul> <li ng-if=\"vm.paging.pageNumbers.length > 1\" class=pager-prev> <a href=# class=\"btn btn-outline btn-tile\" ng-click=\"vm.goToPage({page: vm.paging.page - 1})\"> <i class=\"ico ico-angle-left\"></i><span class=sr-only translate>Previous</span> </a> </li> <li ng-repeat=\"pageObject in vm.paging.pageNumbers\"> <span ng-if=pageObject.isEllipses>...</span> <a ng-if=!pageObject.isEllipses href=# class=\"btn btn-outline btn-tile\" ng-class=\"{'active': pageObject.index === vm.paging.page, 'pager-hidden-sm-down': pageObject.isHiddenOnMobile}\" ng-click=\"vm.goToPage({page: pageObject.index})\"> {{ pageObject.index }} </a> </li> <li ng-if=\"vm.paging.pageNumbers.length > 1\" class=pager-next> <a href=# class=\"btn btn-outline btn-tile\" ng-click=\"vm.goToPage({page: vm.paging.page + 1})\"> <span class=sr-only translate>Next</span><i class=\"ico ico-angle-right\"></i> </a> </li> </ul> </div>";

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = "<div class=totals> <div class=\"total total-discount\"> <span class=lbl translate>Total discount</span> <span class=val>{{ vm.totals.totalDiscount | currency:\"€\":2 }}</span> </div> <div class=\"total total-excl-vat\"> <span class=lbl translate>Total</span> <span class=val>{{ vm.totals.totalPriceWithDiscount | currency:\"€\":2 }}</span> </div> <div class=\"total total-vat\" ng-repeat=\"vat in vm.totals.vatList\"> <span class=lbl><span translate>VAT</span> {{ vat.pct }}%</span> <span class=val>{{ vat.amount | currency:\"€\":2 }}</span> </div> <div class=\"total total-incl-vat\"> <span class=lbl translate>Total (incl. VAT)</span> <span class=val>{{ vm.totals.totalPriceWithDiscountInclVat | currency:\"€\":2 }}</span> </div> </div>";

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = "<a class=filternav-link href=javascript:void(0) title=\"{{::vm.item.name}}\" ng-class=\"{'is-selected': vm.item.isSelected}\" ng-click=\"::vm.onChangeFilters({'filter': vm.item, 'category': vm.category})\"> {{::vm.item.name}} </a> <a class=filternav-list-folder ng-class=\"{'is-open' : vm.treeViewOpen}\" href=javascript:void(0) ng-if=vm.item.children.length ng-click=vm.openTreeView()><i class=ico></i></a> <div class=\"list filternav-list{{::vm.isLink ? ' filternav-list-standard' : ''}}\"> <fb-tree-view ng-if=vm.treeViewOpen change-filters=::vm.onChangeFilters($event) items=vm.item.children category=vm.category level=vm.getLevel()></fb-tree-view> </div>";

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = "<div class=\"list filternav-list{{::vm.isLink ? ' filternav-list-standard' : ''}}\"> <fb-tree-view-item change-filters=::vm.onChangeFilters($event) category=vm.category level=vm.level is-link=::vm.isLink ng-repeat=\"item in vm.items|limitTo:vm.limit\" item=item ng-class=\"'lvl' + vm.level\"> </fb-tree-view-item> </div>";

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = "<input ng-disabled=vm.isDisabled ng-required=true data-provide=typeahead fb-set-focus=vm.hasFocus ng-model=vm.searchString id=\"{{vm.inputId}}\" name=\"{{vm.inputId}}\" type=text autocomplete=\"'off'\" ng-class=\"vm.inputStyle ? vm.inputStyle : 'input'\"/>";

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate ng-if=!vm.isBlackFriday>Discounts</h1> <h1 translate ng-if=vm.isBlackFriday>Black Friday</h1> <product-overview custom-category=vm.customCategory context=discount-overview on-filter-change=vm.onFilterChange() model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{ ::vm.discounttype.name }}</h1> <product-overview context=discounttype-overview on-filter-change=vm.onFilterChange() model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "<div class=error-404> <div class=container> <div class=r> <div class=\"c w-lg-1-2\"> <div class=error-404-content> <div> <a ui-sref=home class=error-404-logo><img src=/assets/img/profficina-logo.svg alt=Profficina /></a> <h1 translate>Something went wrong</h1> <p class=type-h5 translate>We can not find the page you are looking for. The product / news item / ... may no longer exist.</p> <p translate>Below are some useful links:</p> <ul> <li><a ui-sref=home class=link translate>Homepage</a></li> <li><a ui-sref=order-overview class=link translate>My orders</a></li> <li><a ui-sref=general.discounts class=link translate>Overview all discounts</a></li> </ul> <p translate>Contact <a href=mailto:support@profficina.be class=link>support@profficina.be</a> for further assistance.</p> <br/> <div ng-if=\"::vm.errormessage!=''\"> <p>Error {{::vm.errormessage}}</p> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "<h1 translate>Something went wrong</h1> <p class=type-h5 translate>The product you were looking was not found or is inactive.</p> <div ng-if=\"::vm.errormessage!=''\"> <p>Error {{::vm.errormessage}}</p> </div> <br/> <p><a href=/ class=\"btn btn-outline\" translate>Return to the homepage</a></p> <br/>";

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>Fast order</h1> <div class=box> <p><span translate>Add products or import a CSV file with your order.</span> <a ui-sref=\"help({questionCode:'fastorderabout'})\" target=_blank class=link translate>More info</a>.</p> </div> <form name=forms.productOverviewForm fb-prevent-navigation=true> <div class=r> <div class=\"c push-lg-2-3 w-lg-1-3\"> <div class=\"box box-border p-t-1 p-l-1 p-r-1 p-b-0\"> <div class=form-group> <div ngf-drop ngf-select ng-model=vm.file class=file-upload-dropbox ngf-pattern=\"'.csv'\" ngf-accept=\"'.csv'\" accept=.csv ngf-max-size=50MB ngf-drag-over-class=\"'dragover'\" ngf-multiple=false ngf-allow-dir=true> <div class=\"form-lbl p-t-1\" translate>Drag your file here or</div> <div class=\"btn btn-primary\"><i class=\"ico ico-file-upload\"></i><b class=lbl translate>select file</b></div> <div class=form-help translate>.csv file, max. 5MB</div> </div> <div ngf-no-file-drop translate>Your browser does not support file upload.</div> </div> </div> </div> <div class=\"c pull-lg-1-3 w-lg-2-3\"> <div class=\"box box-border p-t-3 p-b-3\"> <div class=\"form-inline fast-order-form\"> <div class=\"form-group form-group-inline-stretch\"> <label class=form-lbl translate>Product number or product name</label> <typeahead has-focus=vm.hasFocus.toString() input-id=\"'productSearch'\" search-string=vm.searchString search-source=vm.searchProducts(query) on-change=vm.productSearchChanged(item)> </typeahead> </div> <div class=form-group> <label class=form-lbl translate>Quantity</label> <input ng-model=vm.quantity ng-class=\"{'has-error' : vm.errors.amount}\" type=number class=\"input input-w-small\"/> </div> <div class=\"form-group align-bottom\"> <button type=submit ng-click=vm.addProductToList() class=\"btn btn-primary\" translate>Add</button> </div> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-2-3\"> <form name=productsForm class=fast-order-form> <div class=box> <p class=loading-message ng-if=vm.isLoading> <span class=loading></span> <span class=lbl translate>Just a moment please, your order is being processed...</span> </p> <p class=loading-message ng-if=vm.isAddingToCart> <span class=loading></span> <span class=lbl translate>Just a moment please, your order is being added to your shopping cart...</span> </p> <div class=\"alert alert-warning\" ng-if=\"vm.errors.amount || vm.errors.quantity || vm.errors.productError || vm.errors.emptyCsv\"> <div ng-if=vm.errors.productError translate>One or more products were not found</div> <div ng-if=vm.errors.amount translate>Please enter a quantity.</div> <div ng-if=vm.errors.quantity translate>The quantity of one or more products is incorrect.</div> <div ng-if=vm.errors.emptyCsv translate>The CSV was empty.</div> </div> <div class=\"alert alert-error\" ng-if=\"vm.errors.fileUpload || vm.errors.shoppingCartAdd\"> <div ng-if=vm.errors.fileUpload translate>Something went wrong with the import of your file. Please check your CSV and try again.</div> <div ng-if=vm.errors.shoppingCartAdd translate>Something went wrong while adding the products to your shoppingcart.</div> </div> <table class=\"table table-block table-adapt fast-order-table\" ng-if=\"vm.products.length > 0\"> <thead> <tr> <td translate>Product number</td> <td translate>Product</td> <td translate>Quantity</td> <td></td> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.products\" ng-class=\"{ 'table-error' : !product.quantity && product.name, 'table-disabled' : !product.name}\"> <td>{{product.nationalNumber}}</td> <td> <span ng-if=product.name>{{product.name}}</span> <span ng-if=!product.name translate>Product not found</span> </td> <td> <div class=input-group> <input type=number min=0 max=10000 step=1 ng-if=product.name ng-model=product.quantity type=number class=\"input input-w-small\" value=\"{{product.quantity}}\"/> </div> </td> <td><button ng-click=vm.deleteProductFromList(product) class=\"btn btn-outline btn-tile\"><i class=\"ico ico-delete\"></i></button></td> </tr> </tbody> </table> <div class=\"btn-holder btn-holder-right\" ng-if=\"vm.products.length > 0\"> <div class=btn-holder-item> <a role=button ng-click=vm.clearList() class=\"btn btn-outline\"><i class=\"ico ico-delete\"></i><b translate>Clear all</b> </a> </div> <div class=btn-holder-item> <a role=button class=\"btn btn-primary\" ng-click=vm.addToShoppingCart()> <i class=\"ico ico-cart\"></i><b translate>Add to shopping cart</b> </a> </div> </div> </div> </form> </div> </div> </form>";

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>FAQ</h1> <div class=r> <div class=\"c w-xl-2-3 w-xx-1-2\"> <div ng-repeat=\"help in ::vm.helpCategories\"> <div class=\"box box-2\"> <div class=box-bd> <div ng-repeat=\"subCategory in ::help.subCategories\"> <div class=folder-faq ng-repeat=\"question in subCategory.questions\"> <folder-collapse is-open=\"question.questionCode == vm.questionCode\" folder-title=question.question> <div class=richtext ng-bind-html=::question.answer> </div> </folder-collapse> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = "<div class=m-t-3 ng-if=\"vm.isFebelcoCustomer && vm.activeCampaigns.length\"> <div ng-repeat=\"campaign in vm.activeCampaigns\"> <a ng-if=campaign.homepageBanner ui-sref=\"general.reservations({ code: campaign.code })\" title=\"{{ campaign.name }}\"> <img class=img-block style=margin-top:4px ng-src=\"{{::$root.getImage(campaign.homepageBanner, 'Original');}}\" alt=\"{{ campaign.name }}\"/> </a> </div> </div> <div class=\"box box-1 box-1-primary\" test-context=adverts ng-if=vm.adverts> <div class=box-hd> <h1 translate>In the spotlight</h1> </div> <div class=\"r advert-grid\"> <div class=\"c w-md-1-2 w-lg-1-3\" ng-repeat=\"ad in vm.adverts\"> <div ng-switch on=ad.linkItem.type class=advert data-name=\"{{ad.name}}\" data-id=\"{{ad.sequenceNr}}\"> <a ng-switch-when=PRODUCT ui-sref=\"general.products.product({ productId: ad.linkItem.value})\" ng-click=vm.advertClicked(ad) class=link> <img ng-src=\"{{::$root.getImage(ad.imagePath, 'Showcase');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Showcase');}}\" alt=\"\" class=img-block /> <div class=advert-overlay> <span class=\"btn btn-light-outline\" translate>Order now</span> </div> </a> <a ng-switch-when=EXTERNAL ng-href=\"{{::ad.linkItem.value}}\" ng-click=vm.advertClicked(ad)> <img ng-src=\"{{::$root.getImage(ad.imagePath, 'Showcase');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Showcase');}}\" alt=\"\" class=img-block /> <div class=advert-overlay> <span class=\"btn btn-light-outline\" translate>Order now</span> </div> </a> <a ng-switch-when=NEWS ui-sref=\"general.news.newsitem({ newsItemId: ad.linkItem.value})\" ng-click=vm.advertClicked(ad) class=link> <img ng-src=\"{{::$root.getImage(ad.imagePath, 'Showcase');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Showcase');}}\" alt=\"\" class=img-block /> <div class=advert-overlay> <span class=\"btn btn-light-outline\" translate>Order now</span> </div> </a> <a ng-switch-when=FILE href={{::$root.getDocument(ad.linkItem.value)}} ng-click=vm.advertClicked(ad) class=link target=_blank> <img ng-src=\"{{::$root.getImage(ad.imagePath, 'Showcase');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Showcase');}}\" alt=\"\" class=img-block /> <div class=advert-overlay> <span class=\"btn btn-light-outline\" translate>Order now</span> </div> </a> </div> </div> </div> </div> <div class=\"box box-1 box-1-primary\" ng-if=\"!vm.discountsModel.isLoadingInitial && !vm.discountsModel.errorOccurred\"> <div class=box-hd> <h1 translate>Discounts</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <div class=r> <form name=forms.productOverviewForm fb-on-close-action=vm.addToCart() fb-prevent-navigation=true> <slick settings=::vm.productSliderSettings> <product-overview-grid-item get-product-discounts=vm.getProductDiscounts(product) class=\"c w-md-1-4 w-xx-1-5\" on-change-quantity=vm.onChangeQuantity() ng-repeat=\"product in vm.products\" product=product is-last=$last context=home parent-state=vm.parentState></product-overview-grid-item> </slick> </form> </div> <ul class=btn-holder> <li class=btn-holder-right><a ui-sref=^.discounts class=\"btn btn-primary-outline btn-large\" test-context=to-discounts-btn><b class=lbl translate>All discounts</b><i class=\"ico ico-angle-right\"></i></a></li> </ul> </div> </div> <div class=\"loading loading-block\" ng-if=\"vm.discountsModel.isLoadingInitial && !vm.discountsModel.errorOccurred\"></div> <div class=\"box box-1 box-1-primary\" ng-if=\"vm.newsitems.length !== 0 && vm.newsitems != null\"> <div class=box-hd> <h1 translate>News</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <div class=r> <slick settings=::vm.newsSliderSettings> <news-tile class=\"c w-sm-2 w-md-3 w-xl-4\" ng-repeat=\"news in vm.newsitems\" badge-clicked=vm._badgeClicked(categoryId) news=news parent-state=vm.parentState></news-tile> </slick> </div> <ul class=btn-holder> <li class=btn-holder-right><a ui-sref=^.news class=\"btn btn-primary-outline btn-large\" test-context=to-news-btn><b class=lbl translate>All news</b><i class=\"ico ico-angle-right\"></i></a></li> </ul> </div> </div> <div class=\"loading loading-block\" ng-if=\"vm.newsitems == null\"></div> <add-products-toolbar products-added=vm.productsAdded is-open=vm.isOpen product=vm.product adding-products=vm.addingProducts products-quantity-changed=vm.productsQuantityChanged has-error=vm.hasError add-to-cart=vm.addToCart()> </add-products-toolbar>";

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "<div class=modal-content> <h1 class=modal-header translate>All pharmacies</h1> <div class=modal-body> <div class=\"toolbar toolbar-top toolbar-search-reservation\"> <div class=toolbar-search> <div class=form-inline> <div class=form-group> <div class=\"form-lbl type-h5\" translate>Search</div> </div> <div class=form-group> <input class=input type=search ng-model-options=\"{ debounce: 200 }\" ng-model=vm.searchValue ng-keydown=\"$event.keyCode === 13 && vm.onSearch()\" placeholder=\"{{ 'Name or APB or client number' | translate }}\"/> </div> <div class=form-group> <a href=# class=\"btn btn-outline hidden-md-up\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i><b translate>Search</b></a> <a href=# class=\"btn btn-outline btn-tile hidden-sm-down\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i></a> </div> </div> </div> </div> <div class=table-responsive> <table ng-if=\"!!vm.buyers && vm.buyers.length > 0\" class=\"table table-block table-adapt\"> <thead class=hidden-sm-down> <tr> <th translate>Name</th> <th translate>APB-number</th> <th translate>Customer number</th> <th translate>Location</th> <th translate>Address</th> </tr></thead> <tbody> <tr ng-repeat=\"buyerBase in vm.buyers\" class=btn-outline style=cursor:pointer ng-click=vm.save(buyerBase)> <td>{{buyerBase.name}}</td> <td>{{buyerBase.apb}}</td> <td>{{buyerBase.febelcoCustomerNr}}</td> <td>{{buyerBase.cityName}}</td> <td>{{buyerBase.address}}</td> </tr> </tbody> </table> <div class=\"align-center center-block\"> <div ng-if=\"!vm.buyers && vm.showSpinner\" class=loading-overlay> <div class=loading></div> </div> <p ng-if=\"!!vm.buyers && vm.buyers.length < vm.buyersCount\"><span translate>Please refine your search.</span> <span translate>Too many results.</span></p> <p ng-if=\"!!vm.buyers && vm.buyers.length == 0\" translate>No results.</p> </div> </div> </div> </div>";

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"!vm.isAdmin && vm.isBuyer\" class=\"w-md-1-2 w-xl-1-3 center\"> <div class=\"box box-border box-border-primary\"> <div class=box-hd> <h3 translate>Please select a pharmacy</h3> </div> <div class=box-bd> <ul class=\"list list-spaced\"> <li class=tenant ng-repeat=\"t in ::vm.tenants\"> <button class=\"btn btn-outline btn-block\" ng-click=vm.select(t.secondaryAppUserKey)>{{::t.name}} - {{::t.apbNumber}}</button> </li> </ul> </div> <div class=box-ft> <p class=type-small translate>More than one pharmacy is linked to your account. Choose the pharmacy you wish to log on with.</p> <p class=type-small translate>Orders in Profficina are pharmacy based. Once logged on, you can always switch pharmacy through the 'My account' link in the menu.</p> </div> </div> </div> <div ng-if=\"!vm.isAdmin && vm.isSeller\"> <div class=\"box box-border box-border-primary w-md-1-2 w-xl-1-3 center\" ng-if=!vm.selectedTenant> <div class=box-hd> <h3 translate>Please select a seller</h3> </div> <div class=box-bd> <ul class=\"list list-spaced\"> <li class=tenant ng-repeat=\"t in ::vm.tenants\"> <button class=\"btn btn-outline btn-block\" ng-click=vm.selectSeller(t)>{{::t.sellerName}}</button> </li> </ul> </div> <div class=box-ft> <p class=type-small translate>More than one seller is linked to your account. Choose the seller you wish to log on with.</p> </div> </div> <div class=\"box box-border box-border-primary w-md-1-1 w-xl-1-1 center\" ng-if=vm.selectedTenant> <buyer-base-select seller-id=vm.selectedTenant.sellerId on-confirm=vm.confirm($event)></buyer-base-select> </div> </div> <div ng-if=vm.isAdmin class=\"w-md-1-1 w-xl-1-1 center\"> <div class=\"box box-border box-border-primary\"> <buyer-base-select on-confirm=vm.confirm($event)></buyer-base-select> </div> </div>";

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "<footer class=site-footer> <div class=site-footer-floormat> <div class=\"container align-center\"> <p><span class=type-h5 translate>A question? A suggestion?</span> <br/><a ui-sref=\"help({questionCode:'feedback'})\" class=link translate>Read our FAQ</a> <span translate>or Send an email to</span> <a href=mailto:support@profficina.be class=link>support@profficina.be</a>.</p> </div> </div> <div class=container> <div class=r> <nav class=\"c w-md-2-3 site-footer-nav\"> <ul> <li><img src=/assets/img/profficina-logo.png alt=Profficina /></li> <li translate><a href=http://www.profficina.be target=_blank class=link>www.profficina.be</a></li> <li translate><a href=http://www.profficina.be/nl/algemene-voorwaarden.html target=_blank class=link>Terms and conditions</a></li> <li translate><a href=http://www.profficina.be/nl/privacy-beleid.html target=_blank class=link>Privacy policy</a></li> </ul> </nav> <div class=\"c w-md-1-3 site-footer-languages site-languages\"> <a href=# ng-click=\"vm.setLanguage('nl')\" class=\"btn btn-tile btn-outline\" ng-class=\"{'active': vm.currentLanguage === 'nl'}\">NL</a>&nbsp;&nbsp; <a href=# ng-click=\"vm.setLanguage('fr')\" class=\"btn btn-tile btn-outline\" test-context=to-fr ng-class=\"{'active': vm.currentLanguage === 'fr'}\">FR</a> </div> </div> <div class=site-footer-notes> <p translate>Gross profit margins (GPM) are calculated based on the pharmacy and public price (non-binding recommended prices).</p> <p><span class=discount-sticker-agios></span> <span translate>This product is in Agios, the discount displayed is not the Agios discount.</span></p> </div> </div> </footer> <a scroll-to=top class=site-to-top><i class=\"ico ico-angle-up\"></i><b>TOP</b></a>";

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "<div class=site-header-nav> <ul class=clearfix> <li class=site-header-nav-search><a role=button ng-click=vm.showSearch() click-outside=vm.hideSearch() outside-if-not=site-search><i class=\"ico ico-search\"></i><b class=lbl translate>Search</b></a></li> <li class=site-header-nav-account click-outside=vm.hideAccount()> <a ui-sref=account ng-click=vm.toggleAccount();vm.preventDefault($event)><i class=\"ico ico-user\"></i><b class=lbl><span translate>My account</span><br/><strong>{{ vm.apbNumber }}</strong><i class=\"ico ico-angle-down\"></i></b></a> <div class=site-account> <div class=close-btn ng-click=vm.hideAccount()><i></i></div> <div class=overlay-scroll> <div class=type-h5> <translate>Hello</translate> {{ ::vm.name }}, </div> <p ng-if=vm.isBuyer> <translate>You are logged in with pharmacy</translate>: <strong>{{ vm.pharmacyName }}</strong> - <strong>{{ vm.apbNumber }}</strong><br/> <a ng-if=\"!vm.isShopAdmin && vm.tenantsCount > 1\" role=button ng-click=vm.changeTenant() class=link> <b><translate>Select other pharmacy</translate></b> </a> <a ng-if=vm.isShopAdmin role=button ng-click=vm.changeBuyerBase() class=link> <b><translate>Select other pharmacy</translate></b> </a> </p> <p ng-if=vm.isSeller> <translate>You are logged in with pharmacy</translate>: <strong>{{ vm.pharmacyName }}</strong> - <strong>{{ vm.apbNumber }}</strong><br/> <a role=button ng-click=vm.changeSellerBuyerBase() class=link> <b><translate>Select other pharmacy</translate></b> </a> </p> <p ng-if=vm.isSeller> <translate>You are logged in with seller</translate>: <strong>{{ vm.sellerName }}</strong><br/> <a ng-if=\"vm.tenantsCount > 1\" role=button ng-click=vm.changeSeller() class=link> <b><translate>Select other seller</translate></b> </a> </p> <p><a role=button ng-click=vm.signOut() class=\"btn btn-outline\"><i class=\"ico ico-sign-out\"></i><b translate>Sign out</b></a></p> <ul class=\"list list-divided\" claim-authorize=IsBuyer> <li class=first><a class=\"link-block type-uppercase\" ui-sref=account ui-sref-active-eq=active ng-click=vm.hideAccount() translate>My account</a></li> <li><a class=\"link-block type-uppercase\" ui-sref=order-overview ui-sref-active-eq=active ng-click=vm.hideAccount() translate>My orders</a></li> <li ng-if=vm.isFebelcoCustomer()><a class=\"link-block type-uppercase\" ui-sref=contracts-overview ui-sref-active-eq=active ng-click=vm.hideAccount() translate>My contracts</a></li> <li ng-if=vm.isFebelcoCustomer()><a class=\"link-block type-uppercase\" ui-sref=my-documents ui-sref-active-eq=active ng-click=vm.hideAccount() translate>_myDocuments._siteHeader.myDocuments</a></li> <li ng-if=vm.isFebelcoCustomer()><a class=\"link-block type-uppercase\" ui-sref=rental-overview ui-sref-active-eq=active ng-click=vm.hideAccount() translate>My rent overview</a></li> <li ng-if=vm.isFebelcoCustomer()><a class=\"link-block type-uppercase\" ui-sref=my-reservations ui-sref-active-eq=active ng-click=vm.hideAccount() translate>My reservations</a></li> <li ng-if=\"vm.isFebelcoCustomer() && vm.canViewPackages\"> <a class=\"link-block type-uppercase\" ui-sref=parcels ui-sref-active-eq=active ng-click=vm.hideAccount() translate> parcel.myParcels </a> </li> <li ng-repeat=\"campaign in vm.activeCampaigns\"> <a class=\"link-block type-uppercase\" ui-sref=\"general.reservations({ code: campaign.code })\" ui-sref-active-eq=active ng-click=vm.hideAccount()> {{ campaign.name }} </a> </li> </ul> </div> </div> </li> <li claim-authorize=IsBuyer><a ui-sref=cart><i class=\"ico ico-cart\"></i><b class=lbl translate>Shopping cart</b></a></li> <li claim-authorize=IsBuyer><a ui-sref=fast-order><i class=\"ico ico-clipboard\"></i><b class=lbl translate>Fast order</b></a></li> <li ng-if=\"vm.isFebelcoCustomer() && vm.checkVaccinDate()\"><a ui-sref=general.vaccines><i class=\"ico ico-syringe\"></i><b class=lbl translate>Flu vaccines</b></a></li> <li><a ui-sref=general.certificates><i class=\"ico ico-certificate\"></i><b class=lbl translate>Certificates headerlink</b></a></li> </ul> </div> <div class=site-search claim-authorize=IsBuyer ng-keydown=vm.onKeydownSearch() ng-class=\"{ 'is-open': vm.searchIsOpen }\"> <div class=close-btn ng-click=vm.hideSearch()><i></i></div> <div class=overlay-scroll> <p class=type-h3 translate>Search products by number or name</p> <form ng-submit=vm.search()> <div id=search-input class=input-group> <input ng-model-options=\"{ debounce: 500 }\" class=input type=search ng-model=vm.searchValue placeholder=\"{{ 'Product name or number' | translate }}\"/> <div class=\"loading loading-small\" ng-show=vm.isLoading></div> <div class=input-append> <button class=\"btn btn-outline btn-tile\" type=submit> <i class=\"ico ico-search\"></i><span class=sr-only translate>Search</span> </button> </div> </div> <div class=site-search-results ng-if=vm.searchResults> <ul class=\"list list-divided\"> <li ng-repeat=\"prod in vm.searchResults\"> <a ui-sref=\"general.products.product({ productId: prod.id })\" ng-click=vm.hideSearch() class=link-block ng-class=\"{'active': vm.selectedSearchResultIndex === $index}\" ng-mouseenter=vm.onMouseEnterSearchResults($index)> <span class=\"media media-align-center\"> <span class=media-img><img ng-src=\"{{::$root.getImage(prod.image, 'ProductThumb');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'ProductThumb');}}\" alt=\"\"/></span> <span class=media-body>{{prod.name}}</span> </span> </a> </li> </ul> <a href=# class=\"btn btn-primary-outline btn-block\" ng-class=\"{'active': vm.selectedSearchResultIndex === vm.searchResults.products.length}\" ng-mouseenter=vm.onMouseEnterSearchResults(vm.searchResults.products.length) ng-click=vm.search() translate>Show all results</a> </div> </form> </div> </div> <div class=site-header-languages> <a role=button ng-click=\"vm.setLanguage('nl')\" class=link ng-class=\"{'active': vm.currentLanguage === 'nl'}\">NL</a>&nbsp;&nbsp; <a role=button ng-click=\"vm.setLanguage('fr')\" class=link test-context=to-fr ng-class=\"{'active': vm.currentLanguage === 'fr'}\">FR</a> </div>";

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "<div class=site-nav-toggle ng-click=vm.toggleMenu()><i></i></div> <nav class=site-nav id=site-nav> <div class=\"container overlay-scroll\"> <div class=site-nav-languages> <a role=button ng-click=\"vm.setLanguage('nl')\" class=\"btn btn-tile btn-outline\" ng-class=\"{'active': vm.currentLanguage === 'nl'}\">NL</a>&nbsp;&nbsp; <a role=button ng-click=\"vm.setLanguage('fr')\" class=\"btn btn-tile btn-outline\" test-context=to-fr ng-class=\"{'active': vm.currentLanguage === 'fr'}\">FR</a> </div> <ul class=site-nav-list claim-authorize=IsSeller> <li class=site-nav-item-home> <a ui-sref=home ui-sref-active-eq=active><span translate>Home</span></a> </li> </ul> <ul class=site-nav-list claim-authorize=IsBuyer> <li class=site-nav-item-home> <a ui-sref=home ui-sref-active-eq=active><span translate>Home</span></a> </li> <li class=site-nav-list-divider></li> <li class=site-nav-item-sellers click-outside=vm.hideSubmenu() outside-if-not=\"has-sub site-nav-sub\"> <a ui-sref=sellers ng-click=vm.toggleSubmenu($event) ui-sref-active-eq=is-active class=has-sub><span translate>Sellers</span></a> <div class=site-nav-sub> <ul> <li class=site-nav-all><a ui-sref=sellers translate>All vendors</a></li> </ul> <ul> <li ng-repeat=\"seller in ::vm.navigationData.sellers | filter: { isVIPSeller: 'true' } | filter: { isVisibleInMenu: 'true'} \"> <a ui-sref=\"seller.home({sellerId: seller.id})\"> <span class=site-nav-item-seller-img><img ng-src=\"{{::$root.getImage(seller.img, 'LogoMenu');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'LogoMenu');}}\" alt=\"\"/></span> <span class=site-nav-item-seller-name>{{ ::seller.name }}</span> </a> </li> </ul> <ul> <li ng-repeat=\"seller in ::vm.navigationData.sellers | filter: { isVIPSeller: 'false'} | filter: { isVisibleInMenu: 'true'}\"> <a ui-sref=\"seller.home({sellerId: seller.id})\"> <span class=site-nav-item-seller-img><img ng-src=\"{{::$root.getImage(seller.img, 'LogoMenu');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'LogoMenu');}}\" alt=\"\"/></span> <span class=site-nav-item-seller-name>{{ ::seller.name }}</span> </a> </li> </ul> </div> </li> <li class=site-nav-list-divider></li> <li class=site-nav-item-discounts> <a ui-sref=general.discounts ui-sref-active-eq=active><span translate>Discounts</span></a> </li> <li ng-if=vm.isFebelcoCustomer() class=site-nav-item-products click-outside=vm.hideSubmenu() outside-if-not=\"has-sub site-nav-sub\"> <a ui-sref=general.products ng-click=vm.toggleSubmenu($event) ui-sref-active-eq=active class=has-sub><span translate>Products</span></a> <div class=site-nav-sub> <ul> <li class=site-nav-all><a ui-sref=\"general.products({categoryId: 0 })\" translate>All products</a></li> <li ng-repeat=\"category in ::vm.navigationData.categories\" fb-load-categories> <a ui-sref=\"general.products.category({categoryId: category.id, page: 1})\">{{::category.name}}</a> </li> </ul> </div> </li> <li ng-if=vm.isFebelcoCustomer() class=site-nav-item-brands> <a ui-sref=brands ui-sref-active-eq=active><span translate>Brands</span></a> </li> <li class=site-nav-list-divider></li> <li class=site-nav-item-news> <a ui-sref=general.news ui-sref-active-eq=active><span translate>News</span></a> </li> <li ng-if=\"vm.isFebelcoCustomer() && vm.outletIsActive()\" class=site-nav-list-divider></li> <li ng-if=\"vm.isFebelcoCustomer() && vm.outletIsActive()\" class=site-nav-item-outlet> <a ui-sref=general.outlet ui-sref-active-eq=active><span translate>Outlet</span></a> </li> </ul> </div> </nav>";

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3 translate>Related news</h3> </div> <div class=box-bd> <slick settings=::vm.newsSliderSettings> <div ng-repeat=\"news in vm.topNewsitems\" slide> <news-tile parent-state=vm.parentState news=news></news-tile> </div> </slick> </div> </div>";

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=vm.errorOccurred translate>News overview cannot be shown</div> <div class=\"r newsitems {{vm.viewMode}}\" ng-if=!vm.errorOccurred> <div class=c ng-repeat=\"news in vm.newsitems\"> <news-tile parent-state=vm.parentState badge-clicked=vm._badgeClicked(categoryId) news=news></news-tile> </div> </div>";

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"vm.model !== null\" class=\"toolbar toolbar-top toolbar-news-overview\"> <div class=\"toolbar-search news-toolbar-search\"> <div class=toolbar-search-by-category> <select class=select ng-change=vm.selectCategoriesChanged() ng-options=\"cat as cat.displayName for cat in vm.model.categories track by cat.id\" ng-model=vm.model.selectedCategory></select> </div> <div class=toolbar-search-by-term> <div class=input-group id=search-input ng-keydown=vm.onKeydown()> <input class=input fb-prevent-keypress type=search ng-model=vm.model.searchValue placeholder=\"{{ 'Your search value' | translate }}\"/> <div class=input-append> <button class=\"btn btn-outline btn-tile\" ng-click=vm.search()> <i class=\"ico ico-search\"></i><b class=sr-only translate>Search</b> </button> </div> <div class=input-append> <button class=\"btn btn-outline btn-tile\" ng-click=vm.clear()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Clear</b> </button> </div> </div> </div> </div> <div class=toolbar-count-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.paging.totalItems}}</strong> <translate translate-n=vm.model.paging.totalItems translate-plural=articles>article</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pagecountList\" ng-model=vm.model.paging.itemsPerPage ng-change=\"vm.changeItemsPerPage({itemsPerPage: vm.model.paging.itemsPerPage})\"></select> <label translate>per page</label> </div> <pager paging=vm.model.paging go-to-page=vm.goToPage(page)></pager> </div> </div> <div ng-if=\"vm.model === null\" class=loading></div> <div ng-if=\"vm.model.paging.totalItems === 0\"><p class=m-t-1 translate>Unfortunately there were no news items found.</p></div> <news-grid ng-if=\"vm.model !== null\" newsitems=vm.model.items view-mode=\"{{vm.viewMode}}\" badge-clicked=vm._badgeClicked(categoryId) parent-state=vm.parentState></news-grid> <div ng-if=\"vm.model !== null && vm.model.paging.totalItems !== 0\" class=\"toolbar toolbar-bottom toolbar-news-overview\"> <div class=news-toolbar-pager> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.model.paging.totalItems}}</strong> <translate translate-n=vm.model.paging.totalItems translate-plural=articles>article</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pagecountList\" ng-model=vm.model.paging.itemsPerPage ng-change=\"vm.changeItemsPerPage({itemsPerPage: vm.model.paging.itemsPerPage})\"></select> <label translate>per page</label> </div> <pager paging=vm.model.paging go-to-page=vm.goToPage(page)></pager> </div> </div>";

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-border\"> <div class=tabs> <ul> <li class=w-1-2><a href=# ng-click=\"vm.onClickTab('popular')\" ng-class=\"{'is-active': vm.currentTab === 'popular'}\"><h3>Popular</h3></a></li> <li class=w-1-2><a href=# ng-click=\"vm.onClickTab('recent')\" ng-class=\"{'is-active': vm.currentTab === 'recent'}\"><h3>Recent</h3></a></li> </ul> </div> <div class=box-bd> <news-aside short-newsitems=::vm.popularNews ng-show=\"vm.currentTab === 'popular'\"></news-aside> <news-aside short-newsitems=::vm.recentNews ng-show=\"vm.currentTab === 'recent'\"></news-aside> </div> </div>";

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-border\"> <div class=box-hd> <h3 translate>Tags</h3> </div> <div class=box-bd> <ul class=\"list list-horizontal\"> <li ng-repeat=\"tag in ::vm.tags\"><a ui-sref=\"newsbytag({id: tag.id})\" class=\"btn btn-outline btn-small\">{{::tag.name}}</a></li> </ul> </div> </div>";

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card news news-card news-card-short news-type-{{::vm.news.type}}\"> <div class=card-bd> <div class=meta> <span class=date>{{::vm.news.date}}</span> <span class=badge>{{ ::vm.news.typeDescription }}</span> </div> <p class=title><a ng-href=\"{{::vm.news.url}}\">{{::vm.news.title}}</a></p> <p class=seller>&copy; {{::vm.news.sellerName}}</p> </div> </div>";

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card news news-card news-type-{{::vm.news.type}}\"> <a ui-sref=\".news.newsitem({ newsItemId: vm.news.id })\" ui-sref-opts=\"{relative: vm.parentState.name}\"> <div class=img-container> <div class=img> <picture picturefill><!--[if IE 9]><video style=\"display: none;\"><![endif]--> <source ng-attr-srcset=\"{{ (vm.news.featuredImagePath) ? $root.getImage(vm.news.featuredImagePath, 'NewsThumb') : $root.getImage('assets/img/product.png', 'NewsThumb'); }}\" pf-media=screen-sm /><!--[if IE 9]></video><![endif]--> <img ng-src=\"{{::$root.getImage(vm.news.featuredImagePath, 'NewsThumbS'); }}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'NewsThumb');}}\" alt=\"{{ ::vm.news.title}}\" class=img-block /> </picture> </div> </div> <div class=card-bd> <div class=meta> <span class=date>{{ ::vm.news.modified | date: 'dd/MM/yyyy' }}</span> <span class=\"badge badge-primary\">{{ ::vm.news.categoryName }}</span> </div> <div class=type-h4>{{ ::vm.news.title }}</div> <p class=seller>&copy; <span ng-if=::vm.news.author>{{::vm.news.author}},</span> {{ ::vm.news.sellerName }}</p> </div> </a> </div>";

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=news-detail> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <h1>{{::vm.newsdetail.title}}</h1> <div class=featured-image> <div class=\"embed embed-ratio-3-2\"> <picture picturefill><!--[if IE 9]><video style=\"display: none;\"><![endif]--> <source ng-attr-srcset=\"{{::$root.getImage(vm.newsdetail.featuredImage.path, 'Featured');}}\" pf-media=\"(min-width: 768px)\"/><!--[if IE 9]></video><![endif]--> <img ng-src=\"{{::$root.getImage(vm.newsdetail.featuredImage.path, 'FeaturedS'); }}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Featured');}}\" alt=\"{{::vm.newsdetail.featuredImage.description}}\"/> </picture> </div> </div> <div class=box> <p class=clearfix> <span class=\"type-small left\">{{ ::vm.newsdetail.publishDate | date: 'd MMMM yyyy' }}</span> <a class=\"badge badge-primary badge-{{ ::vm.newsdetail.categoryLabel | lowercase }} right\" ui-sref=\"general.news({categoryId: vm.newsdetail.categoryId })\">{{ ::vm.newsdetail.categoryName }}</a> </p> <p class=type-lead ng-if=::vm.newsdetail.shortDescription>{{::vm.newsdetail.shortDescription}}</p> <p class=type-small-uppercase>&copy; <span ng-if=::vm.newsdetail.author>{{::vm.newsdetail.author}},</span> {{::vm.newsdetail.sellerName}}</p> <hr class=m-t-2 /> </div> <div class=box ng-if=::vm.newsdetail.description> <div class=richtext ng-bind-html=::vm.newsdetail.description> </div> </div> <hr ng-if=::vm.newsdetail.links.length class=m-b-4 /> <links links=vm.newsdetail.links seller-id=vm.newsdetail.sellerId></links> <div class=box ng-if=::vm.newsdetail.gallery.length> <gallery gallery-slider-settings=::vm.gallerySliderSettings gallery=::vm.newsdetail.gallery></gallery> </div> <hr class=m-b-2 /> <div class=box> <ul class=btn-holder> <li class=btn-holder-right><a class=\"btn btn-outline\" href=\"javascript: history.back();\" translate>Return</a></li> </ul> </div> </div> </div> </div>";

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>News</h1> <news-overview model=vm.newsOverviewModel parent-state=vm.parentState badge-clicked=vm.badgeClicked(categoryId) selected-category=vm.selectedCategory items-per-page-changed=vm.itemsPerPageChanged($event) view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=news translate>News</a> <b class=breadcrumb-item><translate>News for </translate> {{::vm.tag.name}}</b> </div> </nav> <h1>{{'News' | translate }} {{::vm.tag.name}}</h1> <div class=\"r layout-aside-right-xl\"> <div class=\"c layout-main\"> <news-overview model=vm.newsOverviewModel view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview> </div> <div class=\"c layout-aside\"> <div class=r> <div class=\"c w-md-1-2 w-xl-1-1\"> <news-recent-popular recent-news=::vm.recentnews popular-news=::vm.popularnews current-tab=popular></news-recent-popular> </div> <div class=\"c w-md-1-2 w-xl-1-1\"> <news-tags tags=::vm.tags></news-tags> </div> </div> </div> </div>";

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = "<div class=\"h6 filternav-count\"> <strong>{{vm.paging.totalItems}}</strong> <translate translate-n=vm.paging.totalItems translate-plural=products>product</translate> </div> <div class=filternav-folder-wrap> <a href=# class=\"btn btn-outline filternav-folder-filters\" ng-click=\"::vm.filternavFolder({folderClass: 'filternav-is-open'})\"><b translate>Filter</b><i class=\"ico ico-expand\"></i></a> <a href=# class=\"btn btn-outline filternav-folder-sorting\" ng-click=\"::vm.filternavFolder({folderClass: 'sorting-is-open'})\"><b translate>Sort</b><i class=\"ico ico-expand\"></i></a> </div> <div class=filternav> <div class=\"box box-2 filternav-box\"> <div class=box-hd fb-folder init-open=md-up> <h5>{{::category.name}}</h5> </div> <div class=box-bd> <div class=\"list filternav-list filternav-list-standard\"> <div level=\"'1'\" ng-repeat=\"item in ::vm.filterCategories\" ng-class=\"'lvl1'\"> <a class=filternav-link ui-sref=\"general.outlet.category({categoryId: item.url, page:'1'})\" title=\"{{::vm.item.name}}\" ng-class=\"{'is-selected': vm.item.isSelected}\"> {{::item.name}} </a> </div> </div> </div> </div> </div>";

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=vm.model.errorOccurred translate>Product overview cannot be shown</div> <div> <div class=\"r layout-aside-left {{vm.filternavFolderClass}}\" fb-enter-pressed=vm.updateQuantity()> <div class=\"c layout-aside\"> <outlet-product-filters filter-categories=vm.filterCategories paging=vm.model.paging change-filters=\"vm.changeFilters(filter, category)\" link-clicked=vm.linkClicked() filternav-folder=vm.filternavFolder(folderClass)> </outlet-product-filters> </div> <div class=\"c layout-main\"> <div ng-if=vm.model.isLoadingInitial class=\"loading loading-block\"></div> <div ng-if=\"!vm.model.isLoadingInitial && !vm.model.errorOccurred\" class=category-products> <product-overview-toolbar placement=top paging=vm.model.paging sorting=vm.model.sorting view-mode=vm.viewMode change-items-per-page=vm.changeItemsPerPage(itemsPerPage) go-to-page=vm.goToPage(page) change-sorting=vm.changeSorting(sortProperty) change-view-mode=vm.changeViewMode(viewMode)> </product-overview-toolbar> <form ng-if=vm.model.productsAvailableForContext name=forms.productOverviewForm fb-on-close-action=vm.updateQuantity() fb-prevent-navigation=true> <product-overview-grid get-product-discounts=vm.getProductDiscounts(product) on-change-quantity=vm.onChangeQuantity($event) context=vm.context products=vm.model.products ng-show=\"vm.viewMode === 'grid'\" parent-state=vm.parentState></product-overview-grid> <product-overview-list get-product-discounts=vm.getProductDiscounts(product) on-change-quantity=vm.onChangeQuantity($event) context=vm.context products=vm.model.products ng-show=\"vm.viewMode === 'list'\" parent-state=vm.parentState></product-overview-list> </form> <add-products-toolbar products-added=vm.productsAdded is-open=vm.isOpen adding-products=vm.addingProducts products-quantity-changed=vm.productsQuantityChanged has-error=vm.hasError add-to-cart=vm.updateQuantity()> </add-products-toolbar> <div ng-if=!vm.model.productsAvailableForCriteria><p translate>Unfortunately there are no products available for the current criteria.</p></div> <product-overview-toolbar placement=bottom paging=vm.model.paging change-items-per-page=vm.changeItemsPerPage(itemsPerPage) go-to-page=vm.goToPage(page)> </product-overview-toolbar> </div> </div> </div> </div>";

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <div ng-if=!vm.textFields> <p translate>Op=Op? These is the last stock for certain products for an extra discounted price. These products can not be returned.</p> <h1 translate>Klaar voor de winter?</h1> </div> <div ng-if=vm.textFields class=box> <div class=richtext ng-bind-html=::vm.textFields.topText></div> <h1>{{vm.textFields.topTitle}}</h1> </div> </div> <div class=r> <div class=c> <a ui-sref=\"^.outlet.category({categoryId: vm.categories[0].url})\" class=\"hover-item-zoom-in hover-item-zoom-in-less\" title=\"{{vm.categories[0].name}}\"> <div> <img class=\"img-block hover-item\" ng-src=\"{{::$root.getImage(vm.categories[0].imagePath, 'OutletCategoryBig');}}\" alt=\"{{vm.categories[0].name}}\" fb-err-src=https://acc-profficina-shop-webapi.profficina.be:443/images/news/thumb/assets/img/product.png> <div class=hover-item-overlay></div> </div> </a> </div> </div> </div> <div class=\"box box-1 box-1-primary\"> <div class=box-hd> <div ng-if=!vm.textFields> <h1 translate>Discover all promotions!</h1> </div> <div ng-if=vm.textFields> <h1>{{vm.textFields.bottomTitle}}</h1> </div> </div> <div class=\"r gutters-tiny\"> <div class=\"c w-md-1-2 w-lg-1-4\" ng-repeat=\"category in vm.categories\" ng-if=\"$index != 0 && $index <= 4\"> <a ui-sref=\"^.outlet.category({categoryId: category.url})\" class=hover-item-zoom-in title=\"{{category.name}}\"> <div> <img class=\"img-block hover-item\" ng-src=\"{{::$root.getImage(category.imagePath, 'OutletCategorySmall');}}\" alt=\"{{category.name}}\" fb-err-src=https://acc-profficina-shop-webapi.profficina.be:443/images/news/thumb/assets/img/product.png> <div class=hover-item-overlay></div> </div> </a> </div> </div> </div>";

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=general.outlet translate>Outlet</a> <b class=breadcrumb-item><translate>{{::vm.category.name}}</translate></b> </div> </nav> <h1>{{ ::vm.category.name }}</h1> <outlet-product-overview filter-categories=vm.categories on-filter-change=vm.onFilterChange() context=seller-products-overview model=vm.productOverviewModel parent-state=vm.parentState></outlet-product-overview>";

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=vm.isOpen> <div class=\"cart-toolbar fixed is-open\" ng-class=\"{'is-open': vm.isOpen, 'success': vm.productsAdded}\"> <div class=container> <div ng-if=\"vm.product && vm.product.type === 'panacee' && !vm.addingProducts && !vm.productsAdded\"> <div ng-if=\"vm.product.quantityToAddForHighestDiscount > 0\" class=\"message message-info\" translate> Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount </div> <p> <span translate>Panaché:</span> {{ vm.product.totalProductsAmountInPanacee }} <span translate>pcs.</span> &ndash; <span class=color-primary>{{ vm.product.getDiscountPctForQuantity() }}%</span> <span translate>discount</span> &ndash; {{ vm.product.totalPriceWithDiscount | currency:'€':2 }} </p> </div> <div ng-if=vm.productsQuantityChanged> <a class=\"btn btn-primary cart-toolbar-add\" ng-click=vm.addToCart() role=button> <i class=\"ico ico-cart ico-medium\"></i> <b translate>Update shopping cart [ENTER]</b> </a> </div> <div ng-if=vm.addingProducts> <span class=\"loading loading-sm inline-block align-middle\"></span> <span class=\"type-xsmall-uppercase inline-block\" translate>Updating your cart...</span> </div> <div ng-if=vm.productsAdded> <p><i class=\"ico ico-success ico-large\"></i> <span class=\"type-xsmall-uppercase inline-block\" translate>Products were added to your cart</span></p> <a ui-sref=cart class=\"btn btn-light\"> <i class=\"ico ico-cart\"></i> <b class=lbl translate>Shopping cart</b> </a> </div> <div ng-if=vm.hasError> <p class=\"message message-error type-xsmall-uppercase\" translate>Something went wrong while adding your products, please try again.</p> </div> </div> </div> </div>";

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = "<br/> <div class=\"box box-2 box-2-primary product-included-in-pack m-t-2\" ng-if=\"::(vm.product.type === 'pack')\"> <div class=box-hd fb-folder init-open=xs-up> <h2><translate>This promopack contains following products</translate></h2> </div> <div class=box-bd> <div class=\"toolbar toolbar-pack-products toolbar-top\"> <div class=toolbar-view-mode> <a role=button class=link-btn ng-if=\"vm.viewMode == 'list'\" ng-class=\"{'active': vm.viewMode == 'grid'}\" ng-click=\"vm.changeViewMode('grid')\" data-viewmode=grid> <b translate>Show in grid</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-grid\"></i></span> </a> <a role=button class=link-btn ng-if=\"vm.viewMode == 'grid'\" ng-class=\"{'active': vm.viewMode == 'list'}\" ng-click=\"vm.changeViewMode('list')\" data-viewmode=list> <b translate>Show in list</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-list\"></i></span> </a> </div> </div> <product-overview-grid get-product-discounts=vm.getProductDiscounts(product) order-by-property=vm.orderByProperty is-order-by-descending=vm.isOrderByDescending filter=vm.searchText ng-if=\"vm.viewMode === 'grid'\" on-change-quantity=\"vm.packQuantityChanged({product: product})\" context=vm.context products=::vm.product.included_products parent-state=vm.parentState></product-overview-grid> <product-overview-list get-product-discounts=vm.getProductDiscounts(product) order-by-property=vm.orderByProperty is-order-by-descending=vm.isOrderByDescending filter=vm.searchText ng-if=\"vm.viewMode === 'list'\" on-change-quantity=\"vm.packQuantityChanged({product: product})\" context=vm.context products=::vm.product.included_products parent-state=vm.parentState></product-overview-list> </div> </div>";

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = "<br/> <div class=\"box box-2 product-included-in-panacee m-t-2\" id=product-included-in-panacee> <div class=box-hd fb-folder init-open=xs-up> <h3 translate>You can choose from the following products:</h3> </div> <div class=box-bd> <div class=\"toolbar toolbar-top toolbar-search-sort\"> <div class=r> <div class=\"c w-md-1-2 w-xl-1-3 toolbar-search\"> <div class=input-group> <div class=\"input-prepend type-h5\"><translate>Search</translate>:&nbsp;</div> <input type=text class=input ng-model=vm.searchText placeholder=\"{{ 'Productname or product number' | translate }}\"/> <div class=input-append> <a href=# class=\"btn btn-outline btn-tile\"><i class=\"ico ico-search\" title=\"{{ 'Search' | translate }}\"></i></a> </div> </div> </div> <div class=\"c w-md-1-2 w-xl-1-4 push-xl-5-12 toolbar-view-mode\"> <a href=# class=link-btn ng-if=\"vm.viewMode == 'list'\" ng-class=\"{'active': vm.viewMode == 'grid'}\" ng-click=\"vm.changeViewMode('grid')\" data-viewmode=grid> <b translate>Show in grid</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-grid\"></i></span> </a> <a href=# class=link-btn ng-if=\"vm.viewMode == 'grid'\" ng-class=\"{'active': vm.viewMode == 'list'}\" ng-click=\"vm.changeViewMode('list')\" data-viewmode=list> <b translate>Show in list</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-list\"></i></span> </a> </div> <div class=\"c w-xl-5-12 pull-xl-1-4 toolbar-sort\"> <span class=type-h5><translate>Sort by</translate>:&nbsp;</span> <ul class=list> <li> <a role=button class=sort ng-class=\"{'active': vm.orderByProperty === 'name', 'sort-asc': !vm.isOrderByDescending, 'sort-desc': vm.isOrderByDescending }\" ng-click=\"vm.setOrder('name')\"> <b translate>Name</b><i class=ico></i> </a> </li> <li> <a role=button class=sort ng-class=\"{'active': vm.orderByProperty === 'price', 'sort-asc': !vm.isOrderByDescending, 'sort-desc': vm.isOrderByDescending }\" ng-click=\"vm.setOrder('price')\"> <b translate>Price</b><i class=ico></i> </a> </li> </ul> </div> </div> </div> <panacee-overview-grid get-product-discounts=vm.getProductDiscounts(product) order-by-property=vm.orderByProperty is-order-by-descending=vm.isOrderByDescending filter=vm.searchText ng-if=\"vm.viewMode === 'grid'\" on-change-quantity=\"vm.panaceeQuantityChanged({product: product})\" context=vm.context products=vm.product.included_products total-products-amount-in-panacee=vm.product.totalProductsAmountInPanacee parent-state=vm.parentState search-text=vm.searchText></panacee-overview-grid> <panacee-overview-list get-product-discounts=vm.getProductDiscounts(product) order-by-property=vm.orderByProperty is-order-by-descending=vm.isOrderByDescending filter=vm.searchText ng-if=\"vm.viewMode === 'list'\" on-change-quantity=\"vm.panaceeQuantityChanged({product: product})\" context=vm.context products=vm.product.included_products total-products-amount-in-panacee=vm.product.totalProductsAmountInPanacee parent-state=vm.parentState search-text=vm.searchText></panacee-overview-list> </div> </div>";

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-md-1-2\"> <div class=\"box box-2\" ng-if=\"vm.medipimData.faggPublicNotice || vm.medipimData.pharmaPublicNotice || vm.medipimData.laboPublicNotice || vm.medipimData.faggSpecialNotice || vm.medipimData.pharmaSpecialNotice || vm.medipimData.laboSpecialNotice\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate translate-comment=Bijsluiters>Notices</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=\"vm.medipimData.faggPublicNotice || vm.medipimData.pharmaPublicNotice || vm.medipimData.laboPublicNotice\"> <div class=lbl translate translate-comment=Bijsluiters>Notices for patient</div> <div class=val> <ul class=list> <li ng-if=vm.medipimData.faggPublicNotice> <a href={{vm.medipimData.faggPublicNotice}} target=_blank class=\"link link-primary\">FAGG</a> </li> <li ng-if=vm.medipimData.pharmaPublicNotice> <a href={{vm.medipimData.pharmaPublicNotice}} target=_blank class=\"link link-primary\">Pharma.be</a> </li> <li ng-if=vm.medipimData.laboPublicNotice> <a href={{vm.medipimData.laboPublicNotice}} target=_blank class=\"link link-primary\">Labo</a> </li> </ul> </div> </li> <li ng-if=\"vm.medipimData.faggSpecialNotice || vm.medipimData.pharmaSpecialNotice || vm.medipimData.laboSpecialNotice\"> <div class=lbl translate translate-comment=Bijsluiters>Scientific notices</div> <div class=val> <ul class=list> <li ng-if=vm.medipimData.faggSpecialNotice> <a href={{vm.medipimData.faggSpecialNotice}} target=_blank class=\"link link-primary\">FAGG</a> </li> <li ng-if=vm.medipimData.pharmaSpecialNotice> <a href={{vm.medipimData.pharmaSpecialNotice}} target=_blank class=\"link link-primary\">Pharma.be</a> </li> <li ng-if=vm.medipimData.laboSpecialNotice> <a href={{vm.medipimData.laboSpecialNotice}} target=_blank class=\"link link-primary\">Labo</a> </li> </ul> </div> </li> </ul> </div> </div> <div ng-if=\"vm.product.price || vm.product.publicPrice || vm.medipimData.tax\" class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Price information</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=vm.product.price> <div class=lbl><span translate>Pharmacy price</span> <sup>1</sup></div> <div class=val>{{ vm.product.price | currency:'€':2}}</div> </li> <li ng-if=vm.product.publicPrice> <div class=lbl><span translate>Public price</span> <sup>1</sup></div> <div class=val>{{ vm.product.publicPrice | currency:'€':2}}</div> </li> <li> <div class=lbl translate>Tax</div> <div class=val>{{vm.medipimData.tax}}%</div> </li> </ul> <p class=\"text-muted type-small\"><sup>1</sup> <span translate>Non-binding recommended prices</span></p> </div> </div> <div ng-if=\"vm.medipimData.brands.length || vm.medipimData.apbCategory || vm.medipimData.categories.length\" class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Categorisation</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl translate>Prescription</div> <div class=val>{{vm.medipimData.prescription | yesNo}}</div> </li> <li ng-if=vm.medipimData.brands.length> <div class=lbl translate>Brand</div> <div class=val> <ul class=list> <li ng-repeat=\"brand in vm.medipimData.brands\"><a ui-sref=\"brand({id: brand.id})\" class=\"link link-primary\">{{brand.displayName}}</a></li> </ul> </div> </li> <li ng-if=vm.medipimData.apbCategory> <div class=lbl translate>APB category</div> <div class=val> {{vm.medipimData.apbCategory}} </div> </li> <li ng-if=vm.medipimData.categories.length> <div class=lbl translate>Public categories</div> <div class=val> <ul class=list> <li ng-repeat=\"category in vm.medipimData.categories\"><a ui-sref=\"general.products.category({categoryId: category.id})\" class=\"link link-primary\">{{category.displayName}}</a></li> </ul> </div> </li> </ul> </div> </div> <div class=\"box box-2\" ng-if=\"vm.medipimData.ATC || vm.medipimData.EAN || vm.medipimData.NUT\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Reference codes</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=vm.medipimData.ATC> <span class=lbl>ATC</span> <span class=val> <a target=_blank href=\"http://www.whocc.no/atc_ddd_index/?code={{vm.medipimData.ATC}}\" class=\"link link-primary\">{{vm.medipimData.ATC}}</a> </span> </li> <li ng-if=vm.medipimData.EAN> <span class=lbl>EAN</span> <span class=val>{{vm.medipimData.EAN}}</span> </li> <li ng-if=vm.medipimData.NUT> <span class=lbl>NUT</span> <span class=val>{{vm.medipimData.NUT}}</span> </li> </ul> </div> </div> <div class=\"box box-2\" ng-if=\"vm.medipimData.weight || vm.medipimData.width || vm.medipimData.height || vm.medipimData.depth \"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Dimensions</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=vm.medipimData.weight> <span class=lbl translate>Weight</span> <span class=val>{{vm.medipimData.weight}}gr.</span> </li> <li ng-if=vm.medipimData.width> <span class=lbl translate>Width</span> <span class=val>{{vm.medipimData.width}}mm</span> </li> <li ng-if=vm.medipimData.height> <span class=lbl translate>Height</span> <span class=val>{{vm.medipimData.height}}mm</span> </li> <li ng-if=vm.medipimData.depth> <span class=lbl translate>Depth</span> <span class=val>{{vm.medipimData.depth}}mm</span> </li> </ul> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=\"box box-2\" ng-if=vm.medipimData.fullDescription> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Description</h4> </div> <div class=box-bd> <div class=richtext> <div ng-bind-html=vm.medipimData.fullDescription></div> </div> </div> </div> <div class=\"box box-2\" ng-if=vm.medipimData.media.length> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Media</h4> </div> <div class=box-bd> <ul class=\"list list-unstyled list-spaced-2\"> <li ng-repeat=\"media in vm.medipimData.media\"> <div ng-switch on=media.type> <div ng-switch-when=app> <div class=box-bd> <img ng-src=\"{{$root.getImage(media.relativeFilePath, 'Original');}}\" class=\"align-middle img-left img-thumbnail img-s-small\" alt=\"\"/> <div class=media> <div class=media-body> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.name}}</a> <div class=type-small>{{media.description}}</div> </div> </div> </div> </div> <div ng-switch-when=brochure> <div class=box-bd> <img ng-src=\"{{$root.getImage(media.relativeFilePath, 'Original');}}\" class=\"align-middle img-left img-thumbnail img-s-small\" alt=\"\"/> <div class=media> <div class=media-body> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.name}}</a> <div class=type-small>{{media.description}}</div> </div> </div> </div> </div> <div ng-switch-when=video> <div class=box-bd> <div><strong>{{media.name}}</strong></div> <p class=type-small>{{media.description}}</p> <div class=\"embed embed-ratio-3-2\"> <youtube-video video-url=media.link></youtube-video> </div> </div> </div> <div ng-switch-when=website> <img ng-src=\"{{$root.getImage(media.relativeFilePath, 'Original');}}\" class=\"align-middle img-left img-thumbnail img-s-small\" alt=\"\"/> <div class=box-bd> <div class=media> <div class=media-body> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.name}}</a> <div class=type-small>{{media.description}}</div> </div> </div> </div> </div> </div> </li> </ul> </div> </div> <product-info-box title=\"{{'Properties' | translate}}\" text=vm.medipimData.properties></product-info-box> <product-info-box title=\"{{'Indication' | translate}}\" text=vm.medipimData.indication></product-info-box> <product-info-box title=\"{{'Contra indication' | translate}}\" text=vm.medipimData.contraIndication></product-info-box> <product-info-box title=\"{{'Composition' | translate}}\" text=vm.medipimData.composition></product-info-box> <product-info-box title=\"{{'Usage' | translate}}\" text=vm.medipimData.usage></product-info-box> </div> </div>";

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = "<div class=product-grid-item> <product-img product-id=::vm.product.id image=::vm.product.image image-size=Product portal-contract-type-code=vm.product.portalContractTypeCode counter-status=vm.product.counterStatus counter=vm.product.counter discount=::vm.product.discount message=::vm.product.message view-mode=::vm.viewMode parent-state=::vm.parentState max-discount=::vm.product.maxDiscount discount-clicked=vm.toggleProductDiscounts() product-clicked=vm.productClicked() add-link=true></product-img> <div class=product-grid-item-content> <div class=type-xsmall-uppercase> {{vm.product.nationalNumber}} </div> <div class=product-grid-item-name> <a class=link ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked()>{{ vm.product.displayName }}</a> </div> <div class=clearfix> <div class=product-grid-item-price ng-if=!vm.product.discountPct> {{ vm.product.price | currency:'€':2 }} </div> <div class=product-grid-item-price ng-if=vm.product.discountPct> {{ vm.getDiscountPrice()| currency:'€':4 }} <strike class=\"text-muted type-xsmall\"> {{ vm.product.price | currency:'€':2 }}</strike> </div> <div class=product-grid-item-quantity> <div ng-if=\"vm.product.isSellableInStore && vm.context !== 'PACK'\" class=input-group> <input class=input ng-change=vm.onChangeQuantity() ng-model=vm.product.quantity claim-authorize=IsBuyer ng-readonly=\"vm.context === 'PACK'\" type=number min=0 max=10000 step=1 /> </div> <div class=\"input-static align-right w-1-1\" ng-if=\"vm.context === 'PACK'\">{{ vm.product.quantity }} x</div> <div ng-if=!vm.product.isSellableInStore class=product-grid-item-not-available translate>Not available</div> <div class=\"text-primary type-xsmall-uppercase p-y-quart p-r-1 align-right min-max\"> <strong ng-if=vm.product.minOrderAmount>Min&nbsp;{{vm.product.minOrderAmount}}</strong> <strong ng-if=vm.product.maxOrderAmount>Max&nbsp;{{vm.product.maxOrderAmount}}</strong></div> </div> </div> <div class=\"type-xsmall-uppercase p-b-2 p-r-1 align-right min-max\"> <span translate>Quantity in panaché</span> (x{{vm.product.internalQuantity}}) <strong>{{vm.product.quantity * vm.product.internalQuantity}}</strong></div> <div class=clearfix> <div class=product-grid-item-gpm ng-if=vm.product.price> <abbr class=type-xsmall-uppercase title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr>{{(vm.product.grossProfit | number: 0 ) + '%'}} <strike class=\"text-muted type-xsmall\" ng-if=vm.product.discountPct>{{ (vm.getGrossProfit() | number:0) + '%'}}</strike> </div> <div class=product-grid-item-discount> <span class=type-xsmall-uppercase ng-if=\"vm.product.discountPct>0\"><span class=lbl translate>Current discount</span></span> <span class=discount-sticker-current-container ng-if=vm.product.discountPct ng-click=vm.toggleProductDiscounts()> <span class=discount-sticker-current><span class=lbl>{{vm.product.discountPct + '%'}}</span></span> <span class=\"text-info block\" ng-if=vm.product.totalDiscount>{{vm.product.totalDiscount  | currency:'€':2}}</span> </span> </div> </div> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> </div> <product-discounts ng-if=vm.productDiscountsOpen class=product-discount-container-in-grid close=vm.closeProductDiscounts() context=vm.context counter-status=vm.product.counterStatus portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading active-discounts=vm.product.activeDiscountIds total-price-discount-ids=vm.product.totalPriceDiscountIds parent-state=vm.parentState product-discounts=vm.productDiscounts></product-discounts>";

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"!vm.errorOccurred && (vm.productsWithInternalQuantity.length || vm.productsWithoutInternalQuantity.length)\"> <div class=product-grid ng-if=!vm.errorOccurred> <div class=\"r r-sm-2-col r-md-3-col r-lg-3-col r-xl-3-col r-xx-4-col\"> <panacee-overview-grid-item get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.onChangeQuantity() class=\"c bg-primary-lightest\" ng-repeat=\"product in vm.productsWithInternalQuantity | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" product=product is-last=$last context=vm.context parent-state=vm.parentState></panacee-overview-grid-item> <panacee-overview-grid-item get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.onChangeQuantity() class=c ng-class=\"{'is-sold-out': product.tooLate}\" ng-repeat=\"product in vm.productsWithoutInternalQuantity | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" product=product is-last=$last context=vm.context parent-state=vm.parentState></panacee-overview-grid-item> </div> </div> <div class=\"align-right bg-base m-t-2 p-x-1 p-y-1\"><span class=type-xsmall-uppercase translate>Total quantity in panaché</span> <strong>{{vm.totalProductsAmountInPanacee}}</strong></div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-list-item product-list-item-{{::vm.product.type}}\"> <div class=\"table-c table-c-cnk\"> <span ng-if=\"vm.product.productTypeCode !== 'pack' && vm.product.productTypeCode !== 'panacee'\">{{vm.product.nationalNumber}}</span> <span ng-if=\"vm.product.productTypeCode === 'pack'\" translate>Promopack</span> <span ng-if=\"vm.product.productTypeCode === 'panacee'\" translate>Panaché</span> </div> <div class=\"table-c table-c-name\"> <a class=link ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState.name}\" ng-click=vm.productClicked()>{{ vm.product.displayName }}</a> <span class=discount-sticker-agios ng-if=\"::vm.product.portalContractTypeCode === 'AGIOS'\" ng-click=vm.toggleProductDiscounts()></span> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> <div class=\"table-c table-c-price\" ng-class=\"{'hidden-sm-down': vm.product.price === null}\"> <span class=table-lbl translate>Price</span> <span class=table-val> <span class=text-muted ng-if=\"vm.product.price === null\">&ndash;</span> <span ng-if=!vm.product.discountPct> {{ vm.product.price | currency:'€':2 }} </span> <span ng-if=\"vm.product.discountPct > 0\"> {{ vm.getDiscountPrice() | currency:'€':4 }} <strike class=\"text-muted type-xsmall\">{{ vm.product.price | currency:'€':2 }}</strike> </span> </span> </div> <div class=\"table-c table-c-gpm\" ng-class=\"{'hidden-sm-down': vm.product.grossProfit === '0'}\"> <abbr class=table-lbl title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr> <span class=table-val> <span class=text-muted ng-if=\"vm.product.grossProfit === '0'\">&ndash;</span> <span ng-if=\"vm.product.grossProfit !== '0'\"> {{ (vm.product.grossProfit | number:0) + '%' }} </span> <strike class=\"text-muted type-xsmall\" ng-if=vm.product.discountPct> {{ (vm.getGrossProfit() | number:0) + '%'}} </strike> <div>{{vm.product.grossProfitAmount | currency:\"€\":2}}</div> </span> </div> <div class=\"table-c table-c-max-discount\" ng-class=\"{'hidden-sm-down': !vm.product.maxDiscount && !vm.product.portalContractTypeCode === 'AGIOS'}\"> <span class=table-lbl translate ng-if=\"::vm.product.maxDiscount || vm.product.portalContractTypeCode === 'AGIOS'\">Max. discount</span> <span class=table-val> <span class=text-muted ng-if=\"!vm.product.maxDiscount && !vm.product.portalContractTypeCode === 'AGIOS'\">&ndash;</span> <span class=discount-sticker-container ng-if=::vm.product.maxDiscount ng-click=vm.toggleProductDiscounts()> <span ng-if=::vm.product.maxDiscount class=discount-sticker><span class=lbl>{{::vm.product.maxDiscount + '%'}}</span></span> </span> </span> </div> <div class=\"table-c table-c-discount\" ng-class=\"{'hidden-sm-down': !vm.product.discountPct}\"> <span class=table-lbl translate>Current discount</span> <span class=table-val> <span class=text-muted ng-if=!vm.product.discountPct>&ndash;</span> <span class=discount-sticker-current-container ng-click=vm.toggleProductDiscounts() ng-if=vm.product.discountPct> <span class=discount-sticker-current><span class=lbl>{{vm.product.discountPct + '%'}}</span></span> <span class=text-info ng-if=vm.product.totalDiscount>{{vm.product.totalDiscount | currency:'€':2}}</span> </span> </span> </div> <div class=\"table-c table-c-quantity\"> <div ng-if=vm.product.isSellableInStore class=min-max-container> <div class=quantity-container> <div class=input-group ng-if=\"vm.product.productTypeCode !== 'panacee' && vm.context !== 'PACK'\"> <input class=input claim-authorize=IsBuyer ng-change=vm.changeQuantity(vm.product) ng-model=vm.product.quantity ng-readonly=\"vm.context === 'PACK'\" min=0 max=\"{{vm.product.isSellableAsSingleProduct ? 10000 : vm.product.maxOrderAmount}}\" type=number step=1 /> </div> <div class=input-static ng-if=\"vm.product.productTypeCode !== 'panacee' && vm.context === 'PACK'\">{{ vm.product.quantity }} x</div> <div ng-if=\"vm.product.productTypeCode === 'panacee'\"> <a ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked() class=\"btn btn-outline\" translate translate-context=verb>Order</a> </div> </div> <div class=\"text-primary type-xsmall-uppercase p-t-quart align-center min-max\"> <strong ng-if=\"vm.product.minOrderAmount && vm.product.minOrderAmountRequired\" translate>Required&nbsp;{{vm.product.minOrderAmount}}</strong> <strong ng-if=\"vm.product.minOrderAmount && !vm.product.minOrderAmountRequired\" translate>From&nbsp;{{vm.product.minOrderAmount}}</strong> <strong ng-if=vm.product.maxOrderAmount>Max&nbsp;{{vm.product.maxOrderAmount}}</strong> </div> </div> <div ng-if=!vm.product.isSellableInStore class=\"inline-block type-xsmall text-muted\" translate>Not available</div> </div> <div class=\"table-c table-c-quantity-in-panache\"> <span class=table-lbl translate>Quantity in panaché</span> <span class=table-val-right ng-if=\"vm.product.internalQuantity == '1'\">{{vm.product.panaceeQuantity}}</span> <span class=table-val ng-if=\"vm.product.internalQuantity > '1'\">(x{{vm.product.internalQuantity}}) <span class=table-val-right>{{vm.product.panaceeQuantity}}</span></span> </div> </div> <product-discounts ng-if=vm.productDiscountsOpen class=product-discount-container-in-list close=vm.closeProductDiscounts() context=vm.context counter-status=vm.product.counterStatus portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading active-discounts=vm.product.activeDiscountIds total-price-discount-ids=vm.product.totalPriceDiscountIds parent-state=vm.parentState product-discounts=vm.productDiscounts> </product-discounts>";

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-list product-list-panache bg-primary-lightest\" ng-if=\"!vm.errorOccurred  && vm.productsWithInternalQuantity.length\"> <h4 class=\"m-b-0 p-y-2\" translate>Displays</h4> <div class=table-fake> <div class=table-hd> <div class=table-r> <div ng-click=orderProducts() class=\"table-c table-c-cnk\" translate>Product number</div> <div class=\"table-c table-c-name\" translate>Name</div> <div class=\"table-c table-c-price\" translate>Price</div> <div class=\"table-c table-c-gpm\"><abbr title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr></div> <div class=\"table-c table-c-max-discount\" translate>Max. discount</div> <div class=\"table-c table-c-discount\" translate>Current discount</div> <div class=\"table-c table-c-quantity\" translate>N° displays</div> <div class=\"table-c table-c-quantity-in-panache\" translate>Quantity in panaché</div> </div> </div> <div class=table-bd> <panacee-overview-list-item get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.changeQuantity($event) class=table-r ng-repeat=\"product in vm.productsWithInternalQuantity  | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" product=product is-last=$last context=vm.context parent-state=vm.parentState></panacee-overview-list-item> </div> </div> </div> <br/> <div class=\"product-list product-list-panache\" ng-if=\"!vm.errorOccurred  && vm.productsWithoutInternalQuantity.length\"> <div class=table-fake> <div class=table-hd> <div class=table-r> <div ng-click=orderProducts() class=\"table-c table-c-cnk\" translate>Product number</div> <div class=\"table-c table-c-name\" translate>Name</div> <div class=\"table-c table-c-price\" translate>Price</div> <div class=\"table-c table-c-gpm\"><abbr title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr></div> <div class=\"table-c table-c-max-discount\" translate>Max. discount</div> <div class=\"table-c table-c-discount\" translate>Current discount</div> <div class=\"table-c table-c-quantity\" translate>Quantity</div> <div class=\"table-c table-c-quantity-in-panache\" translate>Quantity in panaché</div> </div> </div> <div class=table-bd> <panacee-overview-list-item get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.changeQuantity($event) class=table-r ng-repeat=\"product in vm.productsWithoutInternalQuantity  | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" product=product is-last=$last context=vm.context parent-state=vm.parentState></panacee-overview-list-item> </div> <div class=table-ft> <div class=table-r> <div class=\"table-c align-right bg-base\"><span class=type-xsmall-uppercase translate>Total quantity in panaché</span> <strong class=p-x-1>{{vm.totalProductsAmountInPanacee}}</strong></div> </div> </div> </div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "<div class=toolbar-search> <div class=form-inline> <div class=form-group> <div class=\"form-lbl type-h5\" translate>Search</div> </div> <div class=form-group> <input class=input type=search ng-model-options=\"{ debounce: 200 }\" ng-model=vm.searchValue placeholder=\"{{ 'Batch number' | translate }}\"/> </div> <div class=form-group> <a href=# class=\"btn btn-outline hidden-md-up\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i><b translate>Search</b></a> <a href=# class=\"btn btn-outline btn-tile hidden-sm-down\" title=\"{{ 'Search' | translate }}\" ng-click=vm.onSearch()><i class=\"ico ico-search\"></i></a> </div> </div> </div>";

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-border box-border-primary m-b-0\"> <div class=box-bd> <div ng-if=\"::vm.product.type !== 'panacee'\"> <div ng-if=::vm.product.discount.description> <p>{{::vm.product.discount.description}}</p> </div> <div class=r> <div class=\"c w-1-2\"> <p ng-if=!vm.product.discountPct class=product-detail-price> <span claim-authorize=IsBuyer>{{ vm.product.unitPriceWithDiscount | currency:'€':2}}</span> <span claim-authorize=IsSeller>{{ vm.product.price | currency:'€':2 }}</span> </p> <p ng-if=\"vm.product.discountPct > 0\" class=product-detail-price> <span>{{ vm.product.unitPriceWithDiscount | currency:'€':4}}</span> <strike ng-if=\"vm.product.unitPriceWithDiscount !== vm.product.price\" class=\"text-muted type-xsmall\">{{ vm.product.price | currency:'€':2 }}</strike> </p> <p ng-if=\"vm.product.type !== 'panacee'  && vm.product.price && vm.product.grossProfit > 0\"> </p><div claim-authorize=IsBuyer> <div class=type-xsmall-uppercase title=\"{{'Gross profit margin' | translate }}\" translate>GPM</div> <span> {{ (vm.product.grossProfit | number:0) + '%'}} <strike class=\"text-muted type-xsmall\" ng-if=vm.product.discountPct>{{ (vm.getGrossProfit() | number:0) + '%'}}</strike> </span> <div>{{vm.product.grossProfitAmount | currency:\"€\":2}}</div> </div> <p></p> </div> <div class=\"c w-1-2 p-l-0\" ng-if=\"vm.product.isSellableInStore && vm.product.price !== 0\"> <div class=input-group claim-authorize=IsBuyer> <input class=input ng-change=vm.onChangeQuantity() ng-model=vm.product.quantity ng-readonly=\"vm.product.isInCart || vm.product.type === 'panacee'\" type=number min=0 max=\"{{vm.product.isVipSeller ? 999 : 10000}}\" step=1 /> <div class=input-append> <a href=# ng-click=vm.addToCart() class=\"btn btn-tile btn-primary\"> <i class=\"ico ico-cart\"></i><b class=sr-only translate>Add to shopping cart</b> </a> </div> </div> <div ng-if=\"vm.product.type !== 'panacee' && vm.product.discountPct\" class=product-detail-current-discount> <span class=type-xsmall-uppercase> <span class=lbl translate>Current discount</span> </span> <span class=discount-sticker-current> <span class=lbl>{{vm.product.discountPct + '%'}}</span> </span> <span class=text-info ng-if=vm.product.totalDiscount>{{vm.product.totalDiscount | currency:'€':2}}</span> <span class=\"type-xsmall-uppercase text-info\" ng-if=vm.product.promocode>{{vm.product.promocode}}</span> <span class=\"type-xsmall-uppercase text-info\" ng-if=vm.product.totalPriceDiscountPromoCode>{{vm.product.totalPriceDiscountPromoCode}}</span> </div> </div> <div class=\"c w-1-2\" ng-if=\"!vm.product.isSellableInStore || (vm.product.price === 0 && vm.product.productTypeCode !== 'RENTAL'  && vm.product.productTypeCode !== 'panacee')\"> <span translate>Not available</span> </div> <div class=c> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> </div> </div> <div ng-if=\"::vm.product.type === 'panacee'\"> <p translate>Compose your panacea by choosing products from the list below.</p> <div ng-if=vm.product.discountPct class=product-detail-current-discount> <span class=type-xsmall-uppercase> <span class=lbl translate>Current discount</span> </span> <span class=discount-sticker-current> <span class=lbl>{{vm.product.discountPct + '%'}}</span> </span> <span class=\"type-xsmall-uppercase text-info\" ng-if=vm.product.promocode>{{vm.product.promocode}}</span> <span class=\"type-xsmall-uppercase text-info\" ng-if=vm.product.totalPriceDiscountPromoCode>{{vm.product.totalPriceDiscountPromoCode}}</span> </div> </div> </div> </div> <product-discounts class=product-discount-container-in-detail context=vm.context counter-status=vm.product.counterStatus portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading parent-state=vm.parentState active-discounts=vm.product.activeDiscountIds total-price-discount-ids=vm.product.totalPriceDiscountIds parent-product-type=vm.product.type product-discounts=vm.productDiscounts> </product-discounts>";

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c product-discount-container\"> <div class=close ng-click=vm.close()><b translate>Close</b><i class=\"ico ico-close\"></i></div> <div ng-if=vm.isLoading class=\"loading loading-small\"></div> <div> <div class=product-discount-group ng-repeat=\"discountGroup in vm.productDiscounts\"> <h6>{{ discountGroup[0].displayName}}</h6> <div class=r> <div ng-repeat=\"productDiscount in discountGroup\" class=\"c product-discount-c\" ng-class=\"{'product-discount-c-ordertotal': productDiscount.discountType === 'ORDERTOTALPRICE'}\"> <div ng-if=\"productDiscount.discountType !== 'ORDERTOTALPRICE'\" class={{vm.isActiveDiscount(productDiscount)}}> <div class=\"product-discount-name type-small\"><strong>{{vm.getDiscountType(productDiscount.discountType) | translate }}</strong></div> <ul class=\"list product-discount-conditions\"> <li ng-repeat=\"range in productDiscount.discountRanges\"> <span class=lbl>{{ range.discount }}{{range.discountValueTypeSymbol}}</span> <span class=val>{{range.from ? range.from : range.amount}} <span translate>pcs.</span></span> </li> </ul> <div ng-if=productDiscount.expirationDate><div class=\"message message-info\" translate>Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}</div></div> <div ng-if=\"productDiscount.remark && vm.context !== 'PANACEE' && !( vm.context === 'PRODUCTDETAIL' &&  vm.parentProductType === 'panacee')\" class=\"message message-info\"><a ui-sref=\".products.product({ productId: productDiscount.discountProductId })\" class=link ui-sref-opts=\"{relative: vm.parentState}\">{{productDiscount.remark}}</a></div> <div ng-if=\"productDiscount.remark && ( vm.context === 'PANACEE' || vm.context === 'PRODUCTDETAIL' &&  vm.parentProductType === 'panacee')\" class=\"message message-warning\">{{productDiscount.remark}}</div> <div> <p ng-if=\"productDiscount.counterStatus === 'HI' && productDiscount.discountType === 'PRODUCTCOUNTER'\" class=\"message message-info\" translate>Available</p> <p ng-if=\"productDiscount.counterStatus === 'MED' && productDiscount.discountType === 'PRODUCTCOUNTER'\" class=\"message message-info\" translate>Limited stock!</p> <p ng-if=\"productDiscount.counterStatus === 'LOW' && productDiscount.discountType === 'PRODUCTCOUNTER'\" class=\"message message-warning\" translate>Running low on stock!</p> <p ng-if=\"productDiscount.counterStatus === 'VERYLOW' && productDiscount.discountType === 'PRODUCTCOUNTER'\" class=\"message message-warning\" translate>Only {{productDiscount.counter}} piece(s) left!</p> <div ng-if=productDiscount.retroactive class=type-xsmall translate>Retroactive discount</div> <p class=type-xsmall><span translate>Valid until</span> {{ productDiscount.endDate | date: 'dd/MM/yyyy' }}</p> <p ng-if=\"productDiscount.daysLeft < 30 && productDiscount.daysLeft > 1\" class=\"message message-warning message-expires\" translate>Expires within {{productDiscount.daysLeft}} days</p> <p ng-if=\"productDiscount.daysLeft === 0\" class=\"message message-warning message-expires\" translate>Discount expires today</p> <p ng-if=\"productDiscount.discountType === 'PANACEE' && vm.parentProductType !== 'panacee'\"> <a class=\"link link-primary type-small\" style=font-weight:700 ui-sref=\".products.product({ productId: productDiscount.discountProductId })\" ui-sref-opts=\"{relative: vm.parentState}\" translate>Order panaché</a> </p> <p ng-if=\"productDiscount.discountType === 'PROMOPACK'  && vm.parentProductType !== 'pack'\"> <a class=\"link link-primary type-small\" style=font-weight:700 ui-sref=\".products.product({ productId: productDiscount.discountProductId })\" ui-sref-opts=\"{relative: vm.parentState}\" translate>Order pack</a> </p> </div> </div> <div ng-if=\"productDiscount.discountType === 'ORDERTOTALPRICE'\" class={{vm.isTotalPriceDiscountId(productDiscount)}}> <div class=type-small><strong translate>Discount on order total</strong></div> <ul class=\"list product-discount-conditions\"> <li ng-repeat=\"range in productDiscount.discountRanges\"> <span class=lbl>{{ range.discount }}{{range.discountValueTypeSymbol}}</span> <span class=val>{{range.from ? range.from : range.amount | currency:'€':2 }}</span> </li> </ul> <div> <p class=type-xsmall><span translate>Valid until</span> {{ productDiscount.endDate | date: 'dd/MM/yyyy' }}</p> <p ng-if=\"productDiscount.daysLeft < 30 && productDiscount.daysLeft > 1\" class=\"message message-warning message-expires\" translate>Expires within {{productDiscount.daysLeft}} days</p> <p ng-if=\"productDiscount.daysLeft === 0\" class=\"message message-warning message-expires\" translate>Discount expires today</p> </div> </div> </div> </div> </div> <div class=product-discount-group ng-if=\"vm.portalContractTypeCode === 'AGIOS'\"> <h6><span class=discount-sticker-agios></span> Agios</h6> <div class=type-xsmall translate>The Agios discount is not known, contact the supplier for more info.</div> </div> </div> </div>";

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = "<div class=\"h6 filternav-count\"> <strong>{{vm.paging.totalItems}}</strong> <translate translate-n=vm.paging.totalItems translate-plural=products>product</translate> </div> <div class=filternav-folder-wrap> <a href=# class=\"btn btn-outline filternav-folder-filters\" ng-click=\"::vm.filternavFolder({folderClass: 'filternav-is-open'})\"><b translate>Filter</b><i class=\"ico ico-expand\"></i></a> <a href=# class=\"btn btn-outline filternav-folder-sorting\" ng-click=\"::vm.filternavFolder({folderClass: 'sorting-is-open'})\"><b translate>Sort</b><i class=\"ico ico-expand\"></i></a> </div> <div class=filternav> <div class=\"box box-2 filternav-box\" ng-repeat=\"category in vm.getFilterCategories()\"> <div class=box-hd fb-folder init-open=\"{{category.isCollapsed === false ? 'md-up' : 'false'}}\"> <h5>{{::category.name}}</h5> </div> <div class=box-bd> <fb-tree-view change-filters=::vm.onChangeFilters($event) category=::category items=::category.items is-link=::category.isLink level=1 limit=category.limit></fb-tree-view> <a class=link ng-show=\"category.items.length > category.initialLimit && category.limit !== 9999\" ng-click=\"vm.changeFilterCategoryLimit(category, 9999)\" href=# translate>Show all </a> <a class=link ng-show=\"category.items.length > category.initialLimit && category.limit === 9999\" ng-click=\"vm.changeFilterCategoryLimit(category, category.initialLimit)\" href=# translate>Show less </a> </div> </div> </div>";

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "<div class=product-image-container ng-if=::vm.addLink> <a ui-sref=\".products.product({ productId: vm.productId })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked()> <div class=product-image-outer> <img class=product-image ng-src=\"{{vm.image ? $root.getImage(vm.image, vm.imageSize): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', vm.imageSize);}}\" alt=\"{{vm.product.displayName}}\"/> </div> </a> <div class=\"discount-sticker-container discount-sticker-container-grid\" ng-click=vm.discountClicked() ng-if=\"vm.maxDiscount || vm.portalContractTypeCode === 'AGIOS'\"> <span class=discount-sticker ng-if=vm.maxDiscount> <span class=lbl-max translate>Max</span> <span class=lbl>{{::vm.maxDiscount}}%</span> </span> <span class=discount-sticker-agios ng-if=\"vm.portalContractTypeCode === 'AGIOS'\"></span> </div> </div> <div class=\"product-image-container has-no-link\" ng-if=::!vm.addLink> <div class=product-label ng-if=\"vm.counterStatus === 'HI'\" translate>Available</div> <div class=product-label ng-if=\"vm.counterStatus === 'MED'\" translate>Limited stock!</div> <div class=product-label ng-if=\"vm.counterStatus === 'LOW'\" translate>Running low on stock!</div> <div class=product-label ng-if=\"vm.counterStatus === 'VERYLOW'\" translate>Only {{vm.counter}} piece(s) left!</div> <div class=product-image-outer> <img fb-fancybox data-fancybox ng-attr-data-srcset=\"{{$root.getImage(vm.image, 'GalleryL');}} 1400w, {{$root.getImage(vm.image, 'GalleryM');}} 1000w, {{$root.getImage(vm.image, 'GalleryS');}} 600w\" ng-click=\"\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-href=\"{{$root.getImage(vm.image, 'GalleryS');}}\" ng-src=\"{{vm.image ? $root.getImage(vm.image, vm.imageSize): '';}}\" class=product-image /> </div> <div class=discount-sticker-container ng-if=\"vm.maxDiscount || vm.portalContractTypeCode === 'AGIOS'\"> <span class=discount-sticker ng-if=vm.maxDiscount> <span class=lbl-max translate>Max</span> <span class=lbl>{{::vm.maxDiscount}}%</span> </span> <span class=discount-sticker-agios ng-if=\"vm.portalContractTypeCode === 'AGIOS'\"></span> </div> </div>";

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "<div class=\"box box-2\" ng-if=::vm.text> <div class=box-hd fb-folder init-open=md-up> <h4>{{vm.title}}</h4> </div> <div class=box-bd> <div class=richtext-medipim> <span ng-bind-html=::vm.text></span> </div> </div> </div>";

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = "<div class=r> <div class=\"c w-xl-3-4\"> <div class=\"box box-1\"> <div class=box-hd fb-folder init-open=md-up> <h2 translate>Product information</h2> </div> <div class=box-bd> <div class=r ng-if=\"vm.product.certificates.length > 0\"> <div class=c> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Certificates</h4> </div> <div class=box-bd> <div class=box-bd> <div class=\"toolbar toolbar-top toolbar-search-reservation\"> <product-certificates-overview-search search-value=vm.searchValue search=vm.searchByBatchNumber($event)> </product-certificates-overview-search> </div> <table class=\"table table-block table-adapt\"> <thead class=hidden-sm-down> <tr> <th translate>Batch number</th> <th translate>Expiry date</th> <th translate> Document (pdf) </th> </tr> </thead> <tbody> <tr ng-repeat=\"certificate in vm.product.certificates | filter : vm.batchNumberSearch\"> <td> {{certificate.batchNumber}} </td> <td> {{certificate.expiryDate | date: 'dd-MM-yyyy'}} </td> <td> <a ng-if=!!certificate.filename target=_blank class=\"link link-primary\" href={{vm.getCoaUrl(certificate.id)}}> {{ certificate.filename }} </a> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <div class=r> <div class=\"c w-md-1-2\"> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>General</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=::vm.product.mediPimData.suppliers.length> <div class=lbl translate> Supplier </div> <div class=val> <ul class=list> <li ng-repeat=\"sup in ::vm.product.mediPimData.suppliers\"> {{sup}} </li> </ul> </div> </li> <li> <div class=lbl translate> Written request by patient </div> <div class=val> <span ng-if=vm.product.mediPimData.writtenRequestByPatient translate>true</span> <span ng-if=!vm.product.mediPimData.writtenRequestByPatient translate>false</span> </div> </li> <li ng-if=::vm.product.mediPimData.expires> <div class=lbl> <span translate>product.medipim.expires</span> </div> <div class=val> <span ng-if=vm.product.mediPimData.expires translate>true</span> <span ng-if=!vm.product.mediPimData.expires translate>false</span> </div> </li> <li ng-if=::vm.product.mediPimData.tradeInMonthsBeforeExpiry> <div class=lbl> <span translate>product.medipim.tradeInMonthsBeforeExpiry</span> </div> <div class=val> {{::vm.product.mediPimData.tradeInMonthsBeforeExpiry}} <translate translate-n=vm.product.mediPimData.tradeInMonthsBeforeExpiry translate-plural=Months>Month</translate> </div> </li> <li ng-if=::vm.product.mediPimData.tradeInMonthsAfterExpiry> <div class=lbl translate>product.medipim.tradeInMonthsAfterExpiry </div> <div class=val> {{::vm.product.mediPimData.tradeInMonthsAfterExpiry}} <translate translate-n=vm.product.mediPimData.tradeInMonthsAfterExpiry translate-plural=Months>Month</translate> </div> </li> <li ng-if=::vm.product.mediPimData.refundValueWithoutOmnio> <div class=lbl> <span translate>product.medipim.refundValueWithoutOmnio</span> </div> <div class=val> {{::vm.product.mediPimData.refundValueWithoutOmnio}} </div> </li> <li ng-if=::vm.product.mediPimData.refundValueWithOmnio> <div class=lbl> <span translate>product.medipim.refundValueWithOmnio</span> </div> <div class=val> {{::vm.product.mediPimData.refundValueWithOmnio}} </div> </li> </ul> </div> </div> <div class=\"box box-2\" ng-if=\"::vm.product.mediPimData.faggPublicNotice || vm.product.mediPimData.pharmaPublicNotice || vm.product.mediPimData.laboPublicNotice || vm.product.mediPimData.faggSpecialNotice || vm.product.mediPimData.pharmaSpecialNotice || vm.product.mediPimData.laboSpecialNotice\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate translate-comment=Bijsluiters> Notices </h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=\"::vm.product.mediPimData.faggPublicNotice || vm.product.mediPimData.pharmaPublicNotice || vm.product.mediPimData.laboPublicNotice\"> <div class=lbl translate translate-comment=Bijsluiters> Notices for patient </div> <div class=val> <ul class=list> <li ng-if=::vm.product.mediPimData.faggPublicNotice> <a href={{::vm.product.mediPimData.faggPublicNotice}} target=_blank class=\"link link-primary\">FAGG</a> </li> <li ng-if=::vm.product.mediPimData.pharmaPublicNotice> <a href={{::vm.product.mediPimData.pharmaPublicNotice}} target=_blank class=\"link link-primary\">Pharma.be</a> </li> <li ng-if=::vm.product.mediPimData.laboPublicNotice> <a href={{::vm.product.mediPimData.laboPublicNotice}} target=_blank class=\"link link-primary\">Labo</a> </li> </ul> </div> </li> <li ng-if=\"::vm.product.mediPimData.faggSpecialNotice || vm.product.mediPimData.pharmaSpecialNotice || vm.product.mediPimData.laboSpecialNotice\"> <div class=lbl translate translate-comment=Bijsluiters> Scientific notices </div> <div class=val> <ul class=list> <li ng-if=::vm.product.mediPimData.faggSpecialNotice> <a href={{::vm.product.mediPimData.faggSpecialNotice}} target=_blank class=\"link link-primary\">FAGG</a> </li> <li ng-if=::vm.product.mediPimData.pharmaSpecialNotice> <a href={{::vm.product.mediPimData.pharmaSpecialNotice}} target=_blank class=\"link link-primary\">Pharma.be</a> </li> <li ng-if=::vm.product.mediPimData.laboSpecialNotice> <a href={{::vm.product.mediPimData.laboSpecialNotice}} target=_blank class=\"link link-primary\">Labo</a> </li> </ul> </div> </li> </ul> </div> </div> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Price information</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl> <span translate>Pharmacy price</span> </div> <div class=val> {{ vm.product.price | currency:'€':2}} </div> </li> <li> <div class=lbl> <span translate>Public price</span> <sup>1</sup> </div> <div class=val> {{ vm.product.publicPrice | currency:'€':2}} </div> </li> <li> <div class=lbl translate>Tax</div> <div class=val> {{::vm.product.mediPimData.tax}}% </div> </li> </ul> <p class=\"text-muted type-small\"> <sup>1</sup> <span translate>Non-binding recommended prices</span> </p> </div> </div> <div class=\"box box-2\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Categorisation</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li> <div class=lbl translate> Prescription </div> <div class=val> {{::vm.product.mediPimData.prescription | yesNo}} </div> </li> <li ng-if=vm.product.mediPimData.brands.length> <div class=lbl translate>Brand</div> <div class=val> <ul class=list> <li ng-repeat=\"brand in vm.product.mediPimData.brands\"> <a claim-authorize=IsBuyer ui-sref=\"brand({id: brand.id})\" class=\"link link-primary\">{{::brand.displayName}}</a> <span claim-authorize=IsSeller>{{::brand.displayName}}</span> </li> </ul> </div> </li> <li ng-if=::vm.product.mediPimData.apbCategory> <div class=lbl translate> APB category </div> <div class=val> {{::vm.product.mediPimData.apbCategory}} </div> </li> <li ng-if=::vm.product.mediPimData.conservation> <div class=lbl> <span translate>Conservation</span> </div> <div class=val> {{::vm.product.mediPimData.conservation}} </div> </li> <li ng-repeat=\"attr in ::vm.product.mediPimData.attributes\"> <div class=lbl>{{attr.type}}</div> <div class=val>{{attr.name}}</div> </li> <li ng-if=::vm.product.mediPimData.activeIngredients> <div class=lbl translate> Active ingredients </div> <div class=val> <span ng-repeat=\"ingredient in ::vm.product.mediPimData.activeIngredients\"> {{ingredient.name}}{{ $last ? '' : ','}} </span> </div> </li> <li ng-if=vm.product.mediPimData.categories.length> <div class=lbl translate> Public categories </div> <div class=val> <ul class=list> <li ng-repeat=\"category in vm.product.mediPimData.categories\"> <ul class=\"list c-cat-tree\"> <li ng-style=vm.getMargin($index) ng-repeat=\"parent in category.parentCategories\"> <a ui-sref=\"general.products.category({categoryId: parent.id})\" class=\"link link-primary\" claim-authorize=IsBuyer> {{parent.name}} </a> <span claim-authorize=IsSeller>{{parent.name}}</span> </li> <li ng-style=vm.getMargin(category.parentCategories.length)> <a ui-sref=\"general.products.category({categoryId: category.id})\" class=\"link link-primary\" claim-authorize=IsBuyer> {{category.displayName}} </a> <span claim-authorize=IsSeller>{{category.displayName}}</span> </li> </ul> </li> </ul> </div> </li> </ul> </div> </div> <div class=\"box box-2\" ng-if=\"::vm.product.mediPimData.EAN.length || vm.product.mediPimData.ATC || vm.product.mediPimData.GTIN.length || vm.product.mediPimData.supplierReference || vm.product.mediPimData.ctiExtended || vm.product.mediPimData.UDI || vm.product.mediPimData.NUT\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Reference codes</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=::vm.product.mediPimData.EAN.length> <div class=lbl>EAN</div> <div class=val> <ul class=list> <li ng-repeat=\"ean in ::vm.product.mediPimData.EAN\"> {{ean}} </li> </ul> </div> </li> <li ng-if=::vm.product.mediPimData.ATC> <span class=lbl>ATC</span> <span class=val> <a target=_blank href=\"http://www.whocc.no/atc_ddd_index/?code={{::vm.product.mediPimData.ATC}}\" class=\"link link-primary\">{{::vm.product.mediPimData.ATC}}</a> </span> </li> <li ng-if=::vm.product.mediPimData.GTIN.length> <div class=lbl>GTIN</div> <div class=val> <ul class=list> <li ng-repeat=\"gtin in ::vm.product.mediPimData.GTIN\"> {{gtin}} </li> </ul> </div> </li> <li ng-if=::vm.product.mediPimData.supplierReference> <div class=lbl> <span translate>Supplier reference</span> </div> <div class=val> {{::vm.product.mediPimData.supplierReference}} </div> </li> <li ng-if=::vm.product.mediPimData.ctiExtended> <div class=lbl> <span translate>CTI extended</span> </div> <div class=val> {{::vm.product.mediPimData.ctiExtended}} </div> </li> <li ng-if=::vm.product.mediPimData.UDI> <span class=lbl>UDI</span> <span class=val> {{::vm.product.mediPimData.UDI}} </span> </li> <li ng-if=::vm.product.mediPimData.NUT> <span class=lbl>NUT</span> <span class=val>{{::vm.product.mediPimData.NUT}}</span> </li> </ul> </div> </div> <div class=\"box box-2\" ng-if=\"::vm.product.mediPimData.weight || vm.product.mediPimData.width || vm.product.mediPimData.height || vm.product.mediPimData.depth || vm.product.mediPimData.packageQuantity\"> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Dimensions</h4> </div> <div class=box-bd> <ul class=\"list list-values\"> <li ng-if=::vm.product.mediPimData.packageQuantity> <span class=lbl translate>Package quantity</span> <span class=val>{{::vm.product.mediPimData.packageQuantity}}</span> </li> <li ng-if=::vm.product.mediPimData.weight> <span class=lbl translate>Weight</span> <span class=val>{{::vm.product.mediPimData.weight}}gr.</span> </li> <li ng-if=::vm.product.mediPimData.width> <span class=lbl translate>Width</span> <span class=val>{{::vm.product.mediPimData.width}}mm</span> </li> <li ng-if=::vm.product.mediPimData.height> <span class=lbl translate>Height</span> <span class=val>{{::vm.product.mediPimData.height}}mm</span> </li> <li ng-if=::vm.product.mediPimData.depth> <span class=lbl translate>Depth</span> <span class=val>{{::vm.product.mediPimData.depth}}mm</span> </li> </ul> </div> </div> </div> <div class=\"c w-md-1-2\"> <div class=\"box box-2\" ng-if=::vm.product.mediPimData.fullDescription> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Description</h4> </div> <div class=box-bd> <div class=richtext> <div ng-bind-html=::vm.product.mediPimData.fullDescription></div> </div> </div> </div> <div class=\"box box-2\" ng-if=::vm.product.mediPimData.media> <div class=box-hd fb-folder init-open=md-up> <h4 translate>Media</h4> </div> <div class=box-bd> <ul class=\"list list-unstyled list-spaced-2\"> <li ng-repeat=\"media in vm.product.mediPimData.media\"> <div ng-switch on=media.type> <div ng-switch-when=app> <div class=box-bd> <div class=media> <div class=media-body> <div class=type-bold> {{media.name}} </div> <div class=type-xsmall-uppercase> {{media.type}} </div> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.link}}</a> <div class=type-small> {{media.description}} </div> </div> </div> </div> </div> <div ng-switch-when=brochure> <div class=box-bd> <div class=media> <div class=media-body> <div class=type-bold> {{media.name}} </div> <div class=type-xsmall-uppercase> {{media.type}} </div> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.name}} {{media.language.code}}.pdf</a> <div class=type-small> {{media.description}} </div> </div> </div> </div> </div> <div ng-switch-when=video> <div class=box-bd> <div class=type-bold> {{media.name}} </div> <div class=type-xsmall-uppercase> {{media.type}} </div> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.link}}</a> <p class=type-small> {{media.description}} </p> <div class=\"embed embed-ratio-3-2\"> <youtube-video video-url=media.link></youtube-video> </div> </div> </div> <div ng-switch-when=website> <div class=box-bd> <div class=media> <div class=media-body> <div class=type-bold> {{media.name}} </div> <div class=type-xsmall-uppercase> {{media.type}} </div> <a href={{media.link}} target=_blank class=\"link link-primary\">{{media.link}}</a> <div class=type-small> {{media.description}} </div> </div> </div> </div> </div> </div> </li> </ul> </div> </div> <product-info-box title=\"{{'Properties' | translate}}\" text=::vm.product.mediPimData.properties></product-info-box> <product-info-box title=\"{{'Indication' | translate}}\" text=::vm.product.mediPimData.indication></product-info-box> <product-info-box title=\"{{'Contra indication' | translate}}\" text=::vm.product.mediPimData.contraIndication></product-info-box> <product-info-box title=\"{{'Composition' | translate}}\" text=::vm.product.mediPimData.composition></product-info-box> <product-info-box title=\"{{'Usage' | translate}}\" text=::vm.product.mediPimData.usage></product-info-box> <product-info-box title=\"{{'Side effects' | translate}}\" text=::vm.product.mediPimData.sideEffects></product-info-box> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "<div class=product-grid-item ng-class=\"{'is-sold-out': vm.product.tooLate}\"> <div style=position:relative> <product-img product-id=::vm.product.id image=::vm.product.image image-size=Product portal-contract-type-code=vm.product.portalContractTypeCode counter-status=vm.product.counterStatus counter=vm.product.counter discount=::vm.product.discount message=::vm.product.message view-mode=::vm.viewMode parent-state=::vm.parentState max-discount=::vm.product.maxDiscount discount-clicked=vm.toggleProductDiscounts() product-clicked=vm.productClicked() add-link=true></product-img> <div ng-class=\"'product-label'\" ng-if=\"vm.product.counterStatus === 'HI'\" translate>Available</div> <div ng-class=\"'product-label'\" ng-if=\"vm.product.counterStatus === 'MED'\" translate>Limited stock!</div> <div ng-class=\"'product-label'\" ng-if=\"vm.product.counterStatus === 'LOW'\" translate>Running low on stock!</div> <div ng-class=\"'product-label'\" ng-if=\"vm.product.counterStatus === 'VERYLOW'\" translate>Only {{vm.counter}} piece(s) left!</div> <div class=product-label-sold-out translate>Sold out!</div> </div> <div class=product-grid-item-content> <div class=type-xsmall-uppercase> <span ng-if=\"::vm.product.productTypeCode !== 'pack' && vm.product.productTypeCode !== 'panacee'\">{{::vm.product.nationalNumber}}</span> <span ng-if=\"::vm.product.productTypeCode === 'pack'\" translate>Promopack</span> <span ng-if=\"::vm.product.productTypeCode === 'panacee'\" translate>Panaché</span> </div> <div class=product-grid-item-name> <a class=link ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked()>{{ ::vm.product.displayName }}</a> </div> <div class=clearfix ng-if=\"vm.product.productTypeCode !== 'panacee'\"> <div class=product-grid-item-price ng-if=!vm.product.discountPct> {{ ::vm.product.price | currency:'€':2 }} </div> <div class=product-grid-item-price ng-if=vm.product.discountPct> {{ ::vm.getDiscountPrice()| currency:'€':4 }} <strike class=\"text-muted type-xsmall\"> {{ ::vm.product.price | currency:'€':2 }}</strike> </div> <div class=product-grid-item-quantity> <div ng-if=\"vm.product.isSellableInStore && vm.context !== 'PACK' && vm.product.price !== 0\" class=input-group> <input class=input claim-authorize=IsBuyer ng-change=vm.onChangeQuantity() ng-model=vm.product.quantity ng-readonly=\"vm.context === 'PACK'\" type=number min=0 max=\"{{vm.product.isVipSeller ? 999 : 10000}}\" step=1 /> </div> <div class=\"input-static align-right w-1-1\" ng-if=\"vm.context === 'PACK'\">{{ ::vm.product.quantity }} x</div> <div ng-if=\"!vm.product.isSellableInStore || (vm.product.price === 0 && vm.product.productTypeCode !== 'RENTAL'  && vm.product.productTypeCode !== 'panacee')\" class=product-grid-item-not-available translate>Not available</div> </div> </div> <div class=clearfix ng-if=\"vm.product.productTypeCode === 'panacee'\"> <a ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked() class=\"right btn btn-outline\" translate translate-context=noun>Order</a> </div> <div class=clearfix> <div class=product-grid-item-gpm ng-if=\"vm.product.productTypeCode !== 'panacee'  && vm.product.price\"> <abbr class=type-xsmall-uppercase title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr>{{(vm.product.grossProfit | number: 0 ) + '%'}} <strike class=\"text-muted type-xsmall\" ng-if=vm.product.discountPct>{{ (vm.getGrossProfit() | number:0) + '%'}}</strike> </div> <div class=product-grid-item-discount> <span class=type-xsmall-uppercase ng-if=\"vm.product.discountPct>0\"><span class=lbl translate>Current discount</span></span> <span class=discount-sticker-current-container ng-if=vm.product.discountPct ng-click=vm.toggleProductDiscounts()> <span class=discount-sticker-current><span class=lbl>{{vm.product.discountPct + '%'}}</span></span> <span class=\"text-info block\" ng-if=vm.product.totalDiscount>{{vm.product.totalDiscount | currency:'€':2}}</span> </span> </div> </div> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> </div> <product-discounts ng-if=vm.productDiscountsOpen class=product-discount-container-in-grid close=vm.closeProductDiscounts() context=vm.context counter-status=vm.product.counterStatus portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading active-discounts=vm.product.activeDiscountIds total-price-discount-ids=vm.product.totalPriceDiscountIds parent-state=vm.parentState product-discounts=vm.productDiscounts></product-discounts>";

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "<div class=product-grid ng-if=!vm.errorOccurred> <div class=\"r r-sm-2-col r-md-3-col r-lg-3-col r-xl-3-col r-xx-4-col\"> <div ng-repeat=\"product in vm.products | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" class=c> <product-overview-grid-item ng-if=\"product.productTypeCode !== 'RENTAL'\" get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.onChangeQuantity() class=c ng-class=\"{'is-sold-out': product.tooLate}\" product=product is-last=$last context=vm.context parent-state=vm.parentState></product-overview-grid-item> <rent-product-overview-grid-item ng-if=\"product.productTypeCode === 'RENTAL'\" class=c product=product index=index></rent-product-overview-grid-item> </div> </div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-list-item product-list-item-{{::vm.product.type}}\"> <div class=\"table-c table-c-cnk\"> <span ng-if=\"vm.product.productTypeCode !== 'pack' && vm.product.productTypeCode !== 'panacee'\">{{vm.product.nationalNumber}}</span> <span ng-if=\"vm.product.productTypeCode === 'pack'\" translate>Promopack</span> <span ng-if=\"vm.product.productTypeCode === 'panacee'\" translate>Panaché</span> </div> <div class=\"table-c table-c-name\"> <a class=link ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState.name}\" ng-click=vm.productClicked() ng-bind=vm.product.displayName></a> <span class=discount-sticker-agios ng-if=\"::vm.product.portalContractTypeCode === 'AGIOS'\" ng-click=vm.toggleProductDiscounts()></span> <div ng-if=\"vm.product.allowSpecial && vm.isFebelcoCustomer()\"><a ui-sref=\"help({questionCode:'specialorderabout'})\" class=product-message><span class=link-light translate>Special order possible</span><i class=\"ico ico-alert-question\"></i></a></div> </div> <div class=\"table-c table-c-price\" ng-class=\"{'hidden-sm-down': vm.product.price === null}\"> <span class=table-lbl translate>Price</span> <span class=table-val> <span class=text-muted ng-if=\"vm.product.price === null\">&ndash;</span> <span ng-if=!vm.product.discountPct ng-bind=\"vm.product.price | currency:'€':2\"></span> <span ng-if=\"vm.product.discountPct > 0\"> {{::vm.getDiscountPrice() | currency:'€':2}} <strike class=\"text-muted type-xsmall\" ng-bind=\"vm.product.price | currency:'€':2\"></strike> </span> </span> </div> <div class=\"table-c table-c-gpm\" ng-class=\"{'hidden-sm-down': vm.product.grossProfit === '0'}\"> <abbr class=table-lbl title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr> <span class=table-val> <span class=text-muted ng-if=\"vm.product.grossProfit === '0'\">&ndash;</span> <span ng-if=\"vm.product.grossProfit !== '0'\" ng-bind=\"(vm.product.grossProfit | number:0) + '%' \"></span> <strike class=\"text-muted type-xsmall\" ng-if=vm.product.discountPct> {{(vm.getGrossProfit() | number: 0) + '%'}} </strike> <div ng-show=\"vm.product.grossProfitAmount !== 0\">{{vm.product.grossProfitAmount | currency:\"€\":2}}</div> </span> </div> <div class=\"table-c table-c-max-discount\" ng-class=\"{'hidden-sm-down': !vm.product.maxDiscount && !vm.product.portalContractTypeCode === 'AGIOS'}\"> <span class=table-lbl translate ng-if=\"::vm.product.maxDiscount || vm.product.portalContractTypeCode === 'AGIOS'\">Max. discount</span> <span class=table-val> <span class=text-muted ng-if=\"!vm.product.maxDiscount && !vm.product.portalContractTypeCode === 'AGIOS'\">&ndash;</span> <span class=discount-sticker-container ng-if=::vm.product.maxDiscount ng-click=vm.toggleProductDiscounts()> <span ng-if=::vm.product.maxDiscount class=discount-sticker><span class=lbl ng-bind=\"::vm.product.maxDiscount + '%'\"></span></span> </span> </span> </div> <div class=\"table-c table-c-discount\" ng-class=\"{'hidden-sm-down': !vm.product.discountPct}\"> <span class=table-lbl translate>Current discount</span> <span class=table-val> <span class=text-muted ng-if=!vm.product.discountPct>&ndash;</span> <span class=discount-sticker-current-container ng-click=vm.toggleProductDiscounts() ng-if=vm.product.discountPct> <span class=discount-sticker-current><span class=lbl ng-bind=\"vm.product.discountPct + '%'\"></span></span> <span class=text-info ng-if=vm.product.totalDiscount ng-bind=\"vm.product.totalDiscount  | currency:'€':2\"></span> </span> </span> </div> <div class=\"table-c table-c-quantity\"> <div ng-if=vm.product.isSellableInStore> <div class=input-group ng-if=\"vm.product.productTypeCode !== 'panacee' && vm.context !== 'PACK' && vm.product.productTypeCode !== 'RENTAL' && vm.context !== 'partnership' && vm.product.price !== 0\"> <input class=input claim-authorize=IsBuyer ng-change=vm.changeQuantity(vm.product) ng-model=vm.product.quantity ng-readonly=\"vm.context === 'PACK'\" type=number min=0 max=\"{{vm.product.isVipSeller ? 999 : 10000}}\" step=1 /> </div> <div class=input-static ng-if=\"vm.product.productTypeCode !== 'panacee' && vm.context === 'PACK'\" ng-bind=\"vm.product.quantity + ' x'\"></div> <div ng-if=\"vm.product.productTypeCode === 'panacee'\"> <a ui-sref=\".products.product({ productId: vm.product.id })\" ui-sref-opts=\"{relative: vm.parentState}\" ng-click=vm.productClicked() class=\"btn btn-outline\" translate translate-context=verb>Order</a> </div> <div ng-if=\"vm.product.productTypeCode === 'RENTAL' && vm.product.isSellable\"> <a claim-authorize=IsBuyer ui-sref=\"rentalCheckout({ productId: vm.product.id, sellerId: vm.product.sellerId })\" class=\"btn btn-secondary\" style=min-width:88px translate translate-context=Verb>Rent</a> </div> </div> <div ng-if=\"!vm.product.isSellableInStore || (vm.product.price === 0 && vm.product.productTypeCode !== 'RENTAL'  && vm.product.productTypeCode !== 'panacee')\" class=\"inline-block type-xsmall text-muted\" translate>Not available</div> <div class=product-label-sold-out translate>Sold out!</div> </div> </div> <product-discounts ng-if=vm.productDiscountsOpen class=product-discount-container-in-list close=vm.closeProductDiscounts() context=vm.context counter-status=vm.product.counterStatus portal-contract-type-code=vm.product.portalContractTypeCode is-loading=vm.productDiscountsLoading active-discounts=vm.product.activeDiscountIds total-price-discount-ids=vm.product.totalPriceDiscountIds parent-state=vm.parentState product-discounts=vm.productDiscounts></product-discounts>";

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "<div class=product-list ng-if=!vm.errorOccurred> <div class=table-fake> <div class=table-hd> <div class=table-r> <div ng-click=orderProducts() class=\"table-c table-c-cnk\" translate>Product number</div> <div class=\"table-c table-c-name\" translate>Name</div> <div class=\"table-c table-c-price\" translate>Price</div> <div class=\"table-c table-c-gpm\"><abbr title=\"{{'Gross profit margin' | translate }}\" translate>GPM</abbr></div> <div class=\"table-c table-c-max-discount\" translate>Max. discount</div> <div class=\"table-c table-c-discount\" translate ng-if=\"vm.context !== 'partnership'\">Current discount</div> <div class=\"table-c table-c-quantity\" translate ng-if=\"vm.context !== 'partnership'\">Quantity</div> </div> </div> <div class=table-bd> <product-overview-list-item get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.changeQuantity($event) class=table-r ng-class=\"{'is-sold-out': product.tooLate}\" ng-repeat=\"product in vm.products | orderBy:vm.orderByProperty:vm.isOrderByDescending | filter:vm.searchText\" product=product is-last=$last context=vm.context parent-state=vm.parentState></product-overview-list-item> </div> </div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "<div class=\"toolbar toolbar-{{::vm.placement}} toolbar-product-overview\"> <div class=toolbar-extra ng-if=::vm.sorting.enableSorting> <div class=toolbar-sort> <span class=type-h5><translate>Sort by</translate>:&nbsp;</span> <ul class=list> <li ng-repeat=\"prop in vm.sorting.properties\"> <a href=# class=sort ng-class=\"{'active': vm.sorting.sortProperty == prop.value, 'sort-asc': vm.sorting.sortAsc, 'sort-desc': !vm.sorting.sortAsc}\" ng-click=\"vm.changeSorting({sortProperty: prop})\"> <b>{{ prop.displayname | translate }}</b><i class=ico></i> </a> </li> </ul> </div> <div class=toolbar-view-mode> <a href=# class=link-btn ng-class=\"{'active': vm.viewMode == 'grid'}\" ng-click=\"vm.changeViewMode({viewMode: 'grid'})\" data-viewmode=grid> <b translate>Show in grid</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-grid\"></i></span> </a> <a href=# class=link-btn ng-class=\"{'active': vm.viewMode == 'list'}\" ng-click=\"vm.changeViewMode({viewMode: 'list'})\" data-viewmode=list> <b translate>Show in list</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-list\"></i></span> </a> </div> </div> <div class=\"type-h5 toolbar-count\"> <strong>{{vm.paging.totalItems}}</strong> <translate translate-n=vm.paging.totalItems translate-plural=products>product</translate> </div> <div class=toolbar-nr-to-display> <select class=select ng-options=\"pagecount for pagecount in vm.pagecountList\" ng-model=vm.paging.itemsPerPage ng-change=\"vm.changeItemsPerPage({itemsPerPage: vm.paging.itemsPerPage})\"></select> <label translate>per page</label> </div> <pager paging=vm.paging go-to-page=\"vm.goToPage({page: page})\"></pager> </div>";

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=vm.model.errorOccurred translate>Product overview cannot be shown</div> <div ng-if=\"vm.model.isLoadingInitial && !vm.model.errorOccurred\" class=loading></div> <div ng-if=\"!vm.model.isLoadingInitial && !vm.model.errorOccurred\"> <div ng-if=!vm.model.productsAvailableForContext>{{vm.noItemsMessage}}</div> <div class=\"r layout-aside-left {{vm.filternavFolderClass}}\" ng-if=vm.model.productsAvailableForContext fb-enter-pressed=vm.updateQuantity()> <div class=\"c layout-aside\"> <product-filters filter=vm.model.filter paging=vm.model.paging change-filters=\"vm.changeFilters(filter, category)\" link-clicked=vm.linkClicked() filternav-folder=vm.filternavFolder(folderClass)> </product-filters> </div> <div class=\"c layout-main\"> <div ng-if=vm.model.isLoading class=\"loading loading-block\"></div> <div ng-if=!vm.model.isLoading class=category-products> <product-overview-toolbar placement=top paging=vm.model.paging sorting=vm.model.sorting view-mode=vm.viewMode change-items-per-page=vm.changeItemsPerPage(itemsPerPage) go-to-page=vm.goToPage(page) change-sorting=vm.changeSorting(sortProperty) change-view-mode=vm.changeViewMode(viewMode)> </product-overview-toolbar> <selected-filters selected-filters=vm.model.filter.selectedFilters clear-filter=\"vm.clearFilter(filter, category)\" clear-filters=vm.clearFilters()> </selected-filters> <form name=forms.productOverviewForm fb-on-close-action=vm.updateQuantity() fb-prevent-navigation=true> <product-overview-grid get-product-discounts=vm.getProductDiscounts(product) on-change-quantity=vm.onChangeQuantity($event) context=vm.context products=vm.model.products ng-show=\"vm.viewMode === 'grid'\" parent-state=vm.parentState></product-overview-grid> <product-overview-list get-product-discounts=vm.getProductDiscounts(product) on-change-quantity=vm.onChangeQuantity($event) context=vm.context products=vm.model.products ng-show=\"vm.viewMode === 'list'\" parent-state=vm.parentState></product-overview-list> </form> <add-products-toolbar products-added=vm.productsAdded is-open=vm.isOpen adding-products=vm.addingProducts products-quantity-changed=vm.productsQuantityChanged has-error=vm.hasError add-to-cart=vm.updateQuantity()> </add-products-toolbar> <div ng-if=!vm.model.productsAvailableForCriteria><p translate>Unfortunately there are no products available for the current criteria.</p></div> <product-overview-toolbar placement=bottom paging=vm.model.paging change-items-per-page=vm.changeItemsPerPage(itemsPerPage) go-to-page=vm.goToPage(page)> </product-overview-toolbar> </div> </div> </div> </div>";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "<div class=product-related ng-if=\"::(vm.product.other_discounts.length > 0)\"> <div class=product-related-title translate>Other offers with this product</div> <ul class=\"list product-related-list\"> <li ng-repeat=\"d in ::vm.product.other_discounts\" class=\"product-type-{{::d.discountType}}\"> <a ui-sref=\"^.product({ productId: d.productId })\"> <span class=product-related-amount><span ng-if=\"::(d.numberOfRanges > 1)\" translate>Up to</span> {{::d.maxDiscount}}{{::d.symbol}}</span> <span class=product-related-description>{{::d.name}}</span> </a> </li> </ul> </div>";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "<div class=filternav-selection ng-if=\"vm.selectedFilters && vm.selectedFilters.length\"> <div class=\"type-h5 filternav-selection-title\" translate>Current filters</div> <div class=filternav-selection-list ng-repeat=\"category in vm.selectedFilters\"> <a class=filternav-selection-item ng-repeat=\"item in category.items\" ng-click=\"vm.clearFilter({'filter': item, 'category': category})\" title=\"{{'Delete' | translate}}\" href=\"\"> <span class=lbl>{{::category.name}}:</span> <span class=val>{{::item.name}}</span> </a> </div> <a class=\"link-btn filternav-selection-clear-all\" ng-click=vm.clearFilters() role=button><b translate>Clear all filters</b><span class=\"btn btn-tile btn-outline\"><i class=\"ico ico-remove\"></i></span></a> </div>";

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "<p class=type-xsmall-uppercase translate>Febelco stock info</p> <p><button type=button class=\"btn btn-outline\" ng-click=vm.checkStock() ng-if=!vm.stockOverview.isLoading translate>Check stock</button></p> <p class=loading-message ng-if=vm.stockOverview.isLoading> <span class=loading></span> <span class=lbl translate>Checking stock...</span> </p> <div class=\"box type-small\" ng-if=\"!vm.stockOverview.isLoading && vm.stockOverview.hasloaded\"> <div ng-if=\"vm.stockOverview.stock.deliverCode === null\"> <p class=\"message message-error\" translate>Stock response cannot be checked at the moment.</p> </div> <div ng-if=\"vm.stockOverview.stock.deliverCode !== null\"> <div ng-switch on=::vm.stockOverview.stock.deliverCode> <div ng-switch-when=1> <div ng-switch on=::vm.stockOverview.stock.stockCode> <div ng-switch-when=01> <p ng-if=!vm.stockOverview.stock.remark class=\"message message-success\"> {{'Product available' | translate}} <span ng-if=\"::vm.stockOverview.stock.deliveryDate !== null\"> {{'can be delivered on' | translate }} {{vm.stockOverview.stock.deliveryDate}} <translate translate-context=\"delivered on april 14th AT 17:25\">at</translate> {{vm.stockOverview.stock.deliveryTime}} - {{'tour' | translate }} {{vm.stockOverview.stock.deliveryId}} </span> </p> <p ng-if=vm.stockOverview.stock.remark class=\"message message-success\">{{ vm.stockOverview.stock.remark }}</p> </div> <div ng-switch-when=02> <p> {{vm.stockOverview.stock.deliverQty}} {{'products available' | translate}}<br/> <span ng-if=\"::vm.stockOverview.stock.deliveryDate !== null\"> {{'can be delivered on' | translate }} {{vm.stockOverview.stock.deliveryDate}} <span ng-if=\"::vm.stockOverview.stock.deliveryTime !== null\"> <translate translate-context=\"delivered on april 14th AT 17:25\">at</translate> {{vm.stockOverview.stock.deliveryTime}} </span> </span> </p> </div> </div> </div> <div ng-switch-when=2> <p> {{vm.stockOverview.stock.deliverQty}} {{'products available' | translate}} {{'via another warehouse' | translate}}<br/> {{'can be delivered on' | translate }} {{vm.stockOverview.stock.deliveryDate}} <translate translate-context=\"delivered on april 14th AT 17:25\">at</translate> {{vm.stockOverview.stock.deliveryTime}} </p> </div> <div ng-switch-when=3> <p class=\"message message-warning\"> {{'Replacement product available' | translate}}: Product number {{ vm.stockOverview.stock.replacingCnk }} </p> </div> <div ng-switch-when=4> <p class=\"message message-warning\"> {{'Replacement product available' | translate}}: Product number {{ vm.stockOverview.stock.replacingCnk }} </p> </div> <div ng-switch-when=0> <div ng-switch on=::vm.stockOverview.stock.stockCode> <div ng-switch-when=90> <p class=\"message message-error\" translate>No stock available</p> </div> <div ng-switch-when=91> <p class=\"message message-error\" translate>Supplier has no stock available</p> </div> <div ng-switch-when=92> <p class=\"message message-error\" translate>Withdrawn product</p> </div> <div ng-switch-when=93> <p class=\"message message-error\" translate>No stock available</p> </div> <div ng-switch-when=94> <p class=\"message message-error\" translate>Supplier has no stock available</p> </div> <div ng-switch-when=95> <p class=\"message message-error\" translate>Maximum quantity exceeded.</p> </div> <div ng-switch-when=96> <p>{{vm.stockOverview.stock.remark}}</p> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb ng-if=vm.isFebelcoCustomer()></div> <nav class=breadcrumb ng-if=!vm.isFebelcoCustomer()> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <b class=breadcrumb-item>{{::vm.product.displayName}}</b> </div> </nav> <h1>{{ vm.product.displayName }} <span ng-if=::vm.product.nationalNumber> &ndash; </span> {{::vm.product.nationalNumber}}</h1> <form name=forms.productOverviewForm fb-on-close-action=vm.addToCart() fb-prevent-navigation=true> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4\"> <div class=\"product-detail {{ ::vm.product.discount ? ' product-type-'+vm.product.type : ''}}\"> <div class=r> <div class=\"c w-sm-5-12 w-md-1-2 w-lg-1-2 w-xl-1-3\"> <div class=product-detail-images> <product-img product-id=::vm.product.id image=vm.mainImage image-size=Product portal-contract-type-code=vm.product.portalContractTypeCode counter-status=vm.product.counterStatus counter=vm.product.counter discount=::vm.product.discount message=::vm.product.message parent-state=::vm.parentState max-discount=::vm.product.maxDiscount add-link=false> </product-img> <ul class=list> <li ng-repeat=\"item in vm.product.mediPimData.images\"> <img fb-fancybox data-fancybox=item ng-attr-data-srcset=\"{{::$root.getImage(item.relativeFilePath, 'GalleryL');}} 1400w, {{::$root.getImage(item.relativeFilePath, 'GalleryM');}} 1000w, {{::$root.getImage(item.relativeFilePath, 'GalleryS');}} 600w\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-click=\"\" ng-href=\"{{$root.getImage(item.relativeFilePath, 'GalleryS');}}\" ng-src=\"{{$root.getImage(item.relativeFilePath, 'ProductThumb');}}\"/> </li> </ul> </div> </div> <div class=\"c w-sm-7-12 w-md-1-2 w-lg-1-2 w-xl-1-3\"> <product-detail-content add-to-cart=vm.addToCart() on-change=vm.updateTotals(vm.product) product=vm.product parent-state=vm.parentState></product-detail-content> <br/> </div> <div class=\"c w-md-1-2 w-lg-1-1 w-xl-1-3\"> <div claim-authorize=IsBuyer> <stock-response ng-if=\"vm.isFebelcoCustomer() && vm.product.type === 'single' && vm.product.productSourceCode === 'FEB'\" stock-overview=vm.stockOverview product=vm.product ng-if=\"::vm.product.type === 'single'\" check-stock=vm.checkStock()></stock-response> </div> <div ng-if=vm.mediPimData.brands.length> <div class=type-xsmall-uppercase translate>Brand</div> <ul class=\"list list-comma\"> <li ng-repeat=\"brand in vm.mediPimData.brands\"><a ui-sref=\"brand({id: brand.id})\" class=\"link link-primary\">{{::brand.displayName}}</a></li> </ul> </div> <div ng-if=vm.mediPimData.categories.length> <div class=type-xsmall-uppercase translate>Categories</div> <ul class=\"list list-comma\"> <li ng-repeat=\"category in vm.mediPimData.categories\"><a ui-sref=\"general.products.category({categoryId: category.id})\" class=\"link link-primary\">{{category.displayName}}</a></li> </ul> </div> </div> </div> </div> </div> <div class=\"c w-md-1-2 w-lg-1-3 w-xl-1-4\"> <news-aside ng-if=vm.topNewsitems.length parent-state=::vm.parentState top-newsitems=vm.topNewsitems class=product-detail-news></news-aside> </div> </div> <div class=r> <div class=\"c w-xx-3-4\"> <included-products-in-pack product=vm.product ng-if=\"::vm.product.type === 'pack'\" parent-state=::vm.parentState quantity-changed=vm.updateTotals(product) context=\"'PACK'\"></included-products-in-pack> <included-products-in-panacee product=vm.product ng-if=\"::vm.product.type === 'panacee'\" parent-state=::vm.parentState quantity-changed=vm.updateTotals(product) context=\"'PANACEE'\"></included-products-in-panacee> <add-products-toolbar products-added=vm.productsAdded is-open=vm.isOpen product=vm.product adding-products=vm.addingProducts products-quantity-changed=vm.productsQuantityChanged has-error=vm.hasError add-to-cart=vm.addToCart()> </add-products-toolbar> </div> </div> </form> <product-info product=::vm.product ng-if=\"::vm.product.type === 'single'\"></product-info>";

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=\".product({productId: vm.product.id})\">{{::vm.product.name}}</a> <b class=breadcrumb-item>News</b> </div> </nav> <h1>{{'News' | translate }} {{::vm.product.name}}</h1> <news-overview model=vm.newsOverviewModel view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "<div class=product-image-container ng-if=::vm.addLink> <a ng-if=\"vm.productType  === 'RENTAL'\" ui-sref=\"seller.rentProductDetail({ productId: vm.productId, sellerId: vm.sellerId })\" ng-click=vm.productClicked()> <div class=product-image-outer> <img class=product-image ng-src=\"{{vm.image ? $root.getImage(vm.image, vm.imageSize): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', vm.imageSize);}}\" alt=\"{{vm.product.displayName}}\"/> </div> </a> <a ng-if=\"vm.productType  !== 'RENTAL'\" ui-sref=\"^.products.product({ productId: vm.productId })\" ng-click=vm.productClicked()> <div class=product-image-outer> <img class=product-image ng-src=\"{{vm.image ? $root.getImage(vm.image, vm.imageSize): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', vm.imageSize);}}\" alt=\"{{vm.product.displayName}}\"/> </div> </a> </div> <div class=product-image-container ng-if=::!vm.addLink> <div class=product-image-outer> <img fb-fancybox data-fancybox ng-attr-data-srcset=\"{{$root.getImage(vm.image, 'GalleryL');}} 1400w, {{$root.getImage(vm.image, 'GalleryM');}} 1000w, {{$root.getImage(vm.image, 'GalleryS');}} 600w\" ng-click=\"\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-href=\"{{$root.getImage(vm.image, 'GalleryS');}}\" ng-src=\"{{vm.image ? $root.getImage(vm.image, vm.imageSize): '';}}\" class=product-image /> </div> </div>";

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = "<div class=\"product-grid-item product-grid-item-tgz\"> <div class=product-grid-item-image style=position:relative> <rent-product-img product-type=::vm.product.productTypeCode product-id=::vm.product.id image=::vm.product.imagePath image-size=Product seller-id=::vm.product.sellerId product-clicked=vm.productClicked() add-link=true> </rent-product-img> </div> <div class=product-grid-item-content> <div class=type-xsmall-uppercase> <span>{{::vm.product.nationalNumber}}</span> </div> <div class=product-grid-item-name> <a ng-if=\"::vm.product.productTypeCode === 'RENTAL'\" class=link ui-sref=\"seller.rentProductDetail({ productId: vm.product.id, sellerId: vm.product.sellerId })\" ng-click=vm.productClicked()>{{ ::vm.product.displayName }}</a> <a ng-if=\"::vm.product.productTypeCode !== 'RENTAL'\" class=link ui-sref=\"^.products.product({ productId: vm.product.id })\" ng-click=vm.productClicked()>{{ ::vm.product.displayName }}</a> </div> <div ng-if=\"::vm.product.productTypeCode === 'RENTAL'\" class=d-flex> <div class=\"product-grid-item-price text-secondary type-small\"> <div>{{ 'Rent per day' | translate }}: <strong>{{ ::vm.product.dayPrice | currency:'€':2 }}</strong></div> <div>{{ 'Deposit' | translate }}: <strong>{{ ::vm.product.rentalDeposit | currency:'€':2 }}</strong></div> <div>{{ 'VAT' | translate }}: <strong>{{ ::vm.product.vat}}%</strong></div> </div> <div claim-authorize=IsBuyer> <a ng-if=vm.product.isSellable ui-sref=\"rentalCheckout({ productId: vm.product.id, sellerId: vm.product.sellerId })\" class=\"right btn btn-secondary\" style=min-width:120px translate translate-context=Verb>Rent</a> </div> </div> <div ng-if=\"::vm.product.productTypeCode === 'PORTALPRODUCT'\" class=d-flex> <div class=\"product-grid-item-price text-secondary type-small\"> <div>{{ 'Price' | translate }}: <strong>{{ ::vm.product.pharmacyPrice | currency:'€':2 }}</strong></div> <div>{{ 'VAT' | translate }}: <strong>{{ ::vm.product.vat}}%</strong></div> </div> <div claim-authorize=IsBuyer> <a ui-sref=\"^.products.product({ productId: vm.product.id })\" class=\"right btn btn-tile btn-primary\" style=min-width:120px translate>Buy</a> </div> </div> </div> </div>";

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = "<div class=product-grid ng-class=\"{'product-grid-related': vm.mode === 'related'}\" ng-if=!vm.errorOccurred> <div class=r ng-class=\"{'r-md-3-col r-lg-4-col r-xl-4-col r-xx-5-col': vm.mode === 'overview'}\"> <rent-product-overview-grid-item class=c ng-repeat=\"product in vm.products | orderBy:vm.orderByProperty:vm.isOrderByDescending\" product=product> </rent-product-overview-grid-item> </div> </div> <div ng-if=vm.errorOccurred translate>Product overview cannot be shown</div>";

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "<div class=box-bd> <div class=r> <div class=\"c w-xl-1-2\"> <div class=form-group> <label class=form-lbl translate>Quantity</label> <div class=input-group style=width:184px> <input class=input type=number min=1 max=10000 step=1 name=quantity ng-change=vm.changeQuantity(vm.rentalProduct) ng-model=vm.rentalProduct.quantity /> </div> </div> <div class=form-group> <label class=form-lbl translate>Expected delivery date</label> <fb-date-picker min-date=vm.fromDate on-change=vm.changeDate($event) style=display:block;width:184px value=vm.deliveryInfo.deliveryDate max-date=vm.maxDate> </fb-date-picker> <div ng-messages=vm.formReference.dpicker.$error ng-if=vm.formReference.dpicker.$invalid> <div ng-message=minDate ng-if=!vm.rentalProduct.deliveryByExternalPartner> <span class=invalid-feedback translate>Please enter a date in the future</span> </div> <div ng-message=minDate ng-if=vm.rentalProduct.deliveryByExternalPartner> <span class=invalid-feedback translate>Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.</span> </div> <div ng-message=maxDate> <span class=invalid-feedback translate>Please enter a date before {{vm.maxDate | date: 'dd-MM-yyyy'}}</span> </div> </div> </div> <div class=form-group> <label class=form-lbl i translate>Extra info</label> <textarea ng-class=\"vm.formReference.extraInfo.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\" rows=5 name=extraInfo maxlength=1000 ng-change=vm.changeRemark(vm.deliveryInfo) ng-model=vm.deliveryInfo.remark>\r\n                    </textarea> </div> </div> <div class=\"c w-xl-1-2\" ng-if=vm.rentalProduct.deliveryByExternalPartner> <div class=m-b-2> <p class=type-small translate>Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.</p> </div> <div class=form-row> <div class=\"form-group form-group-grow\"> <label class=form-lbl translate>City</label> <typeahead input-id=\"'location'\" display-context=\"'CITY'\" has-focus=vm.hasFocus search-string=vm.citySearchString search-source=vm.searchCities(query) input-style=\"vm.formReference.location.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\" on-change=vm.changeCity(item)> </typeahead> <div> <span translate ng-if=\"!vm.deliveryInfo.postalLocalityId && vm.formReference.$submitted\" class=invalid-feedback>Please provide a valid city.</span> </div> </div> </div> <div class=form-row> <div class=\"form-group form-group-grow\"> <label class=form-lbl translate>Street</label> <typeahead is-disabled=!vm.deliveryInfo.postalLocalityId input-id=\"'streetName'\" display-context=\"'STREET'\" has-focus=vm.hasFocus search-string=vm.streetSearchString search-source=vm.searchStreet(query) input-style=\"vm.formReference.streetName.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\" on-change=vm.changeStreetName(item) ng-keyup=vm.checkForBackSpace($event)> </typeahead> <div> <span translate ng-if=\"!vm.deliveryInfo.streetId && vm.formReference.$submitted\" class=invalid-feedback>Please provide a street.</span> </div> </div> <div class=form-group> <label class=form-lbl translate>N°</label> <input ng-class=\"vm.formReference.houseNumber.$invalid && vm.formReference.$submitted ? 'input input-w-small has-error' : 'input input-w-small'\" type=text ng-required=true name=houseNumber autocomplete=\"'off'\" ng-change=vm.changeHouseNumber(vm.deliveryInfo) ng-model=vm.deliveryInfo.houseNumber /> <div ng-messages=vm.formReference.houseNumber.$error ng-if=\"vm.formReference.houseNumber.$invalid && vm.formReference.$submitted\"> <div ng-message=required> <span class=invalid-feedback translate>Please provide your housenumber.</span> </div> </div> </div> <div class=form-group> <label class=form-lbl translate>Box.</label> <input class=\"input input-w-small\" type=text name=box autocomplete=\"'off'\" maxlength=5 ng-change=vm.changeBox(vm.deliveryInfo) ng-model=vm.deliveryInfo.boxNumber /> </div> </div> <div class=form-group> <label class=form-lbl translate>Contact person</label> <input ng-class=\"vm.formReference.contactPerson.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\" type=text ng-required=true maxlength=255 autocomplete=\"'off'\" name=contactPerson ng-model=vm.contactInfo.contactPerson ng-change=vm.changeContactPerson(vm.contactInfo) /> <div ng-messages=vm.formReference.contactPerson.$error ng-if=\"vm.formReference.contactPerson.$invalid && vm.formReference.$submitted\"> <div ng-message=required><span translate class=invalid-feedback>Please provide your contact person.</span></div> </div> </div> <div class=form-group> <label class=form-lbl translate>Telephone number</label> <input ng-class=\"vm.formReference.telephoneNumber.$invalid && vm.formReference.$submitted ? 'input has-error' : 'input'\" type=tel ng-required=true maxlength=50 id=telephoneNumber name=telephoneNumber autocomplete=\"'off'\" ng-change=vm.changeTelephoneNumber(vm.contactInfo) ng-model=vm.contactInfo.contactPhoneNumber /> <div ng-messages=vm.formReference.telephoneNumber.$error ng-if=\"vm.formReference.telephoneNumber.$invalid && vm.formReference.$submitted\"> <div ng-message=required><span translate class=invalid-feedback>Please provide your telephone number.</span> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "<div class=tgz-checkout-product-info> <div class=tgz-checkout-product-info-left> <div class=tgz-checkout-product-info-image> <img class=img-block ng-src=\"{{vm.rentalProduct.imagePath ? $root.getImage(vm.rentalProduct.imagePath, 'Product'): '';}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Product');}}\" alt=\"{{vm.rentalProduct.name}}\"/> </div> <div class=tgz-checkout-product-info-text> <div class=type-xsmall-uppercase style=line-height:1>{{::vm.rentalProduct.nationalNumber}}</div> <div class=type-h3 style=margin-bottom:.25rem>{{::vm.rentalProduct.name}}</div> <div class=\"text-secondary type-small d-flex\"> <div style=padding-right:2rem> {{ 'Quantity' | translate}}: <strong>{{vm.rentalProduct.quantity}}</strong><br/> {{'Rent per day' | translate}}: <strong>{{::vm.rentalProduct.dayPrice | currency:'€':2}}</strong><br/> </div> <div> {{'Deposit' | translate}}: <strong>{{::vm.rentalProduct.rentalDeposit | currency:'€':2}}</strong><br/> {{ 'VAT' | translate }}: <strong>{{ ::vm.rentalProduct.vat}}%</strong><br/> </div> </div> </div> </div> <div class=tgz-checkout-product-info-right ng-if=vm.rentalProduct.deliveryByExternalPartner> <div class=font-weight-bold translate>Dit product wordt rechtstreeks geleverd bij de patiënt.</div> <p class=type-xsmall translate>De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.</p> </div> </div>";

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "<h1 style=margin-bottom:0 translate>Uw huuraanvraag</h1> <div class=wizard-nav> <div ng-repeat=\"step in vm.steps\" ng-class=\"$index === vm.activeStep ? 'active wizard-nav-item' : 'wizard-nav-item'\">{{step.value}}</div> </div>";

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=vmWizardStep.isActive ng-transclude></div>";

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "<rental-wizard-menu active-step=vmWizard.activeStepIndex steps=vmWizard.menuSteps></rental-wizard-menu> <form id=form> <div ng-transclude> </div></form>";

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<div class=tgz-rental-product-related-item> <div class=\"custom-control custom-checkbox tgz-rental-product-related-item-checkbox\"> <input type=checkbox id=\"customCheck{{vm.rentalProduct.id}}\" class=custom-control-input ng-change=vm.onOrderedChanged() ng-model=vm.rentalProduct.order> <label class=custom-control-label for=\"customCheck{{vm.rentalProduct.id}}\"></label> </div> <rent-product-img class=tgz-rental-product-related-item-img product-id=::vm.rentalProduct.id image=::vm.rentalProduct.imagePath image-size=Product product-clicked=vm.productClicked() add-link=false product-type=::vm.rentalProduct.productTypeCode> </rent-product-img> <div ng-if=\"::vm.rentalProduct.productTypeCode === 'RENTAL'\" class=tgz-rental-product-related-item-body> <div class=type-xsmall-uppercase style=line-height:1>{{vm.rentalProduct.nationalNumber}}</div> <a class=\"link type-h4\" ui-sref=\"seller.rentProductDetail({ productId: vm.rentalProduct.id, sellerId: vm.sellerId})\">{{vm.rentalProduct.name}}</a> <div class=form-group-container> <div class=text-secondary> {{'Rent per day' | translate }}: <strong>{{::vm.rentalProduct.price | currency:'€':2}}</strong><br/> {{'Deposit' | translate }}: <strong>{{::vm.rentalProduct.rentalDeposit | currency:'€':2}}</strong><br/> {{'VAT' | translate }}: <strong>{{::vm.rentalProduct.vat}}%</strong> </div> <div class=\"form-group ml-auto\"> <label class=form-lbl translate>Quantity</label> <div class=input-group> <input class=input type=number min=0 max=10000 type=number step=1 ng-change=vm.quantityChanged() ng-model=vm.rentalProduct.quantity /> </div> </div> </div> </div> <div ng-if=\"::vm.rentalProduct.productTypeCode === 'PORTALPRODUCT'\" class=tgz-rental-product-related-item-body> <div class=type-xsmall-uppercase style=line-height:1>{{vm.rentalProduct.nationalNumber}}</div> <a class=\"link type-h4\" ui-sref=\"general.products.product({ productId: vm.rentalProduct.id })\">{{vm.rentalProduct.name}}</a> <div class=form-group-container> <div class=text-secondary> {{ 'Price' | translate }}: <strong>{{ ::vm.rentalProduct.pharmacyPrice | currency:'€':2 }}</strong><br/> {{ 'VAT' | translate }}: <strong>{{ ::vm.rentalProduct.vat}}%</strong> </div> <div class=\"form-group ml-auto\"> <label class=form-lbl translate>Quantity</label> <div class=input-group> <input class=input type=number min=0 max=10000 type=number step=1 ng-change=vm.quantityChanged() ng-model=vm.rentalProduct.quantity /> </div> </div> </div> </div> </div>";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "<div> <rental-product-grid-item rental-product=rentalProduct index=index ng-repeat=\"rentalProduct in vm.rentalProducts\"></rental-product-grid-item> </div>";

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<div class=table-responsive> <h3 ng-if=vm.filteredRentalProducts.length translate>Rental products</h3> <table ng-if=vm.filteredRentalProducts.length class=\"table table-block table-adapt\"> <thead class=hidden-sm-down> <tr> <th></th> <th></th> <th></th> <th class=\"align-middle align-right\" translate>Quantity</th> <th class=\"align-middle align-right\" translate>Rent per day</th> <th class=\"align-middle align-right\" translate>Deposit</th> <th class=\"align-middle align-right\" translate>VAT</th> </tr> </thead> <tbody> <tr ng-repeat=\"rentalProduct in vm.filteredRentalProducts\"> <td> <rent-product-img product-id=::rentalProduct.id image=::rentalProduct.imageUrl image-size=Product add-link=false style=display:block;width:48px product-type=::rentalProduct.productTypeCode> </rent-product-img> </td> <td class=align-middle>{{::rentalProduct.nationalNumber}}</td> <td class=align-middle> <div class=type-xsmall-uppercase style=line-height:1></div>{{::rentalProduct.productName}} </td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>Quantity:</span>{{::rentalProduct.quantity}}</td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>Rent per day:</span>{{::rentalProduct.dayPrice ? rentalProduct.dayPrice : rentalProduct.pharmacyPrice | currency:'€':2}}</td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>Deposit:</span>{{::rentalProduct.rentDeposit | currency:'€':2}}</td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>VAT:</span>{{::rentalProduct.vat}}%</td> </tr> </tbody> </table> <h3 ng-if=vm.filteredPortalProducts.length translate>Non Rental Products</h3> <table ng-if=vm.filteredPortalProducts.length class=\"table table-block table-adapt\"> <thead class=hidden-sm-down> <tr> <th></th> <th></th> <th></th> <th class=\"align-middle align-right\" translate>Quantity</th> <th class=\"align-middle align-right\" translate>Price</th> <th class=\"align-middle align-right\" translate>VAT</th> </tr> </thead> <tbody> <tr ng-repeat=\"rentalProduct in vm.filteredPortalProducts\"> <td> <rent-product-img product-id=::rentalProduct.id image=::rentalProduct.imageUrl image-size=Product add-link=false style=display:block;width:48px product-type=::rentalProduct.productTypeCode> </rent-product-img> </td> <td class=align-middle>{{::rentalProduct.nationalNumber}}</td> <td class=align-middle> <div class=type-xsmall-uppercase style=line-height:1></div>{{::rentalProduct.productName}} </td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>Quantity:</span>{{::rentalProduct.quantity}}</td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>Price:</span>{{::rentalProduct.dayPrice ? rentalProduct.dayPrice : rentalProduct.pharmacyPrice | currency:'€':2}}</td> <td class=\"align-middle align-right\"><span class=\"left hidden-md-up\" translate>VAT:</span>{{::rentalProduct.vat}}%</td> </tr> </tbody> </table> </div>";

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "<form class=\"box box-2\" novalidate name=vm.checkoutForm> <rental-checkout-product-info rental-product=vm.rentalProduct></rental-checkout-product-info> <rental-checkout-delivery-info on-delivery-info-change=vm.deliveryInfoChange($event) on-contact-info-change=vm.contactInfoChange($event) on-form-change=vm.onFormChange() form-reference=vm.checkoutForm rental-product=vm.rentalProduct delivery-info=vm.deliveryInfo contact-info=vm.contactInfo> </rental-checkout-delivery-info> <ul class=btn-holder> <li class=btn-holder-right> <button ng-if=vm.rentalProduct.relatedRentalProducts.length type=submit wz-valid=\"{{vm.isFormValid}}\" wz-next class=\"btn btn-secondary\"> <b translate>Next</b> </button> <button type=submit ng-if=!vm.rentalProduct.relatedRentalProducts.length ng-click=vm.confirmOrder() wz-valid=\"{{vm.isFormValid}}\" wz-next class=\"btn btn-secondary\"> <b translate>Send application</b> </button> </li> <li> <button type=submit wz-cancel class=\"btn btn-outline\"> <b translate>Cancel</b> </button> </li> </ul> </form>";

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=!vm.rentedProductsOrder.isLoaded class=loading></div> <div ng-if=vm.rentedProductsOrder.isLoaded> <div class=r> <div class=\"c w-xl-3-4 w-xx-1-2\"> <div class=\"box p-t-3\"> <h2 translate>Uw huuraanvraag is verstuurd naar de klantendienst.</h2> <p translate>Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op uw gekozen leveradres</p> <p translate>Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be</p> </div> </div> </div> <div class=box> <rental-product-table rental-products=vm.rentedProductsOrder.rentalProducts></rental-product-table> </div> <div class=r> <div class=\"c w-xl-3-4 w-xx-1-2\"> <div class=box> <ul class=\"list list-values\"> <li> <div class=lbl translate>Expected delivery date</div> <div class=val>{{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}}</div> </li> <li ng-if=::vm.rentedProductsOrder.deliveryInfo.postalCode> <div class=lbl translate>Delivery address</div> <div class=val> {{::vm.rentedProductsOrder.deliveryInfo.streetName}} {{::vm.rentedProductsOrder.deliveryInfo.houseNumber}} {{::vm.rentedProductsOrder.deliveryInfo.boxNumber}}<br/> {{::vm.rentedProductsOrder.deliveryInfo.postalCode}} {{::vm.rentedProductsOrder.deliveryInfo.cityName}} </div> </li> <li ng-if=::vm.rentedProductsOrder.deliveryInfo.remark> <div class=lbl translate>Extra info</div> <div class=val>{{::vm.rentedProductsOrder.deliveryInfo.remark}}</div> </li> <li ng-if=::vm.rentedProductsOrder.contactInfo.contactPerson> <div class=lbl translate>Contact person</div> <div class=val>{{::vm.rentedProductsOrder.contactInfo.contactPerson}}</div> </li> <li ng-if=::vm.rentedProductsOrder.contactInfo.contactPhoneNumber> <div class=lbl translate>Telephone number</div> <div class=val>{{::vm.rentedProductsOrder.contactInfo.contactPhoneNumber}}</div> </li> </ul> </div> <button type=button wz-finish=vm.finish() class=\"btn btn-secondary\"><b translate>To TGZ homepage</b> </button> </div> </div> </div>";

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "<rental-checkout-product-info rental-product=vm.rentalProduct></rental-checkout-product-info> <br/> <div class=r> <div ng-if=\"vm.recommendedRentalProducts.length || vm.recommendedPortalProducts.length\" class=\"c w-xl-1-2\"> <div class=\"box box-2 m-b-2\"> <div ng-if=vm.recommendedRentalProducts.length class=box-hd> <h3 translate>Wij raden aan om hierbij ook deze producten te huren</h3> </div> <div ng-if=vm.recommendedRentalProducts.length class=box-bd> <rental-product-grid rental-products=vm.recommendedRentalProducts></rental-product-grid> </div> <div ng-if=vm.recommendedPortalProducts.length class=box-hd> <h3 translate>Wij raden aan om hierbij ook deze producten te kopen</h3> </div> <div ng-if=vm.recommendedPortalProducts.length class=box-bd> <rental-product-grid rental-products=vm.recommendedPortalProducts></rental-product-grid> </div> </div> </div> <div class=\"c w-xl-1-2\"> <div class=\"box box-2 m-b-2\"> <div ng-if=vm.suggestedRentalProducts.length class=box-hd> <h3 translate>Producten die mogelijks interessant zijn om bij te huren</h3> </div> <div ng-if=vm.suggestedRentalProducts.length class=box-bd> <rental-product-grid rental-products=vm.suggestedRentalProducts></rental-product-grid> </div> <div ng-if=vm.suggestedPortalProducts.length class=box-hd> <h3 translate>Producten die mogelijks interessant zijn om bij te kopen</h3> </div> <div ng-if=vm.suggestedPortalProducts.length class=box-bd> <rental-product-grid rental-products=vm.suggestedPortalProducts></rental-product-grid> </div> </div> </div> </div> <ul class=btn-holder> <li class=btn-holder-right> <button type=button wz-previous class=\"btn btn-outline\"><b translate>Previous</b> </button> <button type=button ng-click=vm.confirmOrder() wz-next class=\"btn btn-secondary\"><b translate>Send application</b> </button> </li> <li> <button type=button wz-cancel ui-sref=\"^.seller.rentProductOverview({sellerId: vm.seller.id})\" class=\"btn btn-outline\"><b translate>Cancel</b> </button> </li> </ul>";

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <rental-wizard menu-steps=vm.wizardMenuSteps on-finish=vm.wizardFinished() on-cancel=vm.wizardCanceled()> <rental-wizard-step is-form-valid=vm.stepOneFormValid menu-label=vm.wizardMenuSteps[0]> <rental-checkout-step-one rental-product=vm.rentalProduct on-form-valid-change=vm.stepOneFormValidChange() contact-info=vm.contactInfo delivery-info=vm.deliveryInfo on-products-rented-succes=vm.onProductsRentedSucces($event) on-contact-info-change=vm.contactInfoChanged($event) on-delivery-info-change=vm.deliveryInfoChanged($event)> </rental-checkout-step-one> </rental-wizard-step> <rental-wizard-step menu-label=vm.wizardMenuSteps[1] show-step=::vm.hasRelatedProducts()> <rental-checkout-step-two on-products-rented-succes=vm.onProductsRentedSucces($event) rental-product=vm.rentalProduct contact-info=vm.contactInfo delivery-info=vm.deliveryInfo> </rental-checkout-step-two> </rental-wizard-step> <rental-wizard-step menu-label=vm.wizardMenuSteps[2]> <rental-checkout-step-three rented-products-order=vm.rentedProductsOrder> </rental-checkout-step-three> </rental-wizard-step> </rental-wizard>";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{ vm.campaign.campaign.name }}</h1> <div class=r> <div class=\"c w-xl-5-6 w-xx-2-3\"> <div class=box ng-if=vm.campaign.campaign.reservationPageBanner> <img class=img-block style=margin-top:4px ng-src=\"{{::$root.getImage(vm.campaign.campaign.reservationPageBanner, 'Original');}}\" alt=\"\"/> </div> <div class=box> <form> <table class=\"table table-block table-adapt table-flu-vaccines\"> <thead class=hidden-sm-down> <tr> <th translate>_reservationCampaigns.productNumber</th> <th translate>_reservationCampaigns.product</th> <th class=align-right> <span translate>_reservationCampaigns.quantity</span> </th> <th ng-if=vm.displayUnits></th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.campaign.reservations\"> <td class=align-middle>{{product.productNumber}}</td> <td class=align-middle>{{product.productName}}</td> <td class=\"align-middle align-right\" style=width:200px> <div ng-if=vm.campaign.campaign.active> <div class=input-group style=\"width:200px;margin:-3px 0\"> <input ng-model=product.amount type=number class=\"input align-right p-r-4\" ng-disabled=product.totalLimitReached min=0 step=1> <div ng-if=product.limitReached class=\"type-xsmall-uppercase text-error\"> {{ product.limitReached }} </div> <div ng-if=product.totalLimitReached class=type-xsmall-uppercase translate> _reservationCampaigns.totalLimitReached </div> </div> </div> <div ng-if=!vm.campaign.campaign.active> <strong>{{ product.amount }}</strong> </div> </td> <td ng-if=vm.displayUnits class=align-right>{{product.unit}}</td> </tr> </tbody> </table> <p class=align-right ng-if=\"vm.campaign.campaign.active && vm.campaign.canReserve\"> <button type=button ng-click=vm.saveAmounts() class=\"btn btn-primary\" min=0 max=10000 step=1 style=min-width:180px translate>_reservationCampaigns.save </button> </p> </form> </div> <div class=box ng-if=vm.campaign.campaign.text> <div class=richtext ng-bind-html=vm.campaign.campaign.text> </div> </div> </div> </div>";

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=site-title> <h1><translate>You searched for</translate> '{{::vm.searchValue}}'</h1> </div> <product-overview context=search-view parent-state=vm.parentState model=vm.productOverviewModel></product-overview>";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=heroes ng-if=\"::vm.sellerAbout.banners.length > 0\"> <hero-slider banners=vm.sellerAbout.banners settings=vm.heroSliderSettings></hero-slider> </div> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <h1>{{::vm.sellerAbout.title}}</h1> <div class=box ng-if=\"::vm.sellerAbout.leading || vm.sellerAbout.content\"> <p class=type-lead ng-if=::vm.sellerAbout.leading>{{::vm.sellerAbout.leading}}</p> <div class=richtext ng-if=::vm.sellerAbout.content ng-bind-html=::vm.sellerAbout.content></div> </div> <hr class=m-b-2 ng-if=\"::vm.sellerAbout.links.length > 0\"/> <links links=vm.sellerAbout.links seller-id=vm.seller.id></links> <gallery gallery-slider-settings=vm.gallerySliderSettings gallery=vm.sellerAbout.gallery></gallery> <div ng-if=\"::vm.sellerAbout.logosTitle || vm.sellerAbout.logosContent || vm.sellerAbout.logos.length > 0\"> <hr class=m-b-2 /> <div class=box> <h2 ng-if=::vm.sellerAbout.logosTitle>{{vm.sellerAbout.logosTitle}}</h2> <div class=richtext ng-if=::vm.sellerAbout.logosContent ng-bind-html=::vm.sellerAbout.logosContent></div> <br/> <div class=\"r logo-block-r r-2-col r-sm-3-col r-md-4-col r-lg-4-col r-xl-4-col r-xx-5-col\"> <div class=c ng-if=logo.media ng-repeat=\"logo in vm.sellerAbout.logos  | orderBy:'priority'\"> <div class=logo-block ng-switch on=logo.type> <a class=logo-block-item ng-switch-when=EXTERNAL href={{logo.value}} target=_blank> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-when=PRODUCT ui-sref=\"^.products.product({ productId: logo.value})\"> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-when=NEWS ui-sref=\"^.news.newsitem({ newsItemId: logo.value})\"> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-when=BENEFIT ui-sref=\"^.partnerships.partnership({ id: logo.value})\"> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-when=SELLER ui-sref=\"^.home({ sellerId: logo.value})\"> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-when=FILE href={{::$root.getDocument(logo.value)}} target=_blank> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <div class=logo-block-item ng-switch-default> <span class=logo-block-img><img ng-src=\"{{::$root.getImage(logo.media.thumbnailPath, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/></span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "<p ng-if=vm.logo><img alt=\"\" ng-src=\"{{::$root.getImage(vm.logo, 'Logo');}}\" alt=\"\" class=img-adapt style=max-height:64px /></p> <p> <span ng-if=vm.sellerName><strong>{{vm.sellerName}}</strong></span><br/> <span ng-if=vm.sellerAddress.streetName>{{vm.sellerAddress.streetName}}</span> <span ng-if=vm.sellerAddress.houseNumber>{{vm.sellerAddress.houseNumber}}</span> <span ng-if=vm.sellerAddress.boxNumber>{{ 'Box:' | translate }} {{vm.sellerAddress.boxNumber}}</span><br/> <span ng-if=vm.sellerAddress.postalCode>{{vm.sellerAddress.postalCode}}</span> <span ng-if=vm.sellerAddress.cityName> {{vm.sellerAddress.cityName}}</span><br/> <span ng-if=vm.sellerAddress.countryName>{{vm.sellerAddress.countryName}}</span> </p> <p ng-if=\"vm.contactInformation.phoneNumberPrimary || vm.contactInformation.faxNumberPrimary || vm.contactInformation.emailPrimary || vm.contactInformation.websitePrimary\"> <span ng-if=vm.contactInformation.phoneNumberPrimary><span translate>Tel:</span> {{vm.contactInformation.phoneNumberPrimary}}<br/></span> <span ng-if=vm.contactInformation.faxNumberPrimary><span translate>Fax:</span> {{vm.contactInformation.faxNumberPrimary}} (Fax)<br/></span> <span ng-if=vm.contactInformation.emailPrimary><a href=\"mailto:{{vm.contactInformation.emailPrimary}}\" class=link>{{vm.contactInformation.emailPrimary}}</a><br/></span> <span ng-if=vm.contactInformation.websitePrimary><a href={{vm.contactInformation.websitePrimary}} class=link>{{vm.contactInformation.websitePrimary}}</a><br/></span> </p>";

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "<slick class=hero-slider settings=::vm.settings> <div ng-repeat=\"banner in vm.banners | orderBy:'priority'\"> <div class=\"hero {{ vm.bannerTextAlignmentClasses[banner.textAlignment].name }}\" ng-class=\"{'hero-light': !banner.darkTextColor }\" ng-style=\"{'background-color': banner.backgroundColor}\"> <div class=hero-img ng-style=\"{'background-color': banner.backgroundColor}\"> <picture picturefill ng-if=banner.media.path><!--[if IE 9]><video style=\"display: none;\"><![endif]--> <source ng-attr-srcset=\"{{::$root.getImage(banner.media.path, 'HeroM');}}\" pf-media=\"(min-width: 768px)\"/><!--[if IE 9]></video><![endif]--> <img ng-src=\"{{::$root.getImage(banner.media.path, 'HeroS'); }}\" alt=\"{{banner.media.description}}\"/> </picture> </div> <div class=hero-body> <div ng-if=banner.title ng-bind-html=banner.title class=hero-title></div> <div ng-if=banner.content ng-bind-html=banner.content class=hero-text></div> <div ng-if=banner.link.text> <span class=\"btn btn-outline hero-btn\">{{banner.link.text}}</span> </div> <div ng-if=!banner.link.text class=hidden-md-up> <span class=\"btn btn-outline hero-btn\" translate>Read more</span> </div> </div> <div ng-switch on=banner.link.type> <div class=hero-link-container ng-switch-when=EXTERNAL><a href={{banner.link.value}} target=_blank></a></div> <div class=hero-link-container ng-switch-when=PRODUCT><a ui-sref=\"^.products.product({ productId: banner.link.value})\"></a></div> <div class=hero-link-container ng-switch-when=NEWS><a ui-sref=\"^.news.newsitem({ newsItemId: banner.link.value})\"></a></div> <div class=hero-link-container ng-switch-when=BENEFIT><a ui-sref=\"^.partnerships.partnership({ id: banner.link.value})\"></a></div> <div class=hero-link-container ng-switch-when=SELLER><a ui-sref=\"^.home({ sellerId: banner.link.value})\"></a></div> <div class=hero-link-container ng-switch-when=FILE><a href={{::$root.getDocument(banner.link.value)}} target=_blank></a></div> </div> </div> </div> </slick>";

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "<nav class=site-seller-header ng-class=\"{ 'is-open' : vm.sellerNavIsOpen }\"> <div class=container> <div class=site-seller-header-logo> <a ui-sref=\"seller.home({sellerId: vm.seller.id})\" ui-sref-active-eq=is-active><img ng-src=\"{{::$root.getImage(vm.seller.img, 'Logo')}}\" alt=Home /></a> </div> <a role=button ng-click=vm.toggleSellerNav() class=site-seller-header-toggle><i></i></a> <nav class=site-seller-header-nav> <ul class=site-nav-list> <li class=site-nav-item-home><a ui-sref=\"seller.home({sellerId: vm.seller.id})\" ui-sref-active-eq=is-active>{{ 'Overview' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.moduleEnabled('BENEFIT')\"></li> <li class=site-nav-item-partnerships ng-if=\"vm.moduleEnabled('BENEFIT')\"><a ui-sref=.partnerships ui-sref-active-eq=is-active>{{ 'Partnerships' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.moduleEnabled('DISCOUNT')\"></li> <li class=site-nav-item-discounts ng-if=\"vm.moduleEnabled('DISCOUNT')\"><a ui-sref=.discounts ui-sref-active-eq=is-active>{{ 'Discounts' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.moduleEnabled('RENT')\"></li> <li class=site-nav-item-rent><a ng-if=\"vm.moduleEnabled('RENT')\" ui-sref=\"seller.rentProductOverview({sellerId: vm.seller.id})\" ui-sref-active-eq=is-active>{{ 'Rental service' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.moduleEnabled('PRODUCT')\"></li> <li class=site-nav-item-products ng-if=\"vm.moduleEnabled('PRODUCT')\"><a ui-sref=.products ui-sref-active-eq=is-active>{{ 'Products' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.numberOfContracts > 0 && vm.isNotFebelcoPartner\"></li> <li class=site-nav-item-discounts ng-if=\"vm.numberOfContracts > 0 && vm.isNotFebelcoPartner\"><a ui-sref=.contract ui-sref-active-eq=is-active>{{ 'Contracts' | translate}}</a></li> <li class=site-nav-list-divider ng-if=\"vm.moduleEnabled('NEWS')\"></li> <li class=site-nav-item-news ng-if=\"vm.moduleEnabled('NEWS')\"><a ui-sref=.news ui-sref-active-eq=is-active>{{ 'News' | translate}}</a></li> <li class=site-nav-list-divider></li> <li class=site-nav-item-about><a ui-sref=.about ui-sref-active-eq=is-active>{{ 'About us' | translate}}</a></li> <li class=site-nav-list-divider></li> <li class=site-nav-item-contact><a ui-sref=.contact ui-sref-active-eq=is-active translate-context=\"Contact page title\">Contact</a></li> <li class=site-nav-list-divider ng-if=true></li> <li class=site-nav-item-doclib ng-if=\"vm.moduleEnabled('LIB')\"><a ui-sref=.doclib ui-sref-active-eq=is-active>{{ 'Document library' | translate}}</a></li> </ul> </nav> </div> </nav>";

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = "<div class=\"r partnership-grid {{vm.viewMode}}\"> <div class=c ng-repeat=\"partnership in vm.partnerships\"> <partnership-tile partnership=partnership></partnership-tile> </div> </div>";

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = "<a ui-sref=\"^.partnerships.partnership({ 'id': vm.partnership.id })\" class=partnership-card data-name=\"{{vm.partnership.title}}\" data-id=\"{{vm.partnership.id}}\"> <img class=partnership-card-img ng-src=\"{{::$root.getImage(vm.partnership.featuredImagePath, 'NewsThumb');}}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'NewsThumb');}}\" alt=\"\"/> <div class=partnership-card-overlay></div> <div class=partnership-card-content> <div class=partnership-card-partner ng-if=::vm.partnership.partnerName>{{vm.partnership.partnerName}}</div> <div class=partnership-card-title>{{vm.partnership.title}}</div> <div class=\"btn btn-light-outline partnership-card-btn\" translate>More info</div> </div> </a>";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"list list-divided list-divided-light\" ng-if=vm.discounts.length> <li ng-repeat=\"d in vm.discounts\"> <div class=\"box-bg box-bg-primary m-b-0 p-t-1 p-b-0\"> <div class=\"box-bd text-light\"> <p> <span class=inline-block><span translate>Discount on total order at</span> {{d.sellerCodeName}}:</span> <span class=inline-block> <span ng-repeat=\"range in d.discountRanges\"> <strong>{{ range.discount }}{{range.discountValueTypeSymbol}}</strong> <span translate>upward of</span> <strong>{{range.from ? range.from : range.amount | currency:'€':0 }}</strong><span ng-if=!$last>,</span> </span> </span> <span class=\"inline-block type-xsmall\" translate>(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})</span> </p> </div> </div> </li> </ul>";

/***/ }),
/* 667 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate translate-context=\"Contact page title\">Contact</h1> <div class=r> <div class=\"c w-lg-2-3\"> <div class=\"box box-border box-border-primary align-center\"> <i class=\"ico ico-speech-bubbles ico-xxlarge color-primary\"></i> <p class=\"type-lead m-b-1\" ng-if=::vm.sellerContact.moreInfoTitle>{{::vm.sellerContact.moreInfoTitle}}</p> <div class=richtext ng-if=::vm.sellerContact.moreInfoContent ng-bind-html=::vm.sellerContact.moreInfoContent></div> <div ng-repeat=\"link in ::vm.sellerContact.moreInfoLinks | orderBy:'priority'\"> <p ng-switch on=link.type> <span ng-switch-when=EXTERNAL><a href={{link.value}} class=\"btn btn-outline\" target=_blank>{{link.text}}</a></span> <span ng-switch-when=PRODUCT><a ui-sref=\"^.products.product({ productId: link.value})\" class=\"btn btn-outline\">{{link.text}}</a></span> <span ng-switch-when=NEWS><a ui-sref=\"^.news.newsitem({ newsItemId: link.value})\" class=\"btn btn-outline\">{{link.text}}</a></span> <span ng-switch-when=BENEFIT><a ui-sref=\"^.partnerships.partnership({ id: link.value})\" class=\"btn btn-outline\">{{link.text}}</a></span> <span ng-switch-when=SELLER><a ui-sref=\"^.home({ sellerId: link.value})\" class=\"btn btn-outline\">{{link.text}}</a></span> <span ng-switch-when=FILE><a href={{::$root.getDocument(link.value)}} class=\"btn btn-outline\" target=_blank>{{link.text}}</a></span> </p> </div> <div ng-if=\"::(vm.sellerContact.pharmacovigilanceContactInformation.phoneNumberPrimary || \r\n                            vm.sellerContact.pharmacovigilanceContactInformation.emailPrimary || \r\n                            vm.sellerContact.pharmacovigilanceContactInformation.faxNumberPrimary || \r\n                            vm.sellerContact.pharmacovigilanceContactInformation.websitePrimary)\" class=m-b-1> <hr class=\"m-t-2 m-b-2\"/> <h4 translate>Questions or remarks concerning the pharmacovigilance of one of our products?</h4> <div ng-if=::vm.sellerContact.pharmacovigilanceContactInformation.phoneNumberPrimary><span translate>Call</span> {{::vm.sellerContact.pharmacovigilanceContactInformation.phoneNumberPrimary}}</div> <div ng-if=::vm.sellerContact.pharmacovigilanceContactInformation.emailPrimary><span translate>Send an e-mail to</span> {{::vm.sellerContact.pharmacovigilanceContactInformation.emailPrimary}}</div> <div ng-if=::vm.sellerContact.pharmacovigilanceContactInformation.faxNumberPrimary><span translate>Send a fax to</span> {{::vm.sellerContact.pharmacovigilanceContactInformation.faxNumberPrimary}}</div> <div ng-if=::vm.sellerContact.pharmacovigilanceContactInformation.websitePrimary><a href={{::vm.sellerContact.pharmacovigilanceContactInformation.websitePrimary}} class=\"btn btn-outline\" target=_blank>Website</a></div> </div> </div> <br/> <div ng-if=::vm.sellerContact.contactPersons.length class=\"box box-2\"> <div class=box-hd> <h2 translate>Contacts</h2> </div> <div class=box-bd> <ul class=\"list r r-md-2-col r-lg-2-col r-xl-2-col\"> <li class=c ng-repeat=\"contact in ::vm.sellerContact.contactPersons\"> <contact-person contact=contact></contact-person> </li> </ul> </div> </div> </div> <div class=\"c w-lg-1-3\"> <div class=\"box box-border\"> <contact-block logo=::vm.sellerContact.sellerLogo.path seller-name=::vm.seller.name seller-address=::vm.sellerContact.sellerAddress contact-information=::vm.sellerContact.contactInformation></contact-block> </div> </div> </div>";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-xl-3-4\"> <contracts-overview-info contracts=vm.contracts></contracts-overview-info> </div> </div>";

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <contract-detail-info contract=vm.contract> <contract-detail-info></contract-detail-info></contract-detail-info>";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=heroes ng-if=vm.sellerBanners.length> <hero-slider banners=vm.sellerBanners settings=vm.heroSliderSettings> </hero-slider> </div> <div ng-if=!vm.seller.name> <br/> <h1>{{::vm.seller.name}}</h1> </div> <form name=forms.productOverviewForm fb-on-close-action=vm.addToCart() fb-prevent-navigation=true> <div class=\"box box-1 box-1-primary\" ng-if=\"vm.moduleEnabled('BENEFIT') && vm.partnerships.length !== 0\"> <div class=box-hd> <h1 translate>Partnerships</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <div class=\"r partnership-grid\"> <slick settings=::vm.partnershipSliderSettings> <partnership-tile class=\"c w-md-1-2 w-xl-1-3\" ng-repeat=\"partnership in vm.partnerships\" partnership=partnership></partnership-tile> </slick> </div> <ul class=\"btn-holder m-t-2\"> <li class=btn-holder-right> <a ui-sref=\"seller.partnerships({sellerId: vm.seller.id})\" class=\"btn btn-primary-outline btn-large\"> <b class=lbl translate>All partnerships</b> <i class=\"ico ico-angle-right\"></i> </a> </li> </ul> </div> </div> <div class=\"box box-1 box-1-primary\" ng-if=\"vm.moduleEnabled('DISCOUNT') && (vm.discountsModel.products.length !== 0 || vm.totalPriceDiscounts.length !== 0)\"> <div class=box-hd> <h1 translate>Discounts</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <seller-total-price-discounts class=m-t-1 discounts=vm.totalPriceDiscounts></seller-total-price-discounts> <div class=\"r discount-card-container\" ng-if=!vm.discountsModel.isLoadingInitial> <slick settings=::vm.productSliderSettings> <product-overview-grid-item get-product-discounts=vm.getProductDiscounts(product) class=\"c w-md-1-4 w-xx-1-5\" on-change-quantity=vm.productQuantityChanged() ng-repeat=\"product in vm.discountsModel.products\" product=product is-last=$last context=home parent-state=vm.parentState></product-overview-grid-item> </slick> </div> <ul class=btn-holder> <li class=btn-holder-right> <a ui-sref=\"seller.discounts({sellerId: vm.seller.id})\" class=\"btn btn-primary-outline btn-large\"> <b class=lbl translate>All discounts</b> <i class=\"ico ico-angle-right\"></i> </a> </li> </ul> </div> </div> <div class=\"loading loading-block\" ng-if=vm.discountsModel.isLoadingInitial></div> <div class=\"loading loading-block\" ng-if=vm.partnershipsModel.isLoadingInitial></div> <div class=\"box box-1 box-1-primary\" ng-if=\"vm.moduleEnabled('NEWS') && vm.newsitems.length !== 0 && vm.newsitems != null\"> <div class=box-hd> <h1 translate>News</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <div class=r> <slick settings=::vm.newsSliderSettings> <news-tile class=\"c w-md-2 w-xl-3\" ng-repeat=\"news in vm.newsitems\" badge-clicked=vm._badgeClicked(categoryId) news=news parent-state=vm.parentState></news-tile> </slick> </div> <ul class=btn-holder> <li class=btn-holder-right> <a ui-sref=^.news class=\"btn btn-primary-outline btn-large\"> <b class=lbl translate>All news</b> <i class=\"ico ico-angle-right\"></i> </a> </li> </ul> </div> </div> <div class=\"loading loading-block\" ng-if=\"vm.newsitems == null\"></div> <div class=\"box box-1 box-1-primary\" ng-if=\"vm.moduleEnabled('PRODUCT') && vm.productsModel.products.length !== 0\"> <div class=box-hd> <h1 class=left translate>Featured products</h1> </div> <div class=\"box-bd p-t-0 p-b-0\"> <div class=r ng-if=!vm.productsModel.isLoadingInitial> <slick settings=::vm.productSliderSettings> <div ng-repeat=\"product in vm.productsModel.products\" class=\"c w-md-1-4 w-xl-1-5\"> <product-overview-grid-item ng-if=\"product.productTypeCode !== 'RENTAL'\" on-change-quantity=vm.productQuantityChanged() get-product-discounts=vm.getProductDiscountsList(product) on-change-quantity=vm.onChangeQuantity() ng-class=\"{'is-sold-out': product.tooLate}\" product=product is-last=$last context=seller-detail-products parent-state=vm.parentState></product-overview-grid-item> <rent-product-overview-grid-item ng-if=\"product.productTypeCode === 'RENTAL'\" product=product index=index context=seller-detail-products></rent-product-overview-grid-item> </div> </slick> </div> <ul class=btn-holder> <li class=btn-holder-right> <a ui-sref=^.products class=\"btn btn-primary-outline btn-large\"> <b class=lbl translate>All products</b> <i class=\"ico ico-angle-right\"></i> </a> </li> </ul> </div> </div> <div class=\"loading loading-block\" ng-if=vm.productsModel.isLoadingInitial></div> </form> <add-products-toolbar products-added=vm.productsAdded is-open=vm.isOpen product=vm.product adding-products=vm.addingProducts products-quantity-changed=vm.productsQuantityChanged has-error=vm.hasError add-to-cart=vm.addToCart()> </add-products-toolbar>";

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <seller-total-price-discounts discounts=vm.productOverviewModel.totalPriceDiscounts></seller-total-price-discounts> <product-overview context=seller-discounts-overview model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>Document library</h1> <div class=r> <div class=\"c w-lg-2-3\"> <div ng-if=vm.documentCategories.length class=\"box box-2 box-2-primary\"> <div class=box-bd> <div class=folder-faq ng-repeat=\"category in vm.visibleDocumentCategories\"> <folder-collapse is-open=\"$index === 0\" folder-title=::category.title show-count=1 item-count=category.documents.length item-label=\"'documents' | translate\"> <div ng-repeat=\"document in category.documents | orderBy:'sequenceNumber'\"> <a class=\"d-flex link-block m-b-0\" ng-click=\"vm.downloadFile(document.id, document.title)\"> <div class=m-r-2> <div ng-class=\"document.path.endsWith('.zip') ?'p-a-1 inline-block bg-secondary-infotheek-media-light img-circle':'p-a-1 inline-block bg-secondary-light img-circle'\"> <i ng-class=\"document.path.endsWith('.zip') ? 'ico ico-image ico-medium text-light' : 'ico ico-documents ico-medium text-light'\"></i> </div> </div> <div> <div ng-if=::document.title class=type-h4>{{::document.title}}</div> <div class=type-small> <span ng-if=::document.description>{{::document.description}}</span> <div class=\"link type-btn type-regular inline-block cursor\"><i class=\"ico ico-file-download ico-small\"></i> {{ 'Download' | translate}}</div> </div> </div> </a> </div> </folder-collapse> </div> </div> </div> <div ng-if=vm.faq.length class=\"box box-2 box-2-primary\"> <div class=box-hd> <h2 translate>Frequently asked questions</h2> </div> <div class=box-bd> <div class=folder-faq ng-repeat=\"item in vm.faq\"> <folder-collapse is-open=false folder-title=::item.question> <div class=richtext ng-bind-html=::item.answer> </div> </folder-collapse> </div> </div> </div> </div> </div>";

/***/ }),
/* 673 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{::vm.seller.name}} <span translate>news</span></h1> <news-overview parent-state=vm.parentState model=vm.newsOverviewModel items-per-page-changed=vm.itemsPerPageChanged($event) view-mode=\"r-sm-2-col r-md-3-col r-lg-4-col r-xl-4-col r-xx-4-col\"></news-overview>";

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>Sellers</h1> <div class=\"toolbar toolbar-sellers-overview\"> <div class=search> <input ng-model=vm.searchValue type=search placeholder=\"{{ 'Search by name' | translate }}\" class=input /> </div> </div> <div class=box> <ul class=\"list r r-2-col r-sm-3-col r-md-4-col r-lg-4-col r-xl-6-col r-xx-6-col seller-cards-vip\"> <li class=c ng-repeat=\"seller in vm.sellers | filter: {isVIPSeller: 'true', name: vm.searchValue}\"> <div class=\"card seller-card\"> <a ui-sref=\"seller.home({sellerId: seller.id})\" class=link-block> <span class=seller-card-img><img ng-src=\"{{::$root.getImage(seller.img,'LogoMenu');}}\" fb-err-src=\"{{::$root.getImage('assets/img/seller.png','LogoMenu');}}\" alt=\"{{::seller.name}}\"/></span> <span>{{::seller.name}}</span> </a> </div> </li> </ul> <ul class=\"list r r-2-col r-sm-3-col r-md-4-col r-lg-4-col r-xl-6-col r-xx-6-col seller-cards\"> <li class=c ng-repeat=\"seller in vm.sellers |  filter: {isVIPSeller: 'false', name: vm.searchValue}\"> <div class=\"card seller-card\"> <a ui-sref=\"seller.home({sellerId: seller.id})\" class=link-block> <span class=seller-card-img><img ng-src=\"{{::$root.getImage(seller.img,'LogoMenu');}}\" fb-err-src=\"{{::$root.getImage('assets/img/seller.png','LogoMenu');}}\" alt=\"{{::seller.name}}\"/></span> <span>{{::seller.name}}</span> </a> </div> </li> </ul> </div>";

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=partnership-detail> <h1>{{::vm.partnership.title}}</h1> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <div ng-if=vm.partnership.featuredImage class=featured-image> <div class=\"embed embed-ratio-3-2\"> <picture picturefill><!--[if IE 9]><video style=\"display: none;\"><![endif]--> <source ng-attr-srcset=\"{{::$root.getImage(vm.partnership.featuredImage.path, 'Featured');}}\" pf-media=\"(min-width: 768px)\"/><!--[if IE 9]></video><![endif]--> <img ng-src=\"{{::$root.getImage(vm.partnership.featuredImage.path, 'FeaturedS'); }}\" fb-err-src=\"{{::$root.getImage('assets/img/product.png', 'Featured');}}\" alt=\"{{::vm.partnership.featuredImage.description}}\"/> </picture> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <div class=box> <p ng-if=::vm.partnership.partner.name class=type-small-uppercase>{{::vm.partnership.partner.name}}</p> <p ng-if=::vm.partnership.leading class=type-lead>{{::vm.partnership.leading}}</p> <div ng-if=::vm.partnership.summary class=richtext ng-bind-html=::vm.partnership.summary></div> </div> <hr ng-if=::vm.partnership.content class=m-b-2 /> <div ng-if=::vm.partnership.content class=\"box richtext\" ng-bind-html=vm.partnership.content></div> <hr ng-if=::vm.partnership.links.length class=m-b-2 /> <links links=vm.partnership.links seller-id=vm.seller.id></links> <div ng-if=::vm.partnership.gallery.length> <gallery gallery-slider-settings=vm.gallerySliderSettings gallery=vm.partnership.gallery></gallery> </div> <div ng-if=\"vm.partnership.callToActionContent || vm.partnership.callToActionLinks.length > 0\"> <div class=\"box box-border box-border-primary\"> <div ng-if=\"::vm.seller.code !== 'TGZ'\" class=box-hd> <h3 translate>How can you enjoy this partnership?</h3> </div> <div ng-if=::vm.partnership.callToActionContent class=box-bd> <div class=richtext ng-bind-html=::vm.partnership.callToActionContent></div> </div> <div ng-if=::vm.partnership.callToActionLinks.length class=box-ft> <ul class=\"btn-holder btn-holder-center\"> <li ng-repeat=\"link in ::vm.partnership.callToActionLinks\"> <a href={{link.value}} class=\"btn btn-primary\">{{link.text}}</a> </li> </ul> </div> </div> </div> <div ng-if=\"::vm.partnership.sellerContactPersons.length > 0\"> <div class=\"box box-border box-border-primary\"> <div class=box-hd> <h3 translate>Questions? More info?</h3> </div> <div class=box-bd> <ul class=\"list list-spaced-2\"> <li ng-repeat=\"contact in ::vm.partnership.sellerContactPersons\"> <contact-person contact=contact></contact-person> </li> </ul> </div> </div> </div> </div> <div class=\"c w-md-1-2 w-lg-1-3 offset-xx-1-12\"> <div class=\"box box-bg\" ng-if=vm.partnership.contracts.length> <div class=box-hd><h3 translate>Uw contract</h3></div> <div ng-if=vm.partnership.contracts.length ng-repeat=\"contract in vm.partnership.contracts\"> <p translate ng-if=!vm.checkYearsApart(contract)>U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot {{contract.endDate | date}}</p> <p translate ng-if=vm.checkYearsApart(contract)>U heeft voor dit partnership een {{contract.name}} contract van onbepaalde duur vanaf {{contract.startDate | date}}</p> <ul class=\"btn-holder btn-holder-center\"> <li class=btn-holder-center> <a class=\"btn btn-outline\" ui-sref=contract-detail({id:contract.id}) translate>Meer Details</a> </li> <li ng-if=\"$index == 0\" ng-if=vm.partnership.category class=btn-holder-center> <a class=\"btn btn-primary-outline\" ui-sref=\"seller.discounts({filter:'{{vm.partnership.category.categoryTypeId}}_{{vm.partnership.category.id}}_s'})\" translate>Order here</a> </li> </ul> </div> <div ng-if=!vm.partnership.contracts.length> <p translate>Currently you do not have any Febelco Partner or Agios contract.</p> </div> </div> <div ng-if=vm.partnership.partner class=\"box box-border\"> <div class=\"box-bd p-b-1\"> <p ng-if=vm.partnership.partner.logo.thumbnailPath> <img ng-src=\"{{::$root.getImage(vm.partnership.partner.logo.thumbnailPath, 'Logo'); }}\" alt=\"{{::vm.seller.name}}\" class=img-adapt style=max-height:64px /> </p> <p> <span ng-if=vm.partnership.partner.name> <strong>{{vm.partnership.partner.name}}</strong> <br/> </span> <span ng-if=vm.partnership.partner.address.streetName>{{vm.partnership.partner.address.streetName}}</span> <span ng-if=vm.partnership.partner.address.houseNumber>{{vm.partnership.partner.address.houseNumber}}</span> <span translate ng-if=vm.partnership.partner.address.boxNumber>Box: {{vm.partnership.partner.address.boxNumber}}</span> <br/> <span ng-if=vm.partnership.partner.address.postalCode>{{vm.partnership.partner.address.postalCode}}</span> <span ng-if=vm.partnership.partner.address.cityName> {{vm.partnership.partner.address.cityName}}</span> </p> <span ng-if=vm.partnership.partner.contactInformation.phoneNumberPrimary>{{vm.partnership.partner.contactInformation.phoneNumberPrimary}} <br/> </span> <ul ng-if=vm.partnership.partner.contactInformation.phoneNumbers class=\"list m-b-0\"> <li ng-repeat=\"phoneNumber in vm.partnership.partner.contactInformation.phoneNumbers\"> <span>{{phoneNumber}}</span> </li> </ul> <span ng-if=vm.partnership.partner.contactInformation.faxNumberPrimary>{{vm.partnership.partner.contactInformation.faxNumberPrimary}} (Fax) <br/> </span> <span ng-if=vm.partnership.partner.contactInformation.emailPrimary> <a href=\"mailto:{{vm.partnership.partner.contactInformation.emailPrimary}}\" class=link>{{vm.partnership.partner.contactInformation.emailPrimary}}</a> <br/> </span> <span ng-if=vm.partnership.partner.contactInformation.websitePrimary> <a href={{vm.partnership.partner.contactInformation.websitePrimary}} target=_blank class=link>{{vm.partnership.partner.contactInformation.websitePrimary}}</a> </span> </div> </div> </div> </div> <div class=r> <div class=\"c w-lg-2-3 w-xx-7-12\"> <hr class=m-b-2 /> <div class=box> <ul class=btn-holder> <li class=btn-holder-right> <a class=\"btn btn-outline\" ui-sref=seller.partnerships translate>Return</a> </li> </ul> </div> </div> </div> </div>";

/***/ }),
/* 676 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{::vm.seller.name}}: <span translate>partnerships</span></h1> <div ng-if=\"vm.partnershipModel !== null\" class=\"toolbar toolbar-top toolbar-partnerships-overview toolbar-news-overview\"> <div class=toolbar-search> <div class=toolbar-search-by-term> <form ng-submit=vm.search()> <div class=input-group id=search-input ng-keydown=vm.onKeydown()> <input class=input fb-prevent-keypress type=search ng-model=vm.searchValue placeholder=\"{{ 'Your search value' | translate }}\"/> <div class=input-append> <button class=\"btn btn-outline btn-tile\" ng-click=vm.searchPartnerships()> <i class=\"ico ico-search\"></i><b class=sr-only translate>Search</b> </button> </div> <div class=input-append> <button class=\"btn btn-outline btn-tile\" ng-click=vm.clear()> <i class=\"ico ico-delete\"></i><b class=sr-only translate>Clear</b> </button> </div> </div> </form> </div> </div> </div> <div ng-if=\"vm.partnershipModel.partnerships.length === 0\"><br/><p translate>Unfortunately there were no partnerships found.</p><br/><br/></div> <div class=\"box box-2 m-t-2\" ng-repeat=\"(key, item) in vm.partnerships\"> <div class=box-hd> <h2 translate>{{key}}</h2> </div> <div class=\"box-bd p-t-0\"> <partnership-grid partnerships=item error-occurred=vm.errorOccurredInPartnershipOverview view-mode=\"r-md-2-col r-lg-2-col r-xl-3-col r-xx-3-col\"></partnership-grid> </div> </div>";

/***/ }),
/* 677 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{::vm.seller.name}} <translate>products</translate></h1> <seller-total-price-discounts discounts=vm.productOverviewModel.totalPriceDiscounts></seller-total-price-discounts> <product-overview on-filter-change=vm.onFilterChange() context=seller-products-overview model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <div class=heroes ng-if=vm.sellerPublic.banners.length> <hero-slider banners=vm.sellerPublic.banners settings=vm.heroSliderSettings> </hero-slider> </div> <div class=r> <div class=\"c w-lg-2-3\"> <h1>{{!vm.seller.name ? vm.seller.name : vm.sellerPublic.title}}</h1> <div class=box ng-if=\"vm.sellerPublic.leading || vm.sellerPublic.content\"> <p class=type-lead ng-if=vm.sellerPublic.leading>{{vm.sellerPublic.leading}}</p> <div class=richtext ng-if=vm.sellerPublic.content ng-bind-html=vm.sellerPublic.content></div> </div> <hr class=m-b-2 ng-if=::vm.sellerPublic.links.length /> <links links=vm.sellerPublic.links seller-id=vm.seller.id></links> </div> </div> <div class=r> <div class=\"c w-lg-2-3\" ng-if=\"::vm.sellerPublic.contactTitle || vm.sellerPublic.contactContent || vm.sellerPublic.contactLinks.length\"> <div class=\"box box-border box-border-primary align-center\"> <p class=\"type-lead m-b-1\" ng-if=::vm.sellerPublic.contactTitle>{{::vm.sellerPublic.contactTitle}}</p> <div class=richtext ng-if=::vm.sellerPublic.contactContent ng-bind-html=vm.sellerPublic.contactContent></div> <ul class=\"btn-holder btn-holder-center\" ng-if=::vm.sellerPublic.contactLinks> <li ng-repeat=\"link in vm.sellerPublic.contactLinks | orderBy:'priority'\"> <a href={{link.value}} target=_blank class=\"btn btn-outline\">{{link.text}}</a> </li> </ul> </div> </div> <div class=\"c w-lg-1-3\" ng-if=\"::vm.sellerPublic.sellerAddress || vm.sellerPublic.contactInformation\"> <contact-block class=\"block box box-border box-border-base flex-box\" seller-name=::vm.seller.name seller-address=::vm.sellerPublic.sellerAddress contact-information=::vm.sellerPublic.contactInformation></contact-block> </div> </div> <div class=r ng-if=\"::vm.sellerPublic.sellerLogos.length > 0\"> <div class=\"c w-lg-2-3\"> <div class=\"box box-2\"> <div class=box-hd> <h2 translate>Partnerships</h2> </div> <div class=box-bd ng-repeat=\"(key, logos) in vm.sellerLogos\"> <h3 class=m-y-2 translate>{{key}}</h3> <div class=\"r logo-block-r r-2-col r-sm-3-col r-md-4-col r-lg-4-col r-xl-4-col r-xx-5-col\"> <div class=c ng-repeat=\"logo in logos | orderBy: 'priority'\"> <div class=logo-block ng-switch on=logo.type> <a class=logo-block-item ng-switch-when=EXTERNAL href={{logo.value}} target=_blank> <span class=logo-block-img> <img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/> </span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> <a class=logo-block-item ng-switch-default> <span class=logo-block-img> <img ng-src=\"{{::$root.getImage(logo.media.path, 'LogoMenu'); }}\" alt=\"{{::logo.text}}\"/> </span> <span class=logo-block-lbl ng-if=logo.text>{{::logo.text}}</span> </a> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1>{{ vm.product.name }}<span ng-if=::vm.product.nationalNumber> &ndash; </span> {{::vm.product.nationalNumber}}</h1> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4\"> <form> <div class=product-detail> <div class=r> <div class=\"c w-sm-5-12 w-md-1-3 w-lg-1-3 w-xl-1-3\"> <div class=product-detail-images> <rent-product-img image=::vm.product.imagePath image-size=Product product-clicked=vm.productClicked() add-link=false product-type=::vm.product.productTypeCode> </rent-product-img> <ul class=list> <li> <img ng-click=vm.changeMainImage(vm.product.image) ng-src=\"{{$root.getImage(vm.product.image, 'ProductThumb');}}\" alt=\"\"/> </li> <li ng-repeat=\"item in vm.medipimData.images\"> <img fb-fancybox data-fancybox=item ng-attr-data-srcset=\"{{::$root.getImage(item.relativeFilePath, 'GalleryL');}} 1400w, {{::$root.getImage(item.relativeFilePath, 'GalleryM');}} 1000w, {{::$root.getImage(item.relativeFilePath, 'GalleryS');}} 600w\" gallery-id=\"{{vm.galleryId}}\" index=\"{{$index}}\" ng-click=\"\" ng-href=\"{{$root.getImage(item.relativeFilePath, 'GalleryS');}}\" ng-src=\"{{$root.getImage(item.relativeFilePath, 'ProductThumb');}}\"/> </li> </ul> </div> </div> <div class=\"c w-sm-7-12 w-md-1-2 w-xl-1-3\"> <div class=\"box box-border box-border-secondary m-b-0\"> <div class=box-bd> <div class=\"d-flex justify-content-between\"> <div> <div class=type-xsmall-uppercase translate>Rent per day</div> <strong>{{ ::vm.product.dayPrice | currency:'€':2 }}</strong> <div class=type-xsmall-uppercase translate>Deposit</div> <strong>{{ ::vm.product.rentalDeposit | currency:'€':2 }}</strong> <div class=type-xsmall-uppercase translate>VAT</div> <strong>{{ ::vm.product.vat}}%</strong> </div> <p claim-authorize=IsBuyer> <a ng-if=vm.product.isSellable ui-sref-opts=\"{relative: vm.parentState}\" ui-sref=\"rentalCheckout({ productId: vm.product.id, sellerId: vm.product.sellerId })\" class=\"right btn btn-secondary\" style=min-width:96px translate translate-context=Verb>Rent</a> </p> </div> </div> </div> </div> </div> <div ng-if=\"vm.attachments.length ||\r\n                            vm.recommendedRentalProducts.length ||\r\n                            vm.recommendedPortalProducts.length ||\r\n                            vm.suggestedRentalProducts.length ||\r\n                            vm.suggestedPortalProducts.length ||\r\n                            !vm.isEmptyObject(vm.medipimData)\" class=\"box box-1\"> <div class=box-hd fb-folder init-open=md-up> <h2 translate>Product information</h2> </div> <div class=box-bd> <div ng-if=vm.attachments.length class=\"box box-bg p-b-1\"> <div class=media ng-repeat=\"attachment in vm.attachments\"> <img class=media-img src=/assets/img/tgz-logo.png alt=\"\" width=48 /> <div class=media-body> <p> <a class=\"font-weight-medium link\" ng-href=\"{{::$root.getDocument(attachment.path, 'DOCUMENTLIBRARY')}}\">{{attachment.name}}</a><br> <span class=type-small>{{attachment.description}} </span> </p> </div> </div> </div> <div class=r> <div class=r> <div ng-if=\"vm.recommendedRentalProducts.length || vm.recommendedPortalProducts.length\" class=\"c w-xl-1-2\"> <div class=\"box box-2 m-b-2\"> <h3 ng-if=vm.recommendedRentalProducts.length translate>Wij raden aan om hierbij ook deze producten te huren</h3> <div class=box-bd> <rent-product-overview-grid products=vm.recommendedRentalProducts mode=\"'related'\"></rent-product-overview-grid> </div> <h3 ng-if=vm.recommendedPortalProducts.length translate>Wij raden aan om hierbij ook deze producten te kopen</h3> <div ng-if=vm.recommendedPortalProducts.length class=box-bd> <rent-product-overview-grid products=vm.recommendedPortalProducts mode=\"'related'\"></rent-product-overview-grid> </div> </div> </div> <div class=\"c w-xl-1-2\"> <div class=\"box box-2 m-b-2\"> <h3 ng-if=vm.suggestedRentalProducts.length translate>Producten die mogelijks interessant zijn om bij te huren</h3> <div class=box-bd> <rent-product-overview-grid products=vm.suggestedRentalProducts mode=\"'related'\"></rent-product-overview-grid> </div> <h3 ng-if=vm.suggestedPortalProducts.length translate>Producten die mogelijks interessant zijn om bij te kopen</h3> <div ng-if=vm.suggestedPortalProducts.length class=box-bd> <rent-product-overview-grid products=vm.suggestedPortalProducts mode=\"'related'\"></rent-product-overview-grid> </div> </div> </div> </div> </div> <medipim-info ng-if=!vm.isEmptyObject(vm.medipimData) medipim-data=vm.medipimData></medipim-info> </div> </div> </div> </form> </div> <div class=\"c w-md-1-2 w-lg-1-3 w-xl-1-4\"> <news-aside ng-if=vm.topNewsitems parent-state=::vm.parentState top-newsitems=vm.topNewsitems class=product-detail-news></news-aside> </div> </div>";

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"breadcrumb ng-isolate-scope\"> <ul class=breadcrumb-wrap> <li class=breadcrumb-item ng-show=!$last aria-hidden=false><a href=/nl class=ng-binding translate>Home</a></li> <li class=breadcrumb-item ng-show=!$last aria-hidden=false><a ui-sref=\"^.home({sellerId: vm.seller.id})\" class=ng-binding translate>{{vm.seller.name}}</a></li> <li ng-if=vm.activeCategory class=breadcrumb-item><a ui-sref=\"^.rentProductOverview({ categoryId: 0 })\">{{'All rental products' | translate}}</a></li> <li class=breadcrumb-item translate>{{ vm.activeCategory ? vm.activeCategory.name : 'All rental products'}}</li> </ul> </nav> <h1 translate>Rent products</h1> <div class=\"r tgz-rental-filter-r tgz-rental-filter-r-{{vm.activeCategory.code | lowercase}}\"> <div ng-repeat=\"category in vm.rentalProductsCategories\" class=\"c w-sm-1-3\"> <a ui-sref=\"^.rentProductOverview({ categoryId: category.url })\" ng-if=\"vm.activeCategory.code !== category.code\" class=\"tgz-rental-filter tgz-rental-filter-{{category.code | lowercase}}\"> <i class=\"ico ico-large\" ng-class=\"{'ico-baby-bottle': category.code === 'GEZIN', 'ico-bed': category.code === 'PZORG', 'ico-crutches': category.code === 'MOBIL'}\"></i> <span class=lbl translate>{{category.name}}</span> </a> <a ui-sref=\"^.rentProductOverview({ categoryId: 0 })\" ng-if=\"vm.activeCategory.code === category.code\" class=\"tgz-rental-filter tgz-rental-filter-{{category.code | lowercase}}\"> <i class=\"ico ico-large\" ng-class=\"{'ico-baby-bottle': category.code === 'GEZIN', 'ico-bed': category.code === 'PZORG', 'ico-crutches': category.code === 'MOBIL'}\"></i> <span class=lbl translate>{{category.name}}</span> </a> </div> </div> <div ng-if=vm.rentalProductsOverview.isLoading class=\"p-t-2 p-b-2\"> <div class=loading></div> </div> <div class=\"r tgz-product-grid\" fb-enter-pressed=vm.updateQuantity()> <div class=c> <div ng-if=vm.model.isLoading class=\"loading loading-block\"></div> <div ng-if=!vm.model.isLoading class=category-products> <form name=forms.productOverviewForm> <rent-product-overview-grid products=vm.rentalProductsOverview.products mode=\"'overview'\"></rent-product-overview-grid> </form> </div> </div> </div>";

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "<nav class=breadcrumb> <div class=breadcrumb-wrap> <a class=breadcrumb-item ui-sref=home translate>Home</a> <a class=breadcrumb-item ui-sref=sellers translate>Sellers</a> <a class=breadcrumb-item ui-sref=\"seller({id: vm.sellerCategory.id})\">{{::vm.sellerCategory.name}}</a> <a class=breadcrumb-item ui-sref=\"sellercategory({id: vm.sellerCategory.id, categoryId: cat.id})\" ng-repeat=\"cat in ::vm.sellerCategory.categories.slice(0, vm.sellerCategory.categories.length-1)\">{{::cat.name}}</a> <b class=breadcrumb-item>{{::vm.sellerCategory.categories[vm.sellerCategory.categories.length - 1].name}}</b> </div> </nav> <h1>{{::vm.sellerCategory.categories[vm.sellerCategory.categories.length - 1].name}}</h1> <product-overview context=seller-categories-overview model=vm.productOverviewModel></product-overview>";

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "<div ncy-breadcrumb></div> <h1 translate>Griepvaccins 2021-2022</h1> <div class=r> <div class=\"c w-xl-5-6 w-xx-2-3\"> <div class=box> <img class=img-block style=margin-top:4px ng-src=\"{{::$root.getImage(vm.getBannerImageEnded(), 'Original');}}\" alt=\"\"/> </div> <div class=box> <form> <table class=\"table table-block table-adapt table-flu-vaccines\"> <thead class=hidden-sm-down> <tr> <th translate>Product number</th> <th translate>Product</th> <th class=align-right translate>Quantity</th> </tr> </thead> <tbody> <tr ng-repeat=\"v in vm.vaccines\"> <td>{{v.productNumber}}</td> <td>{{v.product}}</td> <td ng-if=!v.disabled class=align-right> <div class=inline-block> <div ng-if=vm.canOrder(v) class=input-group style=\"width:100px;margin:-3px 0\"> <input ng-readonly=!vm.canOrder(v) ng-model=v.amount type=number class=input min=0 step=1> </div> <div ng-if=!vm.canOrder(v) class=align-center><strong>{{ v.amount }}</strong></div> </div> </td> <td ng-if=v.disabled class=align-right></td> </tr> </tbody> </table> </form> </div> <div class=box> <p translate>Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.</p> <p translate>U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.</p> <p ng-if=::vm.vaccines.influvacReadOnly translate><strong>Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.</p> <p translate><strong>Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.</p> <p translate><strong>Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.</p> <p translate>Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.</p> </div> <p class=align-right><button ng-if=vm.reservationCanBeMade type=button ng-click=vm.saveVaccinesOrder() class=\"btn btn-primary\" min=0 max=10000 step=1 style=min-width:160px translate>Bewaren</button></p> </div> </div>";

/***/ }),
/* 683 */,
/* 684 */
/***/ (function(module, exports) {

module.exports = {
	"fr": {
		"(Will be) delivered": "Est livré",
		"(Will be) partially delivered": "Partiellement livré",
		"(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})": "(Hors TVA - {{d.promoCode}} - Valable jusqu'au {{d.endDate | date: 'dd/MM/yyyy'}})",
		".csv file, max. 5MB": "Fichier CSV, max. 5 MB",
		"<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>": "<a href=\"http://www.profficina.be/fr/index.html\" target=\"_blank\" class=\"link\">www.profficina.be</a>",
		"<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Terms and conditions</a>": "<a href=\"http://www.profficina.be/fr/conditions-generales.html\" target=\"_blank\" class=\"link\">Conditions générales d’utilisation</a>",
		"<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy policy</a>": "<a href=\"http://www.profficina.be/fr/protection-de-la-vie-privee.html\" target=\"_blank\" class=\"link\">Protection de la vie privée</a>",
		"<b>Niet te reserveren</b>": "<b>Non réservable.</b>",
		"<b>Zonder korting</b>": "<b>À réserver sans réduction.</b>",
		"<strong>Do not order</strong> the products.": "<strong>Ne pas commander</strong> les produits.",
		"<strong>Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.": "Il sera aussi impossible de retourner les vaccins. Ceux-ci seront livrés dès que nous les avons en stock et jusqu’à épuisement des réserves.",
		"<strong>Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.": "Veuillez également noter que, dès le 28 février prochain, vous ne pourrez plus modifier les quantités réservées. ",
		"<strong>Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.": "<strong  style=\"color: #82BC00;\">Attention : </strong> le seuil de réservation des vaccins Influvac a été franchi. Cela signifie qu'il n'est plus possible de les réserver. Vous pouvez toujours consulter vos réservations de vaccins Influvac, mais vous ne pouvez plus les modifier.",
		"<strong>Order</strong> the products <strong>anyway</strong> via the customer service ('special order').": "<strong>Commander</strong> les produits via le service clientèle (‘Commandes spéciales’). ",
		"A question? A suggestion?": "Une question ? Une suggestion ?",
		"ALPHARIX TETRA 2021-2022 0,5 ML 1 WWSP": "ALPHARIX TETRA 2021-2022 0,5 ML 1 SER A JET",
		"APB category": "Catégorie APB",
		"APB-number": "N° d'autorisation",
		"About us": "À propos de nous",
		"Access is denied": "Accès refusé",
		"Account": "Account",
		"Active ingredients": "Principes actifs",
		"Add": "Ajouter",
		"Add package": "Verzending toevoegen",
		"Add products or import a CSV file with your order.": "Entrez vos produits ou importez un fichier csv avec votre commande.",
		"Add to shopping cart": "Ajouter au panier",
		"Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount": "Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount",
		"Added products to your shoppingcart": "Les produits ont été ajoutés au panier.",
		"Address": "Adresse",
		"Al mijn verzendingen": "Al mijn verzendingen",
		"All categories": "Toutes les catégories",
		"All discounts": "Toutes les réductions",
		"All my rental requests": "Toutes mes demandes",
		"All my rented products": "Mes demandes de location",
		"All news": "Toutes les nouvelles",
		"All partnerships": "Tous les partenariats",
		"All pharmacies": "Toutes les pharmacies",
		"All products": "Tous les produits",
		"All products of this supplier or in your contract.": "Tous les produits de ce labo sont dans votre contrat.",
		"All rental products": "Tous les produits de location",
		"All sellers": "Tous les fournisseurs",
		"All vendors": "Tous les fournisseurs",
		"Amount": "Montant",
		"An error occured when adding products to your shoppingcart, please try again": "Un problème inattendu est survenu en ajoutant des produits à votre panier. Veuillez réessayer. Nos excuses pour l’inconvénient.",
		"An error occurred during the confirmation of the order. Please contact the customer support.": "Un problème inattendu est survenu lors de la confirmation de votre commande. Veuillez prendre contact avec le service clientèle. Nos excuses pour l’inconvénient.",
		"An error occurred during the re order. Please contact the customer support.": "Un problème inattendu est survenu lors de la confirmation de votre commande. Veuillez prendre contact avec le service clientèle. Nos excuses pour l’inconvénient.",
		"An overview of all rental products since 2019.": "Un aperçu de toutes vos locations depuis 2019.",
		"Are you sure you want to clear your shopping cart?": "Êtes-vous certain de vouloir vider votre panier ?",
		"At least": "Au moins",
		"Attention!": "Attention !",
		"Available": "Stock suffisant",
		"Back to overview": "Retour à l’aperçu",
		"Batch number": "Lot",
		"Below are some useful links:": "Veuillez trouver ci-dessous quelques liens pratiques :",
		"Bewaren": "Réserver",
		"Billing address": "Adresse de facturation",
		"Black Friday": "Black Friday",
		"Box.": "Boîte",
		"Box:": "Boîte:",
		"Box: {{vm.partnership.partner.address.boxNumber}}": "Boîte: {{vm.partnership.partner.address.boxNumber}}",
		"Brand": "Marque",
		"Brands": "Marques",
		"Buy": "Acheter",
		"CNK": "CNK",
		"CTI extended": "CTI extended",
		"Call": "Appelez ",
		"Cancel": "Annuler",
		"Cancelled": "Annulé",
		"Categories": "Catégorisatie",
		"Categorisation": "Catégorisation",
		"Certificates": "Certificats",
		"Certificates headerlink": "Certificats d'analyse",
		"Certificates introtext": "<p>Chaque matière première est accompagnée d'un certificat d'analyse. C’est aussi le cas de <strong>Febelcare Elements</strong>. <strong>Grâce à Profficina</strong>, vous avez accès à ces certificats quand et où vous voulez !</p><p>Pour obtenir un certificat d'analyse, il suffit de saisir ci-dessous le numéro de lot, le CNK ou le nom du produit affiché sur l'emballage. Si aucune correspondance n’est trouvée, cela signifie que le numéro de lot a expiré ou que le certificat n'a tout simplement pas été enregistré dans la base de données.</p><p>En cas de problème, merci de prendre contact avec notre service clientèle. Ils se feront un plaisir de vous aider.</p>",
		"Certificates title": "À la recherche d’un certificat d'analyse ?",
		"Change": "Modifier ",
		"Check stock": "Consultez le stock",
		"Check your order": "Vérifiez votre commande",
		"Checking stock...": "En traitement...",
		"City": "Ville",
		"Clear": "Supprimer",
		"Clear all": "Supprimer tout",
		"Clear all filters": "Supprimer tous les filtres",
		"Clear selection": {
			"Datetimepicker tooltips": "Supprimer"
		},
		"Clear shopping cart": "Vider panier",
		"Click here to see the complete list.": "Cliquez ici pour voir la liste.",
		"Close": "Fermer",
		"Close and don't show again": "Ne plus afficher",
		"Close the picker": {
			"Datetimepicker tooltips": "Fermer calendrier"
		},
		"Company number": "Numéro d'entreprise",
		"Compose your panacea by choosing products from the list below.": "Composez votre panaché à l’aide des produits ci-dessous.",
		"Composition": "Composition",
		"Confirm": "Confirmer",
		"Confirm order": "Confirmer commande",
		"Confirmation": "Confirmation",
		"Conservation": "Bewaring",
		"Contact": {
			"$$noContext": "Contact",
			"Contact page title": "Contact"
		},
		"Contact <a href=\"mailto:support@profficina.be\" class=\"link\">support@profficina.be</a> for further assistance.": "Pour recevoir des renseignements ou des conseils, veuillez vous adresser à <a href=\"mailto:support@profficina.be\" class=\"link\">support@profficina.be</a>.",
		"Contact person": "Personne à contacter",
		"Contacts": "Contact",
		"Continue shopping": "Poursuivre vos achats",
		"Continue without updating cart": "Continuer sans mise à jour panier",
		"Contra indication": "Contre-indication",
		"Contract name": "Nom contrat",
		"Contracts": "Contrats",
		"Counter discount": "Réduction compteur",
		"Created": "Créé",
		"Current discount": "Réduction actuelle",
		"Current filters": "Filtres actuels",
		"Currently you do not have any Febelco Partner or Agios contract.": "Vous n’avez pas encore de contrat pour ce partenariat.",
		"Customer number": "N° client",
		"DD-MM-YYYY": "JJ-MM-AAAA",
		"Date": "Date",
		"De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.": "Location minimum de 7 jours calendriers. Les frais de transport de €60 (Prix pharmacie, hors TVA) qui seront facturés, incluent la livraison, l’enlèvement, le nettoyage et l’administration. ESRI ne facturera rien au patient. Toute facturation passera par votre pharmacie.",
		"Decrement Hour": {
			"Datetimepicker tooltips": "Diminuer l'heure"
		},
		"Decrement Minute": {
			"Datetimepicker tooltips": "Diminuer les minutes"
		},
		"Decrement Second": {
			"Datetimepicker tooltips": "Diminuer les secondes"
		},
		"Deficit": "Déficit",
		"Delayed deliveries": "Livraisons réparties sur l'année",
		"Delete": "Supprimer",
		"Deliver earlier": "Avancer le délai de livraison",
		"Delivered": "Livré",
		"Deliveries": "Livraisons",
		"Delivery Date": "Date de livraison prévue",
		"Delivery address": "Adresse de livraison",
		"Delivery nr.": "N° livraison",
		"Deposit": "Caution",
		"Deposit not refunded": "Dépôt non remboursé",
		"Deposit refunded": "Restitution caution",
		"Deposit:": "Caution:",
		"Depth": "Profondeur",
		"Description": "Description",
		"Detail": "Détails",
		"Diameter": "Diamètre",
		"Dimensions": "Dimensions",
		"Discount": "Réduction",
		"Discount date": "Date réduction",
		"Discount expires today": "Réduction expire aujourd'hui.",
		"Discount on order total": "Réduction sur la totalité de votre commande ",
		"Discount on total order at": "Réduction sur la totalité de votre commande chez ",
		"Discount type": "Réduction",
		"Discounts": "Réductions",
		"Discounts only": "Uniquement des réductions",
		"Discover all promotions!": "Découvrez toutes les promotions !",
		"Discover the <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.": "Découvrez nos <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Produits de soins à domicile en location</a>.",
		"Displayname": "Nom d'affichage",
		"Displays": "Displays",
		"Dit product wordt rechtstreeks geleverd bij de patiënt.": "Ce produit sera livré au patient à l’aide de la partie externe ESRI.",
		"Document (pdf)": "Document (PDF)",
		"Document library": "Infothèque",
		"Documents": "Documents",
		"Download": "Télécharger",
		"Download PDF": "Télécharger PDF",
		"Drag your file here or": "Faites glisser le fichier ici ou",
		"Dutch": "Néerlandais",
		"E-mail address and language for order confirmations:": "Vos commandes seront confirmées sur cette adresse:",
		"Email address": "Adresse e-mail",
		"Enkel te bestellen via uw vertegenwoordiger": "À commander via votre délégué",
		"Enter e-mailadress": "Entrez adresse e-mail",
		"Error": "Erreur",
		"Estimated Delivery Date": "Délai de livraison prévu",
		"Expected delivery date": "Date de livraison prévue",
		"Expires": "Expire",
		"Expires within {{productDiscount.daysLeft}} days": "Expire dans {{productDiscount.daysLeft}} jours",
		"Expires within {{vm.product.daysLeftUntilDiscountExpires}} days": "Expire dans {{vm.product.daysLeftUntilDiscountExpires}} jours",
		"Expiry date": "Date de péremption",
		"Extra info": "Informations supplémentaires",
		"FAQ": "FAQ",
		"Fast Order": "Commande rapide",
		"Fast order": "Commande rapide",
		"Fax:": "Fax:",
		"Featured products": "Produits sous la loupe",
		"Febelco stock info": "Stock info Febelco",
		"Filter": "Filtre",
		"Flu vaccines": "Vaccins anti-grippe ",
		"Following products can be ordered via 'special order', should the product not be in stock at the moment.": "Si les produits suivants ne sont plus en stock, ils peuvent être commandés via ‘Commandes spéciales’. ",
		"For more information about this contract, please contact your relationship manager.": "Pour de plus amples renseignements sur ce contrat, merci de vous adresser à votre chargé de relations.",
		"For more information about this contract, please contact your supplier.": "Pour de plus amples renseignements sur ce contrat, merci de vous adresser au labo. ",
		"French": "Français",
		"Frequently asked questions": "Questions fréquemment posées",
		"From": "Du",
		"From date must be greater than contract start date.": "La date doit être supérieure ou égale à la date de début du contrat.",
		"From&nbsp;{{vm.product.minOrderAmount}}": "à partir de&nbsp;{{vm.product.minOrderAmount}}",
		"GPM": "MBB",
		"Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.": "Veuillez ajouter ci-dessous une adresse pour la livraison des produits, ainsi que la personne qui peut être contactée par ESRI à propos de la livraison.",
		"General": "Général",
		"Go to today": {
			"Datetimepicker tooltips": "Aujourd'hui"
		},
		"Griepvaccins 2021-2022": "Vaccins anti-grippe 2021-2022",
		"Gross profit margin": "Marge bénéficiaire brute",
		"Gross profit margins (GPM) are calculated based on the pharmacy and public price (non-binding recommended prices).": "Les marges bénéficiaires brutes (MBB) sont calculées sur base du prix pharmacien et du prix public (prix conseillés non contraignants).",
		"Height": "Hauteur",
		"Hello": "Bonjour",
		"Help": "FAQ",
		"Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.": "Consultez ici les produits Soins à domicile que vous louez actuellement ainsi que vos demandes de location sur Profficina.",
		"Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.": "Consultez ici toutes vos commandes Profficina.",
		"Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.": "Consultez ici toutes vos réservations auprès de Febelco.",
		"Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.": "Vous trouverez ci-dessous vos réservations des douze derniers mois. Si vous souhaitez annuler une réservation, veuillez prendre contact avec votre service clientèle.",
		"Home": "Accueil",
		"Homepage": "Page d’accueil",
		"How can you enjoy this partnership?": "Comment profiter de cet avantage ?",
		"INFLUVAC S 2021-2022 0,5 ML 1 WWSP": "INFLUVAC S 2021-2022 0,5 ML 1 SER A JET",
		"In progress": "En cours de traitement",
		"In the spotlight": "Sous la loupe",
		"Increment Hour": {
			"Datetimepicker tooltips": "Augmenter l'heure"
		},
		"Increment Minute": {
			"Datetimepicker tooltips": "Augmenter les minutes"
		},
		"Increment Second": {
			"Datetimepicker tooltips": "Augmenter les secondes"
		},
		"Indication": "Indication",
		"Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.": "Influvac ne peut plus être réservé après un message du fournisseur le 1/4/20.",
		"Info": "Informations",
		"Invoiced": "Facturé",
		"Just a moment please, your order is being added to your shopping cart...": "Veuillez patienter, traitement des données en cours...",
		"Just a moment please, your order is being processed...": "Veuillez patienter, fichier en cours d’importation… ",
		"Klaar voor de winter?": "Prêt pour l'hiver? ",
		"Language": "Langue",
		"Learn more": "En savoir plus",
		"Lees meer": "Lire plus",
		"Limited stock!": "Stock limité !",
		"Location": "Emplacement",
		"Log in": "Connexion",
		"Log in with other pharmacy:": "Se connecter avec une autre pharmacie",
		"Max": "Max",
		"Max. discount": "Max. réduction",
		"Media": "Média",
		"Meer Details": "Plus de détails",
		"Mijn verzendingen": "Mijn verzendingen",
		"Mijn verzendingen bekijken": "Mijn verzendingen bekijken",
		"Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.": "Pour toute question à ce sujet, merci de prendre contact avec votre chargé(e) de relations.",
		"Modify": "Modifier",
		"Modify password": "Modifier mot de passe",
		"Month": [
			"mois",
			"mois"
		],
		"More info": "En savoir plus",
		"More info about": "More info about",
		"More info about 'special orders'.": "En savoir plus de 'Commande spéciales'.",
		"More than one pharmacy is linked to your account. Choose the pharmacy you wish to log on with.": "Plusieurs pharmacies sont liées à votre compte. Choisissez la pharmacie avec laquelle vous voulez vous connecter.",
		"More than one seller is linked to your account. Choose the seller you wish to log on with.": "Plusieurs fournisseurs sont liés à votre compte. Choisissez le fournisseur avec lequel vous voulez vous connecter.",
		"My account": "Mon compte",
		"My contracts": "Mes contrats",
		"My log in data": "Mes identifiants",
		"My orders": "Mes commandes",
		"My packages": "Mijn verzendingen",
		"My pharmacy": "Ma pharmacie",
		"My rent overview": "Mes demandes de location",
		"My reservations": "Mes Réservations",
		"Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.": "Febelco organise comme chaque année une prévente de vaccins antigrippaux, et ce jusqu'au 28 février 2021.",
		"Name": "Nom",
		"Name or APB or client number": "Nom ou APB ou numéro de client",
		"New order date must be before current order date": "Nouvelle date de livraison doit être antérieure à la date de livraison prévue.",
		"New order date must be later than today": "Nouvelle date de livraison doit être postérieure à aujourd'hui.",
		"Newest": "Dernières",
		"News": "Nouvelles",
		"News for": "Nouvelles pour",
		"News overview cannot be shown": "Fil d’actualité non disponible.",
		"Next": "Suivant",
		"Next Century": {
			"Datetimepicker tooltips": "Siècle suivant"
		},
		"Next Decade": {
			"Datetimepicker tooltips": "Décennie suivante"
		},
		"Next Month": {
			"Datetimepicker tooltips": "Mois suivant"
		},
		"Next Year": {
			"Datetimepicker tooltips": "Année suivante"
		},
		"No": "Non",
		"No certificates found for the given search criteria.": "Aucun certificat n'a été trouvé pour les critères de recherche saisis.",
		"No orders found": "Aucun résultat ne correspond à vos critères de recherche",
		"No passed rental products the last 3 months.": "Aucune demande de location n'a été terminée ces trois derniers mois.",
		"No products found.": "Produit introuvable.",
		"No results.": "Aucun résultat.",
		"No stock available": "Hors stock ",
		"Non Rental Products": "Produits achetés",
		"Non-binding recommended prices": "Prix conseillés non contraignants",
		"Not available": "Non disponible",
		"Note": "Remarque",
		"Notices": "Notices",
		"Notices for patient": "Notice pour patient",
		"N°": "N°",
		"N° displays": "N° displays",
		"OP=OP": "À saisir",
		"One or more products were not found": "Un ou plusieurs produit(s) introuvable(s)",
		"Only {{productDiscount.counter}} piece(s) left!": "Plus que {{productDiscount.counter}} article(s) disponibles.",
		"Only {{vm.counter}} piece(s) left!": "Plus que {{vm.counter}} articles disponibles.",
		"Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.": "Notre partenaire externe, ESRI, ne peut livrer que 24 heures après le moment de votre demande. Si vous avez besoin d'une demande urgente (par exemple pour un patient en soins palliatifs), veuillez contacter le service SÀD de Febelco par sad@febelco.be ou par le numéro 03/292.24.72. Ils examinent ensuite avec le partenaire externe ce qui est possible.",
		"Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op uw gekozen leveradres": "Le(s) produit(s) seront livrés à votre adresse de livraison le {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}}.",
		"Op=Op? These is the last stock for certain products for an extra discounted price. These products can not be returned.": "À saisir ? Ce sont des produits presque épuisés ne pouvant pas être retournés à un prix très avantageux. Visitez régulièrement notre site et découvrez chaque mois nos nouvelles promotions !",
		"Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.": "Attention : les quantités de vaccins antigrippaux sur cette page correspondent à la quantité totale de votre réservation initiale. Autrement dit, ces quantités ne tiennent pas compte des vaccins antigrippaux déjà livrés.",
		"Order": {
			"noun": "Commander",
			"verb": "Commander",
			"$$noContext": "Commande"
		},
		"Order - noun": "Commande",
		"Order confirmation": "Confirmer commande",
		"Order here": "Commander ici",
		"Order now": "Commander maintenant",
		"Order pack": "Commander le promopack",
		"Order panaché": "Découvrez les conditions panaché et passez vos commandes",
		"Order total": "Total commande",
		"Order total price": "Réduction sur la totalité de votre commande",
		"Ordered products": "Produits",
		"Orders are pharmacy based. When you log on as another pharmacy, your shopping basket will change. Your current shopping basket is however not removed.": "Les commandes se font par pharmacie. Si vous vous connectez avec une autre pharmacie, le panier sera modifié. Votre panier actuel ne sera toutefois pas supprimé. ",
		"Orders in Profficina are pharmacy based. Once logged on, you can always switch pharmacy through the 'My account' link in the menu.": "Les commandes dans Profficina se font par pharmacie. Dès que vous êtes connecté, vous pouvez toujours changer de pharmacie en cliquant sur le lien ‘Mon compte’ dans le menu.",
		"Other offers with this product": "Autres offres avec ce produit",
		"Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.": "Ce site utilise des cookies pour améliorer votre expérience de navigation. Si vous poursuivez la navigation, nous considérerons que vous acceptez leur utilisation.",
		"Outlet": "À saisir",
		"Overview": "Aperçu",
		"Overview all discounts": "Aperçu réductions",
		"Overzicht producten in reservatie": "Mes réservations",
		"PDF": "PDF",
		"PROMO": "PROMO",
		"Package quantity": "Quantité de colis",
		"PackageDetail": "Details verzending",
		"Packages archive": "Al mijn verzendingen",
		"Panaché": "Panaché",
		"Panaché:": "Panaché:",
		"Partially in progress by wholesaler": "Commande partiellement en cours de de traitement",
		"Partially invoiced": "Facturé partiellement",
		"Partially registered by wholesaler": "Enregistré partiellement ",
		"Partnerships": "Partenariats",
		"Password": "Mot de passe",
		"Pharmacy": "Pharmacie",
		"Pharmacy price": "Prix pharmacien",
		"Pick Hour": {
			"Datetimepicker tooltips": "Choisissez l'heure"
		},
		"Pick Minute": {
			"Datetimepicker tooltips": "Choisissez minutes"
		},
		"Pick Second": {
			"Datetimepicker tooltips": "Choisissez secondes"
		},
		"Place order": "Commander",
		"Please enter a date before {{vm.maxDate | date: 'dd-MM-yyyy'}}": "Veuillez choisir une date antérieure au {{vm.maxDate | date: 'dd-MM-yyyy'}}",
		"Please enter a date in the future": "Veuillez ajouter une date valable.",
		"Please enter a quantity.": "Entrez une quantité. ",
		"Please place your order within {{error.daysLeftUntilDiscountExpires}} days, discount for {{error.productName}} ends on {{error.expireDate | date:'yyyy-MM-dd'}}": "Veuillez passer votre commande dans les {{error.daysLeftUntilDiscountExpires}} jours, la réduction pour {{error.productName}} expire le {{error.expireDate | date:'yyyy-MM-dd'}}",
		"Please provide a street.": "Veuillez ajouter une rue.",
		"Please provide a valid city.": "Veuillez ajouter une ville valable.",
		"Please provide your contact person.": "Veuillez ajouter une personne à contacter.",
		"Please provide your housenumber.": "Veuillez ajouter votre numéro de maison.",
		"Please provide your telephone number.": "Veuillez ajouter votre numéro de téléphone.",
		"Please refine your search.": "Affinez votre recherche...",
		"Please select a pharmacy": "Sélectionnez une pharmacie",
		"Please select a seller": "Sélectionnez un fournisseur",
		"Prescription": "Sur prescription",
		"Previous": "Dernier",
		"Previous Century": {
			"Datetimepicker tooltips": "Siècle précédent"
		},
		"Previous Decade": {
			"Datetimepicker tooltips": "Décennie précédente"
		},
		"Previous Month": {
			"Datetimepicker tooltips": "Mois précédent"
		},
		"Previous Year": {
			"Datetimepicker tooltips": "Année précédente"
		},
		"Price": "Prix",
		"Price information": "Informations prix",
		"Price:": "Prix:",
		"Processing...": "Traitement en cours…",
		"Product": "Produit",
		"Product available": "Produit disponible",
		"Product discount": "Réduction produit",
		"Product info": "Informations produit",
		"Product information": "Informations produit",
		"Product name or number": "Nom ou numéro du produit",
		"Product name, number or lot number": "CNK, nom produit ou n° lot",
		"Product not found": "Numéro de produit introuvable",
		"Product number": "CNK",
		"Product number or product name": "Cnk ou nom produit",
		"Product number, name product": "Numéro de produit, nom du produit",
		"Product overview cannot be shown": "Aperçu produits non disponible",
		"Product status": "Statut produit",
		"Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}": "Date de péremption : {{productDiscount.expirationDate | date: 'dd/MM/yyyy'}}",
		"ProductNumber": "ProductNumber",
		"Producten die mogelijks\n                                            interessant zijn om bij te huren": "Produits intéressants à louer en addition de votre commande",
		"Producten die mogelijks\n                                            interessant zijn om bij te kopen": "Produits intéressants à acheter en addition de votre commande",
		"Producten die mogelijks interessant zijn om bij te huren": "Produits intéressants à louer en addition de votre commande",
		"Producten die mogelijks interessant zijn om bij te kopen": "Produits intéressants à acheter en addition de votre commande",
		"Productname or product number": "Nom produit ou numéro de produit",
		"Products": "Produits",
		"Products were added to your cart": "Les produits ont été ajoutés au panier.",
		"Profficina": "Profficina",
		"Profficina Ref.": "Profficina Réf.",
		"Profficina ref.": "Profficina Réf.",
		"Profficina ref. or TO-nr.": "Profficina Réf. ou TO N° bon",
		"Promopack": "Promopack",
		"Properties": "Propriétés",
		"Public categories": "Catégories publiques",
		"Public price": "Prix public",
		"Quantity": "Quantité",
		"Quantity in panaché": "Qté en panaché",
		"Quantity:": "Quantité",
		"Questions or remarks concerning the pharmacovigilance of one of our products?": "Des questions ou des remarques sur la pharmacovigilance d’un de nos produits ? ",
		"Questions? More info?": "Des questions ? En savoir plus ?",
		"Read more": "Plus d'infos",
		"Read our FAQ": "Consultez notre FAQ",
		"Receipt": "Note de commande",
		"Recently passed rental products": "Locations terminées récemment",
		"Reference codes": "Codes de références",
		"Refund value with omnio": "Tarif Omnio",
		"Refund value without omnio": "Tarif de remboursement",
		"Refunded deposit": "Restitution caution",
		"Registered": "Enregistré",
		"Registered by seller": "Enregistré par le fournisseur",
		"Related news": "Actualités liées",
		"Rent": {
			"Verb": "Louer"
		},
		"Rent per day": "Prix de location par jour",
		"Rent per day:": "Prix de location par jour:",
		"Rent products": "Produits de location",
		"Rental amount per month": "Prix de location par mois",
		"Rental products": "Produits de location",
		"Rental products in your possession": "Locations en cours",
		"Rental request (Pdf)": "Demande (PDF)",
		"Rental service": "Location",
		"Rented from": "Loué depuis le",
		"Rented product detail": "Détails produit de location",
		"Rented since – until": "Loué du &ndash; au",
		"Rented until": "Loué jusqu'au",
		"Rented until – from": "Loué du &ndash; au",
		"Reorder": "Dupliquer commande",
		"Replacement product available": "Produit de remplacement disponible ",
		"Required&nbsp;{{vm.product.minOrderAmount}}": "{{vm.product.minOrderAmount}}&nbsp; pièces requises",
		"Reservation time": "Réservé depuis",
		"Reservation time:": "Réservé depuis:",
		"Reserved products at Febelco": "Aperçu des produits en réservation",
		"Reserveer nu uw griep vaccins": "Réservez vos vaccins contre la grippe ici.",
		"Reset": "Supprimer",
		"Retroactive discount": "Réduction rétroactive",
		"Return": "Retour",
		"Return to the homepage": "Retour à la page d’accueil",
		"Route number": "Numéro de route",
		"Running low on stock!": "Stock presque épuisé !",
		"Save": "Enregistrer",
		"Scientific notices": "Notice scientifique",
		"Search": "Rechercher",
		"Search by contract name": "Recherche par nom contrat",
		"Search by name": "Recherche par nom",
		"Search by name or number": "Recherche par nom ou code Numéro de produit",
		"Search products by number or name": "Recherche produits par nom ou code Numéro de produit",
		"See the latest discounts": "Consultez les dernières réductions",
		"Select Decade": {
			"Datetimepicker tooltips": "Sélectionnez décennie"
		},
		"Select Month": {
			"Datetimepicker tooltips": "Sélectionnez mois"
		},
		"Select Year": {
			"Datetimepicker tooltips": "Sélectionnez année"
		},
		"Select other pharmacy": "Sélectionnez une autre pharmacie",
		"Select other seller": "Sélectionnez un autre fournisseur",
		"Select wholesaler": "Sélectionnez grossiste",
		"Seller": "Fournisseur",
		"Sellers": "Fournisseurs",
		"Send a fax to": "Envoyez un fax au",
		"Send an e-mail to": "Envoyez un e-mail à",
		"Send application": "Envoyer demande",
		"Sent to seller": "Envoyé au fournisseur",
		"Serialnumber": "Numéro de série",
		"Shipping note": "Note d'envoi",
		"Shopping cart": "Panier",
		"Show all": "Afficher tout",
		"Show all results": "Afficher tous les résultats",
		"Show in grid": "Afficher dans un tableau",
		"Show in list": "Afficher dans une liste",
		"Show less": "Afficher moins",
		"Side effects": "Effets secondaires",
		"Sign out": "Se déconnecter",
		"Sold out!": "Trop tard !",
		"Something went wrong": "Une erreur est survenue.",
		"Something went wrong when loading this page.": "Une erreur est survenue lors du chargement de cette page.",
		"Something went wrong while adding the products to your shoppingcart.": "Une erreur est survenue. Les produits n’ont pas pu être ajoutés au panier.",
		"Something went wrong while adding your products, please try again.": "Une erreur est survenue. Les produits n’ont pas pu être ajoutés au panier.",
		"Something went wrong with the import of your file. Please check your CSV and try again.": "Une erreur est survenue lors de l’importation du fichier CSV. Veuillez vous assurer que le fichier est correct et réessayer. ",
		"Sort": "Trier",
		"Sort by": "Trier par",
		"Special Discounts": "Speciale kortingen (FR)",
		"Special order possible": "Commande spéciale possible",
		"Special orders": "Commandes spéciales",
		"Status": "État",
		"Stock response cannot be checked at the moment.": "Le stock n’est actuellement pas consultable.",
		"Street": "Rue",
		"Subtotal": "Sous-total",
		"Suggesties": "Suggestions",
		"Supplier": "Fournisseur",
		"Supplier has no stock available": "Non tenu en stock par le fournisseur",
		"Supplier reference": "Référence fournisseur",
		"TO-nr.": "TO N° bon",
		"Tags": "Étiquettes",
		"Tax": "TVA",
		"Tel:": "Tél:",
		"Telephone number": "Numéro de téléphone",
		"Thank you for ordering": "Merci de votre commande.",
		"The Agios discount is not known, contact the supplier for more info.": "Réduction Agios inconnue. Pour en savoir plus, veuillez prendre contact avec le fournisseur.",
		"The CSV was empty.": "Le fichier CSV est vide. Veuillez vous assurer que le fichier est correct et réessayer.",
		"The last 3 months you did not submit any rental applications via Profficina.": "Aucune demande de location n'a été faite sur Profficina ces trois derniers mois.",
		"The last 3 months, you ended rent for more than 15 products.": "Plus de 15 locations ont été terminées ces trois derniers mois.",
		"The orders could not be retrieved": "Une erreur s’est produite lors de l’affichage des commandes.",
		"The partnerships could not be retrieved": "Une erreur s’est produite lors de l’affichage des partenariats.",
		"The product could not be added to your shopping cart": "Le produit n’a pas pu être ajouté au panier.",
		"The product could not be removed from your shopping cart": "Le produit n’a pas pu être retiré du panier.",
		"The product quantity could not be updated": "La quantité du produit n’a pas pu être modifiée.",
		"The product you were looking was not found or is inactive.": "Le produit est introuvable ou est inactif.",
		"The products cannot be retrieved.": "Une erreur s’est produite lors de l’affichage des produits.",
		"The products could not be removed from your shopping cart": "Le produit n’a pas pu être retiré du panier.",
		"The quantity of one or more products is incorrect.": "Un ou plusieurs produit(s) ne renseigne(nt) pas la quantité.",
		"The shaded products can no longer be ordered.": "Les produits hachurés ne peuvent plus être commandés.",
		"There are currently no discounts available": "Aucun réduction n’est actuellement disponible.",
		"There are currently no products available": "Aucun produit n’est actuellement disponible.",
		"There are still products in your shopping cart": "Il y a encore des produits dans votre panier",
		"This product is in Agios, the discount displayed is not the Agios discount.": "Ce produit fait partie d'Agios, la réduction affichée n'est pas une réduction Agios.",
		"This promopack contains following products": "Ce paquet de promotion contient les produits suivants",
		"Time": "Moment",
		"To TGZ homepage": "Retour à la page d'accueil sad",
		"Too many results.": "Plus de 20 résultats.",
		"Total": "Total",
		"Total (incl. VAT)": "Total (TVA incluse)",
		"Total discount": "Réduction totale",
		"Total quantity in panaché": "Quantité totale en panaché",
		"Total rent": "Prix de location total",
		"Trade in months after expiry": "Échange en mois après expiration",
		"Trade in months before expiry": "Trade in months before expiry",
		"U heeft momenteel geen openstaande reservaties.": "Vous n’avez aucune réservation ouverte en ce moment.",
		"U heeft voor dit partnership een {{contract.name}} contract van onbepaalde duur vanaf {{contract.startDate | date}}": "Pour ce partenariat, vous avez un contrat {{contract.name}} de durée indéterminée ayant pris effet le {{contract.startDate | date}}.",
		"U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot {{contract.endDate | date}}": "Pour ce partenariat, vous avez un contrat {{contract.name}} du {{contract.startDate | date}} au {{contract.endDate | date}}",
		"Undo changes": "Annuler changements",
		"Unfortunately there are no products available for the current criteria.": "Aucun produit ne correspond aux critères sélectionnés.",
		"Unfortunately there were no certificates found.": "Aucun certificat n'est actuellement disponible.",
		"Unfortunately there were no items found from Profficina.": "Aucune demande de location n'a été faite sur Profficina.",
		"Unfortunately there were no news items found.": "Aucune nouveauté ne correspond aux critères sélectionnés.",
		"Unfortunately there were no partnerships found.": "Aucun avantage ne correspond aux critères sélectionnés.",
		"Unfortunately there were no rental products found.": "Produits de location introuvables.",
		"Unfortunately there were no rental requests found.": "Aucune demande de location n’a été trouvée.",
		"Until": "Au",
		"Up to": "Jusqu’à",
		"Update cart": "Mise à jour panier",
		"Update shopping cart [ENTER]": "Mettre à jour panier [ENTER]",
		"Updating your cart...": "Mise à jour panier en cours...",
		"Usage": "Utilisation",
		"Uw aanvraag": "Votre demande",
		"Uw contract": "Votre contrat",
		"Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.": "Vos vaccins antigrippaux réservés ont été ajoutés à la liste des réservations ci-dessous, mais nous ne pouvons plus faire de nouvelles réservations.",
		"Uw huuraanvraag": "Votre demande de location",
		"Uw huuraanvraag is verstuurd naar de klantendienst.": "Votre demande de location a été envoyée au service clientèle.",
		"VAT": "TVA",
		"VAT:": "TVA:",
		"VAXIGRIP TETRA 2021-2022 0,5 ML 1 WWSP": "VAXIGRIP TETRA 2021-2022 0,5 ML 1 SER A JET",
		"Valid from": "Valable du   ",
		"Valid from - until": "Valable du - au",
		"Valid until": "Valable jusqu'à",
		"Vendor": "Fournisseur",
		"Verstuur": "Envoyer",
		"Verzending": "Verzending",
		"View my orders": "Mes commandes",
		"View my packages": "Mijn verzendingen bekijken",
		"View my rent overview": "Mes demandes de location",
		"View my reservations": "Mes réservations",
		"View your shopping basket": "Ouvrir votre panier",
		"Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be": "Si vous avez des questions relatives à votre demande, ou si vous aimeriez faire des ajustements, veuillez contacter le service clientèle par téléphone au numéro [03/770.70.70] ou adressez-vous à klantendienst@febelco.be.",
		"We can not find the page you are looking for. The product / news item / ... may no longer exist.": "La page que vous demandez est introuvable. Il se peut que le lien vous avez utilisé ne soit plus valable.",
		"Weight": "Poids",
		"What would you like use to do <strong>when these products are not in stock</strong>?": "LE CAS ÉCHÉANT, <strong>QUE SOUHAITEZ-VOUS FAIRE?</strong>",
		"Wholesaler": "Grossiste",
		"Width": "Largeur",
		"active": "Actif",
		"inactive": "Inactif",
		"true": "Oui",
		"false": "Non",
		"Written request by patient": "Sur demande écrite du patient",
		"U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.": "Ces vaccins ne peuvent être réservés que sur Profficina. Nous vous recommandons vivement de bien estimer les quantités dont vous avez besoin, afin que nous puissions aligner notre stock sur celles-ci.",
		"Wij raden aan om\n                                            hierbij ook deze producten te huren": "Nous vous conseillons de louer les produits suivants en supplément",
		"Wij raden aan om\n                                            hierbij ook deze producten te kopen": "Nous vous conseillons d’acheter les produits suivants en supplément",
		"Wij raden aan om hierbij ook deze producten te huren": "Nous vous conseillons de louer les produits suivants en supplément",
		"Wij raden aan om hierbij ook deze producten te kopen": "Nous vous conseillons d’acheter les produits suivants en supplément ",
		"Withdrawn product": "Produit retiré du marché",
		"Maximum quantity exceeded.": "Maximum quantity exceeded.",
		"Year": "Année",
		"Yes": "Oui",
		"You are logged in with pharmacy": "Vous êtes connecté avec la pharmacie ",
		"You are logged in with seller": "Vous êtes connecté avec le fournisseur",
		"You are now logged in with pharmacy": "Vous êtes connecté avec la pharmacie ",
		"You can choose from the following products:": "Vous avez le choix parmi les produits suivants :",
		"You currently do not rent products from Febelco.": "Actuellement, vous ne louez pas de produits Febelco.",
		"You did not update your cart with the quantities you last modified.": "Les dernières quantités modifiées n’ont pas encore été ajoutées à votre panier.",
		"You do not have permission to view this page.": "Vous n’êtes pas autorisé à consulter cette page.",
		"You have more than 15 rental products in your possession.": "Vous louez actuellement plus de 15 produits.",
		"You have more than 15 rental requests in the last 3 months.": "Plus de 15 locations les derniers 3 mois.",
		"You have not rented products from Febelco.": "Vous n’avez loué aucun produit.",
		"You searched for": "Vos résultats de recherche pour",
		"You will receive an email confirmation shortly at {{ vm.mail }}.": "Une confirmation vous a été envoyée par courrier électronique à l’adresse {{ vm.mail }}.",
		"Your browser does not support file upload.": "Your browser does not support file upload.",
		"Your info": "Vos données",
		"Your purchases": "Vos achats",
		"Your recent rental requests": "Locations demandées récemment sur Profficina",
		"Your rent request on": "Demande du",
		"Your reservation has been confirmed.": "Votre réservation a bien été enregistrée.",
		"Your search value": "Votre terme de recherche",
		"Your shopping cart": "Votre panier",
		"_myDocuments._reportNarcotics.description": "Vous trouverez ici un aperçu des produits (contenant des substances énumérées dans les annexes I, II et IV de l’A.R. du 06/09/2017) pour lesquels vous ne nous avez pas encore remis de bon de stupéfiant.",
		"_myDocuments._reportNarcotics.title": "Bons de stupéfiant non traités",
		"_myDocuments._reportPurchaseProposals.description": "Ce rapport est un tableau récapitulatif de vos achats et indique clairement – pour chaque CNK – combien de pièces (1/5/10 pc.) vous devriez acheter pour pouvoir bénéficier d'une réduction maximale. Ces propositions vous aident également à limiter le nombre de livraisons d’un CNK au cours de la même période de facturation, et permettent ainsi d’augmenter votre efficacité.",
		"_myDocuments._reportPurchaseProposals.title": "Propositions d’achat",
		"_myDocuments._settings.introText": "Vous trouverez ici un aperçu des bons de stupéfiant que vous devez encore nous remettre, ainsi qu’un aperçu de vos propositions d’achat.",
		"_myDocuments._settings.myDocuments": "Mes documents",
		"_myDocuments._settings.viewMyDocuments": "Visionner documents",
		"_myDocuments._siteHeader.myDocuments": "Mes documents",
		"_myDocuments.downloadDocument": "Télécharger document",
		"_myDocuments.myDocuments": "Mes documents",
		"_selftests.linkToFaq": "Pour toutes vos questions sur le kit COVID, merci de prendre contact avec votre chargé(e) de relations.",
		"_reservationCampaigns.product": "Produit",
		"_reservationCampaigns.productNumber": "CNK",
		"_reservationCampaigns.quantity": "Quantité",
		"_reservationCampaigns.reservationConfirmed": "Votre réservation a bien été enregistrée.",
		"_reservationCampaigns.save": "Réserver",
		"_reservationCampaigns.totalLimitReached": "Limite de réservation atteinte.",
		"_reservationCampaigns.limitReached": "Maximum {{limit}} pc.",
		"article": [
			"article",
			"articles"
		],
		"at": {
			"delivered on april 14th AT 17:25": "à"
		},
		"can be delivered on": "Ces produits pourront être livrés au plus tôt le ",
		"certificate": [
			"certificat",
			"certificats"
		],
		"checkout.agreeWithTerms": "En cliquant sur \"Confirmer commande\", vous acceptez les <a href=\\\"http://www.profficina.be/nl/algemene-voorwaarden.html\\\" class=\\\"link link-primary\\\" target=\\\"_blank\\\">conditions générales d’utilisation de Profficina</a>.",
		"checkout.contactSupportWhenInvoiceAddressIsIncorrect": "Si ces informations ne sont pas correctes, veuillez prendre contact avec <a href=\"mailto:support@profficina.be\">support@profficina.be</a>.",
		"checkout.linkToOrderOverview": "Vous pouvez toujours consulter les détails de vos commandes via 'Mon compte' <i class=\"ico ico-angle-right\"></i> '<a ui-sref=\"order-overview\" class=\"link link-primary\">Mes commandes</a>' en haut de la page.",
		"discount": "réduction",
		"discounts": "réductions",
		"documents": "documents",
		"indefinite": "pour une durée indéterminée",
		"indefinitely": "durée indéterminée",
		"news": "nouvelles",
		"no": "non",
		"or Send an email to": "ou envoyez un e-mail à",
		"parcel.addAnotherLine": "Ajouter un colis",
		"parcel.addConfirmationExplanations": "Een woordje uitleg wat men nu moet doen   ... Text TBD",
		"parcel.allMyParcels": "Tous mes envois",
		"parcel.back": "Précédent",
		"parcel.backToOverview": "Retour à l’aperçu",
		"parcel.barcode": "Code-barres",
		"parcel.cancel": "Annuler envoi",
		"parcel.cancelParcel": "Annuler colis",
		"parcel.checkData": "Vérifiez les données ci-dessus et confirmez que vous êtes d'accord avec",
		"parcel.confirmOrder": "Confirmer envoi",
		"parcel.createParcel": "Créer envoi",
		"parcel.createShippingLabelHere": "Envoyer un colis à une pharmacie via Febelco ? Créez une étiquette d'envoi ici.",
		"parcel.customerNumber": "Numéro client Febelco",
		"parcel.deliveredWithin48": "Binnen 48u geleverd op bestemming",
		"parcel.enterLicenseNumberLong": "Saisissez le numéro d'autorisation de la pharmacie où votre colis doit être livré. L'adresse du destinataire sera automatiquement affichée sur le prochain écran.",
		"parcel.enterLicenseNumberShort": "Veuillez saisir numéro d'autorisation.",
		"parcel.febelcoNotResponsibleForContent": "Febelco n'est pas responsable du contenu des colis.  ",
		"parcel.followWithTrackAndTrace": "Suivi via le système Track & Trace",
		"parcel.giveParcelToCourier": "Geef uw pakket met label aan de Febelco koerier",
		"parcel.hereYouCanRegister": "Ici, vous pouvez enregistrer un colis à envoyer à une autre pharmacie via Febelco, et suivre le statut de vos envois.",
		"parcel.howDoesItWork": "Hoe werkt het?  ..TBD",
		"parcel.iAgreeToTheTerms": "Je suis d'accord avec les termes et conditions.",
		"parcel.latestShipments": "Les envois des 6 derniers mois",
		"parcel.licenseNumber": "Numéro d'autorisation",
		"parcel.licenseNumberShort": "N° d'autorisation",
		"parcel.isSigned": "Recevoir la signature",
		"parcel.insurance": "Assurance",
		"parcel.insuranceDescription": "Prix ​​€{{insurancePrice}}. Si le colis est assuré, une signature sera également demandée lors de sa réception.",
		"parcel.required": "Obligatoire",
		"parcel.packageValue": "Valeur d'un forfait",
		"parcel.packagePrice": "Prix du coffret: ",
		"parcel.packageDiscount": "Pakket korting: ",
		"parcel.insuranceInvoiceAmount": "Prix ​​facturé pour l'assurance : ",
		"parcel.packageInvoiceAmount": "Prix ​​facturé pour le forfait: ",
		"parcel.freePackage": "Ce forfait est gratuit, toute assurance complémentaire sera toujours facturée.",
		"parcel.line": [
			"colis",
			"colis"
		],
		"parcel.madeOn": "Créé le",
		"parcel.myParcels": "Mes envois",
		"parcel.nameApbOrCustomerNr": "Nom, n° APB, n° client",
		"parcel.next": "Suivant",
		"parcel.no": "Non",
		"parcel.noParcelsFound": "Aucune expédition trouvée.",
		"parcel.noParcelsFoundForCriteria": "Aucun envoi ne correspond aux données saisies.",
		"parcel.noPharmacyFound": "Aucune pharmacie ne correspond aux données saisies.",
		"parcel.orderNumber": "Envoi ID ",
		"parcel.packLower": [
			"colis",
			"colis"
		],
		"parcel.packages": "Colis",
		"parcel.parcel": "Expédition",
		"parcel.parcelBarcode": "Code-barres colis",
		"parcel.parcelCancelCommandSent": "Veuillez patienter, l'annulation de votre colis ou envoi est en cours.",
		"parcel.errorSendingCancelCommand": "Un problème est survenu lors de l'annulation de votre colis ou de votre envoi.",
		"parcel.parcelLower": [
			"expédition",
			"verzendingen"
		],
		"parcel.perPage": "par page",
		"parcel.pleaseAgreeToTerms": "Veuillez accepter les termes et conditions.",
		"parcel.pleaseSelectPackageType": "Veuillez indiquer le type de colis que vous souhaitez envoyer. ",
		"parcel.printAndHandToDriver": "Imprimez les étiquettes d'envoi et remettez le colis à votre chauffeur.",
		"parcel.printLabel": "Imprimer étiquette d'envoi",
		"parcel.remarkForCourier": "Remarque / Message pour le courrier",
		"parcel.remarkForCourierDescription": "Ici, vous pouvez ajouter des renseignements supplémentaires ou des instructions pour le courrier.",
		"parcel.reset": "Supprimer",
		"parcel.search": "Rechercher",
		"parcel.searchAllParcels": "Recherchez un de vos envois ou créez un nouvel envoi.",
		"parcel.sendTo": "Envoyer à",
		"parcel.sentTo": "Destinataire",
		"parcel.shippingDetail": "Détails envoi",
		"parcel.shippingDetails": "Détails envoi",
		"parcel.signatureRequired": "Signer à la réception",
		"parcel.signatureRequiredDescription": "Lorem ipsum dolor sit amet...",
		"parcel.theConditions": "les termes et conditions.",
		"parcel.to": "À l'adresse suivante",
		"parcel.trackAndTraceInDetail": "L'activité Track & Trace en détail",
		"parcel.until": "jusqu'au",
		"parcel.viewMyParcels": "Voir mes envois",
		"parcel.whatCanBeSentAndHowItWorks": "Een woordje uitleg over wat men kan verzenden en hoe het werkt.",
		"parcel.whatToSend": "Que voulez-vous expédier ?",
		"parcel.whichPharmacyToSend": "À quelle pharmacie souhaitez-vous envoyer un colis ?",
		"parcel.yes": "Oui",
		"parcel.youHaveNoRecentParcels": "Aucun envoi n'a été enregistré récemment.",
		"parcel.yourParcelWasRegistered": "Votre envoi a été enregistré.",
		"partnerships": "partenariats",
		"pcs.": "pc.",
		"per page": "par page",
		"product": [
			"produit",
			"produits"
		],
		"product.medipim.expires": "Date de péremption",
		"product.medipim.refundValueWithOmnio": "Tarif Omnio",
		"product.medipim.refundValueWithoutOmnio": "Tarif de remboursement",
		"product.medipim.tradeInMonthsAfterExpiry": "Période d'échange après la date de péremption",
		"product.medipim.tradeInMonthsBeforeExpiry": "Période d'échange avant la date de péremption",
		"product.status.active": "Actif",
		"product.status.inactive": "Inactif",
		"product.status.replaced": "Remplacé",
		"products": "Produits",
		"products available in your warehouse": "produits disponibles dans votre siège. ",
		"products available": "produits disponibles",
		"refundOnDate": "le",
		"rental product": [
			"produit de location",
			"produits de location"
		],
		"rental request": [
			"demande de location",
			"demandes de location"
		],
		"select file": "sélectionnez un fichier",
		"tour": "tournée",
		"until": "au",
		"upward of": "à partir de",
		"v.a. {{d.amount}} st.": "À partir de {{d.amount}} pc.",
		"vac test": "\"Dès aujourd’hui, vous pouvez réserver vos vaccins exclusivement sur la plateforme d’achat Profficina. Vous pouvez égalementy consulter les réductions par produit, et les quantités réservées. Facile, non ?Vous n’avez pas encore de compte sur Profficina ? Prenez contact avec votre chargé de relations, ou envoyez un e-mail àsupport@profficina.be.\"",
		"yes": "oui",
		"{{ vm.activeCategory ? vm.activeCategory.name : 'All rental products'}}": "{{ vm.activeCategory ? vm.activeCategory.name : 'Tous les produits de location'}}",
		"_order.selectAccountTitle": "Sélectionnez votre compte client",
		"Dear Pharmacist,": "Cher pharmacien,",
		"From 23/01/2023 <strong>you</strong> and anyone who gives you rights, <strong>can manage the reservations yourself</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, our new customer portal: changing, removing or adding can then be done in a few mouse clicks.": "À partir du 23/01/2023, vous et tous ceux à qui vous donnez les droits pourront simplement gérer les réservations via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>: vous pouvez les modifier, les supprimer ou les ajouter en quelques clics.",
		"Via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> you also get direct access to all kinds of information, personal data and useful tools. Calling customer service is no longer necessary, so they have more time to help our customers on the line faster.": "Vous bénéficiez également via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> d'un accès direct à toutes sortes d'informations, de données personnelles et d'outils utiles. Il ne sera plus nécessaire d'appeler le service client, ils auront donc plus de temps pour aider nos clients en ligne plus rapidement.",
		"Due to this progress, the <strong>reservation overview</strong> will no longer be available on Profficina and your secure area (my Febelco) <strong>from 16/01</strong>.": "En raison de cette évolution, l'aperçu des réservations ne sera plus disponible sur Profficina et votre zone sécurisé (mon Febelco) à partir du 16/01.",
		"<strong>Questions?</strong><br>Before you can go to MyFebelco, you must activate your account on the basis of a registration email.": "<strong>Des questions?</strong><br>Avant de pouvoir accéder à MyFebelco, vous devez activer votre compte sur la base d'un email d'inscription.",
		"Didn't receive a registration email? Then contact <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>.": "Vous n'avez pas reçu d'e-mail d'inscription? Alors contactez <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>."
	}
};

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = {
	"nl": {
		"(Will be) delivered": "Wordt geleverd",
		"(Will be) partially delivered": "Wordt deels geleverd",
		"(excl. btw - {{d.promoCode}} - Valid until {{d.endDate | date: 'dd/MM/yyyy'}})": "(excl. btw - {{d.promoCode}} - Geldig tot {{d.endDate | date: 'dd/MM/yyyy'}})",
		".csv file, max. 5MB": "CSV-bestand, max. 5MB",
		"<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>": "<a href=\"http://www.profficina.be\" target=\"_blank\" class=\"link\">www.profficina.be</a>",
		"<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Terms and conditions</a>": "<a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" target=\"_blank\" class=\"link\">Algemene gebruiksvoorwaarden</a>",
		"<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy policy</a>": "<a href=\"http://www.profficina.be/nl/privacy-beleid.html\" target=\"_blank\" class=\"link\">Privacy beleid</a>",
		"<b>Niet te reserveren</b>": "<b>Niet te reserveren.</b>",
		"<b>Zonder korting</b>": "<b>Te reserveren zonder korting.</b>",
		"<strong>Do not order</strong> the products.": "de producten <strong>niet te bestellen</strong>.",
		"<strong>Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.": "<strong style=\"color: #82BC00;\">Opgelet!</strong> Geen retours mogelijk. Levering van zodra voorradig en zolang de voorraad strekt.",
		"<strong>Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.": "<strong style=\"color: #82BC00;\">Opgelet!</strong> U kan na 28 februari 2021 uw gereserveerde aantallen niet meer wijzigen.",
		"<strong>Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.": "<strong  style=\"color: #82BC00;\">Opgelet!</strong> het maximale reservatieniveau voor de Influvac vaccins werd bereikt. Het is dus niet meer mogelijk om deze te reserveren. U kan uw eerder gereserveerde Influvac vaccins wel nog raadplegen, maar niet langer wijzigen.",
		"<strong>Order</strong> the products <strong>anyway</strong> via the customer service ('special order').": "De producten <strong>bestellen</strong> via de klantendienst (‘Speciale bestellingen’). ",
		"A question? A suggestion?": "Een vraag? Een suggestie?",
		"ALPHARIX TETRA 2020-2021 0,5 ML 1 WWSP": "ALPHARIX TETRA 2020-2021 0,5 ML 1 WWSP",
		"APB category": "APB categorie",
		"APB-number": "Vergunningsnummer",
		"About us": "Over ons",
		"Access is denied": "Toegang geweigerd",
		"Account": "Account",
		"Active ingredients": "Actieve bestandsdelen",
		"Add": "Toevoegen",
		"Add package": "Verzending toevoegen",
		"Add products or import a CSV file with your order.": "Geef producten in of importeer een csv-bestand met uw bestelling.",
		"Add to shopping cart": "In winkelmand",
		"Add {{ vm.product.quantityToAddForHighestDiscount }} pcs. for {{ vm.product.highestDiscount.discount }}% discount": "Voeg {{ vm.product.quantityToAddForHighestDiscount }} stuks toe voor {{ vm.product.highestDiscount.discount }}% korting",
		"Added products to your shoppingcart": "De producten zijn toegevoegd aan uw winkelmand.",
		"Address": "Adres",
		"Al mijn verzendingen": "Al mijn verzendingen",
		"All categories": "Alle categorieën",
		"All discounts": "Alle kortingen",
		"All my rental requests": "Al mijn huuraanvragen",
		"All my rented products": "Al mijn huurproducten",
		"All news": "Alle nieuws",
		"All partnerships": "Alle partners",
		"All pharmacies": "Alle apotheken",
		"All products": "Alle producten",
		"All products of this supplier or in your contract.": "Alle producten van deze leverancier zitten in uw contract.",
		"All rental products": "Alle huurproducten",
		"All sellers": "Alle aanbieders",
		"All vendors": "Alle aanbieders",
		"Amount": "Bedrag",
		"An error occured when adding products to your shoppingcart, please try again": "Er is iets foutgelopen, probeer het a.u.b. opnieuw",
		"An error occurred during the confirmation of the order. Please contact the customer support.": "Er heeft zich een onverwacht probleem voorgedaan tijdens de bevestiging van uw order. Neem aub contact op met de klantendienst. Onze excuses voor het ongemak.",
		"An error occurred during the re order. Please contact the customer support.": "Er heeft zich een onverwacht probleem voorgedaan tijdens de bevestiging van uw order. Neem aub contact op met de klantendienst. Onze excuses voor het ongemak.",
		"An overview of all rental products since 2019.": "Een overzicht van alles wat u huurde sinds 2019.",
		"Are you sure you want to clear your shopping cart?": "Bent u zeker dat u uw winkelmand wil leegmaken?",
		"At least": "Minstens",
		"Attention!": "Opgelet!",
		"Available": "Voldoende voorraad",
		"Back to overview": "Terug naar overzicht",
		"Batch number": "Lot",
		"Below are some useful links:": "Hieronder vindt u enkele handige links:",
		"Bewaren": "Bewaren",
		"Billing address": "Facturatieadres",
		"Black Friday": "Black Friday",
		"Box.": "Bus",
		"Box:": "Bus: ",
		"Box: {{vm.partnership.partner.address.boxNumber}}": "Bus: {{vm.partnership.partner.address.boxNumber}}",
		"Brand": "Merk",
		"Brands": "Merken",
		"Buy": "Bestellen",
		"CNK": "CNK",
		"CTI extended": "CTI extended",
		"Call": "Bel naar",
		"Cancel": "Annuleren",
		"Cancelled": "Geannuleerd",
		"Categories": "Categorieën",
		"Categorisation": "Categorisatie",
		"Certificates": "Certificaten",
		"Certificates headerlink": "Analyse<br />certificaten",
		"Certificates introtext": "<p>Bij elk grondstof hoort een analysecertificaat, zo ook bij <strong>Febelcare Elements</strong>. <strong>Dankzij Profficina</strong> heeft u altijd en overal <strong>toegang tot deze certificaten!</strong></p><p>Een analysecertificaat opvragen doet u eenvoudigweg door het lotnummer, het CNK of de productnaam op de verpakking hieronder in te geven. Het kan zijn dat er geen lotnummer gevonden wordt. Dit betekent dat het nummer vervallen is of dat het certificaat gewoonweg niet is opgenomen in de database.</p><p>Bij eventuele problemen, kunt u steeds terecht bij onze klantendienst. Zij helpen u graag verder.</p>",
		"Certificates title": "Op zoek naar een analysecertificaat?",
		"Change": "Wijzigen",
		"Check stock": "Raadpleeg voorraad",
		"Check your order": "Kijk uw bestelling na",
		"Checking stock...": "Voorraad wordt gecheckt",
		"City": "Stad",
		"Clear": "Wissen",
		"Clear all": "Alles wissen",
		"Clear all filters": "Alle filters verwijderen",
		"Clear selection": {
			"Datetimepicker tooltips": "Wissen"
		},
		"Clear shopping cart": "Winkelmand leegmaken",
		"Click here to see the complete list.": "Klik hier om de volledige lijst te zien.",
		"Close": "Sluiten",
		"Close and don't show again": "Niet meer weergeven",
		"Close the picker": {
			"Datetimepicker tooltips": "Kalender sluiten"
		},
		"Company number": "Ondernemingsnummer",
		"Compose your panacea by choosing products from the list below.": "Stel uw panaché samen aan de hand van de producten uit onderstaande lijst.",
		"Composition": "Samenstelling",
		"Confirm": "Bevestigen",
		"Confirm order": "Bestelling bevestigen",
		"Confirmation": "Bevestiging",
		"Conservation": "Bewaring",
		"Contact": {
			"$$noContext": "Contact",
			"Contact page title": "Contact"
		},
		"Contact person": "Contactpersoon",
		"Contacts": "Contactpersonen",
		"Continue shopping": "Verder winkelen",
		"Continue without updating cart": "Verdergaan zonder winkelmand aan te passen",
		"Contra indication": "Contra-indicatie",
		"Contract name": "Contract naam",
		"Contracts": "Contracten",
		"Counter discount": "Tellerkorting",
		"Created": "Gecreëerd",
		"Current discount": "Huidige korting",
		"Current filters": "Huidige filters",
		"Currently you do not have any Febelco Partner or Agios contract.": "U heeft nog geen contract voor dit partnership.",
		"Customer number": "Klantnummer",
		"DD-MM-YYYY": "DD-MM-JJJJ",
		"Date": "Datum",
		"De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.": "De minimumhuurtijd bedraagt 7 kalenderdagen. Er worden €60 transportkosten (AP excl BTW) aangerekend; deze kost omvat leveren, ophalen, reiniging en de administratieve afhandeling. ESRI zal niets factureren aan de patiënt. Alle facturatie verloopt via uw apotheek.",
		"Decrement Hour": {
			"Datetimepicker tooltips": "Uur verlagen"
		},
		"Decrement Minute": {
			"Datetimepicker tooltips": "Minuten verlagen"
		},
		"Decrement Second": {
			"Datetimepicker tooltips": "Seconden verlagen"
		},
		"Deficit": "Tekort",
		"Delayed deliveries": "Volgende bestellingen worden later geleverd",
		"Delete": "Verwijderen",
		"Deliver earlier": "Leveringsdatum vervroegen",
		"Delivered": "Geleverd",
		"Deliveries": "Leveringen",
		"Delivery Date": "Levering na",
		"Delivery address": "Leveringsadres",
		"Delivery nr.": "Leveringsnr.",
		"Deposit": "Waarborg",
		"Deposit not refunded": "Waarborg niet terugbetaald",
		"Deposit refunded": "Waarborg terugbetaald",
		"Deposit:": "Waarborg:",
		"Depth": "Diepte",
		"Description": "Beschrijving",
		"Detail": "Detail",
		"Diameter": "Diameter",
		"Dimensions": "Afmetingen",
		"Discount": "Korting",
		"Discount date": "Datum korting",
		"Discount expires today": "Korting vervalt vandaag",
		"Discount on order total": "Korting op totale bestelling",
		"Discount on total order at": "Korting op totale bestelling bij",
		"Discount type": "Korting",
		"Discounts": "Kortingen",
		"Discounts only": "Enkel kortingen",
		"Discover all promotions!": "Ontdek alle promoties!",
		"Discover the <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Homecare rental range</a>.": "Ontdek het <a class=\"link-primary\" ui-sref=\"seller.rentProductOverview({sellerId: vm.tgzId})\">Thuisgezondheidszorg huuraanbod</a>.",
		"Displayname": "Weergave naam",
		"Displays": "Displays",
		"Dit product wordt rechtstreeks geleverd bij de patiënt.": "Dit product wordt rechtstreeks geleverd bij de patiënt.",
		"Document (pdf)": "Document (pdf)",
		"Document library": "Infotheek",
		"Documents": "Documenten",
		"Download PDF": "Download PDF",
		"Drag your file here or": "Sleep je bestand naar hier of",
		"Dutch": "Nederlands",
		"E-mail address and language for order confirmations:": "E-mailadres en taal bevestigingsmails bestelling:",
		"Email address": "E-mailadres",
		"Enkel te bestellen via uw vertegenwoordiger": "Enkel te bestellen via uw vertegenwoordiger",
		"Enter e-mailadress": "Vul e-mailadres in",
		"Error": "Fout",
		"Estimated Delivery Date": "Verwachte levertijd",
		"Expected delivery date": "Verwachte leveringsdatum",
		"Expires": "Vervalt",
		"Expires within {{productDiscount.daysLeft}} days": "Vervalt binnen {{productDiscount.daysLeft}} dagen",
		"Expires within {{vm.product.daysLeftUntilDiscountExpires}} days": "Vervalt binnen {{vm.product.daysLeftUntilDiscountExpires}} dagen",
		"Expiry date": "Vervaldatum",
		"Extra info": "Extra info",
		"FAQ": "Veelgestelde vragen",
		"Fast Order": "Snel bestellen",
		"Fast order": "Snel bestellen",
		"Fax:": "Fax:",
		"Featured products": "Producten in de kijker",
		"Febelco stock info": "Febelco voorraad info",
		"Filter": "Filter",
		"Flu vaccines": "GRIEPVACCINS",
		"Following products can be ordered via 'special order', should the product not be in stock at the moment.": "Indien de volgende producten niet meer op stock zijn, kunt u ze bestellen via ‘Speciale bestellingen’.",
		"For more information about this contract, please contact your relationship manager.": "Voor bijkomende informatie betreffende dit contract kan u terecht bij uw relatiebeheerder.",
		"For more information about this contract, please contact your supplier.": "Voor bijkomende informatie betreffende dit contract kan u terecht bij uw leverancier.",
		"French": "Frans",
		"Frequently asked questions": "Veelgestelde vragen",
		"From": "Van",
		"From date must be greater than contract start date.": "Startdatum moet groter of gelijk zijn aan startdatum contract.",
		"From&nbsp;{{vm.product.minOrderAmount}}": "Vanaf&nbsp;{{vm.product.minOrderAmount}}",
		"GPM": "BWM",
		"Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.": "Gelieve hieronder in te geven waar de producten geleverd mogen worden en wie ESRI kan contacteren om te verwittigen w.b. de levering.",
		"General": "Algemeen",
		"Go to today": {
			"Datetimepicker tooltips": "Vandaag"
		},
		"Griepvaccins 2021-2022": "Griepvaccins 2021-2022",
		"Gross profit margin": "Brutowinstmarge",
		"Gross profit margins (GPM) are calculated based on the pharmacy and public price (non-binding recommended prices).": "Brutowinstmarges (BWM) worden berekend op basis van de apothekers- en publieksprijs (niet-bindende adviesprijzen).",
		"Height": "Hoogte",
		"Hello": "Dag",
		"Help": "Veelgestelde vragen",
		"Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.": "Hier krijgt u een overzicht van alle Thuisgezondheidszorg producten in uw bezit en alle huuraanvragen via Profficina.",
		"Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.": "Hier krijgt u een overzicht van alle bestellingen die u bij Profficina geplaatst heeft.",
		"Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.": "Hier krijgt u een overzicht van alle producten die u bij Febelco gereserveerd heeft.",
		"Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.": "Hieronder kan u uw reservatie van de afgelopen 12 maanden terugvinden. Gelieve met uw klantendienst contact op te nemen indien u een reservatie wenst te annuleren.",
		"Home": "Home",
		"Homepage": "Startpagina",
		"How can you enjoy this partnership?": "Hoe kunt u van dit voordeel genieten?",
		"INFLUVAC S 2020-2021 0,5 ML 1 WWSP": "INFLUVAC S 2020-2021 0,5 ML 1 WWSP",
		"In progress": "In behandeling",
		"In the spotlight": "In de kijker",
		"Increment Hour": {
			"Datetimepicker tooltips": "Uur verhogen"
		},
		"Increment Minute": {
			"Datetimepicker tooltips": "Minuten verhogen"
		},
		"Increment Second": {
			"Datetimepicker tooltips": "Seconden verhogen"
		},
		"Indication": "Indicatie",
		"Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.": "Influvac niet meer reserveerbaar na bericht van de leverancier op 1/4/20.",
		"Info": "Info",
		"Invoiced": "Gefactureerd",
		"Just a moment please, your order is being added to your shopping cart...": "Even geduld, de producten worden toegevoegd aan uw winkelmand...",
		"Just a moment please, your order is being processed...": "Even geduld, uw import wordt verwerkt... ",
		"Klaar voor de winter?": "Klaar voor de winter?",
		"Language": "Taal",
		"Learn more": "Meer info",
		"Lees meer": "Lees meer",
		"Limited stock!": "Beperkte voorraad!",
		"Location": "Plaats",
		"Log in": "Aanmelden",
		"Log in with other pharmacy:": "Aanmelden met een andere apotheek",
		"Max": "Max",
		"Max. discount": "Max. korting",
		"Media": "Media",
		"Meer Details": "Meer Details",
		"Mijn verzendingen": "Mijn verzendingen",
		"Mijn verzendingen bekijken": "Mijn verzendingen bekijken",
		"Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.": "Mocht u verdere vragen hebben, kan u steeds terecht bij uw vertrouwde relatiebeheerder.",
		"Modify": "Aanpassen",
		"Modify password": "Wachtwoord wijzigen",
		"Month": [
			"maand",
			"maanden"
		],
		"More info": "Meer informatie",
		"More info about": "Meer informatie over",
		"More info about 'special orders'.": "Meer informatie over 'Speciale bestellingen'.",
		"More than one pharmacy is linked to your account. Choose the pharmacy you wish to log on with.": "Er zijn meerdere apotheken gelinkt aan uw account. Kies met welke apotheek u wil aanmelden.",
		"More than one seller is linked to your account. Choose the seller you wish to log on with.": "Er zijn meerdere aanbieders gelinkt aan uw account. Kies met welke aanbieder u wil aanmelden.",
		"My account": "Mijn account",
		"My contracts": "Mijn contracten",
		"My log in data": "Mijn aanmeldgegevens",
		"My orders": "Mijn bestellingen",
		"My packages": "Mijn verzendingen",
		"My pharmacy": "Mijn apotheek",
		"My rent overview": "Mijn huuroverzicht",
		"My reservations": "Mijn reservaties",
		"Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.": "Febelco organiseert naar jaarlijkse gewoonte een voorverkoop van griepvaccins, en dat tot en met 28 februari 2021.",
		"Name": "Naam",
		"Name or APB or client number": "Naam of APB of klantnummer",
		"New order date must be before current order date": "Nieuwe leveringsdatum moet vroeger zijn dan de verwachte leveringsdatum ",
		"New order date must be later than today": "Nieuwe leveringsdatum moet na vandaag zijn",
		"Newest": "Nieuwste",
		"News": "Nieuws",
		"News for": "Nieuws voor",
		"News overview cannot be shown": "Het nieuws overzicht is niet beschikbaar.",
		"Next": "Volgende",
		"Next Century": {
			"Datetimepicker tooltips": "Volgende eeuw"
		},
		"Next Decade": {
			"Datetimepicker tooltips": "Volgend decennium"
		},
		"Next Month": {
			"Datetimepicker tooltips": "Volgende maand"
		},
		"Next Year": {
			"Datetimepicker tooltips": "Volgend jaar"
		},
		"No": "Nee",
		"No certificates found for the given search criteria.": "Geen certificaat gevonden voor de ingegeven zoekcriteria.",
		"No orders found": "Geen resultaten.",
		"No passed rental products the last 3 months.": "U hebt de voorbije 3 maanden geen huur stopgezet.",
		"No products found.": "Geen producten gevonden.",
		"No results.": "Geen resultaten.",
		"No stock available": "Niet voorradig",
		"Non Rental Products": "Gekochte producten",
		"Non-binding recommended prices": "Niet-bindende adviesprijzen",
		"Not available": "Niet beschikbaar",
		"Note": "Opmerking",
		"Notices": "Bijsluiters",
		"Notices for patient": "Bijsluiter voor patiënt",
		"N°": "N°",
		"N° displays": "Aantal displays",
		"OP=OP": "OP=OP",
		"One or more products were not found": "Eén of meer producten werd niet gevonden",
		"Only {{productDiscount.counter}} piece(s) left!": "Slechts {{productDiscount.counter}} stuk(s) beschikbaar",
		"Only {{vm.counter}} piece(s) left!": "Slechts {{vm.counter}} stuk(s) beschikbaar",
		"Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.": "Onze externe partner, ESRI, kan pas 24u na het moment van aanvraag leveren. Wenst u een dringende aanvraag (bijv. voor een palliatieve patiënt), neem dan even contact met de thuiszorgafdeling van Febelco via tgz@febelco.be of via het nummer 03/292.24.72. Zij bekijken dan samen met de externe partner wat er mogelijk is.",
		"Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op uw gekozen leveradres": "Op {{vm.rentedProductsOrder.deliveryInfo.deliveryDate | date}} zullen de product(en) geleverd worden op het door u gekozen leveradres.",
		"Op=Op? These is the last stock for certain products for an extra discounted price. These products can not be returned.": "Op=op? Dat zijn de laatste stuks van producten aan een extra voordelige prijs. Elke maand zijn er nieuwe aanbiedingen, kom dus regelmatig een kijkje nemen! De producten kunnen niet geretourneerd worden.",
		"Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.": "Opgelet, de aangeduide aantallen griepvaccins op deze pagina geven uw initiële, totale reservatie griepvaccins weer. De aantallen houden met andere woorden geen rekening met eventueel reeds geleverde griepvaccins.",
		"Order": {
			"$$noContext": "Bestelling",
			"verb": "Bestellen",
			"noun": "Bestelling"
		},
		"Order - noun": "Bestelling",
		"Order confirmation": "Bestelling bevestigen",
		"Order here": "Bestel hier",
		"Order now": "Nu bestellen",
		"Order pack": "Promopack bestellen",
		"Order panaché": "Bekijk de panaché condities en bestel",
		"Order total": "Totaal bestelling",
		"Order total price": "Korting op totale bestelling",
		"Ordered products": "Producten",
		"Orders are pharmacy based. When you log on as another pharmacy, your shopping basket will change. Your current shopping basket is however not removed.": "Bestellingen gebeuren per apotheek. Als u aanmeldt met een andere apotheek zal uw winkelmand wijzigen. Uw huidig winkelmand wordt echter niet verwijderd.",
		"Orders in Profficina are pharmacy based. Once logged on, you can always switch pharmacy through the 'My account' link in the menu.": "Bestellingen in Profficina gebeuren per apotheek. Eens aangemeld, kan u steeds wisselen van apotheek via de link 'Mijn account' in het menu.",
		"Other offers with this product": "Andere aanbiedingen met dit product",
		"Our website uses cookies to make your browsing experience better. By using our site, you agree to our use of cookies.": "Onze website maakt gebruik van cookies om uw gebruikservaring te verbeteren. Door onze website te gebruiken, gaat u akkoord met het gebruik van deze cookies.",
		"Outlet": "Op=Op",
		"Overview": "Overzicht",
		"Overview all discounts": "Overzicht alle kortingen",
		"Overzicht producten in reservatie": "Overzicht producten in reservatie",
		"PDF": "PDF",
		"PROMO": "PROMO",
		"Package quantity": "Verpakkingshoeveelheid",
		"PackageDetail": "Details verzending",
		"Packages archive": "Al mijn verzendingen",
		"Panaché": "Panaché",
		"Panaché:": "Panaché",
		"Partially in progress by wholesaler": "Deels in behandeling",
		"Partially invoiced": "Deels gefactureerd",
		"Partially registered by wholesaler": "Deels geregistreerd",
		"Partnerships": "Partnerships",
		"Password": "Wachtwoord",
		"Pharmacy": "Apotheek",
		"Pharmacy price": "Apothekersprijs",
		"Pick Hour": {
			"Datetimepicker tooltips": "Kies uur"
		},
		"Pick Minute": {
			"Datetimepicker tooltips": "Kies minuten"
		},
		"Pick Second": {
			"Datetimepicker tooltips": "Kies seconden"
		},
		"Place order": "Bestelling plaatsen",
		"Please enter a date before {{vm.maxDate | date: 'dd-MM-yyyy'}}": "Gelieve een datum te kiezen voor {{vm.maxDate | date: 'dd-MM-yyyy'}}",
		"Please enter a date in the future": "Gelieve een datum die in de toekomst ligt op te geven",
		"Please enter a quantity.": "Vul een aantal in.",
		"Please place your order within {{error.daysLeftUntilDiscountExpires}} days, discount for {{error.productName}} ends on {{error.expireDate | date:'yyyy-MM-dd'}}": "Gelieve binnen de {{error.daysLeftUntilDiscountExpires}} dagen te bestellen, de korting op {{error.productName}} vervalt op {{error.expireDate | date:'yyyy-MM-dd'}}",
		"Please provide a street.": "Gelieve een geldige straat te selecteren",
		"Please provide a valid city.": "Gelieve een geldige stad te selecteren.",
		"Please provide your contact person.": "Gelieve een contactpersoon op te geven.",
		"Please provide your housenumber.": "Gelieve uw huisnummer in te vullen.",
		"Please provide your telephone number.": "Gelieve uw telefoonnummer in te vullen.",
		"Please refine your search.": "Verfijn uw zoekopdracht...",
		"Please select a pharmacy": "Selecteer een apotheek",
		"Please select a seller": "Selecteer een aanbieder",
		"Prescription": "Op voorschrift",
		"Previous": "Vorige",
		"Previous Century": {
			"Datetimepicker tooltips": "Vorige eeuw"
		},
		"Previous Decade": {
			"Datetimepicker tooltips": "Vorig decennium"
		},
		"Previous Month": {
			"Datetimepicker tooltips": "Vorige maand"
		},
		"Previous Year": {
			"Datetimepicker tooltips": "Vorig jaar"
		},
		"Price": "Prijs",
		"Price information": "Prijsinformatie",
		"Price:": "Prijs:",
		"Processing...": "Aan het verwerken…",
		"Product": "Product",
		"Product available": "Voorradig",
		"Product discount": "Productkorting",
		"Product info": "Product info",
		"Product information": "Productinformatie",
		"Product name or number": "Productnaam of nummer",
		"Product name, number or lot number": "CNK, productnaam of lotnummer",
		"Product not found": "Er werd geen product gevonden met dit Productnummer.",
		"Product number": "CNK",
		"Product number or product name": "CNK of productnaam",
		"Product number, name product": "CNK of productnaam",
		"Product overview cannot be shown": "Het product overzicht is niet beschikbaar",
		"Product status": "Product status",
		"active": "Actief",
		"inactive": "Niet actief",
		"true": "Ja",
		"false": "Nee",
		"Written request by patient": "Schriftelijke aanvraag",
		"Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}": "Product vervalt op {{productDiscount.expirationDate | date: 'dd/MM/yyyy'  }}",
		"ProductNumber": "Productnummer",
		"Producten die mogelijks\n                                            interessant zijn om bij te huren": "Producten die mogelijks\n interessant zijn om bij te huren",
		"Producten die mogelijks\n                                            interessant zijn om bij te kopen": "Producten die mogelijks\n interessant zijn om bij te huren",
		"Producten die mogelijks interessant zijn om bij te huren": "Producten die mogelijks interessant zijn om bij te huren",
		"Producten die mogelijks interessant zijn om bij te kopen": "Producten die mogelijks interessant zijn om bij te kopen",
		"Productname or product number": "Productnaam of Productnummer",
		"Products": "Producten",
		"Products were added to your cart": "Producten succesvol toegevoegd aan winkelmand.",
		"Profficina": "Profficina",
		"Profficina Ref.": "Profficina ref.",
		"Profficina ref.": "Profficina ref.",
		"Profficina ref. or TO-nr.": "Profficina ref. of TO-bonnr.",
		"Promopack": "Promopack",
		"Properties": "Eigenschappen",
		"Public categories": "Publieke categorieën",
		"Public price": "Publieksprijs",
		"Quantity": "Aantal",
		"Quantity in panaché": "Aant. in panaché",
		"Quantity:": "Aantal:",
		"Questions or remarks concerning the pharmacovigilance of one of our products?": "Vragen of opmerkingen wat betreft de <br />pharmacovigilantie van onze producten?",
		"Questions? More info?": "Vragen? Meer informatie?",
		"Read more": "Lees meer",
		"Read our FAQ": "Raadpleeg onze veelgestelde vragen",
		"Receipt": "Bestelnota",
		"Recently passed rental products": "Recent huur gestopt",
		"Reference codes": "Referentiecodes",
		"Refund value with omnio": "Omnio tarief",
		"Refund value without omnio": "Terugbetalingstarief",
		"Refunded deposit": "Waarborg terug",
		"Registered": "Geregistreerd",
		"Registered by seller": "Geregistreerd door aanbieder",
		"Related news": "Verwant nieuws",
		"Rent": {
			"Verb": "Huur"
		},
		"Rent per day": "Huur per dag",
		"Rent per day:": "Huur per dag:",
		"Rent products": "Huurproducten",
		"Rental amount per month": "Huur per maand",
		"Rental products": "Huurproducten",
		"Rental products in your possession": "Huurproducten in uw bezit",
		"Rental request (Pdf)": "Aanvraag (PDF)",
		"Rental service": "Verhuur",
		"Rented from": "Gehuurd sinds",
		"Rented product detail": "Detail huurproduct",
		"Rented since – until": "Gehuurd sinds &ndash; tot",
		"Rented until": "Gehuurd tot",
		"Rented until – from": "Gehuurd sinds &ndash; tot",
		"Reorder": "Bestel opnieuw",
		"Replacement product available": "Vervangend product voorradig",
		"Required&nbsp;{{vm.product.minOrderAmount}}": "Verplicht&nbsp;{{vm.product.minOrderAmount}}",
		"Reservation time": "Gereserveerd sinds",
		"Reservation time:": "Gereserveerd sinds:",
		"Reserved products at Febelco": "Gereserveerde producten bij Febelco",
		"Reserveer nu uw griep vaccins": "Reserveer nu uw griep vaccins",
		"Reset": "Wissen",
		"Retroactive discount": "Retroactieve korting",
		"Return": "Terug",
		"Return to the homepage": "Terug naar de homepagina",
		"Route number": "Route nummer",
		"Running low on stock!": "Bijna op!",
		"Save": "Bewaren",
		"Scientific notices": "Wetenschappelijke bijsluiter",
		"Search": "Zoeken",
		"Search by contract name": "Zoek op naam contact",
		"Search by name": "Zoek op naam",
		"Search by name or number": "Zoek op productnaam of Productnummer",
		"Search products by number or name": "Zoek producten op Productnummer of naam",
		"See the latest discounts": "Bekijk de laatste kortingen",
		"Select Decade": {
			"Datetimepicker tooltips": "Selecteer decennium"
		},
		"Select Month": {
			"Datetimepicker tooltips": "Selecteer maand"
		},
		"Select Year": {
			"Datetimepicker tooltips": "Selecteer jaar"
		},
		"Select other pharmacy": "Selecteer andere apotheek",
		"Select other seller": "Selecteer andere aanbieder",
		"Select wholesaler": "Selecteer een groothandel",
		"Seller": "Aanbieder",
		"Sellers": "Aanbieders",
		"Send a fax to": "Fax naar",
		"Send an e-mail to": "Mail naar",
		"Send application": "Verstuur aanvraag",
		"Sent to seller": "Verstuurd naar aanbieder",
		"Serialnumber": "Serienummer",
		"Shipping note": "Zendnota",
		"Shopping cart": "Winkelmand",
		"Show all": "Toon alle",
		"Show all results": "Toon alle resultaten",
		"Show in grid": "Toon in rooster",
		"Show in list": "Toon in lijst",
		"Show less": "Toon minder",
		"Side effects": "Bijwerkingen",
		"Sign out": "Afmelden",
		"Sold out!": "Te laat!",
		"Something went wrong": "Er liep iets mis",
		"Something went wrong when loading this page.": "Er liep iets mis bij het inladen van deze pagina.",
		"Something went wrong while adding the products to your shoppingcart.": "Er liep iets mis. De producten konden niet toegevoegd worden aan uw winkelmand.",
		"Something went wrong while adding your products, please try again.": "Er liep iets mis. De producten konden niet toegevoegd worden. Gelieve opnieuw te proberen.",
		"Something went wrong with the import of your file. Please check your CSV and try again.": "Er liep iets mis bij het importeren van het bestand. Gelieve het CSV-bestand te controleren en opnieuw te proberen.",
		"Sort": "Sorteer",
		"Sort by": "Sorteer op",
		"Special Discounts": "Speciale kortingen",
		"Special order possible": "Speciale bestelling mogelijk",
		"Special orders": "Speciale bestellingen",
		"Status": "Status",
		"Stock response cannot be checked at the moment.": "De voorraad kan momenteel niet opgevraagd worden.",
		"Street": "Straat",
		"Subtotal": "Subtotaal",
		"Suggesties": "Suggesties",
		"Supplier": "Leverancier",
		"Supplier has no stock available": "Niet voorradig bij leverancier",
		"Supplier reference": "Leverancier ID",
		"TO-nr.": "TO-bonnr.",
		"Tags": "Labels",
		"Tax": "BTW",
		"Tel:": "Tel:",
		"Telephone number": "Telefoonnummer",
		"Thank you for ordering": "Bedankt voor uw bestelling",
		"The Agios discount is not known, contact the supplier for more info.": "De Agios korting is niet gekend, voor meer info hierover, contacteer de leverancier.",
		"The CSV was empty.": "Het CSV-bestand is leeg. Gelieve dit te controleren en opnieuw te proberen.",
		"The last 3 months you did not submit any rental applications via Profficina.": "U heeft de voorbije 3 maand geen huuraanvraag gedaan via Profficina.",
		"The last 3 months, you ended rent for more than 15 products.": "U heeft de huur stopgezet van meer dan 15 producten de afgelopen 3 maanden.",
		"The orders could not be retrieved": "Er ging iets mis tijdens het ophalen van de bestellingen",
		"The partnerships could not be retrieved": "Er ging iets mis tijdens het ophalen van de partners",
		"The product could not be added to your shopping cart": "Het product kon niet toegevoegd worden aan uw winkelmand",
		"The product could not be removed from your shopping cart": "Het product kon niet verwijderd worden uit uw winkelmand",
		"The product quantity could not be updated": "De product hoeveelheid kon niet aangepast worden",
		"The product you were looking was not found or is inactive.": "Het product dat u wou bekijken is niet meer actief.",
		"The products cannot be retrieved.": "Er liep iets mis met het ophalen van de producten.",
		"The products could not be removed from your shopping cart": "De producten konden niet verwijderd worden uit uw winkelmandje.",
		"The quantity of one or more products is incorrect.": "Bij één of meerdere producten werd geen correct aantal ingegeven.",
		"The shaded products can no longer be ordered.": "De gearceerde producten kunnen niet langer besteld worden.",
		"There are currently no discounts available": "Er zijn geen kortingen beschikbaar.",
		"There are currently no products available": "Er zijn geen producten beschikbaar.",
		"There are still products in your shopping cart": "Er zitten nog producten in uw winkelmand",
		"This product is in Agios, the discount displayed is not the Agios discount.": " Dit product zit in Agios, de getoonde korting is geen Agios korting.",
		"This promopack contains following products": "Dit promopack bevat de volgende producten",
		"Time": "Tijdstip",
		"To TGZ homepage": "TGZ Homepagina ",
		"Too many results.": "Meer dan 20 resultaten.",
		"Total": "Totaal",
		"Total (incl. VAT)": "Totaal (incl. BTW)",
		"Total discount": "Totale korting",
		"Total quantity in panaché": "Totaal aantal producten in panaché",
		"Total rent": "Huurtotaal",
		"Trade in months after expiry": "Omruiltermijn na vervaldatum",
		"Trade in months before expiry": "Trade in months before expiry",
		"Trade in refund value": "Trade in refund value",
		"U heeft momenteel geen openstaande reservaties.": "U heeft momenteel geen openstaande reservaties.",
		"U heeft voor dit partnership een {{contract.name}} contract van onbepaalde duur vanaf {{contract.startDate | date}}": "U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} voor onbepaalde tijd.",
		"U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot {{contract.endDate | date}}": "U heeft voor dit partnership een {{contract.name}} contract van {{contract.startDate | date}} tot en met {{contract.endDate | date}}",
		"Undo changes": "Wijzigingen ongedaan maken",
		"Unfortunately there are no products available for the current criteria.": "Er zijn geen producten beschikbaar voor de geselecteerde criteria.",
		"Unfortunately there were no certificates found.": "Er zijn momenteel geen certificaten beschikbaar.",
		"Unfortunately there were no items found from Profficina.": "U hebt nog geen huuraanvraag gedaan via Profficina.",
		"Unfortunately there were no news items found.": "Er zijn geen nieuwsberichten beschikbaar.",
		"Unfortunately there were no partnerships found.": "Er zijn geen partners gevonden.",
		"Unfortunately there were no rental products found.": "Er zijn geen huurproducten teruggevonden.",
		"Unfortunately there were no rental requests found.": "Er zijn geen huuraanvragen teruggevonden.",
		"Until": "Tot",
		"Up to": "Tot",
		"Update cart": "Winkelmand aanpassen",
		"Update shopping cart [ENTER]": "Winkelmand bijwerken [ENTER]",
		"Updating your cart...": "Winkelmand aan het bijwerken...",
		"Usage": "Gebruik",
		"Uw aanvraag": "Uw aanvraag",
		"Uw contract": "Uw contract",
		"Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.": "Uw gereserveerde griepvaccins zijn toegevoegd aan onderstaande lijst van reservaties echter kunnen we geen nieuwe reservaties meer opnemen.",
		"Uw huuraanvraag": "Uw huuraanvraag",
		"Uw huuraanvraag is verstuurd naar de klantendienst.": "Uw huuraanvraag is verstuurd naar de klantendienst.",
		"VAT": "BTW",
		"VAT:": "Btw:",
		"VAXIGRIP TETRA 2020-2021 0,5 ML 1 WWSP": "VAXIGRIP TETRA 2020-2021 0,5 ML 1 WWSP",
		"Valid from": "Geldig van",
		"Valid from - until": "Geldig van - tot",
		"Valid until": "Geldig tot",
		"Vendor": "Aanbieder",
		"Verstuur": "Verstuur",
		"Verzending": "Verzending",
		"View my orders": "Bestellingen bekijken",
		"View my packages": "Mijn verzendingen bekijken",
		"View my rent overview": "Mijn huuroverzicht bekijken",
		"View my reservations": "Reservaties bekijken",
		"View your shopping basket": "Bekijk uw winkelmand",
		"Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be": "Voor vragen of aanpassingen aan deze aanvraag, gelieve de klantendienst te contacteren op 03/770.70.70 of klantendienst@febelco.be",
		"We can not find the page you are looking for. The product / news item / ... may no longer exist.": "We kunnen de pagina die u zoekt niet vinden. Mogelijks bestaat het product/nieuwsbericht/… niet meer.",
		"Weight": "Gewicht",
		"What would you like use to do <strong>when these products are not in stock</strong>?": "WAT WENST U TE DOEN <strong>INDIEN DIT ZICH VOORDOET?</strong>",
		"Wholesaler": "Groothandel",
		"Width": "Breedte",
		"U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.": "U kan uw vaccins uitsluitend reserveren via Profficina. We bevelen u van harte aan om uw aantallen goed in te schatten, zodat we op basis daarvan voldoende voorraad kunnen voorzien.",
		"Wij raden aan om\n                                            hierbij ook deze producten te huren": "Wij raden aan om hierbij ook deze producten te huren",
		"Wij raden aan om\n                                            hierbij ook deze producten te kopen": "Wij raden aan om hierbij ook deze producten te kopen",
		"Wij raden aan om hierbij ook deze producten te huren": "Wij raden aan om hierbij ook deze producten te huren",
		"Wij raden aan om hierbij ook deze producten te kopen": "Wij raden aan om hierbij ook deze producten te kopen",
		"Withdrawn product": "Product uit handel",
		"Maximum quantity exceeded.": "Maximum quantity exceeded.",
		"Year": "Jaar",
		"Yes": "Ja",
		"You are logged in with pharmacy": "U bent aangemeld met apotheek",
		"You are logged in with seller": "U bent aangemeld met aanbieder",
		"You are now logged in with pharmacy": "U bent nu aangemeld met apotheek",
		"You can choose from the following products:": "U heeft de keuze uit volgende producten:",
		"You currently do not rent products from Febelco.": "U huurt momenteel geen producten van Febelco.",
		"You did not update your cart with the quantities you last modified.": "U heeft uw winkelmand nog niet bijgewerkt met de laatst gewijzigde aantallen.",
		"You do not have permission to view this page.": "U heeft geen toestemming om deze pagina te bekijken.",
		"You have more than 15 rental products in your possession.": "U heeft meer dan 15 huurproducten in uw bezit.",
		"You have more than 15 rental requests in the last 3 months.": "U heeft de laatste 3 maanden huur aanvragen ingedient.",
		"You have not rented products from Febelco.": "U heeft geen producten gehuurd bij Febelco.",
		"You searched for": "Uw zoekresultaten voor",
		"You will receive an email confirmation shortly at {{ vm.mail }}.": "Een bevestiging van uw bestelling werd gemaild naar {{ vm.mail }}.",
		"Your browser does not support file upload.": "Uw browser ondersteunt de bestand-opladen functionaliteit niet.",
		"Your info": "Uw gegevens",
		"Your purchases": "Uw aankopen",
		"Your recent rental requests": "Recente huuraanvragen via Profficina",
		"Your rent request on": "Aanvraag van",
		"Your reservation has been confirmed.": "Uw reservatie van griepvaccins werd goed bewaard.",
		"Your search value": "Uw zoekterm",
		"Your shopping cart": "Uw winkelmand",
		"_myDocuments._reportNarcotics.description": "Hier krijgt u een overzicht van alle producten (met stoffen opgelijst in bijlagen I, II en IV van het K.B. 06/09/2017) waarvoor we nog geen verdovingsbon van u mochten ontvangen.",
		"_myDocuments._reportNarcotics.title": "Openstaande verdovingsbonnen",
		"_myDocuments._reportPurchaseProposals.description": "Dit rapport geeft u een mooi overzicht van uw aankopen en geeft duidelijk weer – per CNK – hoeveel stuks (1/5/10 st.) u het best aankoopt om van een maximale korting te kunnen genieten. Het helpt u ook het aantal inkomende leveringen van eenzelfde CNK binnen eenzelfde facturatieperiode te beperken, en draagt dus bij tot een hogere efficiëntie.",
		"_myDocuments._reportPurchaseProposals.title": "Aankoopvoorstellen",
		"_myDocuments._settings.introText": "Hier krijgt u een overzicht van uw openstaande verdovingsbonnen en uw aankoopvoorstellen.",
		"_myDocuments._settings.myDocuments": "Mijn documenten",
		"_myDocuments._settings.viewMyDocuments": "Documenten bekijken",
		"_myDocuments._siteHeader.myDocuments": "Mijn documenten",
		"_myDocuments.downloadDocument": "Download document",
		"_myDocuments.myDocuments": "Mijn documenten",
		"_selftests.linkToFaq": "Voor al uw vragen met betrekking tot de COVID testkit, gelieve contact op te nemen met uw relatiebeheerder.",
		"_reservationCampaigns.product": "Product",
		"_reservationCampaigns.productNumber": "CNK",
		"_reservationCampaigns.quantity": "Aantal",
		"_reservationCampaigns.reservationConfirmed": "Uw reservatie werd goed ontvangen.",
		"_reservationCampaigns.save": "Bewaren",
		"_reservationCampaigns.totalLimitReached": "Reservatielimiet bereikt.",
		"_reservationCampaigns.limitReached": "Maximum {{limit}} st.",
		"article": [
			"artikel",
			"artikels"
		],
		"at": {
			"delivered on april 14th AT 17:25": "om"
		},
		"can be delivered on": "levering mogelijk op",
		"certificate": [
			"document gevonden",
			"documenten gevonden"
		],
		"checkout.agreeWithTerms": "Door op ‘Bestelling bevestigen’ te klikken, stemt u in met de <a href=\"http://www.profficina.be/nl/algemene-voorwaarden.html\" class=\"link link-primary\" target=\"_blank\">algemene gebruiksvoorwaarden van Profficina</a>.",
		"checkout.contactSupportWhenInvoiceAddressIsIncorrect": "Contacteer <a href=\"mailto:support@profficina.be\">support@profficina.be</a> als deze informatie incorrect is.",
		"checkout.linkToOrderOverview": "U kan op elk moment de status en details van uw bestellingen bekijken via 'Mijn account' <i class=\"ico ico-angle-right\"></i> '<a ui-sref=\"order-overview\" class=\"link link-primary\">Mijn bestellingen</a>' in het menu bovenaan de pagina.",
		"contact": "contact",
		"contract": "contract",
		"contracts": "contracts",
		"discount": "korting",
		"discounts": "kortingen",
		"documents": "documenten",
		"indefinite": "voor onbepaalde tijd",
		"indefinitely": "voor onbepaalde tijd",
		"news": "nieuws",
		"no": "nee",
		"or Send an email to": "of mail naar",
		"parcel.addAnotherLine": "Pakket toevoegen",
		"parcel.addConfirmationExplanations": "Een woordje uitleg wat men nu moet doen   ... Text TBD",
		"parcel.allMyParcels": "Al mijn verzendingen",
		"parcel.back": "Vorige",
		"parcel.backToOverview": "Terug naar overzicht",
		"parcel.barcode": "Barcode",
		"parcel.cancel": "Verzending annuleren",
		"parcel.cancelParcel": "Pakket annuleren",
		"parcel.checkData": "Controleer de gegevens en duid aan dat u akkoord gaat met",
		"parcel.confirmOrder": "Verzending bevestigen",
		"parcel.createALabelHere": "Maak hier een verzendlabel aan",
		"parcel.createParcel": "Verzending aanmaken",
		"parcel.createShippingLabelHere": "Pakket versturen naar een apotheek via Febelco? Maak hier een verzendlabel aan.",
		"parcel.customerNumber": "Klantnummer Febelco",
		"parcel.deliveredWithin48": "Binnen 48u geleverd op bestemming",
		"parcel.enterLicenseNumberLong": "Geef vergunningsnummer in van de apotheek waarvoor uw pakket bestemd is. Het adres van de bestemmeling zal automatisch op het volgende scherm verschijnen.",
		"parcel.enterLicenseNumberShort": "Gelieve vergunningsnummer in te geven.",
		"parcel.febelcoNotResponsibleForContent": "Febelco is niet verantwoordelijk voor de inhoud van de pakketten.",
		"parcel.followWithTrackAndTrace": "Volg via Track & Trace",
		"parcel.giveParcelToCourier": "Geef uw pakket met label aan de Febelco koerier",
		"parcel.hereYouCanRegister": "Hier kan u verzendingen naar andere apotheken via Febelco aanvragen en kan u de status van die verzendingen opvolgen.",
		"parcel.howDoesItWork": "Hoe werkt het?  ..TBD",
		"parcel.iAgreeToTheTerms": "Ik ga akkoord met de voorwaarden.",
		"parcel.latestShipments": "Verzendingen van de laatste 6 maanden",
		"parcel.licenseNumber": "Vergunningsnummer",
		"parcel.licenseNumberShort": "Vergunningsnr.",
		"parcel.isSigned": "Handtekening ontvangen",
		"parcel.insurance": "Verzekering",
		"parcel.insuranceDescription": "Prijs € {{ insurancePrice }} . Als het pakje verzekerd is, dan wordt er ook een handtekening gevraagd bij ontvangst.",
		"parcel.required": "Verplicht",
		"parcel.packageValue": "Waarde van het pakket",
		"parcel.packagePrice": "Pakket prijs: ",
		"parcel.packageDiscount": "Pakket korting: ",
		"parcel.insuranceInvoiceAmount": "Aangerekende prijs voor verzekering:",
		"parcel.packageInvoiceAmount": "Aangerekende prijs voor het pakket: ",
		"parcel.freePackage": "Dit pakket is gratis, een eventuele bijkomende verzekering wordt altijd aangerekend.",
		"parcel.line": [
			"pakket",
			"pakketten"
		],
		"parcel.madeOn": "Aangemaakt op",
		"parcel.myParcels": "Mijn verzendingen",
		"parcel.nameApbOrCustomerNr": "Naam, apb-nr, klantnr.",
		"parcel.next": "Volgende",
		"parcel.no": "Nee",
		"parcel.noParcelsFound": "Geen verzendingen gevonden.",
		"parcel.noParcelsFoundForCriteria": "Geen verzendingen gevonden voor ingegeven zoekcriteria.",
		"parcel.noPharmacyFound": "Geen apotheek gevonden met deze gegevens.",
		"parcel.orderNumber": "Verzending ID",
		"parcel.packLower": [
			"pakket",
			"pakketten"
		],
		"parcel.packages": "Pakketjes",
		"parcel.parcel": "Verzending",
		"parcel.parcelBarcode": "Barcode pakket",
		"parcel.parcelCancelCommandSent": "Even geduld aub, de annulatie van uw pakket of zending is in verwerking.",
		"parcel.errorSendingCancelCommand": "Er is iets fout gegaan bij het annuleren van uw pakket of verzending.",
		"parcel.parcelLower": [
			"verzending",
			"verzendingen"
		],
		"parcel.perPage": "per pagina",
		"parcel.pleaseAgreeToTerms": "Gelieve akkoord te gaan met de voorwaarden.",
		"parcel.pleaseSelectPackageType": "Please select a package type",
		"parcel.printAndHandToDriver": "Print de verzendlabels en geef het pakket mee met uw Febelco-chauffeur.",
		"parcel.printLabel": "Print verzendlabel",
		"parcel.remarkForCourier": "Opmerking / Bericht voor koerier",
		"parcel.remarkForCourierDescription": "Hier kan u extra informatie of instructies toevoegen voor de koerier.",
		"parcel.reset": "Wissen",
		"parcel.search": "Zoeken",
		"parcel.searchAllParcels": "Zoek een van uw verzendingen op of maak een nieuwe verzending aan.",
		"parcel.sendTo": "Verzenden naar",
		"parcel.sentTo": "Verstuurd naar",
		"parcel.shippingDetail": "Detail verzending",
		"parcel.shippingDetails": "Details verzending",
		"parcel.signatureRequired": "Aftekenen bij ontvangst",
		"parcel.signatureRequiredDescription": "Lorem ipsum dolor sit amet...",
		"parcel.theConditions": "de voorwaarden",
		"parcel.to": "Naar",
		"parcel.trackAndTraceInDetail": "Track & Trace activiteit in detail",
		"parcel.until": "tot",
		"parcel.viewMyParcels": "Mijn verzendingen bekijken",
		"parcel.whatCanBeSentAndHowItWorks": "Een woordje uitleg over wat men kan verzenden en hoe het werkt.",
		"parcel.whatToSend": "Wat wil u verzenden?",
		"parcel.whichPharmacyToSend": "Naar welke apotheek wilt u een pakket verzenden?",
		"parcel.yes": "Ja",
		"parcel.youHaveNoRecentParcels": "U heeft recent geen verzendingen geregistreerd",
		"parcel.yourParcelWasRegistered": "Uw verzending is geregistreerd",
		"partnerships": "partnerships",
		"pcs.": "st.",
		"per page": "per pagina",
		"product": [
			"product",
			"producten"
		],
		"product.medipim.expires": "Vervaldatum",
		"product.medipim.refundValueWithOmnio": "Omnio tarief",
		"product.medipim.refundValueWithoutOmnio": "Terugbetalingstarief",
		"product.medipim.tradeInMonthsAfterExpiry": "Ruilperiode na vervaldatum",
		"product.medipim.tradeInMonthsBeforeExpiry": "Ruilperiode voor vervaldatum",
		"product.status.active": "Actief",
		"product.status.inactive": "Niet actief",
		"product.status.replaced": "Vervangen",
		"products": "producten",
		"products available in your warehouse": "stuk(s) voorradig in uw vestiging",
		"products available": "stuk(s) voorradig",
		"public": "public",
		"refundOnDate": "op",
		"rental product": [
			"huurproduct",
			"huurproducten"
		],
		"rental request": [
			"huuraanvraag",
			"huuraanvragen"
		],
		"select file": "selecteer bestand",
		"tour": "toer",
		"until": "tot",
		"upward of": "vanaf",
		"v.a. {{d.amount}} st.": "va. {{d.amount}} st.",
		"vac test": "\"U kan uw vaccins vanaf nu uitsluitend reserveren via het aankoopplatform Profficina. Zo kan u ook makkelijk de kortingenper product raadplegen, en achteraf ook de aantallen die u gereserveerd heeft. Handig, niet?Nog geen Profficina-account? Neem dan snel contact op met uw vertrouwde relatiebeheerder, of met support@profficina.be.\"",
		"yes": "ja",
		"{{ vm.activeCategory ? vm.activeCategory.name : 'All rental products'}}": "{{ vm.activeCategory ? vm.activeCategory.name : 'Alle huurproducten'}}",
		"Contract details": "Details contract",
		"_order.selectAccountTitle": "Selecteer uw klantenrekening",
		"Dear Pharmacist,": "Beste apotheker,",
		"From 23/01/2023 <strong>you</strong> and anyone who gives you rights, <strong>can manage the reservations yourself</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, our new customer portal: changing, removing or adding can then be done in a few mouse clicks.": "Vanaf 23/01/2023 <strong>beheren jij</strong> en iedereen die je rechten geeft, <strong>de reservaties gewoon zelf</strong> via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a>, ons nieuw klantenportaal: wijzigen, verwijderen of toevoegen kan dan in enkele muisklikken.",
		"Via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> you also get direct access to all kinds of information, personal data and useful tools. Calling customer service is no longer necessary, so they have more time to help our customers on the line faster.": "Je krijgt via <a class=\"link\" target=\"_blank\" href=\"{{vm.myFebelcoLink}}\">MyFebelco</a> ook directe toegang tot allerhande info, persoonlijke data en nuttige tools. Bellen naar de klantendienst is niet meer nodig, zo hebben zij meer tijd vrij om onze klanten aan de lijn sneller verder te helpen.",
		"Due to this progress, the <strong>reservation overview</strong> will no longer be available on Profficina and your secure area (my Febelco) <strong>from 16/01</strong>.": "Omwille van deze vooruitgang zal het <strong>reservatie-overzicht niet meer beschikbaar</strong> zijn op Profficina en uw beveiligde zone (mijn Febelco) <strong>vanaf 16/01</strong>.",
		"<strong>Questions?</strong><br>Before you can go to MyFebelco, you must activate your account on the basis of a registration email.": "<strong>Vragen?</strong><br>Voor je op MyFebelco terecht kan, moet je je account activeren, op basis van een registratiemail.",
		"Didn't receive a registration email? Then contact <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>.": "Geen registratiemail ontvangen? Contacteer dan <a href=\"mailto:support@myfebelco.be\" class=\"link\">support@myfebelco.be</a>."
	}
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en-au": 233,
	"./en-au.js": 233,
	"./en-ca": 234,
	"./en-ca.js": 234,
	"./en-gb": 235,
	"./en-gb.js": 235,
	"./en-ie": 236,
	"./en-ie.js": 236,
	"./en-il": 237,
	"./en-il.js": 237,
	"./en-in": 238,
	"./en-in.js": 238,
	"./en-nz": 239,
	"./en-nz.js": 239,
	"./en-sg": 240,
	"./en-sg.js": 240,
	"./fr": 243,
	"./fr-ca": 241,
	"./fr-ca.js": 241,
	"./fr-ch": 242,
	"./fr-ch.js": 242,
	"./fr.js": 243,
	"./nl": 245,
	"./nl-be": 244,
	"./nl-be.js": 244,
	"./nl.js": 245
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 686;


/***/ }),
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _oidcClient = __webpack_require__(165);

var _oidcClient2 = _interopRequireDefault(_oidcClient);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = function () {
    function AuthService($log, $q, $location, $exceptionHandler, settings, Analytics) {
        _classCallCheck(this, AuthService);

        this.$log = $log;
        this.$q = $q;
        this.$location = $location;
        this.$exceptionHandler = $exceptionHandler;
        this._userLoadedEvent = new Event('User loaded');
        this._userUnloadedEvent = new Event('User unloaded');
        this._userSignedOutEvent = new Event('User signed out');
        this._initialized = false;
        this._userManager = new _oidcClient2.default.UserManager(settings);
        this.Analytics = Analytics;
        this._wireUserManagerEvents();
    }

    AuthService.prototype.addUserLoadedEvent = function addUserLoadedEvent(callback) {
        var _this = this;

        this._userLoadedEvent.addHandler(callback);
        return function () {
            return _this._userLoadedEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserLoaded(callback);
        //this._callbacks.push(callback);
        //return () => this._callbacks.splice(this._callbacks.findIndex(callback),1);
    };

    AuthService.prototype.addUserUnloadedEvent = function addUserUnloadedEvent(callback) {
        var _this2 = this;

        this._userUnloadedEvent.addHandler(callback);
        return function () {
            return _this2._userUnloadedEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserLoaded(callback);
        //this._callbacks.push(callback);
        //return () => this._callbacks.splice(this._callbacks.findIndex(callback),1);
    };

    AuthService.prototype.addUserSignedOut = function addUserSignedOut(callback) {
        var _this3 = this;

        this._userSignedOutEvent.addHandler(callback);
        return function () {
            return _this3._userSignedOutEvent.removeHandler(callback);
        };
        //return this._userManager.events.addUserSignedOut(callback);
    };

    AuthService.prototype.hasClaim = function hasClaim(claim, value) {
        var _this4 = this;

        if (!claim) {
            return true;
        }
        if (!this.user) {
            return false;
        }
        if (claim instanceof Array) {
            return claim.every(function (c) {
                return !!_this4.user[c] && _this4._hasClaimValue(claim, value);
            });
        }
        return !!this.user[claim] && this._hasClaimValue(claim, value);
    };

    AuthService.prototype._hasClaimValue = function _hasClaimValue(claim, value) {
        if (value === undefined) {
            return true;
        }
        if (this.user[claim] instanceof Array) {
            return this.user[claim].some(function (c) {
                return c === (value ? '' + value : value);
            });
        }
        return this.user[claim] === (value ? '' + value : value);
    };

    AuthService.prototype.hasClaimAsync = function hasClaimAsync(claim) {
        var _this5 = this;

        if (this._initialized === false) {
            return this._initPromise.then(function () {
                return _this5.hasClaim(claim);
            }, function () {
                return _this5.hasClaim(claim);
            });
        }
        return this.hasClaim(claim);
    };

    AuthService.prototype.init = function init() {
        var _this6 = this;

        this._initialized = false;
        this._initPromise = this._userManager.getUser().then(function (user) {
            _this6._setUser(user);
            _this6._initialized = true;
            return user ? _this6.$q.resolve() : _this6.$q.reject();
        }, function () {
            _this6._initialized = true;
        });
        return this._initPromise;
    };

    AuthService.prototype.signIn = function signIn(requestedUrl, acrValues, language) {
        var _this7 = this;

        if (!acrValues) {
            if (this.isAuthenticated) {
                return this.$q.resolve();
            }
            if (this._initialized === false) {
                return this._initPromise.catch(function () {
                    return _this7._signIn(requestedUrl, acrValues, language);
                });
            }
        }
        return this._signIn(requestedUrl, acrValues, language);
    };

    AuthService.prototype.signOut = function signOut() {
        this._setUser();
        this.$log.debug('Security - sign out');
        return this._userManager.signoutRedirect();
    };

    AuthService.prototype.clearGALocalStorage = function clearGALocalStorage() {
        window.localStorage.removeItem('FlexMail');
        window.localStorage.removeItem('GAFlexTrack');
        window.localStorage.removeItem('GAFlexAlreadyLoginTrack');
        window.localStorage.removeItem('GAUserNotLoggedInTracked');
        window.localStorage.removeItem('GAUserNotLoggedInTrack');
        window.localStorage.removeItem('GAFlexNewLoginTrack');
    };

    AuthService.prototype._accessTokenExpired = function _accessTokenExpired() {
        var _this8 = this;

        this.$log.debug('Access token expired');
        // Must we do this?
        this._userManager.signinSilent().then(function (user) {
            _this8.$log.debug('Relogin success ', user);
            _this8._setUser(user);
        }, function (err) {
            _this8.$log.debug('Relogin failed: ', err);
            _this8._setUser();
        });
    };

    AuthService.prototype._accessTokenExpiring = function _accessTokenExpiring() {
        this.$log.debug('Access token expiring');
    };

    AuthService.prototype._formatAcrValues = function _formatAcrValues(acrValues) {
        if (!acrValues) {
            return;
        }

        var acr_values = this._userManager.settings.acr_values || '';
        for (var key in acrValues) {
            if (acrValues.hasOwnProperty(key)) {
                acr_values += key + ':' + acrValues[key] + ' ';
            }
        }
        return acr_values.trim();
    };

    AuthService.prototype._setUser = function _setUser(value) {
        this._user = value;

        if (value) {
            this._userLoadedEvent.raise(value);
            //this._callbacks.forEach(callback => callback(value));

            // track is the user came from flexmail
            if (this.$location.search().track === 'true') {
                window.localStorage.setItem('FlexMail', true);
            }

            // GA track user entered page and logged in
            if (window.localStorage.getItem('GAUserNotLoggedInTrack') === 'true' && !window.localStorage.getItem('GAUserNotLoggedInTracked')) {
                this.Analytics.trackEvent('GAUserLoggedIn', 'GAUserLoggedIn', 'GAUserLoggedIn');
                window.localStorage.setItem('GAUserNotLoggedInTracked', true);
            }

            // GA if the user clicked a flexmail link, log it once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexTrack')) {
                window.localStorage.setItem('GAFlexTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked');
            }

            // GA if the user that clicked a flexmail link, and is already logged in, log it. Only log this once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexAlreadyLoginTrack') && window.localStorage.getItem('GAFlexTrack') && !window.sessionStorage.getItem('GAFlexNewLoginTrack')) {
                window.localStorage.setItem('GAFlexAlreadyLoginTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailUserAlreadyLoggedIn', 'GATrackFlexmailUserAlreadyLoggedIn', 'GATrackFlexmailUserAlreadyLoggedIn');
            }
        } else {
            this._userUnloadedEvent.raise(value);
        }
    };

    AuthService.prototype._signIn = function _signIn(requestedUrl, acrValues, language) {
        var _this9 = this;

        this.$log.debug('Security - sign in');

        // if(window.localStorage.getItem('lastLoginGA')) {
        //     var blw = moment(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff(moment(), 'days');
        // }

        // //first time log in
        // if(!window.localStorage.getItem('lastLoginGA')) {
        //     window.localStorage.setItem('lastLoginGA', moment().format('DD-MM-YYYY'));
        //     // track is the user came from flexmail
        // } else if (moment(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff(moment(), 'days') > 0 ) {
        //     blw;
        // }

        if (this.$location.search().track === 'true') {
            window.localStorage.setItem('FlexMail', true);
        }

        //if the last time the user logged in is greater than a day
        if ((0, _moment2.default)(window.localStorage.getItem('lastLoginGA'), 'DD-MM-YYYY').diff((0, _moment2.default)(), 'days') > 0 || !window.localStorage.getItem('lastLoginGA')) {

            //clear the GA values in the local storage
            this.clearGALocalStorage();

            //set a new last logged in value in the local storage
            window.localStorage.setItem('lastLoginGA', (0, _moment2.default)().format('DD-MM-YYYY'));

            // GA track user entered page and not logged in, only log this once
            if (!window.localStorage.getItem('GAUserNotLoggedInTrack')) {
                window.localStorage.setItem('GAUserNotLoggedInTrack', true);
                this.Analytics.trackEvent('GAUserNotLoggedIn', 'GAUserNotLoggedIn', 'GAUserNotLoggedIn');
            }

            // GA if the user clicked a flexmail link, log it once
            if (window.localStorage.getItem('FlexMail') && !window.localStorage.getItem('GAFlexTrack')) {
                window.localStorage.setItem('GAFlexTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked', 'GATrackFlexmailLinkClicked');
            }

            // GA if the user that clicked a flexmail link and had to log in, log it. Only log this once
            if (window.localStorage.getItem('FlexMail') && window.localStorage.getItem('GAFlexTrack') && !window.localStorage.getItem('GAFlexNewLoginTrack')) {
                window.localStorage.setItem('GAFlexNewLoginTrack', true);
                this.Analytics.trackEvent('GATrackFlexmailUserLoggedIn', 'GATrackFlexmailUserLoggedIn', 'GATrackFlexmailUserLoggedIn');
            }

            if (this.isAuthenticated && !acrValues) {
                // If the user is allready authenticated we can signIn
                // without bothering the user.
                // Also the history doesn't get polluted with an extra call to sso.
                return this.$q.when(this._userManager.signinSilent()).then(function () {
                    if (requestedUrl) {
                        _this9.$location.url(requestedUrl);
                        //window.location.assign(requestedUrl);
                    }
                }, function (error) {
                    // If signinSilent fails, log it and log out the user
                    _this9.$exceptionHandler(error);
                    _this9.$log.debug('SigninSilent error ' + error);
                    _this9.signOut();
                });
            }
        }

        window.sessionStorage.setItem('redirectUrl', requestedUrl);

        return this._userManager.signinRedirect({
            acr_values: this._formatAcrValues(acrValues),
            ui_locales: language
        }).then(function () {
            return _this9.$q.reject();
        });
    };

    AuthService.prototype._silentRenewError = function _silentRenewError(e) {
        this.$log.debug('Silent renew error');
        // If silentRenew fails, log it and log out the user
        this.$exceptionHandler(e);
        this.signOut();
    };

    AuthService.prototype._userLoaded = function _userLoaded(user) {
        this._setUser(user);
        this.$log.debug('user loaded: ', user);
    };

    AuthService.prototype._userSignedOut = function _userSignedOut() {
        var _this10 = this;

        var user = Object.assign({}, this._user);
        this._setUser();
        this.$log.debug('User signed out');
        setTimeout(function () {
            return _this10._userSignedOutEvent.raise(user);
        });
    };

    AuthService.prototype._userUnloaded = function _userUnloaded() {
        this._setUser();
        this.$log.debug('user unloaded');
    };

    AuthService.prototype._wireUserManagerEvents = function _wireUserManagerEvents() {
        var _this11 = this;

        this._userManager.events.addAccessTokenExpiring(function () {
            return _this11._accessTokenExpiring();
        });
        this._userManager.events.addAccessTokenExpired(function () {
            return _this11._accessTokenExpired();
        });
        this._userManager.events.addSilentRenewError(function (e) {
            return _this11._silentRenewError(e);
        });
        this._userManager.events.addUserLoaded(function (user) {
            return _this11._userLoaded(user);
        });
        this._userManager.events.addUserSignedOut(function () {
            return _this11._userSignedOut();
        });
        this._userManager.events.addUserUnloaded(function () {
            return _this11._userUnloaded();
        });
    };

    _createClass(AuthService, [{
        key: 'isAuthenticated',
        get: function get() {
            return !!this.user;
        }
    }, {
        key: 'isFebelcoCustomer',
        get: function get() {
            return this.user ? this.user.IsFebelcoCustomer === 'True' : false;
        }
    }, {
        key: 'isBuyer',
        get: function get() {
            return this.user ? this.user.IsBuyer === 'IsBuyer' : false;
        }
    }, {
        key: 'isSeller',
        get: function get() {
            return this.user ? this.user.IsSeller === 'IsSeller' : false;
        }
    }, {
        key: 'defaultWholesalerId',
        get: function get() {
            return this.user.DefaultWholesalerId;
        },
        set: function set(id) {
            this.user.DefaultWholesalerId = id;
        }
    }, {
        key: 'user',
        get: function get() {
            if (this._user) {
                return Object.assign({}, this._user.profile, {
                    customInfo: this._customUserInfo
                });
            }
            return;
        }
    }, {
        key: 'accessToken',
        get: function get() {
            if (this._user) {
                return this._user.access_token;
            }
            return '';
        }
    }, {
        key: 'customUserInfo',
        get: function get() {
            return this._customUserInfo || {};
        },
        set: function set(value) {
            this._customUserInfo = value;
        }
    }]);

    return AuthService;
}();

var Event = function () {
    function Event(name) {
        _classCallCheck(this, Event);

        this._name = name;
        this._callbacks = [];
    }

    Event.prototype.addHandler = function addHandler(cb) {
        this._callbacks.push(cb);
    };

    Event.prototype.removeHandler = function removeHandler(cb) {
        var idx = this._callbacks.findIndex(function (item) {
            return item === cb;
        });
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    };

    Event.prototype.raise = function raise() {
        for (var _iterator = this._callbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var cb = _ref;

            cb.apply(undefined, arguments);
        }
    };

    return Event;
}();

exports.default = AuthService;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _security = __webpack_require__(151);

var _security2 = _interopRequireDefault(_security);

var _authService = __webpack_require__(696);

var _authService2 = _interopRequireDefault(_authService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*jshint esversion: 6 */
_security2.default.provider('authService', AuthServiceProvider);

function AuthServiceProvider() {
    var baseUrl = window.location.protocol + '//' + window.location.host;
    //var authService;
    //https://github.com/IdentityModel/oidc-client-js/wiki#configuration
    var defaultSettings = {
        //authority: "https://dev-sso.febelco.be", // "https://idsv-webhost.febelco.be",
        //client_id: "Profficina.Admin",
        redirect_uri: baseUrl + '/loginRedirect.html',
        post_logout_redirect_uri: baseUrl

        // Required if you want to use the silent_renew
        , response_type: 'id_token token'
        //scope: "openid profile email profficinaAdmin",

        // Silent renew will get a new access_token via an iframe just prior to the old access_token expiring (60 seconds prior)
        // The HTML file will be used in a dynamically created iframe to renew the token. The URL of that page is passed to the token manager
        // settings to instruct it to automatically renew the token when it expires.
        // The token manager will renew the token 60 seconds before it expires, which explains why we chose to change to access token 
        // lifetime to 70 seconds (client.cs of the Identity server). This means the token will be renewed every 10 seconds.
        , silent_redirect_uri: baseUrl + '/silentRenew.html',
        automaticSilentRenew: false

        // This will allow all the OIDC protocol claims to be visible in the window. 
        // Normally a client app wouldn't care about them or want them taking up space
        , filterProtocolClaims: false

        // This will use the user info endpoint if it's an OIDC request and there's an access_token
        , loadUserInfo: false
        // Will raise events for when user has performed a signout at the OP.
        // (default: true)
        , monitorSession: false
        // Sets the interval for cheking if the session is still valid.
        , checkSessionInterval: 10000
        // Storage object used to persist User for currently authenticated user. E.g. userStore: new WebStorageStateStore({ store: window.localStorage })
        // (default: session storage)
        // ,userStore: new WebStorageStateStore({ store: window.sessionStorage })
        // The number of seconds before an access token is to expire to raise the accessTokenExpiring event.
        // (default: 60)
        // ,accessTokenExpiringNotificationTime: 60
    },
        settings = Object.assign({}, defaultSettings);

    this.configure = function (appSettings, url) {
        if (url) {
            baseUrl = url;
        }

        settings = Object.assign(defaultSettings, appSettings);
    };

    this.getSettings = function () {
        return Object.assign({}, settings);
    };

    this.getSignInPath = function () {
        return settings.redirect_uri.replace(baseUrl, '');
    };

    this.getSignOutPath = function () {
        return settings.post_logout_redirect_uri.replace(baseUrl, '');
    };

    this.$get = ['$log', '$q', '$location', '$exceptionHandler', 'Analytics', function ($log, $q, $location, $exceptionHandler, Analytics) {
        return new _authService2.default($log, $q, $location, $exceptionHandler, settings, Analytics);
    }];
}

//SecurityModule.service("authService", AuthService);

//AuthService.$inject = ["$log", "$document"];

//function AuthService($log, $q, settings) {
//    const oidcMgr = new OidcClient.UserManager(settings);
//    var callbacks = [];
//    var loggedInUser;
//    var initialized;
//
//    //OidcClient.Log.logger = $log;
//
//    // Raised when a user session has been established (or re-established)
//    oidcMgr.events.addUserLoaded(function(user) {
//        loggedInUser = user;
//
//        callbacks.forEach(callback => callback(user));
//        $log.debug("oidcMgr.events.addUserLoaded()");
//    });
//    oidcMgr.events.addUserUnloaded(function() {
//        loggedInUser = undefined;
//        $log.debug("oidcMgr.events.addUserUnloaded()");
//    });
//    oidcMgr.events.addAccessTokenExpiring(function() {
//        $log.debug("oidcMgr.events.addAccessTokenExpiring()");
//    });
//    oidcMgr.events.addAccessTokenExpired(function() {
//        loggedInUser = undefined;
//        $log.debug("oidcMgr.events.addAccessTokenExpired()");
//    });
//    oidcMgr.events.addSilentRenewError(function(e) {
//        loggedInUser = undefined;
//        $log.debug(" oidcMgr.events.addSilentRenewError(): ", e.message);
//    });
//    oidcMgr.events.addUserSignedOut(e => {
//        loggedInUser = undefined;
//        $log.debug(" oidcMgr.events.userSignedOut(): ", e);
//    });
//
//    function init() {
//        initialized = false;
//        return oidcMgr.getUser().then(user =>{ 
//            loggedInUser = user;
//            initialized = true; 
//        }, () => initialized = true);
//    }
//
//    function signIn(requestedUrl, acrValues) {
//        debugger;
//        $log.debug("Security - sign in");
//
//        if(this.isAuthenticated() && !acrValues){
//            return $q.resolve();
//        }
//
//        if(initialized === false){
//            var deferred = $q.defer();
//            setTimeout(function(ctx, url) {
//                ctx.signIn(url).then(deferred.resolve, deferred.reject, deferred.notify);
//            }, 100, this, requestedUrl);
//            return deferred.promise;
//        }
//
//        let signInObj = { 
//            scope: settings.scope, 
//            response_type: settings.response_type 
//        };
//
//        if(acrValues){
//            var acr_values = "";
//            for (var key in acrValues) {
//                if (acrValues.hasOwnProperty(key)) {
//                    acr_values += key + ":" + acrValues[key] + " ";                    
//                }
//            }
//            signInObj.acr_values = acr_values.trim();
//        }
//
//        window.sessionStorage.setItem("redirectUrl", requestedUrl);
//
//        return oidcMgr.signinRedirect(signInObj).then(function() {
//            $log.debug("Security - sign in success");
//            return $q.reject();
//        }, function(e) {
//            $log.debug("Security - sign in failed: " + e);
//            return $q.reject();
//        });
//    }
//
//    function processLoginResponseData(responseData) {
//        return oidcMgr.signinRedirectCallback(responseData).then(function(/*user*/) {
//            $log.debug("Security - signed in");
//            //loggedInUser = user;
//            let redirectUrl = window.sessionStorage.getItem("redirectUrl") || "/";
//            // Clean up
//            window.sessionStorage.removeItem("redirectUrl");
//            return redirectUrl;
//        }, function(e) {
//            $log.debug("Security - sign in failed: " + e);
//            loggedInUser = undefined;
//            return "/401";
//        });
//    }
//
//    function signOut() {
//        $log.debug("Security - sign out");
//        return oidcMgr.signoutRedirect().then(() => loggedInUser = undefined);
//    }
//
//    function getAccessToken() {
//        if (loggedInUser) {
//            return loggedInUser.access_token;
//        }
//        return "";
//    }
//
//    function isAuthenticated() {
//        return settings.disableSecurity || !!loggedInUser;
//    }
//
//    function getUser() {
//        if (loggedInUser) {
//            return loggedInUser.profile;
//        }
//        return;
//    }
//
//    function addUserLoadedEvent(callback){
//        callbacks.push(callback);
//        return () => callbacks.splice(callbacks.findIndex(callback),1);
//    }
//
//    return {
//        addUserLoadedEvent: addUserLoadedEvent,
//        getAccessToken: getAccessToken,
//        getUser: getUser,
//        init: init,
//        isAuthenticated: isAuthenticated,
//        processLoginResponseData: processLoginResponseData,
//        signIn: signIn,
//        signOut: signOut
//    };
//}

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _security = __webpack_require__(151);

var _security2 = _interopRequireDefault(_security);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_security2.default.directive('claimAuthorize', ['ngIfDirective', 'authService', function (ngIfDirective, authService) {
    var ngIf = ngIfDirective[0];

    return {
        transclude: ngIf.transclude,
        priority: ngIf.priority,
        terminal: ngIf.terminal,
        restrict: ngIf.restrict,
        link: function link($scope, $element, $attr) {
            var claim = $attr.claimAuthorize;
            var value = $scope.$eval($attr.claimValue);
            //var yourCustomValue = $scope.$eval(claim);

            $attr.ngIf = function () {
                return authService.hasClaim(claim, value);
            };
            ngIf.link.apply(ngIf, arguments);
        }
    };
}]); /*jshint esversion: 6 */
/* http://stackoverflow.com/questions/20325480/angularjs-whats-the-best-practice-to-add-ngif-to-a-directive-programmatically */

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


apiFactory.$inject = ["$resource", "$cacheFactory", "config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.apiFactory = apiFactory;
/*@ngInject*/
function apiFactory($resource, $cacheFactory, config) {
    var baseUrl = config.webApiBaseUrl;

    //var sellersCache = $cacheFactory('sellers');
    // var categoriesCache = $cacheFactory('categories');

    return {
        // products

        products: $resource(baseUrl + 'products/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            query: {
                method: 'GET',
                isArray: true
            },
            save: {
                method: 'POST'
            },
            remove: {
                method: 'DELETE'
            },
            delete: {
                method: 'DELETE'
            }
        }),
        productMedipim: $resource(baseUrl + 'products/:productId/getMediPimData', null, {
            getMedipimData: {
                method: 'GET',
                isArray: false
            }
        }),
        productSearch: $resource(baseUrl + 'products/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),

        outletProductsSearch: $resource(baseUrl + 'products/searchOutletProducts', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProducts: $resource(baseUrl + 'productrentals/:sellerId/getByCategory/:categoryId', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        rentalProduct: $resource(baseUrl + 'productrentals/:productId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProductMedipim: $resource(baseUrl + 'productrentals/:productId/getMediPimData', null, {
            getMedipimData: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalProductsOrder: $resource(baseUrl + 'rentalorder/rentProducts', null, {
            order: {
                method: 'POST',
                isArray: false
            }
        }),
        rentalProductCategories: $resource(baseUrl + 'productrentals/getRentalProductCategories/:sellerId', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        rentalHistory: $resource(baseUrl + 'rentalHistory/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalHistoryDetail: $resource(baseUrl + 'rentalHistory/:id', null, {
            getById: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalHistoryRemark: $resource(baseUrl + 'rentalHistory/remark', null, {
            set: {
                method: 'PUT',
                isArray: false
            }
        }),
        rentalHistoryStatus: $resource(baseUrl + 'rentalHistoryStatus/search', null, {
            getAll: {
                method: 'GET',
                isArray: false
            }
        }),
        rentalOrderSearch: $resource(baseUrl + 'rentalorder/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        productReservations: $resource(baseUrl + 'productreservations/getreservations?sortField=:sortField&sortAsc=:sortAsc', null, {
            getAll: {
                method: 'GET',
                isArray: true
            }
        }),
        // searchCities: $resource(baseUrl + 'belgiumPostalLocality?name=:name&code=:code ', null, {
        //     execute: {
        //         method: 'GET',
        //         isArray: false
        //     }
        // }),
        // searchStreet: $resource(baseUrl + 'belgiumStreet?name=:name&postalLocalityId=:postalLocalityId', null, {
        //     execute: {
        //         method: 'GET',
        //         isArray: false
        //     }
        // }),
        searchCities: $resource(baseUrl + 'postalLocality?name=:name&code=:code', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        searchStreet: $resource(baseUrl + 'street?name=:name&postalLocalityId=:postalLocalityId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        productFilter: $resource(baseUrl + 'products/filter', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        productStock: $resource(baseUrl + 'products/stock/:productNumber/:quantity', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        productDiscounts: $resource(baseUrl + 'products/getProductDiscounts/:productId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // sellers

        sellers: $resource(baseUrl + 'sellers/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryQuestions: $resource(baseUrl + 'sellers/:sellerId/getQuestions', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryDocumentCategories: $resource(baseUrl + 'sellers/:sellerId/getDocumentCategories', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        libraryDocument: $resource(baseUrl + 'sellers/DownloadFile/:documentId', null, {
            get: {
                method: 'GET',
                responseType: 'arraybuffer'
            }
        }),

        outletSeller: $resource(baseUrl + 'sellers/outlet', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        menuSellers: $resource(baseUrl + 'sellers/getSellersForMenu', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerModules: $resource(baseUrl + 'sellers/:id/modules', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerAbout: $resource(baseUrl + 'sellers/:id/about', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerBanners: $resource(baseUrl + 'sellers/:id/home/banners', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerProductsAndDiscounts: $resource(baseUrl + 'sellers/:id/home/productsdiscounts', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerCategory: $resource(baseUrl + 'sellers/:id/category/:categoryId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        totalPriceDiscounts: $resource(baseUrl + 'sellers/:id/totalPriceDiscounts', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        sellerContact: $resource(baseUrl + 'sellers/:id/contact', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerPublic: $resource(baseUrl + 'sellers/:id/public', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //wholeSalers

        wholesalers: $resource(baseUrl + 'wholeSaler/getAllWholeSalers', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        // partnerships

        partnerships: $resource(baseUrl + 'partnership/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: false
            }
        }),

        // sellerCategory: $resource(baseUrl + 'sellers/:id/category/:categoryId', null, {
        //     get: { method:'GET', isArray: false }
        // }),

        // brands

        brands: $resource(baseUrl + 'brands/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // banner

        banners: $resource(baseUrl + 'banner', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // categories

        categories: $resource(baseUrl + 'categories', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'POST',
                isArray: true
            }
        }),

        categoriesMenu: $resource(baseUrl + 'categories/menu', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        sellerCategories: $resource(baseUrl + 'products/sellerCategories/:sellerId', null, {
            getSellerCategories: {
                method: 'GET',
                isArray: false
            }
        }),
        category: $resource(baseUrl + 'categories/get/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // cart

        cart: $resource(baseUrl + 'shoppingcart/v2', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //checkout cart
        checkoutCart: $resource(baseUrl + 'shoppingcart/v2/checkout', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        shoppingCartProducts: $resource(baseUrl + 'shoppingcart/getShoppingCartProducts', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        getCustomerAccounts: $resource(baseUrl + 'shoppingcart/customerAccounts', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setProductQuantity: $resource(baseUrl + 'shoppingcart/setProductQuantity', null, {
            execute: {
                method: 'POST',
                isArray: true
            }
        }),

        addProductToCart: $resource(baseUrl + 'shoppingcart/addProduct', null, {
            execute: {
                method: 'POST'
            }
        }),

        setQuantityOfProductToCart: $resource(baseUrl + 'shoppingcart/setQuantityOfProduct', null, {
            execute: {
                method: 'POST'
            }
        }),

        removeProductFromCart: $resource(baseUrl + 'shoppingcart/removeProduct/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        addPromoPackToCart: $resource(baseUrl + 'shoppingcart/addPromoPack', null, {
            execute: {
                method: 'POST'
            }
        }),

        setQuantityOfPromoPackToCart: $resource(baseUrl + 'shoppingcart/setQuantityOfPromoPack', null, {
            execute: {
                method: 'POST'
            }
        }),

        removePromoPackFromCart: $resource(baseUrl + 'shoppingcart/removePromoPack/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        setPanaceeToCart: $resource(baseUrl + 'shoppingcart/setPanacee', null, {
            execute: {
                method: 'POST'
            }
        }),

        removePanaceeFromCart: $resource(baseUrl + 'shoppingcart/removePanacee/:productId/:discountId', null, {
            execute: {
                method: 'DELETE'
            }
        }),

        getAddedToCartInfo: $resource(baseUrl + 'shoppingcart/addedToCartInfo/:id/:discountId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        checkout: $resource(baseUrl + 'shoppingcart/checkout/v2', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        createOrders: $resource(baseUrl + 'shoppingcart/order', null, {
            execute: {
                method: 'POST',
                isArray: true
            }
        }),

        clearCart: $resource(baseUrl + 'shoppingcart/clear', null, {
            execute: {
                method: 'DELETE',
                isArray: false
            }
        }),

        deactivateCartMessage: $resource(baseUrl + 'shoppingcart/deactivateMessage/:messageId', {
            messageId: '@messageId'
        }, {
            deactivate: {
                method: 'PUT',
                isArray: false
            }
        }),

        reOrderProducts: $resource(baseUrl + 'shoppingcart/reOrderProducts', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),

        // order
        orders: $resource(baseUrl + 'orders/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        orderSearch: $resource(baseUrl + 'orders/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        shippingNoteSearch: $resource(baseUrl + 'orders/:id/shippingNote/:warehouseCode/:shippingNote', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        setOrderDeliveryDate: $resource(baseUrl + 'orders/setDeliveryDate', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        // discounttypes
        discounttypes: $resource(baseUrl + 'discounttypes/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        // tenants
        tenants: $resource(baseUrl + 'account/accounts', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // myAccount
        myAccount: $resource(baseUrl + 'account/myaccount', null, {
            get: {
                method: 'GET',
                isArray: false
            },
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        currentTenant: $resource(baseUrl + 'account/currentTenant', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setBuyerMail: $resource(baseUrl + 'account/setBuyerMail', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),

        setBuyerMailLanguage: $resource(baseUrl + 'account/setBuyerMailLanguage', null, {
            execute: {
                method: 'PUT',
                isArray: false
            }
        }),
        // tenantsOld
        // tenants: $resource(baseUrl + 'tenants/:id', null, {
        //     get: { method:'GET', isArray: false },
        //     list: { method:'GET', isArray: true }
        // })

        //news
        newsSearch: $resource(baseUrl + 'news/search', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        news: $resource(baseUrl + 'news/:id', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),

        newsCategories: $resource(baseUrl + 'news/categories/search', null, {
            execute: {
                method: 'GET',
                isArray: true
            }
        }),

        // fast order
        searchProduct: $resource(baseUrl + 'shoppingcart/searchProduct', null, {
            execute: {
                method: 'GET',
                isArray: true
            }
        }),

        quickAddProducts: $resource(baseUrl + 'shoppingcart/quickAddProducts', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        removeSellerFromCart: $resource(baseUrl + 'shoppingcart/removeSellerFromCart', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        // contracts
        contracts: $resource(baseUrl + 'contract', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        numberOfContracts: $resource(baseUrl + 'contract/amount/:sellerId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        contractDetail: $resource(baseUrl + 'contract/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerContract: $resource(baseUrl + 'sellers/:sellerId/contract/:contractId', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        sellerContracts: $resource(baseUrl + 'sellers/:sellerId/contract', null, {
            list: {
                method: 'GET',
                isArray: true
            }
        }),

        // vaccines
        vaccinreservation: $resource(baseUrl + 'vaccinreservation', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setReservationAmounts: $resource(baseUrl + 'vaccinreservation/setReservationAmounts', null, {
            set: {
                method: 'PUT',
                isArray: true
            }
        }),

        // reservation campaigns
        reservationCampaign: $resource(baseUrl + 'reservation/:code', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        setReservationCampaignAmounts: $resource(baseUrl + 'reservation/:code/setReservationAmounts', null, {
            set: {
                method: 'PUT',
                isArray: true
            }
        }),

        getActiveReservationCampaigns: $resource(baseUrl + 'reservation/activeCampaigns', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),

        //corona
        coronaReservation: $resource(baseUrl + 'reservation', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),

        //outlet
        outlet: $resource(baseUrl + 'outlet', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        outletHomePage: $resource(baseUrl + 'outlet/outletHomePage', null, {
            get: {
                method: 'GET'
            }
        }),

        //buyer-base
        buyerBaseSearch: $resource(baseUrl + 'buyerBase?search=:search&sellerId=:sellerId', null, {
            execute: {
                method: 'GET',
                isArray: false
            }
        }),
        certificates: $resource(baseUrl + 'certificates/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        podValidateContact: $resource(baseUrl + 'pod/validateContact?licenseNumber=:licenseNumber', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        podOrderTypes: $resource(baseUrl + 'pod/orderTypes', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        podPackageTypes: $resource(baseUrl + 'pod/packageTypes', null, {
            get: {
                method: 'GET',
                isArray: true
            }
        }),
        podOrderAdd: $resource(baseUrl + 'pod/:orderTypeId', null, {
            execute: {
                method: 'POST',
                isArray: false
            }
        }),
        podOrderDetail: $resource(baseUrl + 'pod/:orderTypeId/cancel', null, {
            cancel: {
                method: 'POST',
                isArray: false
            }
        }),
        pod: $resource(baseUrl + 'pod/:id', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        }),
        podSearch: $resource(baseUrl + 'pod/search', null, {
            search: {
                method: 'GET',
                isArray: false
            }
        }),
        podLineStateHistory: $resource(baseUrl + 'pod/:lineId/stateHistory', null, {
            get: {
                method: 'GET',
                isArray: false
            }
        })
    };
}

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.config = undefined;

var _profficinaConfig = __webpack_require__(1034);

var _profficinaConfig2 = _interopRequireDefault(_profficinaConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = exports.config = {
    env: _profficinaConfig2.default.env,
    webApiBaseUrl: _profficinaConfig2.default.webApiBaseUrl,
    imageBaseUrl: _profficinaConfig2.default.imageBaseUrl,
    ssoBaseUrl: _profficinaConfig2.default.ssoBaseUrl,
    enableTests: _profficinaConfig2.default.enableTests,
    fluVaccines: _profficinaConfig2.default.fluVaccines
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var searchContext = {
    none: { id: 0, value: 'none', description: 'None' },
    seller: { id: 1, value: 'seller', description: 'Seller' },
    discount: { id: 2, value: 'discount', description: 'Discount' },
    brand: { id: 3, value: 'brand', description: 'Brand' },
    category: { id: 4, value: 'category', description: 'Category' },
    search: { id: 5, value: 'search', description: 'Search' },
    sellerProducts: {
        id: 6,
        value: 'sellerProducts',
        description: 'SellerProducts'
    }
};

var newsContext = {
    main: { id: 0, value: 'main', description: 'main' },
    seller: { id: 1, value: 'seller', description: 'seller' },
    brand: { id: 2, value: 'brand', description: 'brand' },
    product: { id: 3, value: 'product', description: 'product' }
};

// all values in categoryType are those that are in table CategoryType
var categoryType = {
    apbCategory: { id: 1, value: 'apbCategory', description: 'APB Category' },
    category: { id: 2, value: 'category', description: 'Category' },
    brand: { id: 3, value: 'brand', description: 'Brand' },
    seller: { id: 45, value: 'seller', description: 'Seller' },
    productRange: { id: 47, value: 'productRange', description: 'ProductRange' }
};

// other category types are those that are not in CategoryType, but that are categories/blocks in the filter
var otherCategoryType = {
    discountType: {
        id: 101,
        value: 'discountType',
        description: 'Discount type'
    },
    seller: { id: 102, value: 'sellers', description: 'Sellers' },
    discountsOnly: {
        id: 103,
        value: 'discountsOnly',
        description: 'Discounts only'
    }
};

// the different type of filters.
// these are stored in different tables in the database, but are passed in the same array when getting the filters
// we keep these values to distinguish between different types
var categoryFilterType = {
    category: { id: 0, description: 'Category' },
    sellerCategory: { id: 1, description: 'Seller category' },
    seller: { id: 2, description: 'Seller' },
    discountType: { id: 3, description: 'discountType' },
    customCategory: { id: 10, value: 'specialDiscounts', description: 'Special Discounts' }
};

var navigationMenuItems = {
    home: { id: 1, value: 'home' },
    discounts: { id: 2, value: 'discounts' },
    sellers: { id: 3, value: 'sellers' },
    brands: { id: 4, value: 'brands' },
    products: { id: 5, value: 'products' },
    news: { id: 6, value: 'news' }
};

var productContexts = {
    PRODUCTDETAIL: 'PRODUCTDETAIL'
};

var getAmounts = {
    default: 20
};

var orderStatusTexts = {
    REGSELLER: { text: gettext('Registered by seller') },
    CREATED: { text: gettext('Created') },
    SENTSELLER: { text: gettext('Sent to seller') },
    REGWS: { text: gettext('Registered') },
    BUSYWS: { text: gettext('In progress') },
    READYWS: { text: gettext('(Will be) delivered') },
    CANCELLED: { text: gettext('Cancelled') },
    ERROR: { text: gettext('Error') },
    REGWSP: { text: gettext('Partially registered by wholesaler') },
    BUSYWSP: { text: gettext('Partially in progress by wholesaler') },
    READYWSP: { text: gettext('(Will be) partially delivered') },
    INVWS: { text: gettext('Invoiced') },
    INVWSP: { text: gettext('Partially invoiced') }
};

var deliveryStatusTexts = {
    DELIVREG: { text: gettext('Registered') },
    DELIVBUSY: { text: gettext('In progress') },
    DELIVREADY: { text: gettext('(Will be) delivered') },
    DELIVINV: { text: gettext('Delivered') }
};

var bannerTextAlignmentClasses = {
    '0': { name: '' },
    '1': { name: 'hero-text-top-left' },
    '2': { name: 'hero-text-top-center' },
    '3': { name: 'hero-text-top-right' },
    '4': { name: 'hero-text-left' },
    '5': { name: 'hero-text-center' },
    '6': { name: 'hero-text-right' },
    '7': { name: 'hero-text-bottom-left' },
    '8': { name: 'hero-text-bottom-center' },
    '9': { name: 'hero-text-bottom-right' }
};

var emailLanguages = [{
    id: 2,
    displayName: gettext('Dutch')
}, {
    id: 3,
    displayName: gettext('French')
}];

var orderProductStatusCodes = {
    CREATED: { value: 'CREATED' },
    CONFIRMED: { value: 'CONFIRMED' },
    ERROR: { value: 'ERROR' },
    REPLACED: { value: 'REPLACED' },
    MODIFIED: { value: 'MODIFIED' },
    CANCELLED: { value: 'CANCELLED' },
    REQUESTED: { value: 'REQUESTED' },
    REG: { value: 'REG' },
    PEN: { value: 'PEN' },
    CON: { value: 'CON' },
    CWN: { value: 'CWN' },
    CAN: { value: 'CAN' }
};

var orderProductReasonCodes = {
    NOSTOCK: { value: 'NOSTOCK' },
    NOSTOCKSUP: { value: 'NOSTOCKSUP' },
    UNKCNK: { value: 'UNKCNK' },
    OFFMARKET: { value: 'OFFMARKET' },
    NOSERVICE: { value: 'NOSERVICE' },
    REFUSED: { value: 'REFUSED' },
    FORWARDED: { value: 'FORWARDED' },
    LIMITED: { value: 'LIMITED' },
    CUSTSERV: { value: 'CUSTSERV' }
};

var rentalProductRelationTypeCodes = {
    RECOM: { value: 'RECOM' },
    INTER: { value: 'INTER' }
};

var newsSliderSettings = {
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    touchMove: false,
    responsive: [{
        breakpoint: 1199,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
};

var partnershipGallerySliderSettings = {
    autoplay: false,
    dots: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    variableWidth: false,
    responsive: [{
        breakpoint: 992,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 576,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }]
};

var productSliderSettings = {
    dots: true,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    touchMove: false,
    responsive: [{
        breakpoint: 1199,
        settings: {
            slidesToShow: 4,
            slidesToScroll: 4
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2
        }
    }, {
        breakpoint: 575,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
};

var rentalCheckoutMenuSteps = exports.rentalCheckoutMenuSteps = [{ index: 0, value: 'Uw aanvraag' }, { index: 1, value: 'Suggesties' }, { index: 2, value: 'Verstuur' }];

var enums = exports.enums = {
    bannerTextAlignmentClasses: bannerTextAlignmentClasses,
    searchContext: searchContext,
    newsContext: newsContext,
    categoryType: categoryType,
    otherCategoryType: otherCategoryType,
    categoryFilterType: categoryFilterType,
    navigationMenuItems: navigationMenuItems,
    orderStatusTexts: orderStatusTexts,
    deliveryStatusTexts: deliveryStatusTexts,
    productContexts: productContexts,
    emailLanguages: emailLanguages,
    orderProductStatusCodes: orderProductStatusCodes,
    orderProductReasonCodes: orderProductReasonCodes,
    getAmounts: getAmounts,
    partnershipGallerySliderSettings: partnershipGallerySliderSettings,
    productSliderSettings: productSliderSettings,
    newsSliderSettings: newsSliderSettings,
    rentalCheckoutMenuSteps: rentalCheckoutMenuSteps,
    rentalProductRelationTypeCodes: rentalProductRelationTypeCodes
};

var breakpoints = exports.breakpoints = [{ name: 'xs', min: 0, max: 575 }, { name: 'sm', min: 576, max: 767 }, { name: 'md', min: 768, max: 991 }, { name: 'lg', min: 992, max: 1199 }, { name: 'xl', min: 1200, max: 99999 }];

var productTypes = exports.productTypes = {
    single: { serverValue: 'PORTALPRODUCT', clientValue: 'single' },
    pack: { serverValue: 'PROMOPACK', clientValue: 'pack' },
    panacee: { serverValue: 'PANACEE', clientValue: 'panacee' }
};

var discountTypes = exports.discountTypes = {
    single: { serverValue: 'PORTALPRODUCT', clientValue: 'single' },
    pack: { serverValue: 'PROMOPACK', clientValue: 'pack' },
    panacee: { serverValue: 'PANACEE', clientValue: 'panacee' },
    counter: { serverValue: 'PRODUCTCOUNTER', clientValue: 'counter' }
};

var discountTypeNames = exports.discountTypeNames = {
    PORTALPRODUCT: {
        serverValue: 'PORTALPRODUCT',
        clientValue: gettext('Product discount')
    },
    PROMOPACK: { serverValue: 'PROMOPACK', clientValue: gettext('Promopack') },
    PANACEE: { serverValue: 'PANACEE', clientValue: gettext('Panaché') },
    PRODUCTCOUNTER: {
        serverValue: 'PRODUCTCOUNTER',
        clientValue: gettext('Counter discount')
    },
    ORDERTOTALPRICE: {
        serverValue: 'ORDERTOTALPRICE', clientValue: gettext('Order total price')
    }
};

var cartMessageTypes = exports.cartMessageTypes = {
    info: { serverValue: 0, clientValue: 'info' },
    warning: { serverValue: 1, clientValue: 'warning' },
    disabled: { serverValue: 2, clientValue: 'disabled' },
    error: { serverValue: 3, clientValue: 'error' }
};

var sortProperties = exports.sortProperties = {
    DiscountDate: {
        value: 'DiscountDate',
        displayname: gettext('Discount date'),
        defaultSorting: 'desc'
    },
    DiscountAmount: {
        value: 'DiscountAmount',
        displayname: gettext('Max. discount'),
        defaultSorting: 'desc'
    },
    UnitPrice: {
        value: 'UnitPrice',
        displayname: gettext('Price'),
        defaultSorting: 'asc'
    },
    Name: {
        value: 'Name',
        displayname: gettext('Name'),
        defaultSorting: 'asc'
    },
    ProductNumber: { value: 'ProductNumber', displayname: gettext('ProductNumber'), defaultSorting: 'asc' },
    Bwm: { value: 'Bwm', displayname: gettext('GPM'), defaultSorting: 'asc' },
    ProductCreationDate: {
        value: 'ProductCreationDate',
        displayname: gettext('Newest'),
        defaultSorting: 'desc'
    }
};

var newsTypes = exports.newsTypes = [{
    type: 'product',
    label: 'Product'
}, {
    type: 'company',
    label: 'Bedrijf'
}, {
    type: 'campaign',
    label: 'Campagne'
}, {
    type: 'training',
    label: 'Opleiding'
}, {
    type: 'event',
    label: 'Event'
}];

function gettext(string) {
    return string;
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exceptionHandler.$inject = ["$provide"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exceptionHandler = exceptionHandler;
/*@ngInject*/
function exceptionHandler($provide) {
    $provide.decorator('$exceptionHandler', ["$delegate", "$window", "config", function ($delegate, $window, config) {
        'ngInject';

        return function (exception, cause) {
            if (config.env === 'dev' || config.env === 'acc' || config.env === 'prod' /* || config.env === 'local'*/) {
                    //TODO
                    if ($window.trackJs) {
                        // Track error and log anything else of interest.
                        $window.trackJs.track(exception);
                    }
                }
            if (config.env === 'local' || config.env === 'dev') {
                // In *non-production* environments you may still want the error sent to the console.
                // You can delegate to the original handler (console.error) if you'd like.
                // Warning, this can cause double tracking of errors, so do not use in production.
                $delegate(exception, cause);
            }
        };
    }]);
}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


httpInterceptorAuthorization.$inject = ["authService", "$q"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorAuthorization = httpInterceptorAuthorization;
/*@ngInject*/
function httpInterceptorAuthorization(authService, /*$state,*/$q) {
    return {
        request: function request(config) {
            if (authService.isAuthenticated) {
                config.headers.Authorization = 'Bearer ' + authService.accessToken;
            }
            return config;
        },
        responseError: function responseError(rejection) {
            if (rejection.status === 401) {
                authService.signIn();
            }

            // if (rejection.status === 403) {
            //     $state.go('unauthenticated');
            // }

            // create a circular dependency with appModule.config
            // if (rejection.status === 403) {
            //     $state.go('unauthorized');
            // }

            return $q.reject(rejection);
        }
    };
}

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


httpInterceptorErrors.$inject = ["common", "config", "$q", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorErrors = httpInterceptorErrors;
/*@ngInject*/
function httpInterceptorErrors(common, config, $q, $state) {
    return {
        responseError: function responseError(rejection) {

            if (rejection.status >= 400 && rejection.status < 500) {
                var clientError = 'The request was invalid or cannot be otherwise served [' + rejection.status + '].';
                // No longer threat 400 as exceptions
                trackJs.console.warn(clientError);
                //common.log.error(clientError);
                common.log.warn('HTTP client error ' + rejection.status);
                common.log.warn(rejection.data);
            }

            if (rejection.status >= 500) {
                //var serverError = 'Something is broken at the server [' + rejection.status + '].';
                trackJs.addMetadata('rejection data', rejection.config);
                //trackJs.track(serverError);
                common.log.error('HTTP server error ' + rejection.status);
                common.log.error(rejection.data);

                $state.go('error');
            }

            return $q.reject(rejection);
        }
    };
}

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorLanguage = httpInterceptorLanguage;
/*@ngInject*/
function httpInterceptorLanguage() {
    return {
        // On request success
        request: function request(config) {
            if (!config.headers) {
                config.headers = {};
            }

            config.headers['x-accept-language'] = window.localStorage.getItem('language') || 'nl';
            return config;
        }
    };
}

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _apiService = __webpack_require__(699);

var _httpInterceptorAuthorization = __webpack_require__(703);

var _httpInterceptorErrors = __webpack_require__(704);

var _httpInterceptorLanguage = __webpack_require__(705);

var _exceptionHandler = __webpack_require__(702);

var _enums = __webpack_require__(701);

var _config = __webpack_require__(700);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.core', []).config(_exceptionHandler.exceptionHandler).factory('api', _apiService.apiFactory).factory('httpInterceptorAuthorization', _httpInterceptorAuthorization.httpInterceptorAuthorization).factory('httpInterceptorErrors', _httpInterceptorErrors.httpInterceptorErrors).factory('httpInterceptorLanguage', _httpInterceptorLanguage.httpInterceptorLanguage).constant('Enums', _enums.enums).constant('Breakpoints', _enums.breakpoints).constant('NewsTypes', _enums.newsTypes).constant('DiscountTypes', _enums.discountTypes).constant('ProductTypes', _enums.productTypes).constant('CartMessageTypes', _enums.cartMessageTypes).constant('config', _config.config).constant('defaultLanguage', 'nl').constant('sortProperties', _enums.sortProperties).constant('discountTypeNames', _enums.discountTypeNames).constant('productContexts', _enums.productContexts).constant('supportedLanguages', ['nl', 'fr']);

exports.default = _module.name;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbDateFormatter = fbDateFormatter;

var _dateTimeHelper = __webpack_require__(73);

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbDateFormatter() {
    'ngInject';

    return {
        restrict: 'A',
        require: ['ngModel', '?^fbDateTimePicker'],
        link: function link(scope, element, attribute, controllers) {
            var ngModel = controllers[0];
            var datetimepicker = controllers[1];

            var dateTimeHelper = new _dateTimeHelper2.default(attribute.format || _dateTimeHelper2.default.defaultDateFormat);

            ngModel.$parsers.push(function (val) {
                return dateTimeHelper.parseValue(val);
            });
            ngModel.$formatters.push(function (val) {
                return dateTimeHelper.formatValue(val);
            });

            if (datetimepicker) {
                datetimepicker.format = dateTimeHelper.momentFormat;
                // Is this necessary?
                //scope.$watch(ngModel.$modelValue, (newValue /*, oldValue*/) => {
                //    datetimepicker.datetime = newValue;
                //});
                datetimepicker.onValueChanged = function (e) {
                    if (e.date) {
                        ngModel.$setViewValue(e.date.format(dateTimeHelper.momentFormat));
                    } else {
                        ngModel.$setViewValue();
                    }
                };
            }
        }
    };
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dateTimeHelper = __webpack_require__(73);

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatetimepickerController = function () {
    _createClass(DatetimepickerController, null, [{
        key: '$inject',
        get: function get() {
            return ['$element'];
        }
    }]);

    function DatetimepickerController($element) {
        var _this = this;

        _classCallCheck(this, DatetimepickerController);

        this.$element = $element;
        this.$element.on('dp.change', function (e) {
            _this.onValueChanged(e);
        });
    }

    _createClass(DatetimepickerController, [{
        key: 'format',
        get: function get() {
            return this.$element.datetimepicker('format');
        },
        set: function set(value) {
            this.$element.datetimepicker('format', _dateTimeHelper2.default.getMomentFormat(value));
        }
    }, {
        key: 'datetime',
        get: function get() {
            return this.$element.datetimepicker('parseInputDate');
        },
        set: function set(value) {
            // Allow this?
            this.$element.datetimepicker('parseInputDate', value);
        }
    }, {
        key: 'onValueChanged',
        get: function get() {
            return this._onValueChanged || function () {};
        },
        set: function set(value) {
            if (typeof value === 'function') {
                this._onValueChanged = value;
            }
        }
    }]);

    return DatetimepickerController;
}();

exports.default = DatetimepickerController;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


fbDateTimePicker.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbDateTimePicker = fbDateTimePicker;

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _datetimepicker = __webpack_require__(708);

var _datetimepicker2 = _interopRequireDefault(_datetimepicker);

var _dateTimeHelper = __webpack_require__(73);

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

__webpack_require__(4);

__webpack_require__(162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbDateTimePicker(gettextCatalog) {
    'ngInject';

    return {
        restrict: 'A',
        controller: _datetimepicker2.default,
        controllerAs: 'vmDatetimepicker',
        link: function link(scope, element, attribute) {

            var format = _dateTimeHelper2.default.getMomentFormat(attribute.format || _dateTimeHelper2.default.defaultDateTimeFormat);
            // Check if it is used as an attribute.
            // Added in case we want to extend to element usage

            if (attribute.$attr.fbDateTimePicker) {
                _angular2.default.element(element).datetimepicker({
                    format: format,
                    locale: window.localStorage.getItem('language'),
                    icons: {
                        time: 'ico ico-time',
                        date: 'ico ico-calendar',
                        up: 'ico ico-angle-up',
                        down: 'ico ico-angle-down',
                        previous: 'ico ico-angle-left',
                        next: 'ico ico-angle-right',
                        today: 'ico ico-target',
                        clear: 'ico ico-delete',
                        close: 'ico ico-close'
                    },
                    tooltips: {
                        today: gettextCatalog.getString('Go to today', null, 'Datetimepicker tooltips'),
                        clear: gettextCatalog.getString('Clear selection', null, 'Datetimepicker tooltips'),
                        close: gettextCatalog.getString('Close the picker', null, 'Datetimepicker tooltips'),
                        selectMonth: gettextCatalog.getString('Select Month', null, 'Datetimepicker tooltips'),
                        prevMonth: gettextCatalog.getString('Previous Month', null, 'Datetimepicker tooltips'),
                        nextMonth: gettextCatalog.getString('Next Month', null, 'Datetimepicker tooltips'),
                        selectYear: gettextCatalog.getString('Select Year', null, 'Datetimepicker tooltips'),
                        prevYear: gettextCatalog.getString('Previous Year', null, 'Datetimepicker tooltips'),
                        nextYear: gettextCatalog.getString('Next Year', null, 'Datetimepicker tooltips'),
                        selectDecade: gettextCatalog.getString('Select Decade', null, 'Datetimepicker tooltips'),
                        prevDecade: gettextCatalog.getString('Previous Decade', null, 'Datetimepicker tooltips'),
                        nextDecade: gettextCatalog.getString('Next Decade', null, 'Datetimepicker tooltips'),
                        prevCentury: gettextCatalog.getString('Previous Century', null, 'Datetimepicker tooltips'),
                        nextCentury: gettextCatalog.getString('Next Century', null, 'Datetimepicker tooltips'),
                        incrementHour: gettextCatalog.getString('Increment Hour', null, 'Datetimepicker tooltips'),
                        pickHour: gettextCatalog.getString('Pick Hour', null, 'Datetimepicker tooltips'),
                        decrementHour: gettextCatalog.getString('Decrement Hour', null, 'Datetimepicker tooltips'),
                        incrementMinute: gettextCatalog.getString('Increment Minute', null, 'Datetimepicker tooltips'),
                        pickMinute: gettextCatalog.getString('Pick Minute', null, 'Datetimepicker tooltips'),
                        decrementMinute: gettextCatalog.getString('Decrement Minute', null, 'Datetimepicker tooltips'),
                        incrementSecond: gettextCatalog.getString('Increment Second', null, 'Datetimepicker tooltips'),
                        pickSecond: gettextCatalog.getString('Pick Second', null, 'Datetimepicker tooltips'),
                        decrementSecond: gettextCatalog.getString('Decrement Second', null, 'Datetimepicker tooltips')
                    }
                });
                // Angular magic =-)

                // Cleanup tooltip
                element.on('$destroy', function () {
                    if (_angular2.default.element(element).data('DateTimePicker')) {
                        _angular2.default.element(element).data('DateTimePicker').destroy();
                    }
                });
            }
        }
    };
}

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbMaxDateValidator = fbMaxDateValidator;

var _dateTimeHelper = __webpack_require__(73);

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbMaxDateValidator() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            var dateTimeHelper = new _dateTimeHelper2.default(attrs.format || _dateTimeHelper2.default.defaultDateFormat);
            attrs.$observe('fbMaxDate', function () {
                ngModel.$validate();
            });

            var compareLevel = 'day';

            if (dateTimeHelper.formatHasSeconds) {
                compareLevel = 'second';
            } else if (dateTimeHelper.formatHasMinutes) {
                compareLevel = 'minute';
            } else if (dateTimeHelper.formatHasHours) {
                compareLevel = 'hour';
            }

            ngModel.$validators.maxDate = function (modelValue) {
                if (!attrs.fbMaxDate) {
                    // consider valid when no value provided
                    return true;
                }
                if (ngModel.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                var maxDate = (0, _moment2.default)(attrs.fbMaxDate);

                if (!maxDate.isValid()) {
                    // consider true when no valid max date provided
                    return true;
                }

                var val = modelValue;
                if (typeof val === 'string' && val.indexOf('+') !== -1) {
                    val = val.substr(0, val.indexOf('+'));
                }
                var dateValue = dateTimeHelper.momentValue(val);

                if (!dateValue.isValid()) {
                    // consider true when no valid date provided
                    return true;
                }

                if (dateValue.isSameOrBefore(maxDate, compareLevel)) {
                    return true;
                }

                // its invalid
                return false;
            };
        }
    };
}

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbMinDateValidator = fbMinDateValidator;

var _dateTimeHelper = __webpack_require__(73);

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fbMinDateValidator() {
    'ngInject';

    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {

            var dateTimeHelper = new _dateTimeHelper2.default(attrs.format || _dateTimeHelper2.default.defaultDateFormat);

            attrs.$observe('fbMinDate', function () {
                ngModel.$validate();
            });

            var compareLevel = 'day';

            if (dateTimeHelper.formatHasSeconds) {
                compareLevel = 'second';
            } else if (dateTimeHelper.formatHasMinutes) {
                compareLevel = 'minute';
            } else if (dateTimeHelper.formatHasHours) {
                compareLevel = 'hour';
            }

            ngModel.$validators.minDate = function (modelValue /*, viewValue*/) {
                if (!attrs.fbMinDate) {
                    // consider valid when no value provided
                    return true;
                }
                if (ngModel.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                var minDate = (0, _moment2.default)(attrs.fbMinDate);

                // if (!minDate.isValid()) {
                //     // consider true when no valid min date provided
                //     return true;
                // }

                var val = modelValue;
                if (typeof val === 'string' && val.indexOf('+') !== -1) {
                    val = val.substr(0, val.indexOf('+'));
                }
                var dateValue = (0, _moment2.default)(val);

                // if (!dateValue.isValid()) {
                //     // consider true when no valid date provided
                //     return true;
                // }

                if (dateValue.isSameOrAfter(minDate, compareLevel)) {
                    return true;
                }

                // its invalid
                return false;
            };
        }
    };
}

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fancybox = fancybox;
function fancybox() {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            var target = '';
            element.on('click', function (event) {
                event.preventDefault();
            });

            target = angular.element(element.find('[fb-fancybox]'));
            target.fancybox({
                margin: [48, 48],
                preload: false,
                //fitToView   : true,
                errorTpl: '<div class="fancybox-error"><p translate>The requested content cannot be loaded. <br /> Please try again later.<p></div>',
                closeTpl: '<button data-fancybox-close class="close-btn"><i>x</i></button>'
            });

            scope.$on('$destroy', function () {
                target.unbind('click.fb');
            });

            if (parseInt(extractIdFromParams(attr.galleryId)) === parseInt(attr.index) + 1) {
                setTimeout(function () {
                    element.click();
                });
            }

            function extractIdFromParams(urlParams) {
                return urlParams.substring(8);
            }
        }
    };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbEnterPressed = fbEnterPressed;
function fbEnterPressed() {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            elem.bind('keyup', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.dbwEnter, { event: event });
                    });
                    event.preventDefault();
                }
            });
        }
    };
}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbErrSrc = fbErrSrc;
function fbErrSrc() {
    return {
        link: function link(scope, element, attrs) {
            element.bind('error', function () {
                if (attrs.src !== attrs.fbErrSrc) {
                    attrs.$set('src', attrs.fbErrSrc);
                }
            });

            attrs.$observe('ngSrc', function (value) {
                if (!value && attrs.fbErrSrc) {
                    attrs.$set('src', attrs.fbErrSrc);
                }
            });
        }
    };
}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbFolder = fbFolder;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
    Folder
    --------------------------------
    
    <div fb-folder="{'default-open': 'sm-down'}"></div>
    <div></div>

*/

function fbFolder() {
    return {
        restrict: 'A',
        scope: {
            target: '@',
            initOpen: '@'
        },
        controller: ["$scope", "$window", "$timeout", "$element", "common", "$attrs", "Breakpoints", function controller($scope, $window, $timeout, $element, common, $attrs, Breakpoints) {
            'ngInject';

            var init, toggle, close, isInitiallyOpen, breakpointMatch;

            init = function init() {
                if ($scope.target) {
                    $element.targetEl = angular.element($scope.target).addClass('folder-content');
                } else {
                    $element.targetEl = $element.next().addClass('folder-content');
                }

                $element.addClass('folder').on('click', function (e) {
                    e.preventDefault();
                    toggle();
                });
                $element.targetEl.find('[fb-folder-close]').on('click', function (e) {
                    e.preventDefault;
                    close();
                });
                // initially closed, use 'init-open' option to open by default
                if (isInitiallyOpen()) {
                    toggle();
                }
            };

            toggle = function toggle() {
                $element.toggleClass('is-open');
                $element.targetEl.toggleClass('is-open');
            };

            close = function close() {
                $element.removeClass('is-open');
                $element.targetEl.removeClass('is-open');
            };

            isInitiallyOpen = function isInitiallyOpen() {
                if (!$scope.initOpen) {
                    return false;
                }
                return breakpointMatch($scope.initOpen);
            };

            breakpointMatch = function breakpointMatch(breakpoint) {
                var bp = breakpoint.split('-')[0];
                var bpRange = breakpoint.split('-')[1];
                var min = 0;
                var max = 99999;

                if (bpRange === 'up') {
                    min = _lodash2.default.find(Breakpoints, { name: bp }).min;
                } else if (bpRange === 'down') {
                    max = _lodash2.default.find(Breakpoints, { name: bp }).max;
                } else if (bpRange === 'only' || bpRange === undefined) {
                    min = _lodash2.default.find(Breakpoints, { name: bp }).min;
                    max = _lodash2.default.find(Breakpoints, { name: bp }).max;
                }

                return $window.innerWidth >= min && $window.innerWidth <= max;
            };

            $timeout(function () {
                init();
            });
        }]
    };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbIgnoreForBreadcrumb = fbIgnoreForBreadcrumb;
function fbIgnoreForBreadcrumb() {
    'ngInject';

    return {
        restrict: 'A',
        link: {
            pre: function pre(scope) {
                // This is dirty, but for now the only way.
                scope.ncyBreadcrumbIgnore = true;
            }
        }
    };
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createInputNumberDirective = createInputNumberDirective;
function createInputNumberDirective(directivesModule) {
    function needsPolyfill() {

        ////// Betere check zou zijn: 
        ////// https://github.com/jonstipe/number-polyfill/blob/master/number-polyfill.js

        ////// i = document.createElement("input");
        ////// i.setAttribute("type", "number");
        ////// if (i.type === "text")  ===> needs polyfill

        ////// iets gelijkaardigs om te checken of min, max, steps ondersteund wordt value: bijv. value gelijk zetten aan value kleiner dan min, groter dan max
        ////// iets gelijkaardigs om numerieke content te checken; bijv. value gelijk zetten aan "a", als value daarna niet "a" is is 't OK

        // checks whether we're using an Internet Explorer 10+ or Edge
        //return (
        //    !!document.documentMode && !!window.atob // IE10+ without Edge
        //) ||
        //    (!!navigator.msLaunchUri // WIN8+
        //        && !!window.atob // IE10+, Edge
        //    );

        return true;
    }

    function hasRequiredAttributes(elem, attrs) {
        var isNumberField = elem.attr('type') && elem.attr('type').toLowerCase() === 'number';
        if (!isNumberField) {
            return false;
        }

        return !isNaN(parseFloat(attrs.max)) && !isNaN(parseFloat(attrs.min)) && !isNaN(parseFloat(attrs.step));
    }

    function createButton(value, modifierHandler) {
        var button = document.createElement('input');
        button.setAttribute('type', 'button');
        button.setAttribute('value', value);
        button.setAttribute('tabindex', '-1');
        var element = angular.element(button);
        element.on('click', modifierHandler);
        return button;
    }

    function createContainerDiv() {
        var div = document.createElement('div');
        div.setAttribute('class', 'input-number-container');
        return div;
    }

    function createSpan() {
        return document.createElement('span');
    }

    function isChildOfOrSame(parent, child) {
        var testElem = child;
        var steps = 3;

        for (; steps > 0; --steps) {
            if (!testElem) {
                return false;
            }
            if (parent === testElem) {
                return true;
            }
            testElem = testElem.parentElement;
        }

        return false;
    }

    if (needsPolyfill()) {
        directivesModule.directive('input', function () {
            return {
                restrict: 'E',
                scope: {},
                require: '?ngModel',
                link: function link(scope, elem, attrs, ngModel) {
                    var containerDiv = null;
                    var inputElem = elem[0];
                    var hiddenRangeInput;
                    var hiddenRangeInputJquery;
                    var hasMouse;

                    function hasFocus() {
                        return document.activeElement === inputElem;
                    }

                    // function notifyAmountExcedeed(){
                    //     var newEvent = document.createEvent('HTMLEvents');
                    //     newEvent.initEvent('amountExcedeed', true, false);
                    //     inputElem.dispatchEvent(newEvent);
                    // }

                    // stepUp, stepDown in IE work only for the range input type
                    function doStep(direction) {

                        if (elem.attr('readonly') === 'readonly') {
                            return;
                        }

                        var value = elem.val();
                        var min = attrs.min;
                        var max = attrs.max;

                        if (value !== 0 && !value) {
                            if (direction === 'up') {
                                value = min;
                            } else {
                                value = max;
                            }
                        }

                        hiddenRangeInput.setAttribute('min', min);
                        hiddenRangeInput.setAttribute('max', max);
                        hiddenRangeInput.setAttribute('value', value);
                        hiddenRangeInput.setAttribute('step', attrs.step);

                        //elem.after(hiddenRangeInput);
                        if (direction === 'up') {
                            hiddenRangeInput.stepUp();
                        } else {
                            hiddenRangeInput.stepDown();
                        }
                        hiddenRangeInputJquery = angular.element(hiddenRangeInput);
                        elem.val(hiddenRangeInputJquery.val());

                        ngModel.$setViewValue(elem.val() !== undefined ? parseInt(elem.val(), 10) : undefined);

                        var event = document.createEvent('HTMLEvents');
                        event.initEvent('change', true, false);
                        inputElem.dispatchEvent(event);
                    }

                    function createButtonClickHandler(direction) {
                        return function (event) {
                            doStep(direction);
                            inputElem.focus();
                            event.preventDefault();

                            return false;
                        };
                    }

                    function createContainerWithButtons() {
                        if (!hasRequiredAttributes(elem, attrs)) {
                            return;
                        }
                        containerDiv = createContainerDiv();
                        var span = createSpan();
                        var btnUp = createButton('▴', createButtonClickHandler('up'));
                        var btnDown = createButton('▾', createButtonClickHandler('down'));
                        hiddenRangeInput = document.createElement('input');
                        hiddenRangeInput.setAttribute('type', 'range');
                        hiddenRangeInput.setAttribute('style', 'display:none;');

                        span.appendChild(btnUp);
                        span.appendChild(btnDown);
                        containerDiv.appendChild(span);
                        containerDiv.appendChild(hiddenRangeInput);
                        elem.after(containerDiv);

                        angular.element(containerDiv).on('mouseleave', function (event) {
                            if (!event.relatedTarget || event.relatedTarget.parentElement !== inputElem) {
                                deleteContainerWithButtons(elem);
                            }
                        });
                    }

                    function deleteContainerWithButtons() {
                        var inputHasFocus = angular.element(elem).is(':focus');
                        if (inputHasFocus) {
                            return;
                        }

                        if (!containerDiv) {
                            return;
                        }

                        hiddenRangeInput = null;
                        angular.element(containerDiv).remove();
                        containerDiv = null;
                        hasMouse = false;
                    }

                    function registerInputElemEventHandler() {
                        elem.on('keydown', function (event) {
                            if (event.keyCode === 38) {
                                doStep('up');
                                event.preventDefault();
                            } else if (event.keyCode === 40) {
                                doStep('down');
                                event.preventDefault();
                            }
                        });

                        elem.on('keyup', function (event) {
                            if (event.keyCode === 16 // shift
                            || event.keyCode === 35 // home 
                            || event.keyCode === 36 // end
                            || event.keyCode === 37 // left arrow
                            || event.keyCode === 39) {
                                //right arrow
                                return;
                            }

                            if (event.keyCode !== 38 && event.keyCode !== 40) {
                                var value = elem.val();
                                hiddenRangeInput.setAttribute('min', attrs.min);
                                hiddenRangeInput.setAttribute('max', attrs.max);
                                hiddenRangeInput.setAttribute('step', attrs.step);

                                if (!value) {
                                    hiddenRangeInput.value = 0;
                                } else if (attrs.min && parseInt(value, 10) < parseInt(attrs.min, 10)) {
                                    hiddenRangeInput.value = parseInt(attrs.min, 10);
                                } else if (attrs.max && parseInt(value, 10) > parseInt(attrs.max, 10)) {
                                    hiddenRangeInput.value = parseInt(attrs.max, 10);
                                } else {
                                    hiddenRangeInput.value = value;
                                }

                                //elem.after(hiddenRangeInput);
                                hiddenRangeInputJquery = angular.element(hiddenRangeInput);
                                // var hiddenVal = hiddenRangeInputJquery.val();
                                elem.val(hiddenRangeInput.value);
                                ngModel.$setViewValue(elem.val() !== undefined ? parseInt(elem.val(), 10) : undefined);

                                var newEvent = document.createEvent('HTMLEvents');
                                newEvent.initEvent('change', true, false);
                                inputElem.dispatchEvent(newEvent);
                            }
                        });

                        elem.on('mouseenter', function () {
                            hasMouse = true;
                            if (containerDiv === null) {
                                createContainerWithButtons();
                            }
                        });

                        elem.on('mouseleave', function (event) {
                            if (event.relatedTarget && isChildOfOrSame(containerDiv, event.relatedTarget)) {
                                return;
                            }
                            if (hasFocus()) {
                                hasMouse = false;
                                return;
                            }
                            deleteContainerWithButtons();
                        });

                        elem.on('focus', function () {
                            if (containerDiv === null) {
                                createContainerWithButtons();
                            }
                        });

                        elem.on('focusout', function () {
                            if (hasMouse) {
                                return;
                            }
                            deleteContainerWithButtons();
                        });
                    }

                    if (hasRequiredAttributes(elem, attrs)) {
                        registerInputElemEventHandler();
                    }
                }
            };
        });
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


fbLoadCategories.$inject = ["$rootScope", "common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbLoadCategories = fbLoadCategories;
/*@ngInject*/
function fbLoadCategories($rootScope, common) {
    return {
        link: function link(scope) {
            if (scope.$last) {
                common.log.info('broadcast categories-loaded event');
                $rootScope.$broadcast('categories-loaded');
            }
        }
    };
}

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbPreventKeypress = fbPreventKeypress;
function fbPreventKeypress() {
    return {
        link: function link(scope, element) {
            element.bind('keydown keypress', function (event) {
                if (event.which === 38 || event.which === 40) {
                    event.preventDefault();
                }
            });
        }
    };
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


fbPreventNavigation.$inject = ["gettextCatalog", "$transitions", "dialogService", "$parse"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbPreventNavigation = fbPreventNavigation;
function fbPreventNavigation(gettextCatalog, $transitions, dialogService, $parse) {
    'ngInject';

    return {
        restrict: 'A',
        require: 'form',
        link: function link(scope, element, attribute, form) {

            var destroyOnExitHandler = $transitions.onExit({}, function () {
                return !attribute.fbPreventNavigation || !form.$dirty || dialogService.unsavedChanges().then(function () {
                    form.$setPristine();
                    return true;
                }, function () {
                    $parse(attribute.fbOnCloseAction)(scope);
                    return false;
                });
            });

            // Cleanup
            element.on('$destroy', function () {
                if (destroyOnExitHandler) {
                    destroyOnExitHandler();
                }
            });
        }
    };
}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbScrollToTop = fbScrollToTop;
/*
    Scroll to top
    -------------------------------- 
*/

function fbScrollToTop() {
    return {
        restrict: 'A',
        controller: ["$element", "$anchorScroll", function controller($element, $anchorScroll) {
            'ngInject';

            $element.on('click', function (e) {
                e.preventDefault();
                $anchorScroll(0);
            });

            // https://github.com/oblador/angular-scroll
        }]
    };
}

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fbSetFocus = fbSetFocus;
/*@ngInject*/
function fbSetFocus() /*$timeout*/{
    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            scope.$watch(attrs.fbSetFocus, function (value) {
                if (value === true) {
                    //$timeout(function() {
                    element[0].focus();
                    scope[attrs.fbSetFocus] = false;
                    //});
                }
            });
        }
    };
}

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _fbFolder = __webpack_require__(715);

var _fbInputNumber = __webpack_require__(717);

var _fancybox = __webpack_require__(712);

var _fbErrSrc = __webpack_require__(714);

var _fbLoadCategories = __webpack_require__(718);

var _fbPreventKeypress = __webpack_require__(719);

var _fbScrollToTop = __webpack_require__(721);

var _fbSetFocus = __webpack_require__(722);

var _testContext = __webpack_require__(724);

var _fbIgnoreForBreadcrumb = __webpack_require__(716);

var _fbEnterPressed = __webpack_require__(713);

var _datetimepicker = __webpack_require__(709);

var _dateFormatter = __webpack_require__(707);

var _fbPreventNavigation = __webpack_require__(720);

var _maxDateValidator = __webpack_require__(710);

var _minDateValidator = __webpack_require__(711);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.directives', []).directive('fbFancybox', _fancybox.fancybox).directive('fbFolder', _fbFolder.fbFolder).directive('fbErrSrc', _fbErrSrc.fbErrSrc).directive('fbLoadCategories', _fbLoadCategories.fbLoadCategories).directive('fbPreventKeypress', _fbPreventKeypress.fbPreventKeypress).directive('fbScrollToTop', _fbScrollToTop.fbScrollToTop).directive('fbSetFocus', _fbSetFocus.fbSetFocus).directive('testContext', _testContext.testContext).directive('fbIgnoreForBreadcrumb', _fbIgnoreForBreadcrumb.fbIgnoreForBreadcrumb).directive('fbEnterPressed', _fbEnterPressed.fbEnterPressed).directive('fbDateTimePicker', _datetimepicker.fbDateTimePicker).directive('fbPreventNavigation', _fbPreventNavigation.fbPreventNavigation).directive('fbMaxDate', _maxDateValidator.fbMaxDateValidator).directive('fbMinDate', _minDateValidator.fbMinDateValidator).directive('fbDateFormatter', _dateFormatter.fbDateFormatter);

(0, _fbInputNumber.createInputNumberDirective)(_module);

exports.default = _module.name;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


testContext.$inject = ["config"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.testContext = testContext;
/*@ngInject*/
function testContext(config) {
    return {
        restrict: 'A',
        controllerAs: 'vm',
        compile: function compile(elem) {
            if (!config.enableTests) {
                elem.removeAttr();
            } else {
                return {
                    post: function post(scope, element, attribute) {
                        element.addClass(('fb-tst-' + attribute.testContext).toLowerCase());
                    }
                };
            }
        }
    };
}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _yesNoFilter = __webpack_require__(726);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.filters', []).filter('yesNo', _yesNoFilter.yesNoFilter);

exports.default = _module.name;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


yesNoFilter.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.yesNoFilter = yesNoFilter;
/*@ngInject*/
function yesNoFilter(gettextCatalog) {
    return function (input) {
        return input ? gettextCatalog.getString('yes') : gettextCatalog.getString('no');
    };
}

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addedToCartInfo = addedToCartInfo;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function addedToCartInfo() {
    var clazz = function AddedToCartInfo() {
        var defaults = {
            isInCart: false,
            productName: '',
            productImagePath: '',
            productQuantity: 0,
            productTotalPrice: 0,
            productTotalDiscount: 0,
            cartTotalPrice: 0,
            cartTotalDiscount: 0,
            quantityToAddForHighestDiscount: 0,
            highestDiscountPercentage: 0,
            discountName: '',
            discountImagePath: '',
            displayName: '',
            image: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var obj = new clazz();

        obj.productName = resource.productName;
        obj.productImagePath = resource.productImagePath;
        obj.productQuantity = resource.quantity;
        obj.productTotalPrice = resource.productTotalPriceExclVat;
        obj.productTotalDiscount = resource.productTotalDiscount;
        obj.cartTotalPrice = resource.shoppingCartTotalPrice;
        obj.cartTotalDiscount = resource.shoppingCartTotalDiscountAmount ? resource.shoppingCartTotalDiscountAmount : resource.totalDiscount;
        obj.cartTotalProductQuantity = resource.shoppingCartTotalProductQuantity;
        obj.quantityToAddForHighestDiscount = resource.quantityToAddForHighestDiscount;
        obj.highestDiscountPercentage = resource.highestDiscountPercentage;
        obj.discountName = resource.discountName;
        obj.discountImagePath = resource.discountImagePath;
        obj.image = obj.discountImagePath || obj.productImagePath;
        obj.displayName = obj.discountName || obj.productName;

        return obj;
    };

    return clazz;
}

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.address = address;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function address() {
    var clazz = function Address() {
        var defaults = {
            streetName: '',
            houseNumber: '',
            boxNumber: '',
            streetName2: '',
            postalCode: '',
            cityName: '',
            countryName: '',
            addressLine1: '',
            addressLine2: '',
            postalCodeAndCity: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.streetName = resource.streetName;
        o.houseNumber = resource.houseNumber || '';
        o.boxNumber = resource.boxNumber || '';
        o.streetName2 = resource.streetName2 || '';
        o.postalCode = resource.postalCode || '';
        o.cityName = resource.cityName || '';
        o.countryName = resource.countryName || '';
        o.addressLine1 = o.streetName + ' ' + o.houseNumber + ' ' + o.boxNumber;
        o.addressLine1 = o.addressLine1.trim();
        o.addressLine2 = o.streetName2.trim();
        o.postalCodeAndCity = o.postalCode + ' ' + o.cityName;
        o.postalCodeAndCity = o.postalCodeAndCity.trim();
        return o;
    };

    return clazz;
}

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.brand = brand;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function brand() {
    var clazz = function Brand() {
        var defaults = {
            id: 0,
            name: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var brand = new clazz();
        brand.id = resource.id;
        brand.name = resource.name;
        return brand;
    };

    return clazz;
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cartDisabledSeller.$inject = ["CartErrorMessage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartDisabledSeller = cartDisabledSeller;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartDisabledSeller(CartErrorMessage) {
    var clazz = function CartDisabledSeller() {
        var defaults = {
            id: 0,
            name: '',
            displayName: '',
            minOrderPriceExclVat: '',
            totalPriceWithDiscount: null,
            errorMessages: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.sellerId;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.minOrderPriceExclVat = resource.minOrderPriceExclVat;

        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.displayName = resource.displayName;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.id = resource.sellerId;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.minOrderPriceExclVat = resource.minOrderPriceExclVat;

        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.displayName = resource.displayName;
        return o;
    };

    return clazz;
}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

cartDraft.$inject = ["Product"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartDraft = cartDraft;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartDraft(Product) {
    var clazz = function CartDraft() {
        var defaults = {
            products: [],
            vatList: [],
            numberOfProducts: 0,
            totalPriceWithoutDiscount: 0,
            totalDiscount: 0,
            totalPriceWithDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        addProduct: function addProduct(product) {
            // when the product is already in the cart, then just update the quantity
            var productInList = _lodash2.default.find(this.products, { id: product.id });
            if (!productInList) {
                product.isInCart = true;
                this.products.push(product);
                this.updateTotals();
            } else {
                var newQuantity = productInList.quantity + product.quantity;
                this.changeQuantity(product.id, newQuantity);
            }
        },

        removeProduct: function removeProduct(productId) {
            _lodash2.default.remove(this.products, { id: productId });
            this.updateTotals();
        },

        updateTotals: function updateTotals() {
            var product = null;
            var numberOfProducts = 0;
            var totalPriceWithoutDiscount = 0;
            var totalDiscount = 0;
            var totalPriceWithDiscount = 0;

            for (var i = 0; i < this.products.length; i++) {
                product = this.products[i];
                numberOfProducts += product.quantity;
                totalPriceWithoutDiscount += product.totalPriceWithoutDiscount;
                totalDiscount += product.totalDiscount;
                totalPriceWithDiscount += product.totalPriceWithDiscount;
            }

            this.numberOfProducts = numberOfProducts;
            this.totalPriceWithoutDiscount = totalPriceWithoutDiscount;
            this.totalDiscount = totalDiscount;
            this.totalPriceWithDiscount = totalPriceWithDiscount;
            this.vatList = this.getVatList();
        },

        getVatList: function getVatList() {
            var vatList = [];
            var thisCart = this;

            angular.forEach(this.products, function (p) {
                thisCart.addVat(vatList, p);
            });

            return vatList;
        },

        addVat: function addVat(vatList, product) {
            var vat = product.tax;
            var vatItem = _lodash2.default.find(vatList, { 'pct': vat });
            var vatAmount = product.totalPriceWithoutDiscount * vat / 100;
            if (!vatItem) {
                vatList.push({ 'pct': vat, 'amount': vatAmount });
            } else {
                vatItem.amount += vatAmount;
            }
        },

        changeQuantity: function changeQuantity(productId, quantity) {
            var product = _lodash2.default.find(this.products, { id: productId });
            if (!product) {
                return;
            }

            product.quantity = quantity;
            product.updateTotals();
            this.updateTotals();
        }
    });

    clazz.create = function (resource) {
        var cart = new clazz();

        cart.products = [];
        angular.forEach(resource.products, function (productResource) {
            var product = Product.getClass().createFromLocalStorage(productResource, null, null, productResource.type, false);
            cart.products.push(product);
        });

        cart.numberOfProducts = resource.numberOfProducts;
        cart.totalPriceWithoutDiscount = resource.totalPriceWithoutDiscount;
        cart.totalDiscount = resource.totalDiscount;
        cart.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        cart.vatList = cart.getVatList();

        return cart;
    };

    return clazz;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cartErrorMessage.$inject = ["common", "CartMessageTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartErrorMessage = cartErrorMessage;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartErrorMessage(common, CartMessageTypes) {
    var clazz = function CartErrorMessage() {
        var defaults = {
            id: 0,
            message: '',
            type: 0, // 0 = info, 1 = warning, 2 = disabled, 3 = blocking
            isMessageActive: false,
            canDisableMessage: false,
            isProductDisabled: false

            // when disabled, product is shown, cart can be ordered
            // when blocking, cart cannot be ordered
            // canDisable => show 'deactivate message' button
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.message = resource.message;
        o.type = common.serverTypes.getClientValue(CartMessageTypes, resource.type);
        if (o.type === 'disabled') {
            o.type = 'error';
        }
        o.isMessageActive = !!resource.active;
        o.canDisableMessage = !!resource.canDisable;
        o.isProductDisabled = resource.type === 2;
        o.code = resource.code;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.message = resource.message;
        o.type = resource.type;
        o.isMessageActive = resource.isMessageActive;
        o.canDisableMessage = resource.canDisableMessage;
        o.isProductDisabled = resource.isProductDisabled;
        o.code = resource.code;
        return o;
    };

    return clazz;
}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cart.$inject = ["CartSeller", "CartDisabledSeller", "Totals"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cart = cart;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cart(CartSeller, CartDisabledSeller, Totals) {
    var clazz = function Cart() {
        var defaults = {
            sellers: [],
            disabledSellers: [],
            totals: null,
            canCheckout: false,
            isEmpty: true,
            totalPriceDiscounts: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, products) {
            var _this = this;

            products.forEach(function (product) {
                var productAndSeller = _this.getProductAndSeller(product.id, product.discountId);
                if (!productAndSeller.product) {
                    return;
                }

                productAndSeller.seller.updateAfterSetQuantity(updatedCart, product);
                productAndSeller.product.updateAfterSetQuantity(updatedCart, product);
            });

            this.totals.updateAfterSetQuantity(updatedCart.totals);
            this.isEmpty = !this.sellers || this.sellers.length <= 0;
            this.canCheckout = updatedCart.canCheckout;
        },

        updateAfterRemove: function updateAfterRemove(updatedCart, sellerId, product) {
            var sellerToUpdate = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerToUpdate) {
                return;
            }

            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return s.id === sellerId;
            });
            if (sellerInUpdatedCart) {
                sellerToUpdate.updateAfterRemove(sellerInUpdatedCart, product);
            } else {
                _lodash2.default.remove(this.sellers, function (s) {
                    return s.id === sellerId;
                });
            }

            this.totals.updateAfterSetQuantity(updatedCart.totals);
            this.isEmpty = !this.sellers || this.sellers.length <= 0;
            this.canCheckout = updatedCart.canCheckout;
        },

        setFocusOnProduct: function setFocusOnProduct(productId) {
            if (!productId) {
                return;
            }

            productId = parseInt(productId);

            var seller = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === productId;
                });
            });
            if (!seller) {
                return;
            }

            var product = _lodash2.default.find(seller.products, function (p) {
                return p.id === productId;
            });
            if (!product) {
                return;
            }

            product.hasFocus = true;
        },

        isProductInCart: function isProductInCart(product) {
            return _lodash2.default.some(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id || p.discountId === product.discountId;
                });
            });
        },

        getProductQuantity: function getProductQuantity(productId, discountId) {
            var productAndSeller = this.getProductAndSeller(productId, discountId);
            return productAndSeller.product ? productAndSeller.product.quantity : 0;
        },

        getIncludedProductQuantity: function getIncludedProductQuantity(parentProduct, includedProduct) {
            var productAndSeller = this.getProductAndSeller(parentProduct.id, parentProduct.discountId);
            if (!productAndSeller.product) {
                return 0;
            }

            var incProduct = _lodash2.default.find(productAndSeller.product.included_products, function (i) {
                return i.id === includedProduct.id;
            });
            return incProduct ? incProduct.quantity : 0;
        },

        getProductAndSeller: function getProductAndSeller(productId, discountId) {
            var seller = _lodash2.default.find(this.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === productId && (p.discountId || 0) === (discountId || 0);
                });
            });
            if (!seller) {
                return { seller: null, product: null };
            }

            var product = _lodash2.default.find(seller.products, function (p) {
                return p.id === productId && (p.discountId || 0) === (discountId || 0);
            });
            return { seller: seller, product: product };
        },

        getPanaceeProductInCart: function getPanaceeProductInCart(productId, discountId) {
            var productAndSeller = this.getProductAndSeller(productId, discountId);
            if (!productAndSeller.product) {
                return null;
            }

            return productAndSeller.product;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.sellers = _lodash2.default.map(resource.sellers, function (i) {
            return CartSeller.create(i, resource.products);
        });
        o.disabledSellers = _lodash2.default.map(resource.disabledSellers, function (i) {
            return CartDisabledSeller.create(i, resource.products);
        });
        o.totals = Totals.create(resource);
        o.canCheckout = resource.canCheckout;
        o.isEmpty = !o.sellers || o.sellers.length <= 0;
        o.errors = resource.errorMessages;
        o.totalPriceDiscounts = resource.totalPriceDiscounts;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.errors = resource.errorMessages;
        o.sellers = _lodash2.default.map(resource.sellers, function (i) {
            return CartSeller.createFromLocalStorage(i);
        });
        o.disabledSellers = _lodash2.default.map(resource.disabledSellers, function (i) {
            return CartDisabledSeller.createFromLocalStorage(i);
        });
        o.totals = Totals.createFromLocalStorage(resource);
        o.canCheckout = resource.canCheckout;
        o.isEmpty = !o.sellers || o.sellers.length <= 0;
        o.totalPriceDiscounts = resource.totalPriceDiscounts;
        return o;
    };

    return clazz;
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartProduct = cartProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartProduct() {
    var clazz = function CartProduct() {
        var defaults = {
            id: 0,
            amount: 0,
            productNumber: '',
            discountAmount: 0,
            discountId: 0,
            discountPercentage: 0,
            discountPromoCode: null,
            discountValueTypeSymbol: null,
            grossProfit: 0,
            totalPriceDiscountId: 0,
            grossProfitAmount: 0,
            cartProduct: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        getCartFields: function getCartFields(product, cartProducts) {
            var this_ = this;

            //find the product in the shoppingcart
            var productSearch = cartProducts.find(function (x) {
                if (this_.nationalNumber) {
                    return x.productNumber === this_.nationalNumber;
                } else {
                    return x.id === this_.id;
                }
            });

            //set the fields from the value from the products that are already in the cart
            if (productSearch) {
                product.discountPct = productSearch.discountPercentage;
                product.promocode = productSearch.discountPromoCode;
                product.totalDiscount = productSearch.discountAmount;
                product.quantity = productSearch.amount;

                productSearch.productWithPossibleDiscounts.map(function (discount) {
                    product.activeDiscountIds.push(discount.discountIds);
                    product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                });
            }
            return product;
        }

    });

    clazz.create = function (resource) {
        var cartProduct = new clazz();
        cartProduct.id = resource.id;
        cartProduct.amount = resource.amount;
        cartProduct.productNumber = resource.productNumber;
        cartProduct.discountAmount = resource.discountAmount;
        cartProduct.discountId = resource.discountId;
        cartProduct.discountPercentage = resource.discountPercentage;
        cartProduct.discountPromoCode = resource.discountPromoCode;
        cartProduct.discountValueTypeSymbol = resource.discountValueTypeSymbol;
        cartProduct.grossProfit = resource.grossProfit;
        cartProduct.totalPriceDiscountId = resource.totalPriceDiscountId;
        cartProduct.totalPriceDiscountPromoCode = resource.totalPriceDiscountPromoCode;
        cartProduct.grossProfitAmount = resource.grossProfitAmount;
        cartProduct.productWithPossibleDiscounts = resource.productWithPossibleDiscounts;

        resource.productWithPossibleDiscounts;

        return cartProduct;
    };

    return clazz;
}

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cartSeller.$inject = ["CartSellerProduct", "Totals", "CartErrorMessage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartSeller = cartSeller;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartSeller(CartSellerProduct, Totals, CartErrorMessage) {
    var clazz = function CartSeller() {
        var defaults = {
            id: 0,
            name: '',
            sellerCodeName: '',
            displayName: '',
            products: [],
            minOrderPriceExclVat: '',
            totals: null,
            errorMessages: null,
            sellerCodeId: 0,
            isVipSeller: false,
            protocolName: '',
            deliveryPartnerName: '',
            promoMessages: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, product) {
            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerInUpdatedCart) {
                return;
            }

            this.totals.updateAfterSetQuantity(sellerInUpdatedCart.totals);
            this.errorMessages = sellerInUpdatedCart.errorMessages;
        },
        updateAfterRemove: function updateAfterRemove(sellerInUpdatedCart, product) {
            _lodash2.default.remove(this.products, function (p) {
                return p.id === product.id && p.discountId === product.discountId;
            });
            this.totals.updateAfterSetQuantity(sellerInUpdatedCart.totals);
            this.errorMessages = sellerInUpdatedCart.errorMessages;
        }
    });

    clazz.create = function (resource, products) {
        var o = new clazz();
        o.id = resource.sellerId;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.sellerCodeName = resource.sellerCodeName;
        o.isVipSeller = resource.isVipSeller;
        o.protocolName = resource.protocolName;
        o.deliveryPartnerName = resource.deliveryPartnerName;
        o.prefix = resource.prefix;
        o.canOrderSpecial = resource.canOrderSpecial;

        if (products) {
            o.products = products.filter(function (product) {
                o.minOrderPriceExclVat = resource.minOrderPriceExclVat;
                return product.sellerId === resource.sellerCodeId;
            });
            o.products = _lodash2.default.map(o.products, function (i) {
                return CartSellerProduct.create(i);
            });
        }

        o.totals = Totals.create(resource);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.displayName = resource.displayName;
        o.promoMessages = resource.promoMessages;

        // if (resource.name !== resource.sellerCodeName) {
        //     resource.onlyOneSellerCode ? o.name : o.displayName += ' - ' + resource.sellerCodeName;
        // }
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.sellerCodeId = resource.sellerCodeId;
        o.name = resource.name;
        o.sellerCodeName = resource.sellerCodeName;
        o.displayName = resource.displayName;
        o.products = _lodash2.default.map(resource.products, function (i) {
            return CartSellerProduct.createFromLocalStorage(i);
        });
        o.totals = Totals.createFromLocalStorage(resource);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.createFromLocalStorage(i);
        });
        o.isVipSeller = resource.isVipSeller;
        o.protocolName = resource.protocolName;
        o.deliveryPartnerName = resource.deliveryPartnerName;
        o.minOrderPriceExclVat = resource.minOrderPriceExclVat;
        return o;
    };

    return clazz;
}

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cartSellerProduct.$inject = ["common", "textBuilder", "CartErrorMessage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartSellerProduct = cartSellerProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartSellerProduct(common, textBuilder, CartErrorMessage) {
    var clazz = function CartSellerProduct() {
        var defaults = {
            id: 0,
            type: '',
            image: '',
            name: '',
            discountName: '',
            discountImagePath: '',
            displayName: '',
            displayImage: '',
            description: '',
            productNumber: '',
            promocode: '',
            discountId: 0,
            discountType: '',
            quantity: 0,
            initialQuantity: 0,
            unitPrice: 0,
            unitPriceWithDiscount: 0,
            discountPct: 0,
            discountAmount: 0,
            vatPct: 0,
            vatAmount: 0,
            totalPriceWithDiscount: 0,
            totalPrice: 0,
            discountRanges: null,
            daysLeftUntilDiscountExpires: 0,
            included_products: [],
            grossProfitPercentage: 0,
            grossProfitPercentageWithoutDiscount: 0,
            grossProfitAmount: 0,
            errorMessages: null,
            // calculated fields
            quantityToAddForHighestDiscount: 0,
            productNumberAndPromo: '',
            isDisabled: false,
            createdOn: null,
            lowestDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedCart, product) {
            var sellerInUpdatedCart = _lodash2.default.find(updatedCart.sellers, function (s) {
                return _lodash2.default.some(s.products, function (p) {
                    return p.id === product.id && p.discountId === product.discountId;
                });
            });
            if (!sellerInUpdatedCart) {
                return;
            }

            var productInUpdatedCart = _lodash2.default.find(sellerInUpdatedCart.products, function (p) {
                return p.id === product.id && p.discountId === product.discountId;
            });
            if (!productInUpdatedCart) {
                return;
            }

            this.unitPriceWithDiscount = productInUpdatedCart.unitPriceWithDiscount;
            this.totalPriceWithDiscount = productInUpdatedCart.totalPriceWithDiscount;
            this.discountPct = productInUpdatedCart.discountPct;
            this.discountAmount = productInUpdatedCart.discountAmount;
            this.totalPrice = this.totalPriceWithDiscount + this.discountAmount;

            // Also set quantityToAddForHighestDiscount and highestDiscount
            this.highestDiscount = this.getHighestDiscount();
            this.quantityToAddForHighestDiscount = this.getQuantityToAddForHighestDiscount();
            this.initialQuantity = this.quantity;

            this.errorMessages = productInUpdatedCart.errorMessages;
        },

        getLowestDiscount: function getLowestDiscount() {
            if (!this.discountRanges || this.discountRanges.length <= 0) {
                return null;
            }

            return this.discountRanges[this.discountRanges.length - 1];
        },

        getHighestDiscount: function getHighestDiscount() {
            if (!this.discountRanges || this.discountRanges.length <= 0) {
                return null;
            }

            return this.discountRanges[0];
        },

        getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
            var highestDiscount = this.getHighestDiscount();
            if (!highestDiscount) {
                return;
            }

            return highestDiscount.from > this.quantity ? highestDiscount.from - this.quantity : 0;
        },

        removeMessage: function removeMessage(id) {
            _lodash2.default.remove(this.errorMessages, { id: id });
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.productId;
        o.type = common.serverTypes.getProductType(resource.productTypeCode);
        o.image = resource.productImagePath;
        o.name = resource.name;
        o.discountName = resource.discountName;
        o.discountImagePath = resource.discountImagePath;
        o.description = resource.description;
        o.productNumber = resource.productNumber;
        o.promocode = resource.promocode;
        o.discountId = resource.discountId;
        o.discountType = resource.discountType;
        o.quantity = resource.quantity;
        o.initialQuantity = o.quantity;
        o.portalContractTypeCode = resource.portalContractTypeCode;
        o.unitPrice = resource.unitPrice;
        o.unitPriceWithDiscount = resource.unitPriceWithDiscount;
        o.discountPct = resource.discountPct;
        o.discountAmount = resource.discountAmount;
        o.vatPct = resource.tax ? resource.tax.taxPercentage : 0;
        o.vatAmount = resource.tax ? resource.tax.amount : 0;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalPrice = o.totalPriceWithDiscount + o.discountAmount;
        o.discountRanges = _lodash2.default.map(resource.discountRanges, function (i) {
            return { from: i.from, discount: i.discount, symbol: i.discountValueTypeSymbol };
        });
        o.daysLeftUntilDiscountExpires = resource.daysLeftUntilDiscountExpires;
        o.createdOn = resource.createdOn;
        o.maxDiscount = resource.maxDiscount;
        o.isExpired = resource.isExpired;
        o.totalPriceDiscount = resource.totalPriceDiscount;
        o.totalPriceDiscountPct = resource.totalPriceDiscountPct;
        o.totalPriceDiscountId = resource.totalPriceDiscountId;
        o.retroactive = resource.retroactive;
        o.allowSpecial = resource.allowSpecial;
        o.grossProfitAmount = resource.grossProfitAmount;

        if (resource.panaceeContent && resource.panaceeContent.length > 0) {
            o.included_products = _lodash2.default.map(resource.panaceeContent, function (i) {
                return {
                    id: i.productId,
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.productNumber
                };
            });
        }

        if (resource.promoPackContent && resource.promoPackContent.length > 0) {
            o.included_products = _lodash2.default.map(resource.promoPackContent, function (i) {
                return {
                    id: i.productId,
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.productNumber
                };
            });
        }

        o.lowestDiscount = o.getLowestDiscount();
        o.highestDiscount = o.getHighestDiscount();
        o.quantityToAddForHighestDiscount = o.getQuantityToAddForHighestDiscount();
        o.productNumberAndPromo = textBuilder.getProductNumberAndPromo(o.productNumber, o.promocode);
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.create(i);
        });
        o.isDisabled = _lodash2.default.some(o.errorMessages, function (i) {
            return i.isProductDisabled;
        });
        o.displayName = o.discountType === 'PANACEE' || o.discountType === 'PORTALPRODUCT' ? o.name : o.discountName || o.name;
        o.displayImage = o.discountImagePath || o.image;
        o.grossProfitPercentage = (resource.grossProfitPercentage * 100).toFixed(0);
        o.grossProfitPercentageWithoutDiscount = (resource.grossProfitPercentageWithoutDiscount * 100).toFixed(0);
        o.totalPriceDiscountPromoCode = resource.totalPriceDiscountPromoCode;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = resource.type;
        o.image = resource.image;
        o.name = resource.name;
        o.discountName = resource.discountName;
        o.discountImagePath = resource.discountImagePath;
        o.description = resource.description;
        o.productNumber = resource.productNumber;
        o.promocode = resource.promocode;
        o.productNumberAndPromo = resource.productNumberAndPromo;
        o.discountId = resource.discountId;
        o.quantity = resource.quantity;
        o.initialQuantity = o.quantity;
        o.unitPrice = resource.unitPrice;
        o.unitPriceWithDiscount = resource.unitPriceWithDiscount;
        o.discountPct = resource.discountPct;
        o.discountAmount = resource.discountAmount;
        o.vatPct = resource.vatPct;
        o.vatAmount = resource.vatAmount;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalPrice = resource.totalPrice;
        o.discountRanges = resource.discountRanges;
        o.daysLeftUntilDiscountExpires = resource.daysLeftUntilDiscountExpires;
        o.included_products = resource.included_products;
        o.createdOn = resource.createdOn;
        o.maxDiscount = resource.maxDiscount;
        o.portalContractTypeCode = resource.portalContractTypeCode;
        o.allowSpecial = resource.allowSpecial;
        o.lowestDiscount = o.getLowestDiscount();
        o.highestDiscount = o.getHighestDiscount();
        o.quantityToAddForHighestDiscount = o.getQuantityToAddForHighestDiscount();
        o.errorMessages = _lodash2.default.map(resource.errorMessages, function (i) {
            return CartErrorMessage.createFromLocalStorage(i);
        });
        o.isDisabled = resource.isDisabled;
        o.displayName = o.discountName || o.name;
        o.displayImage = o.discountImagePath || o.image;

        return o;
    };

    return clazz;
}

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.category = category;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function category() {
    var clazz = function Category() {
        var defaults = {
            id: 0,
            name: '',
            parentCategoryId: null,
            parents: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var category = new clazz();
        category.id = resource.id;
        category.name = resource.name;
        category.parentCategoryId = resource.parentCategoryId;
        category.parents = resource.parents;
        return category;
    };

    return clazz;
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryWithSubcategories = categoryWithSubcategories;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function categoryWithSubcategories() {
    // prodFactory and getClass are created to be able to use the CategoryModel recursively
    var prodFactory = {
        getClass: function getClass() {

            var clazz = function CategoryWithSubcategories() {
                var defaults = {
                    id: 0,
                    name: '',
                    subcategories: null
                };

                _lodash2.default.extend(this, defaults);
            };

            clazz.create = function (resource) {
                var category = new clazz();
                category.id = resource.Id;
                category.name = resource.Name;

                category.subcategories = null;
                if (resource.Subcategories && resource.Subcategories.length > 0) {
                    category.subcategories = [];
                    for (var i = 0; i < resource.Subcategories.length; i++) {
                        var cat = prodFactory.getClass().create(resource.Subcategories[i]);
                        category.subcategories.push(cat);
                    }
                }

                return category;
            };

            return clazz;
        }
    };

    return prodFactory;
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.certificateItem = certificateItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function certificateItem() {
    var clazz = function CertificateItem() {
        var defaults = {
            id: null,
            productId: 0,
            filename: '',
            productNumber: '',
            productName: '',
            batchNumber: '',
            expiryDate: null,
            mediaId: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.productId = resource.productId;
        item.filename = resource.filename;
        item.productNumber = resource.productNumber;
        item.productName = resource.productName;
        item.batchNumber = resource.batchNumber;
        item.expiryDate = resource.expiryDate;
        item.mediaId = resource.mediaId;
        return item;
    };

    return clazz;
}

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contactInfoRentalProduct = contactInfoRentalProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function contactInfoRentalProduct() {
    var clazz = function ContactInfoRentalProduct() {
        var defaults = {
            contactPerson: '',
            contactPhoneNumber: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.contactPerson = resource.contactPerson;
        o.contactPhoneNumber = resource.contactPhoneNumber;
        return o;
    };

    return clazz;
}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


contractDetail.$inject = ["Paging", "$filter"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractDetail = contractDetail;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function contractDetail(Paging, $filter) {
    var clazz = function ContractDetail() {
        var defaults = {
            id: 0,
            startDate: '',
            endDate: null,
            name: null,
            products: [],
            allProducts: false,
            portalContractTypeName: '',
            portalContractTypeCode: '',
            logoImagePath: '',
            agiosNr: null,
            description: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        getPagedProducts: function getPagedProducts(page, products) {
            return products.slice(page * this.paging.itemsPerPage - this.paging.itemsPerPage, page * this.paging.itemsPerPage);
        }
    });

    clazz.create = function (resource) {
        var contractDetail = new clazz();
        contractDetail.id = resource.id;
        contractDetail.startDate = resource.startDate;
        contractDetail.endDate = resource.endDate;
        contractDetail.portalContractTypeName = resource.portalContractTypeName;
        contractDetail.portalContractTypeCode = resource.portalContractTypeCode;
        contractDetail.name = resource.name;
        contractDetail.products = $filter('orderBy')(resource.products, 'name');
        contractDetail.allProducts = resource.allProducts;
        contractDetail.logoImagePath = resource.logoImagePath;
        contractDetail.agiosNr = resource.agiosNr;
        contractDetail.paging = Paging.create({ totalItems: contractDetail.products.length, itemsPerPage: 24, page: 1, pageCount: 1, pageNumbers: [] });
        contractDetail.description = resource.description;
        return contractDetail;
    };

    return clazz;
}

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contract = contract;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function contract() {
    var clazz = function Contract() {
        var defaults = {
            id: 0,
            name: '',
            startDate: null,
            endDate: null,
            contractTypeCode: null,
            contractTypeName: null,
            portalContractTypeName: '',
            portalContractTypeCode: '',
            logoImagePath: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var contract = new clazz();
        contract.id = resource.id;
        contract.name = resource.name;
        contract.startDate = resource.startDate;
        contract.endDate = resource.endDate;
        contract.portalContractTypeName = resource.portalContractTypeName;
        contract.portalContractTypeCode = resource.portalContractTypeCode;
        contract.contractTypeCode = resource.contractTypeCode;
        contract.contractTypeName = resource.contractTypeName;
        contract.logoImagePath = resource.logoImagePath;
        return contract;
    };

    return clazz;
}

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deliveryInfoRentalProduct = deliveryInfoRentalProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function deliveryInfoRentalProduct() {
    var clazz = function DeliveryInfoRentalProduct() {
        var defaults = {
            boxNumber: '',
            cityName: '',
            countryName: '',
            countryCode: '',
            houseNumber: '',
            postalCode: '',
            streetName: '',
            deliveryDate: '',
            remark: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.boxNumber = resource.boxNumber;
        o.cityName = resource.cityName;
        o.countryName = resource.countryName;
        o.countryCode = 'BE';
        o.postalLocalityId = resource.postalLocalityId;
        o.streetId = resource.streetId;
        o.houseNumber = resource.houseNumber;
        o.postalCode = resource.postalCode;
        o.streetName = resource.streetName;
        o.deliveryDate = resource.deliveryDate;
        o.remark = resource.remark;
        return o;
    };

    return clazz;
}

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


delivery.$inject = ["DeliveryProduct"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.delivery = delivery;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function delivery(DeliveryProduct) {
    var clazz = function Delivery() {
        var defaults = {
            id: 0,
            state: '',
            amount: '',
            history: null,
            products: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.deliveryNr;
        o.state = resource.deliveryState;
        o.amount = resource.deliveryAmount;
        o.history = _lodash2.default.map(resource.deliveryHistory, function (i) {
            return { date: i.date, time: i.time, text: i.text };
        });
        o.products = _lodash2.default.map(resource.products, function (i) {
            return DeliveryProduct.create(i);
        });
        return o;
    };

    return clazz;
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


deliveryProduct.$inject = ["textBuilder"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deliveryProduct = deliveryProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function deliveryProduct(textBuilder) {
    var clazz = function DeliveryProduct() {
        var defaults = {
            name: '',
            productNumber: '',
            promocode: '',
            productNumberAndPromo: '',
            quantity: null,
            discount: null,
            amount: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.name = resource.name;
        o.productNumber = resource.productNumber;
        o.promocode = resource.promocode;
        o.productNumberAndPromo = textBuilder.getProductNumberAndPromo(o.productNumber, o.promocode);
        o.quantity = resource.quantity;
        o.discount = resource.discount;
        o.amount = resource.amount;
        return o;
    };

    return clazz;
}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discounttype = discounttype;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function discounttype() {
    var clazz = function Discounttype() {
        var defaults = {
            id: 0,
            name: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.name = resource.name;
        return o;
    };

    return clazz;
}

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fastOrderProduct = fastOrderProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function fastOrderProduct() {
    var clazz = function FastOrderProduct() {
        var defaults = {
            categoryCode: '',
            productNumber: null,
            imagePath: '',
            productId: 0,
            productName: '',
            nationalNumber: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (context) {
        var o = new clazz();
        o.id = context.productId;
        o.categoryCode = context.categoryCode;
        o.nationalNumber = context.productNumber;
        o.imagePath = context.imagePath;
        o.name = context.productName;
        o.quantity = context.quantity;
        return o;
    };

    return clazz;
}

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


filterCategoryItem.$inject = ["common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterCategoryItem = filterCategoryItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterCategoryItem(common) {
    var clazz = function FilterCategoryItem() {
        var defaults = {
            id: '',
            name: '',
            isSelected: false,
            isParent: true,
            level: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource, selectedIds, level, formatNameToPascalCase) {
        var item = new clazz();
        item.id = resource.id;
        if (formatNameToPascalCase) {
            item.name = common.toPascalCase(resource.name);
        } else {
            item.name = resource.name;
        }
        item.isSelected = resource.isSelected ? true : selectedIds ? selectedIds.indexOf(resource.id) >= 0 : false;
        item.isParent = false;
        item.level = level || 1;
        return item;
    };

    clazz.createParent = function (resource, level) {
        var item = new clazz();
        item.id = resource.id;
        item.name = resource.name;
        item.isSelected = true;
        item.isParent = true;
        item.level = level || 1;
        return item;
    };

    return clazz;
}

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


filterCategory.$inject = ["common", "Enums", "FilterCategoryItem", "gettextCatalog", "FilterHierarchyCategoryItem"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterCategory = filterCategory;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterCategory(common, Enums, FilterCategoryItem, gettextCatalog, FilterHierarchyCategoryItem) {
    var clazz = function FilterCategory() {
        var defaults = {
            id: '',
            name: '',
            isHierarchical: false,
            isCollapsed: true,
            isLink: false,
            isSellerCategory: false,
            initialLimit: 15,
            limit: 15,
            items: [],
            order: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var filter = new clazz();

        var isSellerCategory = resource.context === Enums.categoryFilterType.sellerCategory.id;
        filter.limit = resource.initialAmountVisible;

        if (resource.context === Enums.categoryFilterType.category.id) {
            filter.id = String(resource.id);
            filter.name = resource.name;
        } else if (resource.context === Enums.categoryFilterType.sellerCategory.id) {
            filter.id = resource.id;
            filter.name = resource.name;
        } else if (resource.context === Enums.categoryFilterType.seller.id) {
            filter.id = Enums.otherCategoryType.seller.id;
            filter.limit = 9999;
            filter.name = gettextCatalog.getString('Seller');
        } else if (resource.context === Enums.categoryFilterType.discountType.id) {
            filter.id = Enums.otherCategoryType.discountType.id;
            filter.name = gettextCatalog.getString('Discount type');
        } else if (resource.context === Enums.categoryFilterType.customCategory.id) {
            filter.id = Enums.categoryFilterType.customCategory.id;
            filter.name = gettextCatalog.getString('Special Discounts');
        }

        filter.isCollapsed = false;
        filter.isHierarchical = resource.id === 2 || resource.hierarchyItems;
        filter.isLink = resource.isLink;
        filter.isSellerCategory = isSellerCategory;
        filter.initialLimit = resource.initialAmountVisible;
        filter.order = resource.order;

        var formatNameToPascalCase = resource.context === Enums.categoryFilterType.category.id && resource.id === Enums.categoryType.brand.id;
        filter.items = [];

        // check if there are hierarchyItems 
        if (resource.hierarchyItems) {
            resource.hierarchyItems.length > 0 ? filter.items = _lodash2.default.orderBy(resource.hierarchyItems, 'name') : null;
            filter.items = _lodash2.default.map(filter.items, function (item) {
                return FilterHierarchyCategoryItem.create(item, 0, formatNameToPascalCase);
            });
        }

        // if there are no hierarchyItems set the items
        if (filter.items.length === 0) {
            if (resource.items && resource.items.length > 0) {
                var orderedItems = [];
                if (resource.context === Enums.categoryFilterType.seller.id) {
                    orderedItems = _lodash2.default.orderBy(resource.items, ['isVIPSeller', 'name'], ['desc', 'asc']);
                } else {
                    orderedItems = _lodash2.default.orderBy(resource.items, 'name');
                }

                filter.items = _lodash2.default.map(orderedItems, function (item) {
                    return FilterCategoryItem.create(item, 0, formatNameToPascalCase);
                });
            }
        }

        return filter;
    };

    clazz.createShowDiscountsOnly = function () {
        var filter = new clazz();
        filter.id = Enums.otherCategoryType.discountsOnly.id;
        filter.name = gettextCatalog.getString('Discount');
        filter.isHierarchical = false;
        filter.isCollapsed = false;
        filter.isLink = false;
        filter.initialLimit = 15;
        filter.limit = 15;
        filter.items = [];
        filter.items.push(FilterCategoryItem.create({ id: 1, name: gettextCatalog.getString('Discounts only') }));
        return filter;
    };

    return clazz;
}

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


filterHierarchyCategoryItem.$inject = ["common", "$stateParams"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filterHierarchyCategoryItem = filterHierarchyCategoryItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filterHierarchyCategoryItem(common, $stateParams) {
    var clazz = function FilterHierarchyCategoryItem() {
        var defaults = {
            id: '',
            name: '',
            isSelected: false,
            isParent: true,
            children: [],
            isVIPSeller: false,
            parentId: 0,
            childSelected: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        isFilterSelected: function isFilterSelected(qsFilter) {
            qsFilter;
            // this.$stateParams.filter
        },
        hasChildSelected: function hasChildSelected() {
            var childSearch = this.children.find(function (child) {
                return child.isSelected === true;
            });

            if (childSearch) {
                return true;
            } else {
                var hasChildSelected = false;
                this.children.forEach(function (child) {
                    if (child.hasChildSelected(child)) {
                        hasChildSelected = true;
                    }
                });

                return hasChildSelected;
            }
        }
    });

    clazz.create = function (resource, level, formatNameToPascalCase) {
        var _this = this;

        var item = new clazz();
        item.id = resource.id;

        if (formatNameToPascalCase) {
            item.name = common.toPascalCase(resource.name);
        } else {
            item.name = resource.name;
        }

        // check if there are children and add them
        if (resource.children) {
            resource.children = _lodash2.default.orderBy(resource.children, 'name');
            item.children = _lodash2.default.map(resource.children, function (item) {
                return _this.create(item, null, 0, formatNameToPascalCase);
            });
        }

        item.isSelected = $stateParams.categoryId === item.id ? true : false;
        item.parentId = resource.parentId;
        item.isVIPSeller = resource.isVIPSeller;
        item.isParent = resource.parentId === 0 ? true : false;
        item.level = level || 1;
        item.childSelected = item.hasChildSelected();
        return item;
    };

    return clazz;
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


filter.$inject = ["FilterCategory", "FilterCategoryItem", "Enums", "$state", "$stateParams", "queryStringHelper"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.filter = filter;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function filter(FilterCategory, FilterCategoryItem, Enums, $state, $stateParams, queryStringHelper) {
    var clazz = function Filter() {
        var defaults = {
            filterCategories: [],
            flatListsOfCategories: [],
            selectedFilters: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        // Used when clearing a filter
        getParentIdOfChildCategory: function getParentIdOfChildCategory(categoryTypeId, id) {
            var flatList = _lodash2.default.find(this.flatListsOfCategories, { key: categoryTypeId }).list;
            var item = _lodash2.default.find(flatList, function (i) {
                return i.Id === id;
            });
            return item ? item.ParentId : null;
        },

        markFilterCheckboxesAsSelected: function markFilterCheckboxesAsSelected(qsFilter) {
            for (var i = 0; i < this.filterCategories.length; i++) {
                var filterCategory = this.filterCategories[i];
                var selectedIds = queryStringHelper.getSelectedIdsFromQueryString(qsFilter, filterCategory.id);
                var item = null;

                //category 
                if (!filterCategory.isHierarchical && !filterCategory.isLink) {
                    for (var j = 0; j < filterCategory.items.length; j++) {
                        item = filterCategory.items[j];
                        item.isSelected = selectedIds ? selectedIds.indexOf(item.id) >= 0 : false;
                    }
                } else if (!filterCategory.isLink) {
                    if (selectedIds) {
                        //find each category by id and select it
                        selectedIds.forEach(function (selectedCategoryId) {
                            for (var _j = 0; _j < filterCategory.items.length; _j++) {
                                item = filterCategory.items[_j];

                                // select the children and the parent
                                if (item.children && item.children.length > 0 && item.id !== selectedCategoryId) {
                                    item.children.forEach(function (child) {
                                        if (child.id === selectedCategoryId) {
                                            child.isSelected = true;
                                            item.isSelected = true;
                                        }
                                        child.children.forEach(function (child1) {
                                            if (child1.id === selectedCategoryId) {
                                                child1.isSelected = true;
                                                child.isSelected = true;
                                                item.isSelected = true;
                                            }
                                        });
                                    });
                                } else if (item.id === selectedCategoryId) {
                                    item.isSelected = true;
                                } else {
                                    item.isSelected = false;
                                }
                            }
                        });
                    } else {
                        //if there are no selected id's, make sure they are all unchecked
                        filterCategory.items.forEach(function (filterCategoryItem) {
                            if (filterCategoryItem.children) {
                                filterCategoryItem.children.forEach(function (child) {
                                    child.isSelected = false;
                                });
                            }
                            filterCategoryItem.isSelected = false;
                        });
                    }
                }
            }
        },

        setSelectedFilters: function setSelectedFilters(qsFilter) {
            var selectedFilters = [];

            for (var i = 0; i < this.filterCategories.length; i++) {
                var filterCategory = this.filterCategories[i];
                var selectedFilterCategory = filterCategory.isHierarchical ? this.getSelectedItemsForHierarchicalFilterCategory(filterCategory, qsFilter) : this.getSelectedItemsForNonHierarchicalFilterCategory(filterCategory);

                //filter out category and product range filters, because they cannot be shown in the current filter bar
                if (selectedFilterCategory && String(selectedFilterCategory.id) !== String(Enums.categoryType.category.id) && String(selectedFilterCategory.id) !== String(Enums.categoryType.productRange.id)) {
                    selectedFilters.push(selectedFilterCategory);
                }
            }
            this.selectedFilters = selectedFilters;
        },

        // for non-hierarchical filters: get the selected items from the list
        getSelectedItemsForNonHierarchicalFilterCategory: function getSelectedItemsForNonHierarchicalFilterCategory(filterCategory) {
            var selectedItems = _lodash2.default.chain(filterCategory.items).filter({ isSelected: true }).map(function (item) {
                return { id: item.id, name: item.name };
            }).value();

            return selectedItems.length === 0 ? null : { id: filterCategory.id, name: filterCategory.name, items: selectedItems };
        },

        // for hierarchical filters: get the name of the item that corresponds with the query string param, and all of its parents
        getSelectedItemsForHierarchicalFilterCategory: function getSelectedItemsForHierarchicalFilterCategory(filterCategory, qsFilter) {
            var selectedIds = queryStringHelper.getSelectedIdsFromQueryString(qsFilter, filterCategory.id);
            var selectedCategoryId = selectedIds && selectedIds.length > 0 ? selectedIds[0] : null;
            if (!selectedCategoryId) {
                return null;
            }

            var flatList = _lodash2.default.find(this.flatListsOfCategories, { key: filterCategory.id }).list;

            var selectedCategories = [];
            selectedIds.forEach(function (selectedId) {
                var category = _lodash2.default.find(flatList, { id: selectedId });
                if (category) {
                    selectedCategories.push(category);
                }
            });

            return { id: filterCategory.id, name: filterCategory.name, items: selectedCategories };
        },

        clearFilter: function clearFilter(categoryId, filterId) {
            var filterCategory = _lodash2.default.find(this.filterCategories, { id: categoryId });
            if (!filterCategory) {
                return;
            }

            var item = _lodash2.default.find(filterCategory.items, { id: filterId });
            if (!item) {
                return;
            }

            item.isSelected = false;
        },

        isCategoryHierarchical: function isCategoryHierarchical(categoryId) {
            var filterCategory = _lodash2.default.find(this.filterCategories, { id: categoryId });
            return filterCategory && filterCategory.isHierarchical;
        }
    });

    clazz.create = function (resource) {
        var filter = new clazz();
        if (resource.categories && resource.categories.length > 0) {
            _lodash2.default.forEach(resource.categories, function (category) {
                var filterCategory = FilterCategory.create(category);

                //list of categories used in the views$
                filter.filterCategories.push(filterCategory);

                //flatlist of categories used for searches
                if (filterCategory.isSellerCategory || !filterCategory.isSellerCategory && category.id === Enums.categoryType.category.id) {
                    filter.flatListsOfCategories.push({ key: filterCategory.id, list: category.items });
                }
            });
        }

        // set discount only
        if (resource.showDiscountsOnlyOption) {
            var discountsOnlyFilter = FilterCategory.createShowDiscountsOnly();

            //order the discount filter after the items with position 2
            var elementPos = filter.filterCategories.map(function (x) {
                return x.order;
            }).indexOf(2);

            //if position 2 does not exist add it to the end of the array
            elementPos === -1 ? filter.filterCategories.push(discountsOnlyFilter) : filter.filterCategories.splice(elementPos, 0, discountsOnlyFilter);
        }

        //if the state is brand, order the categories
        if ($state.current.name === 'brand') {
            var temp = [filter.filterCategories[1], filter.filterCategories[2], filter.filterCategories[0]];
            filter.filterCategories = temp;
        }

        return filter;
    };

    return clazz;
}

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.helpItem = helpItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function helpItem() {
    var clazz = function HelpItem() {
        var defaults = {
            categoryId: '',
            category: '',
            subCategories: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.categoryId = resource.categoryId;
        o.category = resource.category;
        o.subCategories = resource.subCategories;
        return o;
    };

    return clazz;
}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _addedToCartInfoModel = __webpack_require__(727);

var _addressModel = __webpack_require__(728);

var _brandModel = __webpack_require__(729);

var _cartModel = __webpack_require__(733);

var _cartDraftModel = __webpack_require__(731);

var _cartErrorMessageModel = __webpack_require__(732);

var _cartSellerModel = __webpack_require__(735);

var _cartSellerProductModel = __webpack_require__(736);

var _categoryModel = __webpack_require__(737);

var _categoryWithSubcategoriesModel = __webpack_require__(738);

var _deliveryModel = __webpack_require__(744);

var _deliveryProductModel = __webpack_require__(745);

var _discounttypeModel = __webpack_require__(746);

var _filterCategoryModel = __webpack_require__(749);

var _filterCategoryItemModel = __webpack_require__(748);

var _filterModel = __webpack_require__(751);

var _cartDisabledSellerModel = __webpack_require__(730);

var _mediPimDataModel = __webpack_require__(757);

var _newsItemModel = __webpack_require__(758);

var _newsOverviewModel = __webpack_require__(759);

var _newsSearchRequest = __webpack_require__(760);

var _orderModel = __webpack_require__(763);

var _orderProductModel = __webpack_require__(765);

var _orderConfirmationModel = __webpack_require__(762);

var _orderOverviewItemModel = __webpack_require__(764);

var _pagingModel = __webpack_require__(769);

var _productModel = __webpack_require__(775);

var _productOverviewModel = __webpack_require__(777);

var _productOverviewItemModel = __webpack_require__(776);

var _productFilterRequest = __webpack_require__(774);

var _productSearchRequest = __webpack_require__(778);

var _sellerModel = __webpack_require__(791);

var _sellerCategoryModel = __webpack_require__(789);

var _sellerBannerModel = __webpack_require__(788);

var _tenantModel = __webpack_require__(796);

var _totalsModel = __webpack_require__(797);

var _userModel = __webpack_require__(798);

var _helpItemModel = __webpack_require__(752);

var _newsTileModel = __webpack_require__(761);

var _sellerOverviewModel = __webpack_require__(792);

var _partnershipModel = __webpack_require__(771);

var _partnershipOverviewModel = __webpack_require__(772);

var _partnershipDetail = __webpack_require__(770);

var _stockModel = __webpack_require__(794);

var _stockOverviewModel = __webpack_require__(795);

var _sellerContactModel = __webpack_require__(790);

var _sellerPublicModel = __webpack_require__(793);

var _fastOrderProductModel = __webpack_require__(747);

var _productSetModel = __webpack_require__(779);

var _cartProduct = __webpack_require__(734);

var _productDiscountModel = __webpack_require__(773);

var _contractModel = __webpack_require__(742);

var _contractDetailModel = __webpack_require__(741);

var _filterHierarchyCategoryItemModel = __webpack_require__(750);

var _wholesalerModel = __webpack_require__(799);

var _outletCategoryModel = __webpack_require__(766);

var _outletHomePageModel = __webpack_require__(767);

var _rentalProductOverviewModel = __webpack_require__(786);

var _rentalProductOverviewItemModel = __webpack_require__(785);

var _rentalProductsOrderModel = __webpack_require__(787);

var _rentalProductModel = __webpack_require__(784);

var _rentalProductCategoryModel = __webpack_require__(783);

var _libraryDocumentCategoryModel = __webpack_require__(754);

var _libraryDocumentModel = __webpack_require__(755);

var _libraryQuestionModel = __webpack_require__(756);

var _deliveryInfoRentalProductModel = __webpack_require__(743);

var _contactInfoRentalProductModel = __webpack_require__(740);

var _rentalHistoryItemModel = __webpack_require__(781);

var _rentalHistoryDetailModel = __webpack_require__(780);

var _rentalHistoryStatusItemModel = __webpack_require__(782);

var _certificateItemModel = __webpack_require__(739);

var _packageItemModel = __webpack_require__(768);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.models', []).factory('AddedToCartInfo', _addedToCartInfoModel.addedToCartInfo).factory('Address', _addressModel.address).factory('Brand', _brandModel.brand).factory('CartDraft', _cartDraftModel.cartDraft).factory('CartErrorMessage', _cartErrorMessageModel.cartErrorMessage).factory('Cart', _cartModel.cart).factory('CartSeller', _cartSellerModel.cartSeller).factory('CartDisabledSeller', _cartDisabledSellerModel.cartDisabledSeller).factory('CartSellerProduct', _cartSellerProductModel.cartSellerProduct).factory('Category', _categoryModel.category).factory('CategoryWithSubcategories', _categoryWithSubcategoriesModel.categoryWithSubcategories).factory('Delivery', _deliveryModel.delivery).factory('DeliveryProduct', _deliveryProductModel.deliveryProduct).factory('Discounttype', _discounttypeModel.discounttype).factory('FilterCategory', _filterCategoryModel.filterCategory).factory('FilterCategoryItem', _filterCategoryItemModel.filterCategoryItem).factory('Filter', _filterModel.filter)
//.factory('Identity', identity)
.factory('MediPimData', _mediPimDataModel.mediPimData).factory('NewsItem', _newsItemModel.newsItem).factory('NewsOverview', _newsOverviewModel.newsOverview).factory('NewsSearchRequest', _newsSearchRequest.newsSearchRequest).factory('Order', _orderModel.order).factory('OrderProduct', _orderProductModel.orderProduct).factory('OrderConfirmation', _orderConfirmationModel.orderConfirmation).factory('OrderOverviewItem', _orderOverviewItemModel.orderOverviewItem).factory('Paging', _pagingModel.paging).factory('Product', _productModel.product).factory('ProductOverview', _productOverviewModel.productOverview).factory('ProductOverviewItem', _productOverviewItemModel.productOverviewItem).factory('ProductFilterRequest', _productFilterRequest.productFilterRequest).factory('ProductSearchRequest', _productSearchRequest.productSearchRequest).factory('Seller', _sellerModel.seller).factory('SellerCategory', _sellerCategoryModel.sellerCategory).factory('SellerBanner', _sellerBannerModel.sellerBanner).factory('Tenant', _tenantModel.tenant).factory('Totals', _totalsModel.totals).factory('User', _userModel.user).factory('HelpItem', _helpItemModel.helpItem).factory('NewsTile', _newsTileModel.newsTile).factory('SellerOverview', _sellerOverviewModel.sellerOverview).factory('Partnership', _partnershipModel.partnership).factory('PartnershipOverview', _partnershipOverviewModel.partnershipOverview).factory('PartnershipDetail', _partnershipDetail.partnershipDetail).factory('StockOverview', _stockOverviewModel.stockOverview).factory('Stock', _stockModel.stock).factory('SellerContact', _sellerContactModel.sellerContact).factory('SellerPublic', _sellerPublicModel.sellerPublic).factory('FastOrderProduct', _fastOrderProductModel.fastOrderProduct).factory('ProductDiscount', _productDiscountModel.productDiscount).factory('ProductSet', _productSetModel.productSet).factory('CartProduct', _cartProduct.cartProduct).factory('Contract', _contractModel.contract).factory('FilterHierarchyCategoryItem', _filterHierarchyCategoryItemModel.filterHierarchyCategoryItem).factory('Wholesaler', _wholesalerModel.wholesaler).factory('ContractDetail', _contractDetailModel.contractDetail).factory('RentalProductOverview', _rentalProductOverviewModel.rentalProductOverview).factory('RentalProduct', _rentalProductModel.rentalProduct).factory('RentalProductOverviewItem', _rentalProductOverviewItemModel.rentalProductOverviewItem).factory('RentalHistoryItem', _rentalHistoryItemModel.rentalHistoryItem).factory("RentalHistoryDetail", _rentalHistoryDetailModel.rentalHistoryDetail).factory("RentalHistoryStatusItem", _rentalHistoryStatusItemModel.rentalHistoryStatusItem).factory('RentalProductsOrder', _rentalProductsOrderModel.rentalProductsOrder).factory('OutletCategory', _outletCategoryModel.outletCategory).factory('OutletHomePage', _outletHomePageModel.outletHomePage).factory('RentalProductCategory', _rentalProductCategoryModel.rentalProductCategory).factory('LibraryDocumentCategory', _libraryDocumentCategoryModel.libraryDocumentCategory).factory('LibraryDocument', _libraryDocumentModel.libraryDocument).factory('LibraryQuestion', _libraryQuestionModel.libraryQuestion).factory('ContactInfoRentalProduct', _contactInfoRentalProductModel.contactInfoRentalProduct).factory('DeliveryInfoRentalProduct', _deliveryInfoRentalProductModel.deliveryInfoRentalProduct).factory('CertificateItem', _certificateItemModel.certificateItem).factory('PackageItem', _packageItemModel.packageItem);
//import {identity} from './identityModel';
exports.default = _module.name;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


libraryDocumentCategory.$inject = ["LibraryDocument"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.libraryDocumentCategory = libraryDocumentCategory;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function libraryDocumentCategory(LibraryDocument) {
    var clazz = function LibraryDocumentCategory() {
        var defaults = {
            sequenceNumber: 0,
            title: null,
            documents: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.sequenceNumber = resource.sequenceNumber;
        o.title = resource.title;
        o.documents = _lodash2.default.map(resource.libraryDocuments, function (i) {
            return LibraryDocument.create(i);
        });
        return o;
    };

    return clazz;
}

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.libraryDocument = libraryDocument;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function libraryDocument() {
    var clazz = function LibraryDocument() {
        var defaults = {
            sequenceNumber: 0,
            title: null,
            description: null,
            path: null,
            code: null,
            visible: false,
            languageId: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.sequenceNumber = resource.sequenceNumber;
        o.title = resource.title;
        o.description = resource.description;
        o.path = resource.path;
        o.code = resource.code;
        o.visible = resource.visible;
        o.languageId = resource.languageId;
        o.id = resource.id;
        return o;
    };

    return clazz;
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.libraryQuestion = libraryQuestion;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function libraryQuestion() {
    var clazz = function libraryQuestion() {
        var defaults = {
            sequenceNumber: 0,
            question: '',
            answer: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.sequenceNumber = resource.sequenceNumber;
        o.question = resource.question;
        o.answer = resource.answer;
        return o;
    };

    return clazz;
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mediPimData = mediPimData;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function mediPimData() {
    var clazz = function MediPimData() {
        var defaults = {
            description: '',
            fullDescription: '',
            NUT: '',
            ATC: '',
            EAN: '',
            UDI: '',
            prescription: false,
            properties: '',
            usage: '',
            composition: '',
            contraIndication: '',
            sideEffects: '',
            indication: '',
            images: [],
            height: 0,
            width: 0,
            depth: 0,
            weight: 0,
            brands: [],
            apbCategory: '',
            categories: [],
            tax: 0,
            media: [],
            faggPublicNotice: '',
            faggSpecialNotice: '',
            pharmaPublicNotice: '',
            pharmaSpecialNotice: '',
            laboPublicNotice: '',
            laboSpecialNotice: '',
            packageQuantity: '',
            conservation: '',
            pharmacistPrice: 0,
            expires: false,
            supplierReference: '',
            tradeInMonthsBeforeExpiry: 0,
            tradeInMonthsAfterExpiry: 0,
            tradeInRefundValue: 0,
            status: '',
            ctiExtended: '',
            refundValueWithOmnio: 0,
            refundValueWithoutOmnio: 0,
            attributes: [],
            activeIngredients: [],
            suppliers: [],
            shortDescription: '',
            frontals: [],
            writtenRequestByPatient: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var data = new clazz();
        data.description = resource.description;
        data.fullDescription = resource.fullDescription;
        data.NUT = resource.nut;
        data.ATC = resource.atc;
        data.EAN = resource.ean;
        data.GTIN = resource.gtin;
        data.UDI = resource.udi;
        data.prescription = resource.prescription;
        data.properties = resource.properties;
        data.usage = resource.usage;
        data.composition = resource.composition;
        data.contraIndication = resource.contraIndication;
        data.sideEffects = resource.sideEffects;
        data.indication = resource.indication;
        data.images = resource.images;
        data.height = resource.height;
        data.width = resource.width;
        data.depth = resource.depth;
        data.weight = resource.weight;
        data.brands = resource.brands;
        data.apbCategory = resource.apbCategory;
        data.categories = resource.categories;
        data.tax = resource.tax;
        data.media = resource.media;
        data.faggPublicNotice = resource.faggPublicNotice;
        data.faggSpecialNotice = resource.faggSpecialNotice;
        data.pharmaPublicNotice = resource.pharmaPublicNotice;
        data.pharmaSpecialNotice = resource.pharmaSpecialNotice;
        data.laboPublicNotice = resource.laboPublicNotice;
        data.laboSpecialNotice = resource.laboSpecialNotice;
        data.packageQuantity = resource.packageQuantity;
        data.conservation = resource.conservation;
        data.pharmacistPrice = resource.pharmacistPrice;
        data.expires = resource.expires;
        data.supplierReference = resource.supplierReference;
        data.tradeInMonthsBeforeExpiry = resource.tradeInMonthsBeforeExpiry;
        data.tradeInMonthsAfterExpiry = resource.tradeInMonthsAfterExpiry;
        data.tradeInRefundValue = resource.tradeInRefundValue;
        data.status = resource.status;
        data.ctiExtended = resource.ctiExtended;
        data.refundValueWithOmnio = resource.refundValueWithOmnio;
        data.refundValueWithoutOmnio = resource.refundValueWithoutOmnio;
        data.attributes = resource.attributes;
        data.activeIngredients = resource.activeIngredients;
        data.suppliers = resource.suppliers;
        data.shortDescription = resource.shortDescription;
        data.frontals = resource.frontals;
        data.writtenRequestByPatient = resource.writtenRequestByPatient;
        return data;
    };

    clazz.createFromLocalStorage = function (resource) {
        var data = new clazz();
        data.description = resource.description;
        data.fullDescription = resource.fullDescription;
        data.NUT = resource.nut;
        data.ATC = resource.atc;
        data.EAN = resource.ean;
        data.GTIN = resource.gtin;
        data.UDI = resource.udi;
        data.prescription = resource.prescription;
        data.properties = resource.properties;
        data.usage = resource.usage;
        data.composition = resource.composition;
        data.contraIndication = resource.contraIndication;
        data.sideEffects = resource.sideEffects;
        data.indication = resource.indication;
        data.images = resource.images;
        data.height = resource.height;
        data.width = resource.width;
        data.depth = resource.depth;
        data.weight = resource.weight;
        data.brands = resource.brands;
        data.apbCategory = resource.apbCategory;
        data.categories = resource.categories;
        data.tax = resource.tax;
        data.media = resource.media;
        data.faggPublicNotice = resource.faggPublicNotice;
        data.faggSpecialNotice = resource.faggSpecialNotice;
        data.pharmaPublicNotice = resource.pharmaPublicNotice;
        data.pharmaSpecialNotice = resource.pharmaSpecialNotice;
        data.laboPublicNotice = resource.laboPublicNotice;
        data.laboSpecialNotice = resource.laboSpecialNotice;
        data.packageQuantity = resource.packageQuantity;
        data.conservation = resource.conservation;
        data.pharmacistPrice = resource.pharmacistPrice;
        data.expires = resource.expires;
        data.supplierReference = resource.supplierReference;
        data.tradeInMonthsBeforeExpiry = resource.tradeInMonthsBeforeExpiry;
        data.tradeInMonthsAfterExpiry = resource.tradeInMonthsAfterExpiry;
        data.tradeInRefundValue = resource.tradeInRefundValue;
        data.status = resource.status;
        data.ctiExtended = resource.ctiExtended;
        data.refundValueWithOmnio = resource.refundValueWithOmnio;
        data.refundValueWithoutOmnio = resource.refundValueWithoutOmnio;
        data.attributes = resource.attributes;
        data.activeIngredients = resource.activeIngredients;
        data.suppliers = resource.suppliers;
        data.frontals = resource.frontals;
        data.shortDescription = resource.shortDescription;
        data.writtenRequestByPatient = resource.writtenRequestByPatient;
        return data;
    };

    return clazz;
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


newsItem.$inject = ["NewsTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsItem = newsItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsItem(NewsTypes) {
    var clazz = function NewsItem() {
        var defaults = {
            id: 0,
            type: '',
            sellerId: 0,
            sellerName: '',
            isVipSeller: false,
            title: '',
            description: '',
            html: '',
            categoryId: 0,
            categoryLabel: '',
            categoryName: '',
            tags: [],
            links: [],
            banners: [],
            header: [],
            author: '',
            featuredImage: '',
            publishDate: '',
            shortDescription: '',
            gallery: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        getTypeLabel: function getTypeLabel(type) {
            var item = _lodash2.default.filter(NewsTypes, function (i) {
                return i.type === type;
            });
            return item && item.length > 0 ? item[0].label : null;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = resource.type;
        o.sellerId = resource.sellerId;
        o.sellerName = resource.sellerName;
        o.isVipSeller = resource.isVipSeller;
        o.title = resource.title;
        o.description = resource.description;
        o.html = resource.html;
        o.categoryId = resource.categoryId;
        o.tags = resource.tags;
        o.links = resource.links;
        o.banners = resource.banners;
        o.header = resource.header;
        o.author = resource.author;
        o.categoryLabel = resource.categoryLabel;
        o.categoryName = resource.categoryName;
        o.featuredImage = resource.featuredImage;
        o.publishDate = resource.publishDate;
        o.shortDescription = resource.shortDescription;
        o.gallery = resource.gallery;
        return o;
    };

    return clazz;
}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


newsOverview.$inject = ["Paging"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsOverview = newsOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsOverview(Paging) {
    var clazz = function NewsOverview() {
        var defaults = {
            context: 0,
            items: [],
            categories: [],
            selectedCategory: null,
            searchValue: '',
            sellerId: null,
            brandId: null,
            productId: null,
            tagId: null,
            paging: null,
            isNewsAvailableForContext: false,
            isNewsAvailableForCriteria: true,
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (context, defaultFilterAttr, pageSize) {
        var o = new clazz();
        o.context = context;
        o.paging = Paging.create({ totalItems: 0, itemsPerPage: pageSize ? pageSize : 12, page: 1, pageCount: 1, pageNumbers: [] });

        if (defaultFilterAttr) {
            o.sellerId = defaultFilterAttr.sellerId;
            o.brandId = defaultFilterAttr.brandId;
            o.productId = defaultFilterAttr.productId;
            o.tagId = defaultFilterAttr.tagId;
        }
        return o;
    };

    return clazz;
}

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsSearchRequest = newsSearchRequest;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsSearchRequest() {
    var clazz = function NewsSearchRequest() {
        var defaults = {
            skip: 0,
            take: 5,
            categoryId: null,
            searchValue: '',
            context: 0,
            sellerId: 0,
            brandId: 0,
            productId: 0,
            tagId: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (context, params) {
        var o = new clazz();
        o.skip = params.skip;
        o.take = params.take;
        o.categoryId = params.categoryId;
        o.searchValue = params.searchValue;
        o.context = context;
        o.sellerId = params.sellerId;
        o.brandId = params.brandId;
        o.productId = params.productId;
        o.tagId = params.tagId;
        return o;
    };

    return clazz;
}

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsTile = newsTile;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsTile() {
    var clazz = function NewsTile() {
        var defaults = {
            id: 0,
            shortDescription: '',
            defaultBannerImage: '0',
            featuredImagePath: '0',
            publishDate: '',
            categoryLabel: '',
            categoryName: '',
            author: '',
            title: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.shortDescription = resource.shortDescription;
        o.defaultBannerImage = resource.defaultBannerImage;
        o.featuredImagePath = resource.featuredImagePath;
        o.publishDate = resource.createdOn;
        o.categoryLabel = resource.categoryLabel;
        o.categoryName = resource.categoryName;
        o.author = resource.authorFullName;
        o.title = resource.title;
        o.sellerName = resource.sellerName;
        o.modified = resource.modified;
        return o;
    };

    return clazz;
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderConfirmation = orderConfirmation;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderConfirmation() {
    var clazz = function OrderConfirmation() {
        var defaults = {
            sellerName: '',
            orderNumber: '',
            totalPrice: 0,
            totalDiscount: 0,
            deliveryDate: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.sellerName = resource.sellerName;
        o.orderNumber = resource.orderNumber;
        o.totalPrice = resource.totalPrice;
        o.totalDiscount = resource.totalDiscount;
        o.deliveryDate = resource.deliveryDate;
        return o;
    };

    return clazz;
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


order.$inject = ["Totals", "OrderProduct", "Address", "Enums", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.order = order;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function order(Totals, OrderProduct, Address, Enums, gettextCatalog) {
    var clazz = function Order() {
        var defaults = {
            id: 0,
            referenceNumber: '',
            orderNumber: '',
            date: '',
            sellerName: '',
            wholeSalerName: '',
            orderStatusCode: '',
            isPartialStatus: false,
            orderStatusText: '',
            hasError: false,
            hasSuccess: false,
            customerNumber: '',
            APBNr: '',
            deliveryAddress: null,
            invoiceAddress: null,
            totals: null,
            products: null,
            shippingNotes: null,
            version: 0,
            note: null,
            originalOrderId: 0,
            originalOrderReference: 0,
            actualDeliveryDate: null,
            deliveryRouteNumber: null
            //deliveries: null
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        setDeliveries: function setDeliveries(deliveries) {
            this.deliveries = deliveries;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.referenceNumber = resource.referenceNr;
        o.orderNumber = resource.orderNr;
        o.date = resource.orderDate;
        o.sellerName = resource.sellerName;
        o.wholesalerName = resource.wholeSalerName;
        o.orderStatusCode = resource.stateCode;
        o.isPartialStatus = resource.isPartialState;
        o.orderStatusText = orderStatusText(resource.stateCode);
        o.hasError = hasError(resource.stateCode);
        o.hasSuccess = hasSuccess(resource.stateCode);
        o.customerNumber = resource.febelcoCustomerNr;
        o.APBNr = resource.apbNumber;
        o.deliveryAddress = resource.deliveryAddress ? Address.create(resource.deliveryAddress) : null;
        o.invoiceAddress = resource.invoiceAddress ? Address.create(resource.invoiceAddress) : null;
        o.totals = Totals.create(resource);
        o.products = _lodash2.default.map(resource.orderProducts, function (i) {
            return OrderProduct.create(i);
        });
        o.shippingNotes = resource.shippingNotes;
        o.deliveryDate = resource.deliveryDate;
        o.version = resource.version;
        o.note = resource.note;
        o.originalOrderId = resource.originalOrderId;
        o.originalOrderReference = resource.originalOrderReference;
        o.groupedProducts = _lodash2.default.groupBy(o.products, 'productNumber');
        o.actualDeliveryDate = resource.actualDeliveryDate;
        o.deliveryRouteNumber = resource.deliveryRouteNumber;
        //o.deliveries = lodash.map(resource.Deliveries, i => Delivery.create(i));
        return o;
    };

    function orderStatusText(code) {
        return code ? gettextCatalog.getString(Enums.orderStatusTexts[code].text) : '';
    }

    function hasError(code) {
        return code ? code === 'ERROR' || code === 'CANCELLED' : false;
    }

    function hasSuccess(code) {
        return code ? code === 'READYWS' || code === 'INVWS' || code === 'INVWSP' : false;
    }

    return clazz;
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


orderOverviewItem.$inject = ["Enums", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderOverviewItem = orderOverviewItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderOverviewItem(Enums, gettextCatalog) {
    var clazz = function OrderOverviewItem() {
        var defaults = {
            id: 0,
            referenceNumber: '',
            orderNumber: '',
            date: '',
            seller: '',
            amount: 0,
            orderStatusCode: '',
            isPartialStatus: false,
            orderStatusText: '',
            hasError: false,
            hasSuccess: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.referenceNumber = resource.referenceNumber;
        o.orderNumber = resource.orderNumber;
        o.date = resource.orderDate;
        o.seller = resource.sellerName;
        o.amount = resource.totalPriceWithDiscount;
        o.orderStatusCode = resource.stateCode;
        o.isPartialStatus = resource.isPartialState;
        o.deliveryDate = resource.deliveryDate;
        o.orderStatusText = orderStatusText(resource.stateCode);
        o.hasError = hasError(resource.stateCode);
        o.hasSuccess = hasSuccess(resource.stateCode);
        return o;
    };

    function orderStatusText(code) {
        return code ? gettextCatalog.getString(Enums.orderStatusTexts[code].text) : '';
    }

    function hasError(code) {
        return code ? code === 'ERROR' || code === 'CANCELLED' : false;
    }

    function hasSuccess(code) {
        return code ? code === 'READYWS' || code === 'INVWS' || code === 'INVWSP' : false;
    }

    return clazz;
}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


orderProduct.$inject = ["textBuilder", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderProduct = orderProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderProduct(textBuilder, Enums) {
    var clazz = function OrderProduct() {
        var defaults = {
            id: 0,
            type: '',
            name: '',
            productNumber: '',
            promoCode: '',
            productNumberAndPromo: '',
            quantity: '',
            unitPrice: '',
            totalPriceWithoutDiscount: '',
            totalPriceWithDiscount: '',
            discountPercentage: '',
            totalDiscount: '',
            totalDiscountPct: '',
            included_products: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.type = '';
        o.name = resource.displayName;
        o.productNumber = resource.nationalNumber;
        o.promoCode = resource.promoCode;
        o.productNumberAndPromo = textBuilder.getProductNumberAndPromo(o.productNumber, o.promoCode);
        o.quantity = resource.quantity;
        o.unitPrice = resource.price;
        o.discountPercentage = resource.discountPercentage;
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalDiscountAmount = resource.totalDiscountAmount;
        o.totalPriceWithoutDiscount = resource.totalPriceWithDiscount + resource.totalDiscountAmount;
        o.status = resource.status;
        o.hasSuccess = hasSuccess(resource.statusCode);
        o.hasError = hasError(resource.statusCode);
        o.statusCode = resource.status;
        o.reason = resource.reason;
        o.reasonCode = resource.reasonCode;

        if (resource.content && resource.content.length > 0) {
            o.included_products = _lodash2.default.map(resource.content, function (i) {
                return {
                    name: i.displayName,
                    quantity: i.quantity,
                    productNumber: i.nationalNumber,
                    statusCode: i.statusCode
                };
            });
        }
        return o;
    };

    function hasSuccess(code) {
        return code ? code === Enums.orderProductStatusCodes.CONFIRMED.value || code === Enums.orderProductStatusCodes.CON.value : false;
    }

    function hasError(code) {
        return code ? code === Enums.orderProductStatusCodes.ERROR.value || code === Enums.orderProductStatusCodes.CANCELLED.value || code === Enums.orderProductStatusCodes.CAN.value : false;
    }

    return clazz;
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletCategory = outletCategory;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function outletCategory() {
    var clazz = function OutletCategory() {
        var defaults = {
            id: 0,
            startDate: null,
            endDate: null,
            sequence: 0,
            url: null,
            imagePath: null,
            name: null,
            languageId: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.startDate = resource.startDate;
        o.endDate = resource.endDate;
        o.sequence = resource.priority;
        o.url = resource.url;
        o.imagePath = resource.imagePath;
        o.name = resource.name;
        o.languageId = resource.defaultLanguageId;
        return o;
    };

    return clazz;
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletHomePage = outletHomePage;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function outletHomePage() {
    var clazz = function OutletHomePage() {
        var defaults = {
            id: 0,
            topTitle: null,
            bottomTitle: null,
            topText: null,
            languageId: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.topTitle = resource.topTitle;
        o.bottomTitle = resource.bottomTitle;
        o.topText = resource.topText;
        o.languageId = resource.defaultLanguageId;
        return o;
    };

    return clazz;
}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.packageItem = packageItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function packageItem() {
    var clazz = function HelpItem() {
        var defaults = {
            id: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        return o;
    };

    return clazz;
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


paging.$inject = ["Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paging = paging;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function paging(Enums) {
    var clazz = function Paging() {
        var defaults = {
            totalItems: 0,
            itemsPerPage: Enums.getAmounts.default,
            page: 1,
            pageCount: 1,
            pageNumbers: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        update: function update(page) {
            this.pageCount = this.getPageCount();
            this.pageNumbers = this.getPageNumbers(page);
        },
        getPageCount: function getPageCount() {
            return Math.floor((this.totalItems + this.itemsPerPage - 1) / this.itemsPerPage);
        },
        getPageNumbers: function getPageNumbers(page) {
            var pageCount = this.getPageCount();
            var pageObjects = [];

            if (pageCount <= 5) {
                for (var i = 1; i <= pageCount; i++) {
                    pageObjects.push({ index: i, isHiddenOnMobile: false });
                }
            } else {
                // when current page is 1, 2 or 3
                // - show 1 2 3 4 at the beginning (on mobile: hide 4)
                // - add ellipses
                // - add n
                if (page === 1 || page === 2 || page === 3) {
                    pageObjects.push({ index: 1, isHiddenOnMobile: false });
                    pageObjects.push({ index: 2, isHiddenOnMobile: false });
                    pageObjects.push({ index: 3, isHiddenOnMobile: false });
                    pageObjects.push({ index: 4, isHiddenOnMobile: true });
                    pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                    pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                }

                // when current page is n, n-1, n-2
                // add 1
                // - add ellipses
                // - show n-3 n-2 n-1 n at the end (on mobile: hide n-3)
                else if (page === pageCount || page === pageCount - 1 || page === pageCount - 2) {
                        pageObjects.push({ index: 1, isHiddenOnMobile: false });
                        pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount - 3, isHiddenOnMobile: true });
                        pageObjects.push({ index: pageCount - 2, isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount - 1, isHiddenOnMobile: false });
                        pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                    }

                    // when current page (p) is anything else
                    // - add 1
                    // - add ellipses
                    // - add p-1 p p+1 (on mobile: hide p-1 and p+1)
                    // - add ellipses
                    // - add n
                    else {
                            pageObjects.push({ index: 1, isHiddenOnMobile: false });
                            pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                            pageObjects.push({ index: page - 1, isHiddenOnMobile: true });
                            pageObjects.push({ index: page, isHiddenOnMobile: false });
                            pageObjects.push({ index: page + 1, isHiddenOnMobile: true });
                            pageObjects.push({ isEllipses: '...', isHiddenOnMobile: false });
                            pageObjects.push({ index: pageCount, isHiddenOnMobile: false });
                        }
            }

            return pageObjects;
        },
        getSkipValue: function getSkipValue(page, itemsPerPage) {
            return (page - 1) * itemsPerPage;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.totalItems = resource.totalItems;
        o.itemsPerPage = resource.itemsPerPage;
        o.page = resource.page;
        o.pageCount = o.getPageCount();
        o.pageNumbers = o.getPageNumbers(o.page);
        return o;
    };

    return clazz;
}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


partnershipDetail.$inject = ["ProductOverviewItem", "Contract"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipDetail = partnershipDetail;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipDetail(ProductOverviewItem, Contract) {
    var clazz = function PartnershipDetail() {
        var defaults = {
            id: 0,
            partner: null,
            featuredImage: null,
            title: null,
            leading: null,
            content: null,
            summaryList: null,
            summary: null,
            gallery: null,
            links: null,
            callToActionContent: null,
            callToActionLinks: null,
            sellerContactPersons: null,
            type: '',
            typeName: '',
            contracts: null,
            discounts: null,
            hasNoLinkedContracts: null,
            category: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource, shopProductItems) {
        var partnership = new clazz();
        partnership.id = resource.id;
        partnership.featuredImage = resource.featuredImage;
        partnership.partner = resource.partner;
        partnership.title = resource.title;
        partnership.leading = resource.leading;
        partnership.content = resource.content;
        partnership.summaryList = resource.summaryList;
        partnership.summary = resource.summary;
        partnership.links = resource.links;
        partnership.gallery = resource.gallery;
        partnership.callToActionContent = resource.callToActionContent;
        partnership.callToActionLinks = resource.callToActionLinks;
        partnership.sellerContactPersons = resource.sellerContactPersons;
        partnership.type = resource.type;
        partnership.typeName = resource.typeName;
        partnership.contracts = resource.contracts.map(function (c) {
            return Contract.create(c);
        });
        partnership.hasNoLinkedContracts = resource.hasNoLinkedContracts;
        partnership.discounts = resource.discounts.map(function (d) {
            return ProductOverviewItem.getClass().create(d, shopProductItems);
        });
        partnership.category = resource.category;
        return partnership;
    };

    return clazz;
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnership = partnership;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnership() {
    var clazz = function Partnership() {
        var defaults = {
            id: 0,
            featuredImagePath: '',
            featuredImageDescription: '',
            partnerName: null,
            title: null,
            type: '',
            typeName: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var partnership = new clazz();
        partnership.id = resource.id;
        partnership.featuredImagePath = resource.featuredImagePath;
        partnership.featuredImageDescription = resource.featuredImageDescription;
        partnership.partnerName = resource.partnerName;
        partnership.title = resource.title;
        partnership.type = resource.type;
        partnership.typeName = resource.typeName;
        return partnership;
    };

    return clazz;
}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


partnershipOverview.$inject = ["Paging"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipOverview = partnershipOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipOverview(Paging) {
    var clazz = function PartnershipOverview() {
        var defaults = {
            partnerships: [],
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false,
            paging: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (pageSize) {
        var partnershipOverview = new clazz();
        partnershipOverview.partnerships = [];
        partnershipOverview.paging = Paging.create({ totalItems: 0, itemsPerPage: pageSize ? pageSize : 12, page: 1, pageCount: 1, pageNumbers: [] });
        return partnershipOverview;
    };

    return clazz;
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productDiscount = productDiscount;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productDiscount() {
    var clazz = function ProductDiscount() {
        var defaults = {
            productDiscounts: [],
            totalPriceDiscounts: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.allProductDiscounts = resource.productDiscounts;
        o.totalPriceDiscounts = resource.totalPriceDiscounts;
        return o;
    };

    return clazz;
}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productFilterRequest.$inject = ["Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productFilterRequest = productFilterRequest;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productFilterRequest(Enums) {
    var clazz = function ProductFilterRequest() {
        var defaults = {
            context: 0,
            DiscountTypeId: null,
            SellerId: null,
            SellerPortalProductCategoryTypeId: null,
            MediPimBrandId: null,
            CategoryId: null,
            ProductName: null,
            IsDiscountView: false,
            CacheFilter: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.createForHomePage = function () {
        var request = new clazz();
        request.context = Enums.searchContext.none.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForDiscounts = function (discountTypeId) {
        var request = new clazz();
        request.context = Enums.searchContext.discount.id;
        request.DiscountTypeId = discountTypeId;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSearch = function (searchValue) {
        var request = new clazz();
        request.context = Enums.searchContext.search.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = searchValue;
        request.IsDiscountView = false;
        request.CacheFilter = false;
        return request;
    };

    clazz.createForBrand = function (brandId) {
        var request = new clazz();
        request.context = Enums.searchContext.brand.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = brandId;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForCategory = function (categoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.category.id;
        request.DiscountTypeId = null;
        request.SellerId = null;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = categoryId === 0 ? null : categoryId;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerProducts = function (sellerId, categoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = categoryId ? categoryId : null;
        request.MediPimBrandId = null;
        request.CategoryId = categoryId ? categoryId : null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDiscounts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerCategory = function (sellerId, sellerCategoryId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = sellerCategoryId;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDetailDiscounts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = true;
        request.CacheFilter = true;
        return request;
    };

    clazz.createForSellerDetailProducts = function (sellerId) {
        var request = new clazz();
        request.context = Enums.searchContext.seller.id;
        request.DiscountTypeId = null;
        request.SellerId = sellerId;
        request.SellerPortalProductCategoryTypeId = null;
        request.MediPimBrandId = null;
        request.CategoryId = null;
        request.ProductName = null;
        request.IsDiscountView = false;
        request.CacheFilter = true;
        return request;
    };

    return clazz;
}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


product.$inject = ["common", "textBuilder", "MediPimData", "ProductTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.product = product;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function product(common, textBuilder, MediPimData, ProductTypes) {
    // prodFactory and getClass are created to be able to use the ProductModel recursively
    var prodFactory = {
        getClass: function getClass() {

            var clazz = function Product() {
                var defaults = {
                    id: null,
                    name: '',
                    discountName: '',
                    displayName: '',
                    message: null,
                    type: '',
                    image: '',
                    sellerId: 0,
                    sellerName: '',
                    brand: '',
                    discount: null,
                    productNumber: '',
                    EAN: '',
                    ATC: '',
                    UDI: '',
                    NUT: '',
                    promocode: '',
                    price: 0,
                    tax: 0,
                    other_discounts: [],
                    included_products: [],
                    amountInPack: 0,
                    minQuantityInPanacee: 0,
                    maxQuantityInPanacee: 0,
                    maxDiscount: 0,
                    // calculated totals and discount
                    quantity: 0,
                    internalQuantity: 1,
                    totalPriceDiscountIds: [],
                    activeDiscountIds: [],
                    discountAmount: 0,
                    totalPriceWithoutDiscount: 0,
                    totalDiscount: 0,
                    totalPriceWithDiscount: 0,
                    discountText: '',
                    time_remaining: null,
                    isInCart: false,
                    isSellableInStore: null,
                    isSellableAsSingleProduct: true,
                    productSourceCode: null,
                    portalContractTypeCode: null,
                    counterStatus: null,
                    counter: null,
                    mediPimData: null,
                    productNumberAndPromo: '',
                    grossProfit: undefined,
                    grossProfitAmount: undefined,
                    panaceeQuantity: 0,
                    totalProductsAmountInPanacee: 0,
                    expirationDate: null,
                    quantityToAddForHighestDiscount: 0,
                    unitPriceWithDiscount: 0,
                    topNewsitems: null,
                    productDiscounts: null,
                    certificates: []
                };

                _lodash2.default.extend(this, defaults);
            };

            _lodash2.default.extend(clazz.prototype, {
                getTotalQuantity: function getTotalQuantity() {
                    return this.type === ProductTypes.panacee.clientValue ? _lodash2.default.sumBy(this.included_products, function (p) {
                        return p.quantity * p.internalQuantity;
                    }) : this.quantity;
                },

                getTotalPriceWithoutDiscount: function getTotalPriceWithoutDiscount() {
                    var result = this.type === ProductTypes.panacee.clientValue ? _lodash2.default.sumBy(this.included_products, function (p) {
                        if (p.maxOrderAmount > 0 && p.quantity > p.maxOrderAmount) {
                            return p.maxOrderAmount * p.price;
                        }
                        if (p.minOrderAmount > 0 && p.quantity >= p.minOrderAmount) {
                            return p.price * p.quantity;
                        } else if (p.minOrderAmount > 0 && p.quantity < p.minOrderAmount) {
                            return 0;
                        }

                        return p.price * p.quantity;
                    }) : this.price * this.quantity;
                    result = Math.round(result * 10000) / 10000;

                    //console.log('getTotalPriceWithoutDiscount', result);

                    return result;
                },

                getTotalPriceWithDiscount: function getTotalPriceWithDiscount() {
                    var result = this.totalPriceWithoutDiscount - this.totalDiscount;
                    result = Math.round(result * 10000) / 10000;

                    //console.log('getTotalPriceWithDiscount', result);

                    return result;
                },

                getTotalDiscount: function getTotalDiscount() {
                    // discount is always on group level (or product level for a single product)
                    var totalPriceWithoutDiscount = this.getTotalPriceWithoutDiscount();
                    var discountPct = this.getDiscountPctForQuantity();
                    var result = totalPriceWithoutDiscount * discountPct / 100;
                    return Math.round(result * 10000) / 10000;
                },

                updateTotals: function updateTotals() {
                    var _this = this;

                    this.quantity = this.getTotalQuantity();
                    this.totalDiscount = this.getTotalDiscount();
                    this.unitPriceWithDiscount = this.price - this.price * this.discountPct / 100;
                    this.totalPriceWithoutDiscount = this.getTotalPriceWithoutDiscount();
                    this.totalPriceWithDiscount = this.getTotalPriceWithDiscount();
                    this.quantityToAddForHighestDiscount = this.getQuantityToAddForHighestDiscount();
                    this.panaceeProductMinMaxMessage = this.getPanaceeProductMinMaxMessage();
                    this.totalProductsAmountInPanacee = 0;
                    this.included_products.forEach(function (panaceeProduct) {
                        _this.totalProductsAmountInPanacee += panaceeProduct.panaceeQuantity;
                    });
                },

                getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
                    return this.highestDiscount ? this.highestDiscount.amount - this.getTotalQuantity() : 0;
                },

                getDiscountPctForQuantity: function getDiscountPctForQuantity() {
                    // NOTE: for now, we assume that all discounts are percentages
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0 || !this.getAllConditionsMet()) {
                        return 0;
                    }

                    // NOTE: discount ranges are sorted from high to low
                    var qty = this.getTotalQuantity();
                    for (var i = 0; i < this.discount.discountRanges.length; i++) {
                        var range = this.discount.discountRanges[i];
                        if (qty >= range.amount) {
                            return range.discount;
                        }
                    }

                    return 0;
                },
                getAllConditionsMet: function getAllConditionsMet() {
                    var met = true;
                    this.included_products.forEach(function (panaceeProduct) {
                        if (panaceeProduct.minOrderAmount > panaceeProduct.quantity) {
                            met = false;
                        }
                    });
                    return met;
                },
                getHighestDiscount: function getHighestDiscount() {
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0) {
                        return null;
                    }
                    return this.discount.discountRanges[0];
                },

                getLowestDiscount: function getLowestDiscount() {
                    if (!this.discount || !this.discount.discountRanges || this.discount.discountRanges.length <= 0) {
                        return null;
                    }
                    return this.discount.discountRanges[this.discount.discountRanges.length - 1];
                },

                getPiecesText: function getPiecesText(i) {
                    return i === 1 ? 'st.' : 'st.';
                },

                getPanaceeProductMinMaxMessage: function getPanaceeProductMinMaxMessage() {
                    if (this.minQuantityInPanacee && this.minQuantityInPanacee > 0 && this.maxQuantityInPanacee && this.maxQuantityInPanacee > 0 && this.maxQuantityInPanacee !== 999999) {
                        return 'min. ' + this.minQuantityInPanacee + ' ' + this.getPiecesText(this.minQuantityInPanacee) + ', max. ' + this.maxQuantityInPanacee + ' ' + this.getPiecesText(this.maxQuantityInPanacee);
                    }
                    if (this.minQuantityInPanacee && this.minQuantityInPanacee > 0) {
                        return 'min. ' + this.minQuantityInPanacee + ' ' + this.getPiecesText(this.minQuantityInPanacee);
                    }
                    if (this.maxQuantityInPanacee && this.maxQuantityInPanacee > 0 && this.maxQuantityInPanacee !== 999999) {
                        return 'max. ' + this.maxQuantityInPanacee + ' ' + this.getPiecesText(this.maxQuantityInPanacee);
                    }
                },

                getCartCurrentDiscount: function getCartCurrentDiscount(cartProducts) {
                    var this_ = this;

                    var productSearch = cartProducts.find(function (shoppingCartProduct) {
                        if (this_.nationalNumber) {
                            return shoppingCartProduct.productNumber === this_.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === this_.id;
                            });
                            return shoppingCartProductSearch;
                        }
                    });
                    return productSearch ? productSearch.discountPercentage : 0;
                },

                getTotalPriceDiscountId: function getTotalPriceDiscountId(cartProducts) {
                    var _this2 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.productNumber === _this2.nationalNumber;
                    });
                    return productSearch ? productSearch.totalPriceDiscountId : 0;
                },

                getTotalPriceDiscountCode: function getTotalPriceDiscountCode(cartProducts) {
                    var _this3 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.productNumber === _this3.nationalNumber;
                    });
                    return productSearch ? productSearch.totalPriceDiscountPromoCode : 0;
                },

                getPanaceeQuantity: function getPanaceeQuantity() {
                    var quantity = 0;
                    if (this.quantity >= this.minOrderAmount && (this.maxOrderAmount === 0 || this.quantity <= this.maxOrderAmount)) {
                        quantity = this.quantity * this.internalQuantity;
                    } else if (this.quantity > this.maxOrderAmount) {
                        quantity = this.maxOrderAmount * this.internalQuantity;
                    }
                    return quantity;
                },

                //update all the discount fields
                getCartFields: function getCartFields(product, shoppingCartProducts) {
                    //Find the product that has to updated in the list of products that are in the shoppingcart
                    var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                        if (product.nationalNumber && shoppingCartProduct.productNumber === product.nationalNumber) {
                            return shoppingCartProduct.productNumber === product.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === product.id;
                            });
                            return shoppingCartProductSearch ? true : false;
                        }
                    });

                    //SINGLE PRODUCT - PARENT PRODUCT update all the product fields with the values from the server
                    if (productToUpdate) {
                        product.discountPct = productToUpdate.discountPercentage;
                        product.grossProfit = productToUpdate.grossProfit * 100;
                        product.grossProfitAmount = productToUpdate.grossProfitAmount;
                        product.promocode = productToUpdate.discountPromoCode;
                        product.quantity = productToUpdate.amount;
                        product.totalDiscount = productToUpdate.discountAmount;
                        product.activeDiscountId = productToUpdate.discountId;
                        product.totalPriceDiscountId = productToUpdate.totalPriceDiscountId;
                        product.totalPriceDiscountPromoCode = productToUpdate.totalPriceDiscountPromoCode;

                        if (typeof product.getPanaceeQuantity === 'function') {
                            product.panaceeQuantity = product.getPanaceeQuantity();
                        } else {
                            product.panaceeQuantity = 0;
                        }

                        //clear the discountId's
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];

                        //add the new discount id's
                        productToUpdate.productWithPossibleDiscounts.map(function (discount) {
                            product.activeDiscountIds.push(discount.discountIds);
                            product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                        });
                    } else {
                        product.quantity = 0;
                        product.discountPct = 0;
                        product.promocode = null;
                        product.activeDiscountId = 0;
                        product.totalPriceDiscountId = 0;
                        product.totalPriceDiscountPromoCode = null;
                        product.panaceeQuantity = 0;
                        product.grossProfit = 0;
                        product.grossProfitAmount = 0;
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];
                    }

                    // PANACEE if the product is a panacee update the childproducts
                    if (product.type === ProductTypes.panacee.clientValue) {

                        product.totalProductsAmountInPanacee = 0;

                        product.included_products.forEach(function (includedProduct) {

                            //find the child product in the shoppingcart
                            var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                                if (includedProduct.nationalNumber && shoppingCartProduct.productNumber === includedProduct.nationalNumber) {
                                    return shoppingCartProduct.productNumber === includedProduct.nationalNumber;
                                } else {
                                    var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                        return productWithPossibleDiscount.id === product.id;
                                    });
                                    return shoppingCartProductSearch ? true : false;
                                }
                            });

                            if (productToUpdate) {

                                //update the total products amount
                                product.totalProductsAmountInPanacee += productToUpdate.amount * includedProduct.internalQuantity;

                                //update the child
                                includedProduct.grossProfit = productToUpdate.grossProfit * 100;
                                includedProduct.grossProfitAmount = productToUpdate.grossProfitAmount;
                                includedProduct.promocode = productToUpdate.discountPromoCode;
                                includedProduct.discountPct = productToUpdate.discountPercentage;
                                includedProduct.panaceeQuantity = includedProduct.getPanaceeQuantity();

                                //update the discount values for panacee contents
                                var productDiscount = productToUpdate.productWithPossibleDiscounts.find(function (productWithDiscount) {
                                    return productWithDiscount.id === includedProduct.id;
                                });

                                if (productDiscount) {
                                    includedProduct.activeDiscountIds = [productDiscount.discountIds];
                                    includedProduct.totalPriceDiscountIds = [productDiscount.totalPriceDiscountId];
                                    includedProduct.totalPriceDiscountPromoCode = productDiscount.totalPriceDiscountPromoCode;
                                }
                            } else {
                                includedProduct.discountPct = 0;
                                includedProduct.activeDiscountIds = [];
                                includedProduct.promocode = null;
                                includedProduct.totalPriceDiscountIds = 0;
                                includedProduct.totalPriceDiscountPromoCode = null;
                                includedProduct.grossProfit = 0;
                                includedProduct.panaceeQuantity = 0;
                            }
                        });
                    } else if (product.type === common.serverTypes.getProductType('PROMOPACK')) {
                        // PROMOPACK if the product is a panacee update the childproducts
                        product.included_products.forEach(function (includedProduct) {
                            includedProduct.totalPriceDiscountIds = product.totalPriceDiscountIds;
                            includedProduct.activeDiscountIds = product.activeDiscountIds;
                            includedProduct.discountPct = product.getCartCurrentDiscount(shoppingCartProducts);
                            includedProduct.totalPriceDiscountId = product.getTotalPriceDiscountId(shoppingCartProducts);
                            includedProduct.totalPriceDiscountPromoCode = product.getTotalPriceDiscountCode(shoppingCartProducts);
                        });
                    }

                    //On a product detail page, update the totals
                    product.updateTotals();

                    //Return the updated product
                    return product;
                }

            });

            clazz.create = function (resource, cart, parentProduct, rootProductType, topNewsitems, productDiscounts) {
                var product = new clazz();
                product.type = common.serverTypes.getProductType(resource.productTypeCode);
                product.id = resource.productId;
                product.name = common.toPascalCase(resource.productName);
                product.displayName = common.toPascalCase(resource.discountName || resource.productName);
                product.message = resource.message; //TODO
                product.price = resource.pharmacyPrice;
                product.publicPrice = resource.publicPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.image = resource.imagePath;
                product.sellerId = resource.sellerId;
                product.sellerName = resource.sellerName;
                product.nationalNumber = resource.productNumber ? resource.productNumber : resource.nationalNumber;
                product.promocode = resource.promocode;
                product.productNumberAndPromo = textBuilder.getProductNumberAndPromo(product.nationalNumber, product.promocode);
                product.isSellableInStore = resource.isSellableInStore ? true : false;
                product.isSellableAsSingleProduct = resource.isSellableAsSingleProduct;
                product.productSourceCode = resource.productSourceCode;
                product.portalContractTypeCode = resource.portalContractTypeCode;
                product.counterStatus = resource.counterStatus;
                product.counter = resource.counter;
                product.maxDiscount = resource.maxDiscount;
                product.grossProfit = resource.grossProfit;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.tax = resource.tax;
                product.amountInPack = resource.quantity;
                product.minOrderAmount = resource.minOrderAmount;
                product.maxOrderAmount = resource.maxOrderAmount;
                product.minQuantityInPanacee = resource.minQuantityInPanacee || 0;
                product.maxQuantityInPanacee = resource.maxQuantityInPanacee || 999999;
                product.time_remaining = resource.time_remaining;
                product.orderTotalPriceDiscountIds = resource.orderTotalPriceDiscountIds || [];
                product.allowSpecial = resource.allowSpecial;
                product.internalQuantity = resource.internalQuantity;
                product.totalProductsAmountInPanacee = 0;
                product.minOrderAmountRequired = resource.minOrderAmountRequired;
                product.expirationDate = resource.expirationDate;
                product.topNewsitems = topNewsitems;
                product.productDiscounts = productDiscounts;
                product.isVipSeller = resource.isVipSeller;
                // set the discount ranges
                var discountRanges = _lodash2.default.map(resource.discountRanges, function (discountRange) {
                    return {
                        discount: parseFloat(discountRange.discount),
                        discountValueTypeSymbol: discountRange.discountValueTypeSymbol,
                        amount: parseInt(discountRange.from)
                    };
                });

                // set the discount
                product.discountId = resource.discountId;
                product.discount = {
                    id: resource.discountId,
                    name: resource.discountName,
                    description: resource.discountDescription,
                    startDate: resource.discountStartDate,
                    endDate: resource.discountEndDate,
                    sellerName: resource.sellerName,
                    discountType: resource.productTypeCode,
                    discountRanges: _lodash2.default.orderBy(discountRanges, 'amount', 'desc')
                };

                // set the medipim data
                if (resource.mediPimData) {
                    product.mediPimData = MediPimData.create(resource.mediPimData);
                }

                // Get calculated fields for toolbar data
                product.highestDiscount = product.getHighestDiscount();
                product.lowestDiscount = product.getLowestDiscount();

                //calculated discount fields form the cart
                if (cart) {
                    product = product.getCartFields(product, cart);
                }

                // create the included products if the product is a panacee or pack
                var includedProduct = null;
                product.included_products = [];
                if (product.type === ProductTypes.pack.clientValue && resource.promoPackContents && resource.promoPackContents.length > 0) {
                    for (var i = 0; i < resource.promoPackContents.length; i++) {
                        resource.promoPackContents[i].isSellableInStore = true;
                        includedProduct = prodFactory.getClass().create(resource.promoPackContents[i], cart, product, rootProductType, true);
                        includedProduct.quantity = resource.promoPackContents[i].quantity; //set the quantity for promopack only
                        product.included_products.push(includedProduct);
                    }
                }

                if (product.type === ProductTypes.panacee.clientValue && resource.panaceeContents && resource.panaceeContents.length > 0) {
                    for (var _i = 0; _i < resource.panaceeContents.length; _i++) {
                        resource.panaceeContents[_i].isSellableInStore = true;
                        includedProduct = prodFactory.getClass().create(resource.panaceeContents[_i], cart, product, rootProductType, true);
                        product.included_products.push(includedProduct);
                    }
                }

                return product;
            };

            return clazz;
        }
    };

    return prodFactory;
}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productOverviewItem.$inject = ["common"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverviewItem = productOverviewItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverviewItem(common) {
    // prodFactory and getClass are created to be able to use the ProductModel recursively
    var prodFactory = {
        getClass: function getClass() {
            var clazz = function ProductOverviewItem() {
                var defaults = {
                    id: null,
                    name: '',
                    discountName: '',
                    displayName: '',
                    type: '',
                    image: '',
                    sellerId: 0,
                    sellerName: '',
                    brand: '',
                    discountId: null,
                    discount: null,
                    productNumber: '',
                    promocode: '',
                    productNumberAndPromo: '',
                    price: 0,
                    time_remaining: null,
                    isInCart: false,
                    isSellableInStore: null,
                    isVipSeller: null,
                    portalContractTypeCode: null,
                    counterStatus: null,
                    counter: null,
                    grossProfit: undefined,
                    grossProfitAmount: 0,
                    // calculated totals and discount
                    highestDiscount: null,
                    lowestDiscount: null,
                    quantity: 0,
                    quantityToAddForHighestDiscount: 0,
                    unitPriceWithDiscount: 0,
                    totalPriceWithoutDiscount: 0,
                    totalDiscount: 0,
                    totalPriceWithDiscount: 0,
                    discountPct: 0,
                    other_discounts: [],
                    priority: 0,
                    // tmp
                    message: null,
                    activeDiscountIds: [],
                    totalPriceDiscountIds: [],
                    expirationDate: null
                };

                _lodash2.default.extend(this, defaults);
            };

            _lodash2.default.extend(clazz.prototype, {
                getInitialQuantity: function getInitialQuantity(cart) {
                    // when the product (with the correct discount) is in the cart, get the quantity from the cart
                    var quantityFromCart = 0;
                    if (cart) {
                        quantityFromCart = cart.getProductQuantity(this.id, this.discountId);
                        if (quantityFromCart > 0) {
                            return quantityFromCart;
                        }
                    }

                    var highestDiscount = this.getHighestDiscount();
                    return highestDiscount ? highestDiscount.amount : 1;
                },

                getQuantityToAddForHighestDiscount: function getQuantityToAddForHighestDiscount() {
                    if (!this.highestDiscount) {
                        return 0;
                    }

                    return this.highestDiscount.amount - this.quantity;
                },

                getDiscountPctForQuantity: function getDiscountPctForQuantity() {
                    // NOTE: for now, we assume that all discounts are percentages
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return 0;
                    }

                    // NOTE: discounts are sorted from high to low
                    for (var i = 0; i < this.discount.ranges.length; i++) {
                        var range = this.discount.ranges[i];
                        if (this.quantity >= range.amount) {
                            return range.discount;
                        }
                    }

                    return 0;
                },

                getHighestDiscount: function getHighestDiscount() {
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return null;
                    }

                    return this.discount.ranges[0];
                },

                getLowestDiscount: function getLowestDiscount() {
                    if (!this.discount || !this.discount.ranges || this.discount.ranges.length <= 0) {
                        return null;
                    }
                    return this.discount.ranges[this.discount.ranges.length - 1];
                },
                getCartCurrentDiscount: function getCartCurrentDiscount(cartProducts) {
                    var _this = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this.id;
                    });
                    return productSearch ? productSearch.discountPercentage : 0;
                },
                getCartCurrentDiscountPromoCode: function getCartCurrentDiscountPromoCode(cartProducts) {
                    var _this2 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this2.id;
                    });
                    return productSearch ? productSearch.discountPromoCode : null;
                },
                getTotalDiscount: function getTotalDiscount(cartProducts) {
                    var _this3 = this;

                    var productSearch = cartProducts.find(function (cartProduct) {
                        return cartProduct.id === _this3.id;
                    });
                    return productSearch ? productSearch.discountAmount : null;
                },
                getCartFields: function getCartFields(product, shoppingCartProducts) {

                    //Find the product that has to updated in the list of products that are in the shoppingcart
                    var productToUpdate = shoppingCartProducts.find(function (shoppingCartProduct) {
                        if (product.nationalNumber && shoppingCartProduct.productNumber === product.nationalNumber) {
                            return shoppingCartProduct.productNumber === product.nationalNumber;
                        } else {
                            var shoppingCartProductSearch = shoppingCartProduct.productWithPossibleDiscounts.find(function (productWithPossibleDiscount) {
                                return productWithPossibleDiscount.id === product.id;
                            });
                            return shoppingCartProductSearch ? true : false;
                        }
                    });

                    if (productToUpdate) {
                        product.discountPct = productToUpdate.discountPercentage;
                        product.grossProfit = productToUpdate.grossProfit * 100;
                        product.grossProfitAmount = productToUpdate.grossProfitAmount;
                        product.promocode = productToUpdate.discountPromoCode;
                        product.quantity = productToUpdate.amount;
                        product.totalDiscount = productToUpdate.discountAmount;

                        //clear the discountId's
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];

                        //add the new discount id's
                        productToUpdate.productWithPossibleDiscounts.map(function (discount) {
                            product.activeDiscountIds.push(discount.discountIds);
                            product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                        });
                    } else {
                        product.quantity = 0;
                        product.discountPct = 0;
                        product.promocode = null;
                        product.activeDiscountId = 0;
                        product.totalPriceDiscountId = 0;
                        product.panaceeQuantity = 0;
                        product.grossProfit = 0;
                        product.grossProfitAmount = 0;
                        product.activeDiscountIds = [];
                        product.totalPriceDiscountIds = [];
                    }
                    //Return the updated product
                    return product;
                }
            });

            clazz.create = function (resource, cartProducts) {
                var product = new clazz();
                product.id = resource.productId;
                product.discountId = resource.discountId;
                // On discount pages, discount name should be used
                product.displayName = resource.discountName !== null && resource.discountName !== undefined ? resource.discountName : resource.productName;
                product.image = resource.imagePath;
                product.price = resource.pharmacyPrice;
                product.publicPrice = resource.publicPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.nationalNumber = resource.productNumber ? resource.productNumber : resource.nationalNumber;
                product.isSellableAsSingleProduct = resource.isSellableAsSingleProduct;
                product.isSellableInStore = resource.isSellableInStore;
                product.isVipSeller = resource.isVipSeller;
                product.isSellable = resource.isSellable;
                product.productCreationDate = resource.productCreationDate;
                product.counterStatus = resource.counterStatus;
                product.counter = resource.counter;
                product.portalContractTypeCode = resource.portalContractTypeCode;
                product.maxDiscount = resource.maxDiscount;
                product.tooLate = resource.tooLate;
                product.productTypeCode = common.serverTypes.getProductType(resource.productTypeCode);
                product.grossProfit = resource.grossProfit;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.sellerName = resource.sellerName;
                product.allowSpecial = resource.allowSpecial;
                product.grossProfitAmount = resource.grossProfitAmount;
                product.expirationDate = resource.expirationDate;
                product.sellerId = resource.sellerId;
                //todo split in rental product
                product.dayPrice = resource.dayPrice;
                product.netPublicPrice = resource.netPublicPrice;
                product.publicPrice = resource.publicPrice;
                product.pharmacyPrice = resource.pharmacyPrice;
                product.rentalDeposit = resource.rentalDeposit;
                product.vat = resource.vat;
                product.imagePath = resource.imagePath;

                // Get fields from shoppingcart
                if (cartProducts) {
                    product = product.getCartFields(product, cartProducts);
                }
                return product;
            };

            return clazz;
        }
    };

    return prodFactory;
}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productOverview.$inject = ["Enums", "gettextCatalog", "sortProperties", "Paging", "$state"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverview = productOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverview(Enums, gettextCatalog, sortProperties, Paging, $state) {
    var clazz = function ProductOverview() {
        var defaults = {
            products: [],
            filter: null,
            filters: [],
            paging: null,
            sorting: null,
            productsAvailableForContext: false,
            productsAvailableForCriteria: true,
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (context) {
        var productOverview = new clazz();
        productOverview.products = [];
        productOverview.filter = null;
        productOverview.filters = [];
        productOverview.paging = Paging.create({ totalItems: 0, itemsPerPage: parseInt(window.sessionStorage.getItem('pageSize'), 10) || 24, page: 1, pageCount: 1, pageNumbers: [] });
        productOverview.sorting = getSortingByContext(context);
        return productOverview;

        function getSortingByContext(context) {

            if (context === Enums.searchContext.discount.id || context === Enums.searchContext.seller.id) {
                return {
                    enableSorting: true,
                    sortProperty: window.localStorage.getItem($state.current.name + '-sortProperty') || 'DiscountDate',
                    sortAsc: window.localStorage.getItem($state.current.name + '-sortAsc') || false,
                    properties: [sortProperties['DiscountDate'], sortProperties['Name'], sortProperties['UnitPrice']]
                };
            } else {
                return {
                    enableSorting: true,
                    sortProperty: window.localStorage.getItem($state.current.name + '-sortProperty') || 'Name',
                    sortAsc: window.localStorage.getItem($state.current.name + '-sortAsc') || true,
                    properties: [sortProperties['Name'], sortProperties['UnitPrice']]
                };
            }
        }
    };

    return clazz;
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productSearchRequest.$inject = ["Enums", "queryStringHelper"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productSearchRequest = productSearchRequest;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productSearchRequest(Enums, queryStringHelper) {
    var clazz = function ProductSearchRequest() {
        var defaults = {
            Skip: 0,
            Take: 5,
            SortByField: '',
            SortAsc: true,
            context: Enums.searchContext.none.id,
            Name: '',
            OnlyDiscounts: true,
            CategoryFilters: [],
            SellerIds: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        addCategoryFilter: function addCategoryFilter(categoryType, selectedId) {
            var item = _lodash2.default.find(this.CategoryFilters, {
                CategoryType: categoryType
            });
            if (item) {
                item.CategoryIds.push(selectedId);
            } else {
                this.CategoryFilters.push({
                    CategoryType: categoryType,
                    CategoryIds: [selectedId]
                });
            }
        }
    });

    clazz.createForHomePage = function () {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'DiscountDate';
        request.SortAsc = false;
        request.context = Enums.searchContext.discount.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = [];
        request.SellerIds = [];
        return request;
    };

    clazz.createForDiscounts = function (params, discountTypeId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.discount.id;
        request.Name = '';
        request.DiscountTypeIds = [discountTypeId];
        // TODO Make this correct again, changed for demo
        request.OnlyDiscounts = true; //queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForSearch = function (params, searchValue) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.search.id;
        request.Name = searchValue;
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForBrand = function (params, brandId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.brand.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        // add brand to CategoryFilters
        request.CategoryFilters.push({
            CategoryType: Enums.categoryType.brand.id,
            categoryIds: [brandId]
        });
        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForCategory = function (params, categoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.category.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);

        if (categoryId !== 0) {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
            // add category to CategoryFilters
            request.addCategoryFilter(Enums.categoryType.category.id, categoryId);
        } else if (params.filter !== '') {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        } else {
            request.CategoryFilters = null;
        }

        request.SellerIds = queryStringHelper.getSellerIds(params.filter);
        return request;
    };

    clazz.createForSellerProducts = function (params, sellerId, categoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.sellerProducts.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.SellerIds = [sellerId];

        if (categoryId !== 0 && categoryId) {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
            // add category to CategoryFilters
            request.addCategoryFilter(Enums.categoryType.category.id, categoryId);
        } else if (params.filter !== '') {
            request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        } else {
            request.CategoryFilters = null;
        }

        return request;
    };

    clazz.createForSellerDiscounts = function (params, sellerId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.SellerIds = [sellerId];
        request.DiscountTypeIds = queryStringHelper.getDiscountTypes(params.filter);
        return request;
    };

    clazz.createForSellerCategory = function (params, sellerId, sellerCategoryId) {
        var request = new clazz();
        request.Skip = params.skip;
        request.Take = params.take;
        request.SortByField = params.sortByField;
        request.SortAsc = params.sortAsc;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = queryStringHelper.getDiscountsOnly(params.filter);
        request.CategoryFilters = queryStringHelper.getCategoryFilters(params.filter);
        request.addCategoryFilter(Enums.categoryType.seller.id, sellerCategoryId);
        request.SellerIds = [sellerId];
        return request;
    };

    clazz.createForSellerDetailDiscounts = function (sellerId) {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'DiscountDate';
        request.SortAsc = false;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = true;
        request.CategoryFilters = [];
        request.SellerIds = [sellerId];
        return request;
    };

    clazz.createForSellerDetailProducts = function (sellerId) {
        var request = new clazz();
        request.Skip = 0;
        request.Take = 5;
        request.SortByField = 'Date';
        request.SortAsc = false;
        request.context = Enums.searchContext.seller.id;
        request.Name = '';
        request.OnlyDiscounts = false;
        request.CategoryFilters = [];
        request.SellerIds = [sellerId];
        return request;
    };

    return clazz;
}

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productSet = productSet;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productSet() {
    var clazz = function ProductSet() {
        var defaults = {
            id: null,
            quantity: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (context) {
        var productSet = new clazz();
        productSet.id = context.id;
        productSet.quantity = context.quantity;
        return productSet;
    };

    return clazz;
}

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalHistoryDetail = rentalHistoryDetail;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalHistoryDetail() {
    var clazz = function RentalHistoryDetail() {
        var defaults = {
            id: null,
            version: 0,
            productId: 0,
            productName: '',
            productImagePath: '',
            sellerArticleNumber: '',
            serialNumber: '',
            startDate: null,
            endDate: null,
            remark: '',
            deposit: 0,
            status: {},
            shippingNoteNumber: '',
            depositRefunded: null,
            depositRefundedDate: null,
            dailyRentalPrice: 0,
            totalRent: 0,
            rentPerMonth: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        calculateRentPerPeriod: function calculateRentPerPeriod(startDate, endDate) {
            if (this.status.code !== '50') {
                var daysBetween = endDate.diff(startDate, 'days') + 1;
                return daysBetween * this.dailyRentalPrice;
            }
            return 0;
        },
        isCancelled: function isCancelled() {
            return this.status.code === '50';
        }
    });

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.version = resource.version;
        item.productId = resource.productId;
        item.productName = resource.productName;
        item.productImagePath = resource.productImagePath;
        item.sellerArticleNumber = resource.sellerArticleNumber;
        item.serialNumber = resource.serialNumber;
        item.startDate = resource.startDate;
        item.endDate = resource.endDate;
        item.remark = resource.remark;
        item.status = {
            id: resource.status.id,
            code: resource.status.code,
            name: resource.status.name
        }, item.shippingNoteNumber = resource.shippingNoteNumber;
        item.deposit = resource.deposit;
        item.depositRefunded = resource.depositRefunded;
        item.depositRefundedDate = resource.depositRefundedDate;
        item.dailyRentalPrice = resource.dailyRentalPrice;
        item.isCancelled = item.isCancelled();
        if (item.isCancelled) {
            item.totalRent = 0;
            item.rentPerMonth = [];
        } else if (item.startDate && item.dailyRentalPrice) {
            var startDay = (0, _moment2.default)(item.startDate, 'YYYY-MM-DD');
            var endDay = void 0;
            if (item.endDate) {
                endDay = (0, _moment2.default)(item.endDate, 'YYYY-MM-DD');
            } else {
                endDay = (0, _moment2.default)().startOf('day');
            }
            if (!startDay.isSame(endDay)) {
                item.totalRent = item.calculateRentPerPeriod(startDay, endDay);

                var rentPerMonth = [];
                var day = (0, _moment2.default)(startDay).startOf('month');
                while (day.isSameOrBefore(endDay)) {
                    rentPerMonth.push({
                        month: (0, _moment2.default)(day)
                    });
                    day.add(1, 'month');
                }

                if ((0, _moment2.default)(day).subtract(1, 'day').isSame(endDay)) {
                    rentPerMonth.push({
                        month: (0, _moment2.default)(day)
                    });
                }

                rentPerMonth.forEach(function (i) {
                    var start = _moment2.default.max(startDay, (0, _moment2.default)(i.month).subtract(1, 'day'));
                    var end = _moment2.default.min((0, _moment2.default)(i.month).add(1, 'month').subtract(2, 'day'), endDay);
                    var rent = item.calculateRentPerPeriod(start, end);
                    var month = i.month.format('MMMM YYYY');

                    if (rent > 0) {
                        item.rentPerMonth.push({ rent: rent, month: month });
                    }
                });
            }
        }
        return item;
    };

    return clazz;
}

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalHistoryItem = rentalHistoryItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalHistoryItem() {
    var clazz = function RentalHistoryItem() {
        var defaults = {
            id: null,
            productName: '',
            productImagePath: '',
            statusName: '',
            sellerArticleNumber: '',
            startDate: null,
            endDate: null,
            remark: '',
            deposit: 0,
            depositRefunded: null,
            depositRefundedDate: null,
            dailyRentalPrice: 0,
            totalRent: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        calculateTotalRent: function calculateTotalRent() {
            if (this.statusName !== 'Geannuleerd' && this.statusName !== 'Annulé') {
                var startDay = (0, _moment2.default)(this.startDate, 'YYYY-MM-DD');
                var endDay = void 0;
                if (this.endDate) {
                    endDay = (0, _moment2.default)(this.endDate, 'YYYY-MM-DD');
                } else {
                    endDay = (0, _moment2.default)().startOf('day');
                }
                if (startDay.isSame(endDay)) {
                    return 0;
                }
                var daysBetween = endDay.diff(startDay, 'days') + 1; // =1
                return daysBetween * this.dailyRentalPrice;
            }
            return 0;
        },
        isCancelled: function isCancelled() {
            return this.statusName === 'Geannuleerd' || this.statusName === 'Annulé';
        }
    });

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.productName = resource.productName;
        item.productImagePath = resource.productImagePath;
        item.statusName = resource.statusName;
        item.sellerArticleNumber = resource.sellerArticleNumber;
        item.startDate = resource.startDate;
        item.endDate = resource.endDate;
        item.remark = resource.remark;
        item.deposit = resource.deposit;
        item.depositRefunded = resource.depositRefunded;
        item.depositRefundedDate = resource.depositRefundedDate;
        item.dailyRentalPrice = resource.dailyRentalPrice;
        if (item.startDate && item.dailyRentalPrice) {
            item.totalRent = item.calculateTotalRent();
        }
        item.isCancelled = item.isCancelled();
        return item;
    };

    return clazz;
}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalHistoryStatusItem = rentalHistoryStatusItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalHistoryStatusItem() {
    var clazz = function RentalHistoryStatusItem() {
        var defaults = {
            id: null,
            code: '',
            name: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var item = new clazz();
        item.id = resource.id;
        item.code = resource.code;
        item.name = resource.name;
        return item;
    };

    return clazz;
}

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductCategory = rentalProductCategory;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductCategory() {
    var clazz = function RentalProductCategory() {
        var defaults = {
            id: null,
            imagePath: '',
            languageId: '',
            name: '',
            endDate: null,
            sequence: 0,
            startDate: 0,
            url: '',
            code: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var rentalProductCategory = new clazz();
        rentalProductCategory.id = resource.url;
        rentalProductCategory.imagePath = resource.imagePath;
        rentalProductCategory.languageId = resource.languageId;
        rentalProductCategory.name = resource.name;
        rentalProductCategory.endDate = resource.endDate;
        rentalProductCategory.sequence = resource.sequence;
        rentalProductCategory.startDate = resource.startDate;
        rentalProductCategory.url = resource.url;
        rentalProductCategory.code = resource.code;
        return rentalProductCategory;
    };

    return clazz;
}

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


rentalProduct.$inject = ["RentalProductOverviewItem"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProduct = rentalProduct;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProduct(RentalProductOverviewItem) {
    var clazz = function RentalProduct() {
        var defaults = {
            id: 0,
            relationTypeCode: null,
            name: '',
            nationalNumber: null,
            sellerName: '',
            sellerId: 0,
            sellerBaseCodeId: 0,
            imagePath: '',
            rentalDeposit: 0,
            dayPrice: 0,
            vat: 0,
            deliveryDate: null,
            remark: null,
            address: null,
            contractPerson: null,
            phoneNumber: null,
            isSellable: false,
            quantity: 0,
            relatedRentalProducts: [],
            attachments: [],
            pharmacyPrice: 0,
            publicPrice: 0,
            deliveryByExternalPartner: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        toJSON: function toJSON() {
            return {
                productId: this.id,
                quantity: this.quantity
            };
        }
    });

    clazz.create = function (resource) {
        var product = new clazz();
        product.id = resource.productId;
        product.relationTypeCode = resource.relationTypeCode;
        product.name = resource.productName;
        product.nationalNumber = resource.nationalNumber;
        product.sellerName = resource.sellerName;
        product.sellerId = resource.sellerId;
        product.sellerBaseCodeId = resource.sellerBaseCodeId;
        product.imagePath = resource.imagePath;
        product.rentalDeposit = resource.rentalDeposit;
        product.dayPrice = resource.dayPrice;
        product.vat = resource.vat;
        product.deliveryDate = resource.deliveryDate;
        product.remark = resource.remark;
        product.address = resource.address;
        product.contractPerson = resource.contractPerson;
        product.phoneNumber = resource.phoneNumber;
        product.isSellable = resource.isSellable;
        product.quantity = 1;
        product.relatedRentalProducts = _lodash2.default.map(resource.relatedRentalProducts, function (i) {
            return RentalProductOverviewItem.create(i);
        });
        product.attachments = resource.productRentalAttachments;
        product.pharmacyPrice = resource.pharmacyPrice;
        product.publicPrice = resource.publicPrice;
        product.deliveryByExternalPartner = resource.deliveryByExternalPartner;
        return product;
    };

    return clazz;
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductOverviewItem = rentalProductOverviewItem;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductOverviewItem() {
    var clazz = function RentalProductOverviewItem() {
        var defaults = {
            id: null,
            name: '',
            discountName: '',
            displayName: '',
            message: null,
            type: '',
            image: '',
            sellerId: 0,
            sellerName: '',
            price: 0,
            nationalNumber: 0,
            rentalDeposit: 0,
            sellerBaseCodeId: 0,
            relationTypeCode: 0,
            quantity: 0,
            vat: 0,
            order: false,
            rentedFrom: null,
            pharmacyPrice: 0,
            deliveryByExternalPartner: false,
            isSellable: false
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        toJSON: function toJSON() {
            return {
                productId: this.id,
                quantity: this.quantity
            };
        },

        calculateTotalRent: function calculateTotalRent() {
            var startDay = (0, _moment2.default)(this.rentedFrom, 'YYYY-MM-DD');
            var endDay = (0, _moment2.default)().startOf('day');
            if (startDay.isSame(endDay)) {
                return 0;
            }
            var daysBetween = endDay.diff(startDay, 'days') + 1; // =1
            return daysBetween * this.dayPrice;
        }
    });

    clazz.create = function (resource) {
        var productOverview = new clazz();
        productOverview.id = resource.productId;
        productOverview.name = resource.productName;
        productOverview.displayName = resource.productName;
        productOverview.imagePath = resource.imagePath;
        productOverview.sellerId = resource.sellerId;
        productOverview.sellerName = resource.sellerName;
        productOverview.nationalNumber = resource.nationalNumber;
        productOverview.dayPrice = resource.dayPrice;
        productOverview.price = resource.dayPrice;
        productOverview.vat = resource.vat;
        productOverview.rentalDeposit = resource.rentalDeposit;
        productOverview.sellerBaseCodeId = resource.sellerBaseCodeId;
        productOverview.relationTypeCode = resource.relationTypeCode;
        productOverview.rentedFrom = resource.rentedFrom;
        productOverview.productTypeCode = resource.productTypeCode;
        productOverview.pharmacyPrice = resource.pharmacyPrice;
        productOverview.publicPrice = resource.publicPrice;
        productOverview.deliveryByExternalPartner = resource.deliveryByExternalPartner;
        productOverview.isSellable = resource.isSellable;
        if (productOverview.rentedFrom && productOverview.price) {
            productOverview.totalRent = productOverview.calculateTotalRent();
        }
        return productOverview;
    };

    return clazz;
}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductOverview = rentalProductOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductOverview() {
    var clazz = function RentalProductOverview() {

        var defaults = {
            products: [],
            filter: null,
            filters: [],
            paging: null,
            sorting: null,
            productsAvailableForContext: true,
            productsAvailableForCriteria: true,
            isLoadingInitial: false,
            isLoading: false,
            errorOccurred: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function () {
        var rentalProductOverview = new clazz();
        //todo filter
        return rentalProductOverview;
    };

    return clazz;
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductsOrder = rentalProductsOrder;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductsOrder() {
    var clazz = function RentalProductsOrder() {
        var defaults = {
            deliveryInfo: null,
            contactInfo: null,
            isLoaded: false,
            rentalProducts: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource, isLoaded) {
        var rentalProductsOrder = new clazz();
        rentalProductsOrder.deliveryInfo = resource.deliveryInfo;
        rentalProductsOrder.contactInfo = resource.contactInfo;
        rentalProductsOrder.rentalProducts = resource.rentalProducts;
        rentalProductsOrder.isLoaded = isLoaded;
        return rentalProductsOrder;
    };

    return clazz;
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerBanner = sellerBanner;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerBanner() {
    var clazz = function SellerCategory() {
        var defaults = {
            id: 0,
            darkTextColor: true,
            backgroundColor: '',
            textAlignment: 0,
            sequence: 1,
            link: null,
            content: null,
            title: null,
            media: null,
            priority: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var sellerBanner = new clazz();
        sellerBanner.id = resource.id;
        sellerBanner.darkTextColor = resource.darkTextColor;
        sellerBanner.backgroundColor = resource.backgroundColor;
        sellerBanner.textAlignment = resource.textAlignment;
        sellerBanner.sequence = resource.sequence;
        sellerBanner.link = resource.link;
        sellerBanner.content = resource.content;
        sellerBanner.title = resource.title;
        sellerBanner.media = resource.media;
        sellerBanner.priority = resource.priority;
        return sellerBanner;
    };

    return clazz;
}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerCategory = sellerCategory;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerCategory() {
    var clazz = function SellerCategory() {
        var defaults = {
            id: 0,
            name: '',
            img: '',
            categories: []
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var seller = new clazz();
        seller.id = resource.sellerId;
        seller.name = resource.sellerName;
        seller.img = resource.imagePath;
        seller.categories = _lodash2.default.map(resource.sellerCategoryBreadcrumbItems, function (cat) {
            return {
                id: cat.id,
                name: cat.name
            };
        });
        return seller;
    };

    return clazz;
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerContact = sellerContact;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerContact() {
    var clazz = function Seller() {
        var defaults = {
            id: 0,
            sellerName: '',
            sellerLogo: null,
            contactPersons: null,
            sellerAddress: null,
            contactInformation: null,
            pharmacovigilanceContactInformation: null,
            moreInfoTitle: null,
            moreInfoContent: null,
            moreInfoLinks: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var sellerContact = new clazz();
        sellerContact.id = resource.id;
        sellerContact.sellerName = resource.sellerName;
        sellerContact.sellerLogo = resource.sellerLogo;
        sellerContact.contactPersons = resource.contactPersons;
        sellerContact.sellerAddress = resource.sellerAddress;
        sellerContact.contactInformation = resource.contactInformation;
        sellerContact.pharmacovigilanceContactInformation = resource.pharmacovigilanceContactInformation;
        sellerContact.moreInfoTitle = resource.moreInfoTitle;
        sellerContact.moreInfoContent = resource.moreInfoContent;
        sellerContact.moreInfoLinks = resource.moreInfoLinks;
        return sellerContact;
    };

    return clazz;
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seller = seller;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function seller() {
    var clazz = function Seller() {
        var defaults = {
            id: 0,
            name: '',
            img: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var seller = new clazz();
        seller.id = resource.id;
        seller.name = resource.name;
        seller.img = resource.imagePath;
        seller.isFebelcoSeller = resource.isFebelcoSeller;
        seller.isVIPSeller = resource.isVIPSeller;
        seller.protocolName = resource.ProtocolName;
        seller.isVisibleInMenu = resource.isVisibleInMenu;
        seller.code = resource.code;
        return seller;
    };

    return clazz;
}

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


sellerOverview.$inject = ["Address"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerOverview = sellerOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerOverview(Address) {
    var clazz = function Seller() {
        var defaults = {
            id: 0,
            address: {},
            contactInformation: null,
            pharmacovigilanceContactInformation: null,
            displayName: '',
            sellerEmployees: '',
            sellerPageImagePath: '',
            description: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.address = resource.address ? Address.create(resource.address) : null;
        o.contactInformation = resource.contactInformation;
        o.pharmacovigilanceContactInformation = resource.pharmacovigilanceContactInformation;
        o.displayName = resource.displayName;
        o.sellerEmployees = resource.sellerEmployees;
        o.sellerPageImagePath = resource.sellerPageImagePath;
        o.description = resource.description;
        return o;
    };

    return clazz;
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPublic = sellerPublic;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerPublic() {
    var clazz = function sellerPublic() {
        var defaults = {
            id: null,
            sellerName: '',
            sellerLogo: null,
            title: '',
            leading: '',
            content: '',
            banners: null,
            links: null,
            sellerAddress: null,
            contactInformation: null,
            contactTitle: '',
            contactContent: '',
            contactLinks: null,
            sellerLogos: null,
            logoTitle: null
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.sellerName = resource.sellerName;
        o.sellerLogo = resource.sellerLogo;
        o.title = resource.title;
        o.leading = resource.leading;
        o.content = resource.content;
        o.banners = resource.banners;
        o.links = resource.links;
        o.sellerAddress = resource.sellerAddress;
        o.contactInformation = resource.contactInformation;
        o.contactTitle = resource.contactTitle;
        o.contactContent = resource.contactContent;
        o.contactLinks = resource.contactLinks;
        o.sellerLogos = resource.logos;
        o.logoTitle = resource.logoTitle;
        return o;
    };

    return clazz;
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stock = stock;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function stock() {
    var clazz = function Stock() {
        var defaults = {
            cnk: '',
            deliverQty: null,
            deliverCode: '',
            replacingCnk: '',
            stockCode: '',
            deliveryId: '',
            deliveryDate: '',
            deliveryTime: '',
            remark: ''
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.cnk = resource.cnk;
        o.deliverQty = resource.deliverQty;
        o.deliverCode = resource.deliverCode;
        o.replacingCnk = resource.replacingCnk;
        o.stockCode = resource.stockCode;
        o.deliveryId = resource.deliveryId;
        o.deliveryDate = resource.deliveryDate;
        o.deliveryTime = resource.deliveryTime;
        o.remark = resource.remark;

        return o;
    };

    return clazz;
}

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stockOverview = stockOverview;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function stockOverview() {
    var clazz = function StockOverview() {
        var defaults = {
            isLoading: false,
            errorOccurred: false,
            hasloaded: false,
            stock: null
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var o = new clazz();
        if (resource) {
            o.isLoading = resource.isLoading;
            o.errorOccurred = resource.errorOccurred;
            o.hasloaded = resource.hasloaded;
            o.stock = resource.stock;
        }
        return o;
    };

    return clazz;
}

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tenant = tenant;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function tenant() {
    var clazz = function Tenant() {
        var defaults = {
            apbNumber: '',
            name: '',
            sellerName: '',
            sellerId: '',
            secondaryAppUserKey: '',
            canViewPackages: false
        };

        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.febelcoCustomerNr = resource.febelcoCustomerNr;
        o.apbNumber = resource.apbNumber;
        o.sellerName = resource.sellerName;
        o.sellerId = resource.sellerId;
        o.name = resource.description;
        o.secondaryAppUserKey = resource.secondaryAppUserKey;
        o.canViewPackages = resource.canViewPackages;
        return o;
    };

    return clazz;
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.totals = totals;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function totals() {
    var clazz = function Totals() {
        var defaults = {
            totalPriceWithDiscount: 0,
            totalVatAmount: 0,
            vatList: [],
            totalPriceInclVat: 0,
            totalDiscount: 0
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        updateAfterSetQuantity: function updateAfterSetQuantity(updatedTotals) {
            this.totalPriceWithDiscount = updatedTotals.totalPriceWithDiscount;
            this.vatList = updatedTotals.vatList;
            this.totalPriceWithDiscountInclVat = updatedTotals.totalPriceWithDiscountInclVat;
            this.totalDiscount = updatedTotals.totalDiscount;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalVatAmount = resource.totalVatAmount;
        o.vatList = _lodash2.default.map(resource.vatList, function (i) {
            return { pct: i.vatPercentage, amount: i.vatAmount };
        });
        o.totalPriceWithDiscountInclVat = o.totalPriceWithDiscount + o.totalVatAmount;
        o.totalDiscount = resource.totalDiscountAmount;
        return o;
    };

    clazz.createFromLocalStorage = function (resource) {
        var o = new clazz();
        o.totalPriceWithDiscount = resource.totalPriceWithDiscount;
        o.totalVatAmount = resource.totalVatAmount;
        o.vatList = resource.vatList;
        o.totalPriceWithDiscountInclVat = resource.totalPriceWithDiscountInclVat;
        o.totalDiscount = resource.totalDiscount;
        return o;
    };

    return clazz;
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.user = user;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function user() {
    var clazz = function Cart() {
        var defaults = {
            id: 0,
            companyName: '',
            title: '',
            firstName: '',
            lastName: '',
            deliveryAddress: null,
            invoiceAddress: null,
            pharmacies: null,
            client_unauthorized: null,
            email: null
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {});

    clazz.create = function (resource) {
        var user = new clazz();
        user.id = resource.id;
        user.companyName = resource.companyName;
        user.title = resource.title;
        user.firstName = resource.firstName;
        user.lastName = resource.lastName;
        user.deliveryAddress = resource.deliveryAddress;
        user.invoiceAddress = resource.invoiceAddress;
        user.pharmacies = resource.pharmacies;
        user.sellerBaseEmployees = resource.sellerBaseEmployees;
        user.client_unauthorized = resource.client_unauthorized;
        user.mail = resource.mail;
        user.communicationLanguageId = resource.communicationLanguageId;
        user.phoneNumber = resource.phoneNumber;
        user.companyNumber = resource.companyNumber;
        return user;
    };

    return clazz;
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wholesaler = wholesaler;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function wholesaler() {
    var clazz = function Wholesaler() {
        var defaults = {
            id: 0,
            name: ''
        };
        _lodash2.default.extend(this, defaults);
    };

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.name = resource.name;
        o.isFebelcoCustomerWholesaler = resource.isFebelcoCustomerWholesaler;
        return o;
    };

    return clazz;
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


advertService.$inject = ["$http", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.advertService = advertService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function advertService($http, api) {

    return {
        getAll: getAll,
        getBySellerId: getBySellerId,
        getAdvertsForHomepage: getAdvertsForHomepage
    };

    function getAll() {
        return api.banners.list().$promise.then(function (banners) {
            return banners;
        });
    }

    function getBySellerId(sellerId) {
        return getAll().then(function (response) {
            // for demo purposes   
            return _lodash2.default.filter(response, function (i) {
                return i.seller === sellerId;
            });
        });
    }

    function getAdvertsForHomepage() {
        return getAll().then(function (response) {
            // for demo purposes  
            var firstSixAdverts = _lodash2.default.take(response, 6);
            return firstSixAdverts;
        });
    }
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


brandService.$inject = ["Brand", "$http", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.brandService = brandService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function brandService(Brand, $http, api) {
    return {
        getAll: getAll,
        getById: getById
    };

    function getAll() {
        return api.brands.list().$promise.then(function (resources) {
            return _lodash2.default.map(resources, function (resource) {
                return Brand.create(resource);
            });
        });
    }

    function getById(id) {
        return api.brands.get({ id: id }).$promise.then(function (resource) {
            return Brand.create(resource);
        });
    }
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


buyerBaseService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buyerBaseService = buyerBaseService;
/*@ngInject*/
function buyerBaseService(api) {
    return {
        search: search
    };

    function search(searchString, sellerId) {
        return api.buyerBaseSearch.execute({ search: searchString, sellerId: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


cartService.$inject = ["$rootScope", "api", "common", "Cart", "CartDraft", "AddedToCartInfo", "$http", "$localStorage", "ProductTypes", "OrderConfirmation", "ProductSet", "CartProduct", "Analytics", "$state", "Wholesaler"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartService = cartService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartService($rootScope, api, common, Cart, CartDraft, AddedToCartInfo, $http, $localStorage, ProductTypes, OrderConfirmation, ProductSet, CartProduct, Analytics, $state, Wholesaler) {

    //added products for analytics
    var addedProducts = [];

    return {
        getFromServer: getFromServer,
        getFromServerCheckoutCart: getFromServerCheckoutCart,
        addProduct: addProduct,
        removeProducts: removeProducts,
        changeQuantity: changeQuantity,
        checkout: checkout,
        createOrders: createOrders,
        clear: clear,
        deactivateMessage: deactivateMessage,
        getAddedToCartInfo: getAddedToCartInfo,
        quickAddProducts: quickAddProducts,
        updateCart: updateCart,
        updateCartOverview: updateCartOverview,
        getAddedProducts: getAddedProducts,
        addProductToAddedProductsList: addProductToAddedProductsList,
        addProductToCartAnalytics: addProductToCartAnalytics,
        setAddedProducts: setAddedProducts,
        reOrderProducts: reOrderProducts,
        getWholesalers: getWholesalers,
        removeSellerFromCart: removeSellerFromCart,
        getCustomerAccounts: getCustomerAccounts
    };

    function getCustomerAccounts() {
        return api.getCustomerAccounts.get().$promise.then(function (resource) {
            return resource;
        });
    }

    function setAddedProducts(products) {
        addedProducts = products;
    }

    function getAddedProducts() {
        return addedProducts;
    }

    function addProductToAddedProductsList(product) {
        if (!addedProducts.includes(product)) {
            addedProducts.push(product);
        }
    }

    function getFromServer() {
        return api.cart.get().$promise.then(function (resource) {
            var cart = Cart.create(resource);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        }).catch(function () {
            $rootScope.isShoppingCartInvalid = true;
        });
    }

    function getFromServerCheckoutCart() {
        return api.checkoutCart.get().$promise.then(function (resource) {
            var cart = Cart.create(resource);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        }).catch(function () {
            $rootScope.isShoppingCartInvalid = true;
        });
    }

    function getAddedToCartInfo(id) {
        return api.getAddedToCartInfo.get({
            id: id
        }).$promise.then(function (resource) {
            return AddedToCartInfo.create(resource);
        });
    }

    function addProduct(product) {
        var apiCall = null;
        var data = null;

        if (product.type === ProductTypes.single.clientValue) {
            apiCall = api.setProductQuantity;
            data = [{
                id: product.id,
                quantity: product.quantity
            }];
        } else if (product.type === ProductTypes.pack.clientValue) {
            apiCall = api.setProductQuantity;
            data = [{
                id: product.id,
                quantity: product.quantity
            }];
        } else if (product.type === ProductTypes.panacee.clientValue) {
            apiCall = api.setProductQuantity;
            data = _lodash2.default.map(product.included_products, function (p) {
                return {
                    id: p.id,
                    quantity: p.quantity
                };
            });
        } else {
            throw 'A product of type ' + product.type + ' cannot be used as argument of the addProduct method';
        }

        return apiCall.execute(data).$promise.then(function (data) {
            return data;
        });
    }

    function removeSellerFromCart(sellerBaseCodeId) {
        return api.removeSellerFromCart.execute(sellerBaseCodeId).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    function removeProducts(products) {

        products.forEach(function (product) {
            Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '');
            Analytics.trackCart('remove', product.displayName);
            Analytics.trackEvent('Product', 'removedFromCart', product.displayName);
            common.log.info('Analysis: product removed', product.name);
        });

        products = _lodash2.default.map(products, function (p) {
            return {
                id: p.id,
                quantity: 0
            };
        });
        products = _lodash2.default.map(products, function (o) {
            return ProductSet.create(o);
        });

        return api.quickAddProducts.execute(products).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    /* Update the cart for the shoppingcart pages */
    function updateCart(products) {

        products = products.filter(function (product) {
            return product.type !== 'panacee';
        });

        return api.quickAddProducts.execute(products).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    /* Update the cart for the product overview and detail pages */
    function updateCartOverview(products) {

        var apiCall = api.setProductQuantity;
        products = products.filter(function (product) {
            return product.type !== 'panacee';
        });

        products = _lodash2.default.map(products, function (o) {
            return ProductSet.create(o);
        });

        return apiCall.execute(products).$promise.then(function (cart) {
            return _lodash2.default.map(cart, function (o) {
                return CartProduct.create(o);
            });
        });
    }

    function changeQuantity(cart, productId, quantity) {
        cart.changeQuantity(productId, quantity);
        $localStorage.cart = cart;
        $rootScope.isShoppingCartEmpty = cart.isEmpty;
    }

    function checkout() {
        return api.checkout.execute().$promise.then(function (resource) {
            return Cart.create(resource);
        });
    }

    function createOrders(isSpecial, selectedWholeSaler, selectedCustomerAccount) {
        var selectedWholeSalerId = selectedWholeSaler ? selectedWholeSaler.id : null;
        var selectedCustomerAccountNumber = selectedCustomerAccount ? selectedCustomerAccount.number : null;
        return api.createOrders.execute({
            isSpecial: isSpecial,
            wholeSalerId: selectedWholeSalerId,
            customerAccountNumber: selectedCustomerAccountNumber
        }).$promise.then(function (orders) {
            return _lodash2.default.map(orders, function (o) {
                return OrderConfirmation.create(o);
            });
        });
    }

    function clear() {
        return api.clearCart.execute().$promise.then(function () {
            $localStorage.cart = null;
            $rootScope.isShoppingCartEmpty = true;
        });
    }

    function deactivateMessage(id) {
        return api.deactivateCartMessage.deactivate({
            messageId: id
        }).$promise.then(function (resource) {
            return resource;
        });
    }

    function quickAddProducts(products) {
        return api.quickAddProducts.execute(products).$promise.then(function (resource) {
            return resource;
        });
    }

    /* google analytics when product clicked */
    function addProductToCartAnalytics() {
        if (addedProducts.length > 0) {
            addedProducts.forEach(function (product) {
                if (product.quantity === 0) {
                    Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId,
                        location: $state.current.name
                    });
                    Analytics.trackCart('remove', product.displayName);
                    Analytics.trackEvent('Product', 'removedFromCart', product.displayName);
                    common.log.info('Analysis: product removed', product.name);
                } else {
                    Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId,
                        location: $state.current.name
                    });
                    Analytics.trackCart('add', product.displayName);
                    Analytics.trackEvent('Product', 'addedToCart', product.displayName);
                    common.log.info('Analysis: product added', product.name);
                }
            });
        }
    }

    function reOrderProducts(id) {
        return api.reOrderProducts.execute({
            id: id
        }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getWholesalers() {
        return api.wholesalers.get().$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (o) {
                return Wholesaler.create(o);
            });
        });
    }
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


categoryService.$inject = ["api", "Category", "CategoryWithSubcategories", "$cacheFactory", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoryService = categoryService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function categoryService(api, Category, CategoryWithSubcategories, $cacheFactory, gettextCatalog) {
    var cache = $cacheFactory('myCache');

    return {
        getMenuCategories: getMenuCategories,
        getById: getById,
        getCategoryTreeInArrayById: getCategoryTreeInArrayById
    };

    function getAll() {
        // var cachedCategories = cache.get('categories');
        // if (!angular.isUndefined(cachedCategories)) {
        //     return $q.when(cachedCategories);
        // }

        return api.categories.list({ ParentId: null, CategoryTypeIds: [] }).$promise.then(function (resourceList) {
            var categories = _lodash2.default.map(resourceList, function (resource) {
                return Category.create(resource);
            });

            cache.put('categories', categories);
            return categories;
        });
    }

    function getMenuCategories() {
        return api.categoriesMenu.get().$promise.then(function (resourceList) {
            var categories = _lodash2.default.map(resourceList, function (resource) {
                return Category.create(resource);
            });

            cache.put('categories', categories);
            categories = getCategoriesWithSubcategories(categories, null, 1);
            return categories;
        });
    }

    function getById(categoryId) {
        if (categoryId === 0) {
            return {
                name: gettextCatalog.getString('All products')
            };
        } else if (categoryId === undefined) {
            return null;
        }

        return api.category.get({ id: categoryId }).$promise.then(function (resource) {
            return Category.create(resource);
        });
    }

    function getCategoryTreeInArrayById(id) {
        return getAll().then(function (categories) {
            if (id === 0) {
                return categories;
            }

            var list = [];

            var category = _lodash2.default.find(categories, { id: id });
            while (category) {
                list.push({ id: category.id, name: category.name });
                category = _lodash2.default.find(categories, {
                    id: category.parentCategoryId
                });
            }

            return list;
        });
    }

    /// private stuff

    function getCategoriesWithSubcategories(categories, parentCategoryId, level) {
        var list = [];

        for (var i = 0; i < categories.length; i++) {
            var cat = categories[i];
            if (cat.parentCategoryId === parentCategoryId) {
                var newCat = {
                    id: cat.id,
                    name: cat.name,
                    subcategories: level >= 2 ? null : getCategoriesWithSubcategories(categories, cat.id, level + 1)
                };
                list.push(newCat);
            }
        }

        return list.length === 0 ? null : list;
    }
}

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


certificatesService.$inject = ["api", "config", "$stateParams", "CertificateItem", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.certificatesService = certificatesService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function certificatesService(api, config, $stateParams, CertificateItem, authService) {
    var baseUrl = config.webApiBaseUrl;

    return {
        searchCertificates: searchCertificates,
        getCoaUrl: getCoaUrl
    };

    function searchCertificates(search) {
        return api.certificates.search(search).$promise.then(function (response) {
            response.results = _lodash2.default.map(response.results, function (i) {
                return CertificateItem.create(i);
            });
            return response;
        });
    }
    function getCoaUrl(id) {
        return baseUrl + ('certificates/' + id + '/getCertificateOfAnalysis?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
    }
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


commonService.$inject = ["$rootScope", "$q", "$log", "config", "$localStorage", "Enums", "$window", "defaultLanguage", "supportedLanguages", "ProductTypes", "DiscountTypes"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonService = commonService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function commonService($rootScope, $q, $log, config, $localStorage, Enums, $window, defaultLanguage, supportedLanguages, ProductTypes, DiscountTypes /*, gettextCatalog*/) {
    return {
        log: $log,
        config: config,
        setTitle: setTitle,
        toPascalCase: toPascalCase,
        getProductNumberAndPromo: getProductNumberAndPromo,
        enums: {
            existsIdInEnum: existsIdInEnum
        },
        localization: {
            getCurrentLanguage: getCurrentLanguage,
            getDefaultLanguage: getDefaultLanguage,
            isLanguageSupported: isLanguageSupported
        },
        navigationMenu: {
            clearActiveMenu: clearActiveMenu,
            setHomeActive: setHomeActive,
            setDiscountsActive: setDiscountsActive,
            setSellersActive: setSellersActive,
            setBrandsActive: setBrandsActive,
            setProductsActive: setProductsActive,
            setNewsActive: setNewsActive
        },
        serverTypes: {
            getProductType: getProductType,
            getDiscountType: getDiscountType,
            getClientValue: getClientValue
        }
    };

    function setTitle(title) {
        $window.document.title = title;
    }

    function toPascalCase(value) {
        // TO DO : functie mag uiteindelijk gedelete worden, back-end moet ervoor gezorgd worden dat Febelco Product namen omgezet worden naar camelcase
        if (!value) {
            return '';
        }
        return value; //return value.toLowerCase().replace(/\b./g, function(a){ return a.toUpperCase(); } );
    }

    /* Enums */
    function existsIdInEnum(enumeration, id) {
        for (var property in enumeration) {
            if (enumeration.hasOwnProperty(property)) {
                if (enumeration[property].id === id) {
                    return true;
                }
            }
        }

        return false;
    }
    /* End: Enums */

    /* Localization */
    function getCurrentLanguage() {
        return window.localStorage.getItem('language') || getDefaultLanguage();
    }

    function getDefaultLanguage() {
        return defaultLanguage;
    }

    function isLanguageSupported(language) {
        for (var i = 0; i < supportedLanguages.length; i++) {
            var sl = supportedLanguages[i];
            if (language.toUpperCase() === sl.toUpperCase()) {
                return true;
            }
        }

        return false;
    }

    /* End: Localization */

    /* Navigation menu */
    function clearActiveMenu() {
        $rootScope.activeMenu = '';
    }

    function setHomeActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.home.value;
    }

    function setDiscountsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.discounts.value;
    }

    function setSellersActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.sellers.value;
    }

    function setBrandsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.brands.value;
    }

    function setProductsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.products.value;
    }

    function setNewsActive() {
        $rootScope.activeMenu = Enums.navigationMenuItems.news.value;
    }

    /* end: Navigation menu */

    /* convert server to client types */
    function getProductType(type) {
        if (type === ProductTypes.single.serverValue) {
            return ProductTypes.single.clientValue;
        } else if (type === ProductTypes.pack.serverValue) {
            return ProductTypes.pack.clientValue;
        } else if (type === ProductTypes.panacee.serverValue) {
            return ProductTypes.panacee.clientValue;
        }
        return type;
    }

    function getDiscountType(type) {
        if (type === DiscountTypes.single.serverValue) {
            return DiscountTypes.single.clientValue;
        } else if (type === DiscountTypes.pack.serverValue) {
            return DiscountTypes.pack.clientValue;
        } else if (type === DiscountTypes.panacee.serverValue) {
            return DiscountTypes.panacee.clientValue;
        }
        return type;
    }

    function getClientValue(types, serverValue) {
        var type = _lodash2.default.find(types, function (i) {
            return i.serverValue === serverValue;
        });
        return type ? type.clientValue : null;
    }
    /* END: convert server to client types */

    function getProductNumberAndPromo(productNumber, promocode) {
        var productNumberIsEmpty = !productNumber || productNumber.length <= 0;
        var promocodeIsEmpty = !promocode || promocode.length <= 0;

        if (productNumberIsEmpty && promocodeIsEmpty) {
            return '';
        }

        var productNumberLabel = 'Product number'; //gettextCatalog.getString('productNumber');
        var promocodeLabel = 'PROMO'; //gettextCatalog.getString('PROMO');

        if (promocodeIsEmpty) {
            return '(' + productNumberLabel + ': ' + productNumber + ')';
        }

        if (productNumberIsEmpty) {
            return '(' + promocodeLabel + ': ' + promocode + ')';
        }

        return '(' + productNumberLabel + ': ' + productNumber + ', ' + promocodeLabel + ': ' + promocode + ')';
    }
}

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


contractService.$inject = ["$http", "api", "Contract", "ContractDetail"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractService = contractService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function contractService($http, api, Contract, ContractDetail) {

    return {
        get: get,
        getById: getById,
        getNumberOfContracts: getNumberOfContracts
    };

    function get() {
        return api.contracts.list().$promise.then(function (response) {
            return _lodash2.default.map(response, function (i) {
                return _lodash2.default.assign({
                    "type": i.portalContractType,
                    "contracts": _lodash2.default.map(i.contracts, function (x) {
                        return Contract.create(x);
                    })
                });
            });
        });
    }

    function getById(id) {
        return api.contractDetail.get({ id: id }).$promise.then(function (response) {
            return ContractDetail.create(response);
        });
    }
    function getNumberOfContracts(sellerId) {
        return api.numberOfContracts.get({ sellerId: sellerId }).$promise.then(function (response) {
            return response.amount;
        });
    }
}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


coronaService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.coronaService = coronaService;
/*@ngInject*/
function coronaService(api) {
    return {
        setCoronaReservation: setCoronaReservation,
        getCorona: getCorona,
        vaccinsCanOrder: vaccinsCanOrder,
        canOrderVaccin: canOrderVaccin,
        allReservationsMade: allReservationsMade,
        isEnabled: isEnabled
    };

    function getCorona() {
        return api.coronaReservation.get({}).$promise.then(function (resource) {
            return resource.reservations;
        });
    }

    function vaccinsCanOrder(vaccins) {
        var vaccin = vaccins.find(function (vaccin) {
            return vaccin.amount > 0;
        });
        return vaccin === undefined ? false : true;
    }

    function allReservationsMade(vaccins) {
        return vaccins.every(amountNotZero);
    }

    function amountNotZero(vaccin) {
        return vaccin.amount !== 0;
    }

    function canOrderVaccin(vaccin) {
        return vaccin.amount === 0;
    }

    function setCoronaReservation(vaccines) {
        var vaccinesPost = [];

        vaccines.forEach(function (vaccine) {
            vaccinesPost.push({
                productNumber: vaccine.productNumber,
                amount: vaccine.amount
            });
        });

        return api.setReservationAmounts.set({
            reservations: vaccinesPost
        }).$promise.then(function (resources) {
            return resources;
        });
    }

    function isEnabled() {
        return api.enabled.get({}).$promise.then(function (resource) {
            return resource;
        });
    }
}

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


dialogService.$inject = ["$q", "$rootScope", "ngDialog", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dialogService = dialogService;
/*@ngInject*/
function dialogService($q, $rootScope, ngDialog, authService) {
    return {
        confirm: confirm,
        selectTenant: selectTenant,
        askConfirm: askConfirm,
        unsavedChanges: unsavedChanges
    };

    function confirm(scope, title, msg) {
        var deffered = $q.defer();

        var dlgScope = scope.$new(true);
        dlgScope.title = title;
        dlgScope.msg = msg;

        ngDialog.open({
            template: __webpack_require__(506),
            className: 'ngdialog ngdialog-theme-default',
            plain: true,
            showClose: true,
            scope: dlgScope,
            disableAnimation: true
        }).closePromise.then(function (result) {
            if (result.value === 1) {
                deffered.resolve();
            } else {
                deffered.reject();
            }
        });

        return deffered.promise;
    }

    function selectTenant() {
        var deffered = $q.defer();
        var dlgScope = $rootScope.$new(true);
        dlgScope.tenants = authService.customUserInfo.tenants;
        dlgScope.activeTenant = dlgScope.tenants.find(function (t) {
            return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService._user.profile.SAUK || !!t.id && t.id === parseInt(authService._user.profile.BuyerID, 10);
        });

        ngDialog.open({
            template: __webpack_require__(507),
            className: 'ngdialog ngdialog-theme-default',
            plain: true,
            showClose: true,
            scope: dlgScope,
            disableAnimation: true,
            controller: ["$scope", "common", function controller($scope, common) {
                'ngInject';

                $scope.select = function (tenant) {
                    common.log.debug('you selected tenant ' + tenant.secondaryAppUserKey);
                    $scope.closeThisDialog({ closingState: 1, tenant: tenant });
                };
            }]
        }).closePromise.then(function (result) {
            if (result.value && result.value.closingState === 1 && result.value.tenant) {
                deffered.resolve(result.value.tenant);
            } else {
                deffered.reject();
            }
        });

        return deffered.promise;
    }

    function askConfirm(title, message) {
        return ngDialog.openConfirm({
            template: '<fb-confirm-dialog message="' + message + '" message-title="' + title + '" on-cancel="closeThisDialog(\'cancel\')" on-confirm="confirm()" on-reject="closeThisDialog(\'reject\')"></fb-confirm-dialog>',
            plain: true // plain html template no url
        });
    }

    function unsavedChanges() {
        return ngDialog.openConfirm({
            template: '<fb-unsaved-changes-dialog on-discard=\"confirm()\" on-cancel=\"closeThisDialog()\"></fb-unsaved-changes-dialog>',
            plain: true // plain html template no url
        });
    }
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


discounttypeService.$inject = ["Discounttype", "$http", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.discounttypeService = discounttypeService;
/*@ngInject*/
function discounttypeService(Discounttype, $http, api) {
    return {
        get: get
    };

    function get(id) {
        return api.discounttypes.get({ id: id }).$promise.then(function (resource) {
            return Discounttype.create(resource);
        });
    }
}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


documentLibraryService.$inject = ["LibraryQuestion", "LibraryDocumentCategory", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.documentLibraryService = documentLibraryService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function documentLibraryService(LibraryQuestion, LibraryDocumentCategory, api) {
    return {
        getLibraryQuestions: getLibraryQuestions,
        getLibraryDocumentCategories: getLibraryDocumentCategories,
        getLibraryDocument: getLibraryDocument
    };

    function getLibraryQuestions(sellerId) {
        return api.libraryQuestions.get({ sellerId: sellerId }).$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (i) {
                return LibraryQuestion.create(i);
            });
        });
    }

    function getLibraryDocumentCategories(sellerId) {
        return api.libraryDocumentCategories.get({ sellerId: sellerId }).$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (i) {
                return LibraryDocumentCategory.create(i);
            });
        });
    }

    function getLibraryDocument(documentId) {
        return api.libraryDocument.get({ documentId: documentId }).$promise;
    }
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exceptionService.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exceptionService = exceptionService;
/*@ngInject*/
function exceptionService(gettextCatalog) {
    return {
        logException: logException
    };

    function logException(msg) {
        var title = gettextCatalog.getString('Error');
        'error', title, msg;
    }
}

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


helpService.$inject = ["$http", "HelpItem", "localizer", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.helpService = helpService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function helpService($http, HelpItem, localizer, authService) {
    return {
        getHelpCategories: getHelpCategories,
        getHelpSubCategory: getHelpSubCategory
    };

    function getHelpCategories() {
        var currentLanguage = localizer.getCurrentLanguage() ? localizer.getCurrentLanguage() : 'nl';
        var urlString = '';

        if (authService.isFebelcoCustomer) {
            urlString = '/assets/data/help-' + currentLanguage + '.json';
        } else {
            urlString = '/assets/data/help-nonfp-' + currentLanguage + '.json';
        }

        return $http.get(urlString).then(function (response) {
            return _lodash2.default.map(response.data.help, function (i) {
                return HelpItem.create(i);
            });
        });
    }

    function getHelpSubCategory(categoryId) {
        var currentLanguage = localizer.getCurrentLanguage() ? localizer.getCurrentLanguage() : 'nl';
        var urlString = '';

        if (authService.isFebelcoCustomer) {
            urlString = '/assets/data/help-' + currentLanguage + '.json';
        } else {
            urlString = '/assets/data/help-nonfp-' + currentLanguage + '.json';
        }

        return $http.get(urlString).then(function (response) {
            return HelpItem.create(_lodash2.default.find(response.data.help, function (item) {
                return item.categoryId === categoryId;
            }));
        });
    }
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _advertService = __webpack_require__(800);

var _brandService = __webpack_require__(801);

var _buyerBaseService = __webpack_require__(802);

var _cartService = __webpack_require__(803);

var _categoryService = __webpack_require__(804);

var _commonService = __webpack_require__(806);

var _dialogService = __webpack_require__(809);

var _discounttypeService = __webpack_require__(810);

var _documentLibraryService = __webpack_require__(811);

var _exceptionService = __webpack_require__(812);

var _localizer = __webpack_require__(815);

var _newsService = __webpack_require__(817);

var _newsOverviewService = __webpack_require__(816);

var _orderService = __webpack_require__(818);

var _productService = __webpack_require__(824);

var _queryStringHelper = __webpack_require__(825);

var _sellerService = __webpack_require__(830);

var _sellerCategoryService = __webpack_require__(829);

var _screenService = __webpack_require__(828);

var _tenantService = __webpack_require__(831);

var _textBuilder = __webpack_require__(832);

var _userService = __webpack_require__(833);

var _productOverviewService = __webpack_require__(823);

var _helpService = __webpack_require__(813);

var _partnershipsService = __webpack_require__(822);

var _contractService = __webpack_require__(807);

var _vaccinesService = __webpack_require__(834);

var _reservationCampaignService = __webpack_require__(827);

var _coronaService = __webpack_require__(808);

var _outletService = __webpack_require__(819);

var _rentalProductsService = __webpack_require__(826);

var _packagesService = __webpack_require__(820);

var _parcelService = __webpack_require__(821);

var _security = __webpack_require__(166);

var _security2 = _interopRequireDefault(_security);

var _certificatesService = __webpack_require__(805);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {authServiceProvider} from './authService';
var _module = _angular2.default.module('app.services', [_security2.default]).factory('advertService', _advertService.advertService).factory('brandService', _brandService.brandService).factory('buyerBaseService', _buyerBaseService.buyerBaseService).factory('cartService', _cartService.cartService).factory('categoryService', _categoryService.categoryService).factory('common', _commonService.commonService).factory('dialogService', _dialogService.dialogService).factory('discounttypeService', _discounttypeService.discounttypeService).factory('documentLibraryService', _documentLibraryService.documentLibraryService).factory('exceptionService', _exceptionService.exceptionService).factory('localizer', _localizer.localizer).factory('newsService', _newsService.newsService).factory('newsOverviewService', _newsOverviewService.newsOverviewService).factory('orderService', _orderService.orderService).factory('productService', _productService.productService).factory('queryStringHelper', _queryStringHelper.queryStringHelper).factory('sellerService', _sellerService.sellerService).factory('sellerCategoryService', _sellerCategoryService.sellerCategoryService).factory('screenService', _screenService.screenService).factory('tenantService', _tenantService.tenantService).factory('textBuilder', _textBuilder.textBuilder).factory('userService', _userService.userService).factory('productOverviewService', _productOverviewService.productOverviewService).factory('helpService', _helpService.helpService).factory('partnershipsService', _partnershipsService.partnershipsService).factory('contractService', _contractService.contractService).factory('outletService', _outletService.outletService).factory('rentalProductsService', _rentalProductsService.rentalProductsService).factory('vaccinesService', _vaccinesService.vaccinesService).factory('reservationCampaignService', _reservationCampaignService.reservationCampaignService).factory('coronaService', _coronaService.coronaService).factory('certificatesService', _certificatesService.certificatesService).factory('packagesService', _packagesService.packagesService).factory('parcelService', _parcelService.parcelService);
//.provider('authService', authServiceProvider);

exports.default = _module.name;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

localizer.$inject = ["gettextCatalog", "common", "$q", "$localStorage", "tmhDynamicLocale"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.localizer = localizer;

var _nl = __webpack_require__(685);

var _nl2 = _interopRequireDefault(_nl);

var _fr = __webpack_require__(684);

var _fr2 = _interopRequireDefault(_fr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function localizer(gettextCatalog, common, $q, $localStorage, tmhDynamicLocale) {
    var isLanguageLoaded = false;
    var languageChangeEvent = new Event('LanguageChange');

    gettextCatalog.setStrings('nl', _nl2.default.nl);
    gettextCatalog.setStrings('fr', _fr2.default.fr);

    return {
        addLanguageChangeEvent: addLanguageChangeEvent,
        init: init,
        getCurrentLanguage: getCurrentLanguage,
        setLanguage: setLanguage
    };

    function init(lang) {

        return setLanguage(lang);
    }

    function getCurrentLanguage() {
        return gettextCatalog.getCurrentLanguage();
    }

    function setLanguage(lang) {
        common.log.info('set language to:', lang);

        var isSameLanguage = lang === getCurrentLanguage() && isLanguageLoaded;
        if (isSameLanguage) {
            return $q.when(lang);
        }

        angular.element('html').attr('lang', lang);

        // Set the current language before the promise returns, otherwise the language is not highlighted in the footer
        gettextCatalog.setCurrentLanguage(lang);

        // set locale (for formatting of dates and currencies)
        tmhDynamicLocale.set(lang);

        // set text catalog
        common.log.info('load localization file', lang);

        // set local storage
        window.localStorage.setItem('language', lang);

        $localStorage.language = lang;
        languageChangeEvent.raise(lang);
    }

    function addLanguageChangeEvent(callback) {
        return languageChangeEvent.addHandler(callback);
    }
}

function Event(name) {
    this._name = name;
    this._callbacks = [];
}

Event.prototype = function () {
    function addHandler(cb) {
        var ctx = this;
        this._callbacks.push(cb);
        return function () {
            ctx.removeHandler(cb);
        };
    }
    function removeHandler(cb) {
        var idx = this._callbacks.findIndex(function (item) {
            return item === cb;
        });
        if (idx >= 0) {
            this._callbacks.splice(idx, 1);
        }
    }
    function raise() {
        for (var _iterator = this._callbacks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var cb = _ref;

            cb.apply(null, arguments);
        }
    }

    return {
        addHandler: addHandler,
        removeHandler: removeHandler,
        raise: raise
    };
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


newsOverviewService.$inject = ["newsService", "NewsOverview", "NewsSearchRequest", "common", "Enums", "$state", "$stateParams", "$q", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsOverviewService = newsOverviewService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsOverviewService(newsService, NewsOverview, NewsSearchRequest, common, Enums, $state, $stateParams, $q, gettextCatalog) {
    return {
        handleGetNews: handleGetNews
    };

    function handleGetNews(scope, context, defaultFilterAttr, pageSize) {
        var newsOverviewModel = NewsOverview.create(context, defaultFilterAttr, pageSize);
        return getNews(true, newsOverviewModel).then(function (model) {
            newsOverviewModel = model;
            listenForLocationChangeSuccess();
            return newsOverviewModel;
        });

        function listenForLocationChangeSuccess() {
            scope.$on('$locationChangeSuccess', function () {
                getNews(false, newsOverviewModel).then(function (model) {
                    newsOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, { location: false });
                });
            });
        }
    }

    function getNews(init, newsOverviewModel) {
        var params = getQueryStringParams(newsOverviewModel);
        var searchRequest = NewsSearchRequest.create(newsOverviewModel.context, params);
        return loadNews(init, newsOverviewModel, searchRequest, params.page);
    }

    function getQueryStringParams(newsOverviewModel) {
        var page = parseInt($stateParams.page);
        var pageSize = newsOverviewModel.paging.itemsPerPage;

        return {
            page: page,
            skip: newsOverviewModel.paging.getSkipValue(page, pageSize),
            take: pageSize,
            categoryId: $stateParams.categoryId === '0' ? null : parseInt($stateParams.categoryId),
            searchValue: $stateParams.searchValue,
            sellerId: newsOverviewModel.sellerId,
            brandId: newsOverviewModel.brandId,
            productId: newsOverviewModel.productId,
            tagId: newsOverviewModel.tagId
        };
    }

    function loadNews(init, model, searchRequest, page) {
        var promises = [];
        promises.push(newsService.getByCriteria(searchRequest));
        promises.push(init ? newsService.getCategories() : $q.when(null));

        model.errorOccurred = false;
        model.isLoadingInitial = init;

        return $q.all(promises).then(function (promiseResults) {
            var newsResult = promiseResults[0];
            var categoriesResult = promiseResults[1];
            model.paging.totalItems = newsResult.count;
            model.paging.page = page;
            model.items = newsResult.results;
            model.searchValue = $stateParams.searchValue || '';

            if (categoriesResult) {
                model.categories = categoriesResult;
                var allCategoriesText = gettextCatalog.getString('All categories');
                var allCategoriesItem = {
                    id: 0,
                    displayName: allCategoriesText
                };
                model.categories.splice(0, 0, allCategoriesItem);
                model.selectedCategory = allCategoriesItem;

                if ($stateParams.categoryId) {
                    var categoryId = parseInt($stateParams.categoryId);
                    var selectedCategory = _lodash2.default.find(model.categories, function (i) {
                        return i.id === categoryId;
                    });
                    if (selectedCategory) {
                        model.selectedCategory = selectedCategory;
                    }
                }
            }

            model.paging.update(page);

            if (init && model.items.length > 0) {
                model.isNewsAvailableForContext = true;
            }

            model.isNewsAvailableForCriteria = model.items.length > 0;

            model.isLoadingInitial = false;
            model.isLoading = false;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.errorOccurred = true;
            return model;
        });
    }
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


newsService.$inject = ["$http", "NewsItem", "api", "NewsTile", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsService = newsService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsService($http, NewsItem, api, NewsTile, Enums) {
    return {
        getById: getById,
        getByCriteria: getByCriteria,
        // getRecentNews: getRecentNews,
        // getPopularNews: getPopularNews,
        // getBySellerId: getBySellerId,
        getNewsForHomepage: getNewsForHomepage,
        getNewsForSellerPage: getNewsForSellerPage,
        getNewsForProduct: getNewsForProduct,
        getNewsForBrand: getNewsForBrand,
        getCategories: getCategories,
        getNewsSliderSettings: getNewsSliderSettings
    };

    function getById(id) {
        return api.news.get({ id: id }).$promise.then(function (resource) {
            return NewsItem.create(resource);
        });
    }

    function getByCriteria(searchRequest) {

        var params = {
            skip: searchRequest.skip,
            take: searchRequest.take,
            title: searchRequest.searchValue,
            productId: searchRequest.productId,
            sellerId: searchRequest.sellerId,
            brandId: searchRequest.brandId,
            categoryId: searchRequest.categoryId
        };

        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return searchResponse;
        });
    }

    // function getRecentNews() {
    //     return getAll().then(r => lodash.chain(r).sortBy('date').reverse().take(5).value());
    // }

    // function getPopularNews() {
    //     return getAll().then(r => lodash.chain(r).sortBy('id').take(5).value());
    // }

    // function getBySellerId(id) { 
    //     return getAll().then(r => lodash.filter(r, i => i.sellerId === id));
    // }

    function getNewsForSellerPage(id) {
        var params = {
            skip: 0,
            take: 3,
            sellerId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForHomepage() {
        var params = {
            skip: 0,
            take: 4
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForProduct(id) {
        var params = {
            skip: 0,
            take: 3,
            productId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForBrand(id, skip, take) {
        var params = {
            skip: skip,
            take: take,
            brandId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getCategories() {
        var params = {};
        return api.newsCategories.execute(params).$promise.then(function (categories) {
            return categories;
        });
    }

    // function getTags() {
    //     return $http.get('/assets/data/tags.json')
    //         .then(function(response) { 
    //             return response.data;
    //         });
    // }

    function getNewsSliderSettings() {
        return Enums.newsSliderSettings;
    }
}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


orderService.$inject = ["api", "$http", "$q", "OrderOverviewItem", "Order"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderService = orderService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function orderService(api, $http, $q, OrderOverviewItem, Order) {
    return {
        getByCriteria: getByCriteria,
        getById: getById,
        setOrderDeliveryDate: setOrderDeliveryDate
    };

    function getByCriteria(searchValue, page, itemsPerPage, sortProperty, sortAsc, sellerId) {
        var params = {
            Number: searchValue,
            Skip: itemsPerPage * (page - 1),
            Take: itemsPerPage,
            OrderBy: sortProperty,
            OrderAsc: sortAsc,
            SellerId: sellerId
        };

        return api.orderSearch.execute(params).$promise.then(function (searchResponse) {
            return {
                totalItems: searchResponse.count,
                orders: _lodash2.default.map(searchResponse.results, function (i) {
                    return OrderOverviewItem.create(i);
                })
            };
        });
    }

    function getById(id) {
        return $q.all([api.orders.get({ id: id }).$promise]).then(function (results) {
            var order = Order.create(results[0]);

            if (order.shippingNotes) {
                order.shippingNotes.forEach(function (note, i) {
                    getShippingNoteDetail(order.id, note.warehouseCode, note.shippingNoteNumber).then(function (result) {
                        order.shippingNotes[i].detail = result;
                        return result;
                    });
                });
            }

            return order;
        });
    }

    function getShippingNoteDetail(id, warehouseCode, shippingNote) {
        return api.shippingNoteSearch.execute({ id: id, warehouseCode: warehouseCode, shippingNote: shippingNote }).$promise.then(function (result) {
            return result;
        });
    }

    function setOrderDeliveryDate(order, newDeliveryDate) {
        return api.setOrderDeliveryDate.execute({ id: order.id, deliveryDate: newDeliveryDate, version: order.version }).$promise.then(function () {
            return getById(order.id).then(function (order) {
                return order;
            });
        });
    }
}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


outletService.$inject = ["api", "OutletCategory", "OutletHomePage"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletService = outletService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function outletService(api, OutletCategory, OutletHomePage) {
    return {
        getCategories: getCategories,
        getTextFields: getTextFields
    };

    function getCategories() {

        return api.outlet.get().$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse, function (i) {
                return OutletCategory.create(i);
            });
        });
    }
    function getTextFields() {
        return api.outletHomePage.get().$promise.then(function (response) {
            return OutletHomePage.create(response);
        });
    }
}

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


packagesService.$inject = ["$http"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.packagesService = packagesService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function packagesService($http) {
    //, PackageItem
    return {
        getRecentOrders: getRecentOrders,
        getOrders: getOrders,
        getOrderTypes: getOrderTypes,
        getPackageTypes: getPackageTypes,
        validateContact: validateContact,
        getStateHistory: getStateHistory,
        getById: getById,
        getContactTypeName: getContactTypeName,
        getOrderStateContext: getOrderStateContext,
        getOrderStateIcon: getOrderStateIcon
    };

    function getContactTypeName(id) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var orderType = response.data.orderTypes.find(function (i) {
                return i.id === id;
            });
            return orderType ? orderType.name : null;
        });
    }

    function getOrderStateContext(code) {
        var context = void 0;

        switch (code) {
            case 'READY':
                context = 'secondary';
                break;
            case 'PICKEDUP':
                context = 'info';
                break;
            case 'DEPOT':
                context = 'info';
                break;
            case 'TRANSIT':
                context = 'info';
                break;
            case 'DELIVERED':
                context = 'success';
                break;
            case 'SIGNED':
                context = 'success';
                break;

            default:
                context = 'success';
            //
        }
        return context;
    }

    function getOrderStateIcon(code) {
        var icon = void 0;

        switch (code) {
            case 'READY':
                icon = 'ico-truck';
                break;
            case 'PICKEDUP':
                icon = 'ico-truck';
                break;
            case 'DEPOT':
                icon = 'ico-truck';
                break;
            case 'TRANSIT':
                icon = 'ico-truck';
                break;
            case 'DELIVERED':
                icon = 'ico-truck';
                break;
            case 'SIGNED':
                icon = 'ico-truck';
                break;

            default:
                icon = 'ico-truck';
            //
        }

        return icon;
    }

    function getRecentOrders() {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.orders.results.slice(0, 2);
        });
    }

    function getOrders() {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.orders.results;
        });
    }

    function validateContact(customerNumber, licenseNumber) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            return response.data.contacts.find(function (i) {
                return i.customerNumber === customerNumber && i.licenseNumber === licenseNumber;
            });
        });
    }

    function getStateHistory(id) {
        ///api/pod/{id:int}/stateHistory 
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var stateHistory = void 0;
            stateHistory = response.data.stateHistory.find(function (i) {
                return i.id === id;
            });
            if (!stateHistory) {
                stateHistory = response.data.stateHistory.find(function (i) {
                    return i.id === 6;
                });
            }

            return stateHistory.stateHistory;
        });
    }

    function getOrderTypes() {
        ///api/pod/orderTypes 
        var urlString = '/assets/data/packages.json';
        return $http.get(urlString).then(function (response) {
            return response.data.orderTypes.results;
        });
    }

    function getPackageTypes() {
        ///api/pod/packageTypes 
        var urlString = '/assets/data/packages.json';
        return $http.get(urlString).then(function (response) {
            //return lodash.map(response.data.packages, i => PackageItem.create(i));
            return response.data.packageTypes.results;
        });
    }

    function getById(id) {
        var urlString = '/assets/data/packages.json';

        return $http.get(urlString).then(function (response) {
            var orders = response.data.orders.results;
            var order = _lodash2.default.find(orders, function (i) {
                return i.id === id;
            });

            if (!order) {
                order = _lodash2.default.find(orders, function (i) {
                    return i.id === 3;
                });
            }

            return order;
        });
    }
}

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


parcelService.$inject = ["api", "config", "$stateParams", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parcelService = parcelService;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function parcelService(api, config, $stateParams, authService) {
    var packageLineNumber = 1;
    var insuranceLineNumber = 2;

    return {
        init: init,
        validateReceiver: validateReceiver,
        getOrderTypes: getOrderTypes,
        add: add,
        get: get,
        search: search,
        getRecentOrders: getRecentOrders,
        getLabelDownloadUrl: getLabelDownloadUrl,
        getStateHistory: getStateHistory,
        getOrderStateContext: getOrderStateContext,
        getOrderStateIcon: getOrderStateIcon,
        cancel: cancel
    };

    function init() {
        var _this = this;

        if (!this.podPackageTypes) {
            return getPackageTypes().then(function (response) {
                return _this.podPackageTypes = response;
            });
        }
    }

    function add(orderTypeId, parcelAdd) {
        return api.podOrderAdd.execute({ orderTypeId: orderTypeId }, parcelAdd).$promise.then(function (resource) {
            return resource;
        });
    }

    function validateReceiver(licenseNumber) {
        return api.podValidateContact.get({ licenseNumber: licenseNumber }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getOrderTypes() {
        return api.podOrderTypes.get().$promise.then(function (resource) {
            return resource;
        });
    }

    function getPackageTypes(customerNumber) {
        return api.podPackageTypes.get({ customerNumber: customerNumber }).$promise.then(function (resource) {
            return resource;
        });
    }

    function get(id) {
        return api.pod.get({ id: id }).$promise.then(function (result) {
            result.lines = result.lines.map(function (line) {
                var packageInvoiceLine = line.invoiceLines.find(function (invoiceLine) {
                    return invoiceLine.lineNumber === packageLineNumber;
                });
                var insuranceInvoiceLine = line.invoiceLines.find(function (invoiceLine) {
                    return invoiceLine.lineNumber === insuranceLineNumber;
                });
                line.isFree = packageInvoiceLine ? packageInvoiceLine.isFree : null;
                line.packageInvoiceAmount = packageInvoiceLine ? packageInvoiceLine.invoiceAmount : null;
                line.insuranceInvoiceAmount = insuranceInvoiceLine ? insuranceInvoiceLine.invoiceAmount : null;
                return line;
            });
            return result;
        });
    }

    function getRecentOrders() {
        var search = {
            dateFrom: (0, _moment2.default)().add(-6, 'months').format('YYYY-MM-DD'),
            take: 10
        };
        return api.podSearch.search(search).$promise.then(function (resource) {
            return resource.results;
        });
    }

    function search(search) {
        return api.podSearch.search(search).$promise.then(function (resource) {
            return resource;
        });
    }

    function getLabelDownloadUrl(id) {
        return config.webApiBaseUrl + ('pod/' + id + '/downloadLabel?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
    }

    function getStateHistory(id) {
        return api.podLineStateHistory.get({ lineId: id }).$promise.then(function (resource) {
            return resource;
        });
    }

    function cancel(orderTypeId, lineIds) {
        return api.podOrderDetail.cancel({ orderTypeId: orderTypeId }, lineIds).$promise.then(function (resource) {
            return resource;
        });
    }

    function getOrderStateContext(code) {
        var context = void 0;

        switch (code) {
            case 'CREATED':
                context = 'secondary';
                break;
            case 'REG':
                context = 'secondary';
                break;
            case 'PICK':
                context = 'info';
                break;
            case 'TRANSIT':
                context = 'info';
                break;
            case 'TOURDEL':
                context = 'info';
                break;
            case 'DELIV':
                context = 'success';
                break;
            case 'ANO':
                context = 'error';
                break;
            case 'CANCEL':
                context = 'error';
                break;

            default:
                context = 'success';
        }
        return context;
    }

    function getOrderStateIcon(code) {
        var icon = void 0;

        switch (code) {
            case 'CREATED':
                icon = 'ico-truck';
                break;
            case 'REG':
                icon = 'ico-truck';
                break;
            case 'PICK':
                icon = 'ico-truck';
                break;
            case 'TRANSIT':
                icon = 'ico-truck';
                break;
            case 'TOURDEL':
                icon = 'ico-truck';
                break;
            case 'DELIV':
                icon = 'ico-truck';
                break;
            case 'ANO':
                icon = 'ico-truck';
                break;
            case 'CANCEL':
                icon = 'ico-truck';
                break;

            default:
                icon = 'ico-truck';
        }

        return icon;
    }
}

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


partnershipsService.$inject = ["Partnership", "$http", "api", "PartnershipOverview", "PartnershipDetail", "Enums", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.partnershipsService = partnershipsService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function partnershipsService(Partnership, $http, api, PartnershipOverview, PartnershipDetail, Enums, authService) {

    return {
        getAllTemp: getAllTemp,
        // getPartnershipsForSellerHomepage: getPartnershipsForSellerHomepage,
        getAll: getAll,
        getById: getById,
        init: init,
        getGallerySliderSettings: getGallerySliderSettings
    };

    function init(pageSize) {
        return PartnershipOverview.create(pageSize);
    }

    function getAllTemp(model) {
        return $http.get('/assets/data/partnerships.json').then(function (resource) {
            _lodash2.default.map(resource.data.results, function (result) {
                model.partnerships.push(result);
            });
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.paging.totalItems = resource.data.count;
            model.paging.update(1);
            return model;
        });
    }

    function getAll(model, searchRequest, page) {

        model.errorOccurred = false;
        model.isLoadingInitial = true;

        var params = {
            skip: model.paging.getSkipValue(page, searchRequest.take),
            take: searchRequest.take,
            sellerId: searchRequest.sellerId,
            title: searchRequest.title
        };

        return api.partnerships.list(params).$promise.then(function (resource) {
            _lodash2.default.map(resource.results, function (result) {
                model.partnerships.push(result);
            });
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.paging.totalItems = resource.count;
            model.paging.update(page);
            model.paging.page = page;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.errorOccurred = true;
            return model;
        });
    }

    function getById(id) {
        return api.partnerships.get({ id: id }).$promise.then(function (resource) {
            if (authService.isSeller) {
                return PartnershipDetail.create(resource);
            }
            return api.shoppingCartProducts.get({}).$promise.then(function (cartProducts) {
                return PartnershipDetail.create(resource, cartProducts);
            });
        });
    }

    function getGallerySliderSettings() {
        return Enums.partnershipGallerySliderSettings;
    }
}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productOverviewService.$inject = ["productService", "ProductOverview", "ProductSearchRequest", "ProductFilterRequest", "Filter", "common", "Enums", "FilterCategory", "$stateParams", "$q", "$state", "categoryService", "sellerService", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productOverviewService = productOverviewService;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productOverviewService(productService, ProductOverview, ProductSearchRequest, ProductFilterRequest, Filter, common, Enums, FilterCategory, $stateParams, $q, $state, categoryService, sellerService, gettextCatalog) {
    return {
        init: init,
        loadProducts: loadProducts,
        getProductsForHomepage: getProductsForHomepage,
        getProductsByDiscounts: getProductsByDiscounts,
        getProductsBySearchValue: getProductsBySearchValue,
        getProductsByBrand: getProductsByBrand,
        getProductsByCategory: getProductsByCategory,
        getDiscountsBySeller: getDiscountsBySeller,
        getSellerProducts: getSellerProducts,
        getSellerDiscounts: getSellerDiscounts,
        getProductsBySellerCategory: getProductsBySellerCategory,
        getSellerDetailDiscounts: getSellerDetailDiscounts,
        getSellerDetailProducts: getSellerDetailProducts,
        getProductSliderSettings: getProductSliderSettings,
        getOutletProducts: getOutletProducts,
        setProductOverviewModel: setProductOverviewModel,
        getProductOverviewModel: getProductOverviewModel,
        getCustomCategory: getCustomCategory
    };

    function init(context) {
        return ProductOverview.create(context);
    }
    function getCustomCategory() {
        var cat = FilterCategory.create({
            id: '0',
            name: 'Special Discounts',
            isHierarchical: false,
            isCollapsed: false,
            isLink: true,
            isSellerCategory: false,
            initialLimit: 15,
            limit: 15,
            items: [{ id: 0,
                name: 'Black Friday',
                parentCategoryId: null,
                parents: [],
                isSelected: $stateParams.filter.indexOf('10_0') !== -1
            }],
            context: 10,
            order: 0
        });
        return cat;
    }
    function loadProducts(init, loadFilter, model, searchRequest, filterRequest, page, outlet) {
        var promises = [];

        if (outlet) {
            promises.push(productService.getByCriteriaForOutlet(searchRequest));
        } else if (filterRequest.SellerId) {
            promises.push(productService.getByCriteria(searchRequest));
            promises.push(loadFilter ? productService.getFilter(filterRequest) : $q.when(null));
            promises.push(categoryService.getById($stateParams.categoryId));
            promises.push(sellerService.getSellerTotalPriceDiscounts($stateParams.sellerId));
        } else {
            promises.push(productService.getByCriteria(searchRequest));
            promises.push(loadFilter ? productService.getFilter(filterRequest) : $q.when(null));
            promises.push(categoryService.getById($stateParams.categoryId));
        }

        model.errorOccurred = false;
        model.isLoadingInitial = init;
        model.isLoading = true;

        //TODO: when query string filter param is available and init, then get products without filter and with filter 
        return $q.all(promises).then(function (promiseResults) {
            var productsResult = promiseResults[0];
            var filtersResult = promiseResults[1];
            var categoryResult = promiseResults[2];
            var totalPriceDiscounts = promiseResults[3];
            var test = (0, _moment2.default)().isSame('2018-11-23', 'day');
            if (searchRequest.context === Enums.searchContext.discount.id && filtersResult && filtersResult.filterCategories && test) {
                filtersResult.filterCategories.unshift(getCustomCategory());
            }
            model.paging.totalItems = productsResult.totalItems;
            model.paging.page = page;
            model.products = productsResult.products;
            model.category = categoryResult === null ? { name: gettextCatalog.getString('All products') } : categoryResult;
            model.totalPriceDiscounts = totalPriceDiscounts;
            if (filtersResult) {
                model.filter = filtersResult;
            }

            model.paging.update(page);
            if (model.filter) {
                model.filter.markFilterCheckboxesAsSelected($stateParams.filter);
                model.filter.setSelectedFilters($stateParams.filter);
            }

            if (model.products.length > 0) {
                model.productsAvailableForContext = true;
            }

            model.productsAvailableForCriteria = model.products.length > 0;
            model.isLoadingInitial = false;
            model.isLoading = false;
            return model;
        }).catch(function () {
            model.isLoadingInitial = false;
            model.isLoading = false;
            model.errorOccurred = true;
            return model;
        });
    }

    function getQueryStringParams(productOverviewModel, defaultSortProperty) {
        var page = parseInt($stateParams.page);
        var pageSize = parseInt(window.sessionStorage.getItem('pageSize')) || parseInt($stateParams.pageSize);
        var sortByField = null;
        var sortAsc = null;
        //set sorting and check localstorage     
        if (window.localStorage.getItem($state.current.name + '-sortProperty')) {
            sortByField = window.localStorage.getItem($state.current.name + '-sortProperty');
        } else {
            sortByField = $stateParams.sortProperty || defaultSortProperty;
        }

        if (window.localStorage.getItem($state.current.name + '-sortAsc')) {
            sortAsc = window.localStorage.getItem($state.current.name + '-sortAsc');
        } else {
            sortAsc = $stateParams.sortAsc;
        }

        return {
            page: page,
            skip: productOverviewModel.paging.getSkipValue(page, pageSize),
            take: pageSize,
            sortByField: sortByField,
            sortAsc: sortAsc,
            filter: $stateParams.filter
        };
    }

    function getProductsForHomepage(init, productOverviewModel) {
        common.log.info('getProductsForHomepage');
        var searchRequest = ProductSearchRequest.createForHomePage();
        var filterRequest = ProductFilterRequest.createForHomePage();
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getProductsByDiscounts(init, productOverviewModel, discountTypeId) {
        common.log.info('getProductsByDiscounts');
        var params = getQueryStringParams(productOverviewModel, 'DiscountDate');
        var searchRequest = ProductSearchRequest.createForDiscounts(params, discountTypeId);
        var filterRequest = ProductFilterRequest.createForDiscounts(discountTypeId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsBySearchValue(init, productOverviewModel, searchValue) {
        common.log.info('getProductsBySearchValue');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSearch(params, searchValue);
        var filterRequest = ProductFilterRequest.createForSearch(searchValue);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsByBrand(init, productOverviewModel, brandId) {
        common.log.info('getProductsByBrand');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForBrand(params, brandId);
        var filterRequest = ProductFilterRequest.createForBrand(brandId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsByCategory(init, productOverviewModel, categoryId) {
        common.log.info('getProductsByCategory');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForCategory(params, categoryId);
        var filterRequest = ProductFilterRequest.createForCategory(categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getDiscountsBySeller(init, productOverviewModel, sellerId) {
        common.log.info('getDiscountsBySeller');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSeller(params, sellerId);
        var filterRequest = ProductFilterRequest.createForSeller(sellerId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getOutletProducts(init, productOverviewModel, sellerId, categoryId) {
        common.log.info('getSellerProducts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerProducts(params, sellerId, categoryId);
        var filterRequest = ProductFilterRequest.createForSellerProducts(sellerId, categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page, true);
    }

    function getSellerProducts(init, productOverviewModel, sellerId, categoryId) {
        common.log.info('getSellerProducts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerProducts(params, sellerId, categoryId);
        var filterRequest = ProductFilterRequest.createForSellerProducts(sellerId, categoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getSellerDiscounts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDiscounts');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerDiscounts(params, sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDiscounts(sellerId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getProductsBySellerCategory(init, productOverviewModel, sellerId, sellerCategoryId) {
        common.log.info('getProductsBySellerCategory');
        var params = getQueryStringParams(productOverviewModel, 'Name');
        var searchRequest = ProductSearchRequest.createForSellerCategory(params, sellerId, sellerCategoryId);
        var filterRequest = ProductFilterRequest.createForSellerCategory(sellerId, sellerCategoryId);
        return loadProducts(init, true, productOverviewModel, searchRequest, filterRequest, params.page);
    }

    function getSellerDetailDiscounts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDetailDiscounts');
        var searchRequest = ProductSearchRequest.createForSellerDetailDiscounts(sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDetailDiscounts(sellerId);
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getSellerDetailProducts(init, productOverviewModel, sellerId) {
        common.log.info('getSellerDetailProducts');
        var searchRequest = ProductSearchRequest.createForSellerDetailProducts(sellerId);
        var filterRequest = ProductFilterRequest.createForSellerDetailDiscounts(sellerId);
        return loadProducts(init, false, productOverviewModel, searchRequest, filterRequest, 0);
    }

    function getProductSliderSettings() {
        return Enums.productSliderSettings;
    }

    function setProductOverviewModel(productOverviewModel) {
        this.productOverviewModel = productOverviewModel;
    }

    function getProductOverviewModel() {
        return this.productOverviewModel;
    }
}

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


productService.$inject = ["$http", "ProductOverviewItem", "Product", "Filter", "$q", "$cacheFactory", "api", "ProductSearchRequest", "Stock", "Upload", "config", "FastOrderProduct", "ProductDiscount", "$stateParams", "MediPimData", "NewsTile", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productService = productService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productService($http, ProductOverviewItem, Product, Filter, $q, $cacheFactory, api, ProductSearchRequest, Stock, Upload, config, FastOrderProduct, ProductDiscount, $stateParams, MediPimData, NewsTile, authService) {
    var cache = $cacheFactory('filterCache');

    return {
        get: get,
        getFilter: getFilter,
        getByCriteria: getByCriteria,
        getSearchResults: getSearchResults,
        searchProducts: searchProducts,
        uploadProductList: uploadProductList,
        getProductStock: getProductStock,
        getProductDiscounts: getProductDiscounts,
        calculateGrossProfit: calculateGrossProfit,
        calculateGrossProfits: calculateGrossProfits,
        calculateGrossProfitWithoutDiscount: calculateGrossProfitWithoutDiscount,
        calculateGrossProfitAmounts: calculateGrossProfitAmounts,
        calculateGrossProfitAmount: calculateGrossProfitAmount,
        calculateGrossProfitAmountWithoutDiscount: calculateGrossProfitAmountWithoutDiscount,
        calculateGrossProfitAmountWithDiscount: calculateGrossProfitAmountWithDiscount,
        formatProductDiscount: formatProductDiscount,
        getByCriteriaForOutlet: getByCriteriaForOutlet,
        getProductMedipimdata: getProductMedipimdata
    };

    function get(id) {
        var promises = [];
        promises.push(api.products.get({ id: id }).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        } else {
            promises.push(Promise.resolve());
        }
        var params = {
            skip: 0,
            take: 3,
            productId: id
        };
        promises.push(api.newsSearch.execute(params).$promise);
        promises.push(api.productDiscounts.get({ productId: id }).$promise);

        return $q.all(promises).then(function (results) {
            var product = results[0];
            var cartProducts = results[1];
            var topNewsitems = _lodash2.default.map(results[2].results, function (i) {
                return NewsTile.create(i);
            });
            var productDiscounts = formatProductDiscount(ProductDiscount.create(results[3]));

            var prod = Product.getClass().create(product, cartProducts, null, product.productTypeCode, topNewsitems, productDiscounts);
            prod.grossProfit = calculateGrossProfit(prod);
            prod.grossProfitAmount = calculateGrossProfitAmount(prod);
            calculateGrossProfits(prod.included_products);
            calculateGrossProfitAmounts(prod.included_products);
            prod.shoppingCartProducts = cartProducts;
            return prod;
        });
    }
    function getProductMedipimdata(productId) {
        return api.productMedipim.getMedipimData({ productId: productId }).$promise.then(function (response) {
            return MediPimData.create(response);
        });
    }
    function getProductStock(model, productNumber, quantity) {
        return api.productStock.get({ productNumber: productNumber, quantity: quantity }).$promise.then(function (response) {
            model.stock = Stock.create(response);
            return model;
        });
    }

    function getProductDiscounts(productId) {
        return api.productDiscounts.get({ productId: productId }).$promise.then(function (response) {
            return ProductDiscount.create(response);
        });
    }

    function getByCriteria(searchRequest) {
        var promises = [];
        promises.push(api.productSearch.search(searchRequest).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        } else {
            promises.push(Promise.resolve());
        }
        return $q.all(promises).then(function (results) {
            var searchResponse = results[0];
            var cartProducts = results[1];
            var productResources = searchResponse.results;

            var products = _lodash2.default.map(productResources, function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts, searchRequest.context);
            });
            calculateGrossProfits(products);
            calculateGrossProfitAmounts(products);
            return {
                totalItems: searchResponse.count,
                products: products,
                filters: null
            };
        });
    }
    function getByCriteriaForOutlet(searchRequest) {
        var promises = [];
        promises.push(api.outletProductsSearch.search(searchRequest).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        }
        return $q.all(promises).then(function (results) {
            var searchResponse = results[0];
            var cartProducts = results[1];
            var productResources = searchResponse.results;

            var products = _lodash2.default.map(productResources, function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts, searchRequest.context);
            });
            calculateGrossProfits(products);
            calculateGrossProfitAmounts(products);
            return {
                totalItems: searchResponse.count,
                products: products,
                filters: null
            };
        });
    }
    function getFilter(params) {

        var cachedFilter = void 0;
        var cachedFilterDate = void 0;

        //do not chache te filter
        if (!params.IsDiscountView && params.CacheFilter) {
            cachedFilter = cache.get('product-filters?sellerId=' + params.SellerId + '&context=' + params.context + '&isDiscountView=' + params.IsDiscountView + '&lang=' + $stateParams.language);
            cachedFilterDate = cache.put('cachedFilterDate', (0, _moment2.default)());
        }

        if (cachedFilter) {

            // clear the filter if older than one day
            if (cachedFilterDate.diff((0, _moment2.default)().subtract(1, 'days'), 'days') > 1) {
                cachedFilter = null;
                cachedFilterDate = null;
            }

            return Filter.create(cachedFilter);
        } else {
            return api.productFilter.get(params).$promise.then(function (response) {

                if (!params.IsDiscountView && params.CacheFilter) {
                    cache.put('product-filters?sellerId=' + params.SellerId + '&context=' + params.context + '&isDiscountView=' + params.IsDiscountView + '&lang=' + $stateParams.language, response);
                    cache.put('cachedFilterDate', (0, _moment2.default)());
                }

                return Filter.create(response);
            });
        }
    }

    function getSearchResults(searchValue) {
        var searchRequest = ProductSearchRequest.createForSearch({ skip: 0, take: 3, sortAsc: true, filter: '' }, searchValue);
        return this.getByCriteria(searchRequest).then(function (resources) {
            var mappedItems = _lodash2.default.map(resources.products, function (p) {
                return {
                    id: p.id,
                    name: p.displayName,
                    image: p.image,
                    discountId: p.discountId
                };
            });

            return {
                totalItems: resources.totalItems,
                products: mappedItems
            };
        });
    }

    /* Products search home and fast order*/
    function searchProducts(searchString, take) {
        return api.searchProduct.execute({ search: searchString, take: take }).$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (o) {
                return Product.getClass().create(o);
            });
        });
    }

    /* Product list upload fast order page */
    function uploadProductList(file) {
        return Upload.upload({
            url: config.webApiBaseUrl + 'shoppingcart/UploadProductList',
            data: { file: file }
        }).then(function (result) {
            return _lodash2.default.map(result.data, function (o) {
                return FastOrderProduct.create(o);
            });
        });
    }

    function calculateGrossProfits(products) {
        products.forEach(function (product) {
            product.grossProfit = calculateGrossProfit(product);
        });
    }

    function calculateGrossProfit(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.discountPct ? (product.price !== 0 ? product.price : 0) * ((100 - product.discountPct) / 100) : product.price;
        return (publicPrice === 0 ? 0 : (publicPrice - pharmacyPrice) / publicPrice * 100).toFixed(0);
    }

    function calculateGrossProfitWithoutDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.price || 0;
        return (publicPrice === 0 ? 0 : (publicPrice - pharmacyPrice) / publicPrice * 100).toFixed(0);
    }
    function calculateGrossProfitAmounts(products) {
        products.forEach(function (product) {
            product.grossProfitAmount = calculateGrossProfitAmount(product);
        });
    }

    function calculateGrossProfitAmountWithoutDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.price || 0;
        var grossProfitAmount = (publicPrice === 0 ? 0 : publicPrice - pharmacyPrice) * product.quantity;
        return grossProfitAmount;
    }
    function calculateGrossProfitAmount(product) {
        return product.discountPct > 0 ? calculateGrossProfitAmountWithDiscount(product) : calculateGrossProfitAmountWithoutDiscount(product);
    }
    function calculateGrossProfitAmountWithDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.discountPct ? (product.price !== 0 ? product.price : 0) * ((100 - product.discountPct) / 100) : product.price;
        var grossProfitAmount = (publicPrice === 0 ? 0 : publicPrice - pharmacyPrice) * product.quantity;
        return grossProfitAmount;
    }

    function formatProductDiscount(discount) {

        //if there are no product discounts return the totalPriceDiscounts, else this won't be shown
        if (discount.allProductDiscounts.length === 0) {
            return [discount.totalPriceDiscounts];
        }

        var groupedProductDiscounts = _lodash2.default.groupBy(discount.allProductDiscounts, 'sellerBaseCodeId');

        /* add totalprice discount to the correct group or create a new group when none is found */
        discount.totalPriceDiscounts.forEach(function (totalPriceDiscount) {
            if (groupedProductDiscounts[totalPriceDiscount.sellerCodeId]) {
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId].push(totalPriceDiscount);
            } else {
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId] = [];
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId].push(totalPriceDiscount);
            }
        });

        return _lodash2.default.values(groupedProductDiscounts);
    }
}

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

queryStringHelper.$inject = ["common", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.queryStringHelper = queryStringHelper;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function queryStringHelper(common, Enums) {
    return {
        getFilterParam: getFilterParam,
        getCategoryFilters: getCategoryFilters,
        getSellerIds: getSellerIds,
        getDiscountsOnly: getDiscountsOnly,
        getSelectedIdsFromQueryString: getSelectedIdsFromQueryString,
        getDiscountTypes: getDiscountTypes
    };

    // formats the selected filters into a query string parameter
    function getFilterParam(filterCategories, categoryId, selectedId) {
        var param = '';
        angular.forEach(filterCategories, function (filterCategory) {

            // for non-hierarchical lists: add all selected id's
            // for hierarchical lists: add only 1 id (the one at the lowest level)
            // for hierarchical lists: the parent id might be set, this is passed in the selectedId argument
            if (filterCategory.id) if (categoryId && filterCategory.id === categoryId) {
                // set the query string param from the arguments, not from the selected items in filterCategory
                if (selectedId <= 0) {
                    // don't add the category to the query string param
                } else {
                    if (param.length > 0) {
                        param += '__';
                    }

                    param += categoryId;
                    param += '_' + selectedId;
                }
            } else {
                var hasAnySelectedItem = null;

                if (filterCategory.isHierarchical) {
                    hasAnySelectedItem = _lodash2.default.some(filterCategory.items, { isSelected: true });
                    angular.forEach(filterCategory.items, function (item) {
                        if (!hasAnySelectedItem) {
                            hasAnySelectedItem = _lodash2.default.some(item.children, { isSelected: true });
                            angular.forEach(item.children, function (item) {
                                if (!hasAnySelectedItem) {
                                    hasAnySelectedItem = _lodash2.default.some(item.children, { isSelected: true });
                                }
                            });
                        }
                    });
                } else {
                    hasAnySelectedItem = _lodash2.default.some(filterCategory.items, { isSelected: true });
                }

                if (hasAnySelectedItem) {
                    if (param.length > 0) {
                        param += '__';
                    }
                    param += filterCategory.id;

                    // if the category is hierarchical add the selected child id's
                    if (filterCategory.isHierarchical) {
                        angular.forEach(filterCategory.items, function (item) {
                            var hasChildrenSelected = false;
                            // set childcategories in the params
                            angular.forEach(item.children, function (child) {
                                if (child.isSelected) {
                                    param += '_' + child.id;
                                    hasChildrenSelected = true;
                                }
                                angular.forEach(child.children, function (child) {
                                    if (child.isSelected) {
                                        param += '_' + child.id;
                                        hasChildrenSelected = true;
                                    }
                                });
                            });

                            // set the parentcategories in the params
                            if (item.isSelected && !hasChildrenSelected) {
                                param += '_' + item.id;
                            }
                            if (item.isSelected && filterCategory.isSellerCategory && !hasChildrenSelected) {
                                param += '_s';
                            }
                        });
                    } else {
                        angular.forEach(filterCategory.items, function (item) {
                            if (item.isSelected) {
                                param += '_' + item.id;
                                if (filterCategory.isSellerCategory) {
                                    param += '_s';
                                }
                            }
                        });
                    }
                }

                //if the category has children
                // filterCategory.items.forEach((categoryFilter) => {
                //     categoryFilter.children.forEach((child) => {

                //     });
                // });
            }
        });

        return param;
    }

    // parse the query string parameter into an array of category filters, 
    // which can be passed to the product search API call
    function getCategoryFilters(queryStringParam) {
        //TODO: validate
        var categoryFilters = [];

        if (!queryStringParam) {
            return categoryFilters;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');
            var categoryType = values[0];
            // var isCategoryType = GetIsCategoryType(categoryType);
            // var isSellerCategoryType = GetIsSellerCategoryType(categoryType);
            // isSellerCategoryType
            // if(values[2] && values[2]=== 's'){
            //     isCategoryType = true;
            //     values.pop();
            // }
            // if (!isCategoryType) {
            //     return categoryFilters;
            // }
            var categoryIsSeller = CategoryIsSeller(categoryType);

            if (categoryIsSeller) {
                return categoryFilters;
            }

            var categoryIds = [];
            for (var i = 1; i <= values.length - 1; i++) {
                if (values[i] !== 's') {
                    var id = parseInt(values[i]);
                    categoryIds.push(id);
                }
            }

            var categoryFilter = { CategoryType: categoryType, CategoryIds: categoryIds };
            categoryFilters.push(categoryFilter);
        });

        return categoryFilters;
    }

    function getDiscountTypes(queryStringParam) {
        var discountTypeIds = [];

        if (!queryStringParam) {
            return discountTypeIds;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');
            var categoryType = values[0];

            if (categoryType === '101') {
                for (var i = 1; i < values.length; i++) {
                    var id = parseInt(values[i]);
                    discountTypeIds.push(id);
                }
            }
        });

        return discountTypeIds;
    }

    function getSellerIds(queryStringParam) {
        var sellerIds = [];

        if (!queryStringParam) {
            return sellerIds;
        }

        var categories = queryStringParam.split('__');

        angular.forEach(categories, function (categoryString) {
            var values = categoryString.split('_');

            var category = values[0];
            //if (category === 'sellers') {
            if (category === String(Enums.otherCategoryType.seller.id)) {
                for (var i = 1; i <= values.length - 1; i++) {
                    var id = parseInt(values[i]);
                    sellerIds.push(id);
                }
            }
        });

        return sellerIds;
    }

    function getDiscountsOnly(queryStringParam) {
        // when filter starts with '102_1' or contains '__102_1', then checkbox only discounts is selected
        var searchValue1 = String(Enums.otherCategoryType.discountsOnly.id) + '_1';
        var searchValue2 = '__' + Enums.otherCategoryType.discountsOnly.id + '_1';
        return queryStringParam && (queryStringParam.indexOf(searchValue1) === 0 || queryStringParam.indexOf(searchValue2) >= 0) ? true : false;
    }

    function getSelectedIdsFromQueryString(queryStringParam, categoryId) {
        if (!queryStringParam) {
            return null;
        }

        var categories = queryStringParam.split('__');

        for (var i = 0; i < categories.length; i++) {
            var categoryString = categories[i];
            var values = categoryString.split('_');
            var categoryType = values[0];

            if (String(categoryType) === String(categoryId)) {
                var selectedIds = [];
                for (var _i = 1; _i <= values.length - 1; _i++) {
                    var id = parseInt(values[_i]);
                    if (typeof id === 'number' && !isNaN(id)) {
                        selectedIds.push(id);
                    }
                }

                return selectedIds;
            }
        }

        return null;
    }

    // function getSelectedIdOnLowestLevel(items) {
    //     var selectedId = 0;

    //     for (let i=0; i<items.length; i++) {
    //         if (items[i].isSelected) {
    //             selectedId = items[i].id;   
    //         }
    //     }

    //     return selectedId;
    // }

    // function GetIsCategoryType(categoryType) {
    //     var categoryTypeId = parseInt(categoryType);
    //     if (!categoryTypeId) { return false; }

    //     return common.enums.existsIdInEnum(Enums.categoryType, categoryTypeId);
    // }

    // function GetIsSellerCategoryType(categoryType) {
    //     // = categoryType endsWith 'S'
    //     return categoryType.indexOf('S', categoryType.length - 1) !== -1;
    // }

    function CategoryIsSeller(categoryType) {
        return common.enums.existsIdInEnum(Enums.otherCategoryType, parseInt(categoryType));
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


rentalProductsService.$inject = ["common", "$stateParams", "RentalProductOverview", "RentalProductOverviewItem", "RentalHistoryItem", "RentalHistoryDetail", "RentalHistoryStatusItem", "RentalProduct", "RentalProductCategory", "api", "$cacheFactory", "$q", "MediPimData", "RentalProductsOrder"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalProductsService = rentalProductsService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function rentalProductsService(common, $stateParams, RentalProductOverview, RentalProductOverviewItem, RentalHistoryItem, RentalHistoryDetail, RentalHistoryStatusItem, RentalProduct, RentalProductCategory, api, $cacheFactory, $q, MediPimData, RentalProductsOrder) {
    var cache = $cacheFactory('rentalCategoriesCache');

    return {
        init: init,
        getRentalProducts: getRentalProducts,
        getRentalProductById: getRentalProductById,
        getNewOrderContactInfo: getNewOrderContactInfo,
        setNewOrderContactInfo: setNewOrderContactInfo,
        getNewOrderDeliveryInfo: getNewOrderDeliveryInfo,
        setNewOrderDeliveryInfo: setNewOrderDeliveryInfo,
        getRentalProductCategories: getRentalProductCategories,
        getRentalProductMedipimdata: getRentalProductMedipimdata,
        orderRentedProducts: orderRentedProducts,
        searchCities: searchCities,
        searchStreet: searchStreet,
        getRentalHistory: getRentalHistory,
        getHistoryById: getHistoryById,
        setHistoryRemark: setHistoryRemark,
        getHistoryStatuses: getHistoryStatuses,
        searchRentalOrders: searchRentalOrders
    };

    var newOrderContactInfo;
    var newOrderDeliveryInfo;

    function getNewOrderContactInfo() {
        return newOrderContactInfo;
    }

    function setNewOrderContactInfo(_newOrderContactInfo) {
        newOrderContactInfo = _newOrderContactInfo;
    }

    function getNewOrderDeliveryInfo() {
        return newOrderDeliveryInfo;
    }

    function setNewOrderDeliveryInfo(_newOrderDeliveryInfo) {
        newOrderDeliveryInfo = _newOrderDeliveryInfo;
    }

    function init() {
        return RentalProductOverview.create();
    }

    function getRentalProducts(sellerId, categoryId, model) {
        model.isLoading = true;
        return api.rentalProducts.getAll({ sellerId: sellerId, categoryId: categoryId ? categoryId : 0 }).$promise.then(function (response) {
            model.isLoading = false;
            model.products = _lodash2.default.map(response, function (i) {
                return RentalProductOverviewItem.create(i);
            });
            return model;
        });
    }
    function getRentalHistory(search) {
        return api.rentalHistory.search(search).$promise.then(function (response) {
            response.results = _lodash2.default.map(response.results, function (i) {
                return RentalHistoryItem.create(i);
            });
            return response;
        });
    }
    function getHistoryById(id) {
        return api.rentalHistoryDetail.getById({ id: id }).$promise.then(function (response) {
            return RentalHistoryDetail.create(response);
        });
    }
    function setHistoryRemark(id, version, remark) {
        return api.rentalHistoryRemark.set({
            id: id,
            version: version,
            remark: remark
        }).$promise.then(function (response) {
            return RentalHistoryDetail.create(response);
        });
    }
    function getHistoryStatuses() {
        return api.rentalHistoryStatus.getAll().$promise.then(function (response) {
            return _lodash2.default.map(response.results, function (i) {
                return RentalHistoryStatusItem.create(i);
            });
        });
    }
    function searchRentalOrders(search) {
        return api.rentalOrderSearch.execute(search).$promise;
    }
    function getRentalProductMedipimdata(productId) {
        return api.rentalProductMedipim.getMedipimData({ productId: productId }).$promise.then(function (response) {
            return MediPimData.create(response);
        });
    }

    function getRentalProductCategories(sellerId) {
        var cachedRentalCategories = cache.get('rentalCategoriesCache?sellerId=' + $stateParams.SellerId + '&lang=' + common.localization.getCurrentLanguage());
        if (cachedRentalCategories) {
            return $q.when(_lodash2.default.map(cachedRentalCategories, function (i) {
                return RentalProductCategory.create(i);
            }));
        } else {
            return api.rentalProductCategories.getAll({ sellerId: sellerId }).$promise.then(function (response) {
                cache.put('rentalCategoriesCache?sellerId=' + $stateParams.SellerId + '&lang=' + common.localization.getCurrentLanguage(), response);
                return _lodash2.default.map(response, function (i) {
                    return RentalProductCategory.create(i);
                });
            });
        }
    }

    function getRentalProductById(productId) {
        return api.rentalProduct.get({ productId: productId }).$promise.then(function (response) {
            return RentalProduct.create(response);
        });
    }

    function orderRentedProducts(rentalProduct, recommendedProducts, suggestedProducts, contactInfo, deliveryInfo) {
        var rentalProductsOrder = void 0;

        //filter the ordered products
        if (recommendedProducts || suggestedProducts) {
            recommendedProducts = recommendedProducts.filter(function (p) {
                return p.order === true;
            });
            suggestedProducts = suggestedProducts.filter(function (p) {
                return p.order === true;
            });

            recommendedProducts = recommendedProducts.map(function (p) {
                return p.toJSON();
            });
            suggestedProducts = suggestedProducts.map(function (p) {
                return p.toJSON();
            });

            //create a new rentalproductorder and add the info
            rentalProductsOrder = RentalProductsOrder.create({
                rentalProducts: [rentalProduct.toJSON()].concat(recommendedProducts, suggestedProducts),
                contactInfo: contactInfo,
                deliveryInfo: deliveryInfo
            });
        } else {
            rentalProductsOrder = RentalProductsOrder.create({
                rentalProducts: [rentalProduct.toJSON()],
                contactInfo: contactInfo,
                deliveryInfo: deliveryInfo
            });
        }

        return api.rentalProductsOrder.order(rentalProductsOrder).$promise.then(function (response) {
            return RentalProductsOrder.create(response, true);
        });
    }

    /* Products search home and fast order*/
    function searchCities(searchString) {
        return api.searchCities.execute({ name: searchString }).$promise.then(function (resource) {
            return resource.results;
        });
    }

    function searchStreet(searchString, postalLocalityId) {
        return api.searchStreet.execute({ name: searchString, postalLocalityId: postalLocalityId }).$promise.then(function (resource) {
            return resource.results;
        });
    }
}

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


reservationCampaignService.$inject = ["api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reservationCampaignService = reservationCampaignService;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function reservationCampaignService(api) {

    return {
        setReservationCampaign: setReservationCampaign,
        getReservationCampaign: getReservationCampaign,
        getActiveReservationCampaigns: getActiveReservationCampaigns
    };

    function getReservationCampaign(code) {

        return api.reservationCampaign.get({ code: code }).$promise.then(function (resource) {
            resource.campaign.text = (0, _marked2.default)(resource.campaign.text || '');
            resource.canReserve = !!resource.reservations.find(function (product) {
                return !product.totalLimitReached;
            });
            return resource;
        });
    }

    function getActiveReservationCampaigns() {
        return api.getActiveReservationCampaigns.get({}).$promise.then(function (resource) {
            return resource;
        });
    }

    function setReservationCampaign(code, reservations) {
        var reservationsPost = [];
        reservations.forEach(function (reservation) {
            reservationsPost.push({
                productNumber: reservation.productNumber,
                amount: reservation.amount
            });
        });

        return api.setReservationCampaignAmounts.set({ code: code }, {
            code: code,
            reservations: reservationsPost
        }).$promise.then(function () {
            return getReservationCampaign(code);
        });
    }
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


screenService.$inject = ["$window"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.screenService = screenService;
/*@ngInject*/
function screenService($window) {

    var breakpointMobileMenu = 768;

    return {
        getNavigationMenuMode: getNavigationMenuMode
    };

    function getNavigationMenuMode() {
        return $window.innerWidth < breakpointMobileMenu ? 'mobile' : 'desktop';
    }
}

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


sellerCategoryService.$inject = ["SellerCategory", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerCategoryService = sellerCategoryService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/

function sellerCategoryService(SellerCategory, api) {
    return {
        get: get,
        getSellerCategories: getSellerCategories
    };

    function get(sellerId, sellerCategoryId) {
        return api.sellerCategory.get({ id: sellerId, categoryId: sellerCategoryId }).$promise.then(function (resource) {
            return SellerCategory.create(resource);
        });
    }

    function getSellerCategories(sellerId) {
        return api.sellerCategories.getSellerCategories({ sellerId: sellerId }).$promise.then(function (resourceList) {
            var categories = _lodash2.default.forEach(resourceList.categories, function (category) {
                return _lodash2.default.map(category.items, function (item) {
                    return SellerCategory.create(item);
                });
            });

            //cache.put('categories', categories);
            return categories;
        });
    }
}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

sellerService.$inject = ["common", "Seller", "$http", "api", "$q", "$cacheFactory", "SellerOverview", "SellerBanner", "SellerContact", "SellerPublic", "ProductOverviewItem", "Cart", "$localStorage", "productService", "Contract", "ContractDetail", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerService = sellerService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function sellerService(common, Seller, $http, api, $q, $cacheFactory, SellerOverview, SellerBanner, SellerContact, SellerPublic, ProductOverviewItem, Cart, $localStorage, productService, Contract, ContractDetail, authService) {
    var cache = $cacheFactory('sellerCache');

    return {
        getAll: getAll,
        getById: getById,
        getBySellerId: getBySellerId,
        getSellerAbout: getSellerAbout,
        getSellerBanners: getSellerBanners,
        getSellerProducts: getSellerProducts,
        getSellerContact: getSellerContact,
        getSellerPublic: getSellerPublic,
        getModules: getModules,
        getSellerTotalPriceDiscounts: getSellerTotalPriceDiscounts,
        getSellerContract: getSellerContract,
        getSellerContracts: getSellerContracts,
        getSellerProductsAndDiscounts: getSellerProductsAndDiscounts,
        getAllForMenu: getAllForMenu,
        getOutletSellerId: getOutletSellerId
    };

    function getById(id) {
        return getAll().then(function (sellers) {
            return _lodash2.default.find(sellers, { id: parseInt(id) });
        });
    }
    function getOutletSellerId() {
        return api.outletSeller.get().$promise.then(function (seller) {
            return seller.id;
        });
    }

    function getAll() {
        var cachedSellers = cache.get('sellers ' + common.localization.getCurrentLanguage());

        if (!angular.isUndefined(cachedSellers)) {
            return $q.when(cachedSellers);
        }

        return api.sellers.list().$promise.then(function (resourceList) {
            var sellers = _lodash2.default.map(resourceList, function (resource) {
                return Seller.create(resource);
            });

            cache.put('sellers ' + common.localization.getCurrentLanguage(), sellers);
            return sellers;
        }).catch(function () {});
    }

    function getAllForMenu() {
        var cachedSellers = cache.get('menuSellers&lang=' + common.localization.getCurrentLanguage());

        if (!angular.isUndefined(cachedSellers)) {
            return $q.when(cachedSellers);
        }

        return api.menuSellers.list().$promise.then(function (resourceList) {
            var sellers = _lodash2.default.map(resourceList, function (resource) {
                return Seller.create(resource);
            });

            cache.put('menuSellers&lang=' + common.localization.getCurrentLanguage(), sellers);
            return sellers;
        }).catch(function () {});
    }

    function getBySellerId(sellerId) {
        return api.sellers.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerOverview.create(resource);
        });
    }
    function getModules(sellerId) {
        return api.sellerModules.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerBanners(sellerId) {
        return api.sellerBanners.get({ id: sellerId }).$promise.then(function (resources) {
            return resources.banners.map(function (resource) {
                return SellerBanner.create(resource);
            });
        });
    }

    function getSellerProductsAndDiscounts(sellerId, productsModel, discountsModel) {

        var promises = [];
        promises.push(api.sellerProductsAndDiscounts.get({ id: sellerId }).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        }
        return $q.all(promises).then(function (results) {
            var productsAndDiscounts = results[0];
            var cartProducts = results[1];

            productsModel.products = productsAndDiscounts.products.map(function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts);
            });
            discountsModel.products = productsAndDiscounts.discounts.map(function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts);
            });

            productService.calculateGrossProfits(productsModel.products);
            productService.calculateGrossProfits(discountsModel.products);

            return {
                productsModel: productsModel,
                discountsModel: discountsModel
            };
        });
    }

    function getSellerTotalPriceDiscounts(sellerId) {
        return api.totalPriceDiscounts.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerProducts(sellerId) {
        return api.sellerBanners.get({ id: sellerId }).$promise.then(function (resource) {
            var cart = null;
            if ($localStorage.cart) {
                cart = Cart.createFromLocalStorage($localStorage.cart);
            }
            var sellerProducts = _lodash2.default.map(resource.products, function (response) {
                return ProductOverviewItem.getClass().create(response, cart);
            });
            return {
                totalItems: resource.products.count,
                products: sellerProducts,
                filters: null
            };
        });
    }

    function getSellerAbout(sellerId) {
        return api.sellerAbout.get({ id: sellerId }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getSellerContact(sellerId) {
        return api.sellerContact.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerContact.create(resource);
        });
    }

    function getSellerContract(sellerId, contractId) {
        return api.sellerContract.get({ sellerId: sellerId, contractId: contractId }).$promise.then(function (resource) {
            return ContractDetail.create(resource);
        });
    }

    function getSellerContracts(sellerId) {
        return api.sellerContracts.list({ sellerId: sellerId }).$promise.then(function (resources) {
            return resources.map(function (resource) {
                return {
                    type: resource.portalContractType,
                    contracts: resource.contracts.map(function (x) {
                        return Contract.create(x);
                    })
                };
            });
        });
    }

    function getSellerPublic(sellerId) {
        return api.sellerPublic.get({ id: sellerId }).$promise.then(function (resource) {
            return SellerPublic.create(resource);
        });
    }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


tenantService.$inject = ["Tenant", "$http", "api"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tenantService = tenantService;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function tenantService(Tenant, $http, api) {
    return {
        getAll: getAll
    };

    function getAll() {
        return api.tenants.list().$promise.then(function (resources) {
            return _lodash2.default.map(resources, function (resource) {
                return Tenant.create(resource);
            });
        });
    }
}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


textBuilder.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textBuilder = textBuilder;
/*@ngInject*/
function textBuilder(gettextCatalog) {
    return {
        getProductNumberAndPromo: getProductNumberAndPromo
    };

    function getProductNumberAndPromo(productNumber, promocode) {
        var productNumberIsEmpty = !productNumber || productNumber.length <= 0;
        var promocodeIsEmpty = !promocode || promocode.length <= 0;

        if (productNumberIsEmpty && promocodeIsEmpty) {
            return '';
        }

        var productNumberLabel = gettextCatalog.getString('ProductNumber');
        var promocodeLabel = gettextCatalog.getString('PROMO');

        if (promocodeIsEmpty) {
            return productNumberLabel + ': ' + productNumber;
        }

        if (productNumberIsEmpty) {
            return promocodeLabel + ': ' + promocode;
        }

        return productNumberLabel + ': ' + productNumber + ', ' + promocodeLabel + ': ' + promocode;
    }
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


userService.$inject = ["$http", "api", "User"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userService = userService;
/*@ngInject*/
function userService($http, api, User) {
    return {
        getById: getById,
        getMyAccount: getMyAccount,
        setBuyerMail: setBuyerMail,
        setBuyerMailLanguage: setBuyerMailLanguage,
        getCurrentTenant: getCurrentTenant
    };

    function getById(id) {
        return $http.get('/assets/data/user-' + id + '.json').then(function (response) {
            var resource = response.data;
            return resource;
        });
    }

    function getMyAccount() {
        return api.myAccount.get().$promise.then(function (response) {
            return User.create(response);
        });
    }

    function setBuyerMail(mail) {
        return api.setBuyerMail.execute({ mail: mail }).$promise;
    }

    function setBuyerMailLanguage(language) {
        return api.setBuyerMailLanguage.execute({ id: language.id }).$promise;
    }

    function getCurrentTenant() {
        return api.currentTenant.get().$promise.then(function (resource) {
            return resource;
        });
    }
}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


vaccinesService.$inject = ["api", "config", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.vaccinesService = vaccinesService;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function vaccinesService(api, config, gettextCatalog) {
    var fluVaccinesEndDate = config.fluVaccines.startDate;
    var fluVaccinesStartDate = config.fluVaccines.endDate;

    return {
        setVaccinReservation: setVaccinReservation,
        getVaccines: getVaccines,
        vaccinsCanOrder: vaccinsCanOrder,
        canOrderVaccin: canOrderVaccin,
        allReservationsMade: allReservationsMade
    };

    function getVaccines() {
        return api.vaccinreservation.get({}).$promise.then(function (resource) {

            var vaccins = [{
                productNumber: '4297123',
                product: gettextCatalog.getString('VAXIGRIP TETRA 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 224,
                // discountType: 'percentage',
                // discounts: [{
                //         amount: 112,
                //         percentage: 5
                //     },
                //     {
                //         amount: 224,
                //         percentage: 10
                //     }
                // ],
                disabled: false
            }, {
                productNumber: '4299764',
                product: gettextCatalog.getString('ALPHARIX TETRA 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 180,
                // discountType: 'none',
                // discounts: [],
                disabled: false
            }, {
                productNumber: '4307617',
                product: gettextCatalog.getString('INFLUVAC S 2021-2022 0,5 ML 1 WWSP'),
                // price: 8.07,
                amount: 120,
                // discountType: 'none',
                // discounts: [],
                disabled: false
            }];

            vaccins.map(function (vaccin) {
                var vaccinSearch = resource.reservations.find(function (x) {
                    return vaccin.productNumber === x.productNumber;
                });
                vaccin.amount = !!vaccinSearch ? vaccinSearch.amount : 0;
                return vaccin;
            });
            vaccins.influvacReadOnly = resource.influvacReadOnly;
            return vaccins;
        });
    }

    function vaccinsCanOrder() {
        return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD');

        // let vaccin = vaccins.find((vaccin) => {
        //     return vaccin.amount > 0;
        // });
        // return vaccin === undefined ? false : true;
    }

    function allReservationsMade(vaccins) {
        return vaccins.every(amountNotZero);
    }

    function amountNotZero(vaccin) {
        return vaccin.amount !== 0;
    }

    function canOrderVaccin() {
        return (0, _moment2.default)(fluVaccinesStartDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(fluVaccinesEndDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD'); // return vaccin.amount === 0;
    }

    function setVaccinReservation(vaccines) {
        var vaccinesPost = [];
        vaccines.forEach(function (vaccine) {
            vaccinesPost.push({
                productNumber: vaccine.productNumber,
                amount: vaccine.amount
            });
        });

        return api.setReservationAmounts.set({
            reservations: vaccinesPost
        }).$promise.then(function (resources) {
            return resources;
        });
    }
}

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractDetailInfoComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var contractDetailInfoComponent = exports.contractDetailInfoComponent = {
    template: __webpack_require__(508),
    bindings: {
        contract: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "config", "authService", "$stateParams", function contractDetailInfoController(common, config, authService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$stateParams = $stateParams;
        vm.getDownloadUrl = getDownloadUrlContractProductsDetail;
        vm.startDateIsValid = startDateIsValid;
        vm.getDownloadUrlContractDetail = getDownloadUrlContractDetail;
        vm.from = (0, _moment2.default)(vm.contract.startDate).toISOString();
        if (vm.contract.portalContractTypeCode === 'FEB') {
            vm.minFrom = (0, _moment2.default)(vm.contract.startDate).toISOString();
        }
        vm.to = (0, _moment2.default)(vm.contract.endDate).toISOString();
        vm.checkYearsApart = checkYearsApart;

        function init() {
            common.navigationMenu.clearActiveMenu();
            vm.contract.description = (0, _marked2.default)(vm.contract.description || '');
        }

        function getDownloadUrlContractProductsDetail() {

            if (vm.contract.agiosNr === 'F001' || vm.contract.agiosNr === 'A005') {
                if (!vm.startDateIsValid()) return null;
                return config.webApiBaseUrl + ('report/febelCareProductsDetail/' + vm.contract.id + '?from=' + (0, _moment2.default)(vm.from).toISOString() + '&to=' + (0, _moment2.default)(vm.to).toISOString() + '&lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
            } else {
                return config.webApiBaseUrl + ('report/agiosProductsDetail/' + vm.contract.id + '?from=' + (0, _moment2.default)(vm.from).toISOString() + '&to=' + (0, _moment2.default)(vm.to).toISOString() + '&lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
            }
        }

        function startDateIsValid() {
            return !!vm.from;
        }

        function getDownloadUrlContractDetail() {
            return config.webApiBaseUrl + ('report/agiosContractDetail/' + vm.contract.id + '?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken);
        }

        function checkYearsApart() {
            return (0, _moment2.default)(vm.contract.endDate).format('YYYY') - (0, _moment2.default)(vm.contract.startDate).format('YYYY') > 10 ? true : false;
        }
    }]
};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contractProductsComponent = exports.contractProductsComponent = {
    template: __webpack_require__(509),
    bindings: {
        contract: '<'
    },
    controllerAs: 'vm',
    controller: ["$filter", function contractProductsController($filter) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.goToPage = goToPage;
        vm.onProductSearch = onProductSearch;
        vm.onOrderProducts = onOrderProducts;
        vm.pagedContractProducts = [];
        vm.filteredProducts = [];

        function init() {
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.contract.products);
        }

        function onProductSearch() {
            vm.filteredProducts = $filter('filter')(vm.contract.products, function (product) {
                return product.name.toLowerCase().includes(vm.searchValue.toLowerCase()) || product.sellerArticleNumber.toLowerCase().includes(vm.searchValue.toLowerCase());
            });
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.filteredProducts);
            vm.contract.paging.page = 1;
            vm.contract.paging.totalItems = vm.filteredProducts.length;
            vm.contract.paging.update(1);
        }

        function goToPage(page) {
            if (page === 0 || page > vm.contract.paging.pageCount) {
                return;
            }
            vm.pagedContractProducts = vm.contract.getPagedProducts(page, vm.contract.products);
            vm.contract.paging.page = page;
            vm.contract.paging.update(page);
        }

        function onOrderProducts(orderValue) {
            vm.contract.products = $filter('orderBy')(vm.contract.products, orderValue);
            vm.pagedContractProducts = vm.contract.getPagedProducts(1, vm.contract.products);
            vm.contract.paging.page = 1;
            vm.contract.paging.update(1);
        }
    }]
};

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contractsOverviewInfoComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contractsOverviewInfoComponent = exports.contractsOverviewInfoComponent = {
    template: __webpack_require__(510),
    bindings: {
        contracts: '<',
        context: '@?'
    },
    controllerAs: 'vm',
    controller: ["common", function contractsOverviewController(common) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.sortBy = sortBy;
        vm.reverse = false;
        vm.propertyName = 'name';
        vm.checkYearsApart = checkYearsApart;

        function init() {
            common.navigationMenu.clearActiveMenu();
        }

        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        function checkYearsApart(contract) {
            return (0, _moment2.default)(contract.endDate).format('YYYY') - (0, _moment2.default)(contract.startDate).format('YYYY') > 10 ? true : false;
        }
    }]
};

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailDeliveriesComponent = exports.orderDetailDeliveriesComponent = {
    template: __webpack_require__(511),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "Enums", "gettextCatalog", function orderDetailDeliveriesController(common, Enums, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.orderStatusTexts = {};
        vm.getOrderStatusText = getOrderStatusText;
        vm.getDeliveryStatusText = getDeliveryStatusText;

        function init() {
            vm.orderStatusTexts = Enums.orderStatusTexts;
            vm.deliveryStatusTexts = Enums.deliveryStatusTexts;
        }

        function getOrderStatusText(code) {
            return code ? gettextCatalog.getString(vm.orderStatusTexts[code].text) : '';
        }

        function getDeliveryStatusText(code) {
            if (!code) {
                return '';
            }
            return code ? gettextCatalog.getString(vm.deliveryStatusTexts[code].text) : '';
        }
    }]
};

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailDeliveryHistoryComponent = exports.orderDetailDeliveryHistoryComponent = {
    template: __webpack_require__(512),
    bindings: {
        history: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailDeliveryProductsComponent = exports.orderDetailDeliveryProductsComponent = {
    template: __webpack_require__(513),
    bindings: {
        products: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailExtraInfoComponent = exports.orderDetailExtraInfoComponent = {
    template: __webpack_require__(514),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderDetailHeaderComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var orderDetailHeaderComponent = exports.orderDetailHeaderComponent = {
    template: __webpack_require__(515),
    bindings: {
        order: '<',
        setOrderDeliveryDate: '&',
        updatingOrderDate: '<',
        updateOrderDeliverDateErrors: '<'
    },
    controllerAs: 'vm',
    controller: ["config", "authService", "$stateParams", "$state", "cartService", "gettextCatalog", "toastr", function orderOverviewController(config, authService, $stateParams, $state, cartService, gettextCatalog, toastr) {
        'ngInject';

        var vm = this;
        vm.getDownloadUrl = getDownloadUrl;
        vm.onSetOrderDelivery = onSetOrderDelivery;
        vm.showRequestOrderDate = showRequestOrderDate;
        vm.orderProductsAgain = orderProductsAgain;
        vm.buttonDisabled = buttonDisabled;
        vm.maxDate = (0, _moment2.default)(vm.order.deliveryDate).format('DD/MM/YYYY');
        vm.minDate = (0, _moment2.default)().add(1, 'days').format('DD/MM/YYYY');
        vm.newOrderDate = vm.order.deliveryDate;
        vm.isAddingToCart = false;

        vm.forms = [];

        function getDownloadUrl(order) {
            return config.webApiBaseUrl + ('report/orderDetail/' + order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function onSetOrderDelivery(newDeliveryDate) {
            vm.setOrderDeliveryDate({ $event: newDeliveryDate });
        }

        function showRequestOrderDate() {
            return vm.order.orderStatusCode === 'CREATED' && (0, _moment2.default)(vm.order.deliveryDate).isAfter((0, _moment2.default)().add(1, 'days')) || (0, _moment2.default)(vm.order.deliveryDate).isSame((0, _moment2.default)().add(1, 'days')) && vm.order.deliveryDate;
        }

        function buttonDisabled() {
            return vm.forms.requestOrderDate.$error.maxDate || vm.forms.requestOrderDate.$error.minDate || !vm.newOrderDate || (0, _moment2.default)(vm.order.deliveryDate).format('DD/MM/YYYY') === (0, _moment2.default)(vm.newOrderDate).format('DD/MM/YYYY');
        }

        function orderProductsAgain() {
            vm.isAddingToCart = true;
            cartService.reOrderProducts(vm.order.id).then(function () {
                vm.isAddingToCart = false;

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {

                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                vm.isAddingToCart = false;
                vm.errors.shoppingCartAdd = true;
            });
        }
    }]
};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailProductsComponent = exports.orderDetailProductsComponent = {
    template: __webpack_require__(516),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.getDiscountPrice = getDiscountPrice;

        /* Get the discount price */
        function getDiscountPrice(unitPrice, discountPercentage) {
            return unitPrice - unitPrice * discountPercentage / 100;
        }
    }
};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderOverviewSearchComponent = exports.orderOverviewSearchComponent = {
    template: __webpack_require__(517),
    bindings: {
        searchValue: '=',
        search: '&',
        sellers: '<'
    },
    controllerAs: 'vm',
    controller: function contractsOverviewController() {
        'ngInject';

        var vm = this;
        vm.onSearch = onSearch;
        vm.$onInit = init;

        function init() {
            vm.selectedSeller = vm.sellers[0];
        }

        function onSearch() {
            var data = {
                searchValue: vm.searchValue,
                selectedSeller: vm.selectedSeller
            };
            vm.search({ $event: data });
        }
    }
};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contractDetailComponent = exports.contractDetailComponent = {
    template: __webpack_require__(518),
    bindings: {
        contract: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "Analytics", function contractDetailController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString(vm.contract.name));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/contracts/' + vm.contract.id, vm.contract.name);
        }
    }]
};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contractsOverviewComponent = exports.contractsOverviewComponent = {
    template: __webpack_require__(519),
    bindings: {
        contracts: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "Analytics", function contractsOverviewController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            common.setTitle(gettextCatalog.getString('My contracts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/contracts', gettextCatalog.getString('My contracts'));
        }
    }]
};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _settings = __webpack_require__(892);

var _orderDetail = __webpack_require__(868);

var _orderOverview = __webpack_require__(869);

var _contractsOverview = __webpack_require__(846);

var _orderDetailHeader = __webpack_require__(842);

var _orderDetailProducts = __webpack_require__(843);

var _orderDetailDeliveries = __webpack_require__(838);

var _orderDetailDeliveryHistory = __webpack_require__(839);

var _orderDetailDeliveryProducts = __webpack_require__(840);

var _orderDetailExtraInfo = __webpack_require__(841);

var _orderOverviewSearch = __webpack_require__(844);

var _contractDetail = __webpack_require__(845);

var _contractDetailInfo = __webpack_require__(835);

var _contractsOverviewInfo = __webpack_require__(837);

var _contractProducts = __webpack_require__(836);

var _myDocuments = __webpack_require__(848);

var _myReservations = __webpack_require__(867);

var _rentalOverview = __webpack_require__(888);

var _rentalRequestArchive = __webpack_require__(889);

var _rentedProductArchive = __webpack_require__(890);

var _rentedProductDetail = __webpack_require__(891);

var _podOrderAdd = __webpack_require__(863);

var _podOrderAddConfirmation = __webpack_require__(862);

var _podOrderArchive = __webpack_require__(864);

var _podOrderDetail = __webpack_require__(865);

var _podOrderOverview = __webpack_require__(866);

var _addStep1SelectReceiverForm = __webpack_require__(849);

var _addStep1SelectReceiverRead = __webpack_require__(850);

var _addStep2DetailsForm = __webpack_require__(851);

var _addStep2DetailsRead = __webpack_require__(852);

var _addStep3ConfirmForm = __webpack_require__(853);

var _howDoesItWorkBox = __webpack_require__(854);

var _orderReceiverDetail = __webpack_require__(859);

var _orderDetailContent = __webpack_require__(855);

var _orderSearchResultItem = __webpack_require__(860);

var _orderState = __webpack_require__(861);

var _orderLineState = __webpack_require__(858);

var _orderLineDetail = __webpack_require__(856);

var _orderLineStateHistory = __webpack_require__(857);

var _parcelsOverview = __webpack_require__(887);

var _parcelAdd = __webpack_require__(884);

var _parcelAddConfirmation = __webpack_require__(883);

var _parcelArchive = __webpack_require__(885);

var _parcelDetail = __webpack_require__(886);

var _parcelHowDoesItWorkBox = __webpack_require__(876);

var _parcelAddStep1SelectReceiverForm = __webpack_require__(870);

var _parcelAddStep1SelectReceiverRead = __webpack_require__(871);

var _parcelAddStep2DetailsForm = __webpack_require__(872);

var _parcelAddStep2DetailsRead = __webpack_require__(873);

var _parcelAddStep3ConfirmForm = __webpack_require__(874);

var _parcelSearchResultItem = __webpack_require__(881);

var _parcelReceiverDetail = __webpack_require__(880);

var _parcelLineState = __webpack_require__(879);

var _parcelState = __webpack_require__(882);

var _parcelDetailContent = __webpack_require__(875);

var _parcelLineDetail = __webpack_require__(877);

var _parcelLineStateHistory = __webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.account', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('account', {
        parent: 'general',
        url: '/account',
        ncyBreadcrumb: {
            label: '{{"My account" | translate}}'
        },
        redirectTo: 'account-detail'
    }).state('account-detail', {
        parent: 'general',
        url: '/account',
        views: {
            'main@root': {
                component: 'accountSettings'
            }
        },
        resolve: {
            user: ["userService", function user(userService) {
                return userService.getMyAccount();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"My account" | translate}}'
        }
    }).state('rental-overview', {
        parent: 'account',
        url: '/rentals?page',
        views: {
            'main@root': {
                component: 'rentalOverview'
            }
        },
        params: {
            loadingOverlay: true
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            statuses: ["rentalProductsService", function statuses(rentalProductsService) {
                return rentalProductsService.getHistoryStatuses();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"My rent overview" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rented-product-detail', {
        parent: 'rented-product-archive',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'rentedProductDetail'
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            rentalHistory: ["$stateParams", "rentalProductsService", function rentalHistory($stateParams, rentalProductsService) {
                return rentalProductsService.getHistoryById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Rented product detail" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rented-product-archive', {
        parent: 'rental-overview',
        url: '/rented-product-archive?page&pageSize&statusId&product&year&remark&depositRefunded',
        views: {
            'main@root': {
                component: 'rentedProductArchive'
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }],
            statuses: ["rentalProductsService", function statuses(rentalProductsService) {
                return rentalProductsService.getHistoryStatuses();
            }]
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            statusId: {
                value: null,
                squash: true
            },
            product: {
                value: '',
                squash: true
            },
            year: {
                value: null,
                squash: true
            },
            remark: {
                value: '',
                squash: true
            },
            depositRefunded: {
                value: null,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"All my rented products" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('rental-request-archive', {
        parent: 'rental-overview',
        url: '/request-archive?page&pageSize&product&year',
        views: {
            'main@root': {
                component: 'rentalRequestArchive'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            product: {
                value: '',
                squash: true
            },
            year: {
                value: null,
                squash: true
            }
        },
        resolve: {
            tgzId: ["sellerService", function tgzId(sellerService) {
                return sellerService.getAllForMenu().then(function (results) {
                    return results.find(function (s) {
                        return s.code === 'TGZ';
                    }).id;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{"All my rental requests" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('order-overview', {
        parent: 'account',
        url: '/orders?page',
        views: {
            'main@root': {
                component: 'orderOverview'
            }
        },
        resolve: {
            input: ["orderService", "Enums", function input(orderService, Enums) {
                return orderService.getByCriteria('', 1, Enums.getAmounts.default, 'OrderDate', false, 0);
            }],
            sellers: ["sellerService", "gettextCatalog", function sellers(sellerService, gettextCatalog) {
                return sellerService.getAll().then(function (sellers) {
                    var newSellers = _angular2.default.copy(sellers);

                    // add all sellers option
                    newSellers.unshift({
                        id: 0,
                        name: gettextCatalog.getString('All sellers')
                    });
                    return newSellers;
                });
            }]
        },
        params: {
            loadingOverlay: true
        },
        reloadOnSearch: false,
        ncyBreadcrumb: {
            label: '{{"My orders" | translate}}'
        }
    }).state('order', {
        parent: 'order-overview',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'orderDetail'
            }
        },
        resolve: {
            order: ["$stateParams", "orderService", function order($stateParams, orderService) {
                return orderService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Order - noun" | translate}} {{$resolve.order.referenceNumber}}'
        }
    }).state('contracts-overview', {
        parent: 'account',
        url: '/contracts',
        views: {
            'main@root': {
                component: 'contractsOverview'
            }
        },
        resolve: {
            contracts: ["$stateParams", "contractService", function contracts($stateParams, contractService) {
                return contractService.get();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"My contracts" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('contract-detail', {
        parent: 'contracts-overview',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'contractDetail'
            }
        },
        resolve: {
            contract: ["$stateParams", "contractService", function contract($stateParams, contractService) {
                return contractService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-documents', {
        parent: 'account',
        url: '/myDocuments',
        views: {
            'main@root': {
                component: 'myDocuments'
            }
        },
        params: {},
        ncyBreadcrumb: {
            label: '{{"_myDocuments.myDocuments" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-reservations', {
        parent: 'account',
        url: '/myReservations',
        views: {
            'main@root': {
                component: 'myReservations'
            }
        },
        ncyBreadcrumb: {
            label: '{{"My reservations" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('my-packages', {
        parent: 'account',
        url: '/my-packages',
        views: {
            'main@root': {
                component: 'podOrderOverview'
            }
        },
        resolve: {
            recentOrders: ["packagesService", function recentOrders(packagesService) {
                return packagesService.getRecentOrders();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Mijn verzendingen'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('package-archive', {
        parent: 'my-packages',
        url: '/package-archive',
        views: {
            'main@root': {
                component: 'podOrderArchive'
            }
        },
        resolve: {
            orders: ["packagesService", function orders(packagesService) {
                return packagesService.getOrders();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Al mijn verzendingen'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('package-detail', {
        parent: 'my-packages',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'podOrderDetail'
            }
        },
        resolve: {
            order: ["$stateParams", "packagesService", function order($stateParams, packagesService) {
                return packagesService.getById($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending {{$resolve.order.orderNumber}}'
            // label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-package', {
        parent: 'my-packages',
        url: '/add-package',
        views: {
            'main@root': {
                component: 'podOrderAdd'
            }
        },
        resolve: {
            /*     contract: ($stateParams, contractService) => {
                    return contractService.getById($stateParams.id);
                } */
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending aanmaken'
            // label: '{{$resolve.contract.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-package-confirmation', {
        parent: 'my-packages',
        url: '/add-package-confirmation',
        views: {
            'main@root': {
                component: 'podOrderAddConfirmation'
            }
        },
        resolve: {
            order: ["packagesService", function order(packagesService) {
                return packagesService.getById(99);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: 'Verzending aangemaakt'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcels', {
        parent: 'account',
        url: '/parcels',
        views: {
            'main@root': {
                component: 'parcelsOverview'
            }
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.myParcels" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcel-archive', {
        parent: 'parcels',
        url: '/parcel-archive?page&pageSize&identification&barCode&orderNumber&dateFrom&dateTo',
        views: {
            'main@root': {
                component: 'parcelArchive'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            identification: {
                value: '',
                squash: true
            },
            barCode: {
                value: '',
                squash: true
            },
            orderNumber: {
                value: '',
                squash: true
            },
            dateFrom: {
                value: null,
                squash: true
            },
            dateTo: {
                value: null,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"parcel.allMyParcels" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-parcel', {
        parent: 'parcels',
        url: '/add-parcel',
        views: {
            'main@root': {
                component: 'parcelAdd'
            }
        },
        resolve: {
            data: ["parcelService", function data(parcelService) {
                return parcelService.init();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.createParcel" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('add-parcel-confirmation', {
        parent: 'parcels',
        url: '/add-parcel-confirmation/{id:int}',
        views: {
            'main@root': {
                component: 'parcelAddConfirmation'
            }
        },
        resolve: {
            parcel: ["$stateParams", "parcelService", function parcel($stateParams, parcelService) {
                return parcelService.get($stateParams.id);
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.yourParcelWasRegistered" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('parcel-detail', {
        parent: 'parcels',
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'parcelDetail'
            }
        },
        resolve: {
            parcelId: ["$stateParams", function parcelId($stateParams) {
                return $stateParams.id;
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"parcel.parcel" | translate}} {{$resolve.parcel.orderNumber}}'
        },
        data: {
            febelcoCustomer: true
        }
    });
}]).component('accountSettings', _settings.accountSettingsComponent).component('orderOverview', _orderOverview.orderOverviewComponent).component('orderDetail', _orderDetail.orderDetailComponent).component('orderDetailHeader', _orderDetailHeader.orderDetailHeaderComponent).component('orderDetailProducts', _orderDetailProducts.orderDetailProductsComponent).component('orderDetailDeliveries', _orderDetailDeliveries.orderDetailDeliveriesComponent).component('orderDetailDeliveryHistory', _orderDetailDeliveryHistory.orderDetailDeliveryHistoryComponent).component('orderDetailDeliveryProducts', _orderDetailDeliveryProducts.orderDetailDeliveryProductsComponent).component('orderDetailExtraInfo', _orderDetailExtraInfo.orderDetailExtraInfoComponent).component('orderOverviewSearch', _orderOverviewSearch.orderOverviewSearchComponent).component('contractsOverview', _contractsOverview.contractsOverviewComponent).component('contractDetailInfo', _contractDetailInfo.contractDetailInfoComponent).component('contractsOverviewInfo', _contractsOverviewInfo.contractsOverviewInfoComponent).component('contractProducts', _contractProducts.contractProductsComponent).component('myDocuments', _myDocuments.myDocumentsComponent).component('myReservations', _myReservations.myReservationsComponent).component('contractDetail', _contractDetail.contractDetailComponent).component('rentalOverview', _rentalOverview.rentalOverviewComponent).component('rentalRequestArchive', _rentalRequestArchive.rentalRequestArchiveComponent).component('rentedProductArchive', _rentedProductArchive.rentedProductArchiveComponent).component('rentedProductDetail', _rentedProductDetail.rentedProductDetailComponent).component('podOrderAdd', _podOrderAdd.podOrderAddComponent).component('podOrderAddConfirmation', _podOrderAddConfirmation.podOrderAddConfirmationComponent).component('podOrderArchive', _podOrderArchive.podOrderArchiveComponent).component('podOrderDetail', _podOrderDetail.podOrderDetailComponent).component('podOrderOverview', _podOrderOverview.podOrderOverviewComponent).component('addStep1SelectReceiverForm', _addStep1SelectReceiverForm.addStep1SelectReceiverFormComponent).component('addStep1SelectReceiverRead', _addStep1SelectReceiverRead.addStep1SelectReceiverReadComponent).component('addStep2DetailsForm', _addStep2DetailsForm.addStep2DetailsFormComponent).component('addStep2DetailsRead', _addStep2DetailsRead.addStep2DetailsReadComponent).component('addStep3ConfirmForm', _addStep3ConfirmForm.addStep3ConfirmFormComponent).component('howDoesItWorkBox', _howDoesItWorkBox.howDoesItWorkBoxComponent).component('orderReceiverDetail', _orderReceiverDetail.orderReceiverDetailComponent).component('orderDetailContent', _orderDetailContent.orderDetailContentComponent).component('orderSearchResultItem', _orderSearchResultItem.orderSearchResultItemComponent).component('orderState', _orderState.orderStateComponent).component('orderLineState', _orderLineState.orderLineStateComponent).component('orderLineDetail', _orderLineDetail.orderLineDetailComponent).component('orderLineStateHistory', _orderLineStateHistory.orderLineStateHistoryComponent).component('parcelAdd', _parcelAdd.parcelAddComponent).component('parcelAddConfirmation', _parcelAddConfirmation.parcelAddConfirmationComponent).component('parcelsOverview', _parcelsOverview.parcelsOverviewComponent).component('parcelArchive', _parcelArchive.parcelArchiveComponent).component('parcelDetail', _parcelDetail.parcelDetailComponent).component('parcelHowDoesItWorkBox', _parcelHowDoesItWorkBox.parcelHowDoesItWorkBoxComponent).component('parcelAddStep1SelectReceiverForm', _parcelAddStep1SelectReceiverForm.parcelAddStep1SelectReceiverFormComponent).component('parcelAddStep1SelectReceiverRead', _parcelAddStep1SelectReceiverRead.parcelAddStep1SelectReceiverReadComponent).component('parcelAddStep2DetailsForm', _parcelAddStep2DetailsForm.parcelAddStep2DetailsFormComponent).component('parcelAddStep2DetailsRead', _parcelAddStep2DetailsRead.parcelAddStep2DetailsReadComponent).component('parcelAddStep3ConfirmForm', _parcelAddStep3ConfirmForm.parcelAddStep3ConfirmFormComponent).component('parcelReceiverDetail', _parcelReceiverDetail.parcelReceiverDetailComponent).component('parcelDetailContent', _parcelDetailContent.parcelDetailContentComponent).component('parcelSearchResultItem', _parcelSearchResultItem.parcelSearchResultItemComponent).component('parcelLineState', _parcelLineState.parcelLineStateComponent).component('parcelState', _parcelState.parcelStateComponent).component('parcelLineDetail', _parcelLineDetail.parcelLineDetailComponent).component('parcelLineStateHistory', _parcelLineStateHistory.parcelLineStateHistoryComponent);

exports.default = _module.name;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var myDocumentsComponent = exports.myDocumentsComponent = {
    template: __webpack_require__(520),
    controllerAs: 'vm',
    controller: ["config", "common", "authService", "$stateParams", "gettextCatalog", "Analytics", function myDocumentsController(config, common, authService, $stateParams, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$stateParams = $stateParams;
        vm.getUrlReportNarcotics = getUrlReportNarcotics;
        vm.getUrlReportPurchaseProposals = getUrlReportPurchaseProposals;

        function init() {
            common.setTitle(gettextCatalog.getString('_myDocuments.myDocuments'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/myDocuments', gettextCatalog.getString('_myDocuments.myDocuments'));
        }

        function getUrlReportNarcotics() {
            return config.webApiBaseUrl + 'report/narcoticsReminder?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken;
        }

        function getUrlReportPurchaseProposals() {
            return config.webApiBaseUrl + 'report/purchaseProposals?lang=' + vm.$stateParams.language + '&access_token=' + authService.accessToken;
        }
    }]
};

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep1SelectReceiverFormComponent = exports.addStep1SelectReceiverFormComponent = {
    template: __webpack_require__(521),
    controllerAs: 'vm',
    bindings: {
        receiver: '<',
        selectReceiver: '&',
        cancel: '&'
    },
    controller: function addStep1SelectReceiverFormController() {
        'ngInject';

        var vm = this;

        vm.orderTypeId;
        vm.licenseNumber;
        vm.customerNumber;
        vm.error;
        vm.errorNotFound;

        vm.$onInit = init;
        vm.submitStep1Form = submitStep1Form;
        vm.onCancel = onCancel;

        function init() {
            resetStep1Form();
        }

        function resetStep1Form() {
            vm.orderTypeId = 1; // 'PA', Pakje apotheek
            vm.licenseNumber = vm.receiver ? vm.receiver.licenseNumber : null;
            vm.customerNumber = vm.receiver ? vm.receiver.customerNumber : null;
            vm.error = null;
            vm.errorNotFound = false;
        }

        function submitStep1Form() {
            if (!vm.licenseNumber || !vm.customerNumber) {
                vm.error = 'Gelieve vergunningsnummer en klantnummer in te geven.';
                vm.errorNotFound = false;
                return;
            } else if (isNaN(vm.licenseNumber) || isNaN(vm.customerNumber)) {
                vm.errorNotFound = true;
                vm.error = null;
            } else {
                vm.error = null;
                vm.errorNotFound = false;
                var selectedReceiver = void 0;

                selectedReceiver = {
                    orderTypeId: vm.orderTypeId,
                    licenseNumber: vm.licenseNumber,
                    customerNumber: vm.customerNumber,
                    businessUnitCode: null,
                    name: 'Tijskens Marc BVBA',
                    streetName: "Gasstraat",
                    houseNumber: "105",
                    boxNumber: null,
                    postalCode: "2060",
                    cityName: "Antwerpen",
                    id: 50
                };

                vm.selectReceiver({ $event: selectedReceiver });
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep1SelectReceiverReadComponent = exports.addStep1SelectReceiverReadComponent = {
    template: __webpack_require__(522),
    bindings: {
        receiver: '<',
        editReceiver: '&'
    },
    controllerAs: 'vm',
    controller: function addStep1SelectReceiverReadController() {
        'ngInject';

        var vm = this;
        vm.onEditStep1 = onEditStep1;

        function onEditStep1() {

            vm.editReceiver();
        }
    }
};

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep2DetailsFormComponent = exports.addStep2DetailsFormComponent = {
    template: __webpack_require__(523),
    bindings: {
        receiver: '<',
        delivery: '<',
        submitStep2: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function addStep2DetailsFormController(packagesService) {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.submitStep2Form = submitStep2Form;
        vm.onCancel = onCancel;
        vm.addOrderline = addOrderline;
        vm.deleteOrderline = deleteOrderline;
        vm.getPackageTypes = getPackageTypes;

        vm.packageTypes;
        vm.orderlines;
        vm.remark;
        vm.qty1;
        vm.qty2;
        vm.qty3;
        vm.qtyHcp;
        vm.signatureOfDelivery;

        vm.showError = false;

        function getPackageTypes() {
            packagesService.getPackageTypes().then(function (packageTypes) {
                vm.packageTypes = packageTypes;

            }, function (data) {

            });
        }

        vm.getPackageTypes();

        function init() {
            initForm();
        }

        function initForm() {

            if (vm.delivery) {
                vm.orderlines = vm.delivery.orderlines;
                vm.remark = vm.delivery.remark;
                vm.showError = false;
            } else {
                resetForm();
            }
        }

        function resetForm() {
            vm.orderlines = [];
            vm.remark = null;
            vm.showError = false;
            vm.addOrderline();
        }

        function addOrderline() {

            vm.orderlines.push({
                packageTypeCode: null,
                signatureRequired: false
            });
        }

        function deleteOrderline(index) {

            vm.orderlines.splice(index, 1);
        }

        function submitStep2Form() {

            var deliveryDetails = null;
            var error = false;

            // temp validate for demo
            error = false;

            if (error) {
                vm.showError = true;
            } else {
                vm.showError = false;
                deliveryDetails = {
                    remark: vm.remark,
                    orderlines: [{
                        signatureRequired: true,
                        packageType: {
                            code: "NORML",
                            name: "Standaard pakket",
                            description: "Kleiner dan een groene Febelco bak",
                            id: 1
                        }
                    }, {
                        signatureRequired: true,
                        packageType: {
                            code: "LARGE",
                            name: "Groot pakket",
                            description: "Groter dan een groene Febelco bak",
                            id: 2
                        }
                    }]
                };

                vm.submitStep2({ $event: deliveryDetails });
            }
        }

        function onCancel() {

            vm.cancel();
        }
    }]
};

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep2DetailsReadComponent = exports.addStep2DetailsReadComponent = {
    template: __webpack_require__(524),
    bindings: {
        delivery: '<',
        editStep2: '&'
    },
    controllerAs: 'vm',
    controller: function addStep2DetailsReadController() {
        'ngInject';

        var vm = this;
        vm.onEditStep2 = onEditStep2;

        function onEditStep2() {

            vm.editStep2();
        }
    }
};

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep3ConfirmFormComponent = exports.addStep3ConfirmFormComponent = {
    template: __webpack_require__(525),
    bindings: {
        delivery: '<',
        submitStep3: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: function addStep3ConfirmFormController() {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.onSubmitStep3Form = onSubmitStep3Form;
        vm.onCancel = onCancel;

        vm.showError = false;
        vm.agreeWithTerms = false;

        function init() {
            resetForm();
        }

        function resetForm() {
            vm.agreeWithTerms = false;
            vm.showError = false;
        }

        function onSubmitStep3Form() {
            if (vm.agreeWithTerms) {
                vm.showError = false;
                vm.submitStep3();
            } else {
                vm.showError = true;
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }
};

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var howDoesItWorkBoxComponent = exports.howDoesItWorkBoxComponent = {
    template: __webpack_require__(526),
    bindings: {},
    controllerAs: 'vm',
    controller: function howDoesItWorkBoxController() {
        'ngInject';

        var vm = this;

        vm.$onInit = init;

        function init() {}
    }
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailContentComponent = exports.orderDetailContentComponent = {
    template: __webpack_require__(527),
    bindings: {
        order: '<',
        confirmation: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;

        vm.$onInit = init;

        function init() {}
    }
};

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderLineDetailComponent = exports.orderLineDetailComponent = {
    template: __webpack_require__(528),
    bindings: {
        line: '<',
        showLineState: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;



        vm.$onInit = init;

        function init() {}
    }
};

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderLineStateHistoryComponent = exports.orderLineStateHistoryComponent = {
    template: __webpack_require__(529),
    bindings: {
        lineId: '<'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function orderLineStateHistoryController(packagesService) {
        'ngInject';

        var vm = this;
        vm.stateHistory;
        vm.getStateHistory = getStateHistory;

        function getStateHistory() {
            packagesService.getStateHistory(vm.lineId).then(function (stateHistory) {
                vm.stateHistory = stateHistory;
            }, function (data) {

            });
        }

        vm.getStateHistory();
    }]
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderLineStateComponent = exports.orderLineStateComponent = {
    template: __webpack_require__(530),
    bindings: {
        state: '<'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function controller(packagesService) {
        'ngInject';

        var vm = this;
        vm.stateContext;
        vm.stateIcon;

        vm.$onInit = init;

        function init() {
            vm.stateContext = 'text-' + packagesService.getOrderStateContext(vm.state.code);
            vm.stateIcon = packagesService.getOrderStateIcon(vm.state.code);
        }
    }]
};

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderReceiverDetailComponent = exports.orderReceiverDetailComponent = {
    template: __webpack_require__(531),
    bindings: {
        receiver: '<'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function controller(packagesService) {
        'ngInject';

        var vm = this;



        vm.orderTypeName;
        vm.$onInit = init;

        function init() {
            vm.orderTypeName = packagesService.getContactTypeName(vm.receiver.orderTypeId);
        }
    }]
};

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderSearchResultItemComponent = exports.orderSearchResultItemComponent = {
    template: __webpack_require__(532),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;



        vm.$onInit = init;

        function init() {}
    }
};

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderStateComponent = exports.orderStateComponent = {
    template: __webpack_require__(533),
    bindings: {
        state: '<'
    },
    controllerAs: 'vm',
    controller: ["packagesService", function controller(packagesService) {
        'ngInject';

        var vm = this;
        vm.stateContext;
        vm.stateIcon;

        vm.$onInit = init;

        function init() {
            vm.stateContext = 'text' + packagesService.getOrderStateContext(vm.state.code);
            vm.stateIcon = packagesService.getOrderStateIcon(vm.state.code);
        }
    }]
};

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderAddConfirmationComponent = exports.podOrderAddConfirmationComponent = {
    template: __webpack_require__(534),
    controllerAs: 'vm',
    bindings: {
        order: '<'
    },
    controller: function podOrderAddrConfirmationController() {
        'ngInject';
    }
};

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderAddComponent = exports.podOrderAddComponent = {
    template: __webpack_require__(535),
    controllerAs: 'vm',
    bindings: {},
    controller: ["common", "gettextCatalog", "$state", function podOrderAddController(common, gettextCatalog, $state) {
        'ngInject';

        var vm = this;

        vm.currentStep = 0;

        vm.receiver;
        vm.delivery;

        vm.initForm = initForm;
        vm.selectReceiver = selectReceiver;
        vm.editReceiver = editReceiver;
        vm.submitStep2 = submitStep2;
        vm.editStep2 = editStep2;
        vm.submitStep3 = submitStep3;
        vm.cancel = cancel;

        vm.$onInit = init;

        function init() {
            common.setTitle(gettextCatalog.getString('Add package'));

            initForm();
        }

        function initForm() {
            vm.currentStep = 1;
            vm.receiver = null;
            vm.delivery = null;
        }

        function selectReceiver($event) {
            vm.currentStep = 2;
            vm.receiver = $event;
        }

        function submitStep2($event) {
            vm.currentStep = 3;
            vm.delivery = $event;
        }

        function submitStep3($event) {
            vm.currentStep = 4;

            $state.go('add-package-confirmation');
        }

        function editReceiver() {
            vm.currentStep = 1;
        }

        function editStep2() {
            vm.currentStep = 2;
        }

        function cancel() {
            $state.go('my-packages');
        }
    }]
};

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderArchiveComponent = exports.podOrderArchiveComponent = {
    template: __webpack_require__(536),
    controllerAs: 'vm',
    bindings: {
        orders: '<'
    },
    controller: ["common", "gettextCatalog", function podOrderArchiveController(common, gettextCatalog) {
        'ngInject';

        var vm = this;

        vm.search = search;
        vm.clear = clear;

        vm.$onInit = init;
        vm.model = {
            results: [],
            paging: {
                totalItems: 23,
                itemsPerPage: 12,
                page: 1,
                pageCount: 2,
                pageNumbers: [{
                    index: 1,
                    isHiddenOnMobile: false
                }, {
                    index: 2,
                    isHiddenOnMobile: false
                }]
            }
        };

        function init() {
            common.setTitle(gettextCatalog.getString('Al mijn verzendingen'));
        }

        function search() {}

        function clear() {}
    }]
};

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderDetailComponent = exports.podOrderDetailComponent = {
    template: __webpack_require__(537),
    controllerAs: 'vm',
    bindings: {
        order: '<'
    },
    controller: ["common", "gettextCatalog", function podOrderDetailController(common, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            common.setTitle(gettextCatalog.getString('Verzending') + ' ' + vm.order.number);


        }
    }]
};

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var podOrderOverviewComponent = exports.podOrderOverviewComponent = {
    template: __webpack_require__(538),
    controllerAs: 'vm',
    bindings: {
        recentOrders: '<'
    },
    controller: ["common", "gettextCatalog", function podOrderOverviewController(common, gettextCatalog) {
        'ngInject';

        var vm = this;

        vm.$onInit = init;

        function init() {

            common.setTitle(gettextCatalog.getString('Mijn verzendingen'));
        }
    }]
};

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var myReservationsComponent = exports.myReservationsComponent = {
    template: __webpack_require__(539),
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", function myReservationsController(common, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.myFebelcoLink = 'https://www.myfebelco.be/MyPharmacy/Reservations';

        function init() {
            common.setTitle(gettextCatalog.getString('Overzicht producten in reservatie'));
        }
    }]
};

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderDetailComponent = exports.orderDetailComponent = {
    template: __webpack_require__(540),
    bindings: {
        order: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "authService", "config", "$stateParams", "orderService", "Analytics", function orderDetailController(common, gettextCatalog, authService, config, $stateParams, orderService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.setOrderDeliveryDate = setOrderDeliveryDate;
        vm.updateOrderDeliverDateErrors = [];
        vm.updatingOrderDate = false;

        function init() {
            common.navigationMenu.clearActiveMenu();
            var pageTitle = vm.order.referenceNumber ? gettextCatalog.getString('Order - noun') + ' ' + vm.order.referenceNumber : gettextCatalog.getString('Order - noun');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/orders/' + vm.order.id, pageTitle);
        }

        function getDownloadUrl() {
            return config.webApiBaseUrl + ('report/orderDetail/' + vm.order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function setOrderDeliveryDate(newDeliveryDate) {
            vm.updatingOrderDate = true;
            orderService.setOrderDeliveryDate(vm.order, newDeliveryDate).then(function (order) {
                vm.order = order;
                vm.updatingOrderDate = false;
                vm.updateOrderDeliverDateErrors = [];
            }).catch(function (err) {
                vm.updateOrderDeliverDateErrors = err.data.errors;
                vm.updatingOrderDate = false;
            });
        }
    }]
};

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderOverviewComponent = exports.orderOverviewComponent = {
    template: __webpack_require__(541),
    bindings: {
        input: '<',
        sellers: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "gettextCatalog", "orderService", "exceptionService", "Paging", "config", "authService", "$stateParams", "$window", "cartService", "$state", "toastr", "Analytics", "Enums", function orderOverviewController($scope, common, gettextCatalog, orderService, exceptionService, Paging, config, authService, $stateParams, $window, cartService, $state, toastr, Analytics, Enums) {
        'ngInject';

        var vm = this;
        vm.orders = vm.input.orders;
        vm.searchValue = '';
        vm.paging = null;
        vm.sortProperty = 'OrderDate';
        vm.sortAsc = false;
        vm.isLoading = false;
        vm.isAddingToCart = false;
        vm.getOrders = getOrders;
        vm.search = search;
        vm.goToPage = goToPage;
        vm.changeSorting = changeSorting;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.reOrderProducts = reOrderProducts;
        vm.itemsPerPage = Enums.getAmounts.default;

        angular.element($window).on('keydown', function (event) {
            if (event.which === 13 && !vm.isLoading) {
                vm.getOrders();
            }
        });

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('My orders'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/orders', gettextCatalog.getString('My orders'));

            vm.selectedSeller = vm.sellers[0];
            vm.paging = Paging.create({
                page: 1,
                itemsPerPage: vm.itemsPerPage,
                totalItems: vm.input.totalItems
            });
        }

        function getOrders() {
            common.log.info('search orders: searchValue ' + vm.searchValue + ', page ' + vm.paging.page + ', sort by ' + vm.sortProperty + ', sort asc ' + vm.sortAsc);

            vm.isLoading = true;
            orderService.getByCriteria(vm.searchValue, vm.paging.page, vm.itemsPerPage, vm.sortProperty, vm.sortAsc, vm.selectedSeller.id).then(function (result) {
                vm.orders = result.orders;
                vm.paging = Paging.create({
                    page: vm.paging.page,
                    itemsPerPage: vm.itemsPerPage,
                    totalItems: result.totalItems
                });
            }).catch(function () {
                var msg = gettextCatalog.getString('The orders could not be retrieved');
                exceptionService.logException(msg);
            }).finally(function () {
                return vm.isLoading = false;
            });
        }

        function search(e) {
            vm.searchValue = e.searchValue;
            vm.selectedSeller = e.selectedSeller;
            vm.paging.page = 1;
            getOrders();
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            vm.paging.page = page;
            getOrders();
        }

        function changeSorting(sortProperty) {
            vm.sortAsc = vm.sortProperty === sortProperty ? !vm.sortAsc : true;
            vm.sortProperty = sortProperty;
            vm.paging.page = 1;
            getOrders();
        }

        function getDownloadUrl(order) {
            return config.webApiBaseUrl + ('report/orderDetail/' + order.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function reOrderProducts(order) {
            vm.isAddingToCart = true;
            cartService.reOrderProducts(order.id).then(function () {
                vm.isAddingToCart = false;

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {
                vm.isAddingToCart = false;

                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                var msg = gettextCatalog.getString('An error occurred during the re order. Please contact the customer support.');
                exceptionService.logException(msg);
            });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep1SelectReceiverFormComponent = exports.parcelAddStep1SelectReceiverFormComponent = {
    template: __webpack_require__(542),
    controllerAs: 'vm',
    bindings: {
        receiver: '<',
        selectReceiver: '&',
        validateReceiver: '&',
        cancel: '&'
    },
    controller: ["gettextCatalog", function parcelAddStep1SelectReceiverFormController(gettextCatalog) {
        'ngInject';

        var vm = this;

        vm.orderTypeId;
        vm.licenseNumber;
        vm.error;
        vm.errorNotFound;

        vm.$onInit = init;
        vm.submitStep1Form = submitStep1Form;
        vm.onCancel = onCancel;

        function init() {
            resetStep1Form();
        }

        function resetStep1Form() {
            vm.orderTypeId = 1;
            vm.licenseNumber = vm.receiver ? vm.receiver.licenseNumber : null;
            vm.error = null;
            vm.errorNotFound = false;
        }

        function submitStep1Form() {
            if (!vm.licenseNumber) {
                vm.error = gettextCatalog.getString('parcel.enterLicenseNumberShort');
                vm.errorNotFound = false;
                return;
            } else if (isNaN(vm.licenseNumber)) {
                vm.errorNotFound = true;
                vm.error = null;
            } else {
                vm.validateReceiver({ $event: { licenseNumber: vm.licenseNumber } }).then(function (response) {
                    vm.error = null;
                    vm.errorNotFound = false;
                    vm.selectReceiver({ $event: response });
                }, function () {
                    vm.errorNotFound = true;
                    vm.error = null;
                });
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }]
};

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep1SelectReceiverReadComponent = exports.parcelAddStep1SelectReceiverReadComponent = {
    template: __webpack_require__(543),
    bindings: {
        receiver: '<',
        editReceiver: '&',
        editable: '<'
    },
    controllerAs: 'vm',
    controller: function parcelAddStep1SelectReceiverReadController() {
        'ngInject';

        var vm = this;
        vm.onEditStep1 = onEditStep1;

        function onEditStep1() {
            vm.editReceiver();
        }
    }
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep2DetailsFormComponent = exports.parcelAddStep2DetailsFormComponent = {
    template: __webpack_require__(544),
    bindings: {
        receiver: '<',
        delivery: '<',
        submitStep2: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: ["gettextCatalog", "parcelService", function parcelAddStep2DetailsFormController(gettextCatalog, parcelService) {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.submitStep2Form = submitStep2Form;
        vm.onCancel = onCancel;
        vm.addOrderline = addOrderline;
        vm.deleteOrderline = deleteOrderline;
        vm.onPackageTypeSelection = onPackageTypeSelection;

        vm.packageTypes = parcelService.podPackageTypes;

        vm.orderlines;
        vm.remark;
        vm.qty1;
        vm.qty2;
        vm.qty3;
        vm.qtyHcp;

        function init() {
            initForm();
        }

        function initForm() {
            if (vm.delivery) {
                vm.orderlines = vm.delivery.orderlines;
                vm.remark = vm.delivery.remark;
            } else {
                resetForm();
            }
        }

        function resetForm() {
            vm.orderlines = [];
            vm.remark = null;
            vm.addOrderline();
        }

        function addOrderline() {
            vm.orderlines.push({
                packageType: null,
                packageTypeCode: null,
                hasInsurance: false,
                packageValue: null,
                insurancePriceDescription: null,
                packageTypeError: null
            });
        }

        function onPackageTypeSelection(index) {
            var ol = vm.orderlines[index];
            var insurancePrice = vm.packageTypes.find(function (pt) {
                return pt.code === ol.packageTypeCode;
            }).insurancePrice;
            ol.insurancePriceDescription = gettextCatalog.getString('parcel.insuranceDescription', { insurancePrice: insurancePrice });
        }

        function deleteOrderline(index) {
            vm.orderlines.splice(index, 1);
        }

        function submitStep2Form() {
            if (vm.formReference.$valid) {
                vm.orderlines.forEach(function (element) {
                    element.packageTypeError = !element.packageTypeCode ? gettextCatalog.getString('parcel.pleaseSelectPackageType') : null;
                });
                if (!vm.orderlines.find(function (x) {
                    return x.packageTypeError;
                })) {
                    var deliveryDetails = {
                        remark: vm.remark,
                        orderlines: vm.orderlines.map(function (orderLine) {
                            orderLine.packageType = vm.packageTypes.find(function (pt) {
                                return pt.code === orderLine.packageTypeCode;
                            });
                            return orderLine;
                        })
                    };
                    vm.submitStep2({ $event: deliveryDetails });
                }
            }
        }
        function onCancel() {
            vm.cancel();
        }
    }]
};

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep2DetailsReadComponent = exports.parcelAddStep2DetailsReadComponent = {
    template: __webpack_require__(545),
    bindings: {
        delivery: '<',
        editStep2: '&',
        editable: '<'
    },
    controllerAs: 'vm',
    controller: function parcelAddStep2DetailsReadController() {
        'ngInject';

        var vm = this;
        vm.onEditStep2 = onEditStep2;

        function onEditStep2() {
            vm.editStep2();
        }
    }
};

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep3ConfirmFormComponent = exports.parcelAddStep3ConfirmFormComponent = {
    template: __webpack_require__(546),
    bindings: {
        delivery: '<',
        submitStep3: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: function parcelAddStep3ConfirmFormController() {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.onSubmitStep3Form = onSubmitStep3Form;
        vm.onCancel = onCancel;
        vm.showError = false;
        vm.agreeWithTerms = false;

        function init() {
            resetForm();
        }

        function resetForm() {
            vm.agreeWithTerms = false;
            vm.showError = false;
        }

        function onSubmitStep3Form() {
            if (vm.agreeWithTerms) {
                vm.showError = false;
                vm.submitStep3();
            } else {
                vm.showError = true;
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelDetailContentComponent = exports.parcelDetailContentComponent = {
    template: __webpack_require__(547),
    bindings: {
        parcel: '<',
        confirmation: '<',
        cancel: '&?',
        canCancel: '<?'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;

        vm.onCancel = onCancel;

        function onCancel(lineId) {
            return vm.cancel(lineId);
        }
    }
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelHowDoesItWorkBoxComponent = exports.parcelHowDoesItWorkBoxComponent = {
    template: __webpack_require__(548),
    bindings: {},
    controllerAs: 'vm',
    controller: function parcelHowDoesItWorkBoxController() {
        'ngInject';
    }
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelLineDetailComponent = exports.parcelLineDetailComponent = {
    template: __webpack_require__(549),
    bindings: {
        line: '<',
        showLineState: '<',
        cancel: '&?',
        canCancel: '<?'
    },
    controllerAs: 'vm',
    controller: ["gettextCatalog", "parcelService", function controller(gettextCatalog, parcelService) {
        'ngInject';

        var vm = this;
        vm.stateHistory;

        vm.insuranceDescription = gettextCatalog.getString('parcel.insuranceDescription', { insurancePrice: vm.line.packageType.insurancePrice });
        vm.getLabelUrl = getLabelUrl;
        vm.loadHistory = loadHistory;
        vm.canCancelLine = canCancelLine;
        vm.onCancel = onCancel;

        function loadHistory() {
            if (!vm.stateHistory) {
                parcelService.getStateHistory(vm.line.id).then(function (response) {
                    vm.stateHistory = response.stateHistory;
                });
            }
        }

        function getLabelUrl() {
            return parcelService.getLabelDownloadUrl(vm.line.id);
        }

        function canCancelLine() {
            return vm.canCancel && (vm.line.state.code === 'CREATED' || vm.line.state.code === 'REG');
        }

        function onCancel() {
            vm.cancel();
        }
    }]
};

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelLineStateHistoryComponent = exports.parcelLineStateHistoryComponent = {
    template: __webpack_require__(550),
    bindings: {
        stateHistory: '<'
    },
    controllerAs: 'vm',
    controller: ["parcelService", function parcelLineStateHistoryController(parcelService) {
        'ngInject';

        var vm = this;
        vm.getContext = getContext;
        function getContext(code) {
            return 'text-' + parcelService.getOrderStateContext(code);
        }
    }]
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelLineStateComponent = exports.parcelLineStateComponent = {
    template: __webpack_require__(551),
    bindings: {
        state: '<'
    },
    controllerAs: 'vm',
    controller: ["parcelService", function controller(parcelService) {
        'ngInject';

        var vm = this;
        vm.stateContext;
        vm.stateIcon;

        vm.$onInit = init;

        function init() {
            vm.stateContext = 'text-' + parcelService.getOrderStateContext(vm.state.code);
            vm.stateIcon = parcelService.getOrderStateIcon(vm.state.code);
        }
    }]
};

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelReceiverDetailComponent = exports.parcelReceiverDetailComponent = {
    template: __webpack_require__(552),
    bindings: {
        receiver: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';
    }
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelSearchResultItemComponent = exports.parcelSearchResultItemComponent = {
    template: __webpack_require__(553),
    bindings: {
        parcel: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';
    }
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelStateComponent = exports.parcelStateComponent = {
    template: __webpack_require__(554),
    bindings: {
        state: '<'
    },
    controllerAs: 'vm',
    controller: ["parcelService", function controller(parcelService) {
        'ngInject';

        var vm = this;
        vm.stateContext;
        vm.stateIcon;

        vm.$onInit = init;

        function init() {
            vm.stateContext = 'text' + parcelService.getOrderStateContext(vm.state.code);
            vm.stateIcon = parcelService.getOrderStateIcon(vm.state.code);
        }
    }]
};

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddConfirmationComponent = exports.parcelAddConfirmationComponent = {
    template: __webpack_require__(555),
    controllerAs: 'vm',
    bindings: {
        parcel: '<'
    },
    controller: ["common", "gettextCatalog", "Analytics", function parcelAddConfirmationController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.yourParcelWasRegistered');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/add-parcel-confirmation', pageTitle);
        }
    }]
};

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddComponent = exports.parcelAddComponent = {
    template: __webpack_require__(556),
    controllerAs: 'vm',
    bindings: {},
    controller: ["common", "gettextCatalog", "$state", "parcelService", "Analytics", function parcelAddController(common, gettextCatalog, $state, parcelService, Analytics) {
        'ngInject';

        var vm = this;

        vm.currentStep = 0;

        vm.receiver;
        vm.delivery;

        vm.initForm = initForm;
        vm.validateReceiver = validateReceiver;
        vm.selectReceiver = selectReceiver;
        vm.editReceiver = editReceiver;
        vm.submitStep2 = submitStep2;
        vm.editStep2 = editStep2;
        vm.submitStep3 = submitStep3;
        vm.cancel = cancel;

        vm.$onInit = init;

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.createParcel');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/add-parcel', pageTitle);
            initForm();
        }

        function initForm() {
            vm.currentStep = 1;
            vm.receiver = null;
            vm.delivery = null;
        }

        function selectReceiver($event) {
            vm.currentStep = 2;
            vm.receiver = $event;
        }

        function validateReceiver($event) {
            return parcelService.validateReceiver($event.licenseNumber);
        }

        function submitStep2($event) {
            vm.currentStep = 3;
            vm.delivery = $event;
        }

        function submitStep3() {
            vm.currentStep = 4;

            var parcelAdd = {
                receiverCustomerNumber: vm.receiver.customerNumber,
                receiverLicenseNumber: vm.receiver.licenseNumber,
                remark: vm.delivery.remark,
                lines: vm.delivery.orderlines.map(function (ol) {
                    return { packageTypeId: ol.packageType.id,
                        packageValue: ol.packageValue, hasInsurance: ol.hasInsurance
                    };
                })
            };

            parcelService.add(vm.receiver.contactTypeId, parcelAdd).then(function (response) {
                $state.go('add-parcel-confirmation', { id: response.id });
            }).catch(function () {
                $state.go('error', {}, {
                    location: false
                });
            });
        }

        function editReceiver() {
            vm.currentStep = 1;
        }

        function editStep2() {
            vm.currentStep = 2;
        }

        function cancel() {
            $state.go('parcels');
        }
    }]
};

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parcelArchiveComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parcelArchiveComponent = exports.parcelArchiveComponent = {
    template: __webpack_require__(557),
    controllerAs: 'vm',
    bindings: {
        parcels: '<'
    },
    controller: ["$scope", "$state", "$stateParams", "common", "gettextCatalog", "Paging", "parcelService", "Analytics", function parcelArchiveController($scope, $state, $stateParams, common, gettextCatalog, Paging, parcelService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.isSearchUsed = isSearchUsed;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.ordersLoading = false;
        vm.dateFormat = 'YYYY-MM-DD';
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.allMyParcels');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/parcel-archive', pageTitle);

            loadData(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadData(vm.paging.itemsPerPage);
            });
        }

        function loadData(itemsPerPage) {
            vm.ordersLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return parcelService.search(params).then(function (response) {
                vm.model = response;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.ordersLoading = false;
            });
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                identification: $stateParams.identification,
                orderNumber: $stateParams.orderNumber,
                barCode: $stateParams.barCode,
                dateFrom: $stateParams.dateFrom,
                dateTo: $stateParams.dateTo
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                identification: vm.model.search.identification,
                orderNumber: vm.model.search.orderNumber,
                barCode: vm.model.search.barCode,
                dateFrom: vm.model.search.dateFrom && (0, _moment2.default)(vm.model.search.dateFrom).format(vm.dateFormat),
                dateTo: vm.model.search.dateTo && (0, _moment2.default)(vm.model.search.dateTo).format(vm.dateFormat)
            });
        }

        function clear() {
            vm.model.search.identification = null;
            vm.model.search.orderNumber = null;
            vm.model.search.barCode = null;
            vm.model.search.dateFrom = null;
            vm.model.search.dateTo = null;

            search();
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }

        function isSearchUsed() {
            return !!$stateParams.identification && $stateParams.identification.length > 0 || !!$stateParams.orderNumber && $stateParams.orderNumber.length > 0 || !!$stateParams.barCode && $stateParams.barCode.length > 0 || !!$stateParams.dateFrom || !!$stateParams.dateTo;
        }
    }]
};

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelDetailComponent = exports.parcelDetailComponent = {
    template: __webpack_require__(558),
    controllerAs: 'vm',
    bindings: {
        parcelId: '<'
    },
    controller: ["common", "gettextCatalog", "parcelService", "toastr", "Analytics", function parcelDetailController(common, gettextCatalog, parcelService, toastr, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.cancel = cancel;
        vm.cancelLine = cancelLine;
        vm.cancelOrder = cancelOrder;
        vm.orderCanBeCancelled = orderCanBeCancelled;
        vm.canCancel = true;

        function init() {
            refreshParcel().then(function () {
                var pageTitle = gettextCatalog.getString('parcel.parcel') + ' ' + vm.parcel.number;
                common.setTitle(pageTitle);
                Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels/parcel-detail/' + vm.parcel.id, pageTitle);
            });
        }

        function refreshParcel() {
            return parcelService.get(vm.parcelId).then(function (result) {
                vm.parcel = result;
            });
        }

        function cancelLine(lineId) {
            return cancel([lineId]);
        }

        function cancelOrder() {
            return cancel(vm.parcel.lines.map(function (line) {
                return line.id;
            }));
        }

        function cancel(lineIds) {
            return parcelService.cancel(vm.parcel.type.id, lineIds).then(function () {
                toastr.success(gettextCatalog.getString('parcel.parcelCancelCommandSent'), '', {
                    progressBar: true,
                    timeOut: 3000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
                refreshParcel();
            }).catch(function () {
                toastr.error(gettextCatalog.getString('parcel.errorSendingCancelCommand'), '', {
                    timeOut: 3000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
            });
        }

        function orderCanBeCancelled() {
            return !vm.parcel.lines.find(function (line) {
                return line.state.code !== 'CREATED' && line.state.code !== 'REG';
            }) && vm.canCancel;
        }
    }]
};

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelsOverviewComponent = exports.parcelsOverviewComponent = {
    template: __webpack_require__(559),
    controllerAs: 'vm',
    bindings: {},
    controller: ["common", "gettextCatalog", "parcelService", "Analytics", function parcelsOverviewController(common, gettextCatalog, parcelService, Analytics) {
        'ngInject';

        var vm = this;
        vm.recentOrders = [];

        vm.$onInit = init;

        function init() {
            var pageTitle = gettextCatalog.getString('parcel.myParcels');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/parcels', pageTitle);

            parcelService.getRecentOrders().then(function (results) {
                return vm.recentOrders = results;
            });
        }
    }]
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalOverviewComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalOverviewComponent = exports.rentalOverviewComponent = {
    template: __webpack_require__(560),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<',
        statuses: '<'
    },
    controller: ["rentalProductsService", "config", "common", "gettextCatalog", "$stateParams", "authService", "$q", "Analytics", function rentalOverviewController(rentalProductsService, config, common, gettextCatalog, $stateParams, authService, $q, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.productsLoading = false;
        vm.ordersLoading = false;
        vm.recentRentEndedProductsLoading = false;
        vm.loadOrders = loadOrders;
        vm.getDownloadUrl = getDownloadUrl;
        vm.getInRentStatus = getInRentStatus;
        vm.getRentEndedStatus = getRentEndedStatus;
        vm.rentingProductsTotalCount = 0;
        vm.recentRentEndedProductsCount = 0;
        vm.rentEndedProductsTotalCount = 0;
        vm.ordersTotalCount = 0;

        function init() {
            common.setTitle(gettextCatalog.getString('My rent overview'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals', gettextCatalog.getString('My rent overview'));
            loadInRentProducts();
            loadRecentRentEndedProducts();
            loadOrders();
        }

        function loadInRentProducts() {
            vm.productsLoading = true;
            var search = {
                skip: 0,
                take: 15,
                statusId: vm.getInRentStatus().id
            };
            rentalProductsService.getRentalHistory(search).then(function (response) {
                vm.products = response.results;
                vm.rentingProductsTotalCount = response.count;
                vm.productsLoading = false;
            });
        }

        function loadRecentRentEndedProducts() {
            vm.recentRentEndedProductsLoading = true;
            var search = {
                skip: 0,
                take: 15,
                statusId: vm.getRentEndedStatus().id,
                minDate: (0, _moment2.default)().add(-3, 'months').format('YYYY-MM-DD')
            };
            var totalCountSearch = {
                skip: 0,
                take: 1,
                statusId: vm.getRentEndedStatus().id
            };
            $q.all([rentalProductsService.getRentalHistory(search), rentalProductsService.getRentalHistory(totalCountSearch)]).then(function (response) {
                vm.rentEndedProducts = response[0].results;
                vm.recentRentEndedProductsCount = response[0].count;
                vm.rentEndedProductsTotalCount = response[1].count;
                vm.recentRentEndedProductsLoading = false;
            });
        }

        function loadOrders() {
            vm.ordersLoading = true;
            var search = {
                skip: 0,
                take: 15,
                minDate: (0, _moment2.default)().add(-3, 'months').format('YYYY-MM-DD')
            };
            rentalProductsService.searchRentalOrders(search).then(function (response) {
                vm.orders = response.results;
                vm.ordersTotalCount = response.count;
                vm.ordersLoading = false;
            });
        }

        function getInRentStatus() {
            return vm.statuses.find(function (x) {
                return x.code === '20';
            });
        }

        function getRentEndedStatus() {
            return vm.statuses.find(function (x) {
                return x.code === '40';
            });
        }

        function getDownloadUrl(rentalOrder) {
            return config.webApiBaseUrl + ('report/rentalOrderDetail/' + rentalOrder.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }
    }]
};

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalRequestArchiveComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalRequestArchiveComponent = exports.rentalRequestArchiveComponent = {
    template: __webpack_require__(561),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<'
    },
    controller: ["$scope", "$state", "rentalProductsService", "config", "common", "gettextCatalog", "Paging", "$stateParams", "authService", "Analytics", function rentalRequestArchiveController($scope, $state, rentalProductsService, config, common, gettextCatalog, Paging, $stateParams, authService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.isSearchUsed = isSearchUsed;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.ordersLoading = false;
        vm.years = [];
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });
        vm.getDownloadUrl = getDownloadUrl;

        function init() {
            common.setTitle(gettextCatalog.getString('All my rental requests'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals/request-archive', gettextCatalog.getString('All my rental requests'));

            var currentYear = (0, _moment2.default)().get('year');
            var minYear = 2019;
            vm.years = Array.from({ length: currentYear - minYear + 1 }, function (v, i) {
                return currentYear - i;
            });

            loadOrders(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadOrders(vm.paging.itemsPerPage);
            });
        }

        function loadOrders(itemsPerPage) {
            vm.ordersLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return rentalProductsService.searchRentalOrders(params).then(function (response) {
                vm.model = response;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.ordersLoading = false;
            });
        }

        function getDownloadUrl(rentalOrder) {
            return config.webApiBaseUrl + ('report/rentalOrderDetail/' + rentalOrder.id + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                product: $stateParams.product,
                year: $stateParams.year
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                product: vm.model.search.product,
                year: vm.model.search.year
            });
        }

        function clear() {
            vm.model.search.product = null;
            vm.model.search.year = null;

            search();
        }

        function isSearchUsed() {
            return isNullOrEmpty($stateParams.statusId) || isNullOrEmpty($stateParams.product) || isNullOrEmpty($stateParams.remark) || isNullOrEmpty($stateParams.year) || isNullOrEmpty($stateParams.depositRefunded);
        }

        function isNullOrEmpty(str) {
            return !!str && str.length > 0;
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }
    }]
};

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentedProductArchiveComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentedProductArchiveComponent = exports.rentedProductArchiveComponent = {
    template: __webpack_require__(562),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<',
        statuses: '<'
    },
    controller: ["$scope", "$state", "common", "gettextCatalog", "rentalProductsService", "$stateParams", "Paging", "Analytics", function rentedProductArchiveController($scope, $state, common, gettextCatalog, rentalProductsService, $stateParams, Paging, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.isSearchUsed = isSearchUsed;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.historyLoading = false;
        vm.years = [];
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });

        function init() {
            common.setTitle(gettextCatalog.getString('All my rented products'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals/rented-product-archive', gettextCatalog.getString('All my rented products'));

            var currentYear = (0, _moment2.default)().get('year');
            var minYear = 2019;
            vm.years = Array.from({ length: currentYear - minYear + 1 }, function (v, i) {
                return currentYear - i;
            });

            loadProducts(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadProducts(vm.paging.itemsPerPage);
            });
        }

        function loadProducts(itemsPerPage) {
            vm.historyLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return rentalProductsService.getRentalHistory(params).then(function (response) {
                vm.model = response;
                vm.model.search.status = vm.statuses.find(function (x) {
                    return x.id === vm.model.search.statusId;
                });
                vm.model.search.depositRefunded = vm.model.search.depositRefunded !== null ? String(vm.model.search.depositRefunded) : null;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.historyLoading = false;
            });
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                statusId: $stateParams.statusId ? parseInt($stateParams.statusId) : null,
                product: $stateParams.product,
                remark: $stateParams.remark,
                year: $stateParams.year,
                depositRefunded: $stateParams.depositRefunded
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                product: vm.model.search.product,
                statusId: vm.model.search.status && vm.model.search.status.id,
                year: vm.model.search.year,
                remark: vm.model.search.remark,
                depositRefunded: vm.model.search.depositRefunded
            });
        }

        function clear() {
            vm.model.search.product = null;
            vm.model.search.statusId = null;
            vm.model.search.status = null;
            vm.model.search.year = null;
            vm.model.search.remark = null;
            vm.model.search.depositRefunded = null;

            search();
        }

        function isSearchUsed() {
            return isNullOrEmpty($stateParams.statusId) || isNullOrEmpty($stateParams.product) || isNullOrEmpty($stateParams.remark) || isNullOrEmpty($stateParams.year) || isNullOrEmpty($stateParams.depositRefunded);
        }

        function isNullOrEmpty(str) {
            return !!str && str.length > 0;
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }
    }]
};

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentedProductDetailComponent = exports.rentedProductDetailComponent = {
    template: __webpack_require__(563),
    controllerAs: 'vm',
    bindings: {
        tgzId: '<',
        rentalHistory: '<'
    },
    controller: ["common", "gettextCatalog", "rentalProductsService", "Analytics", function rentedProductDetailController(common, gettextCatalog, rentalProductsService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$onChanges = bindingChanges;
        vm.saveRemark = saveRemark;
        vm.clearRemark = clearRemark;
        vm.isEditingRemark = false;
        vm.remark = '';
        vm.rentalProductsService = rentalProductsService;

        function init() {
            var pageTitle = vm.rentalHistory.productName ? gettextCatalog.getString('Rented product detail') + ' ' + vm.rentalHistory.productName + ' - ' + vm.rentalHistory.sellerArticleNumber : gettextCatalog.getString('Rented product detail');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/rentals/rented-product-archive/' + vm.rentalHistory.id, pageTitle);
        }

        function bindingChanges(changes) {
            if (changes.rentalHistory && changes.rentalHistory.currentValue) {
                vm.rentalHistory = changes.rentalHistory.currentValue;
                vm.remark = vm.rentalHistory.remark;
            }
        }

        function saveRemark() {
            vm.rentalProductsService.setHistoryRemark(vm.rentalHistory.id, vm.rentalHistory.version, vm.remark).then(function (response) {
                vm.rentalHistory = response;
                vm.remark = vm.rentalHistory.remark;
                vm.isEditingRemark = false;
            });
        }

        function clearRemark() {
            vm.remark = '';
        }
    }]
};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accountSettingsComponent = undefined;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountSettingsComponent = exports.accountSettingsComponent = {
    template: __webpack_require__(564),
    bindings: {
        user: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "authService", "$rootScope", "userService", "Enums", "$scope", "$window", "gettextCatalog", "Analytics", "ngDialog", function controller(common, authService, $rootScope, userService, Enums, $scope, $window, gettextCatalog, Analytics, ngDialog) {
        'ngInject';

        var vm = this;
        vm.name = '';
        vm.apbNumber = '';
        vm.tenants = null;
        vm.selectTenant = selectTenant;
        vm.signOut = signOut;
        vm.$onInit = init;
        vm.modifyName = modifyName;
        vm.modifyPassword = modifyPassword;
        vm.modifyEmail = modifyEmail;
        vm.modifyBuyerEmail = modifyBuyerEmail;
        vm.showModifyBuyerEmail = showModifyBuyerEmail;
        vm.getEmailLanguages = getEmailLanguages;
        vm.amr = '';
        vm.showModifyEmail = false;
        vm.newMail = '';
        vm.selectedLanguage = vm.getEmailLanguages()[0];
        vm.selectedLanguageChanged = selectedLanguageChanged;
        vm.showModifyCommunicationLanguage = showModifyCommunicationLanguage;
        vm.modifyCommunicationLanguage = false;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.changeBuyerBase = changeBuyerBase;
        vm.isShopAdmin = null;

        //update email/communicationlanguage on enter
        angular.element($window).on('keydown', function (event) {
            if (event.which === 13) {
                if (vm.modifyCommunicationLanguage) {
                    vm.selectedLanguageChanged();
                }
                if (vm.showModifyEmail) {
                    vm.modifyBuyerEmail();
                }
            }
        });

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('My account'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account', gettextCatalog.getString('My account'));
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.name = authService.user.display_name;
            vm.apbNumber = activeTenant.apbNumber;
            vm.tenants = tenants;
            vm.pharmacyName = activeTenant.name;
            vm.canViewPackages = activeTenant.canViewPackages;
            vm.email = authService.user.email;
            vm.amr = authService.user.amr;
            vm.showModifyEmail = false;
            vm.communicationLanguage = _lodash2.default.find(Enums.emailLanguages, { 'id': vm.user.communicationLanguageId });
            vm.isShopAdmin = authService.hasClaim('ShopAdmin');
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function selectTenant(tenant) {
            var _this = this;

            authService.signIn('/', { tenant: tenant }).catch(function () {
                _this.$log.warn('Signin with tenant failed');
            });
            $rootScope.$broadcast('tenant-changed', { secondaryAppUserKey: tenant });
        }

        function signOut() {
            authService.signOut();
        }

        function modifyPassword() {
            return common.config.ssoBaseUrl + '/account?tab=password';
        }

        function modifyName() {
            return common.config.ssoBaseUrl + '/account?tab=general';
        }

        function modifyEmail() {
            return common.config.ssoBaseUrl + '/account?tab=primaryEmail';
        }
        function modifyBuyerEmail() {
            return userService.setBuyerMail(vm.newMail).then(function () {
                userService.getMyAccount().then(function (u) {
                    vm.user.mail = u.mail;
                    showModifyBuyerEmail();
                });
            });
        }
        function showModifyBuyerEmail() {
            vm.showModifyEmail = !vm.showModifyEmail;
        }

        function getEmailLanguages() {
            return Enums.emailLanguages;
        }

        function selectedLanguageChanged() {
            userService.setBuyerMailLanguage(vm.selectedLanguage).then(function (res) {
                vm.communicationLanguage = _lodash2.default.find(Enums.emailLanguages, { 'id': res.id });
                vm.modifyCommunicationLanguage = false;
            });
        }

        function showModifyCommunicationLanguage() {
            vm.modifyCommunicationLanguage ? vm.modifyCommunicationLanguage = false : vm.modifyCommunicationLanguage = true;
        }

        function changeBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(result.id);
            });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _unauthorized = __webpack_require__(894);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.authorization', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider
    //.state('sso', {
    //    url: '/sso/:responsedata',
    //    skipAuthentication: true,
    //    resolve: {
    //        auth: function ($rootScope, $state, $location, $stateParams, authService) {
    //            'ngInject';
    //            //send the user to the correct page if they are authenticated/chose a tenant
    //            return authService.processSsoResponseData($location.absUrl())
    //                .then(function(result) {
    //                    if (result.isTenantChanged) {
    //                        $state.go('home', { language: 'nl', isTenantChanged: true });
    //                    }
    //                    else if (!result.hasCurrentTenant && result.toState !== 'unauthorized') {
    //                        if(authService.identity.tenants.length === 1) { // if there is one tenant automaticly choose that one
    //                            authService.signInWithTenant(authService.identity.tenants[0].secondaryAppUserKey, false);
    //                        } 
    //                        else {  //else show the select tenant screen
    //                            $state.go('login');
    //                        }
    //                    }
    //                    else {
    //                        $state.go(result.toState, result.toParams);                                 
    //                    }       
    //                })
    //                .catch(function() {
    //                    $state.go('unauthorized');
    //                });
    //        }
    //    }
    //})
    .state('unauthorized', {
        url: '/unauthorized',
        parent: 'master',
        views: {
            'main@root': {
                component: 'unauthorized'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': ''
        },
        data: {
            public: true
        }
    });
}]).component('unauthorized', _unauthorized.unauthorizedComponent);

exports.default = _module.name;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var unauthorizedComponent = exports.unauthorizedComponent = {
    template: __webpack_require__(565)
};

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var options = {
    template: __webpack_require__(566),
    bindings: {
        brand: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "$state", "Analytics", function controller($scope, productOverviewService, Enums, common, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.newsitems = [];
        vm.$onInit = init;

        function init() {
            common.navigationMenu.setBrandsActive();
            var pageTitle = vm.brand.name;
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/brands/' + vm.brand.id, pageTitle);

            //put the brandname in the params so it can be used on the news page breadcrumbs
            $state.params.breadcrumbName = vm.brand.name;

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.brand.id);
            productOverviewService.getProductsByBrand(true, vm.productOverviewModel, vm.brand.id).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByBrand(false, vm.productOverviewModel, vm.brand.id).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                });
            });
        }
    }]
};

exports.default = options;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _detail = __webpack_require__(895);

var _detail2 = _interopRequireDefault(_detail);

var _overview = __webpack_require__(898);

var _news = __webpack_require__(897);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.brand', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('brands', {
        parent: 'general',
        url: '/brands',
        views: {
            'main@root': {
                component: 'brandOverview'
            }
        },
        resolve: {
            brands: ["brandService", function brands(brandService) {
                return brandService.getAll();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Brands" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('brand', {
        parent: 'brands',
        url: '/{id:int}?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'brand'
            }
        },
        resolve: {
            brand: ["$stateParams", "brandService", function brand($stateParams, brandService) {
                return brandService.getById($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            pageSize: { value: '24', squash: true },
            sortProperty: { value: sortProperties['UnitPrice'].value, squash: true },
            sortAsc: { value: (sortProperties['UnitPrice'].defaultSorting === 'asc').toString(), squash: true },
            filter: { value: '', squash: true },
            breadcrumbName: ''
        },
        ncyBreadcrumb: {
            label: '{{$resolve.brand.name | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('brand-news', {
        parent: 'brand',
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'brandNews'
            }
        },
        resolve: {
            brand: ["$stateParams", "brandService", function brand($stateParams, brandService) {
                return brandService.getById($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        },
        data: {
            febelcoCustomer: true
        }
    });
    //.state('brand.product', {
    //    url: '/product/:productId',
    //    views:{
    //        'main@root':{
    //            component: 'product'
    //        }
    //    },
    //    resolve: {
    //        product: function($stateParams, productService) {
    //            return productService.get($stateParams.productId);
    //        }
    //    },
    //    reloadOnSearch : false,
    //    params: {
    //        discountId: {
    //            value: null,
    //            squash: true
    //        },
    //        loadingOverlay: true
    //    },
    //    ncyBreadcrumb: {
    //        label: '{{$resolve.product.displayName}}'
    //    }
    //});
}]).component('brand', _detail2.default).component('brandOverview', _overview.brandOverviewComponent).component('brandNews', _news.brandNewsComponent);

exports.default = _module.name;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var brandNewsComponent = exports.brandNewsComponent = {
    template: __webpack_require__(567),
    bindings: {
        brand: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsOverviewService", "Enums", "gettextCatalog", "Analytics", function brandNewsController($scope, common, newsOverviewService, Enums, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.setBrandsActive();
            common.setTitle(gettextCatalog.getString('News for ') + vm.brand.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/brands/news', 'vm.brand.name ' + gettextCatalog.getString('News'));
            newsOverviewService.handleGetNews($scope, Enums.newsContext.brand.id, { brandId: vm.brand.id }).then(function (i) {
                return vm.newsOverviewModel = i;
            });
        }
    }]
};

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var brandOverviewComponent = exports.brandOverviewComponent = {
    template: __webpack_require__(568),
    bindings: {
        brands: '<'
    },
    controllerAs: 'vm',
    controller: ["brandService", "lodash", "$location", "gettextCatalog", "common", "Analytics", function controller(brandService, lodash, $location, gettextCatalog, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.brandIndexes = getBrandIndexes(vm.brands);
        vm.currentLanguage = common.localization.getCurrentLanguage();
        vm.scrollTo = scrollTo;

        common.setTitle(gettextCatalog.getString('Brands'));
        Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/brands', gettextCatalog.getString('Brands'));

        function getBrandIndexes(brands) {
            common.navigationMenu.setBrandsActive();
            var indexes = lodash.uniq(lodash.map(brands, function (b) {
                return b.name.charAt(0).toLowerCase();
            })).sort();

            var brandIndexes = lodash.map(indexes, function (i) {
                return {
                    'char': i,
                    'brands': getBrandsByIndex(brands, i)
                };
            });

            return brandIndexes;
        }

        function getBrandsByIndex(brands, char) {
            return lodash.filter(brands, function (b) {
                return b.name.charAt(0).toLowerCase() === char;
            });
        }
    }]
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _overview = __webpack_require__(900);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.category', []);

_module.config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    $stateProvider.state('general.products', {
        url: '/products?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'categoryOverview'
            }
        },
        // reloadOnSearch: true,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.sessionStorage.getItem('pageSize'), squash: true, dynamic: true },
            sortProperty: { value: sortProperties['Name'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['Name'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true }
        },
        resolve: {
            category: ["categoryService", function category(categoryService) {
                return categoryService.getById(0); //id 0 returns all products
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Products" | translate}}'
        },
        data: {
            febelcoCustomer: true
        }
    }).state('general.products.category', {
        url: '/category/{categoryId:int}',
        views: {
            'main@root': {
                component: 'categoryOverview'
            }
        },
        //reloadOnSearch: true,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.localStorage.getItem('pageSize'), squash: true, dynamic: true },
            sortProperty: { value: sortProperties['Name'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['Name'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true },
            categoryId: { squash: true },
            noReloadFilter: { squash: true }
        },
        resolve: {
            // category: function($stateParams, categoryService) {
            //     return categoryService.getById($stateParams.categoryId);
            // }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.category.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    });
}]);

_module.component('categoryOverview', _overview.categoryOverviewComponent);

exports.default = _module.name;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var categoryOverviewComponent = exports.categoryOverviewComponent = {
    template: __webpack_require__(569),
    bindings: {
        category: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "$stateParams", "gettextCatalog", "Analytics", function controller($scope, productOverviewService, Enums, common, $stateParams, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.initialLoad = null;
        vm.onFilterChange = onFilterChange;

        function init() {

            common.setTitle(gettextCatalog.getString('Products'));
            common.navigationMenu.setProductsActive();

            if (!$stateParams.categoryId) {
                vm.categoryId = 0;
            } else {
                vm.categoryId = $stateParams.categoryId;
            }

            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/products/category/' + vm.categoryId, gettextCatalog.getString('Products'));

            //todo put in resolve
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.category.id);
            }
            productOverviewService.getProductsByCategory($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, vm.categoryId).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByCategory(false, vm.productOverviewModel, vm.categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var certificatesComponent = exports.certificatesComponent = {
    template: __webpack_require__(570),
    controllerAs: 'vm',
    controller: ["$scope", "$state", "common", "gettextCatalog", "certificatesService", "$stateParams", "Paging", "Analytics", function certificatesController($scope, $state, common, gettextCatalog, certificatesService, $stateParams, Paging, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.search = search;
        vm.clear = clear;
        vm.goToPage = goToPage;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.isSearchUsed = isSearchUsed;
        vm.pageCountList = [12, 24, 36];
        vm.model = null;
        vm.certificatesLoading = false;
        vm.paging = Paging.create({
            page: 1,
            itemsPerPage: parseInt($stateParams.pageSize) || vm.pageCountList[0],
            totalItems: 0
        });
        vm.getCoaUrl = getCoaUrl;

        function init() {
            var pageTitle = gettextCatalog.getString('Certificates');
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/certificates', pageTitle);
            loadCertificates(vm.paging.itemsPerPage).then(function () {
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                loadCertificates(vm.paging.itemsPerPage);
            });
        }

        function loadCertificates(itemsPerPage) {
            vm.certificatesLoading = true;

            var params = getQueryStringParams(itemsPerPage);

            return certificatesService.searchCertificates(params).then(function (response) {
                vm.model = response;
                vm.paging = Paging.create({
                    page: params.page,
                    itemsPerPage: vm.paging.itemsPerPage,
                    totalItems: response.count
                });
                vm.certificatesLoading = false;
            });
        }

        function getQueryStringParams(itemsPerPage) {
            var page = parseInt($stateParams.page);

            return {
                page: page,
                skip: vm.paging.getSkipValue(page, itemsPerPage),
                take: itemsPerPage,
                identification: $stateParams.identification,
                isExpired: false
            };
        }

        function search(page) {
            $state.go('.', {
                page: page || 1,
                pageSize: vm.paging.itemsPerPage,
                identification: vm.model.search.identification
            });
        }

        function clear() {
            vm.model.search.identification = null;

            search();
        }

        function goToPage(page) {
            if (page === 0 || page > vm.paging.pageCount) {
                return;
            }
            search(page);
        }

        function changeItemsPerPage(itemsPerPage) {
            vm.paging.itemsPerPage = itemsPerPage;
            search();
        }

        function getCoaUrl(id) {
            return certificatesService.getCoaUrl(id);
        }

        function isSearchUsed() {
            return !!$stateParams.identification && $stateParams.identification.length > 0;
        }
    }]
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _certificates = __webpack_require__(901);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.certificates', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.certificates', {
        url: '/certificates?page&pageSize&identification',
        views: {
            'main@root': {
                component: 'certificates'
            }
        },
        reloadOnSearch: false,
        params: {
            loadingOverlay: false,
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: true
            },
            identification: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Certificates" | translate}}'
        }
    }).state('root-certificaten', {
        parent: 'root',
        url: '/certificaten',
        onEnter: ["$state", function onEnter($state) {
            var language = 'nl';

            return $state.target('general.certificates', Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('root-certificats', {
        parent: 'root',
        url: '/certificats',
        onEnter: ["$state", function onEnter($state) {
            var language = 'fr';

            return $state.target('general.certificates', Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('general-certificaten', {
        parent: 'general',
        url: '/certificaten',
        redirectTo: 'general.certificates'
    }).state('general-certificats', {
        parent: 'general',
        url: '/certificats',
        redirectTo: 'general.certificates'
    });
}]).component('certificates', _certificates.certificatesComponent);

exports.default = _module.name;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartErrorComponent = exports.cartErrorComponent = {
    template: __webpack_require__(571)
};

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartComponent = exports.cartComponent = {
    template: __webpack_require__(572),
    bindings: {
        cart: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "$stateParams", "$timeout", "cartService", "common", "exceptionService", "gettextCatalog", "dialogService", "Analytics", "authService", "$window", function checkoutCartController($scope, $state, $stateParams, $timeout, cartService, common, exceptionService, gettextCatalog, dialogService, Analytics, authService, $window) {
        'ngInject';

        var vm = this;
        vm.isLoading = false;
        vm.messages = null;
        vm.removeProducts = removeProducts;
        vm.updateQuantity = updateQuantity;
        vm.quantityChanged = quantityChanged;
        vm.undoChanged = undoChanged;
        vm.removeInactiveProducts = removeInactiveProducts;
        vm.checkout = checkout;
        vm.clear = clear;
        vm.$onInit = init;
        vm.cartUpdated = false;
        vm.productDiscounts = {};
        vm.removeSellerFromCart = removeSellerFromCart;

        function init() {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.apbNumber = activeTenant.apbNumber;

            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Shopping cart'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart', gettextCatalog.getString('Shopping cart'));

            vm.isLoading = true;
            cartService.getFromServer().then(function (cart) {
                vm.cart = cart;
                vm.isLoading = false;
                if (vm.cart) {
                    vm.initCart = angular.copy(vm.cart);
                    vm.cart.setFocusOnProduct($stateParams.productId);
                }

                //update quantity on enter
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true) {
                        vm.updateQuantity();
                    }
                });
            });
        }

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function quantityChanged() {
            vm.cartUpdated = true;
        }

        function removeSellerFromCart(sellerBaseCodeId) {
            vm.isLoading = true;
            vm.cartUpdated = false;

            cartService.removeSellerFromCart(sellerBaseCodeId).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The products could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function removeProducts(products) {
            vm.isLoading = true;
            vm.cartUpdated = false;

            cartService.removeProducts(products).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The product could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function updateQuantity() {

            vm.isLoading = true;
            vm.cartUpdated = false;

            var products = [];

            vm.cart.sellers.map(function (seller) {
                products = products.concat(seller.products);
            });

            cartService.updateCart(products).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
            }).catch(function () {
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function checkout(number) {
            vm.cart.customerAccountNumber = number;
            angular.forEach(vm.cart.sellers, function (seller) {
                angular.forEach(seller.products, function (product) {
                    Analytics.addProduct(product.id, product.displayName, product.type, product.brand, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        dimension1: product.sellerId,
                        dimension2: product.sellerName,
                        dimension3: product.discountId
                    });
                });
            });
            Analytics.trackCheckout(1);

            $state.go('checkout-order');
        }

        function clear() {
            var title = gettextCatalog.getString('Confirmation');
            var msg = gettextCatalog.getString('Are you sure you want to clear your shopping cart?');

            dialogService.confirm($scope, title, msg).then(function () {
                return cartService.clear();
            }).then(function () {
                vm.cart = null;
            });
        }

        function undoChanged() {
            vm.cartUpdated = false;
            vm.cart = angular.copy(vm.initCart);
        }

        function removeInactiveProducts() {
            vm.isLoading = true;
            vm.cartUpdated = false;

            var products = [];
            vm.cart.sellers.map(function (seller) {
                products = products.concat(seller.products);
            });

            var inactiveProducts = products.filter(function (product) {
                return product.isExpired === true;
            });

            cartService.removeProducts(inactiveProducts).then(function (updatedCart) {
                vm.cart = updatedCart;
                vm.initCart = angular.copy(updatedCart);
                vm.isLoading = false;
            }).catch(function () {
                var msg = gettextCatalog.getString('The product could not be removed from your shopping cart');
                exceptionService.logException(msg);
            }).finally(function () {
                vm.isLoading = false;
            });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartBySellersComponent = exports.cartBySellersComponent = {
    template: __webpack_require__(573),
    bindings: {
        cart: '<',
        updateQuantity: '&',
        removeProduct: '&'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartProductComponent = exports.cartProductComponent = {
    template: __webpack_require__(574),
    bindings: {
        product: '=',
        sellerId: '<',
        sellerName: '<',
        isVipSeller: '<',
        removeProducts: '&',
        quantityChanged: '&',
        openProductDiscounts: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["productService", "authService", function controller(productService, authService) {
        'ngInject';

        var vm = this;
        vm.openProductDiscounts = openProductDiscounts;
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.removeProductsFromList = removeProductsFromList;
        vm.productDiscounts = {};
        vm.isFebelcoCustomer = isFebelcoCustomer;

        function openProductDiscounts(product) {
            if (!product.isDisabled) {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    productService.getProductDiscounts(product.id).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        function toggleProductDiscounts(product) {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    openProductDiscounts(product);
                }
            }
        }

        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function removeProductsFromList(products) {
            vm.removeProducts({ $event: products });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartTotalPriceDiscountsComponent = exports.cartTotalPriceDiscountsComponent = {
    template: __webpack_require__(575),
    bindings: {
        close: '&',
        totalPriceDiscounts: '<'
    },
    controllerAs: 'vm',
    controller: ["discountTypeNames", function controller(discountTypeNames) {
        'ngInject';

        var vm = this;

        // vm.isTotalPriceDiscountId = isTotalPriceDiscountId;
        vm.getDiscountType = getDiscountType;
        vm.isActive = isActive;

        function getDiscountType(discountType) {
            return discountTypeNames[discountType].clientValue;
        }
        function isActive(discount) {

            return discount.isActive ? 'product-discount is-active' : 'product-discount';
        }
        // function isTotalPriceDiscountId(productDiscount) {
        //     return productDiscount.discountId === vm.totalPriceDiscountId ? 'product-discount is-active' : 'product-discount';
        // }
    }]
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartConfirmationComponent = exports.cartConfirmationComponent = {
    template: __webpack_require__(576),
    bindings: {
        disabledSellers: '<',
        orders: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "authService", "config", "$stateParams", "userService", "Analytics", function controller(common, gettextCatalog, authService, config, $stateParams, userService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.ordersWithDeliveryDate = [];
        vm.ordersWithoutDeliveryDate = [];
        vm.mail = null;
        vm.user = null;

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Order confirmation'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart/confirmation', gettextCatalog.getString('Order confirmation'));

            splitArrayByDeliveryDate();
            userService.getMyAccount().then(function (u) {
                vm.mail = u.mail;
                vm.user = u;
            });
        }

        function splitArrayByDeliveryDate() {
            vm.orders.forEach(function (o) {
                if (o.deliveryDate === null) {
                    vm.ordersWithDeliveryDate.push(o);
                } else {
                    vm.ordersWithoutDeliveryDate.push(o);
                }
            });
        }

        function getDownloadUrl(orderId) {
            return config.webApiBaseUrl + ('report/orderDetail/' + orderId + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }
    }]
};

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _cart = __webpack_require__(904);

var _confirmation = __webpack_require__(908);

var _order = __webpack_require__(910);

var _cartProduct = __webpack_require__(906);

var _cartTotalPriceDiscounts = __webpack_require__(907);

var _cartBySellers = __webpack_require__(905);

var _cartError = __webpack_require__(903);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//TODO FIX STATE NAME WITH CAMELCASE!
var _module = _angular2.default.module('app.checkout', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('cart', {
        parent: 'general',
        url: '/cart?productId',
        views: {
            'main@root': {
                component: 'checkoutCart'
            }
        },
        reloadOnSearch: true,
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Your shopping cart" | translate}}'
        }
    }).state('checkout-order', {
        parent: 'cart',
        url: '/order',
        views: {
            'main@root': {
                component: 'checkoutOrder'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': ''
        },
        resolve: {
            wholeSalers: ["cartService", function wholeSalers(cartService) {
                return cartService.getWholesalers().then(function (whole) {
                    var febelco = {
                        id: 22168,
                        isFebelcoCustomerWholesaler: true,
                        isDisabled: true,
                        name: 'Febelco'
                    };
                    whole.push(febelco);
                    return whole;
                });
            }],
            customerAccounts: ["cartService", function customerAccounts(cartService) {
                return cartService.getCustomerAccounts().then(function (response) {
                    return response && response.accounts || [];
                });
            }],
            cart: ["cartService", function cart(cartService) {
                return cartService.checkout();
            }]
        },
        params: {
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Order" | translate}}'
        }
    }).state('order-draft', {
        parent: 'cart',
        url: '/order-draft',
        views: {
            'main@root': {
                component: 'checkoutOrderDraft'
            }
        },
        params: {
            loadingOverlay: true
        }
    }).state('checkout-confirmation', {
        parent: 'cart',
        url: '/confirmation',
        views: {
            'main@root': {
                component: 'checkoutConfirmation'
            }
        },
        resolve: {
            orders: ["$state", "$stateParams", "$timeout", "$q", function orders($state, $stateParams, $timeout, $q) {
                // when there is no orders in the stateParams, go to the order overview
                if ($stateParams.orders && $stateParams.orders.length > 0) {
                    return $stateParams.orders;
                } else {
                    $timeout(function () {
                        return $state.go('order-overview', $stateParams);
                    }, 0);
                    return $q.reject();
                }
            }],
            disabledSellers: ["$stateParams", function disabledSellers($stateParams) {
                return $stateParams.disabledSellers;
            }]
        },
        params: {
            orders: null,
            disabledSellers: null,
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{"Thank you for ordering" | translate}}'
        }
    }).state('carterror', {
        parent: 'general',
        url: '/carterror',
        views: {
            'main@root': {
                component: 'cartError'
            }
        },
        data: {
            public: true
        }
    });
}]).component('checkoutCart', _cart.cartComponent).component('checkoutConfirmation', _confirmation.cartConfirmationComponent).component('checkoutOrder', _order.orderComponent).component('cartProduct', _cartProduct.cartProductComponent).component('cartBySellers', _cartBySellers.cartBySellersComponent).component('cartError', _cartError.cartErrorComponent).component('cartTotalPriceDiscounts', _cartTotalPriceDiscounts.cartTotalPriceDiscountsComponent);

exports.default = _module.name;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var orderComponent = exports.orderComponent = {
    template: __webpack_require__(577),
    bindings: {
        cart: '<',
        wholeSalers: '<',
        customerAccounts: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "common", "gettextCatalog", "cartService", "$state", "exceptionService", "Analytics", "authService", "userService", function checkoutOrderController($rootScope, common, gettextCatalog, cartService, $state, exceptionService, Analytics, authService, userService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.createOrders = createOrders;
        vm.specialOrderProducts = [];
        vm.isSpecialOrder = false;
        vm.isCreateOrderDisabled = isCreateOrderDisabled;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.selectedWholeSaler = null;
        vm.selectedCustomerAccount = null;
        vm.hasSpecialOrderProducts = null;
        vm.showCustomerAccounts = false;
        vm.user = null;

        function init() {
            common.navigationMenu.clearActiveMenu();

            common.setTitle(gettextCatalog.getString('Place order'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart/order', gettextCatalog.getString('Place order'));

            //get apb number
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            vm.apbNumber = activeTenant.apbNumber;
            userService.getMyAccount().then(function (u) {
                vm.user = u;
            });
            //get list of products with special order products
            vm.cart.sellers.forEach(function (seller) {
                seller.products.map(function (sellerProduct) {
                    if (sellerProduct.allowSpecial && seller.canOrderSpecial) {
                        vm.specialOrderProducts.push(sellerProduct);
                    }
                });
            });

            vm.specialOrderProducts.length === 0 ? vm.hasSpecialOrderProducts = false : vm.hasSpecialOrderProducts = true;

            setDefaultWholeSaler();
            setShowCustomerAccounts();
            setDefaultCustomerAccount();
        }

        function setDefaultWholeSaler() {
            vm.selectedWholeSaler = vm.wholeSalers.find(function (wholeSaler) {
                return String(wholeSaler.id) === authService.defaultWholesalerId;
            });
        }

        function setShowCustomerAccounts() {
            var hasMultipleCustomerAccounts = vm.customerAccounts.length > 1;
            var hasFebelcoSellerProducts = !!vm.cart.sellers.find(function (seller) {
                return seller.isVipSeller;
            });

            vm.showCustomerAccounts = hasFebelcoSellerProducts && hasMultipleCustomerAccounts;
        }

        function setDefaultCustomerAccount() {

            if (vm.customerAccounts && vm.customerAccounts.length) {
                var defaultAccount = vm.customerAccounts.find(function (x) {
                    return x.number === authService.user.FebelcoCustomerNumber;
                });
                vm.selectedCustomerAccount = defaultAccount || vm.customerAccounts[0];
            }
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function createOrders() {

            angular.forEach(vm.cart.sellers, function (seller) {
                angular.forEach(seller.products, function (product) {
                    Analytics.addProduct(product.id, product.name, product.type, product.brand, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId
                    });
                });
            });

            cartService.createOrders(vm.isSpecialOrder, vm.selectedWholeSaler, vm.selectedCustomerAccount).then(function (orders) {
                orders.forEach(function (order) {
                    Analytics.trackTransaction(order.orderNumber, order.sellerName, order.totalPrice, '', '', '', '', '', '');
                });
                cartService.getFromServerCheckoutCart().then(function (cart) {
                    $state.go('checkout-confirmation', {
                        orders: orders,
                        disabledSellers: cart.disabledSellers
                    });
                });
            }).catch(function () {
                var msg = gettextCatalog.getString('An error occurred during the confirmation of the order. Please contact the customer support.');
                exceptionService.logException(msg);
            });
        }

        function isCreateOrderDisabled() {
            if (vm.isFebelcoCustomer()) {
                if (vm.hasSpecialOrderProducts) {
                    return vm.isSpecialOrder ? false : true;
                } else {
                    return false;
                }
            } else {
                return vm.selectedWholeSaler ? false : true;
            }
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addressComponent = exports.addressComponent = {
    template: __webpack_require__(578),
    bindings: {
        address: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contactPersonComponent = exports.contactPersonComponent = {
    template: __webpack_require__(579),
    bindings: {
        contact: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var febDatePickerComponent = exports.febDatePickerComponent = {
    transclude: true,
    template: __webpack_require__(580),
    bindings: {
        value: '=',
        maxDate: '<',
        minDate: '<',
        onChange: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.valueChanged = valueChanged;

        function valueChanged(event) {
            vm.onChange({ $event: event });
        }
    }
};

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var confirmDialogComponent = exports.confirmDialogComponent = {
    transclude: true,
    template: __webpack_require__(581),
    bindings: {
        message: '@?',
        messageTitle: '@?',
        onConfirm: '&',
        onReject: '&',
        onCancel: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.confirm = confirm;
        vm.reject = reject;
        vm.cancel = cancel;

        function confirm() {
            vm.onConfirm();
        }
        function reject() {
            vm.onReject();
        }
        function cancel() {
            vm.onCancel();
        }
    }
};

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var unsavedChangesDialogComponent = exports.unsavedChangesDialogComponent = {
    transclude: true,
    template: __webpack_require__(582),
    bindings: {
        onDiscard: '&',
        onCancel: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.discard = discard;
        vm.cancel = cancel;

        function discard() {
            vm.onDiscard();
        }
        function cancel() {
            vm.onCancel();
        }
    }
};

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var folderCollapseComponent = exports.folderCollapseComponent = {
    transclude: true,
    template: __webpack_require__(583),
    bindings: {
        folderTitle: '<',
        isOpen: '<',
        showCount: '<?',
        itemCount: '<?',
        itemLabel: '<?'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.folderOpen = true;
        vm.toggleFolder = toggleFolder;
        vm.setFolderClass = setFolderClass;
        vm.$onInit = init;

        function init() {
            vm.folderOpen = vm.isOpen ? true : false;
        }

        function toggleFolder() {
            vm.folderOpen = vm.folderOpen ? false : true;
        }

        function setFolderClass() {
            return vm.folderOpen ? 'folder is-open' : 'folder';
        }
    }
};

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// import angular from 'angular';

var galleryComponent = exports.galleryComponent = {
    template: __webpack_require__(584),
    bindings: {
        gallerySliderSettings: '<',
        gallery: '<'
    },
    controllerAs: 'vm',
    controller: ["$stateParams", function controller($stateParams) {
        'ngInject';

        var vm = this;
        vm.galleryId = $stateParams['#'];
    }]
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var helpQuestionComponent = exports.helpQuestionComponent = {
    template: '<a ui-sref="helpDetail({ categoryId: vm.question.categoryId, subCategoryId: vm.question.subCategoryId, questionId: vm.question.questionId})">{{vm.question.question}}</a>',
    bindings: {
        question: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        var vm = this;
        vm.$onInit = init;

        function init() {}
    }
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _address = __webpack_require__(911);

var _pager = __webpack_require__(921);

var _totals = __webpack_require__(922);

var _folderCollapse = __webpack_require__(916);

var _helpQuestion = __webpack_require__(918);

var _contactPerson = __webpack_require__(912);

var _typeahead = __webpack_require__(925);

var _gallery = __webpack_require__(917);

var _links = __webpack_require__(920);

var _datePicker = __webpack_require__(913);

var _confirmDialog = __webpack_require__(914);

var _unsavedChangesDialog = __webpack_require__(915);

var _treeView = __webpack_require__(924);

var _treeViewItem = __webpack_require__(923);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.commoncomponents', []).component('address', _address.addressComponent).component('pager', _pager.pagerComponent).component('totals', _totals.totalsComponent).component('folderCollapse', _folderCollapse.folderCollapseComponent).component('helpQuestion', _helpQuestion.helpQuestionComponent).component('typeahead', _typeahead.typeaheadComponent).component('contactPerson', _contactPerson.contactPersonComponent).component('gallery', _gallery.galleryComponent).component('links', _links.linksComponent).component('fbUnsavedChangesDialog', _unsavedChangesDialog.unsavedChangesDialogComponent).component('fbConfirmDialog', _confirmDialog.confirmDialogComponent).component('fbTreeView', _treeView.treeViewComponent).component('fbTreeViewItem', _treeViewItem.treeViewItemComponent).component('fbDatePicker', _datePicker.febDatePickerComponent);

exports.default = _module.name;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// import angular from 'angular';

var linksComponent = exports.linksComponent = {
    template: __webpack_require__(585),
    bindings: {
        links: '<',
        sellerId: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var pagerComponent = exports.pagerComponent = {
    template: __webpack_require__(586),
    bindings: {
        paging: '<',
        goToPage: '&'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var totalsComponent = exports.totalsComponent = {
    template: __webpack_require__(587),
    bindings: {
        totals: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeViewItemComponent = exports.treeViewItemComponent = {
    template: __webpack_require__(588),
    bindings: {
        category: '<',
        changeFilters: '&',
        level: '<',
        item: '<',
        isLink: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.treeViewOpen = vm.item.isSelected || vm.item.childSelected ? true : false;
        vm.getLevel = getLevel;
        vm.onChangeFilters = onChangeFilters;
        vm.openTreeView = openTreeView;

        function getLevel() {
            return parseInt(vm.level) + 1;
        }

        function onChangeFilters($event) {
            vm.changeFilters({ $event: $event });
        }

        function openTreeView() {
            vm.treeViewOpen ? vm.treeViewOpen = false : vm.treeViewOpen = true;
        }
    }
};

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var treeViewComponent = exports.treeViewComponent = {
    template: __webpack_require__(589),
    bindings: {
        items: '<',
        level: '<',
        isLink: '<',
        limit: '<',
        category: '<',
        changeFilters: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.onChangeFilters = onChangeFilters;

        function onChangeFilters($event) {
            vm.changeFilters({ $event: $event });
        }
    }
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.typeaheadComponent = undefined;

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var typeaheadComponent = exports.typeaheadComponent = {
    template: __webpack_require__(590),
    bindings: {
        searchString: '=',
        hasFocus: '=',
        searchSource: '&',
        onChange: '&',
        displayContext: '<',
        inputId: '<',
        isDisabled: '<',
        inputStyle: '<'
    },
    controllerAs: 'vm',
    controller: ["$timeout", function controller($timeout) {
        'ngInject';

        var vm = this;

        _angular2.default.element(vm.inputId + '.input-sm').siblings('input.tt-hint').addClass('hint-small');
        _angular2.default.element(vm.inputId + '.input-lg').siblings('input.tt-hint').addClass('hint-large');

        // TYPE AHEAD
        $timeout(function () {
            //DOM has finished rendering
            _angular2.default.element('#' + vm.inputId).typeahead({
                items: 'all',
                source: function source(query, process) {
                    vm.searchSource({ query: query }).then(function (results) {
                        return process(results);
                    });
                },
                updater: function updater(item) {
                    vm.onChange({ item: item });
                    return item;
                },
                displayText: function displayText(item) {
                    //make dynamic with input binding and scope.eval
                    switch (vm.displayContext) {
                        case 'CITY':
                            return item.postalCode + ' - ' + item.name;
                        case 'STREET':
                            return '' + item.name;
                        default:
                            return item.nationalNumber + ' - ' + item.name;
                    }
                }
            });
        });
    }]
};

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var discountsComponent = exports.discountsComponent = {
    template: __webpack_require__(591),
    bindings: {
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "gettextCatalog", "Analytics", "$stateParams", "$state", function controller($scope, productOverviewService, Enums, common, gettextCatalog, Analytics, $stateParams, $state) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.onFilterChange = onFilterChange;
        vm.setIsBlackFriday = setIsBlackFriday;
        vm.isBlackFriday = false;
        vm.setBlackFriday = setBlackFriday;

        function setIsBlackFriday(value) {
            return vm.isBlackFriday = value;
        }

        function setBlackFriday() {
            if ($stateParams.filter.indexOf('10_0') !== -1) {
                $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Black Friday');
                $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Black Friday');
                $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts?filter=10_0';
                setIsBlackFriday(true);
            } else {
                $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Discounts');
                $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Discounts');
                $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts';
                setIsBlackFriday(false);
            }
        }
        function init() {
            common.navigationMenu.setDiscountsActive();
            common.setTitle(gettextCatalog.getString('Discounts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/discounts', gettextCatalog.getString('Discounts'));
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.discount.id);
            }
            setBlackFriday();

            productOverviewService.getProductsByDiscounts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByDiscounts(false, vm.productOverviewModel).then(function (model) {
                    vm.productOverviewModel = model;
                    setBlackFriday();
                });
            });
        }

        function onFilterChange() {
            $state.current.ncyBreadcrumb.label = gettextCatalog.getString('Discounts');
            $state.current.ncyBreadcrumbLabel = gettextCatalog.getString('Discounts');
            $state.current.ncyBreadcrumbLink = '/' + common.localization.getCurrentLanguage() + '/discounts';
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var discounttypeComponent = exports.discounttypeComponent = {
    template: __webpack_require__(592),
    bindings: {
        discounttype: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "Analytics", "gettextCatalog", "$stateParams", function controller($scope, productOverviewService, Enums, common, Analytics, gettextCatalog, $stateParams) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.onFilterChange = onFilterChange;

        //TODO is this the same as discount.js? use same component?
        function init() {
            common.navigationMenu.setDiscountsActive();

            var pageTitle = vm.discounttype.name;
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/discounts/discounttype/' + vm.discounttype.id, pageTitle);

            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.discount.id);
            }

            productOverviewService.getProductsByDiscounts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, vm.discounttype.id).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByDiscounts(false, vm.productOverviewModel, vm.discounttype.id).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _discounts = __webpack_require__(926);

var _discounttype = __webpack_require__(927);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.discount', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('general.discounts', {
        url: '/discounts?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'discounts'
            }
        },
        //reloadOnSearch : false,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.localStorage.getItem('pageSize'), squash: false, dynamic: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true
                //specificDateFilter : {value:'',squash: true, dynamic: true}
            } },
        ncyBreadcrumb: {
            label: '{{"Discounts" | translate}}'
        }
    }).state('general.discounts.discounttype', {
        url: '/discounttype/{id:int}',
        views: {
            'main@root': {
                component: 'discounttype'
            }
        },
        resolve: {
            discounttype: ["$stateParams", "discounttypeService", function discounttype($stateParams, discounttypeService) {
                'ngInject';

                return discounttypeService.get(parseInt($stateParams.id));
            }]
        },
        //loadOnSearch : false,
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.localStorage.getItem('pageSize'), squash: true, dynamic: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '', squash: true, dynamic: true },
            noReloadFilter: { squash: true }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.discounttype.name}}'
        }
    }).state('seller.discounts.discounttype', {
        url: '/discounttype/{id:int}?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'discounttype'
            }
        },
        resolve: {
            discounttype: ["$stateParams", "discounttypeService", function discounttype($stateParams, discounttypeService) {
                'ngInject';

                return discounttypeService.get(parseInt($stateParams.id));
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            pageSize: { value: '24', squash: true },
            sortProperty: { value: sortProperties['DiscountDate'].value, squash: true },
            sortAsc: { value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(), squash: true },
            filter: { value: '', squash: true },
            noReloadFilter: { squash: true }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.discounttype.name}}'
        }
    });
}]).component('discounts', _discounts.discountsComponent).component('discounttype', _discounttype.discounttypeComponent);

exports.default = _module.name;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var errorComponent = exports.errorComponent = {
    template: __webpack_require__(593),
    controllerAs: 'vm',
    controller: ["common", "$stateParams", "$timeout", "$state", "Analytics", "gettextCatalog", function controller(common, $stateParams, $timeout, $state, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.errormessage = $stateParams.message || '404 - Page not found';
        vm.$onInit = init;
        common.navigationMenu.clearActiveMenu();

        function init() {
            common.setTitle(gettextCatalog.getString('Error'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/error', 'Error');

            $timeout(function () {
                $state.go('home');
            }, 300000);
        }
    }]
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _error = __webpack_require__(929);

var _productNotFound = __webpack_require__(931);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.error', ['ng']).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('error', {
        parent: 'master',
        url: '/error',
        views: {
            'main@root': {
                component: 'error'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        params: {
            message: null
        },
        data: {
            public: true
        }
    }).state('error-product', {
        parent: 'master',
        url: '/productNotFound',
        views: {
            'main@root': {
                component: 'productNotFound'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        data: {
            public: true
        }
    });
}]).component('error', _error.errorComponent).component('productNotFound', _productNotFound.productNotFoundComponent);

exports.default = _module.name;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productNotFoundComponent = exports.productNotFoundComponent = {
    template: __webpack_require__(594),
    controllerAs: 'vm',
    controller: ["common", "$stateParams", "$timeout", "$state", "Analytics", "gettextCatalog", function controller(common, $stateParams, $timeout, $state, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.errormessage = $stateParams.message || '404 - Page not found';
        vm.$onInit = init;
        common.navigationMenu.clearActiveMenu();

        function init() {
            common.setTitle(gettextCatalog.getString('Product not found'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/productNotFound', gettextCatalog.getString('Product not found'));

            $timeout(function () {
                $state.go('home');
            }, 5000);
        }
    }]
};

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var fastOrderDetailComponent = exports.fastOrderDetailComponent = {
    template: __webpack_require__(595),
    controllerAs: 'vm',
    controller: ["cartService", "$scope", "$state", "toastr", "gettextCatalog", "productService", "common", "Analytics", function controller(cartService, $scope, $state, toastr, gettextCatalog, productService, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.addProductToList = addProductToList;
        vm.deleteProductFromList = deleteProductFromList;
        vm.addToShoppingCart = addToShoppingCart;
        vm.clearList = clearList;
        vm.quantity = 1;
        vm.searchString = null;
        vm.isLoading = false;
        vm.products = [];
        vm.errors = {};
        vm.productNotfound = true;
        vm.stateName = null;
        vm.searchProducts = searchProducts;
        vm.productSearchChanged = productSearchChanged;
        vm.isAddingToCart = false;
        vm.hasFocus = true;
        vm.$onInit = init;
        $scope.forms = {};

        function init() {
            common.setTitle(gettextCatalog.getString('Fast Order'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/fast-order', gettextCatalog.getString('Fast Order'));
        }

        function searchProducts(query) {
            return productService.searchProducts(query, 10);
        }

        function productSearchChanged(item) {
            vm.selectedProduct = item;
        }

        // UPLOAD CSV
        $scope.$watch('vm.file', function () {
            if (vm.file) {
                uploadProductList();
            }
        });

        this.checkError = function (product) {
            if (product.hasQuantityError) {
                product.hasQuantityError = false;
            }
        };

        function uploadProductList() {
            vm.isLoading = true;
            vm.errors.fileUpload = false;
            vm.errors.shoppingCartAdd = false;

            productService.uploadProductList(vm.file).then(function (products) {
                products.forEach(function (product) {
                    vm.isLoading = false;

                    if (product.quantity <= 0) {
                        vm.errors.amount = true;
                    }
                    if (!product.quantity) {
                        vm.errors.quantity = true;
                    }
                    if (!product.name) {
                        vm.errors.productError = true;
                    }

                    //check if product is in list
                    var data = vm.products.find(function (elem) {
                        if (product.id === null) {
                            return null;
                        } else if (elem.id === product.id) {
                            elem.quantity += product.quantity;
                            return elem;
                        }
                    });

                    if (!data) {
                        vm.products.push(product);
                    }
                    //check for errors
                });
                if (!products.length) {
                    vm.isLoading = false;
                    vm.errors.emptyCsv = true;
                }
                Analytics.trackEvent('FastOrder', 'productListUploaded', 'productListUploaded', 0, true, { fileSize: vm.file.size + 'B' });
            }).catch(function (ex) {
                vm.isLoading = false;
                vm.errors.fileUpload = true;
                Analytics.trackException(ex, true);
            });
        }

        // PRODUCT OPERATIONS

        function addProductToList() {
            // Quickfix if no procduct is selected. trackjs issue (https://my.trackjs.com/shared/MTdlMGNmYThlNTg3NGZjNDk1MDY0MTFmYzg2YmVjMWY)
            if (!vm.selectedProduct) {
                return;
            }

            changeFocus();

            vm.errors.shoppingCartAdd = false;
            if (vm.quantity <= 0) {
                vm.errors.amount = true;
            } else {
                //check if product is in list
                var data = vm.products.find(function (elem, index) {
                    if (elem.id === vm.selectedProduct.id) {
                        elem.quantity += vm.quantity;
                        vm.products.splice(index, 1);
                        vm.products.unshift(elem);
                        return elem;
                    }
                });
                if (!data) {
                    vm.selectedProduct.quantity = vm.quantity;
                    vm.products.unshift(vm.selectedProduct);
                }

                vm.quantity = 1;
                vm.searchString = null;
                vm.selectedProduct = null;
                vm.errors.amount = false;
                vm.errors.fileUpload = false;
            }
        }

        function changeFocus() {
            vm.hasFocus === true ? vm.hasFocus = false : vm.hasFocus = true;
        }

        function deleteProductFromList(product) {
            vm.products.splice(vm.products.findIndex(function (elem) {
                return elem.id === product.id;
            }), 1);

            if (vm.products.length === 0) {
                vm.errors = {};
            }
        }

        function clearList() {
            vm.errors = {};
            vm.products = [];
        }

        function addToShoppingCart() {
            $scope.forms.productOverviewForm.$setPristine();
            vm.isAddingToCart = true;
            vm.productsForCart = [];
            vm.products.map(function (product) {
                if (product.name && product.name !== '' && product.nationalNumber && product.quantity) {
                    vm.productsForCart.push(product);
                }
            });

            vm.errors = {};
            vm.products = [];

            cartService.quickAddProducts(vm.productsForCart).then(function () {
                vm.productsForCart = [];
                vm.isAddingToCart = false;

                Analytics.trackEvent('FastOrder', 'addedFastOrderProductsToCart', 'addedFastOrderProductsToCart', 0, true, {});

                toastr.success(gettextCatalog.getString('Added products to your shoppingcart'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                $state.go('cart');
            }).catch(function () {
                toastr.error(gettextCatalog.getString('An error occured when adding products to your shoppingcart, please try again'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });

                vm.isAddingToCart = false;
                vm.errors.shoppingCartAdd = true;
            });
        }
    }]
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _detail = __webpack_require__(932);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.fastOrder', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('fast-order', {
        parent: 'general',
        url: '/fast-order',
        views: {
            'main@root': {
                component: 'fastOrderDetail'
            }
        },
        ncyBreadcrumb: {
            label: '{{"Fast order" | translate}}'
        }
    });
}]).component('fastOrderDetail', _detail.fastOrderDetailComponent);

exports.default = _module.name;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var helpComponent = exports.helpComponent = {
    template: __webpack_require__(596),
    bindings: {
        helpCategories: '<',
        helpQuestion: '<'
    },
    controllerAs: 'vm',
    controller: ["$stateParams", "common", "Analytics", "gettextCatalog", function controller($stateParams, common, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.questionId = 1;

        function init() {
            common.setTitle(gettextCatalog.getString('FAQ'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/help', gettextCatalog.getString('FAQ'));

            vm.questionCode = $stateParams.questionCode ? $stateParams.questionCode : 'orderprocess';
        }
    }]
};

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _help = __webpack_require__(934);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import {helpDetailComponent}  from './detail';  
//import {helpContactComponent}  from './components/help-contact';
//import {helpContactBoxComponent}  from './components/help-contact-box';
//import {helpContactFaqBoxComponent}  from './components/help-contact-faq-box';

var _module = _angular2.default.module('app.help', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('help', {
        parent: 'general',
        url: '/help/{questionCode}',
        views: {
            'main@root': {
                component: 'help'
            }
        },
        resolve: {
            helpCategories: ["helpService", function helpCategories(helpService) {
                return helpService.getHelpCategories();
            }]
        },
        ncyBreadcrumb: {
            label: '{{"FAQ" | translate}}'
        }
    }); /*
        .state('helpDetail', {
        parent: 'help',
        url: '/{categoryId}/{subCategoryId}/{questionId}',
        views:{
            'main@root':{
                component: 'helpDetail'
            }
        },
        reloadOnSearch : false,
        resolve: { 
            helpCategory: function($stateParams, helpService) {
                debugger;
                return helpService.getHelpSubCategory($stateParams.categoryId);
            }
        }
        });*/
}]).component('help', _help.helpComponent);
//.component('helpDetail', helpDetailComponent);
//.component('helpContact', helpContactComponent)
//.component('helpContactBox', helpContactBoxComponent)
//.component('helpContactFaqBox', helpContactFaqBoxComponent);

exports.default = _module.name;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var options = {
    template: __webpack_require__(597),
    bindings: {
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "productOverviewService", "advertService", "newsService", "cartService", "Enums", "common", "gettextCatalog", "authService", "Analytics", "$location", "$timeout", "exceptionService", "productService", "reservationCampaignService", "$window", "$state", function controller($scope, $stateParams, productOverviewService, advertService, newsService, cartService, Enums, common, gettextCatalog, authService, Analytics, $location, $timeout, exceptionService, productService, reservationCampaignService, $window, $state) {
        'ngInject';

        var vm = this;
        vm.adverts = null;
        vm.discountsModel = null;
        vm.errorOccurredInProductOverview = false;
        vm.newsitems = null;
        vm.products = null;
        vm.addToCart = addToCart;
        vm.advertClicked = advertClicked;
        vm.buildUrl = buildUrl;
        vm.activeCampaigns = [];
        vm.isFebelcoCustomer = false;
        vm.$onInit = init;
        vm.onChangeQuantity = onChangeQuantity;
        vm._badgeClicked = _badgeClicked;
        vm.getProductDiscounts = getProductDiscounts;
        $scope.forms = {};

        function init() {
            common.navigationMenu.setHomeActive();
            common.setTitle(gettextCatalog.getString('Profficina'));

            //GA
            Analytics.trackPage('/' + common.localization.getCurrentLanguage(), gettextCatalog.getString('Profficina'));

            //get the settings for the sliders
            vm.productSliderSettings = productOverviewService.getProductSliderSettings();
            vm.newsSliderSettings = newsService.getNewsSliderSettings();

            vm.isFebelcoCustomer = authService.isFebelcoCustomer;
            if (vm.isFebelcoCustomer) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    vm.activeCampaigns = response;
                });
            }

            //load the adverts. Refactor code so it can be put in resolve with loading spinners shown
            advertService.getAdvertsForHomepage().then(function (model) {
                vm.adverts = model;
                angular.forEach(vm.adverts, function (advert) {
                    Analytics.addPromo(advert.id, advert.name, $state.current.name + ' ' + advert.sequenceNr, '');
                });
                //Analytics.pageView(); // Homepage werd 2x getrackt hierdoor
            });

            //load the news items. Do not put in resolve or loading spinners will not be shown
            newsService.getNewsForHomepage().then(function (model) {
                vm.newsitems = model;
            });

            //load the product items. do not put in resolve or loading spinners will not be shown
            vm.discountsModel = productOverviewService.init(Enums.searchContext.discount.id);
            productOverviewService.getProductsForHomepage(true, vm.discountsModel).then(function (model) {
                vm.discountsModel = model;
                vm.products = model.products;
                vm.errorOccurredInProductOverview = model.errorOccurred;
            });

            //update quantity on enter
            angular.element($window).on('keydown', function (event) {
                if (event.which === 13 && vm.addingProducts !== true) {
                    vm.addToCart();
                }
            });

            $scope.$on('$destroy', function () {
                angular.element($window).off('keydown');
            });
        }

        function advertClicked(advert) {
            Analytics.addPromo(advert.id, advert.name, $state.current.name + ' ' + advert.sequenceNr, '');
            Analytics.promoClick('Home');
        }

        function buildUrl(url) {
            return $location.path() + url;
        }

        function _badgeClicked(categoryId) {
            vm.badgeClicked({
                categoryId: categoryId
            });
        }

        function onChangeQuantity() {
            vm.productsQuantityChanged = true;
            vm.productsAdded = false;
            vm.isOpen = true;
        }

        function addToCart() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;
            cartService.updateCartOverview(vm.products).then(function (shoppingCartProducts) {
                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }
                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                vm.shoppingCartProducts = shoppingCartProducts;

                vm.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                $timeout(function () {
                    vm.productsAdded = false;
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.isOpen = false;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
                vm.hasError = true;
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};

exports.default = options;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _home = __webpack_require__(936);

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.home', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general', {
        url: '',
        parent: 'master',
        abstract: true,
        views: {
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData"></site-nav>'
            }
        },
        resolve: {
            navigationData: ["categoryService", "sellerService", "$q", function navigationData(categoryService, sellerService, $q) {
                var promises = [];
                promises.push(categoryService.getMenuCategories());
                promises.push(sellerService.getAllForMenu());

                return $q.all(promises).then(function (results) {
                    return {
                        categories: results[0],
                        sellers: results[1]
                    };
                });
            }],
            parentState: ["$state", function parentState($state) {
                return $state.get('general');
            }]
        },
        ncyBreadcrumb: {
            skip: true // Never display this state in breadcrumb.
        }
    }).state('home', {
        url: '',
        parent: 'general',
        views: {
            'main@root': {
                component: 'home'
            }
        },
        ncyBreadcrumb: {
            skip: true // Never display this state in breadcrumb.
        }
    });
}]).component('home', _home2.default);

exports.default = _module.name;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var buyerBaseSelectComponent = exports.buyerBaseSelectComponent = {
    template: __webpack_require__(598),
    bindings: {
        onCancel: '&?',
        sellerId: '<?',
        onConfirm: '&'
    },
    controllerAs: 'vm',
    controller: ["buyerBaseService", function buyerBaseSelectController(buyerBaseService) {
        'ngInject';

        var vm = this;
        vm.buyers;
        vm.buyersCount;

        vm.save = save;
        vm.close = close;

        vm.onSearch = onSearch;
        vm.searchValue = '';
        vm.showSpinner = false;

        function onSearch() {
            if (vm.searchValue.trim() !== '') {
                vm.showSpinner = true;
                vm.buyers = undefined;
                buyerBaseService.search(vm.searchValue, this.sellerId).then(function (resources) {
                    vm.buyers = resources.results;
                    vm.buyersCount = resources.count;
                }).finally(function () {
                    vm.showSpinner = false;
                });
            }
        }

        function save(selectedBuyer) {
            vm.onConfirm({ $event: selectedBuyer });
        }

        function close() {
            vm.onCancel({ $event: 'closed' });
        }
    }]
};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _login = __webpack_require__(940);

var _siteNav = __webpack_require__(943);

var _siteHeader = __webpack_require__(942);

var _siteFooter = __webpack_require__(941);

var _buyerBaseSelect = __webpack_require__(938);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.layout', ['ng']).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('login', {
        parent: 'master',
        url: '/login',
        views: {
            'main@root': {
                component: 'login'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': '',
            'submenu@root': '',
            'footer@root': ''
        },
        data: {
            noTenant: true
        },
        resolve: {
            tenants: ["$injector", function tenants($injector) {
                var tenantService = $injector.get('tenantService');
                var authService = $injector.get('authService');
                if (!authService.hasClaim('ShopAdmin')) {
                    return tenantService.getAll().then(function (tenants) {
                        authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                            tenants: tenants
                        });
                        return tenants;
                    });
                }
            }],
            isAdmin: ["$injector", function isAdmin($injector) {
                var authService = $injector.get('authService');
                return authService.hasClaim('ShopAdmin');
            }],
            isSeller: ["$injector", function isSeller($injector) {
                var authService = $injector.get('authService');
                return authService.isSeller;
            }],
            isBuyer: ["$injector", function isBuyer($injector) {
                var authService = $injector.get('authService');
                return authService.isBuyer;
            }],
            redirectLocation: ["$stateParams", function redirectLocation($stateParams) {
                return $stateParams.redirectLocation || '/';
            }],
            selectedSauk: ["$stateParams", function selectedSauk($stateParams) {
                return $stateParams.selectedSauk;
            }]
        },
        params: {
            redirectLocation: { value: '/', squash: true },
            selectedSauk: { value: null, squash: true }
        }
    });
}]).component('login', _login.loginComponent).component('siteNav', _siteNav.siteNavComponent).component('siteHeader', _siteHeader.siteHeaderComponent).component('siteFooter', _siteFooter.siteFooterComponent).component('buyerBaseSelect', _buyerBaseSelect.buyerBaseSelectComponent);

exports.default = _module.name;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loginComponent = exports.loginComponent = {
    template: __webpack_require__(599),
    controllerAs: 'vm',
    bindings: {
        redirectLocation: '@?',
        tenants: '<?',
        isAdmin: '<',
        isBuyer: '<',
        isSeller: '<',
        selectedSauk: '<?'
    },
    controller: ["common", "gettextCatalog", "authService", function controller(common, gettextCatalog, authService) {
        'ngInject';

        var vm = this;
        vm.select = select;
        vm.selectSeller = selectSeller;
        vm.$onInit = init;
        vm.confirm = confirm;

        vm.selectedTenant = undefined;

        function init() {
            var _this = this;

            common.navigationMenu.setHomeActive();
            common.setTitle(gettextCatalog.getString('Log in'));
            if (this.selectedSauk) {
                this.selectSeller(this.tenants.find(function (x) {
                    return x.secondaryAppUserKey === _this.selectedSauk;
                }));
            }
        }

        function select(tenant) {
            var isSeller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var redirect = vm.redirectLocation;
            if (isSeller && redirect && redirect.indexOf('/nl/' + vm.selectedTenant.sellerId) < 0 && redirect.indexOf('/fr/' + vm.selectedTenant.sellerId)) {
                redirect = '/';
            }
            authService.signIn(redirect, { tenant: tenant }).catch(function () {
                common.log.warn('Signin with tenant failed');
            });
        }

        function selectSeller(tenant) {
            this.selectedTenant = tenant;
        }

        function confirm(buyer) {
            if (this.isBuyer) {
                vm.select(buyer.id);
            } else {
                vm.select(this.selectedTenant.secondaryAppUserKey + ';' + buyer.id, true);
            }
        }
    }]
};

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var siteFooterComponent = exports.siteFooterComponent = {
    template: __webpack_require__(600),
    controllerAs: 'vm',
    controller: ["config", "localizer", "$state", function controller(config, localizer, $state) {
        'ngInject';

        var vm = this;
        vm.env = config.env !== 'prod' ? config.env : '';
        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.setLanguage = setLanguage;

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', { language: language });
        }
    }]
};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.siteHeaderComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteHeaderComponent = exports.siteHeaderComponent = {
    template: __webpack_require__(601),
    bindings: {
        navigationData: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$element", "$state", "$timeout", "config", "productService", "common", "exceptionService", "gettextCatalog", "authService", "dialogService", "ngDialog", "localizer", "reservationCampaignService", "Analytics", function controller(
    // $rootScope,
    $scope, $element, $state, $timeout, config,
    // ProductSearchRequest,
    // cartService,
    productService, common, exceptionService, gettextCatalog, authService, dialogService, ngDialog, localizer, reservationCampaignService, Analytics) {
        'ngInject';

        var vm = this;
        vm.name = '';
        vm.apbNumber = '';
        vm.tenantsCount = null;

        vm.toggleAccount = toggleAccount;
        vm.hideAccount = hideAccount;
        vm.showAccount = showAccount;
        vm.signOut = signOut;
        vm.changeTenant = changeTenant;

        vm.searchValue = '';
        vm.isLoading = false;
        vm.searchResults = null;
        vm.search = search;
        vm.searchIsOpen = false;
        vm.searchIsHovered = false;
        vm.showSearch = showSearch;
        vm.hideSearch = hideSearch;
        vm.onKeydownSearch = onKeydownSearch;
        vm.onMouseEnterSearchResults = onMouseEnterSearchResults;
        vm.selectedSearchResultIndex = -1;

        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.setLanguage = setLanguage;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.checkVaccinDate = checkVaccinDate;

        vm.isShopAdmin = null;
        vm.selectTenant = selectTenant;
        vm.changeBuyerBase = changeBuyerBase;
        vm.changeSellerBuyerBase = changeSellerBuyerBase;
        vm.changeSeller = changeSeller;
        vm.vaccinesConfig = config.fluVaccines;
        vm.fluVaccinesEndDate = null;
        vm.fluVaccinesStartDate = null;

        vm.activeCampaigns = [];

        function checkVaccinDate() {
            vm.fluVaccinesEndDate = vm.vaccinesConfig.endDate;
            vm.fluVaccinesStartDate = vm.vaccinesConfig.startDate;
            return (0, _moment2.default)(vm.fluVaccinesStartDate).format('YYYY-MM-DD') <= (0, _moment2.default)().format('YYYY-MM-DD') && (0, _moment2.default)(vm.fluVaccinesEndDate).format('YYYY-MM-DD') >= (0, _moment2.default)().format('YYYY-MM-DD');
            // var today= moment().format('YYYY-MM-DD');
            // var startDate= moment('2020-03-16').format('YYYY-MM-DD');
            // var endDate = moment(config.vaccinesEndDate).format('YYYY-MM-DD');
            // var condition = startDate <= today && endDate >= today;
            // if (condition) {
            //     return true;
            // }
            // return false; //change to false to make this work
        }

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', {
                language: language
            });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        vm.preventDefault = function (e) {
            e.preventDefault();
        };
        vm.$onInit = init;

        function init() {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === authService.user.SAUK || !!t.id && t.id === parseInt(authService.user.BuyerID, 10);
            });
            if (!activeTenant) {
                $timeout(function () {
                    init();
                }, 100);
                return;
            }
            vm.name = authService.user.display_name;
            vm.tenantsCount = (tenants || []).length;
            if (activeTenant) {
                vm.apbNumber = activeTenant.apbNumber;
                vm.pharmacyName = activeTenant.name;
                vm.sellerName = activeTenant.sellerName;
                vm.canViewPackages = activeTenant.canViewPackages;
            }
            vm.isShopAdmin = authService.hasClaim('ShopAdmin');
            vm.isSeller = authService.isSeller;
            vm.isBuyer = authService.isBuyer;

            $element.find('.site-account a').on('click', function () {
                hideAccount();
            });

            if (isFebelcoCustomer()) {
                reservationCampaignService.getActiveReservationCampaigns().then(function (response) {
                    vm.activeCampaigns = response;
                });
            }
        }

        function toggleAccount() {
            angular.element('html').toggleClass('site-account-is-open');
        }

        function showAccount() {
            angular.element('html').toggleClass('site-account-is-open', true);
        }

        function hideAccount() {
            angular.element('html').toggleClass('site-account-is-open', false);
        }

        function signOut() {
            authService.signOut();
        }

        //tenant changed outside, update the tenant in menu
        $scope.$on('tenant-changed', function (event, args) {
            var tenants = authService.customUserInfo.tenants;
            var activeTenant = tenants && tenants.find(function (t) {
                return !!t.secondaryAppUserKey && t.secondaryAppUserKey === args.secondaryAppUserKey || !!t.id && t.id === parseInt(args.BuyerID, 10);
            });
            if (activeTenant) {
                vm.apbNumber = activeTenant.apbNumber;
                vm.pharmacyName = activeTenant.name;
                vm.sellerName = activeTenant.sellerName;
            }
        });

        function changeTenant() {
            return dialogService.selectTenant().then(function (tenant) {
                if (tenant.secondaryAppUserKey) {
                    vm.selectTenant(tenant.secondaryAppUserKey);
                    return tenant.secondaryAppUserKey;
                }
            }).then(function (secondaryAppUserKey) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.secondaryAppUserKey === secondaryAppUserKey;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function selectTenant(tenant) {
            authService.signIn('/', { tenant: tenant }).catch(function () {
                common.log.warn('Signin with tenant failed');
            });
        }

        function changeBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(result.id);
                return result.id;
            }).then(function (id) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.id === id;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function changeSellerBuyerBase() {
            ngDialog.openConfirm({
                template: '<buyer-base-select seller-id="' + authService.user.SellerID + '" on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                className: 'ngdialog ngdialog-theme-webshop',
                plain: true,
                showClose: true,
                closeByNavigation: true
            }).then(function (result) {
                vm.selectTenant(authService.user.SAUK + ';' + result.id);
                return { buyerId: result.id, sauk: authService.user.SAUK };
            }).then(function (response) {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return t.secondaryAppUserKey === response.sauk;
                });
                if (activeTenant) {
                    vm.apbNumber = activeTenant.apbNumber;
                    vm.pharmacyName = activeTenant.name;
                    vm.sellerName = activeTenant.sellerName;
                }
            });
        }

        function changeSeller() {
            return dialogService.selectTenant().then(function (tenant) {
                ngDialog.openConfirm({
                    template: '<buyer-base-select seller-id="' + tenant.sellerId + '" on-cancel="closeThisDialog($event)" on-confirm="confirm($event)"></buyer-base-select>',
                    className: 'ngdialog ngdialog-theme-webshop',
                    plain: true,
                    showClose: true,
                    closeByNavigation: true
                }).then(function (result) {
                    vm.selectTenant(tenant.secondaryAppUserKey + ';' + result.id);
                    return { buyerId: result.id, sauk: tenant.secondaryAppUserKey };
                }).then(function (response) {
                    var tenants = authService.customUserInfo.tenants;
                    var activeTenant = tenants && tenants.find(function (t) {
                        return t.secondaryAppUserKey === response.sauk;
                    });
                    if (activeTenant) {
                        vm.apbNumber = activeTenant.apbNumber;
                        vm.pharmacyName = activeTenant.name;
                        vm.sellerName = activeTenant.sellerName;
                    }
                });
            });
        }

        // Search

        function search() {
            common.log.info('go to search view from the search input box');

            if (vm.searchValue !== '') {
                $state.go('search', {
                    searchValue: vm.searchValue,
                    page: 1,
                    pageSize: 24,
                    sortProperty: '',
                    sortAsc: true
                });
                hideSearch();
            }
        }

        function showSearch() {
            vm.searchIsOpen = true;
            angular.element('html').toggleClass('locked site-search-is-open', true);
            angular.element('#search-input').find('input').focus();
        }

        function hideSearch() {
            vm.searchResults = null;
            vm.selectedSearchResultIndex = -1;
            vm.searchValue = '';

            vm.searchIsOpen = false;
            angular.element('html').toggleClass('locked site-search-is-open', false);
        }

        function onKeydownSearch() {
            //vm.showSearch();
            if (vm.searchResults && vm.searchResults.products) {
                if (event.keyCode === 40) {
                    // keyIdentifier = 'Down'
                    if (vm.selectedSearchResultIndex >= vm.searchResults.products.length) {
                        return;
                    }

                    vm.selectedSearchResultIndex++;
                } else if (event.keyCode === 38) {
                    // keyIdentifier = 'Up'
                    if (vm.selectedSearchResultIndex < 0) {
                        return;
                    }

                    vm.selectedSearchResultIndex--;
                } else if (event.keyCode === 13) {
                    // keyIdentifier = 'Enter'

                    if (!vm.searchResults || !vm.searchResults.products || vm.searchResults.products.length <= 0 || vm.selectedSearchResultIndex < 0 || vm.selectedSearchResultIndex > vm.searchResults.products.length) {
                        return;
                    }

                    if (vm.selectedSearchResultIndex === vm.searchResults.products.length) {
                        search();
                    } else {
                        var productId = vm.searchResults.products[vm.selectedSearchResultIndex].id;
                        common.log.info('go to product ' + productId + ' from search results');
                        $state.go('.product', {
                            productId: productId
                        });
                    }

                    vm.hideSearch();
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                }
            }
        }

        function onMouseEnterSearchResults(index) {
            vm.selectedSearchResultIndex = index;
        }

        $scope.$watch('vm.searchValue', function (newValue) {

            if (!newValue || newValue.length <= 2) {
                vm.searchResults = null;
                vm.selectedSearchResultIndex = -1;
                return;
            } else if (newValue && newValue.length > 2) {
                Analytics.trackPage('/search_results?q=' + newValue, 'send');
                Analytics.pageView();
            }

            vm.isLoading = true;
            common.log.info('search for ' + newValue);

            productService.searchProducts(newValue, 3).then(function (results) {
                Analytics.trackEvent('ProductSearch', 'siteHeaderSearch', newValue);
                vm.searchResults = results;
            }).catch(function () {
                exceptionService.logException(gettextCatalog.getString('The products cannot be retrieved.'));
            }).finally(function () {
                vm.isLoading = false;
            });
        });
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var siteNavComponent = exports.siteNavComponent = {
    template: __webpack_require__(602),
    bindings: {
        navigationData: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$element", "$state", "localizer", "authService", function controller(common, $element, $state, localizer, authService) {
        'ngInject';

        var vm = this;
        vm.isSellerActive = true;
        vm.currentLanguage = common.localization.getCurrentLanguage();
        vm.toggleMenu = toggleMenu;
        vm.hideMenu = hideMenu;
        vm.toggleSubmenu = toggleSubmenu;
        vm.hideSubmenu = hideSubmenu;
        vm.preventDefault = function (e) {
            e.preventDefault();
        };
        vm.$onInit = init;
        vm.desktopMenuThreshold = 768;
        vm.currentLanguage = localizer.getCurrentLanguage();
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.setLanguage = setLanguage;
        vm.outletIsActive = outletIsActive;

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }

        function setLanguage(language) {
            localizer.setLanguage(language);
            $state.go('.', { language: language });
        }

        function init() {
            /*$element.find('a.has-sub').on('click', function(e){ 

                e.preventDefault();
                angular.element(e.currentTarget.parentElement).toggleClass('is-open');
            });*/
            $element.on('click', 'a:not(.has-sub)', function () {
                angular.element('html').toggleClass('site-nav-is-open', false);
                vm.hideSubmenu();
            });
        }

        function toggleMenu() {
            angular.element('html').toggleClass('site-nav-is-open');
        }

        function hideMenu() {
            angular.element('html').toggleClass('site-nav-is-open', false);
        }
        function outletIsActive() {
            return vm.navigationData.sellers.find(function (x) {
                return x.code === 'OUT';
            });
        }
        function toggleSubmenu(e) {
            e.preventDefault();
            var parent = angular.element(e.currentTarget.parentElement);
            var isOpen = parent.hasClass('is-open');
            if (!isOpen && window.innerWidth >= vm.desktopMenuThreshold) {
                // when opens ==> close others
                parent.siblings('.is-open').removeClass('is-open');
            }
            parent.toggleClass('is-open');
        }

        function hideSubmenu() {
            $element.find('.site-nav').find('.is-open').removeClass('is-open');
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsAsideComponent = exports.newsAsideComponent = {
    template: __webpack_require__(603),
    bindings: {
        topNewsitems: '=',
        errorOccurred: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.newsSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                touchMove: false,
                adaptiveHeight: false
            };
        }
    }
};

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsGridComponent = exports.newsGridComponent = {
    template: __webpack_require__(604),
    bindings: {
        newsitems: '<',
        errorOccurred: '<',
        viewMode: '@',
        badgeClicked: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: function newsOverviewController() {
        'ngInject';

        var vm = this;
        vm._badgeClicked = _badgeClicked;

        function _badgeClicked(categoryId) {
            vm.badgeClicked({ categoryId: categoryId });
        }
    }
};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsOverviewComponent = undefined;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsOverviewComponent = exports.newsOverviewComponent = {
    template: __webpack_require__(605),
    bindings: {
        model: '<',
        viewMode: '@',
        itemsPerPageChanged: '&',
        selectedCategory: '<',
        badgeClicked: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "Analytics", function newsOverviewController($scope, $state, Analytics) {
        'ngInject';

        var vm = this;

        vm.search = search;
        vm.clear = clear;
        vm.onKeydown = onKeydown;
        vm.goToPage = goToPage;
        vm.selectCategoriesChanged = selectCategoriesChanged;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.pagecountList = [12, 24, 36];
        vm._badgeClicked = _badgeClicked;

        function search() {
            Analytics.trackEvent('News', 'newsSearch', vm.model.searchValue, 0, true);
            $state.go('.', { page: 1, searchValue: vm.model.searchValue });
        }

        function clear() {
            vm.model.searchValue = null;
            $state.go('.', { page: 1, searchValue: vm.model.searchValue });
        }

        function onKeydown() {
            if (event.keyCode === 13) {
                // keyIdentifier = 'Enter'
                $state.go('.', { page: 1, searchValue: vm.model.searchValue });

                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
            }
        }

        function goToPage(page) {
            if (page === 0 || page > vm.model.paging.pageCount) {
                return;
            }
            $state.go('.', { page: page });
        }

        // function goToPage(page) {
        //     if (page === 0 || page > vm.paging.pageCount) { return; }
        //     vm.paging.page = page;
        //     getOrders();
        // }

        /* paging */
        function changeItemsPerPage(_ref) {
            var itemsPerPage = _ref.itemsPerPage;

            vm.model.paging.itemsPerPage = itemsPerPage;
            $state.go('.', { page: 1 });
            vm.itemsPerPageChanged({ $event: itemsPerPage });
        }

        function selectCategoriesChanged() {
            $state.go('.', { page: 1, categoryId: vm.model.selectedCategory.id });
        }

        function _badgeClicked(categoryId) {
            vm.model.selectedCategory = _lodash2.default.find(vm.model.categories, function (i) {
                return i.id === categoryId;
            });
            vm.badgeClicked({ categoryId: categoryId });
        }
    }]
};

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsRecentPopularComponent = exports.newsRecentPopularComponent = {
    template: __webpack_require__(606),
    bindings: {
        recentNews: '<',
        popularNews: '<',
        currentTab: '@'
    },
    controllerAs: 'vm',
    controller: function controller() {

        var vm = this;

        //vm.currentTab = currentTab;
        vm.onClickTab = onClickTab;

        function onClickTab(tabId) {
            vm.currentTab = tabId;
        }
    }
};

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsTagsComponent = exports.newsTagsComponent = {
    template: __webpack_require__(607),
    bindings: {
        tags: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsTileShortComponent = exports.newsTileShortComponent = {
    template: __webpack_require__(608),
    bindings: {
        news: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var newsTileComponent = exports.newsTileComponent = {
    template: __webpack_require__(609),
    bindings: {
        news: '<',
        badgeClicked: '&',
        parentState: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsDetail = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var newsDetail = exports.newsDetail = {
    template: __webpack_require__(610),
    bindings: {
        newsdetail: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "$state", "common", "$scope", "gettextCatalog", "Analytics", function controller($rootScope, $state, common, $scope, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.mediaTotal = 0;
        vm.extractVideoId = extractVideoId;
        vm.$onChanges = bindingChanges;

        vm.sliderSettings = {
            autoplay: true,
            autoplaySpeed: 10000,
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false
                }
            }],
            event: {
                beforeChange: function beforeChange(event, slick, currentSlide, nextSlide) {
                    slick.$slider.toggleClass('slick-slider-light', angular.element(slick.$slides[nextSlide]).find('.hero').hasClass('hero-light'));
                }
            }
        };

        function init() {

            common.setTitle(vm.newsdetail.title);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/news/' + vm.newsdetail.id, vm.newsdetail.title);

            //if there is no previous state go back news
            $state.previous.name === '' ? $state.previous.name = 'news' : $state.previous.name;
            //set the previous breadcrumb
            vm.breadcrumbPrevious = $state.fromParams.breadcrumbName ? $state.fromParams.breadcrumbName : gettextCatalog.getString('News');

            //vm.newsdetail.videos
            vm.mediaTotal = vm.newsdetail.gallery.length;

            //getMediaSliderDescription(0);
        }

        function bindingChanges(changes) {
            if (changes.newsdetail) {
                if (changes.newsdetail.currentValue) {
                    vm.newsdetail = Object.assign(changes.newsdetail.currentValue, {
                        description: (0, _marked2.default)(changes.newsdetail.currentValue.description || '')
                    });
                } else {
                    vm.newsdetail = changes.newsdetail.currentValue;
                }
            }
        }

        vm.gallerySliderSettings = {
            autoplay: false,
            dots: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            enabled: true,
            infinite: false,
            variableWidth: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }],
            method: {}
        };

        function extractVideoId(videoUrl) {
            var video_id = videoUrl.replace('http://www.youtube.com/', '');
            return video_id;
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _detail = __webpack_require__(951);

var _mainOverview = __webpack_require__(953);

var _newsByTag = __webpack_require__(954);

var _newsAside = __webpack_require__(944);

var _newsRecentPopular = __webpack_require__(947);

var _newsGrid = __webpack_require__(945);

var _newsOverview = __webpack_require__(946);

var _newsTags = __webpack_require__(948);

var _newsTile = __webpack_require__(950);

var _newsTileShort = __webpack_require__(949);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.news', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.news', {
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'mainNewsOverview'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"News" | translate}}'
        },
        doNotTrack: true
    }).state('general.newsbytag', {
        url: '/news/tag/{id:int}?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'newsByTag'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        }
    }).state('general.news.newsitem', {
        url: '/{newsItemId:int}',
        views: {
            'main@root': {
                component: 'news'
            }
        },
        resolve: {
            newsdetail: ["$stateParams", "newsService", function newsdetail($stateParams, newsService) {
                return newsService.getById($stateParams.newsItemId).then(function (newsdetail) {
                    return newsdetail;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.newsdetail.title | translate}}'
        }
    });
}]).component('news', _detail.newsDetail).component('mainNewsOverview', _mainOverview.mainNewsOverviewComponent).component('newsByTag', _newsByTag.newsByTagComponent).component('newsOverview', _newsOverview.newsOverviewComponent).component('newsRecentPopular', _newsRecentPopular.newsRecentPopularComponent).component('newsAside', _newsAside.newsAsideComponent).component('newsGrid', _newsGrid.newsGridComponent).component('newsTags', _newsTags.newsTagsComponent).component('newsTile', _newsTile.newsTileComponent).component('newsTileShort', _newsTileShort.newsTileShortComponent);

exports.default = _module.name;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var mainNewsOverviewComponent = exports.mainNewsOverviewComponent = {
    template: __webpack_require__(611),
    bindings: {
        recentnews: '<',
        popularnews: '<',
        tags: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsService", "newsOverviewService", "Enums", "gettextCatalog", "$state", "Analytics", function mainNewsOverviewController($scope, common, newsService, newsOverviewService, Enums, gettextCatalog, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;
        vm.itemsPerPageChanged = itemsPerPageChanged;
        vm.badgeClicked = badgeClicked;

        function init() {
            common.navigationMenu.setNewsActive();
            common.setTitle(gettextCatalog.getString('News'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/news', gettextCatalog.getString('News'));

            handleGetNews(12); //default page size is 12 todo put in const
        }

        function itemsPerPageChanged(itemsPerPage) {
            handleGetNews(itemsPerPage);
        }

        function handleGetNews(itemsPerPage) {
            newsOverviewService.handleGetNews($scope, Enums.newsContext.main.id, {}, itemsPerPage).then(function (model) {
                vm.newsOverviewModel = model;
            });
        }

        function badgeClicked(categoryId) {
            $state.go('.', {
                page: 1,
                categoryId: categoryId
            });
        }
    }]
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsByTagComponent = undefined;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var newsByTagComponent = exports.newsByTagComponent = {
    template: __webpack_require__(612),
    bindings: {
        recentnews: '<',
        popularnews: '<',
        tags: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "common", "newsService", "newsOverviewService", "Enums", "gettextCatalog", function newsByTagController($scope, $stateParams, common, newsService, newsOverviewService, Enums, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;

        function init() {
            var tagId = parseInt($stateParams.id);
            vm.tag = _lodash2.default.find(vm.tags, function (i) {
                return i.id === tagId;
            });

            common.navigationMenu.setNewsActive();
            common.setTitle(gettextCatalog.getString('News for ') + vm.tag.name);
            newsOverviewService.handleGetNews($scope, Enums.newsContext.main.id, { tagId: tagId }).then(function (i) {
                return vm.newsOverviewModel = i;
            });
        }
    }]
};

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var outletProductFiltersComponent = exports.outletProductFiltersComponent = {
    template: __webpack_require__(613),
    bindings: {
        paging: '=',
        changeFilters: '&',
        filternavFolder: '&',
        filterCategories: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.changeFilterCategoryLimit = changeFilterCategoryLimit;
        vm.onChangeFilters = onChangeFilters;

        function changeFilterCategoryLimit(category, limit) {
            category.limit = limit;
        }

        function onChangeFilters($event) {
            vm.changeFilters({ 'filter': $event.filter, 'category': $event.category });
        }
    }
};

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var outletProductOverviewComponent = exports.outletProductOverviewComponent = {
    template: __webpack_require__(614),
    bindings: {
        model: '<',
        context: '<',
        getProducts: '&',
        parentState: '<',
        filterCategories: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "productService", "queryStringHelper", "$state", "Enums", "$window", "cartService", "gettextCatalog", "exceptionService", "$timeout", "Analytics", "dialogService", function controller($scope, $stateParams, productService, queryStringHelper, $state, Enums, $window, cartService, gettextCatalog, exceptionService, $timeout, Analytics, dialogService) {
        'ngInject';

        var vm = this;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';
        vm.filternavFolderClass = '';
        vm.changeViewMode = changeViewMode;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.goToPage = goToPage;
        vm.changeSorting = changeSorting;
        vm.changeFilters = changeFilters;
        vm.clearFilter = clearFilter;
        vm.clearFilters = clearFilters;
        vm.filternavFolder = filternavFolder;
        vm.noItemsMessage = null;
        vm.$onInit = init;
        vm.isMobile = false;
        vm.updateQuantity = updateQuantity;
        vm.onChangeQuantity = onChangeQuantity;
        vm.productsQuantityChanged = false;
        vm.addingProducts = false;
        vm.getProductDiscounts = getProductDiscounts;
        $scope.forms = {};

        /* view mode */
        function init() {
            createNoItemsMessage();
            vm.isMobile = $window.innerWidth < 768;
            setPaging();

            //update quantity on enter
            angular.element($window).on('keydown', function (event) {
                if (event.which === 13 && vm.addingProducts !== true) {
                    vm.updateQuantity();
                }
            });
        }

        $scope.$on('$destroy', function () {
            angular.element($window).off('keydown');
        });

        function setPaging() {
            vm.model.paging.itemsPerPage = parseInt(window.sessionStorage.getItem('pageSize')) || parseInt($stateParams.pageSize);
        }

        function createNoItemsMessage() {
            if (!vm.model.productsAvailableForContext) {
                switch ($state.current.name) {
                    case 'seller.discounts' || 'general.discounts':
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no discounts available');
                        break;
                    default:
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no products available');
                }
            }
        }

        /* change view mode */
        function changeViewMode(viewMode) {
            // set local storage
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /* change paging */
        function changeItemsPerPage(itemsPerPage) {
            vm.model.isLoading = true;
            vm.model.paging.itemsPerPage = itemsPerPage;
            //cache the paging
            window.sessionStorage.setItem('pageSize', itemsPerPage);
            $state.go('.', { page: 1, pageSize: itemsPerPage });
        }

        function goToPage(page) {
            if ($scope.forms.productOverviewForm.$dirty === true) {
                dialogService.unsavedChanges().then(function () {
                    vm.isOpen = false;
                    vm.model.isLoading = true;
                    if (page === 0 || page > vm.model.paging.pageCount) {
                        return;
                    }
                    $state.go('.', { page: page });
                }, function () {
                    return false;
                });
            } else {
                vm.isOpen = false;
                vm.model.isLoading = true;
                if (page === 0 || page > vm.model.paging.pageCount) {
                    return;
                }
                $state.go('.', { page: page });
            }
        }

        /* sorting changed */
        function changeSorting(sortProperty) {
            //set the new sorting
            var sortAscByDefault = sortProperty.defaultSorting === 'asc';
            vm.model.sorting.sortAsc = sortProperty.value === vm.model.sorting.sortProperty ? !vm.model.sorting.sortAsc : sortAscByDefault;
            vm.model.sorting.sortProperty = sortProperty.value;

            // put the new properties in local storage
            window.localStorage.setItem($state.current.name + '-sortProperty', sortProperty.value);
            window.localStorage.setItem($state.current.name + '-sortAsc', vm.model.sorting.sortAsc);

            //go to the page with the correct sorting
            $state.go('.', {
                page: 1,
                sortProperty: sortProperty.value,
                sortAsc: vm.model.sorting.sortAsc
            });
        }

        /* filters changed TODO PUT IN SERVICE */
        function changeFilters(filter, category) {

            var categorySearch = category.items.find(function (filterHierarchyCategoryItem) {
                return filterHierarchyCategoryItem.isSelected === true;
            });

            //if the same category is selected do nothing
            if (filter.id === categorySearch.id) {
                return;
            }

            vm.model.isLoading = true;
            Analytics.trackEvent('Filter', 'setFilterOutletOverview', filter.name, 0, true);

            // select or unselect
            filter.isSelected = !filter.isSelected;

            //if the category is a link navigate to that page
            if (category.isLink) {
                navigateToPage(filter, category);
                return;
            }

            var filterParam = '';

            // on select/unselect, select/unselect all the children when the category is a parent
            if (filter.children && filter.children.length && !filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = false;
                    child.children.forEach(function (child) {
                        child.isSelected = false;
                    });
                });
            } else if (filter.children && filter.children.length && filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = true;
                    child.children.forEach(function (child) {
                        child.isSelected = true;
                    });
                });
            }

            // create the query string
            filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);
            // navigate to the route with craeted filter params
            $state.go('.', { page: 1, filter: filterParam });
        }

        /* clear the filter */
        function clearFilter(filter, category) {
            vm.model.isLoading = true;

            if (category.isLink) {
                return;
            }

            // when category is hierarchical, don't get isSelected from the items, but set the query string param directly
            var filterParam = '';
            if (!vm.model.filter.isCategoryHierarchical(category.id)) {
                vm.model.filter.clearFilter(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);
            } else {
                var selectedId = vm.model.filter.getParentIdOfChildCategory(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories, category.id, selectedId);
            }

            $state.go('.', { page: 1, filter: filterParam });
        }

        /* reset the page when clearing the filters */
        function clearFilters() {
            vm.model.isLoading = true;

            $state.go('.', {
                page: 1,
                pageSize: 24,
                sortProperty: '',
                sortAsc: true,
                filter: ''
            });
        }

        /* On filter changed, navigate to correct page */
        function navigateToPage(filter) {
            $state.go('general.outlet.category', {
                categoryId: filter.id,
                filter: $stateParams.filter === Enums.otherCategoryType.discountsOnly.id + '_1' ? Enums.otherCategoryType.discountsOnly.id + '_1' : '',
                page: 1,
                noReloadFilter: true
            });
        }

        /* toggle visibility sorting or filters */
        function filternavFolder(folderClass) {
            if (folderClass === vm.filternavFolderClass) {
                folderClass = '';
            }
            vm.filternavFolderClass = folderClass;
        }

        /* add products to the shoppingcart */
        function updateQuantity() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;

            var productFilterNoPanacee = vm.model.products.filter(function (x) {
                return x.productTypeCode !== 'panacee';
            });

            cartService.updateCartOverview(productFilterNoPanacee).then(function (shoppingCartProducts) {

                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }

                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;

                vm.model.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                cartService.setAddedProducts([]);
                cartService.addProductToCartAnalytics();

                $timeout(function () {
                    vm.isOpen = false;
                    vm.productsAdded = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.hasError = true;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
                exceptionService.logException(msg);
            });
        }

        /* quantity of product changed */
        function onChangeQuantity($event) {
            if ($event) {
                cartService.addProductToAddedProductsList($event);
            }

            if (!vm.addingProducts) {
                vm.isOpen = true;
                vm.productsAdded = false;
                vm.productsQuantityChanged = true;
            }
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _outletProducts = __webpack_require__(959);

var _outletCategoryOverview = __webpack_require__(958);

var _outletProductOverview = __webpack_require__(956);

var _outletProductFilters = __webpack_require__(955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.outlet', []);

_module.config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    $stateProvider.state('general.outlet', {
        url: '/op=op',
        views: {
            'main@root': {
                component: 'outletCategoryOverview'
            }
        },
        resolve: {
            categories: ["outletService", function categories(outletService) {
                return outletService.getCategories().then(function (categories) {
                    return categories;
                });
            }],
            textFields: ["outletService", function textFields(outletService) {
                return outletService.getTextFields().then(function (textFields) {
                    return textFields;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Outlet" | translate}}'
        },
        reloadOnSearch: false,
        data: {
            febelcoCustomer: true
        }
    }).state('general.outlet.category', {
        url: '/category/{categoryId:int}?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'outletProducts'
            }
        },
        params: {
            page: { value: '1', squash: true, dynamic: true },
            pageSize: { value: window.sessionStorage.getItem('pageSize'), squash: false, dynamic: true },
            sortProperty: { value: sortProperties['Name'].value, squash: true, dynamic: true, array: false },
            sortAsc: { value: (sortProperties['Name'].defaultSorting === 'asc').toString(), squash: true, dynamic: true, array: false },
            filter: { value: '103_1', squash: true, dynamic: true },
            categoryId: { squash: true },
            noReloadFilter: { squash: true }
        },
        resolve: {
            // category: ($stateParams, categoryService) => {
            //     return categoryService.getById($stateParams.categoryId);
            // }
        },
        reloadOnSearch: false,
        ncyBreadcrumb: {
            label: '{{$resolve.category.name}}'
        },
        data: {
            febelcoCustomer: true
        }
    });
}]);

_module.component('outletProducts', _outletProducts.outletProductsComponent);
_module.component('outletProductOverview', _outletProductOverview.outletProductOverviewComponent);
_module.component('outletProductFilters', _outletProductFilters.outletProductFiltersComponent);
_module.component('outletCategoryOverview', _outletCategoryOverview.outletCategoryOverviewComponent);
exports.default = _module.name;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.outletCategoryOverviewComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var outletCategoryOverviewComponent = exports.outletCategoryOverviewComponent = {
    template: __webpack_require__(615),
    bindings: {
        categories: '<',
        textFields: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "$state", "Analytics", function controller(common, gettextCatalog, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.$state = $state;
        vm.language = window.localStorage.getItem('language');
        vm.$onChanges = bindingChanges;

        function init() {
            common.setTitle(gettextCatalog.getString('OP=OP'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/op=op');
        }

        function bindingChanges(changes) {
            if (changes.textFields) {
                if (changes.textFields.currentValue) {
                    vm.textFields = Object.assign(changes.textFields.currentValue, {
                        topText: (0, _marked2.default)(changes.textFields.currentValue.topText || '')
                    });
                } else {
                    vm.partnership = changes.partnership.currentValue;
                }
            }
        }
    }]
};

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var outletProductsComponent = exports.outletProductsComponent = {
    template: __webpack_require__(616),
    bindings: {
        parentState: '<',
        categories: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "$stateParams", "gettextCatalog", "Analytics", "$state", function controller($scope, productOverviewService, Enums, common, $stateParams, gettextCatalog, Analytics, $state) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$state = $state;
        vm.category = null;
        vm.onFilterChange = onFilterChange;

        function init() {

            vm.category = vm.categories.find(function (category) {
                return category.url === $stateParams.categoryId;
            });
            common.setTitle(gettextCatalog.getString(vm.category.name + ' Products'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/op=op/category/' + $stateParams.categoryId, gettextCatalog.getString(vm.category.name));

            if (!$stateParams.categoryId) {
                vm.categoryId = 0;
            } else {
                vm.categoryId = $stateParams.categoryId;
            }

            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.category.id);
            }

            //todo repeating code put in function
            productOverviewService.getOutletProducts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, 0, $state.params.categoryId).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getOutletProducts(false, vm.productOverviewModel, 0, $state.params.categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var addProductsToolbar = exports.addProductsToolbar = {
    template: __webpack_require__(617),
    bindings: {
        product: '=',
        addingProducts: '<',
        productsQuantityChanged: '<',
        addToCart: '&',
        isOpen: '<',
        productsAdded: '<',
        hasError: '<'
    },
    controllerAs: 'vm',
    controller: function addProductsToolbarController() {
        'ngInject';
    }
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var includedProductsInPackComponent = exports.includedProductsInPackComponent = {
    template: __webpack_require__(618),
    bindings: {
        product: '<',
        quantityChanged: '&',
        context: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "Analytics", "productService", function includedProductsInPackController(common, Analytics, productService) {
        'ngInject';

        var vm = this;
        vm.productClicked = productClicked;
        vm.changeViewMode = changeViewMode;
        vm.packQuantityChanged = packQuantityChanged;
        vm.getProductDiscounts = getProductDiscounts;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';

        // buy quantity pack changed
        function packQuantityChanged(product) {
            vm.productsQuantityChanged = true;
            vm.quantityChanged(product);
        }

        // save in local storage when viewmode is changed
        function changeViewMode(viewMode) {
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /*Google Analytics */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, null, vm.product.brand, null, vm.product.price, null, null, null, { dimension1: vm.product.sellerId, dimension2: vm.product.sellerName, dimension3: vm.product.discountId });
            Analytics.productClick('Included product in pack');
            common.log.info('Analysis: product clicked from included product in pack', vm.product.name);
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var includedProductsInPanaceeComponent = exports.includedProductsInPanaceeComponent = {
    template: __webpack_require__(619),
    bindings: {
        product: '=',
        context: '<',
        quantityChanged: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["productService", function controller(productService) {
        'ngInject';

        var vm = this;
        vm.orderByProperty = 'name';
        vm.isOrderByDescending = false;
        vm.setOrder = setOrder;
        vm.panaceeQuantityChanged = panaceeQuantityChanged;
        vm.changeViewMode = changeViewMode;
        vm.getProductDiscounts = getProductDiscounts;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';

        /* On quantity on changed */
        function panaceeQuantityChanged(product) {
            vm.productsQuantityChanged = true;
            vm.quantityChanged(product);
        }

        /* Save in localstorage when viewmode changed */
        function changeViewMode(viewMode) {
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /* Order the products */
        function setOrder(propName) {
            if (vm.orderByProperty === propName) {
                vm.isOrderByDescending = !vm.isOrderByDescending;
            } else {
                vm.isOrderByDescending = false;
            }
            vm.orderByProperty = propName;
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var medipimInfoComponent = exports.medipimInfoComponent = {
    template: __webpack_require__(620),
    bindings: {
        medipimData: '<',
        product: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var panaceeOverviewGridItemComponent = exports.panaceeOverviewGridItemComponent = {
    template: __webpack_require__(621),
    bindings: {
        product: '=',
        isLast: '=',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        getProductDiscounts: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "common", "exceptionService", "gettextCatalog", "Analytics", "$stateParams", "$state", "productService", "authService", function controller($scope, cartService, common, exceptionService, gettextCatalog, Analytics, $stateParams, $state, productService, authService) {
        'ngInject';

        var vm = this;
        vm.categoryId = $stateParams.id;
        vm.productDiscountsOpen = false;
        vm.productDiscounts = {};
        vm.productDiscountClicked = productDiscountClicked;
        vm.loadProductDiscounts = loadProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.getDiscountPrice = getDiscountPrice;
        vm.getGrossProfit = getGrossProfit;
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.productClicked = productClicked;
        vm.isFebelcoCustomer = isFebelcoCustomer;

        /* Get the discount price */
        function getDiscountPrice() {
            return vm.product.price - vm.product.price * vm.product.discountPct / 100;
        }

        /* Get the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        /* google analytics when product clicked */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { sellerId: vm.product.sellerId, sellerName: vm.product.sellerName, discountId: vm.product.discountId });
            Analytics.productClick(vm.context);
            Analytics.trackEvent('Product', 'click', vm.product.name);
            common.log.info('Analysis: product clicked', vm.product.name);
        }

        /* google analytics when product clicked */
        function productDiscountClicked() {
            // Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { dimension1: vm.product.sellerId, dimension2: vm.product.sellerName, dimension3: vm.product.discountId });
            // Analytics.productClick(vm.context);
            Analytics.trackEvent('ProductDiscount', 'click', vm.product.name);
            common.log.info('Analysis: product discount clicked', vm.product.name);
        }

        /* load the product discounts */
        function loadProductDiscounts() {
            productDiscountClicked();
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    vm.getProductDiscounts(vm.product).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        /* open the porduct discounts */
        function toggleProductDiscounts() {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    loadProductDiscounts();
                }
            }
        }

        /* close the product discounts */
        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var panaceeOverviewGridComponent = exports.panaceeOverviewGridComponent = {
    template: __webpack_require__(622),
    bindings: {
        products: '<',
        errorOccurred: '<',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        orderByProperty: '<',
        filter: '<',
        isOrderByDescending: '<',
        getProductDiscounts: '&',
        searchText: '<',
        totalProductsAmountInPanacee: '<'
    },
    controllerAs: 'vm',
    controller: ["Analytics", function panaceeOverviewGridController(Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getProductDiscountsList = getProductDiscountsList;

        function init() {
            angular.forEach(vm.products, function (p) {
                Analytics.addImpression(p.id, p.name, vm.context, p.brand, '', '', '', p.price, { dimension1: p.sellerId, dimension2: p.sellerName, dimension3: p.discountId });
            });
            Analytics.pageView();
            vm.productsWithInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity > 1;
            });
            vm.productsWithoutInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity === 1 || x.internalQuantity === 0;
            });
        }

        /* get the product discounts */
        function getProductDiscountsList(product) {
            return vm.getProductDiscounts({ product: product });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var panaceeOverviewListItemComponent = exports.panaceeOverviewListItemComponent = {
    template: __webpack_require__(623),
    bindings: {
        product: '=',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        getProductDiscounts: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "common", "exceptionService", "gettextCatalog", "Analytics", "$stateParams", "$state", "productService", "authService", function controller($scope, cartService, common, exceptionService, gettextCatalog, Analytics, $stateParams, $state, productService, authService) {
        'ngInject';

        var vm = this;
        vm.productClicked = productClicked;
        vm.categoryId = $stateParams.id;
        vm.loadProductDiscounts = loadProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.getGrossProfit = getGrossProfit;
        // vm.getGrossProfitAmount = getGrossProfitAmount;
        vm.productDiscountsOpen = false;
        vm.getDiscountPrice = getDiscountPrice;
        vm.productDiscounts = {};
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.changeQuantity = changeQuantity;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.$onInit = init;

        function init() {
            if (vm.product.quantity === 0 && vm.product.minOrderAmount > 0) {
                vm.product.quantity = vm.product.minOrderAmount;
                vm.changeQuantity(vm.product);
            }
        }

        function changeQuantity(product) {
            vm.onChangeQuantity({ $event: product });
        }

        /* Get the discount price */
        function getDiscountPrice() {
            return vm.product.price - vm.product.price * vm.product.discountPct / 100; //todo put code like this in model or service
        }

        /* Get the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        /* google analytics when product clicked */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { sellerId: vm.product.sellerId, sellerName: vm.product.sellerName, discountId: vm.product.discountId });
            Analytics.productClick(vm.context);
            Analytics.trackEvent('Product', 'click', vm.product.name);
            common.log.info('Analysis: product clicked', vm.product.name);
        }

        /* google analytics when discount clicked */
        function productDiscountClicked() {
            Analytics.trackEvent('ProductDiscount', 'click', vm.product.name);
            common.log.info('Analysis: product discount clicked', vm.product.name);
        }

        /* load the product discounts */
        function loadProductDiscounts() {
            productDiscountClicked();
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    vm.getProductDiscounts(vm.product).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        /* open the product discounts */
        function toggleProductDiscounts() {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    loadProductDiscounts();
                }
            }
        }

        /* close the product discounts */
        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var panaceeOverviewListComponent = exports.panaceeOverviewListComponent = {
    template: __webpack_require__(624),
    bindings: {
        products: '<',
        errorOccurred: '<',
        context: '<',
        viewMode: '=',
        parentState: '<',
        onChangeQuantity: '&',
        filter: '<',
        isOrderByDescending: '<',
        getProductDiscounts: '&',
        totalProductsAmountInPanacee: '<',
        orderByProperty: '<',
        searchText: '<'
    },
    controllerAs: 'vm',
    controller: ["Analytics", function panaceeOverviewListController(Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getProductDiscountsList = getProductDiscountsList;
        vm.changeQuantity = changeQuantity;

        function init() {
            angular.forEach(vm.products, function (p) {
                Analytics.addImpression(p.id, p.name, vm.context, p.brand, '', '', '', p.price, { sellerId: p.sellerId, sellerName: p.sellerName, discountId: p.discountId });
            });

            vm.productsWithInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity > 1;
            });
            vm.productsWithoutInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity === 1 || x.internalQuantity === 0;
            });
            Analytics.pageView();
        }

        function changeQuantity($event) {
            vm.onChangeQuantity({ $event: $event });
        }

        /* get the product discounts */
        function getProductDiscountsList(product) {
            return vm.getProductDiscounts({ product: product });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productCertificatesOverviewSearchComponent = exports.productCertificatesOverviewSearchComponent = {
    template: __webpack_require__(625),
    bindings: {
        searchValue: '=',
        search: '&'
    },
    controllerAs: 'vm',
    controller: function productCertificatesOverviewSearchController() {
        'ngInject';

        var vm = this;
        vm.onSearch = onSearch;
        vm.searchValue;

        function onSearch() {
            vm.search({ $event: vm.searchValue });
        }
    }
};

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productDetailContentComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productDetailContentComponent = exports.productDetailContentComponent = {
    template: __webpack_require__(626),
    bindings: {
        product: '=',
        onChange: '&',
        addToCart: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "productService", "Enums", "authService", function controller($scope, cartService, productService, Enums, authService) {
        'ngInject';

        var vm = this;
        vm.onChangeQuantity = onChangeQuantity;
        vm.addToCartEnabled = true;
        vm.$onInit = init;
        vm.checkedStock = false;
        vm.stock = null;
        vm.context = Enums.productContexts['PRODUCTDETAIL'];
        vm.getGrossProfit = getGrossProfit;
        vm.getProductDiscounts = getProductDiscounts;
        vm.addProductToCart = addProductToCart;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.productDiscounts = {};
        $scope.forms = {};

        /* On it prepare the marked data */
        function init() {
            if (vm.product.mediPimData) {
                vm.product.mediPimData = Object.assign(vm.product.mediPimData, {
                    description: (0, _marked2.default)(vm.product.mediPimData.description || '')
                });
            }
            vm.getProductDiscounts();
        }

        /* get the product discounts */
        function getProductDiscounts() {
            vm.productDiscounts = vm.product.productDiscounts;

            // productService.getProductDiscounts(vm.product.id).then(x => {
            //     vm.productDiscounts = productService.formatProductDiscount(x);
            // });
        }

        /* On change: update the product totals */
        function onChangeQuantity() {
            // vm.product.updateTotals();
            vm.onChange();
        }

        /* Calculate the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        // function getGrossProfitAmount(){
        //     return productService.calculateGrossProfitAmount(vm.product);
        // }

        function addProductToCart() {
            $scope.forms.productOverviewForm.$setPristine();
            vm.addToCart();
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productDiscountsComponent = exports.productDiscountsComponent = {
    template: __webpack_require__(627),
    bindings: {
        close: '&',
        context: '<',
        portalContractTypeCode: '<',
        isLoading: '<',
        parentState: '<',
        productDiscounts: '<',
        parentProductType: '<',
        activeDiscounts: '<',
        totalPriceDiscountIds: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "discountTypeNames", function controller(common, discountTypeNames) {
        'ngInject';

        var vm = this;
        vm.getDiscountType = getDiscountType;
        vm.isActiveDiscount = isActiveDiscount;
        vm.isTotalPriceDiscountId = isTotalPriceDiscountId;
        vm.counter = getCounter;

        function getDiscountType(discountType) {
            return discountTypeNames[discountType].clientValue;
        }
        function getCounter() {
            return;
        }
        function isActiveDiscount(productDiscount) {
            var idSearch = vm.activeDiscounts.find(function (activeDiscountId) {
                return productDiscount.discountId === activeDiscountId;
            });
            return idSearch ? 'product-discount is-active' : 'product-discount';
        }

        function isTotalPriceDiscountId(productDiscount) {
            var idSearch = vm.totalPriceDiscountIds.find(function (totalPriceDiscountId) {
                return productDiscount.discountId === totalPriceDiscountId;
            });
            return idSearch ? 'product-discount is-active' : 'product-discount';
        }
    }]
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productFiltersComponent = exports.productFiltersComponent = {
    template: __webpack_require__(628),
    bindings: {
        filter: '<',
        paging: '=',
        changeFilters: '&',
        filternavFolder: '&'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.changeFilterCategoryLimit = changeFilterCategoryLimit;
        vm.onChangeFilters = onChangeFilters;
        vm.expandFilters = expandFilters;
        vm.getFilterCategories = getFilterCategories;

        function getFilterCategories() {
            vm.expandFilters();
            return vm.filter.filterCategories;
        }

        function changeFilterCategoryLimit(category, limit) {
            category.limit = limit;
        }

        function onChangeFilters($event) {
            vm.changeFilters({ 'filter': $event.filter, 'category': $event.category });
        }
        function expandFilters() {
            var _this = this;

            if (!vm.filter.isAutoExpanded) {
                vm.filter.isAutoExpanded = true;
                vm.filter.filterCategories.forEach(function (category) {
                    for (var i = category.items.length - 1; i >= 0; i--) {
                        if (category.items[i].isSelected && i + 1 > category.limit) {
                            _this.changeFilterCategoryLimit(category, 9999);
                            break;
                        }
                    }
                });
            }
        }
    }
};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productImageComponent = exports.productImageComponent = {
    //todo gewoon product doorgeven?
    template: __webpack_require__(629),
    bindings: {
        productId: '<',
        image: '<',
        imageSize: '@',
        discount: '<',
        message: '<',
        productClicked: '&',
        navigateToProductDetailPage: '&',
        parentState: '<',
        portalContractTypeCode: '<',
        counterStatus: '<',
        counter: '<',
        maxDiscount: '<',
        discountClicked: '&',
        addLink: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productInfoBoxComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productInfoBoxComponent = exports.productInfoBoxComponent = {
    template: __webpack_require__(630),
    bindings: {
        title: '@',
        text: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            if (vm.text) {
                vm.text = (0, _marked2.default)(vm.text || '');
            }
        }
    }
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productInfoComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var productInfoComponent = exports.productInfoComponent = {
    template: __webpack_require__(631),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm',
    controller: ["lodash", "certificatesService", function controller(lodash, certificatesService) {
        'ngInject';

        var vm = this;
        vm.hasNotices = hasNotices;
        vm.searchValue = '';
        vm.batchNumberSearch = batchNumberSearch;
        vm.searchByBatchNumber = searchByBatchNumber;
        vm.getCoaUrl = getCoaUrl;
        vm.getMargin = getMargin;
        vm.$onInit = init;

        function hasNotices() {
            return vm.product.mediPimData ? vm.product.mediPimData.faggPublicNotice || vm.product.mediPimData.faggSpecialNotice || vm.product.mediPimData.pharmaPublicNotice || vm.product.mediPimData.pharmaSpecialNotice || vm.product.mediPimData.laboPublicNotice || vm.product.mediPimData.laboSpecialNotice : false;
        }

        function init() {
            if (vm.product.mediPimData) {
                vm.appstores = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 1;
                });
                vm.leaflets = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 2;
                });
                vm.videos = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 3;
                });
                vm.websites = lodash.filter(vm.product.mediPimData.media, function (i) {
                    return i.type === 4;
                });
            }
        }

        function searchByBatchNumber(event) {
            vm.searchValue = event;
        }

        function batchNumberSearch(item) {
            if (vm.searchValue === '' || item.batchNumber && item.batchNumber.toLowerCase().indexOf(vm.searchValue) !== -1) {
                return true;
            }
            return false;
        }

        function getCoaUrl(id) {
            return certificatesService.getCoaUrl(id);
        }

        function getMargin(size) {
            return { "margin-left": +2 * (size - 1) + "em" };
        }
    }]
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewGridItemComponent = exports.productOverviewGridItemComponent = {
    template: __webpack_require__(632),
    bindings: {
        product: '=',
        isLast: '=',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        getProductDiscounts: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "common", "exceptionService", "gettextCatalog", "Analytics", "$stateParams", "$state", "productService", "authService", function controller($scope, cartService, common, exceptionService, gettextCatalog, Analytics, $stateParams, $state, productService, authService) {
        'ngInject';

        var vm = this;
        vm.categoryId = $stateParams.id;
        vm.productDiscountsOpen = false;
        vm.productDiscounts = {};
        vm.productDiscountClicked = productDiscountClicked;
        vm.loadProductDiscounts = loadProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.getDiscountPrice = getDiscountPrice;
        vm.getGrossProfit = getGrossProfit;
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.productClicked = productClicked;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.counter = vm.product.counter;
        vm.soldOut = false;

        /* Get the discount price */
        function getDiscountPrice() {
            return vm.product.price - vm.product.price * vm.product.discountPct / 100;
        }

        /* Get the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        /* google analytics when product clicked */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { sellerId: vm.product.sellerId, sellerName: vm.product.sellerName, discountId: vm.product.discountId });
            Analytics.productClick(vm.context);
            Analytics.trackEvent('Product', 'click', vm.product.name);
            common.log.info('Analysis: product clicked', vm.product.name);
        }

        /* google analytics when product clicked */
        function productDiscountClicked() {
            // Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { dimension1: vm.product.sellerId, dimension2: vm.product.sellerName, dimension3: vm.product.discountId });
            // Analytics.productClick(vm.context);
            Analytics.trackEvent('ProductDiscount', 'click', vm.product.name);
            common.log.info('Analysis: product discount clicked', vm.product.name);
        }

        /* load the product discounts */
        function loadProductDiscounts() {
            productDiscountClicked();
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;

                    //todo get the resolved discounts object from the parent and not the promise (bad practice)
                    vm.getProductDiscounts(vm.product).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        /* open the product discounts */
        function toggleProductDiscounts() {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    loadProductDiscounts();
                }
            }
        }

        /* close the product discounts */
        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewGridComponent = exports.productOverviewGridComponent = {
    template: __webpack_require__(633),
    bindings: {
        products: '<',
        errorOccurred: '<',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        orderByProperty: '<',
        filter: '<',
        isOrderByDescending: '<',
        getProductDiscounts: '&',
        searchText: '<'
    },
    controllerAs: 'vm',
    controller: function productOverviewGridController() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getProductDiscountsList = getProductDiscountsList;

        function init() {}
        // angular.forEach(vm.products, (p) => {
        //     Analytics.addImpression(p.id, p.name, vm.context, p.brand, '', '', '', p.price, { dimension1: p.sellerId, dimension2: p.sellerName, dimension3: p.discountId });
        // });
        // Analytics.pageView();           


        /* get the product discounts */
        function getProductDiscountsList(product) {
            return vm.getProductDiscounts({ product: product });
        }
    }
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewListItemComponent = exports.productOverviewListItemComponent = {
    template: __webpack_require__(634),
    bindings: {
        product: '=',
        context: '<',
        parentState: '<',
        onChangeQuantity: '&',
        getProductDiscounts: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", "cartService", "common", "exceptionService", "gettextCatalog", "Analytics", "$stateParams", "$state", "productService", "authService", function controller($scope, cartService, common, exceptionService, gettextCatalog, Analytics, $stateParams, $state, productService, authService) {
        'ngInject';

        var vm = this;
        vm.productClicked = productClicked;
        vm.categoryId = $stateParams.id;
        vm.loadProductDiscounts = loadProductDiscounts;
        vm.toggleProductDiscounts = toggleProductDiscounts;
        vm.getGrossProfit = getGrossProfit;
        vm.productDiscountsOpen = false;
        vm.getDiscountPrice = getDiscountPrice;
        vm.productDiscounts = {};
        vm.closeProductDiscounts = closeProductDiscounts;
        vm.changeQuantity = changeQuantity;
        vm.isFebelcoCustomer = isFebelcoCustomer;

        vm.soldOut = false;

        function changeQuantity(product) {
            vm.onChangeQuantity({ $event: product });
        }

        // TODO put in product model
        /* Get the discount price  */
        function getDiscountPrice() {
            return vm.product.price - vm.product.price * vm.product.discountPct / 100;
        }

        /* Get the gross profit */
        function getGrossProfit() {
            return productService.calculateGrossProfitWithoutDiscount(vm.product);
        }

        /* google analytics when product clicked */
        function productClicked() {
            Analytics.addProduct(vm.product.id, vm.product.name, '', vm.product.brand, '', vm.product.price, '', '', '', { sellerId: vm.product.sellerId, sellerName: vm.product.sellerName, discountId: vm.product.discountId });
            Analytics.productClick(vm.context);
            Analytics.trackEvent('Product', 'click', vm.product.name);
            common.log.info('Analysis: product clicked', vm.product.name);
        }

        /* google analytics when discount clicked */
        function productDiscountClicked() {
            Analytics.trackEvent('ProductDiscount', 'click', vm.product.name);
            common.log.info('Analysis: product discount clicked', vm.product.name);
        }

        /* load the product discounts */
        function loadProductDiscounts() {
            productDiscountClicked();
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                vm.productDiscountsOpen = true;
                if (Object.keys(vm.productDiscounts).length === 0) {
                    vm.productDiscountsLoading = true;
                    vm.getProductDiscounts(vm.product).then(function (result) {
                        vm.productDiscountsLoading = false;
                        vm.productDiscounts = productService.formatProductDiscount(result);
                    });
                }
            }
        }

        /* open the product discounts */
        function toggleProductDiscounts() {
            if (vm.product.maxDiscount !== null || vm.product.portalContractTypeCode === 'AGIOS') {
                if (vm.productDiscountsOpen) {
                    closeProductDiscounts();
                } else {
                    loadProductDiscounts();
                }
            }
        }

        /* close the product discounts */
        function closeProductDiscounts() {
            vm.productDiscountsOpen = false;
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewListComponent = exports.productOverviewListComponent = {
    template: __webpack_require__(635),
    bindings: {
        products: '<',
        errorOccurred: '<',
        context: '<',
        viewMode: '=',
        parentState: '<',
        onChangeQuantity: '&',
        filter: '<',
        isOrderByDescending: '<',
        getProductDiscounts: '&',
        searchText: '<'
    },
    controllerAs: 'vm',
    controller: function productOverviewListController() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getProductDiscountsList = getProductDiscountsList;
        vm.changeQuantity = changeQuantity;

        function init() {
            // angular.forEach(vm.products, (p) => { 
            //     Analytics.addImpression(p.id, p.name, vm.context, p.brand, '', '', '', p.price, { sellerId: p.sellerId, sellerName: p.sellerName, discountId: p.discountId });
            // });
            vm.productsWithInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity > 1;
            });
            vm.productsWithoutInternalQuantity = vm.products.filter(function (x) {
                return x.internalQuantity === 1;
            });
            // Analytics.pageView();
        }

        function changeQuantity($event) {
            vm.onChangeQuantity({ $event: $event });
        }

        /* get the product discounts */
        function getProductDiscountsList(product) {
            return vm.getProductDiscounts({ product: product });
        }
    }
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewToolbarComponent = exports.productOverviewToolbarComponent = {
    template: __webpack_require__(636),
    bindings: {
        paging: '=',
        sorting: '=',
        viewMode: '=',
        placement: '@',
        changeItemsPerPage: '&',
        goToPage: '&',
        changeSorting: '&',
        changeViewMode: '&'
    },
    controllerAs: 'vm',
    controller: ["$scope", function controller($scope) {
        'ngInject';

        var vm = this;
        vm.pagecountList = [24, 48, 72, 96, 120];
        vm.$onInit = init;

        /* view mode */
        function init() {
            $scope.$watch('vm.paging.itemsPerPage', function (newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    vm.changeItemsPerPage({ itemsPerPage: vm.paging.itemsPerPage });
                }
            });
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productOverviewComponent = exports.productOverviewComponent = {
    template: __webpack_require__(637),
    bindings: {
        model: '<',
        context: '<',
        getProducts: '&',
        onFilterChange: '&',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$stateParams", "productService", "queryStringHelper", "$state", "Enums", "$window", "cartService", "gettextCatalog", "exceptionService", "$timeout", "Analytics", "dialogService", "authService", function controller($scope, $stateParams, productService, queryStringHelper, $state, Enums, $window, cartService, gettextCatalog, exceptionService, $timeout, Analytics, dialogService, authService) {
        'ngInject';

        var vm = this;
        vm.viewMode = window.localStorage.getItem('viewMode') || 'list';
        vm.filternavFolderClass = '';
        vm.changeViewMode = changeViewMode;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.goToPage = goToPage;
        vm.changeSorting = changeSorting;
        vm.changeFilters = changeFilters;
        vm.clearFilter = clearFilter;
        vm.clearFilters = clearFilters;
        vm.filternavFolder = filternavFolder;
        vm.noItemsMessage = null;
        vm.$onInit = init;
        vm.isMobile = false;
        vm.updateQuantity = updateQuantity;
        vm.onChangeQuantity = onChangeQuantity;
        vm.productsQuantityChanged = false;
        vm.addingProducts = false;
        vm.getProductDiscounts = getProductDiscounts;
        $scope.forms = {};

        /* view mode */
        function init() {

            createNoItemsMessage();
            vm.isMobile = $window.innerWidth < 768;
            setPaging();

            //update quantity on enter
            if (authService.isBuyer) {
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true) {
                        vm.updateQuantity();
                    }
                });
            }
        }
        if (authService.isBuyer) {
            $scope.$on('$destroy', function () {
                angular.element($window).off('keydown');
            });
        }

        function setPaging() {
            vm.model.paging.itemsPerPage = parseInt(window.sessionStorage.getItem('pageSize')) || parseInt($stateParams.pageSize);
        }

        function createNoItemsMessage() {
            if (!vm.model.productsAvailableForContext) {
                switch ($state.current.name) {
                    case 'seller.discounts' || 'general.discounts':
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no discounts available');
                        break;
                    default:
                        vm.noItemsMessage = gettextCatalog.getString('There are currently no products available');
                }
            }
        }

        /* change view mode */
        function changeViewMode(viewMode) {
            // set local storage
            window.localStorage.setItem('viewMode', viewMode);
            vm.viewMode = viewMode;
        }

        /* change paging */
        function changeItemsPerPage(itemsPerPage) {
            vm.model.isLoading = true;
            vm.model.paging.itemsPerPage = itemsPerPage;

            //caching
            window.sessionStorage.setItem('pageSize', itemsPerPage);
            $state.go('.', { page: 1, pageSize: itemsPerPage });
        }

        function goToPage(page) {
            if (page !== vm.model.paging.page && page > 0) {
                if ($scope.forms.productOverviewForm.$dirty === true) {
                    dialogService.unsavedChanges().then(function () {
                        vm.isOpen = false;
                        vm.model.isLoading = true;
                        if (page === 0 || page > vm.model.paging.pageCount) {
                            return;
                        }
                        $state.go('.', { page: page });
                    }, function () {
                        return false;
                    });
                } else {
                    vm.isOpen = false;
                    vm.model.isLoading = true;
                    if (page === 0 || page > vm.model.paging.pageCount) {
                        return;
                    }
                    $state.go('.', { page: page });
                }
            }
        }

        /* sorting changed */
        function changeSorting(sortProperty) {
            //set the new sorting
            var sortAscByDefault = sortProperty.defaultSorting === 'asc';
            vm.model.sorting.sortAsc = sortProperty.value === vm.model.sorting.sortProperty ? !vm.model.sorting.sortAsc : sortAscByDefault;
            vm.model.sorting.sortProperty = sortProperty.value;

            // put the new properties in local storage
            window.localStorage.setItem($state.current.name + '-sortProperty', sortProperty.value);
            window.localStorage.setItem($state.current.name + '-sortAsc', vm.model.sorting.sortAsc);

            //go to the page with the correct sorting
            $state.go('.', {
                page: 1,
                sortProperty: sortProperty.value,
                sortAsc: vm.model.sorting.sortAsc
            });
        }

        /* filters changed */
        function changeFilters(filter, category) {
            vm.model.isLoading = true;
            Analytics.trackEvent('Filter', 'setFilterProductOverview', filter.name, 0, true);

            vm.onFilterChange();

            // select or unselect
            if (category.id === Enums.categoryFilterType.customCategory.id && $stateParams.filter.indexOf('10_0') !== -1) {
                filter.isSelected = true;
            } else {
                filter.isSelected = !filter.isSelected;
            }

            //if the category is a link navigate to that page
            if (category.isLink) {
                navigateToPage(filter, category);
                return;
            }

            // on select/unselect, select/unselect all the children when the category is a parent
            if (filter.children && filter.children.length && !filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = false;
                    child.children.forEach(function (child) {
                        child.isSelected = false;
                    });
                });
            } else if (filter.children && filter.children.length && filter.isSelected) {
                filter.children.forEach(function (child) {
                    child.isSelected = true;
                    child.children.forEach(function (child) {
                        child.isSelected = true;
                    });
                });
            }

            // create the query string
            var filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);

            // navigate to the route with craeted filter params
            $state.go('.', { page: 1, filter: filterParam });
        }

        /* clear the filter */
        function clearFilter(filter, category) {
            vm.model.isLoading = true;

            if (category.isLink) {
                return;
            }

            // when category is hierarchical, don't get isSelected from the items, but set the query string param directly
            var filterParam = '';
            if (!vm.model.filter.isCategoryHierarchical(category.id)) {
                vm.model.filter.clearFilter(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories);
            } else {
                var selectedId = vm.model.filter.getParentIdOfChildCategory(category.id, filter.id);
                filterParam = queryStringHelper.getFilterParam(vm.model.filter.filterCategories, category.id, selectedId);
            }

            $state.go('.', { page: 1, filter: filterParam });
        }

        /* reset the page when clearing the filters */
        function clearFilters() {
            vm.model.isLoading = true;

            $state.go('.', {
                page: 1,
                pageSize: 24,
                sortProperty: '',
                sortAsc: true,
                filter: ''
            });
        }

        /* On filter changed, navigate to correct page */
        function navigateToPage(filter, category) {
            if ($state.current.name === 'seller.products' || $state.current.name === 'seller.products.category') {
                $state.go('seller.products.category', {
                    categoryId: filter.id,
                    filter: $stateParams.filter === Enums.otherCategoryType.discountsOnly.id + '_1' ? Enums.otherCategoryType.discountsOnly.id + '_1' : '',
                    page: 1,
                    noReloadFilter: true
                });
            } else if (category.id === Enums.categoryFilterType.customCategory.id) {
                if ($stateParams.filter === '10_0') {
                    vm.model.isLoading = false;
                } else {
                    $state.go('general.discounts', {
                        filter: '10_0',
                        page: 1,
                        noReloadFilter: true
                    });
                }
            } else {
                if (category.id === Enums.otherCategoryType.discountType.id) {
                    if ($state.current.name === 'general.discounts.discounttype') {
                        $state.go('^.discounttype', {
                            id: filter.id,
                            filter: '',
                            page: 1,
                            noReloadFilter: true

                        });
                    } else {
                        $state.go('.discounttype', {
                            id: filter.id,
                            filter: '',
                            page: 1,
                            noReloadFilter: true
                        });
                    }
                } else {
                    $state.go('general.products.category', {
                        categoryId: filter.id,
                        filter: $stateParams.filter === Enums.otherCategoryType.discountsOnly.id + '_1' ? Enums.otherCategoryType.discountsOnly.id + '_1' : '',
                        page: 1,
                        noReloadFilter: true
                    });
                }
            }
        }

        /* toggle visibility sorting or filters */
        function filternavFolder(folderClass) {
            if (folderClass === vm.filternavFolderClass) {
                folderClass = '';
            }
            vm.filternavFolderClass = folderClass;
        }

        /* add products to the shoppingcart */
        function updateQuantity() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;

            var productFilterNoPanacee = vm.model.products.filter(function (x) {
                return x.productTypeCode !== 'panacee';
            });

            cartService.updateCartOverview(productFilterNoPanacee).then(function (shoppingCartProducts) {

                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }

                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;

                vm.model.products.map(function (product) {
                    product.getCartFields(product, shoppingCartProducts);
                });

                cartService.setAddedProducts([]);
                cartService.addProductToCartAnalytics();

                $timeout(function () {
                    vm.isOpen = false;
                    vm.productsAdded = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.hasError = true;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
                exceptionService.logException(msg);
            });
        }

        /* quantity of product changed */
        function onChangeQuantity($event) {
            if ($event) {
                cartService.addProductToAddedProductsList($event);
            }

            if (!vm.addingProducts) {
                vm.isOpen = true;
                vm.productsAdded = false;
                vm.productsQuantityChanged = true;
            }
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var relatedProductsComponent = exports.relatedProductsComponent = {
    template: __webpack_require__(638),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var selectedFiltersComponent = exports.selectedFiltersComponent = {
    template: __webpack_require__(639),
    bindings: {
        selectedFilters: '=',
        clearFilters: '&',
        clearFilter: '&'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var stockResponseComponent = exports.stockResponseComponent = {
    template: __webpack_require__(640),
    bindings: {
        product: '=',
        checkStock: '&',
        stockOverview: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productDetailComponent = exports.productDetailComponent = {
    template: __webpack_require__(641),
    bindings: {
        product: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "common", "newsService", "Analytics", "productService", "StockOverview", "cartService", "gettextCatalog", "exceptionService", "$timeout", "$window", "ProductTypes", "authService", "$stateParams", "certificatesService", function controller($scope, $state, common, newsService, Analytics, productService, StockOverview, cartService, gettextCatalog, exceptionService, $timeout, $window, ProductTypes, authService, $stateParams, certificatesService) {
        'ngInject';

        var vm = this;
        vm.newsitems = null;
        vm.topNewsitems = null;
        vm.shortNewsitems = null;
        vm.medipimDataLoading = false;
        vm.isEmptyObject = isEmptyObject;
        vm.$onInit = init;
        vm.updateTotals = updateTotals;
        vm.checkStock = checkStock;
        vm.addToCart = addToCart;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.loadMedipimData = loadMedipimData;
        vm.loadIcoreData = loadIcoreData;
        $scope.forms = {};

        function init() {

            common.setTitle(vm.product.displayName);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/products/' + vm.product.id, vm.product.displayName);
            if (vm.product.type === 'single') {
                loadMedipimData();
            }
            loadIcoreData();
            //update quantity on enter
            if (authService.isBuyer) {
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true && vm.productsQuantityChanged) {
                        vm.addToCart();
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element($window).off('keydown');
                });
            }

            vm.topNewsitems = vm.product.topNewsitems;

            vm.mainImage = vm.product.image;

            Analytics.addProduct(vm.product.id, vm.product.displayName, vm.product.type, vm.product.brand, '', vm.product.price, vm.product.quantity, '', '', {
                sellerId: vm.product.sellerId,
                sellerName: vm.product.sellerName,
                discountId: vm.product.discountId
            });

            Analytics.trackDetail();
        }

        function isEmptyObject(o) {
            if (o) {
                return Object.keys(o).every(function (x) {
                    return o[x] === '' || o[x] === null || o[x] === false || o[x] === 0 || o[x] === undefined;
                });
            } else {
                return true;
            }
        }

        function loadMedipimData() {
            vm.medipimDataLoading = true;
            productService.getProductMedipimdata($stateParams.productId).then(function (medipimData) {
                vm.medipimDataLoading = false;
                vm.product.mediPimData = medipimData;
            });
        }

        function loadIcoreData() {
            var search = {
                identification: vm.product.nationalNumber,
                isExpired: false
            };
            certificatesService.searchCertificates(search).then(function (response) {
                vm.product.certificates = response.results;
            });
        }

        function updateTotals() {
            vm.isOpen = true;
            vm.productsAdded = false;
            vm.productsQuantityChanged = true;
            if (vm.product.type === ProductTypes.panacee.clientValue) {
                vm.product.updateTotals();
            }
        }

        function checkStock() {
            vm.stockOverview = StockOverview.create();
            vm.stockOverview.isLoading = true;
            var quantity = vm.product.quantity === 0 ? 1 : vm.product.quantity;
            productService.getProductStock(vm.stockOverview, vm.product.nationalNumber, quantity).then(function (model) {
                vm.stockOverview.hasloaded = true;
                vm.stockOverview.isLoading = false;
                vm.stockOverview = model;
            });
        }

        function addToCart() {

            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;

            cartService.addProduct(vm.product).then(function (shoppingCartProducts) {

                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }

                //update the discount values after add
                vm.product = vm.product.getCartFields(vm.product, shoppingCartProducts);
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                vm.addingProducts = false;

                $timeout(function () {
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {

                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.hasError = true;

                var msg = gettextCatalog.getString('The product could not be added to your shopping cart');
                exceptionService.logException(msg);

                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _detail = __webpack_require__(984);

var _news = __webpack_require__(986);

var _includedProductsInPack = __webpack_require__(961);

var _includedProductsInPanacee = __webpack_require__(962);

var _productDetailContent = __webpack_require__(969);

var _productImg = __webpack_require__(972);

var _productInfo = __webpack_require__(974);

var _productInfoBox = __webpack_require__(973);

var _relatedProducts = __webpack_require__(981);

var _productDiscounts = __webpack_require__(970);

var _productFilters = __webpack_require__(971);

var _productOverview = __webpack_require__(980);

var _productOverviewToolbar = __webpack_require__(979);

var _productOverviewGrid = __webpack_require__(976);

var _productOverviewGridItem = __webpack_require__(975);

var _panaceeOverviewGrid = __webpack_require__(965);

var _panaceeOverviewGridItem = __webpack_require__(964);

var _productOverviewList = __webpack_require__(978);

var _productOverviewListItem = __webpack_require__(977);

var _panaceeOverviewList = __webpack_require__(967);

var _panaceeOverviewListItem = __webpack_require__(966);

var _selectedFilters = __webpack_require__(982);

var _stockResponse = __webpack_require__(983);

var _addProductsToolbar = __webpack_require__(960);

var _medipimInfo = __webpack_require__(963);

var _productCertificatesOverviewSearch = __webpack_require__(968);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.product', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('master.product-news', {
        url: '/products/{id:int}/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'productNews'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", function product($stateParams, productService) {
                return productService.get($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        }
    }).state('seller.product-news', {
        url: '/products/{id:int}/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'productNews'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", function product($stateParams, productService) {
                return productService.get($stateParams.id);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: { value: '1', squash: true },
            categoryId: { value: '0', squash: true },
            searchValue: { value: '', squash: true }
        }
    }).state('general.products.product', {
        url: '/{productId:int}',
        views: {
            'main@root': {
                component: 'product'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", "$state", function product($stateParams, productService, $state) {
                return productService.get($stateParams.productId).then(function (result) {
                    if (result.type === 'RENTAL') {
                        $state.go('seller.rentProductDetail', { sellerId: result.sellerId, productId: result.id }, { reload: true });
                    } else {
                        return result;
                    }
                });
            }]
        },
        reloadOnSearch: false,
        params: {
            productId: {
                value: null,
                squash: true
            },
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.displayName}}'
        },
        data: {
            febelcoCustomer: false
        },
        title: function title($resolve) {
            return $resolve.product.displayName;
        }
    });
}]).component('product', _detail.productDetailComponent).component('productNews', _news.productNewsComponent).component('includedProductsInPack', _includedProductsInPack.includedProductsInPackComponent).component('includedProductsInPanacee', _includedProductsInPanacee.includedProductsInPanaceeComponent).component('productDetailContent', _productDetailContent.productDetailContentComponent).component('productImg', _productImg.productImageComponent).component('productInfo', _productInfo.productInfoComponent).component('productInfoBox', _productInfoBox.productInfoBoxComponent).component('relatedProducts', _relatedProducts.relatedProductsComponent).component('productFilters', _productFilters.productFiltersComponent).component('productDiscounts', _productDiscounts.productDiscountsComponent).component('productOverview', _productOverview.productOverviewComponent).component('productOverviewToolbar', _productOverviewToolbar.productOverviewToolbarComponent).component('productOverviewGrid', _productOverviewGrid.productOverviewGridComponent).component('productOverviewGridItem', _productOverviewGridItem.productOverviewGridItemComponent).component('panaceeOverviewGrid', _panaceeOverviewGrid.panaceeOverviewGridComponent).component('panaceeOverviewGridItem', _panaceeOverviewGridItem.panaceeOverviewGridItemComponent).component('productOverviewList', _productOverviewList.productOverviewListComponent).component('productOverviewListItem', _productOverviewListItem.productOverviewListItemComponent).component('panaceeOverviewList', _panaceeOverviewList.panaceeOverviewListComponent).component('panaceeOverviewListItem', _panaceeOverviewListItem.panaceeOverviewListItemComponent).component('selectedFilters', _selectedFilters.selectedFiltersComponent).component('stockResponse', _stockResponse.stockResponseComponent).component('addProductsToolbar', _addProductsToolbar.addProductsToolbar).component('medipimInfo', _medipimInfo.medipimInfoComponent).component('productCertificatesOverviewSearch', _productCertificatesOverviewSearch.productCertificatesOverviewSearchComponent);

exports.default = _module.name;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var productNewsComponent = exports.productNewsComponent = {
    template: __webpack_require__(642),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsOverviewService", "Enums", "gettextCatalog", function productNewsController($scope, common, newsOverviewService, Enums, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.setProductsActive();
            common.setTitle(gettextCatalog.getString('News for ') + vm.product.name);
            newsOverviewService.handleGetNews($scope, Enums.newsContext.product.id, { productId: vm.product.id }).then(function (i) {
                return vm.newsOverviewModel = i;
            });
        }
    }]
};

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductImageComponent = exports.rentProductImageComponent = {
    //todo gewoon product doorgeven?
    template: __webpack_require__(643),
    bindings: {
        productId: '<',
        sellerId: '<',
        image: '<',
        imageSize: '@',
        discount: '<',
        message: '<',
        productClicked: '&',
        navigateToProductDetailPage: '&',
        parentState: '<',
        addLink: '<',
        productType: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductOverviewGridItemComponent = exports.rentProductOverviewGridItemComponent = {
    template: __webpack_require__(644),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductOverviewGridComponent = exports.rentProductOverviewGridComponent = {
    template: __webpack_require__(645),
    bindings: {
        products: '<',
        mode: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalCheckoutDeliveryInfoComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rentalCheckoutDeliveryInfoComponent = exports.rentalCheckoutDeliveryInfoComponent = {
    template: __webpack_require__(646),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onContactInfoChange: '&',
        onDeliveryInfoChange: '&',
        onFormChange: '&',
        onCityChange: '&',
        formReference: '<'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "$timeout", function controller(rentalProductsService, $timeout) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.changeTelephoneNumber = changeTelephoneNumber;
        vm.changeContactPerson = changeContactPerson;
        vm.changeCity = changeCity;
        vm.changeBox = changeBox;
        vm.changeHouseNumber = changeHouseNumber;
        vm.changeStreetName = changeStreetName;
        vm.checkForBackSpace = checkForBackSpace;
        vm.changeRemark = changeRemark;
        vm.changeDate = changeDate;
        vm.searchStreet = searchStreet;
        vm.searchCities = searchCities;
        vm.formchange = formchange;
        vm.citySearchString = vm.deliveryInfo.cityName ? vm.deliveryInfo.cityName : '';
        vm.streetSearchString = vm.deliveryInfo.streetName ? vm.deliveryInfo.streetName : '';

        function init() {
            var minDate;
            if (vm.rentalProduct.deliveryByExternalPartner) {
                if ((0, _moment2.default)().isoWeekday() === 5 || (0, _moment2.default)().isoWeekday() === 6) {
                    minDate = (0, _moment2.default)().add(3, 'days');
                } else {
                    minDate = (0, _moment2.default)().add(2, 'days');
                }
            } else {
                minDate = (0, _moment2.default)().add(1, 'days');
            }
            vm.fromDate = minDate.toISOString();
            vm.maxDate = (0, _moment2.default)().add(1, 'months').toISOString();
            vm.deliveryInfo.deliveryDate ? null : vm.deliveryInfo.deliveryDate = minDate; //if there is no deliveryDate, set a default
        }

        $timeout(function () {
            vm.formchange(); //hack to trigger validation when going to the previous page
        });

        function searchCities(query) {
            vm.deliveryInfo.postalLocalityId = 0;
            vm.deliveryInfo.cityName = '';
            vm.deliveryInfo.postalCode = '';
            vm.streetSearchString = '';
            vm.deliveryInfo.streetName = '';
            vm.deliveryInfo.streetId = 0;
            vm.formchange();
            return rentalProductsService.searchCities(query);
        }

        function searchStreet(query) {
            vm.deliveryInfo.streetName = '';
            vm.deliveryInfo.streetId = 0;
            vm.formchange();
            return rentalProductsService.searchStreet(query, vm.deliveryInfo.postalLocalityId);
        }

        function formchange() {
            vm.onFormChange();
        }

        function changeDate($event) {
            vm.deliveryInfo.deliveryDate = $event;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function changeCity(item) {
            vm.deliveryInfo.postalLocalityId = item.id;
            vm.deliveryInfo.cityName = item.name;
            vm.deliveryInfo.postalCode = item.postalCode;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function checkForBackSpace(event) {
            if (event.keyCode === 8) {
                vm.deliveryInfo.streetId = 0;
            }
            vm.formchange();
        }

        function changeStreetName(item) {
            vm.deliveryInfo.streetName = item.name;
            vm.deliveryInfo.streetId = item.id;
            this.onDeliveryInfoChange({ $event: vm.deliveryInfo });
            vm.formchange();
        }

        function changeBox(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeHouseNumber(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeRemark(deliveryInfo) {
            this.onDeliveryInfoChange({ $event: deliveryInfo });
            vm.formchange();
        }

        function changeContactPerson(contactInfo) {
            this.onContactInfoChange({ $event: contactInfo });
            vm.formchange();
        }

        function changeTelephoneNumber(contactInfo) {
            this.onContactInfoChange({ $event: contactInfo });
            vm.formchange();
        }
    }]
};

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutProductInfoComponent = exports.rentalCheckoutProductInfoComponent = {
    template: __webpack_require__(647),
    bindings: {
        rentalProduct: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalWizardButton = rentalWizardButton;
/*@ngInject*/

function rentalWizardButton() {
    return {
        restrict: 'A',
        replace: false,
        require: '^rentalWizard',
        link: function link($scope, $element, $attrs, wizard) {
            var action;

            if ($attrs.wzNext !== undefined) {
                action = 'next';
            } else if ($attrs.wzPrevious !== undefined) {
                action = 'previous';
            } else if ($attrs.wzFinish !== undefined) {
                action = 'finish';
            } else if ($attrs.wzCancel !== undefined) {
                action = 'cancel';
            }

            $element.on('click', function (e) {
                if ($attrs.wzValid !== 'false') {
                    e.preventDefault();
                    $scope.$apply(function () {
                        wizard[action]();
                    });
                }
                return;
            });
        }
    };
}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalWizardMenuComponent = exports.rentalWizardMenuComponent = {
    template: __webpack_require__(648),
    bindings: {
        steps: '<',
        activeStep: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalWizardStepComponent = exports.rentalWizardStepComponent = {
    template: __webpack_require__(649),
    controllerAs: 'vmWizardStep',
    bindings: {
        showStep: '<',
        menuLabel: '<',
        isValid: '<'
    },
    require: {
        wizard: '^rentalWizard'
    },
    transclude: true,
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.isActive = false;
        vm.setIsActive = setIsActive;

        function init() {
            if (vm.showStep !== false) {
                vm.wizard.registerStep(vm);
                vm.wizard.registerMenuStep(vm.menuLabel);
            }
        }

        function setIsActive() {
            vm.isActive ? vm.isActive = false : vm.isActive = true;
        }
    }
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalWizardComponent = exports.rentalWizardComponent = {
    transclude: true,
    template: __webpack_require__(650),
    controllerAs: 'vmWizard',
    bindings: {
        onFinish: '&',
        onCancel: '&'
    },
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.next = next;
        vm.previous = previous;
        vm.registerStep = registerStep;
        vm.finish = finish;
        vm.cancel = cancel;
        vm.registerMenuStep = registerMenuStep;
        vm.steps = [];
        vm.activeStepIndex = 0;
        vm.$onInit = init;
        vm.menuSteps = [];

        function init() {
            // vm.steps[0].isActive = true;
        }

        function registerStep(step) {
            if (vm.steps.length === 0) {
                vm.steps.push(step);
                vm.steps[0].setIsActive();
            } else {
                vm.steps.push(step);
            }
        }

        function registerMenuStep(step) {
            vm.menuSteps.push(step);
        }

        function next(callback) {
            if (vm.steps.length) {
                vm.activeStepIndex += 1;
                vm.steps[vm.activeStepIndex - 1].setIsActive(); //hide previous step     
                vm.steps[vm.activeStepIndex].setIsActive(); //show next step
            }

            if (angular.isFunction(callback)) {
                callback();
            }
        }

        function previous() {
            if (vm.steps.length) {
                vm.activeStepIndex -= 1;
                vm.steps[vm.activeStepIndex + 1].setIsActive(); // hide previous step
                vm.steps[vm.activeStepIndex].setIsActive(); // show next step
            }
        }

        function finish() {
            vm.onFinish();
        }

        function cancel() {
            vm.onCancel();
        }
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalProductGridItemComponent = exports.rentalProductGridItemComponent = {
    template: __webpack_require__(651),
    bindings: {
        rentalProduct: '<'
    },
    controllerAs: 'vm',
    controller: ["$stateParams", function controller($stateParams) {
        'ngInject';

        var vm = this;
        vm.onOrderedChanged = onOrderedChanged;
        vm.quantityChanged = quantityChanged;
        vm.sellerId = 0;
        vm.$onInit = init;

        function init() {
            vm.sellerId = $stateParams.sellerId;
        }

        function onOrderedChanged() {
            vm.rentalProduct.order ? vm.rentalProduct.quantity = 1 : vm.rentalProduct.quantity = 0;
        }

        function quantityChanged() {
            vm.rentalProduct.quantity > 0 ? vm.rentalProduct.order = true : vm.rentalProduct.order = false;
        }
    }]
};

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalProductGridComponent = exports.rentalProductGridComponent = {
    template: __webpack_require__(652),
    bindings: {
        rentalProducts: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalProductTableComponent = exports.rentalProductTableComponent = {
    template: __webpack_require__(653),
    bindings: {
        rentalProducts: '<'
    },
    controllerAs: 'vm',
    controller: function controller() {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            vm.filteredRentalProducts = vm.rentalProducts.filter(function (p) {
                return p.productType === 'RENTAL';
            });
            vm.filteredPortalProducts = vm.rentalProducts.filter(function (p) {
                return p.productType === 'PORTALPRODUCT';
            });
        }
    }
};

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _rentalCheckout = __webpack_require__(1003);

var _rentalCheckoutStepOne = __webpack_require__(1000);

var _rentalCheckoutStepTwo = __webpack_require__(1002);

var _rentalCheckoutStepThree = __webpack_require__(1001);

var _rentalCheckoutProductInfo = __webpack_require__(991);

var _rentalCheckoutDeliveryInfo = __webpack_require__(990);

var _rentalProductGrid = __webpack_require__(997);

var _rentalProductGridItem = __webpack_require__(996);

var _rentalProductTable = __webpack_require__(998);

var _rentalWizard = __webpack_require__(995);

var _rentalWizardMenu = __webpack_require__(993);

var _rentalWizardStep = __webpack_require__(994);

var _rentalWizardButton = __webpack_require__(992);

var _rentProductOverviewGrid = __webpack_require__(989);

var _rentProductOverviewGridItem = __webpack_require__(988);

var _rentProductImg = __webpack_require__(987);

__webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.rental', ['ngMessages']);

_module.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state('rentalCheckout', {
        parent: 'seller.rentProductDetail',
        url: '/rentalCheckout',
        views: {
            'main@root': {
                component: 'rentalCheckout'
            },
            'header@root': '',
            'aside@root': '',
            'menu@root': ''
        },
        resolve: {
            rentalProduct: ["rentalProductsService", "$stateParams", function rentalProduct(rentalProductsService, $stateParams) {
                return rentalProductsService.getRentalProductById($stateParams.productId).then(function (rentalProduct) {
                    return rentalProduct;
                });
            }],
            wizardMenuSteps: ["Enums", "gettextCatalog", function wizardMenuSteps(Enums, gettextCatalog) {
                var menu = JSON.parse(JSON.stringify(Enums.rentalCheckoutMenuSteps));
                return menu.map(function (obj) {
                    obj.value = gettextCatalog.getString(obj.value);
                    return obj;
                });
            }],
            deliveryInfo: ["DeliveryInfoRentalProduct", function deliveryInfo(DeliveryInfoRentalProduct) {
                return DeliveryInfoRentalProduct.create({});
            }],
            contactInfo: ["ContactInfoRentalProduct", function contactInfo(ContactInfoRentalProduct) {
                return ContactInfoRentalProduct.create({});
            }],
            rentedProductsOrder: ["RentalProductsOrder", function rentedProductsOrder(RentalProductsOrder) {
                return RentalProductsOrder.create({});
            }]
        },
        params: {
            productId: {
                value: null,
                squash: true
            },
            sellerId: {
                value: null,
                squash: true
            }
        },
        data: {
            febelcoCustomer: true
        },
        ncyBreadcrumb: {
            label: '{{"Uw huuraanvraag" | translate }}'
        }
    });
}]);

_module.component('rentalCheckout', _rentalCheckout.rentalCheckoutComponent).component('rentalCheckoutStepOne', _rentalCheckoutStepOne.rentalCheckoutStepOneComponent).component('rentalCheckoutStepTwo', _rentalCheckoutStepTwo.rentalCheckoutStepTwoComponent).component('rentalCheckoutStepThree', _rentalCheckoutStepThree.rentalCheckoutStepThreeComponent).component('rentalCheckoutProductInfo', _rentalCheckoutProductInfo.rentalCheckoutProductInfoComponent).component('rentalCheckoutDeliveryInfo', _rentalCheckoutDeliveryInfo.rentalCheckoutDeliveryInfoComponent).component('rentalProductGrid', _rentalProductGrid.rentalProductGridComponent).component('rentalProductGridItem', _rentalProductGridItem.rentalProductGridItemComponent).component('rentalProductTable', _rentalProductTable.rentalProductTableComponent).component('rentalWizard', _rentalWizard.rentalWizardComponent).component('rentalWizardStep', _rentalWizardStep.rentalWizardStepComponent).component('rentalWizardMenu', _rentalWizardMenu.rentalWizardMenuComponent).component('rentProductOverviewGrid', _rentProductOverviewGrid.rentProductOverviewGridComponent).component('rentProductOverviewGridItem', _rentProductOverviewGridItem.rentProductOverviewGridItemComponent).component('rentProductImg', _rentProductImg.rentProductImageComponent).directive('wzNext', _rentalWizardButton.rentalWizardButton).directive('wzPrevious', _rentalWizardButton.rentalWizardButton).directive('wzFinish', _rentalWizardButton.rentalWizardButton).directive('wzCancel', _rentalWizardButton.rentalWizardButton);

exports.default = _module.name;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutStepOneComponent = exports.rentalCheckoutStepOneComponent = {
    template: __webpack_require__(654),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onDeliveryInfoChange: '&',
        onContactInfoChange: '&',
        onProductsRentedSucces: '&',
        onFormValidChange: '&'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", function controller(rentalProductsService) {
        'ngInject';

        var vm = this;
        vm.deliveryInfoChange = deliveryInfoChange;
        vm.contactInfoChange = contactInfoChange;
        vm.confirmOrder = confirmOrder;
        vm.onFormChange = onFormChange;
        vm.isFormValid = false;

        function deliveryInfoChange($event) {
            vm.onDeliveryInfoChange({
                $event: $event
            });
        }

        function contactInfoChange($event) {
            vm.onContactInfoChange({
                $event: $event
            });
        }

        function confirmOrder() {
            if (vm.checkoutForm.$valid && vm.isFormValid) {
                rentalProductsService.orderRentedProducts(vm.rentalProduct, null, null, vm.contactInfo, vm.deliveryInfo).then(function (result) {
                    vm.onProductsRentedSucces({
                        $event: result
                    });
                });
            }
        }

        function onFormChange() {
            vm.isFormValid = checkFormValid();
        }

        function checkFormValid() {
            return vm.checkoutForm.dpicker.$valid && vm.checkoutForm.$valid && vm.deliveryInfo.postalLocalityId !== 0 && vm.deliveryInfo.streetId !== 0;
        }
    }]
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutStepThreeComponent = exports.rentalCheckoutStepThreeComponent = {
    template: __webpack_require__(655),
    bindings: {
        rentedProductsOrder: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutStepTwoComponent = exports.rentalCheckoutStepTwoComponent = {
    template: __webpack_require__(656),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        onProductsRentedSucces: '&'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "Enums", function controller(rentalProductsService, Enums) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.confirmOrder = confirmOrder;
        vm.recommendedRentalProducts;
        vm.recommendedPortalProducts;
        vm.suggestedRentalProducts;
        vm.suggestedPortalProducts;

        function init() {
            filterRelatedProducts();
        }

        function filterRelatedProducts() {
            vm.recommendedRentalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'RENTAL';
            });
            vm.recommendedPortalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'PORTALPRODUCT';
            });
            vm.suggestedRentalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'RENTAL';
            });
            vm.suggestedPortalProducts = vm.rentalProduct.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'PORTALPRODUCT';
            });
        }

        function confirmOrder() {
            rentalProductsService.orderRentedProducts(vm.rentalProduct, [].concat(vm.recommendedRentalProducts, vm.recommendedPortalProducts), [].concat(vm.suggestedRentalProducts, vm.suggestedPortalProducts), vm.contactInfo, vm.deliveryInfo).then(function (result) {
                vm.onProductsRentedSucces({
                    $event: result
                });
            });
        }
    }]
};

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentalCheckoutComponent = exports.rentalCheckoutComponent = {
    template: __webpack_require__(657),
    bindings: {
        rentalProduct: '<',
        deliveryInfo: '<',
        contactInfo: '<',
        sellerId: '<',
        wizardMenuSteps: '<',
        rentedProductsOrder: '<'
    },
    controllerAs: 'vm',
    controller: ["$state", "common", "gettextCatalog", "Analytics", function controller($state, common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.wizardActiveStepIndex = 0;
        vm.rentedProducts = [];
        vm.wizardFinished = wizardFinished;
        vm.wizardCanceled = wizardCanceled;
        vm.hasRelatedProducts = hasRelatedProducts;
        vm.deliveryInfoChanged = deliveryInfoChanged;
        vm.contactInfoChanged = contactInfoChanged;
        vm.onProductsRentedSucces = onProductsRentedSucces;
        vm.stepOneFormValidChange = stepOneFormValidChange;
        vm.stepOneFormValid = false;

        function init() {
            common.setTitle(gettextCatalog.getString('Uw huuraanvraag'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/rentalProduct/' + vm.rentalProduct, gettextCatalog.getString('Uw huuraanvraag'));
        }

        function wizardFinished() {
            $state.go('seller.home', {
                sellerId: $state.params.sellerId
            });
        }

        function wizardCanceled() {
            $state.go('seller.rentProductOverview', {
                sellerId: $state.params.sellerId
            });
        }

        function hasRelatedProducts() {
            return vm.rentalProduct.relatedRentalProducts.length > 0;
        }

        function deliveryInfoChanged($event) {
            vm.deliveryInfo = $event;
        }

        function contactInfoChanged($event) {
            vm.contactInfo = $event;
        }

        function onProductsRentedSucces($event) {
            vm.rentedProductsOrder = $event;
        }

        function stepOneFormValidChange($event) {
            vm.stepOneFormValid = $event.isFormValid;
        }
    }]
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _reservationCampaign = __webpack_require__(1005);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.reservationCampaign', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.reservations', {
        url: '/reservations/{code:string}',
        views: {
            'main@root': {
                component: 'reservationCampaign'
            }
        },
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.campaign.campaign.name}}'
        },
        resolve: {
            campaign: ["reservationCampaignService", "$stateParams", function campaign(reservationCampaignService, $stateParams) {
                return reservationCampaignService.getReservationCampaign($stateParams.code);
            }]
        }
    });
}]).component('reservationCampaign', _reservationCampaign.reservationCampaignComponent);

exports.default = _module.name;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var reservationCampaignComponent = exports.reservationCampaignComponent = {
    template: __webpack_require__(658),
    bindings: {
        campaign: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "reservationCampaignService", "Analytics", "toastr", function reservationCampaignController(common, gettextCatalog, reservationCampaignService, Analytics, toastr) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.saveAmounts = saveAmounts;

        function init() {
            common.setTitle(vm.campaign.campaign.code);
            vm.displayUnits = vm.campaign.reservations.every(function (reservation) {
                return reservation.unit;
            }) ? false : true;
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/reservations', vm.campaign.campaign.code);
        }

        function saveAmounts() {
            if (validateLines()) {
                reservationCampaignService.setReservationCampaign(vm.campaign.campaign.code, vm.campaign.reservations).then(function (response) {
                    vm.campaign = response;
                    toastr.success(gettextCatalog.getString('_reservationCampaigns.reservationConfirmed'), '', {
                        progressBar: true,
                        timeOut: 5000,
                        extendedTimeOut: 1000,
                        closeButton: true
                    });
                });
            }
        }

        function validateLines() {
            var valid = true;
            vm.campaign.reservations.forEach(function (product) {
                if (product.limit && product.limit < product.amount) {
                    product.limitReached = gettextCatalog.getString('_reservationCampaigns.limitReached', { limit: product.limit });
                    valid = false;
                }
            });
            return valid;
        }
    }]
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _search = __webpack_require__(1007);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.search', []);

_module.config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    $stateProvider.state('search', {
        parent: 'general',
        url: '/search/:searchValue?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'search'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: '24',
                squash: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true
            },
            filter: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Search" | translate}}'
        }
    });
}]);

_module.component('search', _search.searchComponent);

exports.default = _module.name;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var searchComponent = exports.searchComponent = {
    template: __webpack_require__(659),
    controllerAs: 'vm',
    bindings: {
        parentState: '<'
    },
    controller: ["$stateParams", "$scope", "productOverviewService", "Enums", "common", "gettextCatalog", "Analytics", function controller($stateParams, $scope, productOverviewService, Enums, common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.searchValue = $stateParams.searchValue;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Search') + ' ' + vm.searchValue);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/search/' + vm.searchValue, 'Search ' + vm.searchValue);

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.search.id);
            productOverviewService.getProductsBySearchValue(true, vm.productOverviewModel, vm.searchValue).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsBySearchValue(false, vm.productOverviewModel, vm.searchValue).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }
    }]
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerAboutComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerAboutComponent = exports.sellerAboutComponent = {
    template: __webpack_require__(660),
    bindings: {
        seller: '<',
        sellerAbout: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "$state", "common", "$scope", "Enums", "gettextCatalog", "Analytics", function controller($rootScope, $state, common, $scope, Enums, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;
        vm.$onChanges = bindingChanges;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(gettextCatalog.getString('More info about ') + vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/about', vm.seller.name + ' ' + gettextCatalog.getString('about'));
        }

        vm.heroSliderSettings = {
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            draggable: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false
                }
            }]
        };

        vm.gallerySliderSettings = {
            autoplay: false,
            dots: true,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            variableWidth: false,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }]
        };

        function bindingChanges(changes) {
            if (changes.sellerAbout) {
                if (changes.sellerAbout.currentValue) {
                    vm.sellerAbout = Object.assign(changes.sellerAbout.currentValue, {
                        content: (0, _marked2.default)(changes.sellerAbout.currentValue.content || ''),
                        logosContent: (0, _marked2.default)(changes.sellerAbout.currentValue.logosContent || '')
                    });
                } else {
                    vm.sellerAbout = changes.sellerAbout.currentValue;
                }
            }
        }
    }]
};

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contactBlockComponent = exports.contactBlockComponent = {
    template: __webpack_require__(661),
    bindings: {
        contactInformation: '<',
        sellerName: '<',
        sellerAddress: '<',
        logo: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.heroSliderComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: true,
    sanitize: true
});

var heroSliderComponent = exports.heroSliderComponent = {
    template: __webpack_require__(662),
    bindings: {
        banners: '<',
        settings: '<'
    },
    controllerAs: 'vm',
    controller: ["Enums", function heroSliderController(Enums) {
        'ngInject';

        var vm = this;
        vm.$onChanges = bindingChanges;

        vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;

        function bindingChanges(changes) {
            if (changes.banners) {
                changes.banners.currentValue.forEach(function (banner, index) {
                    vm.banners[index].content = banner.content ? (0, _marked2.default)(changes.banners.currentValue[index].content || '') : null;
                    vm.banners[index].title = banner.title ? (0, _marked2.default)(changes.banners.currentValue[index].title || '') : null;
                });
            }
        }
    }]
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerMenuComponent = exports.sellerMenuComponent = {
    template: __webpack_require__(663),
    bindings: {
        seller: '<',
        sellerModules: '<',
        numberOfContracts: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$element", function controller(common, $element) {
        'ngInject';

        var vm = this;
        vm.sellerNavIsOpen = false;
        vm.toggleSellerNav = toggleSellerNav;
        vm.hideSellerNav = hideSellerNav;
        vm.moduleEnabled = moduleEnabled;
        vm.isNotFebelcoPartner = true;
        vm.$onInit = init;
        function init() {
            $element.on('click', 'a:not(.site-seller-header-toggle)', function () {
                vm.hideSellerNav();
            });
            vm.isNotFebelcoPartner = vm.seller.code !== 'FPA';
        }

        function toggleSellerNav() {
            vm.sellerNavIsOpen = !vm.sellerNavIsOpen;
        }

        function hideSellerNav() {
            vm.sellerNavIsOpen = false;
        }

        function moduleEnabled(module) {
            // Dirty, dirty hack for Febelco Partner!
            if (module === 'PRODUCT' && vm.seller && vm.seller.img && vm.seller.img.indexOf('FPA') === 0) {
                return false;
            }
            return (vm.sellerModules || []).indexOf(module) >= 0;
        }
    }]
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var partnershipGridComponent = exports.partnershipGridComponent = {
    template: __webpack_require__(664),
    bindings: {
        partnerships: '<',
        errorOccurred: '<',
        viewMode: '@'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var partnershipTileComponent = exports.partnershipTileComponent = {
    template: __webpack_require__(665),
    bindings: {
        partnership: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerTotalPriceDiscountsComponent = exports.sellerTotalPriceDiscountsComponent = {
    template: __webpack_require__(666),
    bindings: {
        discounts: '<'
    },
    controllerAs: 'vm'
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerContactComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});
var sellerContactComponent = exports.sellerContactComponent = {
    template: __webpack_require__(667),
    bindings: {
        seller: '<',
        sellerContact: '<'
    },
    controllerAs: 'vm',
    controller: ["$state", "common", "gettextCatalog", "Analytics", function controller($state, common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onChanges = bindingChanges;
        vm.$onInit = init;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(gettextCatalog.getString('Contact ') + vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/contact', vm.seller.name + ' ' + gettextCatalog.getString('contact'));
        }

        function bindingChanges(changes) {
            if (changes.sellerContact) {
                if (changes.sellerContact.currentValue) {
                    vm.sellerContact = Object.assign(changes.sellerContact.currentValue, {
                        moreInfoContent: (0, _marked2.default)(changes.sellerContact.currentValue.moreInfoContent || '')
                    });
                } else {
                    vm.sellerContact = changes.sellerContact.currentValue;
                }
            }
        }
    }]
};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerContractOverviewComponent = undefined;

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sellerContractOverviewComponent = exports.sellerContractOverviewComponent = {
    template: __webpack_require__(668),
    bindings: {
        contracts: '<',
        seller: '<'

    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "Analytics", function contractsOverviewController(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.sortBy = sortBy;
        vm.reverse = false;
        vm.propertyName = 'name';
        vm.checkYearsApart = checkYearsApart;

        function init() {
            common.navigationMenu.clearActiveMenu();

            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('contracts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/contract', vm.seller.name + ' ' + gettextCatalog.getString('contract'));
        }

        function sortBy(propertyName) {
            vm.reverse = vm.propertyName === propertyName ? !vm.reverse : false;
            vm.propertyName = propertyName;
        }

        function checkYearsApart(contract) {
            return (0, _moment2.default)(contract.endDate).format('YYYY') - (0, _moment2.default)(contract.startDate).format('YYYY') > 10 ? true : false;
        }
    }]
};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerContractComponent = exports.sellerContractComponent = {
    template: __webpack_require__(669),
    bindings: {
        contract: '<',
        seller: '<'
    },
    controllerAs: 'vm',
    controller: ["$state", "common", "Analytics", function controller($state, common, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.contract.title);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/contract/' + vm.contract.id, vm.contract.title);
        }
    }]
};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerDetailComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerDetailComponent = exports.sellerDetailComponent = {
    template: __webpack_require__(670),
    bindings: {
        seller: '<',
        parentState: '<',
        sellerModules: '<',
        rentalProductsCategories: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "newsService", "sellerService", "productOverviewService", "partnershipsService", "Enums", "common", "Analytics", "$state", "lodash", "cartService", "$timeout", "gettextCatalog", "exceptionService", "productService", "$window", "authService", function controller($scope, newsService, sellerService, productOverviewService, partnershipsService, Enums, common, Analytics, $state, lodash, cartService, $timeout, gettextCatalog, exceptionService, productService, $window, authService) {
        'ngInject';

        var vm = this;
        vm.discountsModel = null;
        vm.productsModel = null;
        vm.errorOccurredInDiscountOverview = false;
        vm.newsitems = null;
        vm.initSlider = null;
        vm.addToCart = addToCart;
        vm.sellerBanners = null;
        vm.sellerContent = null;
        vm.errorOccurredInProductOverview = false;
        vm.scrollTo = scrollTo;
        vm.$onInit = init;
        vm.myContacts = [];
        vm.otherContacts = [];
        vm.partnershipsModel = null;
        vm.partnerships = [];
        vm.$onChanges = bindingChanges;
        vm.productQuantityChanged = productQuantityChanged;
        vm.getProductDiscounts = getProductDiscounts;
        vm.moduleEnabled = moduleEnabled;

        function init() {

            //no seller found redirect to error page
            if (!vm.seller) {
                $state.go('error');
            }

            //update quantity on enter
            if (authService.isBuyer) {
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true) {
                        vm.addToCart();
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element($window).off('keydown');
                });
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id, vm.seller.name);

            vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;

            /* load seller Details */
            sellerService.getBySellerId(vm.seller.id).then(function (sellerContent) {
                vm.sellerContent = sellerContent;
                if (vm.sellerContent.sellerEmployees) {
                    vm.myContacts = lodash.filter(vm.sellerContent.sellerEmployees, function (i) {
                        return i.isMyRepresentative === true;
                    });
                    vm.otherContacts = lodash.filter(vm.sellerContent.sellerEmployees, function (i) {
                        return i.isMyRepresentative === false;
                    });
                }
            });

            /* load seller total price disounts*/
            sellerService.getSellerTotalPriceDiscounts(vm.seller.id).then(function (totalPriceDiscounts) {
                vm.totalPriceDiscounts = totalPriceDiscounts;
            });

            /* load news */
            newsService.getNewsForSellerPage(vm.seller.id).then(function (m) {
                vm.newsitems = m;
            });

            /* load banners */
            sellerService.getSellerBanners(vm.seller.id).then(function (banners) {
                vm.sellerBanners = banners;
                angular.forEach(vm.sellerBanners, function (banner) {
                    Analytics.addPromo(banner.id, banner.name, banner.sequenceNr, '');
                });
                // Analytics.pageView(); // causes double pageview tracking, location is shop.profficina.be
            });

            /* load products and discounts */
            vm.discountsModel = productOverviewService.init(Enums.searchContext.seller.id);
            vm.productsModel = productOverviewService.init(Enums.searchContext.seller.id);
            vm.discountsModel.isLoadingInitial = true;
            vm.productsModel.isLoadingInitial = true;

            sellerService.getSellerProductsAndDiscounts(vm.seller.id, vm.productsModel, vm.discountsModel).then(function (model) {
                vm.productsModel.isLoadingInitial = false;
                vm.discountsModel.isLoadingInitial = false;
                vm.productsModel = model.productsModel;
                vm.discountsModel = model.discountsModel;
                vm.errorOccurredInDiscountOverview = model.discountsModel.errorOccurred;
            });

            /*  load partnerships */
            vm.partnershipsModel = partnershipsService.init();
            partnershipsService.getAll(vm.partnershipsModel, {
                skip: 0,
                take: 4,
                sellerId: vm.seller.id
            }, 1).then(function (model) {
                vm.partnershipsModel = model;
                vm.partnerships = model.partnerships;
                vm.errorOccurredInPartnershipOverview = model.errorOccurred;
            });

            // todo put in service
            /* slider settings */
            vm.heroSliderSettings = {
                autoplay: true,
                autoplaySpeed: 6000,
                draggable: false,
                dots: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        arrows: false
                    }
                }]
            };

            /* settings for the product slider */
            vm.productSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };

            /* settings for the news slider */
            vm.newsSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };

            /* settings for the benifit slider */
            vm.partnershipSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };
        }

        function bindingChanges(changes) {
            if (changes.sellerBanners) {
                if (changes.sellerBanners.currentValue) {
                    // vm.sellerPublic = Object.assign(changes.sellerPublic.currentValue, {
                    //     content: marked(changes.sellerPublic.currentValue.content || ''),
                    //     contactContent: marked(changes.sellerPublic.currentValue.contactContent || '')
                    // });
                } else {
                    vm.sellerPublic = changes.sellerPublic.currentValue;
                }
            }
        }

        /* product quanitity changed open toolbar */
        function productQuantityChanged() {
            vm.productsQuantityChanged = true;
            vm.productsAdded = false;
            vm.isOpen = true;
        }

        /* add product to cart */
        function addToCart() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;
            var addProducts = vm.discountsModel.products.concat(vm.productsModel.products);

            cartService.updateCartOverview(addProducts).then(function (result) {

                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                $scope.forms.productOverviewForm.$setPristine();
                var shoppingCartProducts = result;

                vm.discountsModel.products.map(function (discount) {
                    return discount = discount.getCartFields(discount, shoppingCartProducts);
                });

                vm.productsModel.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                $timeout(function () {
                    vm.productsAdded = false;
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
                vm.hasError = true;
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }

        function moduleEnabled(module) {
            return (vm.sellerModules || []).indexOf(module) >= 0;
        }
    }]
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerDiscountsComponent = exports.sellerDiscountsComponent = {
    template: __webpack_require__(671),
    bindings: {
        seller: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "productOverviewService", "Enums", "common", "sellerService", "gettextCatalog", "Analytics", function controller($scope, $state, productOverviewService, Enums, common, sellerService, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('discounts'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/discounts', vm.seller.name + ' ' + gettextCatalog.getString('discounts'));

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.seller.id);

            // sellerService.getSellerTotalPriceDiscounts(vm.seller.id)
            //              .then((totalPriceDiscounts) => {
            //                  vm.totalPriceDiscounts = totalPriceDiscounts;
            //              });

            productOverviewService.getSellerDiscounts(true, vm.productOverviewModel, vm.seller.id).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getSellerDiscounts(false, vm.productOverviewModel, vm.seller.id).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }
    }]
};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerDocumentLibraryComponent = undefined;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerDocumentLibraryComponent = exports.sellerDocumentLibraryComponent = {
    template: __webpack_require__(672),
    bindings: {
        documentCategories: '<',
        faq: '<'
    },
    controllerAs: 'vm',
    controller: ["config", "authService", function controller(config, authService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.visibleDocumentCategories;
        vm.downloadFile = downloadFile;

        function init() {
            vm.faq = vm.faq || [];

            for (var i = 0; i < vm.faq.length; i++) {
                vm.faq[i] = Object.assign(vm.faq[i], {
                    answer: (0, _marked2.default)(vm.faq[i].answer || '')
                });
            }

            vm.documentCategories = vm.documentCategories || [];

            vm.visibleDocumentCategories = _lodash2.default.map(vm.documentCategories, function (c) {
                var filteredDocuments = _lodash2.default.filter(c.documents, function (i) {
                    return i.visible;
                });
                c.documents = filteredDocuments;
                return c;
            });
        }

        function downloadFile(documentId, documentTitle) {
            var url = config.webApiBaseUrl + 'sellers/DownloadFile/' + documentId + '?access_token=' + authService.accessToken;
            var link = document.createElement('a');
            link.download = documentTitle;
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }]
};

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _documentLibrary = __webpack_require__(1020);

var _menu = __webpack_require__(1011);

var _overview = __webpack_require__(1023);

var _detail = __webpack_require__(1018);

var _products = __webpack_require__(1026);

var _discounts = __webpack_require__(1019);

var _news = __webpack_require__(1022);

var _about = __webpack_require__(1008);

var _partnerships = __webpack_require__(1025);

var _partnershipDetail = __webpack_require__(1024);

var _contact = __webpack_require__(1015);

var _contract = __webpack_require__(1017);

var _contractOverview = __webpack_require__(1016);

var _sellercategory = __webpack_require__(1030);

var _public = __webpack_require__(1027);

var _rentProductOverview = __webpack_require__(1029);

var _partnershipGrid = __webpack_require__(1012);

var _partnershipTile = __webpack_require__(1013);

var _contactBlock = __webpack_require__(1009);

var _heroSlider = __webpack_require__(1010);

var _rentProductDetail = __webpack_require__(1028);

var _sellerTotalPriceDiscounts = __webpack_require__(1014);

//import angular from 'angular';
var _module = angular.module('app.seller', []).config(["$stateProvider", "sortProperties", function ($stateProvider, sortProperties) {
    'ngInject';

    $stateProvider.state('seller', {
        url: '/{sellerId:int}',
        parent: 'master',
        views: {
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData" class="site-nav-compact"></site-nav>'
            },
            'submenu@root': {
                component: 'sellerMenu'
            }
        },
        resolve: {
            navigationData: ["sellerService", "$q", function navigationData(sellerService, $q) {
                var promises = [];
                promises.push(sellerService.getAll());

                return $q.all(promises).then(function (results) {
                    return {
                        sellers: results[0]
                    };
                });
            }],
            numberOfContracts: ["$stateParams", "contractService", "authService", function numberOfContracts($stateParams, contractService, authService) {
                if (authService.isBuyer) {
                    return contractService.getNumberOfContracts($stateParams.sellerId);
                } else {
                    return null;
                }
            }],
            seller: ["$stateParams", "sellerService", function seller($stateParams, sellerService) {
                return sellerService.getById($stateParams.sellerId);
            }],
            sellerModules: ["$stateParams", "sellerService", function sellerModules($stateParams, sellerService) {
                return sellerService.getModules($stateParams.sellerId);
            }],
            parentState: ["$state", function parentState($state) {
                return $state.get('seller');
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.seller.name}}'
        },
        redirectTo: 'seller.home'
    }).state('seller.home', {
        url: '',
        views: {
            'main@root': {
                component: 'seller'
            }
        },
        resolve: {
            rentalProductsCategories: ["$stateParams", "rentalProductsService", function rentalProductsCategories($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductCategories($stateParams.sellerId).then(function (result) {
                    return result;
                });
            }]
        },
        ncyBreadcrumb: {
            skip: true
        }
    }).state('sellers', {
        parent: 'general',
        url: '/sellers',
        views: {
            'main@root': {
                component: 'sellerOverview'
            }
        },
        resolve: {
            sellers: ["sellerService", function sellers(sellerService) {
                var data = sellerService.getAll();
                return data;
            }]
        },
        params: {
            breadcrumbName: ''
        },
        ncyBreadcrumb: {
            label: '{{"Sellers" | translate}}'
        }
    }).state('seller.products', {
        url: '/products?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'sellerProducts'
            }
        },
        params: {
            page: {
                value: '1',
                squash: true,
                dynamic: true
            },
            pageSize: {
                squash: true,
                dynamic: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true,
                dynamic: true,
                array: false
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true,
                dynamic: true,
                array: false
            },
            filter: {
                value: '',
                squash: true,
                dynamic: true
            },
            noReloadFilter: {
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Products" | translate}}'
        },
        resolve: {
            // totalPriceDiscounts: function($stateParams, sellerService) {
            //     return sellerService.getSellerTotalPriceDiscounts($stateParams.sellerId);
            // }
        }
    }).state('seller.products.category', {
        url: '/category/{categoryId:int}',
        views: {
            'main@root': {
                component: 'sellerProducts'
            }
        },
        params: {
            page: {
                value: '1',
                squash: true,
                dynamic: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: false,
                dynamic: true
            },
            sortProperty: {
                value: sortProperties['Name'].value,
                squash: true,
                dynamic: true,
                array: false
            },
            sortAsc: {
                value: (sortProperties['Name'].defaultSorting === 'asc').toString(),
                squash: true,
                dynamic: true,
                array: false
            },
            filter: {
                value: '',
                squash: true,
                dynamic: true
            },
            categoryId: {
                squash: true
            }
        },
        reloadOnSearch: true,
        resolve: {
            // category: function($stateParams, categoryService) {
            //     return categoryService.getById($stateParams.categoryId);
            // }
        },
        ncyBreadcrumb: {
            label: '{{$resolve.category.name}}'
        }
    }).state('seller.products.product', {
        url: '/{productId:int}',
        views: {
            'main@root': {
                component: 'product'
            }
        },
        resolve: {
            product: ["$stateParams", "productService", "$state", function product($stateParams, productService, $state) {
                return productService.get($stateParams.productId).then(function (result) {
                    if (result.type === 'RENTAL') {
                        $state.go('seller.rentProductDetail', { sellerId: result.sellerId, productId: result.id }, { reload: true });
                    } else {
                        return result;
                    }
                });
            }]
        },
        reloadOnSearch: false,
        params: {
            // productId: {
            //     value: null,
            //     squash: true
            // },
            loadingOverlay: true
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.displayName}}'
        }
    }).state('seller.discounts', {
        url: '/discounts?page&pageSize&sortProperty&sortAsc&filter',
        views: {
            'main@root': {
                component: 'sellerDiscounts'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            pageSize: {
                value: window.localStorage.getItem('pageSize'),
                squash: false
            },
            sortProperty: {
                value: sortProperties['DiscountDate'].value,
                squash: true
            },
            sortAsc: {
                value: (sortProperties['DiscountDate'].defaultSorting === 'asc').toString(),
                squash: true
            },
            filter: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Discounts" | translate}}'
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('DISCOUNT') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.partnerships', {
        url: '/partnerships?page',
        views: {
            'main@root': {
                component: 'sellerPartnerships'
            }
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"Partnerships" | translate}}'
        },
        resolve: {
            partnershipModel: ["$stateParams", "partnershipsService", function partnershipModel($stateParams, partnershipsService) {
                var searchRequest = {
                    skip: 0,
                    take: 50,
                    sellerId: $stateParams.sellerId,
                    title: null
                };
                return partnershipsService.getAll(partnershipsService.init(), searchRequest, 1);
            }]
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('BENEFIT') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.partnerships.partnership', {
        url: '/{id:int}',
        views: {
            'main@root': {
                component: 'partnershipDetail'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.partnership.title}}'
        },
        resolve: {
            partnership: ["$stateParams", "partnershipsService", function partnership($stateParams, partnershipsService) {
                return partnershipsService.getById($stateParams.id);
            }]
        }
    }).state('seller.about', {
        url: '/about',
        views: {
            'main@root': {
                component: 'sellerAbout'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Over" | translate}} {{$resolve.seller.name | translate}}'
        },
        resolve: {
            sellerAbout: ["$stateParams", "sellerService", function sellerAbout($stateParams, sellerService) {
                return sellerService.getSellerAbout($stateParams.sellerId);
            }]
        }
    }).state('seller.contact', {
        url: '/contact',
        views: {
            'main@root': {
                component: 'sellerContact'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Contact" | translate}}'
        },
        resolve: {
            sellerContact: ["$stateParams", "sellerService", function sellerContact($stateParams, sellerService) {
                return sellerService.getSellerContact($stateParams.sellerId);
            }]
        }
    }).state('seller.contract', {
        url: '/contract',
        onEnter: ["$state", "$stateParams", "sellerService", function onEnter($state, $stateParams, sellerService) {
            sellerService.getSellerContracts($stateParams.sellerId).then(function (result) {
                if (result.length === 1 && result[0].contracts.length === 1) {
                    return $state.go('seller.contractDetail', {
                        id: result[0].contracts[0].id,
                        result: result[0].contracts
                    });
                } else {
                    return $state.go('seller.contractList', {
                        results: result
                    });
                }
            });
        }]
    }).state('seller.contractDetail', {
        url: '/contract/{id:int}',
        views: {
            'main@root': {
                component: 'contractDetail'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{$resolve.contract.name}}'
        },
        resolve: {
            contract: ["$stateParams", "sellerService", function contract($stateParams, sellerService) {
                return sellerService.getSellerContract($stateParams.sellerId, $stateParams.id);
            }]
        }
    }).state('seller.contractList', {
        url: '/contract',
        views: {
            'main@root': {
                component: 'sellerContractOverview'
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            label: '{{"Contracts" | translate}}'
        },
        resolve: {
            contracts: ["sellerService", "$stateParams", function contracts(sellerService, $stateParams) {
                return sellerService.getSellerContracts($stateParams.sellerId);
            }]
        }
    }).state('seller.public', {
        url: '/public',
        views: {
            'main@root': {
                component: 'sellerPublic'
            },
            'menu@root': {
                template: '<site-nav navigation-data="$resolve.navigationData"></site-nav>'
            },
            'submenu@root': {
                component: undefined
            }
        },
        reloadOnSearch: false,
        params: {},
        ncyBreadcrumb: {
            skip: true
        },
        resolve: {
            sellerPublic: ["$stateParams", "sellerService", function sellerPublic($stateParams, sellerService) {
                return sellerService.getSellerPublic($stateParams.sellerId);
            }]
        }
    }).state('seller.news', {
        url: '/news?page&categoryId&searchValue',
        views: {
            'main@root': {
                component: 'sellerNews'
            }
        },
        resolve: {
            seller: ["$stateParams", "sellerService", function seller($stateParams, sellerService) {
                return sellerService.getById($stateParams.sellerId);
            }]
        },
        reloadOnSearch: false,
        params: {
            page: {
                value: '1',
                squash: true
            },
            categoryId: {
                value: '0',
                squash: true
            },
            searchValue: {
                value: '',
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"News" | translate}}'
        },
        onEnter: ["$transition$", "$state", "sellerModules", function onEnter($transition$, $state, sellerModules) {
            if (sellerModules.indexOf('NEWS') >= 0) {
                return true;
            }
            $state.go('seller.home', $transition$.params('to'));
            return false;
        }]
    }).state('seller.news.newsitem', {
        url: '/{newsItemId:int}',
        views: {
            'main@root': {
                component: 'news'
            }
        },
        resolve: {
            newsdetail: ["$stateParams", "newsService", function newsdetail($stateParams, newsService) {
                return newsService.getById($stateParams.newsItemId).then(function (newsdetail) {
                    return newsdetail;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.newsdetail.title | translate}}'
        }
    }).state('seller.doclib', {
        url: '/documentLibrary',
        views: {
            'main@root': {
                component: 'sellerDocumentLibrary'
            }
        },
        resolve: {
            documentCategories: ["$stateParams", "documentLibraryService", function documentCategories($stateParams, documentLibraryService) {
                return documentLibraryService.getLibraryDocumentCategories($stateParams.sellerId).then(function (documentCategories) {
                    return documentCategories;
                });
            }],
            faq: ["$stateParams", "documentLibraryService", function faq($stateParams, documentLibraryService) {
                return documentLibraryService.getLibraryQuestions($stateParams.sellerId).then(function (questions) {
                    return questions;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{"Document library"| translate}}'
        }
    }).state('seller.rentProductOverview', {
        url: '/rentAProductOverview?{categoryId:int}',
        views: {
            'main@root': {
                component: 'rentProductOverview'
            }
        },
        resolve: {
            rentalProductsCategories: ["$stateParams", "rentalProductsService", function rentalProductsCategories($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductCategories($stateParams.sellerId).then(function (result) {
                    return result;
                });
            }]
        },
        params: {
            categoryId: {
                value: 0,
                squash: true
            }
        },
        ncyBreadcrumb: {
            label: '{{"All Rental products"| translate}}'
        }
    }).state('seller.rentProductDetail', {
        url: '/rentalProduct/{productId:int}',
        views: {
            'main@root': {
                component: 'rentProductDetail'
            }
        },
        resolve: {
            product: ["$stateParams", "rentalProductsService", function product($stateParams, rentalProductsService) {
                return rentalProductsService.getRentalProductById($stateParams.productId).then(function (rentalProduct) {
                    return rentalProduct;
                });
            }]
        },
        ncyBreadcrumb: {
            label: '{{$resolve.product.name}}'
        }
    });
}]).component('sellerDocumentLibrary', _documentLibrary.sellerDocumentLibraryComponent).component('sellerMenu', _menu.sellerMenuComponent).component('sellerOverview', _overview.sellersOverviewComponent).component('seller', _detail.sellerDetailComponent).component('sellerProducts', _products.sellerProductsComponent).component('sellerDiscounts', _discounts.sellerDiscountsComponent).component('sellerNews', _news.sellerNewsComponent).component('sellerAbout', _about.sellerAboutComponent).component('sellerPartnerships', _partnerships.sellerPartnershipsComponent).component('sellerContact', _contact.sellerContactComponent).component('sellerContract', _contract.sellerContractComponent).component('sellerCategory', _sellercategory.sellerCategoryComponent).component('sellerPublic', _public.sellerPublicComponent).component('partnershipDetail', _partnershipDetail.sellerPartnershipDetailComponent).component('partnershipGrid', _partnershipGrid.partnershipGridComponent).component('partnershipTile', _partnershipTile.partnershipTileComponent).component('contactBlock', _contactBlock.contactBlockComponent).component('heroSlider', _heroSlider.heroSliderComponent).component('rentProductOverview', _rentProductOverview.rentProductOverviewComponent).component('sellerTotalPriceDiscounts', _sellerTotalPriceDiscounts.sellerTotalPriceDiscountsComponent).component('sellerContractOverview', _contractOverview.sellerContractOverviewComponent).component('rentProductDetail', _rentProductDetail.rentProductDetailComponent);

exports.default = _module.name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerNewsComponent = exports.sellerNewsComponent = {
    template: __webpack_require__(673),
    bindings: {
        seller: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsOverviewService", "Enums", "gettextCatalog", "$state", "Analytics", function sellerNewsController($scope, common, newsOverviewService, Enums, gettextCatalog, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;
        vm.itemsPerPageChanged = itemsPerPageChanged;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(gettextCatalog.getString('News for ') + vm.seller.name);

            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/news', vm.seller.name + ' ' + gettextCatalog.getString('news'));

            handleGetNews(12); //default page size is 12 todo put enums
        }

        function itemsPerPageChanged(itemsPerPage) {
            handleGetNews(itemsPerPage);
        }

        function handleGetNews(itemsPerPage) {
            newsOverviewService.handleGetNews($scope, Enums.newsContext.seller.id, { sellerId: vm.seller.id }, itemsPerPage).then(function (i) {
                return vm.newsOverviewModel = i;
            });
        }
    }]
};

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellersOverviewComponent = exports.sellersOverviewComponent = {
    template: __webpack_require__(674),
    bindings: {
        sellers: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "Analytics", function controller(common, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;

        function init() {
            common.navigationMenu.setSellersActive();
            common.setTitle(gettextCatalog.getString('Sellers'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/sellers', gettextCatalog.getString('Sellers'));
        }
    }]
};

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPartnershipDetailComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerPartnershipDetailComponent = exports.sellerPartnershipDetailComponent = {
    template: __webpack_require__(675),
    bindings: {
        seller: '<',
        partnership: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "$state", "common", "gettextCatalog", "Analytics", "partnershipsService", function sellerPartnershipDetailController($rootScope, $state, common, gettextCatalog, Analytics, partnershipsService) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.$onChanges = bindingChanges;
        vm.context = 'partnership';
        vm.checkYearsApart = checkYearsApart;
        vm.moment = _moment2.default;

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            vm.gallerySliderSettings = partnershipsService.getGallerySliderSettings();
            common.setTitle(gettextCatalog.getString(vm.partnership.title));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/partnerships/' + vm.partnership.id, vm.partnership.title);
        }

        function checkYearsApart(contract) {
            return (0, _moment2.default)(contract.endDate).format('YYYY') - (0, _moment2.default)(contract.startDate).format('YYYY') > 10 ? true : false;
        }

        function bindingChanges(changes) {
            if (changes.partnership) {
                if (changes.partnership.currentValue) {
                    vm.partnership = Object.assign(changes.partnership.currentValue, {
                        summary: (0, _marked2.default)(changes.partnership.currentValue.summary || ''),
                        content: (0, _marked2.default)(changes.partnership.currentValue.content || ''),
                        callToActionContent: (0, _marked2.default)(changes.partnership.currentValue.callToActionContent || '')
                    });
                } else {
                    vm.partnership = changes.partnership.currentValue;
                }
            }
        }
    }]
};

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPartnershipsComponent = undefined;

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sellerPartnershipsComponent = exports.sellerPartnershipsComponent = {
    template: __webpack_require__(676),
    bindings: {
        seller: '<',
        partnershipModel: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "$state", "partnershipsService", "gettextCatalog", "exceptionService", "Analytics", function newsOverviewController(common, $state, partnershipsService, gettextCatalog, exceptionService, Analytics) {
        'ngInject';

        var vm = this;
        vm.pagecountList = [12, 24, 36];
        vm.goToPage = goToPage;
        // vm.paging = null;
        vm.isLoading = false;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.searchPartnerships = searchPartnerships;
        vm.searchValue = null;
        vm.clear = clear;
        vm.$onInit = init;
        vm.partnerships = [];

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('partnerships'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/partnerships', vm.seller.name + ' ' + gettextCatalog.getString('partnerships'));
            updateFarmaPartnerShips();
        }

        /* Clear searches */
        function clear() {
            vm.searchValue = null;
            handleGetPartnerships({
                take: 50
            }, 1);
        }

        /* Search partnerships */
        function searchPartnerships() {
            handleGetPartnerships({
                take: 50,
                title: vm.searchValue
            }, 1);
        }

        /* navigate to page */
        function goToPage(page) {
            if (page === 0 || page > vm.partnershipModel.paging.pageCount) {
                return;
            }
            handleGetPartnerships({
                take: 50
            }, page);
        }

        /* Change amount of items per page */
        function changeItemsPerPage(_ref) {
            var itemsPerPage = _ref.itemsPerPage;

            $state.go('.', {
                page: 1
            });
            handleGetPartnerships({
                take: itemsPerPage
            }, 1);
        }

        /* Load partnerships */
        function handleGetPartnerships(searchRequest, page) {
            searchRequest.sellerId = vm.seller.id;

            partnershipsService.getAll(partnershipsService.init(searchRequest.take), searchRequest, page).then(function (result) {
                vm.isLoading = false;
                vm.partnershipModel = result;
                updateFarmaPartnerShips();
            }).catch(function () {
                var msg = gettextCatalog.getString('The partnerships could not be retrieved');
                exceptionService.logException(msg);
            }).finally(function () {
                return vm.isLoading = false;
            });
        }

        function updateFarmaPartnerShips() {
            var test = _lodash2.default.orderBy(vm.partnershipModel.partnerships, ['typePriority', 'priority']);
            vm.partnerships = _lodash2.default.groupBy(test, 'typeName');
        }
    }]

};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerProductsComponent = exports.sellerProductsComponent = {
    template: __webpack_require__(677),
    bindings: {
        seller: '<',
        parentState: '<',
        totalPriceDiscounts: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "productOverviewService", "Enums", "common", "sellerService", "gettextCatalog", "Analytics", "$stateParams", function controller($scope, $state, productOverviewService, Enums, common, sellerService, gettextCatalog, Analytics, $stateParams) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.onFilterChange = onFilterChange;

        function init() {

            if (!vm.seller) {
                $state.go('error');
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name + ' ' + gettextCatalog.getString('products'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/products', vm.seller.name + ' ' + gettextCatalog.getString('products'));

            loadProducts();
        }

        function loadProducts() {
            //load the products after init
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.category.id);
            }

            productOverviewService.getSellerProducts($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, vm.seller.id, $state.params.categoryId).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
                model.filter.flatListsOfCategories.find(function (cl) {
                    var category = cl.list.find(function (c) {
                        return c.id === $state.params.categoryId;
                    });
                    if (category) {
                        return $state.current.ncyBreadcrumbLabel = category.name;
                    }
                    return null;
                });
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getSellerProducts(false, vm.productOverviewModel, vm.seller.id, $state.params.categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerPublicComponent = undefined;

var _marked = __webpack_require__(17);

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = __webpack_require__(25);

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});
var sellerPublicComponent = exports.sellerPublicComponent = {
    template: __webpack_require__(678),
    bindings: {
        seller: '<',
        sellerPublic: '<'
    },
    controllerAs: 'vm',
    controller: ["$rootScope", "Enums", "$state", "common", "Analytics", "gettextCatalog", function controller($rootScope, Enums, $state, common, Analytics, gettextCatalog) {
        'ngInject';

        var vm = this;
        vm.$onChanges = bindingChanges;
        vm.$onInit = init;
        vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;
        vm.sellerLogos = [];

        //todo put in service/enum
        vm.heroSliderSettings = {
            autoplay: true,
            autoplaySpeed: 6000,
            dots: true,
            draggable: false,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            responsive: [{
                breakpoint: 576,
                settings: {
                    dots: true,
                    arrows: false
                }
            }]
        };

        function init() {
            if (!vm.seller) {
                $state.go('error');
            }

            common.setTitle(vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id + '/public', vm.seller.name + ' ' + gettextCatalog.getString('public'));
            vm.sellerLogos = _lodash2.default.groupBy(_lodash2.default.orderBy(vm.sellerPublic.sellerLogos, ['partnershipType', 'priority']), 'partnershipTypeName');
        }

        function bindingChanges(changes) {
            if (changes.sellerPublic) {
                if (changes.sellerPublic.currentValue) {
                    vm.sellerPublic = Object.assign(changes.sellerPublic.currentValue, {
                        content: (0, _marked2.default)(changes.sellerPublic.currentValue.content || ''),
                        contactContent: (0, _marked2.default)(changes.sellerPublic.currentValue.contactContent || '')
                    });
                } else {
                    vm.sellerPublic = changes.sellerPublic.currentValue;
                }
            }
        }
    }]
};

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductDetailComponent = exports.rentProductDetailComponent = {
    template: __webpack_require__(679),
    bindings: {
        product: '<'
    },
    controllerAs: 'vm',
    controller: ["Enums", "rentalProductsService", "$stateParams", function controller(Enums, rentalProductsService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.medipimData = null;
        vm.medipimDataLoading = false;
        vm.isEmptyObject = isEmptyObject;
        vm.recommendedRentalProducts = [];
        vm.recommendedPortalProducts = [];
        vm.suggestedRentalProducts = [];
        vm.suggestedPortalProducts = [];

        function init() {
            filterRelatedProducts();
            loadMedipimData();
            vm.attachments = vm.product.attachments;
        }

        function loadMedipimData() {
            vm.medipimDataLoading = true;
            rentalProductsService.getRentalProductMedipimdata($stateParams.productId).then(function (medipimData) {
                vm.medipimDataLoading = false;
                vm.medipimData = medipimData;
            });
        }

        function filterRelatedProducts() {
            vm.recommendedRentalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'RENTAL';
            });
            vm.recommendedPortalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.RECOM.value && p.productTypeCode === 'PORTALPRODUCT';
            });
            vm.suggestedRentalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'RENTAL';
            });
            vm.suggestedPortalProducts = vm.product.relatedRentalProducts.filter(function (p) {
                return p.relationTypeCode === Enums.rentalProductRelationTypeCodes.INTER.value && p.productTypeCode === 'PORTALPRODUCT';
            });
        }

        function isEmptyObject(o) {
            if (o) {
                return Object.keys(o).every(function (x) {
                    return o[x] === '' || o[x] === null || o[x] === false || o[x] === 0 || o[x] === undefined;
                });
            } else {
                return true;
            }
        }
    }]
};

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductOverviewComponent = exports.rentProductOverviewComponent = {
    template: __webpack_require__(680),
    bindings: {
        rentalProductsCategories: '<',
        seller: '<'
    },
    controllerAs: 'vm',
    controller: ["rentalProductsService", "$stateParams", function controller(rentalProductsService, $stateParams) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.rentalProductsOverview = null;

        function init() {
            loadProducts();
            vm.activeCategory = vm.rentalProductsCategories.find(function (cat) {
                return cat.id === $stateParams.categoryId.toString();
            });
        }

        function loadProducts() {
            vm.rentalProductsOverview = rentalProductsService.init();
            rentalProductsService.getRentalProducts($stateParams.sellerId, $stateParams.categoryId, vm.rentalProductsOverview).then(function (model) {
                vm.rentalProductsOverview = model;
            });
        }

        //but in const
        // vm.banners = [
        //     {
        //         'media': {
        //             'type': 'IMAGE',
        //             'path': 'TGZ\\images\\64e64e25-0f32-401c-bd0c-348db1d57e55.jpeg',
        //             'thumbnailPath': 'TGZ\\images\\64e64e25-0f32-401c-bd0c-348db1d57e55.jpeg',
        //             'description': 'Mobiliteit zonder zorgen',
        //             'priority': null
        //         },
        //         'title': '',
        //         'content': null,
        //         'link': null,
        //         'priority': 1,
        //         'textAlignment': 0,
        //         'backgroundColor': null,
        //         'darkTextColor': false,
        //         'name': '',
        //         'id': null
        //     }
        // ];

        //put in const
        // vm.heroSliderSettings = { 
        //     autoplay: true,
        //     autoplaySpeed: 6000,
        //     dots: true,
        //     draggable: false,
        //     arrows: true,
        //     slidesToShow: 1, 
        //     slidesToScroll: 1,
        //     infinite: true,
        //     responsive: [ 
        //         {
        //             breakpoint: 576,
        //             settings: {
        //                 dots: true, 
        //                 arrows: false
        //             }
        //         }
        //     ]
        // };
    }]
};

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sellerCategoryComponent = exports.sellerCategoryComponent = {
    template: __webpack_require__(681),
    bindings: {
        sellerCategory: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "$stateParams", "productOverviewService", "Enums", "common", function controller($scope, $state, $stateParams, productOverviewService, Enums, common) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;

        var categoryId = parseInt($stateParams.categoryId);

        function init() {
            common.navigationMenu.setSellersActive();
            common.setTitle(vm.sellerCategory.categories[vm.sellerCategory.categories.length - 1].name);

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.seller.id);
            productOverviewService.getProductsBySellerCategory(true, vm.productOverviewModel, vm.sellerCategory.id, categoryId).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsBySellerCategory(false, vm.productOverviewModel, vm.sellerCategory.id, categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                }).catch(function () {
                    $state.go('error', {}, {
                        location: false
                    });
                });
            });
        }
    }]
};

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _vaccines = __webpack_require__(1032);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.vaccines', []).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('general.vaccines', {
        url: '/flu-vaccines',
        views: {
            'main@root': {
                component: 'vaccines'
            }
        },
        params: {},
        ncyBreadcrumb: {
            label: '{{"Flu vaccines" | translate}}'
        },
        resolve: {
            vaccines: ["vaccinesService", function vaccines(vaccinesService) {
                return vaccinesService.getVaccines();
            }]
        }
    });
}]).component('vaccines', _vaccines.vaccinesComponent);

exports.default = _module.name;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var vaccinesComponent = exports.vaccinesComponent = {
    template: __webpack_require__(682),
    bindings: {
        vaccines: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsOverviewService", "Enums", "gettextCatalog", "vaccinesService", "Analytics", "toastr", function vaccinesController($scope, common, newsOverviewService, Enums, gettextCatalog, vaccinesService, Analytics, toastr) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.saveVaccinesOrder = saveVaccinesOrder;
        vm.isActiveDiscount = isActiveDiscount;
        vm.getBannerImage = getBannerImage;
        vm.hasVaccinesOrdered = hasVaccinesOrdered;
        vm.getBannerImageEnded = getBannerImageEnded;
        vm.canOrder = canOrder;
        vm.anyReservationsMade = false;
        vm.allReservationsMade = false;
        vm.unModifiedVaccines = [];
        vm.reservationCanBeMade = false;

        function init() {
            common.setTitle(gettextCatalog.getString('My reservations'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/myReservations', gettextCatalog.getString('My reservations'));
            vm.unModifiedVaccines = deepCopy(vm.vaccines);
            vm.anyReservationsMade = vaccinesService.vaccinsCanOrder(vm.unModifiedVaccines);
            vm.allReservationsMade = vaccinesService.allReservationsMade(vm.unModifiedVaccines);
            vm.reservationCanBeMade = vaccinesService.canOrderVaccin();
        }

        function hasVaccinesOrdered() {
            return !!vm.unModifiedVaccines.find(function (v) {
                return v.amount > 0;
            });
        }

        function canOrder(vaccin) {
            var res = vaccinesService.canOrderVaccin(vm.unModifiedVaccines.find(function (v) {
                return v.productNumber === vaccin.productNumber;
            }));
            if (vaccin.productNumber === '4307617' && vm.vaccines.influvacReadOnly) {
                return false;
            }
            return res;
        }

        function saveVaccinesOrder() {
            vaccinesService.setVaccinReservation(vm.vaccines).then(function () {

                vm.unModifiedVaccines = deepCopy(vm.vaccines);
                vm.anyReservationsMade = vaccinesService.vaccinsCanOrder(vm.unModifiedVaccines);
                vm.allReservationsMade = vaccinesService.allReservationsMade(vm.unModifiedVaccines);

                toastr.success(gettextCatalog.getString('Your reservation has been confirmed.'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
            });
        }

        function isActiveDiscount(vaccine, discount) {
            var nextDiscount = null;
            vaccine.discounts.forEach(function (e) {
                if (vaccine.amount >= e.amount) {
                    nextDiscount = e;
                }
            });
            return nextDiscount && nextDiscount.amount === discount.amount ? 'bg-info-light' : '';
        }

        function getBannerImage() {
            var currentLanguage = common.localization.getCurrentLanguage();

            if (currentLanguage === 'nl') {
                return '/Common/griepvaccin-nl.png';
            } else if (currentLanguage === 'fr') {
                return '/Common/griepvaccin-fr.png';
            }
        }

        function getBannerImageEnded() {
            var currentLanguage = common.localization.getCurrentLanguage();

            if (currentLanguage === 'nl') {
                return '/Common/griepvaccin-no-text.png';
            } else if (currentLanguage === 'fr') {
                return '/Common/griepvaccin-no-text.png';
            }
        }

        function deepCopy(o) {
            var copy = o,
                k;

            if (o && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object') {
                copy = Object.prototype.toString.call(o) === '[object Array]' ? [] : {};
                for (k in o) {
                    copy[k] = deepCopy(o[k]);
                }
            }

            return copy;
        }
    }]
};

/***/ }),
/* 1033 */,
/* 1034 */
/***/ (function(module, exports) {

module.exports = profficinaConfig;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(19);

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

__webpack_require__(99);

var _security = __webpack_require__(166);

var _security2 = _interopRequireDefault(_security);

var _common = __webpack_require__(256);

var _common2 = _interopRequireDefault(_common);

var _features = __webpack_require__(257);

var _features2 = _interopRequireDefault(_features);

var _app = __webpack_require__(255);

var _logDecorator = __webpack_require__(258);

var _trackJs = __webpack_require__(259);

var _trackJs2 = _interopRequireDefault(_trackJs);

var _visualizer = __webpack_require__(98);

var _moment = __webpack_require__(4);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(107);

__webpack_require__(106);

__webpack_require__(246);

__webpack_require__(247);

__webpack_require__(248);

__webpack_require__(102);

__webpack_require__(108);

__webpack_require__(100);

__webpack_require__(103);

__webpack_require__(253);

__webpack_require__(249);

__webpack_require__(97);

__webpack_require__(75);

__webpack_require__(105);

__webpack_require__(104);

__webpack_require__(162);

__webpack_require__(101);

__webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appModule = _angular2.default.module('app', ['ui.router.state.events', _security2.default, _common2.default, _features2.default, 'ngAnimate', 'smoothScroll', 'ncy-angular-breadcrumb', 'ngSanitize', 'ngFileUpload', 'angular-cookie-law', 'ngMessages']); /*jshint esversion: 6 */


appModule.config(_logDecorator.logDecorator);
appModule.component('appComponent', _app.appComponent);

//config the breadcrumb template
appModule.config(["$breadcrumbProvider", function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
        template: '<nav class="breadcrumb">\n                        <ul class="breadcrumb-wrap">\n                            <li class="breadcrumb-item" ng-repeat="step in steps" ng-show="!$last"><a href="{{step.ncyBreadcrumbLink}}">{{step.ncyBreadcrumbLabel}}</a></li>\n                            <li class="breadcrumb-item"><b>{{steps[steps.length-1].ncyBreadcrumbLabel}}</b></li>\n                        </ul>\n                    </nav>'
    });
}]);

appModule.config(["$stateProvider", function ($stateProvider) {
    // Master template
    $stateProvider.state('root', {
        url: '',
        abstract: true,
        component: 'appComponent'

        // template: appTemplate /*,
        // data: {
        //     public: true
        // }*/
    }).state('language', {
        parent: 'root',
        url: '/{language}',
        abstract: true,
        params: {
            language: {
                value: '',
                squash: true
            }
        },
        onEnter: ["$state", "$stateParams", "localizer", "common", "$location", function onEnter($state, $stateParams, localizer, common, $location) {
            if ($stateParams.language && common.localization.isLanguageSupported($stateParams.language)) {
                //set the locale in moment
                _moment2.default.locale($stateParams.language);
                localizer.init($stateParams.language);
                return true;
            }
            var language = window.localStorage.getItem('language') ? window.localStorage.getItem('language') : common.localization.getDefaultLanguage();
            if (!common.localization.isLanguageSupported(language)) {
                language = common.localization.getDefaultLanguage();
            }

            // Current fallback if no language is provided for a route with only something after the '/'
            if ($stateParams.language) {
                return $location.url('/' + language + $state.href($state.transition.$to().name, $state.transition.params('to')));
            }

            return $state.target($state.transition.$to().name, Object.assign({}, $state.transition.params('to'), {
                language: language
            }));
        }]
    }).state('master', {
        url: '',
        parent: 'language',
        views: {
            'header@root': {
                component: 'siteHeader'
            },
            'footer@root': {
                component: 'siteFooter'
            }
        },
        data: {
            public: false
        },
        redirectTo: 'home',
        ncyBreadcrumb: {
            label: '{{"Home" | translate}}'
        }
    });
}]);

appModule.config(["$locationProvider", "$httpProvider", "$urlRouterProvider", function ($locationProvider, $httpProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);

    $httpProvider.defaults.headers.common['x-accept-language'] = 'nl';
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

    //initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // http://stackoverflow.com/questions/16098430/angular-ie-caching-issue-for-http
    //disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    // extra
    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';

    $httpProvider.interceptors.push('httpInterceptorLanguage');
    $httpProvider.interceptors.push('httpInterceptorErrors');
    $httpProvider.interceptors.push('httpInterceptorAuthorization');

    $urlRouterProvider.otherwise(function ($injector) {
        var $state = $injector.get('$state');
        $state.go('home');
    });
}]);

appModule.config(["authServiceProvider", function (authServiceProvider) {
    authServiceProvider.configure(profficinaConfig.authentication);
}]);

appModule.config(["toastrConfig", function (toastrConfig) {
    _angular2.default.extend(toastrConfig, {
        positionClass: 'toast-top-center',
        closeButton: true,
        closeHtml: '<button class="toast-close-button"></button>'
    });
}]);

appModule.config(["AnalyticsProvider", function (AnalyticsProvider) {
    // https://www.npmjs.com/package/angular-google-analytics

    var tracker = profficinaConfig.googleAnalytics.isEnabled ? profficinaConfig.googleAnalytics.tracker : '';
    AnalyticsProvider.setAccount({
        tracker: tracker,
        trackEvent: true,
        trackEcommerce: true
    })
    // Use ga.js (classic) instead of analytics.js (universal)
    // By default, universal analytics is used, unless this is called with a falsey value.
    .useAnalytics(true)
    // Use ga.js (classic) instead of analytics.js (universal)
    // By default, universal analytics is used, unless this is called with a falsey value.
    .trackPages(false)
    // Track all URL query params (default is false).
    //.trackUrlParams(true)

    // Ignore first page view (default is false).
    // Helpful when using hashes and whenever your bounce rate looks obscenely low.
    //.ignoreFirstPageLoad(true)

    // RegEx to scrub location before sending to analytics.
    // Internally replaces all matching segments with an empty string.
    //.setRemoveRegExp(/\/\d+?$/)
    // Enable enhanced e-commerce module (ec.js)
    // Universal Analytics only
    .useECommerce(true, true)
    // Change the default page event name.
    // Helpful when using ui-router, which fires $stateChangeSuccess instead of $routeChangeSuccess.
    .setPageEvent('$stateChangeSuccess')
    // Set Currency. Default is 'USD'. Use ISO currency codes.
    .setCurrency('EUR');
}]);

appModule.run(["$rootScope", "$state", "$location", "$window", "Analytics", "$transitions", "$stateParams", "authService", "toastr", "$injector", "common", "tmhDynamicLocaleCache", "$uiRouter", "$timeout", "userService", function ($rootScope, $state, $location, $window, Analytics, $transitions, $stateParams, authService, toastr, $injector, common, tmhDynamicLocaleCache, $uiRouter, $timeout, userService) {
    __webpack_require__(251);
    tmhDynamicLocaleCache.put('nl', getInjectedLocale());

    __webpack_require__(250);
    tmhDynamicLocaleCache.put('fr', getInjectedLocale());

    //$window.ga('create', 'UA-44932554-4', 'auto');

    $rootScope.$on('$stateChangeStart', function (event, toState /*, toParams*/) {

        if (
        /*$location.absUrl().indexOf('localhost') < 0 && */
        $location.protocol() !== 'https') {
            event.preventDefault();
            $window.location.href = $location.absUrl().replace('http', 'https');
            return;
        }
        //show the overlay if loadingoverlay is true
        $rootScope.overlayVisible = toState.params && toState.params.loadingOverlay;
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {

        //if there is an error with the cart go to the error menu
        if ($rootScope.isShoppingCartInvalid === true) {
            $state.go('carterror');
        }

        $state.previous = fromState;
        $state.fromParams = fromParams;

        $rootScope.overlayVisible = false;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        $rootScope.$emit('close-menu');
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {

        $rootScope.overlayVisible = false;
        if (error === 'handled') {
            return;
        }
        // we pass the language param here, because otherwise it is undefined in the master controller
        event.preventDefault();
        common.log.error(error);
        $state.get('error').error = error;

        if (toState.name === 'general.products.product') {
            return $state.go('error-product', {
                language: toParams.language
            });
        } else {
            return $state.go('error', {
                language: toParams.language
            });
        }
    });

    $rootScope.getDocument = function (documentPath, context) {
        var location = void 0;

        switch (context) {
            case 'DOCUMENTLIBRARY':
                location = 'file/tgz/documents/';
                break;
            default:
                location = 'media/';
        }

        return documentPath ? common.config.imageBaseUrl + location + documentPath : undefined;
    };

    $rootScope.getBlackFridayImageUrl = function () {
        var currentLanguage = common.localization.getCurrentLanguage();

        if (currentLanguage === 'nl') {
            return 'assets/img/blackfriday-is-here-nl-2019.jpg';
        } else if (currentLanguage === 'fr') {
            return 'assets/img/blackfriday-is-here-fr-2019.jpg';
        }
    };

    $rootScope.getBeforeBlackFridayImageUrl = function () {
        var currentLanguage = common.localization.getCurrentLanguage();

        if (currentLanguage === 'nl') {
            return 'assets/img/blackfriday-is-coming-nl-2019.jpg';
        } else if (currentLanguage === 'fr') {
            return 'assets/img/blackfriday-is-coming-fr-2019.jpg';
        }
    };

    $rootScope.getImage = function (src, size) {

        if (src) {
            src = src.replace('#', '');
            switch (size) {
                case 'Original':
                    return common.config.imageBaseUrl + 'images/original/' + src;
                case 'Showcase':
                    return common.config.imageBaseUrl + 'images/showcase/' + src;
                case 'PartnershipThumb':
                    return common.config.imageBaseUrl + 'images/partnership/thumb/' + src;
                case 'Featured':
                    return common.config.imageBaseUrl + 'images/featured/' + src;
                case 'FeaturedS':
                    return common.config.imageBaseUrl + 'images/featured/s/' + src;
                case 'GalleryS':
                    return common.config.imageBaseUrl + 'images/gallery/s/' + src;
                case 'GalleryM':
                    return common.config.imageBaseUrl + 'images/gallery/m/' + src;
                case 'GalleryL':
                    return common.config.imageBaseUrl + 'images/gallery/l/' + src;
                case 'GalleryThumb':
                    return common.config.imageBaseUrl + 'images/gallery/thumb/' + src;
                case 'HeroS':
                    return common.config.imageBaseUrl + 'images/hero/s/' + src;
                case 'HeroM':
                    return common.config.imageBaseUrl + 'images/hero/m/' + src;
                case 'HeroL':
                    return common.config.imageBaseUrl + 'images/hero/l/' + src;
                case 'Logo':
                    return common.config.imageBaseUrl + 'images/logo/' + src;
                case 'LogoMenu':
                    return common.config.imageBaseUrl + 'images/logo/menu/' + src;
                case 'NewsThumb':
                    return common.config.imageBaseUrl + 'images/news/thumb/' + src;
                case 'NewsThumbS':
                    return common.config.imageBaseUrl + 'images/news/thumb/s/' + src;
                case 'PersonThumb':
                    return common.config.imageBaseUrl + 'images/person/thumb/' + src;
                case 'Product':
                    return common.config.imageBaseUrl + 'images/product/' + src;
                case 'ProductThumb':
                    return common.config.imageBaseUrl + 'images/product/thumb/' + src;
                case 'OutletCategoryBig':
                    return common.config.imageBaseUrl + 'images/outletBig/' + src;
                case 'OutletCategorySmall':
                    return common.config.imageBaseUrl + 'images/outletSmall/' + src;
            }
        }
    };

    authService.init();
    $state.defaultErrorHandler(function () {});

    // Handler for authentication
    $transitions.onBefore({
        to: function to(state) {
            return !state.data || !state.data.public;
        }
    }, function (transition) {
        var redirectUrl = transition.to().name === 'login' ? '/' : transition.router.stateService.href(transition.to().name, transition.params('to'), true);
        var language = transition.params('to').language;

        if (!authService.isAuthenticated) {
            return authService.signIn(redirectUrl, null, language).then(function () {
                if (authService.isBuyer && !authService.user.SAUK && !authService.user.BuyerID) {
                    $state.go('login', {
                        redirectLocation: redirectUrl,
                        language: transition.params('to').language
                    });
                    return false;
                }
                if (authService.isSeller) {
                    if (!authService.user.SAUK) {
                        $state.go('login', {
                            redirectLocation: redirectUrl,
                            language: transition.params('to').language
                        });
                        return false;
                    }
                    if (!authService.user.BuyerID) {
                        $state.go('login', {
                            redirectLocation: redirectUrl,
                            language: transition.params('to').language,
                            selectedSauk: authService.user.SAUK
                        });
                        return false;
                    }
                }
                return true;
            }, function () {
                return false;
            });
            //authService.signIn(common.location.url());
            //return false;
        } else if (!authService.user.SAUK && !authService.user.BuyerID && !(transition.to().data && transition.to().data.noTenant)) {
            $state.go('login', {
                redirectLocation: redirectUrl,
                language: transition.params('to').language
            });
            return false;
        }
        return true;
    });

    //handler for authorization
    $transitions.onBefore({
        to: function to(state) {
            return state.data && state.data.febelcoCustomer;
        }
    }, function () {
        if (authService.isFebelcoCustomer) {
            return true;
        } else {
            $state.go('error');
            return false;
        }
    });

    //handler for seller authorization
    $transitions.onBefore({}, function (transition) {
        if (authService.isSeller) {
            if (transition.to().name === 'home') {
                $state.go('seller.home', {
                    sellerId: authService.user.SellerID
                });
                return false;
            }
            if (transition.to().name !== 'login' && transition.to().name !== 'master' && transition.to().name !== 'unauthorized' && transition.to().name !== 'error' && transition.to().name.indexOf('seller') !== 0) {
                $state.go('unauthorized');
                return false;
            }
            if (transition.to().name.indexOf('seller') === 0 && transition.params('to').sellerId !== parseInt(authService.user.SellerID, 10)) {
                $state.go('unauthorized');
                return false;
            }
        }
        return true;
    });

    // set the default filter values
    $transitions.onBefore({}, function () {
        if (!window.sessionStorage.getItem('pageSize')) {
            window.sessionStorage.setItem('pageSize', '24');
        }
        return true;
    });

    $transitions.onEnter({
        to: 'seller.**'
    }, function (transition) {
        var toState = transition.$to();
        if (toState.name === 'seller.public') {
            return true;
        }
        if (authService.hasClaim('SellerID', transition.params('to').sellerId)) {
            return true;
        }
        $state.go('seller.public', transition.params('to'));
        return false;
    });
    $transitions.onEnter({
        to: 'general.news.newsitem'
    }, function (transition) {
        var tokens = transition.getResolveTokens();
        var promise = transition.injector().getAsync(tokens.find(function (t) {
            return t === 'newsdetail';
        }));
        if (!(!authService.isFebelcoCustomer && promise && promise.$$state.value && promise.$$state.value.isVipSeller)) {
            return true;
        }
        $state.go('seller.home', {
            sellerId: promise.$$state.value.sellerId
        });
        return false;
    });
    $transitions.onEnter({
        to: 'general.products.**'
    }, function (transition) {
        var tokens = transition.getResolveTokens();
        if (!authService.isFebelcoCustomer) {
            var promise = transition.injector().getAsync(tokens.find(function (t) {
                return t === 'product';
            }));
            if (!(!authService.isFebelcoCustomer && promise && promise.$$state.value && promise.$$state.value.isVipSeller)) {
                return true;
            }
            $state.go('seller.home', {
                sellerId: promise.$$state.value.sellerId
            });
        } else {
            return true;
        }
    });
    authService.addUserLoadedEvent(function (user) {
        if (!authService.customUserInfo.tenants) {
            var tenantService = $injector.get('tenantService');
            if (authService.hasClaim('ShopAdmin')) {
                if (authService.hasClaim('BuyerID')) {
                    userService.getCurrentTenant().then(function (tenant) {
                        authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                            tenants: [tenant]
                        });
                    });
                }
            } else {
                tenantService.getAll().then(function (tenants) {
                    authService.customUserInfo = Object.assign(authService.customUserInfo || {}, {
                        tenants: tenants
                    });
                });
            }
        }

        $timeout(function () {
            notifyTenantChange(user);
        }, 1000);

        _trackJs2.default.configure({
            userId: user.profile.sub
        });
        Analytics.set('&uid', user.profile.sub);
    });

    function notifyTenantChange(user) {
        var currentTenant = window.sessionStorage.getItem('currentTenant');
        var currentBuyer = window.sessionStorage.getItem('currentBuyer');
        if (currentTenant && currentBuyer && (user.profile.IsBuyer && currentTenant !== user.profile.SAUK && currentTenant !== user.profile.BuyerID || user.profile.IsSeller && currentTenant !== user.profile.SAUK || currentBuyer !== user.profile.BuyerID)) {
            if (!authService.customUserInfo || !authService.customUserInfo.tenants || !authService.customUserInfo.tenants.length) {
                $timeout(function () {
                    notifyTenantChange(user);
                }, 1000);
                return;
            } else {
                var tenants = authService.customUserInfo.tenants;
                var activeTenant = tenants && tenants.find(function (t) {
                    return !!t.secondaryAppUserKey && t.secondaryAppUserKey === user.profile.SAUK || !!t.id && t.id === parseInt(user.profile.BuyerID, 10);
                });
                if (authService.isBuyer && activeTenant || authService.isSeller && activeTenant && activeTenant.name) {
                    var gettextCatalog = $injector.get('gettextCatalog');
                    toastr.success(gettextCatalog.getString('You are now logged in with pharmacy') + ': ' + activeTenant.name + ' - ' + activeTenant.apbNumber, '', {
                        progressBar: true,
                        timeOut: 30000,
                        extendedTimeOut: 1000,
                        closeButton: true
                    });
                }
            }
        }
        currentTenant = user.profile.SAUK || user.profile.BuyerID;
        currentBuyer = user.profile.BuyerID;
        window.sessionStorage.setItem('currentTenant', currentTenant);
        window.sessionStorage.setItem('currentBuyer', currentBuyer);
    }

    authService.addUserSignedOut(function (user) {
        // redirect to login
        var redirectUrl = window.location.href.indexOf('login') ? '/' : window.location.href;
        authService.signIn(redirectUrl, user ? {
            tenant: user.profile.SAUK || user.profile.BuyerID
        } : undefined);
    });

    if (common.config.enableStateVisualizer) {
        $uiRouter.plugin(_visualizer.Visualizer);
    }
}]);

function getInjectedLocale() {
    var localInjector = _angular2.default.injector(['ngLocale']);
    return localInjector.get('$locale');
}

/***/ })
],[1035]);


// WEBPACK FOOTER //
// js/profficina.59136ee88fda4895b9cf.js